var of = Object.defineProperty;
var af = (n, e, t) => e in n ? of(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t;
var oe = (n, e, t) => (af(n, typeof e != "symbol" ? e + "" : e, t), t);
import * as vt from "react";
import Fe, { createContext as kn, useContext as ia, useState as X, useRef as Re, useEffect as ee, useCallback as He, useMemo as xt, useLayoutEffect as On, useImperativeHandle as lf, forwardRef as su, createElement as cf } from "react";
function uf(n, e) {
  for (var t = 0; t < e.length; t++) {
    const s = e[t];
    if (typeof s != "string" && !Array.isArray(s)) {
      for (const r in s)
        if (r !== "default" && !(r in n)) {
          const a = Object.getOwnPropertyDescriptor(s, r);
          a && Object.defineProperty(n, r, a.get ? a : {
            enumerable: !0,
            get: () => s[r]
          });
        }
    }
  }
  return Object.freeze(Object.defineProperty(n, Symbol.toStringTag, { value: "Module" }));
}
var So = function(n, e) {
  return So = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, s) {
    t.__proto__ = s;
  } || function(t, s) {
    for (var r in s)
      Object.prototype.hasOwnProperty.call(s, r) && (t[r] = s[r]);
  }, So(n, e);
};
function ps(n, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
  So(n, e);
  function t() {
    this.constructor = n;
  }
  n.prototype = e === null ? Object.create(e) : (t.prototype = e.prototype, new t());
}
function wo(n) {
  var e = typeof Symbol == "function" && Symbol.iterator, t = e && n[e], s = 0;
  if (t)
    return t.call(n);
  if (n && typeof n.length == "number")
    return {
      next: function() {
        return n && s >= n.length && (n = void 0), { value: n && n[s++], done: !n };
      }
    };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function or(n, e) {
  var t = typeof Symbol == "function" && n[Symbol.iterator];
  if (!t)
    return n;
  var s = t.call(n), r, a = [], c;
  try {
    for (; (e === void 0 || e-- > 0) && !(r = s.next()).done; )
      a.push(r.value);
  } catch (l) {
    c = { error: l };
  } finally {
    try {
      r && !r.done && (t = s.return) && t.call(s);
    } finally {
      if (c)
        throw c.error;
    }
  }
  return a;
}
function ar(n, e, t) {
  if (t || arguments.length === 2)
    for (var s = 0, r = e.length, a; s < r; s++)
      (a || !(s in e)) && (a || (a = Array.prototype.slice.call(e, 0, s)), a[s] = e[s]);
  return n.concat(a || Array.prototype.slice.call(e));
}
function Si(n) {
  return typeof n == "function";
}
function ru(n) {
  var e = function(s) {
    Error.call(s), s.stack = new Error().stack;
  }, t = n(e);
  return t.prototype = Object.create(Error.prototype), t.prototype.constructor = t, t;
}
var Kr = ru(function(n) {
  return function(t) {
    n(this), this.message = t ? t.length + ` errors occurred during unsubscription:
` + t.map(function(s, r) {
      return r + 1 + ") " + s.toString();
    }).join(`
  `) : "", this.name = "UnsubscriptionError", this.errors = t;
  };
});
function Ao(n, e) {
  if (n) {
    var t = n.indexOf(e);
    0 <= t && n.splice(t, 1);
  }
}
var zr = function() {
  function n(e) {
    this.initialTeardown = e, this.closed = !1, this._parentage = null, this._finalizers = null;
  }
  return n.prototype.unsubscribe = function() {
    var e, t, s, r, a;
    if (!this.closed) {
      this.closed = !0;
      var c = this._parentage;
      if (c)
        if (this._parentage = null, Array.isArray(c))
          try {
            for (var l = wo(c), d = l.next(); !d.done; d = l.next()) {
              var h = d.value;
              h.remove(this);
            }
          } catch (o) {
            e = { error: o };
          } finally {
            try {
              d && !d.done && (t = l.return) && t.call(l);
            } finally {
              if (e)
                throw e.error;
            }
          }
        else
          c.remove(this);
      var m = this.initialTeardown;
      if (Si(m))
        try {
          m();
        } catch (o) {
          a = o instanceof Kr ? o.errors : [o];
        }
      var y = this._finalizers;
      if (y) {
        this._finalizers = null;
        try {
          for (var b = wo(y), v = b.next(); !v.done; v = b.next()) {
            var w = v.value;
            try {
              Da(w);
            } catch (o) {
              a = a ?? [], o instanceof Kr ? a = ar(ar([], or(a)), or(o.errors)) : a.push(o);
            }
          }
        } catch (o) {
          s = { error: o };
        } finally {
          try {
            v && !v.done && (r = b.return) && r.call(b);
          } finally {
            if (s)
              throw s.error;
          }
        }
      }
      if (a)
        throw new Kr(a);
    }
  }, n.prototype.add = function(e) {
    var t;
    if (e && e !== this)
      if (this.closed)
        Da(e);
      else {
        if (e instanceof n) {
          if (e.closed || e._hasParent(this))
            return;
          e._addParent(this);
        }
        (this._finalizers = (t = this._finalizers) !== null && t !== void 0 ? t : []).push(e);
      }
  }, n.prototype._hasParent = function(e) {
    var t = this._parentage;
    return t === e || Array.isArray(t) && t.includes(e);
  }, n.prototype._addParent = function(e) {
    var t = this._parentage;
    this._parentage = Array.isArray(t) ? (t.push(e), t) : t ? [t, e] : e;
  }, n.prototype._removeParent = function(e) {
    var t = this._parentage;
    t === e ? this._parentage = null : Array.isArray(t) && Ao(t, e);
  }, n.prototype.remove = function(e) {
    var t = this._finalizers;
    t && Ao(t, e), e instanceof n && e._removeParent(this);
  }, n.EMPTY = function() {
    var e = new n();
    return e.closed = !0, e;
  }(), n;
}(), ou = zr.EMPTY;
function au(n) {
  return n instanceof zr || n && "closed" in n && Si(n.remove) && Si(n.add) && Si(n.unsubscribe);
}
function Da(n) {
  Si(n) ? n() : n.unsubscribe();
}
var lu = {
  onUnhandledError: null,
  onStoppedNotification: null,
  Promise: void 0,
  useDeprecatedSynchronousErrorHandling: !1,
  useDeprecatedNextContext: !1
}, Co = {
  setTimeout: function(n, e) {
    for (var t = [], s = 2; s < arguments.length; s++)
      t[s - 2] = arguments[s];
    var r = Co.delegate;
    return r != null && r.setTimeout ? r.setTimeout.apply(r, ar([n, e], or(t))) : setTimeout.apply(void 0, ar([n, e], or(t)));
  },
  clearTimeout: function(n) {
    var e = Co.delegate;
    return ((e == null ? void 0 : e.clearTimeout) || clearTimeout)(n);
  },
  delegate: void 0
};
function df(n) {
  Co.setTimeout(function() {
    throw n;
  });
}
function Na() {
}
function $s(n) {
  n();
}
var cu = function(n) {
  ps(e, n);
  function e(t) {
    var s = n.call(this) || this;
    return s.isStopped = !1, t ? (s.destination = t, au(t) && t.add(s)) : s.destination = mf, s;
  }
  return e.create = function(t, s, r) {
    return new Eo(t, s, r);
  }, e.prototype.next = function(t) {
    this.isStopped || this._next(t);
  }, e.prototype.error = function(t) {
    this.isStopped || (this.isStopped = !0, this._error(t));
  }, e.prototype.complete = function() {
    this.isStopped || (this.isStopped = !0, this._complete());
  }, e.prototype.unsubscribe = function() {
    this.closed || (this.isStopped = !0, n.prototype.unsubscribe.call(this), this.destination = null);
  }, e.prototype._next = function(t) {
    this.destination.next(t);
  }, e.prototype._error = function(t) {
    try {
      this.destination.error(t);
    } finally {
      this.unsubscribe();
    }
  }, e.prototype._complete = function() {
    try {
      this.destination.complete();
    } finally {
      this.unsubscribe();
    }
  }, e;
}(zr), ff = Function.prototype.bind;
function Yr(n, e) {
  return ff.call(n, e);
}
var hf = function() {
  function n(e) {
    this.partialObserver = e;
  }
  return n.prototype.next = function(e) {
    var t = this.partialObserver;
    if (t.next)
      try {
        t.next(e);
      } catch (s) {
        Us(s);
      }
  }, n.prototype.error = function(e) {
    var t = this.partialObserver;
    if (t.error)
      try {
        t.error(e);
      } catch (s) {
        Us(s);
      }
    else
      Us(e);
  }, n.prototype.complete = function() {
    var e = this.partialObserver;
    if (e.complete)
      try {
        e.complete();
      } catch (t) {
        Us(t);
      }
  }, n;
}(), Eo = function(n) {
  ps(e, n);
  function e(t, s, r) {
    var a = n.call(this) || this, c;
    if (Si(t) || !t)
      c = {
        next: t ?? void 0,
        error: s ?? void 0,
        complete: r ?? void 0
      };
    else {
      var l;
      a && lu.useDeprecatedNextContext ? (l = Object.create(t), l.unsubscribe = function() {
        return a.unsubscribe();
      }, c = {
        next: t.next && Yr(t.next, l),
        error: t.error && Yr(t.error, l),
        complete: t.complete && Yr(t.complete, l)
      }) : c = t;
    }
    return a.destination = new hf(c), a;
  }
  return e;
}(cu);
function Us(n) {
  df(n);
}
function pf(n) {
  throw n;
}
var mf = {
  closed: !0,
  next: Na,
  error: pf,
  complete: Na
}, gf = function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}();
function yf(n) {
  return n;
}
function vf(n) {
  return n.length === 0 ? yf : n.length === 1 ? n[0] : function(t) {
    return n.reduce(function(s, r) {
      return r(s);
    }, t);
  };
}
var Fa = function() {
  function n(e) {
    e && (this._subscribe = e);
  }
  return n.prototype.lift = function(e) {
    var t = new n();
    return t.source = this, t.operator = e, t;
  }, n.prototype.subscribe = function(e, t, s) {
    var r = this, a = xf(e) ? e : new Eo(e, t, s);
    return $s(function() {
      var c = r, l = c.operator, d = c.source;
      a.add(l ? l.call(a, d) : d ? r._subscribe(a) : r._trySubscribe(a));
    }), a;
  }, n.prototype._trySubscribe = function(e) {
    try {
      return this._subscribe(e);
    } catch (t) {
      e.error(t);
    }
  }, n.prototype.forEach = function(e, t) {
    var s = this;
    return t = Ba(t), new t(function(r, a) {
      var c = new Eo({
        next: function(l) {
          try {
            e(l);
          } catch (d) {
            a(d), c.unsubscribe();
          }
        },
        error: a,
        complete: r
      });
      s.subscribe(c);
    });
  }, n.prototype._subscribe = function(e) {
    var t;
    return (t = this.source) === null || t === void 0 ? void 0 : t.subscribe(e);
  }, n.prototype[gf] = function() {
    return this;
  }, n.prototype.pipe = function() {
    for (var e = [], t = 0; t < arguments.length; t++)
      e[t] = arguments[t];
    return vf(e)(this);
  }, n.prototype.toPromise = function(e) {
    var t = this;
    return e = Ba(e), new e(function(s, r) {
      var a;
      t.subscribe(function(c) {
        return a = c;
      }, function(c) {
        return r(c);
      }, function() {
        return s(a);
      });
    });
  }, n.create = function(e) {
    return new n(e);
  }, n;
}();
function Ba(n) {
  var e;
  return (e = n ?? lu.Promise) !== null && e !== void 0 ? e : Promise;
}
function bf(n) {
  return n && Si(n.next) && Si(n.error) && Si(n.complete);
}
function xf(n) {
  return n && n instanceof cu || bf(n) && au(n);
}
var Sf = ru(function(n) {
  return function() {
    n(this), this.name = "ObjectUnsubscribedError", this.message = "object unsubscribed";
  };
}), uu = function(n) {
  ps(e, n);
  function e() {
    var t = n.call(this) || this;
    return t.closed = !1, t.currentObservers = null, t.observers = [], t.isStopped = !1, t.hasError = !1, t.thrownError = null, t;
  }
  return e.prototype.lift = function(t) {
    var s = new qa(this, this);
    return s.operator = t, s;
  }, e.prototype._throwIfClosed = function() {
    if (this.closed)
      throw new Sf();
  }, e.prototype.next = function(t) {
    var s = this;
    $s(function() {
      var r, a;
      if (s._throwIfClosed(), !s.isStopped) {
        s.currentObservers || (s.currentObservers = Array.from(s.observers));
        try {
          for (var c = wo(s.currentObservers), l = c.next(); !l.done; l = c.next()) {
            var d = l.value;
            d.next(t);
          }
        } catch (h) {
          r = { error: h };
        } finally {
          try {
            l && !l.done && (a = c.return) && a.call(c);
          } finally {
            if (r)
              throw r.error;
          }
        }
      }
    });
  }, e.prototype.error = function(t) {
    var s = this;
    $s(function() {
      if (s._throwIfClosed(), !s.isStopped) {
        s.hasError = s.isStopped = !0, s.thrownError = t;
        for (var r = s.observers; r.length; )
          r.shift().error(t);
      }
    });
  }, e.prototype.complete = function() {
    var t = this;
    $s(function() {
      if (t._throwIfClosed(), !t.isStopped) {
        t.isStopped = !0;
        for (var s = t.observers; s.length; )
          s.shift().complete();
      }
    });
  }, e.prototype.unsubscribe = function() {
    this.isStopped = this.closed = !0, this.observers = this.currentObservers = null;
  }, Object.defineProperty(e.prototype, "observed", {
    get: function() {
      var t;
      return ((t = this.observers) === null || t === void 0 ? void 0 : t.length) > 0;
    },
    enumerable: !1,
    configurable: !0
  }), e.prototype._trySubscribe = function(t) {
    return this._throwIfClosed(), n.prototype._trySubscribe.call(this, t);
  }, e.prototype._subscribe = function(t) {
    return this._throwIfClosed(), this._checkFinalizedStatuses(t), this._innerSubscribe(t);
  }, e.prototype._innerSubscribe = function(t) {
    var s = this, r = this, a = r.hasError, c = r.isStopped, l = r.observers;
    return a || c ? ou : (this.currentObservers = null, l.push(t), new zr(function() {
      s.currentObservers = null, Ao(l, t);
    }));
  }, e.prototype._checkFinalizedStatuses = function(t) {
    var s = this, r = s.hasError, a = s.thrownError, c = s.isStopped;
    r ? t.error(a) : c && t.complete();
  }, e.prototype.asObservable = function() {
    var t = new Fa();
    return t.source = this, t;
  }, e.create = function(t, s) {
    return new qa(t, s);
  }, e;
}(Fa), qa = function(n) {
  ps(e, n);
  function e(t, s) {
    var r = n.call(this) || this;
    return r.destination = t, r.source = s, r;
  }
  return e.prototype.next = function(t) {
    var s, r;
    (r = (s = this.destination) === null || s === void 0 ? void 0 : s.next) === null || r === void 0 || r.call(s, t);
  }, e.prototype.error = function(t) {
    var s, r;
    (r = (s = this.destination) === null || s === void 0 ? void 0 : s.error) === null || r === void 0 || r.call(s, t);
  }, e.prototype.complete = function() {
    var t, s;
    (s = (t = this.destination) === null || t === void 0 ? void 0 : t.complete) === null || s === void 0 || s.call(t);
  }, e.prototype._subscribe = function(t) {
    var s, r;
    return (r = (s = this.source) === null || s === void 0 ? void 0 : s.subscribe(t)) !== null && r !== void 0 ? r : ou;
  }, e;
}(uu), wf = function(n) {
  ps(e, n);
  function e(t) {
    var s = n.call(this) || this;
    return s._value = t, s;
  }
  return Object.defineProperty(e.prototype, "value", {
    get: function() {
      return this.getValue();
    },
    enumerable: !1,
    configurable: !0
  }), e.prototype._subscribe = function(t) {
    var s = n.prototype._subscribe.call(this, t);
    return !s.closed && t.next(this._value), s;
  }, e.prototype.getValue = function() {
    var t = this, s = t.hasError, r = t.thrownError, a = t._value;
    if (s)
      throw r;
    return this._throwIfClosed(), a;
  }, e.prototype.next = function(t) {
    n.prototype.next.call(this, this._value = t);
  }, e;
}(uu);
const er = new wf("en"), Te = (n) => typeof n == "string", Rn = () => {
  let n, e;
  const t = new Promise((s, r) => {
    n = s, e = r;
  });
  return t.resolve = n, t.reject = e, t;
}, Ha = (n) => n == null ? "" : "" + n, Af = (n, e, t) => {
  n.forEach((s) => {
    e[s] && (t[s] = e[s]);
  });
}, Cf = /###/g, Va = (n) => n && n.indexOf("###") > -1 ? n.replace(Cf, ".") : n, Ga = (n) => !n || Te(n), Jn = (n, e, t) => {
  const s = Te(e) ? e.split(".") : e;
  let r = 0;
  for (; r < s.length - 1; ) {
    if (Ga(n))
      return {};
    const a = Va(s[r]);
    !n[a] && t && (n[a] = new t()), Object.prototype.hasOwnProperty.call(n, a) ? n = n[a] : n = {}, ++r;
  }
  return Ga(n) ? {} : {
    obj: n,
    k: Va(s[r])
  };
}, Wa = (n, e, t) => {
  const {
    obj: s,
    k: r
  } = Jn(n, e, Object);
  if (s !== void 0 || e.length === 1) {
    s[r] = t;
    return;
  }
  let a = e[e.length - 1], c = e.slice(0, e.length - 1), l = Jn(n, c, Object);
  for (; l.obj === void 0 && c.length; )
    a = `${c[c.length - 1]}.${a}`, c = c.slice(0, c.length - 1), l = Jn(n, c, Object), l && l.obj && typeof l.obj[`${l.k}.${a}`] < "u" && (l.obj = void 0);
  l.obj[`${l.k}.${a}`] = t;
}, Ef = (n, e, t, s) => {
  const {
    obj: r,
    k: a
  } = Jn(n, e, Object);
  r[a] = r[a] || [], r[a].push(t);
}, lr = (n, e) => {
  const {
    obj: t,
    k: s
  } = Jn(n, e);
  if (t)
    return t[s];
}, kf = (n, e, t) => {
  const s = lr(n, t);
  return s !== void 0 ? s : lr(e, t);
}, du = (n, e, t) => {
  for (const s in e)
    s !== "__proto__" && s !== "constructor" && (s in n ? Te(n[s]) || n[s] instanceof String || Te(e[s]) || e[s] instanceof String ? t && (n[s] = e[s]) : du(n[s], e[s], t) : n[s] = e[s]);
  return n;
}, ln = (n) => n.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
var Of = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
const Tf = (n) => Te(n) ? n.replace(/[&<>"'\/]/g, (e) => Of[e]) : n;
class If {
  constructor(e) {
    this.capacity = e, this.regExpMap = /* @__PURE__ */ new Map(), this.regExpQueue = [];
  }
  getRegExp(e) {
    const t = this.regExpMap.get(e);
    if (t !== void 0)
      return t;
    const s = new RegExp(e);
    return this.regExpQueue.length === this.capacity && this.regExpMap.delete(this.regExpQueue.shift()), this.regExpMap.set(e, s), this.regExpQueue.push(e), s;
  }
}
const Uf = [" ", ",", "?", "!", ";"], zf = new If(20), Rf = (n, e, t) => {
  e = e || "", t = t || "";
  const s = Uf.filter((c) => e.indexOf(c) < 0 && t.indexOf(c) < 0);
  if (s.length === 0)
    return !0;
  const r = zf.getRegExp(`(${s.map((c) => c === "?" ? "\\?" : c).join("|")})`);
  let a = !r.test(n);
  if (!a) {
    const c = n.indexOf(t);
    c > 0 && !r.test(n.substring(0, c)) && (a = !0);
  }
  return a;
}, ko = function(n, e) {
  let t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".";
  if (!n)
    return;
  if (n[e])
    return n[e];
  const s = e.split(t);
  let r = n;
  for (let a = 0; a < s.length; ) {
    if (!r || typeof r != "object")
      return;
    let c, l = "";
    for (let d = a; d < s.length; ++d)
      if (d !== a && (l += t), l += s[d], c = r[l], c !== void 0) {
        if (["string", "number", "boolean"].indexOf(typeof c) > -1 && d < s.length - 1)
          continue;
        a += d - a + 1;
        break;
      }
    r = c;
  }
  return r;
}, cr = (n) => n && n.replace("_", "-"), Pf = {
  type: "logger",
  log(n) {
    this.output("log", n);
  },
  warn(n) {
    this.output("warn", n);
  },
  error(n) {
    this.output("error", n);
  },
  output(n, e) {
    console && console[n] && console[n].apply(console, e);
  }
};
class ur {
  constructor(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.init(e, t);
  }
  init(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.prefix = t.prefix || "i18next:", this.logger = e || Pf, this.options = t, this.debug = t.debug;
  }
  log() {
    for (var e = arguments.length, t = new Array(e), s = 0; s < e; s++)
      t[s] = arguments[s];
    return this.forward(t, "log", "", !0);
  }
  warn() {
    for (var e = arguments.length, t = new Array(e), s = 0; s < e; s++)
      t[s] = arguments[s];
    return this.forward(t, "warn", "", !0);
  }
  error() {
    for (var e = arguments.length, t = new Array(e), s = 0; s < e; s++)
      t[s] = arguments[s];
    return this.forward(t, "error", "");
  }
  deprecate() {
    for (var e = arguments.length, t = new Array(e), s = 0; s < e; s++)
      t[s] = arguments[s];
    return this.forward(t, "warn", "WARNING DEPRECATED: ", !0);
  }
  forward(e, t, s, r) {
    return r && !this.debug ? null : (Te(e[0]) && (e[0] = `${s}${this.prefix} ${e[0]}`), this.logger[t](e));
  }
  create(e) {
    return new ur(this.logger, {
      prefix: `${this.prefix}:${e}:`,
      ...this.options
    });
  }
  clone(e) {
    return e = e || this.options, e.prefix = e.prefix || this.prefix, new ur(this.logger, e);
  }
}
var ai = new ur();
let Rr = class {
  constructor() {
    this.observers = {};
  }
  on(e, t) {
    return e.split(" ").forEach((s) => {
      this.observers[s] || (this.observers[s] = /* @__PURE__ */ new Map());
      const r = this.observers[s].get(t) || 0;
      this.observers[s].set(t, r + 1);
    }), this;
  }
  off(e, t) {
    if (this.observers[e]) {
      if (!t) {
        delete this.observers[e];
        return;
      }
      this.observers[e].delete(t);
    }
  }
  emit(e) {
    for (var t = arguments.length, s = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
      s[r - 1] = arguments[r];
    this.observers[e] && Array.from(this.observers[e].entries()).forEach((c) => {
      let [l, d] = c;
      for (let h = 0; h < d; h++)
        l(...s);
    }), this.observers["*"] && Array.from(this.observers["*"].entries()).forEach((c) => {
      let [l, d] = c;
      for (let h = 0; h < d; h++)
        l.apply(l, [e, ...s]);
    });
  }
};
class Ka extends Rr {
  constructor(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      ns: ["translation"],
      defaultNS: "translation"
    };
    super(), this.data = e || {}, this.options = t, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
  }
  addNamespaces(e) {
    this.options.ns.indexOf(e) < 0 && this.options.ns.push(e);
  }
  removeNamespaces(e) {
    const t = this.options.ns.indexOf(e);
    t > -1 && this.options.ns.splice(t, 1);
  }
  getResource(e, t, s) {
    let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const a = r.keySeparator !== void 0 ? r.keySeparator : this.options.keySeparator, c = r.ignoreJSONStructure !== void 0 ? r.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let l;
    e.indexOf(".") > -1 ? l = e.split(".") : (l = [e, t], s && (Array.isArray(s) ? l.push(...s) : Te(s) && a ? l.push(...s.split(a)) : l.push(s)));
    const d = lr(this.data, l);
    return !d && !t && !s && e.indexOf(".") > -1 && (e = l[0], t = l[1], s = l.slice(2).join(".")), d || !c || !Te(s) ? d : ko(this.data && this.data[e] && this.data[e][t], s, a);
  }
  addResource(e, t, s, r) {
    let a = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      silent: !1
    };
    const c = a.keySeparator !== void 0 ? a.keySeparator : this.options.keySeparator;
    let l = [e, t];
    s && (l = l.concat(c ? s.split(c) : s)), e.indexOf(".") > -1 && (l = e.split("."), r = t, t = l[1]), this.addNamespaces(t), Wa(this.data, l, r), a.silent || this.emit("added", e, t, s, r);
  }
  addResources(e, t, s) {
    let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
      silent: !1
    };
    for (const a in s)
      (Te(s[a]) || Array.isArray(s[a])) && this.addResource(e, t, a, s[a], {
        silent: !0
      });
    r.silent || this.emit("added", e, t, s);
  }
  addResourceBundle(e, t, s, r, a) {
    let c = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {
      silent: !1,
      skipCopy: !1
    }, l = [e, t];
    e.indexOf(".") > -1 && (l = e.split("."), r = s, s = t, t = l[1]), this.addNamespaces(t);
    let d = lr(this.data, l) || {};
    c.skipCopy || (s = JSON.parse(JSON.stringify(s))), r ? du(d, s, a) : d = {
      ...d,
      ...s
    }, Wa(this.data, l, d), c.silent || this.emit("added", e, t, s);
  }
  removeResourceBundle(e, t) {
    this.hasResourceBundle(e, t) && delete this.data[e][t], this.removeNamespaces(t), this.emit("removed", e, t);
  }
  hasResourceBundle(e, t) {
    return this.getResource(e, t) !== void 0;
  }
  getResourceBundle(e, t) {
    return t || (t = this.options.defaultNS), this.options.compatibilityAPI === "v1" ? {
      ...this.getResource(e, t)
    } : this.getResource(e, t);
  }
  getDataByLanguage(e) {
    return this.data[e];
  }
  hasLanguageSomeTranslations(e) {
    const t = this.getDataByLanguage(e);
    return !!(t && Object.keys(t) || []).find((r) => t[r] && Object.keys(t[r]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var fu = {
  processors: {},
  addPostProcessor(n) {
    this.processors[n.name] = n;
  },
  handle(n, e, t, s, r) {
    return n.forEach((a) => {
      this.processors[a] && (e = this.processors[a].process(e, t, s, r));
    }), e;
  }
};
const Ya = {};
class dr extends Rr {
  constructor(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    super(), Af(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], e, this), this.options = t, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = ai.create("translator");
  }
  changeLanguage(e) {
    e && (this.language = e);
  }
  exists(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    if (e == null)
      return !1;
    const s = this.resolve(e, t);
    return s && s.res !== void 0;
  }
  extractFromKey(e, t) {
    let s = t.nsSeparator !== void 0 ? t.nsSeparator : this.options.nsSeparator;
    s === void 0 && (s = ":");
    const r = t.keySeparator !== void 0 ? t.keySeparator : this.options.keySeparator;
    let a = t.ns || this.options.defaultNS || [];
    const c = s && e.indexOf(s) > -1, l = !this.options.userDefinedKeySeparator && !t.keySeparator && !this.options.userDefinedNsSeparator && !t.nsSeparator && !Rf(e, s, r);
    if (c && !l) {
      const d = e.match(this.interpolator.nestingRegexp);
      if (d && d.length > 0)
        return {
          key: e,
          namespaces: Te(a) ? [a] : a
        };
      const h = e.split(s);
      (s !== r || s === r && this.options.ns.indexOf(h[0]) > -1) && (a = h.shift()), e = h.join(r);
    }
    return {
      key: e,
      namespaces: Te(a) ? [a] : a
    };
  }
  translate(e, t, s) {
    if (typeof t != "object" && this.options.overloadTranslationOptionHandler && (t = this.options.overloadTranslationOptionHandler(arguments)), typeof t == "object" && (t = {
      ...t
    }), t || (t = {}), e == null)
      return "";
    Array.isArray(e) || (e = [String(e)]);
    const r = t.returnDetails !== void 0 ? t.returnDetails : this.options.returnDetails, a = t.keySeparator !== void 0 ? t.keySeparator : this.options.keySeparator, {
      key: c,
      namespaces: l
    } = this.extractFromKey(e[e.length - 1], t), d = l[l.length - 1], h = t.lng || this.language, m = t.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (h && h.toLowerCase() === "cimode") {
      if (m) {
        const S = t.nsSeparator || this.options.nsSeparator;
        return r ? {
          res: `${d}${S}${c}`,
          usedKey: c,
          exactUsedKey: c,
          usedLng: h,
          usedNS: d,
          usedParams: this.getUsedParamsDetails(t)
        } : `${d}${S}${c}`;
      }
      return r ? {
        res: c,
        usedKey: c,
        exactUsedKey: c,
        usedLng: h,
        usedNS: d,
        usedParams: this.getUsedParamsDetails(t)
      } : c;
    }
    const y = this.resolve(e, t);
    let b = y && y.res;
    const v = y && y.usedKey || c, w = y && y.exactUsedKey || c, o = Object.prototype.toString.apply(b), u = ["[object Number]", "[object Function]", "[object RegExp]"], f = t.joinArrays !== void 0 ? t.joinArrays : this.options.joinArrays, p = !this.i18nFormat || this.i18nFormat.handleAsObject, g = !Te(b) && typeof b != "boolean" && typeof b != "number";
    if (p && b && g && u.indexOf(o) < 0 && !(Te(f) && Array.isArray(b))) {
      if (!t.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const S = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(v, b, {
          ...t,
          ns: l
        }) : `key '${c} (${this.language})' returned an object instead of string.`;
        return r ? (y.res = S, y.usedParams = this.getUsedParamsDetails(t), y) : S;
      }
      if (a) {
        const S = Array.isArray(b), x = S ? [] : {}, E = S ? w : v;
        for (const k in b)
          if (Object.prototype.hasOwnProperty.call(b, k)) {
            const R = `${E}${a}${k}`;
            x[k] = this.translate(R, {
              ...t,
              joinArrays: !1,
              ns: l
            }), x[k] === R && (x[k] = b[k]);
          }
        b = x;
      }
    } else if (p && Te(f) && Array.isArray(b))
      b = b.join(f), b && (b = this.extendTranslation(b, e, t, s));
    else {
      let S = !1, x = !1;
      const E = t.count !== void 0 && !Te(t.count), k = dr.hasDefaultValue(t), R = E ? this.pluralResolver.getSuffix(h, t.count, t) : "", O = t.ordinal && E ? this.pluralResolver.getSuffix(h, t.count, {
        ordinal: !1
      }) : "", T = E && !t.ordinal && t.count === 0 && this.pluralResolver.shouldUseIntlApi(), D = T && t[`defaultValue${this.options.pluralSeparator}zero`] || t[`defaultValue${R}`] || t[`defaultValue${O}`] || t.defaultValue;
      !this.isValidLookup(b) && k && (S = !0, b = D), this.isValidLookup(b) || (x = !0, b = c);
      const N = (t.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && x ? void 0 : b, I = k && D !== b && this.options.updateMissing;
      if (x || S || I) {
        if (this.logger.log(I ? "updateKey" : "missingKey", h, d, c, I ? D : b), a) {
          const j = this.resolve(c, {
            ...t,
            keySeparator: !1
          });
          j && j.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let C = [];
        const U = this.languageUtils.getFallbackCodes(this.options.fallbackLng, t.lng || this.language);
        if (this.options.saveMissingTo === "fallback" && U && U[0])
          for (let j = 0; j < U.length; j++)
            C.push(U[j]);
        else
          this.options.saveMissingTo === "all" ? C = this.languageUtils.toResolveHierarchy(t.lng || this.language) : C.push(t.lng || this.language);
        const z = (j, F, q) => {
          const W = k && q !== b ? q : N;
          this.options.missingKeyHandler ? this.options.missingKeyHandler(j, d, F, W, I, t) : this.backendConnector && this.backendConnector.saveMissing && this.backendConnector.saveMissing(j, d, F, W, I, t), this.emit("missingKey", j, d, F, b);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && E ? C.forEach((j) => {
          const F = this.pluralResolver.getSuffixes(j, t);
          T && t[`defaultValue${this.options.pluralSeparator}zero`] && F.indexOf(`${this.options.pluralSeparator}zero`) < 0 && F.push(`${this.options.pluralSeparator}zero`), F.forEach((q) => {
            z([j], c + q, t[`defaultValue${q}`] || D);
          });
        }) : z(C, c, D));
      }
      b = this.extendTranslation(b, e, t, y, s), x && b === c && this.options.appendNamespaceToMissingKey && (b = `${d}:${c}`), (x || S) && this.options.parseMissingKeyHandler && (this.options.compatibilityAPI !== "v1" ? b = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${d}:${c}` : c, S ? b : void 0) : b = this.options.parseMissingKeyHandler(b));
    }
    return r ? (y.res = b, y.usedParams = this.getUsedParamsDetails(t), y) : b;
  }
  extendTranslation(e, t, s, r, a) {
    var c = this;
    if (this.i18nFormat && this.i18nFormat.parse)
      e = this.i18nFormat.parse(e, {
        ...this.options.interpolation.defaultVariables,
        ...s
      }, s.lng || this.language || r.usedLng, r.usedNS, r.usedKey, {
        resolved: r
      });
    else if (!s.skipInterpolation) {
      s.interpolation && this.interpolator.init({
        ...s,
        interpolation: {
          ...this.options.interpolation,
          ...s.interpolation
        }
      });
      const h = Te(e) && (s && s.interpolation && s.interpolation.skipOnVariables !== void 0 ? s.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let m;
      if (h) {
        const b = e.match(this.interpolator.nestingRegexp);
        m = b && b.length;
      }
      let y = s.replace && !Te(s.replace) ? s.replace : s;
      if (this.options.interpolation.defaultVariables && (y = {
        ...this.options.interpolation.defaultVariables,
        ...y
      }), e = this.interpolator.interpolate(e, y, s.lng || this.language || r.usedLng, s), h) {
        const b = e.match(this.interpolator.nestingRegexp), v = b && b.length;
        m < v && (s.nest = !1);
      }
      !s.lng && this.options.compatibilityAPI !== "v1" && r && r.res && (s.lng = this.language || r.usedLng), s.nest !== !1 && (e = this.interpolator.nest(e, function() {
        for (var b = arguments.length, v = new Array(b), w = 0; w < b; w++)
          v[w] = arguments[w];
        return a && a[0] === v[0] && !s.context ? (c.logger.warn(`It seems you are nesting recursively key: ${v[0]} in key: ${t[0]}`), null) : c.translate(...v, t);
      }, s)), s.interpolation && this.interpolator.reset();
    }
    const l = s.postProcess || this.options.postProcess, d = Te(l) ? [l] : l;
    return e != null && d && d.length && s.applyPostProcessor !== !1 && (e = fu.handle(d, e, t, this.options && this.options.postProcessPassResolved ? {
      i18nResolved: {
        ...r,
        usedParams: this.getUsedParamsDetails(s)
      },
      ...s
    } : s, this)), e;
  }
  resolve(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, s, r, a, c, l;
    return Te(e) && (e = [e]), e.forEach((d) => {
      if (this.isValidLookup(s))
        return;
      const h = this.extractFromKey(d, t), m = h.key;
      r = m;
      let y = h.namespaces;
      this.options.fallbackNS && (y = y.concat(this.options.fallbackNS));
      const b = t.count !== void 0 && !Te(t.count), v = b && !t.ordinal && t.count === 0 && this.pluralResolver.shouldUseIntlApi(), w = t.context !== void 0 && (Te(t.context) || typeof t.context == "number") && t.context !== "", o = t.lngs ? t.lngs : this.languageUtils.toResolveHierarchy(t.lng || this.language, t.fallbackLng);
      y.forEach((u) => {
        this.isValidLookup(s) || (l = u, !Ya[`${o[0]}-${u}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(l) && (Ya[`${o[0]}-${u}`] = !0, this.logger.warn(`key "${r}" for languages "${o.join(", ")}" won't get resolved as namespace "${l}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), o.forEach((f) => {
          if (this.isValidLookup(s))
            return;
          c = f;
          const p = [m];
          if (this.i18nFormat && this.i18nFormat.addLookupKeys)
            this.i18nFormat.addLookupKeys(p, m, f, u, t);
          else {
            let S;
            b && (S = this.pluralResolver.getSuffix(f, t.count, t));
            const x = `${this.options.pluralSeparator}zero`, E = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (b && (p.push(m + S), t.ordinal && S.indexOf(E) === 0 && p.push(m + S.replace(E, this.options.pluralSeparator)), v && p.push(m + x)), w) {
              const k = `${m}${this.options.contextSeparator}${t.context}`;
              p.push(k), b && (p.push(k + S), t.ordinal && S.indexOf(E) === 0 && p.push(k + S.replace(E, this.options.pluralSeparator)), v && p.push(k + x));
            }
          }
          let g;
          for (; g = p.pop(); )
            this.isValidLookup(s) || (a = g, s = this.getResource(f, u, g, t));
        }));
      });
    }), {
      res: s,
      usedKey: r,
      exactUsedKey: a,
      usedLng: c,
      usedNS: l
    };
  }
  isValidLookup(e) {
    return e !== void 0 && !(!this.options.returnNull && e === null) && !(!this.options.returnEmptyString && e === "");
  }
  getResource(e, t, s) {
    let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return this.i18nFormat && this.i18nFormat.getResource ? this.i18nFormat.getResource(e, t, s, r) : this.resourceStore.getResource(e, t, s, r);
  }
  getUsedParamsDetails() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const t = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"], s = e.replace && !Te(e.replace);
    let r = s ? e.replace : e;
    if (s && typeof e.count < "u" && (r.count = e.count), this.options.interpolation.defaultVariables && (r = {
      ...this.options.interpolation.defaultVariables,
      ...r
    }), !s) {
      r = {
        ...r
      };
      for (const a of t)
        delete r[a];
    }
    return r;
  }
  static hasDefaultValue(e) {
    const t = "defaultValue";
    for (const s in e)
      if (Object.prototype.hasOwnProperty.call(e, s) && t === s.substring(0, t.length) && e[s] !== void 0)
        return !0;
    return !1;
  }
}
const Jr = (n) => n.charAt(0).toUpperCase() + n.slice(1);
class Ja {
  constructor(e) {
    this.options = e, this.supportedLngs = this.options.supportedLngs || !1, this.logger = ai.create("languageUtils");
  }
  getScriptPartFromCode(e) {
    if (e = cr(e), !e || e.indexOf("-") < 0)
      return null;
    const t = e.split("-");
    return t.length === 2 || (t.pop(), t[t.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(t.join("-"));
  }
  getLanguagePartFromCode(e) {
    if (e = cr(e), !e || e.indexOf("-") < 0)
      return e;
    const t = e.split("-");
    return this.formatLanguageCode(t[0]);
  }
  formatLanguageCode(e) {
    if (Te(e) && e.indexOf("-") > -1) {
      if (typeof Intl < "u" && typeof Intl.getCanonicalLocales < "u")
        try {
          let r = Intl.getCanonicalLocales(e)[0];
          if (r && this.options.lowerCaseLng && (r = r.toLowerCase()), r)
            return r;
        } catch {
        }
      const t = ["hans", "hant", "latn", "cyrl", "cans", "mong", "arab"];
      let s = e.split("-");
      return this.options.lowerCaseLng ? s = s.map((r) => r.toLowerCase()) : s.length === 2 ? (s[0] = s[0].toLowerCase(), s[1] = s[1].toUpperCase(), t.indexOf(s[1].toLowerCase()) > -1 && (s[1] = Jr(s[1].toLowerCase()))) : s.length === 3 && (s[0] = s[0].toLowerCase(), s[1].length === 2 && (s[1] = s[1].toUpperCase()), s[0] !== "sgn" && s[2].length === 2 && (s[2] = s[2].toUpperCase()), t.indexOf(s[1].toLowerCase()) > -1 && (s[1] = Jr(s[1].toLowerCase())), t.indexOf(s[2].toLowerCase()) > -1 && (s[2] = Jr(s[2].toLowerCase()))), s.join("-");
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? e.toLowerCase() : e;
  }
  isSupportedCode(e) {
    return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (e = this.getLanguagePartFromCode(e)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(e) > -1;
  }
  getBestMatchFromCodes(e) {
    if (!e)
      return null;
    let t;
    return e.forEach((s) => {
      if (t)
        return;
      const r = this.formatLanguageCode(s);
      (!this.options.supportedLngs || this.isSupportedCode(r)) && (t = r);
    }), !t && this.options.supportedLngs && e.forEach((s) => {
      if (t)
        return;
      const r = this.getLanguagePartFromCode(s);
      if (this.isSupportedCode(r))
        return t = r;
      t = this.options.supportedLngs.find((a) => {
        if (a === r)
          return a;
        if (!(a.indexOf("-") < 0 && r.indexOf("-") < 0) && (a.indexOf("-") > 0 && r.indexOf("-") < 0 && a.substring(0, a.indexOf("-")) === r || a.indexOf(r) === 0 && r.length > 1))
          return a;
      });
    }), t || (t = this.getFallbackCodes(this.options.fallbackLng)[0]), t;
  }
  getFallbackCodes(e, t) {
    if (!e)
      return [];
    if (typeof e == "function" && (e = e(t)), Te(e) && (e = [e]), Array.isArray(e))
      return e;
    if (!t)
      return e.default || [];
    let s = e[t];
    return s || (s = e[this.getScriptPartFromCode(t)]), s || (s = e[this.formatLanguageCode(t)]), s || (s = e[this.getLanguagePartFromCode(t)]), s || (s = e.default), s || [];
  }
  toResolveHierarchy(e, t) {
    const s = this.getFallbackCodes(t || this.options.fallbackLng || [], e), r = [], a = (c) => {
      c && (this.isSupportedCode(c) ? r.push(c) : this.logger.warn(`rejecting language code not found in supportedLngs: ${c}`));
    };
    return Te(e) && (e.indexOf("-") > -1 || e.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && a(this.formatLanguageCode(e)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && a(this.getScriptPartFromCode(e)), this.options.load !== "currentOnly" && a(this.getLanguagePartFromCode(e))) : Te(e) && a(this.formatLanguageCode(e)), s.forEach((c) => {
      r.indexOf(c) < 0 && a(this.formatLanguageCode(c));
    }), r;
  }
}
let Mf = [{
  lngs: ["ach", "ak", "am", "arn", "br", "fil", "gun", "ln", "mfe", "mg", "mi", "oc", "pt", "pt-BR", "tg", "tl", "ti", "tr", "uz", "wa"],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ["af", "an", "ast", "az", "bg", "bn", "ca", "da", "de", "dev", "el", "en", "eo", "es", "et", "eu", "fi", "fo", "fur", "fy", "gl", "gu", "ha", "hi", "hu", "hy", "ia", "it", "kk", "kn", "ku", "lb", "mai", "ml", "mn", "mr", "nah", "nap", "nb", "ne", "nl", "nn", "no", "nso", "pa", "pap", "pms", "ps", "pt-PT", "rm", "sco", "se", "si", "so", "son", "sq", "sv", "sw", "ta", "te", "tk", "ur", "yo"],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ["ay", "bo", "cgg", "fa", "ht", "id", "ja", "jbo", "ka", "km", "ko", "ky", "lo", "ms", "sah", "su", "th", "tt", "ug", "vi", "wo", "zh"],
  nr: [1],
  fc: 3
}, {
  lngs: ["be", "bs", "cnr", "dz", "hr", "ru", "sr", "uk"],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ["ar"],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ["cs", "sk"],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ["csb", "pl"],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ["cy"],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ["fr"],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ["ga"],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ["gd"],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ["is"],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ["jv"],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ["kw"],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ["lt"],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ["lv"],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ["mk"],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ["mnk"],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ["mt"],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ["or"],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ["ro"],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ["sl"],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ["he", "iw"],
  nr: [1, 2, 20, 21],
  fc: 22
}], jf = {
  1: (n) => +(n > 1),
  2: (n) => +(n != 1),
  3: (n) => 0,
  4: (n) => n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2,
  5: (n) => n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5,
  6: (n) => n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2,
  7: (n) => n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2,
  8: (n) => n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3,
  9: (n) => +(n >= 2),
  10: (n) => n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4,
  11: (n) => n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3,
  12: (n) => +(n % 10 != 1 || n % 100 == 11),
  13: (n) => +(n !== 0),
  14: (n) => n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3,
  15: (n) => n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2,
  16: (n) => n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2,
  17: (n) => n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1,
  18: (n) => n == 0 ? 0 : n == 1 ? 1 : 2,
  19: (n) => n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3,
  20: (n) => n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2,
  21: (n) => n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0,
  22: (n) => n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3
};
const Lf = ["v1", "v2", "v3"], Df = ["v4"], Za = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
}, Nf = () => {
  const n = {};
  return Mf.forEach((e) => {
    e.lngs.forEach((t) => {
      n[t] = {
        numbers: e.nr,
        plurals: jf[e.fc]
      };
    });
  }), n;
};
class Ff {
  constructor(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.languageUtils = e, this.options = t, this.logger = ai.create("pluralResolver"), (!this.options.compatibilityJSON || Df.includes(this.options.compatibilityJSON)) && (typeof Intl > "u" || !Intl.PluralRules) && (this.options.compatibilityJSON = "v3", this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.")), this.rules = Nf(), this.pluralRulesCache = {};
  }
  addRule(e, t) {
    this.rules[e] = t;
  }
  clearCache() {
    this.pluralRulesCache = {};
  }
  getRule(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (this.shouldUseIntlApi())
      try {
        const s = cr(e === "dev" ? "en" : e), r = t.ordinal ? "ordinal" : "cardinal", a = JSON.stringify({
          cleanedCode: s,
          type: r
        });
        if (a in this.pluralRulesCache)
          return this.pluralRulesCache[a];
        const c = new Intl.PluralRules(s, {
          type: r
        });
        return this.pluralRulesCache[a] = c, c;
      } catch {
        return;
      }
    return this.rules[e] || this.rules[this.languageUtils.getLanguagePartFromCode(e)];
  }
  needsPlural(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const s = this.getRule(e, t);
    return this.shouldUseIntlApi() ? s && s.resolvedOptions().pluralCategories.length > 1 : s && s.numbers.length > 1;
  }
  getPluralFormsOfKey(e, t) {
    let s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return this.getSuffixes(e, s).map((r) => `${t}${r}`);
  }
  getSuffixes(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const s = this.getRule(e, t);
    return s ? this.shouldUseIntlApi() ? s.resolvedOptions().pluralCategories.sort((r, a) => Za[r] - Za[a]).map((r) => `${this.options.prepend}${t.ordinal ? `ordinal${this.options.prepend}` : ""}${r}`) : s.numbers.map((r) => this.getSuffix(e, r, t)) : [];
  }
  getSuffix(e, t) {
    let s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const r = this.getRule(e, s);
    return r ? this.shouldUseIntlApi() ? `${this.options.prepend}${s.ordinal ? `ordinal${this.options.prepend}` : ""}${r.select(t)}` : this.getSuffixRetroCompatible(r, t) : (this.logger.warn(`no plural rule found for: ${e}`), "");
  }
  getSuffixRetroCompatible(e, t) {
    const s = e.noAbs ? e.plurals(t) : e.plurals(Math.abs(t));
    let r = e.numbers[s];
    this.options.simplifyPluralSuffix && e.numbers.length === 2 && e.numbers[0] === 1 && (r === 2 ? r = "plural" : r === 1 && (r = ""));
    const a = () => this.options.prepend && r.toString() ? this.options.prepend + r.toString() : r.toString();
    return this.options.compatibilityJSON === "v1" ? r === 1 ? "" : typeof r == "number" ? `_plural_${r.toString()}` : a() : this.options.compatibilityJSON === "v2" || this.options.simplifyPluralSuffix && e.numbers.length === 2 && e.numbers[0] === 1 ? a() : this.options.prepend && s.toString() ? this.options.prepend + s.toString() : s.toString();
  }
  shouldUseIntlApi() {
    return !Lf.includes(this.options.compatibilityJSON);
  }
}
const Qa = function(n, e, t) {
  let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ".", r = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0, a = kf(n, e, t);
  return !a && r && Te(t) && (a = ko(n, t, s), a === void 0 && (a = ko(e, t, s))), a;
}, Zr = (n) => n.replace(/\$/g, "$$$$");
class Bf {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = ai.create("interpolator"), this.options = e, this.format = e.interpolation && e.interpolation.format || ((t) => t), this.init(e);
  }
  init() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    e.interpolation || (e.interpolation = {
      escapeValue: !0
    });
    const {
      escape: t,
      escapeValue: s,
      useRawValueToEscape: r,
      prefix: a,
      prefixEscaped: c,
      suffix: l,
      suffixEscaped: d,
      formatSeparator: h,
      unescapeSuffix: m,
      unescapePrefix: y,
      nestingPrefix: b,
      nestingPrefixEscaped: v,
      nestingSuffix: w,
      nestingSuffixEscaped: o,
      nestingOptionsSeparator: u,
      maxReplaces: f,
      alwaysFormat: p
    } = e.interpolation;
    this.escape = t !== void 0 ? t : Tf, this.escapeValue = s !== void 0 ? s : !0, this.useRawValueToEscape = r !== void 0 ? r : !1, this.prefix = a ? ln(a) : c || "{{", this.suffix = l ? ln(l) : d || "}}", this.formatSeparator = h || ",", this.unescapePrefix = m ? "" : y || "-", this.unescapeSuffix = this.unescapePrefix ? "" : m || "", this.nestingPrefix = b ? ln(b) : v || ln("$t("), this.nestingSuffix = w ? ln(w) : o || ln(")"), this.nestingOptionsSeparator = u || ",", this.maxReplaces = f || 1e3, this.alwaysFormat = p !== void 0 ? p : !1, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const e = (t, s) => t && t.source === s ? (t.lastIndex = 0, t) : new RegExp(s, "g");
    this.regexp = e(this.regexp, `${this.prefix}(.+?)${this.suffix}`), this.regexpUnescape = e(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`), this.nestingRegexp = e(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
  }
  interpolate(e, t, s, r) {
    let a, c, l;
    const d = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {}, h = (v) => {
      if (v.indexOf(this.formatSeparator) < 0) {
        const f = Qa(t, d, v, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(f, void 0, s, {
          ...r,
          ...t,
          interpolationkey: v
        }) : f;
      }
      const w = v.split(this.formatSeparator), o = w.shift().trim(), u = w.join(this.formatSeparator).trim();
      return this.format(Qa(t, d, o, this.options.keySeparator, this.options.ignoreJSONStructure), u, s, {
        ...r,
        ...t,
        interpolationkey: o
      });
    };
    this.resetRegExp();
    const m = r && r.missingInterpolationHandler || this.options.missingInterpolationHandler, y = r && r.interpolation && r.interpolation.skipOnVariables !== void 0 ? r.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    return [{
      regex: this.regexpUnescape,
      safeValue: (v) => Zr(v)
    }, {
      regex: this.regexp,
      safeValue: (v) => this.escapeValue ? Zr(this.escape(v)) : Zr(v)
    }].forEach((v) => {
      for (l = 0; a = v.regex.exec(e); ) {
        const w = a[1].trim();
        if (c = h(w), c === void 0)
          if (typeof m == "function") {
            const u = m(e, a, r);
            c = Te(u) ? u : "";
          } else if (r && Object.prototype.hasOwnProperty.call(r, w))
            c = "";
          else if (y) {
            c = a[0];
            continue;
          } else
            this.logger.warn(`missed to pass in variable ${w} for interpolating ${e}`), c = "";
        else
          !Te(c) && !this.useRawValueToEscape && (c = Ha(c));
        const o = v.safeValue(c);
        if (e = e.replace(a[0], o), y ? (v.regex.lastIndex += c.length, v.regex.lastIndex -= a[0].length) : v.regex.lastIndex = 0, l++, l >= this.maxReplaces)
          break;
      }
    }), e;
  }
  nest(e, t) {
    let s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r, a, c;
    const l = (d, h) => {
      const m = this.nestingOptionsSeparator;
      if (d.indexOf(m) < 0)
        return d;
      const y = d.split(new RegExp(`${m}[ ]*{`));
      let b = `{${y[1]}`;
      d = y[0], b = this.interpolate(b, c);
      const v = b.match(/'/g), w = b.match(/"/g);
      (v && v.length % 2 === 0 && !w || w.length % 2 !== 0) && (b = b.replace(/'/g, '"'));
      try {
        c = JSON.parse(b), h && (c = {
          ...h,
          ...c
        });
      } catch (o) {
        return this.logger.warn(`failed parsing options string in nesting for key ${d}`, o), `${d}${m}${b}`;
      }
      return c.defaultValue && c.defaultValue.indexOf(this.prefix) > -1 && delete c.defaultValue, d;
    };
    for (; r = this.nestingRegexp.exec(e); ) {
      let d = [];
      c = {
        ...s
      }, c = c.replace && !Te(c.replace) ? c.replace : c, c.applyPostProcessor = !1, delete c.defaultValue;
      let h = !1;
      if (r[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(r[1])) {
        const m = r[1].split(this.formatSeparator).map((y) => y.trim());
        r[1] = m.shift(), d = m, h = !0;
      }
      if (a = t(l.call(this, r[1].trim(), c), c), a && r[0] === e && !Te(a))
        return a;
      Te(a) || (a = Ha(a)), a || (this.logger.warn(`missed to resolve ${r[1]} for nesting ${e}`), a = ""), h && (a = d.reduce((m, y) => this.format(m, y, s.lng, {
        ...s,
        interpolationkey: r[1].trim()
      }), a.trim())), e = e.replace(r[0], a), this.regexp.lastIndex = 0;
    }
    return e;
  }
}
const qf = (n) => {
  let e = n.toLowerCase().trim();
  const t = {};
  if (n.indexOf("(") > -1) {
    const s = n.split("(");
    e = s[0].toLowerCase().trim();
    const r = s[1].substring(0, s[1].length - 1);
    e === "currency" && r.indexOf(":") < 0 ? t.currency || (t.currency = r.trim()) : e === "relativetime" && r.indexOf(":") < 0 ? t.range || (t.range = r.trim()) : r.split(";").forEach((c) => {
      if (c) {
        const [l, ...d] = c.split(":"), h = d.join(":").trim().replace(/^'+|'+$/g, ""), m = l.trim();
        t[m] || (t[m] = h), h === "false" && (t[m] = !1), h === "true" && (t[m] = !0), isNaN(h) || (t[m] = parseInt(h, 10));
      }
    });
  }
  return {
    formatName: e,
    formatOptions: t
  };
}, cn = (n) => {
  const e = {};
  return (t, s, r) => {
    let a = r;
    r && r.interpolationkey && r.formatParams && r.formatParams[r.interpolationkey] && r[r.interpolationkey] && (a = {
      ...a,
      [r.interpolationkey]: void 0
    });
    const c = s + JSON.stringify(a);
    let l = e[c];
    return l || (l = n(cr(s), r), e[c] = l), l(t);
  };
};
class Hf {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = ai.create("formatter"), this.options = e, this.formats = {
      number: cn((t, s) => {
        const r = new Intl.NumberFormat(t, {
          ...s
        });
        return (a) => r.format(a);
      }),
      currency: cn((t, s) => {
        const r = new Intl.NumberFormat(t, {
          ...s,
          style: "currency"
        });
        return (a) => r.format(a);
      }),
      datetime: cn((t, s) => {
        const r = new Intl.DateTimeFormat(t, {
          ...s
        });
        return (a) => r.format(a);
      }),
      relativetime: cn((t, s) => {
        const r = new Intl.RelativeTimeFormat(t, {
          ...s
        });
        return (a) => r.format(a, s.range || "day");
      }),
      list: cn((t, s) => {
        const r = new Intl.ListFormat(t, {
          ...s
        });
        return (a) => r.format(a);
      })
    }, this.init(e);
  }
  init(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    this.formatSeparator = t.interpolation.formatSeparator || ",";
  }
  add(e, t) {
    this.formats[e.toLowerCase().trim()] = t;
  }
  addCached(e, t) {
    this.formats[e.toLowerCase().trim()] = cn(t);
  }
  format(e, t, s) {
    let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const a = t.split(this.formatSeparator);
    if (a.length > 1 && a[0].indexOf("(") > 1 && a[0].indexOf(")") < 0 && a.find((l) => l.indexOf(")") > -1)) {
      const l = a.findIndex((d) => d.indexOf(")") > -1);
      a[0] = [a[0], ...a.splice(1, l)].join(this.formatSeparator);
    }
    return a.reduce((l, d) => {
      const {
        formatName: h,
        formatOptions: m
      } = qf(d);
      if (this.formats[h]) {
        let y = l;
        try {
          const b = r && r.formatParams && r.formatParams[r.interpolationkey] || {}, v = b.locale || b.lng || r.locale || r.lng || s;
          y = this.formats[h](l, v, {
            ...m,
            ...r,
            ...b
          });
        } catch (b) {
          this.logger.warn(b);
        }
        return y;
      } else
        this.logger.warn(`there was no format function for ${h}`);
      return l;
    }, e);
  }
}
const Vf = (n, e) => {
  n.pending[e] !== void 0 && (delete n.pending[e], n.pendingCount--);
};
class Gf extends Rr {
  constructor(e, t, s) {
    let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    super(), this.backend = e, this.store = t, this.services = s, this.languageUtils = s.languageUtils, this.options = r, this.logger = ai.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = r.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = r.maxRetries >= 0 ? r.maxRetries : 5, this.retryTimeout = r.retryTimeout >= 1 ? r.retryTimeout : 350, this.state = {}, this.queue = [], this.backend && this.backend.init && this.backend.init(s, r.backend, r);
  }
  queueLoad(e, t, s, r) {
    const a = {}, c = {}, l = {}, d = {};
    return e.forEach((h) => {
      let m = !0;
      t.forEach((y) => {
        const b = `${h}|${y}`;
        !s.reload && this.store.hasResourceBundle(h, y) ? this.state[b] = 2 : this.state[b] < 0 || (this.state[b] === 1 ? c[b] === void 0 && (c[b] = !0) : (this.state[b] = 1, m = !1, c[b] === void 0 && (c[b] = !0), a[b] === void 0 && (a[b] = !0), d[y] === void 0 && (d[y] = !0)));
      }), m || (l[h] = !0);
    }), (Object.keys(a).length || Object.keys(c).length) && this.queue.push({
      pending: c,
      pendingCount: Object.keys(c).length,
      loaded: {},
      errors: [],
      callback: r
    }), {
      toLoad: Object.keys(a),
      pending: Object.keys(c),
      toLoadLanguages: Object.keys(l),
      toLoadNamespaces: Object.keys(d)
    };
  }
  loaded(e, t, s) {
    const r = e.split("|"), a = r[0], c = r[1];
    t && this.emit("failedLoading", a, c, t), !t && s && this.store.addResourceBundle(a, c, s, void 0, void 0, {
      skipCopy: !0
    }), this.state[e] = t ? -1 : 2, t && s && (this.state[e] = 0);
    const l = {};
    this.queue.forEach((d) => {
      Ef(d.loaded, [a], c), Vf(d, e), t && d.errors.push(t), d.pendingCount === 0 && !d.done && (Object.keys(d.loaded).forEach((h) => {
        l[h] || (l[h] = {});
        const m = d.loaded[h];
        m.length && m.forEach((y) => {
          l[h][y] === void 0 && (l[h][y] = !0);
        });
      }), d.done = !0, d.errors.length ? d.callback(d.errors) : d.callback());
    }), this.emit("loaded", l), this.queue = this.queue.filter((d) => !d.done);
  }
  read(e, t, s) {
    let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, a = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : this.retryTimeout, c = arguments.length > 5 ? arguments[5] : void 0;
    if (!e.length)
      return c(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng: e,
        ns: t,
        fcName: s,
        tried: r,
        wait: a,
        callback: c
      });
      return;
    }
    this.readingCalls++;
    const l = (h, m) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const y = this.waitingReads.shift();
        this.read(y.lng, y.ns, y.fcName, y.tried, y.wait, y.callback);
      }
      if (h && m && r < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, e, t, s, r + 1, a * 2, c);
        }, a);
        return;
      }
      c(h, m);
    }, d = this.backend[s].bind(this.backend);
    if (d.length === 2) {
      try {
        const h = d(e, t);
        h && typeof h.then == "function" ? h.then((m) => l(null, m)).catch(l) : l(null, h);
      } catch (h) {
        l(h);
      }
      return;
    }
    return d(e, t, l);
  }
  prepareLoading(e, t) {
    let s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = arguments.length > 3 ? arguments[3] : void 0;
    if (!this.backend)
      return this.logger.warn("No backend was added via i18next.use. Will not load resources."), r && r();
    Te(e) && (e = this.languageUtils.toResolveHierarchy(e)), Te(t) && (t = [t]);
    const a = this.queueLoad(e, t, s, r);
    if (!a.toLoad.length)
      return a.pending.length || r(), null;
    a.toLoad.forEach((c) => {
      this.loadOne(c);
    });
  }
  load(e, t, s) {
    this.prepareLoading(e, t, {}, s);
  }
  reload(e, t, s) {
    this.prepareLoading(e, t, {
      reload: !0
    }, s);
  }
  loadOne(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const s = e.split("|"), r = s[0], a = s[1];
    this.read(r, a, "read", void 0, void 0, (c, l) => {
      c && this.logger.warn(`${t}loading namespace ${a} for language ${r} failed`, c), !c && l && this.logger.log(`${t}loaded namespace ${a} for language ${r}`, l), this.loaded(e, c, l);
    });
  }
  saveMissing(e, t, s, r, a) {
    let c = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {}, l = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : () => {
    };
    if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(t)) {
      this.logger.warn(`did not save key "${s}" as the namespace "${t}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
      return;
    }
    if (!(s == null || s === "")) {
      if (this.backend && this.backend.create) {
        const d = {
          ...c,
          isUpdate: a
        }, h = this.backend.create.bind(this.backend);
        if (h.length < 6)
          try {
            let m;
            h.length === 5 ? m = h(e, t, s, r, d) : m = h(e, t, s, r), m && typeof m.then == "function" ? m.then((y) => l(null, y)).catch(l) : l(null, m);
          } catch (m) {
            l(m);
          }
        else
          h(e, t, s, r, l, d);
      }
      !e || !e[0] || this.store.addResource(e[0], t, s, r);
    }
  }
}
const Xa = () => ({
  debug: !1,
  initImmediate: !0,
  ns: ["translation"],
  defaultNS: ["translation"],
  fallbackLng: ["dev"],
  fallbackNS: !1,
  supportedLngs: !1,
  nonExplicitSupportedLngs: !1,
  load: "all",
  preload: !1,
  simplifyPluralSuffix: !0,
  keySeparator: ".",
  nsSeparator: ":",
  pluralSeparator: "_",
  contextSeparator: "_",
  partialBundledLanguages: !1,
  saveMissing: !1,
  updateMissing: !1,
  saveMissingTo: "fallback",
  saveMissingPlurals: !0,
  missingKeyHandler: !1,
  missingInterpolationHandler: !1,
  postProcess: !1,
  postProcessPassResolved: !1,
  returnNull: !1,
  returnEmptyString: !0,
  returnObjects: !1,
  joinArrays: !1,
  returnedObjectHandler: !1,
  parseMissingKeyHandler: !1,
  appendNamespaceToMissingKey: !1,
  appendNamespaceToCIMode: !1,
  overloadTranslationOptionHandler: (n) => {
    let e = {};
    if (typeof n[1] == "object" && (e = n[1]), Te(n[1]) && (e.defaultValue = n[1]), Te(n[2]) && (e.tDescription = n[2]), typeof n[2] == "object" || typeof n[3] == "object") {
      const t = n[3] || n[2];
      Object.keys(t).forEach((s) => {
        e[s] = t[s];
      });
    }
    return e;
  },
  interpolation: {
    escapeValue: !0,
    format: (n) => n,
    prefix: "{{",
    suffix: "}}",
    formatSeparator: ",",
    unescapePrefix: "-",
    nestingPrefix: "$t(",
    nestingSuffix: ")",
    nestingOptionsSeparator: ",",
    maxReplaces: 1e3,
    skipOnVariables: !0
  }
}), _a = (n) => (Te(n.ns) && (n.ns = [n.ns]), Te(n.fallbackLng) && (n.fallbackLng = [n.fallbackLng]), Te(n.fallbackNS) && (n.fallbackNS = [n.fallbackNS]), n.supportedLngs && n.supportedLngs.indexOf("cimode") < 0 && (n.supportedLngs = n.supportedLngs.concat(["cimode"])), n), zs = () => {
}, Wf = (n) => {
  Object.getOwnPropertyNames(Object.getPrototypeOf(n)).forEach((t) => {
    typeof n[t] == "function" && (n[t] = n[t].bind(n));
  });
};
class is extends Rr {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 ? arguments[1] : void 0;
    if (super(), this.options = _a(e), this.services = {}, this.logger = ai, this.modules = {
      external: []
    }, Wf(this), t && !this.isInitialized && !e.isClone) {
      if (!this.options.initImmediate)
        return this.init(e, t), this;
      setTimeout(() => {
        this.init(e, t);
      }, 0);
    }
  }
  init() {
    var e = this;
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, s = arguments.length > 1 ? arguments[1] : void 0;
    this.isInitializing = !0, typeof t == "function" && (s = t, t = {}), !t.defaultNS && t.defaultNS !== !1 && t.ns && (Te(t.ns) ? t.defaultNS = t.ns : t.ns.indexOf("translation") < 0 && (t.defaultNS = t.ns[0]));
    const r = Xa();
    this.options = {
      ...r,
      ...this.options,
      ..._a(t)
    }, this.options.compatibilityAPI !== "v1" && (this.options.interpolation = {
      ...r.interpolation,
      ...this.options.interpolation
    }), t.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = t.keySeparator), t.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = t.nsSeparator);
    const a = (m) => m ? typeof m == "function" ? new m() : m : null;
    if (!this.options.isClone) {
      this.modules.logger ? ai.init(a(this.modules.logger), this.options) : ai.init(null, this.options);
      let m;
      this.modules.formatter ? m = this.modules.formatter : typeof Intl < "u" && (m = Hf);
      const y = new Ja(this.options);
      this.store = new Ka(this.options.resources, this.options);
      const b = this.services;
      b.logger = ai, b.resourceStore = this.store, b.languageUtils = y, b.pluralResolver = new Ff(y, {
        prepend: this.options.pluralSeparator,
        compatibilityJSON: this.options.compatibilityJSON,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      }), m && (!this.options.interpolation.format || this.options.interpolation.format === r.interpolation.format) && (b.formatter = a(m), b.formatter.init(b, this.options), this.options.interpolation.format = b.formatter.format.bind(b.formatter)), b.interpolator = new Bf(this.options), b.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      }, b.backendConnector = new Gf(a(this.modules.backend), b.resourceStore, b, this.options), b.backendConnector.on("*", function(v) {
        for (var w = arguments.length, o = new Array(w > 1 ? w - 1 : 0), u = 1; u < w; u++)
          o[u - 1] = arguments[u];
        e.emit(v, ...o);
      }), this.modules.languageDetector && (b.languageDetector = a(this.modules.languageDetector), b.languageDetector.init && b.languageDetector.init(b, this.options.detection, this.options)), this.modules.i18nFormat && (b.i18nFormat = a(this.modules.i18nFormat), b.i18nFormat.init && b.i18nFormat.init(this)), this.translator = new dr(this.services, this.options), this.translator.on("*", function(v) {
        for (var w = arguments.length, o = new Array(w > 1 ? w - 1 : 0), u = 1; u < w; u++)
          o[u - 1] = arguments[u];
        e.emit(v, ...o);
      }), this.modules.external.forEach((v) => {
        v.init && v.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, s || (s = zs), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const m = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      m.length > 0 && m[0] !== "dev" && (this.options.lng = m[0]);
    }
    !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((m) => {
      this[m] = function() {
        return e.store[m](...arguments);
      };
    }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((m) => {
      this[m] = function() {
        return e.store[m](...arguments), e;
      };
    });
    const d = Rn(), h = () => {
      const m = (y, b) => {
        this.isInitializing = !1, this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), d.resolve(b), s(y, b);
      };
      if (this.languages && this.options.compatibilityAPI !== "v1" && !this.isInitialized)
        return m(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, m);
    };
    return this.options.resources || !this.options.initImmediate ? h() : setTimeout(h, 0), d;
  }
  loadResources(e) {
    let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : zs;
    const r = Te(e) ? e : this.language;
    if (typeof e == "function" && (s = e), !this.options.resources || this.options.partialBundledLanguages) {
      if (r && r.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0))
        return s();
      const a = [], c = (l) => {
        if (!l || l === "cimode")
          return;
        this.services.languageUtils.toResolveHierarchy(l).forEach((h) => {
          h !== "cimode" && a.indexOf(h) < 0 && a.push(h);
        });
      };
      r ? c(r) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((d) => c(d)), this.options.preload && this.options.preload.forEach((l) => c(l)), this.services.backendConnector.load(a, this.options.ns, (l) => {
        !l && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), s(l);
      });
    } else
      s(null);
  }
  reloadResources(e, t, s) {
    const r = Rn();
    return typeof e == "function" && (s = e, e = void 0), typeof t == "function" && (s = t, t = void 0), e || (e = this.languages), t || (t = this.options.ns), s || (s = zs), this.services.backendConnector.reload(e, t, (a) => {
      r.resolve(), s(a);
    }), r;
  }
  use(e) {
    if (!e)
      throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!e.type)
      throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return e.type === "backend" && (this.modules.backend = e), (e.type === "logger" || e.log && e.warn && e.error) && (this.modules.logger = e), e.type === "languageDetector" && (this.modules.languageDetector = e), e.type === "i18nFormat" && (this.modules.i18nFormat = e), e.type === "postProcessor" && fu.addPostProcessor(e), e.type === "formatter" && (this.modules.formatter = e), e.type === "3rdParty" && this.modules.external.push(e), this;
  }
  setResolvedLanguage(e) {
    if (!(!e || !this.languages) && !(["cimode", "dev"].indexOf(e) > -1))
      for (let t = 0; t < this.languages.length; t++) {
        const s = this.languages[t];
        if (!(["cimode", "dev"].indexOf(s) > -1) && this.store.hasLanguageSomeTranslations(s)) {
          this.resolvedLanguage = s;
          break;
        }
      }
  }
  changeLanguage(e, t) {
    var s = this;
    this.isLanguageChangingTo = e;
    const r = Rn();
    this.emit("languageChanging", e);
    const a = (d) => {
      this.language = d, this.languages = this.services.languageUtils.toResolveHierarchy(d), this.resolvedLanguage = void 0, this.setResolvedLanguage(d);
    }, c = (d, h) => {
      h ? (a(h), this.translator.changeLanguage(h), this.isLanguageChangingTo = void 0, this.emit("languageChanged", h), this.logger.log("languageChanged", h)) : this.isLanguageChangingTo = void 0, r.resolve(function() {
        return s.t(...arguments);
      }), t && t(d, function() {
        return s.t(...arguments);
      });
    }, l = (d) => {
      !e && !d && this.services.languageDetector && (d = []);
      const h = Te(d) ? d : this.services.languageUtils.getBestMatchFromCodes(d);
      h && (this.language || a(h), this.translator.language || this.translator.changeLanguage(h), this.services.languageDetector && this.services.languageDetector.cacheUserLanguage && this.services.languageDetector.cacheUserLanguage(h)), this.loadResources(h, (m) => {
        c(m, h);
      });
    };
    return !e && this.services.languageDetector && !this.services.languageDetector.async ? l(this.services.languageDetector.detect()) : !e && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(l) : this.services.languageDetector.detect(l) : l(e), r;
  }
  getFixedT(e, t, s) {
    var r = this;
    const a = function(c, l) {
      let d;
      if (typeof l != "object") {
        for (var h = arguments.length, m = new Array(h > 2 ? h - 2 : 0), y = 2; y < h; y++)
          m[y - 2] = arguments[y];
        d = r.options.overloadTranslationOptionHandler([c, l].concat(m));
      } else
        d = {
          ...l
        };
      d.lng = d.lng || a.lng, d.lngs = d.lngs || a.lngs, d.ns = d.ns || a.ns, d.keyPrefix !== "" && (d.keyPrefix = d.keyPrefix || s || a.keyPrefix);
      const b = r.options.keySeparator || ".";
      let v;
      return d.keyPrefix && Array.isArray(c) ? v = c.map((w) => `${d.keyPrefix}${b}${w}`) : v = d.keyPrefix ? `${d.keyPrefix}${b}${c}` : c, r.t(v, d);
    };
    return Te(e) ? a.lng = e : a.lngs = e, a.ns = t, a.keyPrefix = s, a;
  }
  t() {
    return this.translator && this.translator.translate(...arguments);
  }
  exists() {
    return this.translator && this.translator.exists(...arguments);
  }
  setDefaultNamespace(e) {
    this.options.defaultNS = e;
  }
  hasLoadedNamespace(e) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!this.isInitialized)
      return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
    if (!this.languages || !this.languages.length)
      return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
    const s = t.lng || this.resolvedLanguage || this.languages[0], r = this.options ? this.options.fallbackLng : !1, a = this.languages[this.languages.length - 1];
    if (s.toLowerCase() === "cimode")
      return !0;
    const c = (l, d) => {
      const h = this.services.backendConnector.state[`${l}|${d}`];
      return h === -1 || h === 0 || h === 2;
    };
    if (t.precheck) {
      const l = t.precheck(this, c);
      if (l !== void 0)
        return l;
    }
    return !!(this.hasResourceBundle(s, e) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || c(s, e) && (!r || c(a, e)));
  }
  loadNamespaces(e, t) {
    const s = Rn();
    return this.options.ns ? (Te(e) && (e = [e]), e.forEach((r) => {
      this.options.ns.indexOf(r) < 0 && this.options.ns.push(r);
    }), this.loadResources((r) => {
      s.resolve(), t && t(r);
    }), s) : (t && t(), Promise.resolve());
  }
  loadLanguages(e, t) {
    const s = Rn();
    Te(e) && (e = [e]);
    const r = this.options.preload || [], a = e.filter((c) => r.indexOf(c) < 0 && this.services.languageUtils.isSupportedCode(c));
    return a.length ? (this.options.preload = r.concat(a), this.loadResources((c) => {
      s.resolve(), t && t(c);
    }), s) : (t && t(), Promise.resolve());
  }
  dir(e) {
    if (e || (e = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language)), !e)
      return "rtl";
    const t = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], s = this.services && this.services.languageUtils || new Ja(Xa());
    return t.indexOf(s.getLanguagePartFromCode(e)) > -1 || e.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 ? arguments[1] : void 0;
    return new is(e, t);
  }
  cloneInstance() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : zs;
    const s = e.forkResourceStore;
    s && delete e.forkResourceStore;
    const r = {
      ...this.options,
      ...e,
      isClone: !0
    }, a = new is(r);
    return (e.debug !== void 0 || e.prefix !== void 0) && (a.logger = a.logger.clone(e)), ["store", "services", "language"].forEach((l) => {
      a[l] = this[l];
    }), a.services = {
      ...this.services
    }, a.services.utils = {
      hasLoadedNamespace: a.hasLoadedNamespace.bind(a)
    }, s && (a.store = new Ka(this.store.data, r), a.services.resourceStore = a.store), a.translator = new dr(a.services, r), a.translator.on("*", function(l) {
      for (var d = arguments.length, h = new Array(d > 1 ? d - 1 : 0), m = 1; m < d; m++)
        h[m - 1] = arguments[m];
      a.emit(l, ...h);
    }), a.init(r, t), a.translator.options = r, a.translator.backendConnector.services.utils = {
      hasLoadedNamespace: a.hasLoadedNamespace.bind(a)
    }, a;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const qe = is.createInstance();
qe.createInstance = is.createInstance;
qe.createInstance;
qe.dir;
qe.init;
qe.loadResources;
qe.reloadResources;
qe.use;
qe.changeLanguage;
qe.getFixedT;
qe.t;
qe.exists;
qe.setDefaultNamespace;
qe.hasLoadedNamespace;
qe.loadNamespaces;
qe.loadLanguages;
function Oo(n) {
  "@babel/helpers - typeof";
  return Oo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Oo(n);
}
function hu() {
  return typeof XMLHttpRequest == "function" || (typeof XMLHttpRequest > "u" ? "undefined" : Oo(XMLHttpRequest)) === "object";
}
function Kf(n) {
  return !!n && typeof n.then == "function";
}
function Yf(n) {
  return Kf(n) ? n : Promise.resolve(n);
}
var Zn = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function ms(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
function Jf(n) {
  throw new Error('Could not dynamically require "' + n + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var To = { exports: {} }, Rs = { exports: {} }, $a;
function Zf() {
  return $a || ($a = 1, function(n, e) {
    var t = typeof globalThis < "u" && globalThis || typeof self < "u" && self || typeof Zn < "u" && Zn, s = function() {
      function a() {
        this.fetch = !1, this.DOMException = t.DOMException;
      }
      return a.prototype = t, new a();
    }();
    (function(a) {
      (function(c) {
        var l = typeof a < "u" && a || typeof self < "u" && self || typeof l < "u" && l, d = {
          searchParams: "URLSearchParams" in l,
          iterable: "Symbol" in l && "iterator" in Symbol,
          blob: "FileReader" in l && "Blob" in l && function() {
            try {
              return new Blob(), !0;
            } catch {
              return !1;
            }
          }(),
          formData: "FormData" in l,
          arrayBuffer: "ArrayBuffer" in l
        };
        function h(C) {
          return C && DataView.prototype.isPrototypeOf(C);
        }
        if (d.arrayBuffer)
          var m = [
            "[object Int8Array]",
            "[object Uint8Array]",
            "[object Uint8ClampedArray]",
            "[object Int16Array]",
            "[object Uint16Array]",
            "[object Int32Array]",
            "[object Uint32Array]",
            "[object Float32Array]",
            "[object Float64Array]"
          ], y = ArrayBuffer.isView || function(C) {
            return C && m.indexOf(Object.prototype.toString.call(C)) > -1;
          };
        function b(C) {
          if (typeof C != "string" && (C = String(C)), /[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(C) || C === "")
            throw new TypeError('Invalid character in header field name: "' + C + '"');
          return C.toLowerCase();
        }
        function v(C) {
          return typeof C != "string" && (C = String(C)), C;
        }
        function w(C) {
          var U = {
            next: function() {
              var z = C.shift();
              return { done: z === void 0, value: z };
            }
          };
          return d.iterable && (U[Symbol.iterator] = function() {
            return U;
          }), U;
        }
        function o(C) {
          this.map = {}, C instanceof o ? C.forEach(function(U, z) {
            this.append(z, U);
          }, this) : Array.isArray(C) ? C.forEach(function(U) {
            this.append(U[0], U[1]);
          }, this) : C && Object.getOwnPropertyNames(C).forEach(function(U) {
            this.append(U, C[U]);
          }, this);
        }
        o.prototype.append = function(C, U) {
          C = b(C), U = v(U);
          var z = this.map[C];
          this.map[C] = z ? z + ", " + U : U;
        }, o.prototype.delete = function(C) {
          delete this.map[b(C)];
        }, o.prototype.get = function(C) {
          return C = b(C), this.has(C) ? this.map[C] : null;
        }, o.prototype.has = function(C) {
          return this.map.hasOwnProperty(b(C));
        }, o.prototype.set = function(C, U) {
          this.map[b(C)] = v(U);
        }, o.prototype.forEach = function(C, U) {
          for (var z in this.map)
            this.map.hasOwnProperty(z) && C.call(U, this.map[z], z, this);
        }, o.prototype.keys = function() {
          var C = [];
          return this.forEach(function(U, z) {
            C.push(z);
          }), w(C);
        }, o.prototype.values = function() {
          var C = [];
          return this.forEach(function(U) {
            C.push(U);
          }), w(C);
        }, o.prototype.entries = function() {
          var C = [];
          return this.forEach(function(U, z) {
            C.push([z, U]);
          }), w(C);
        }, d.iterable && (o.prototype[Symbol.iterator] = o.prototype.entries);
        function u(C) {
          if (C.bodyUsed)
            return Promise.reject(new TypeError("Already read"));
          C.bodyUsed = !0;
        }
        function f(C) {
          return new Promise(function(U, z) {
            C.onload = function() {
              U(C.result);
            }, C.onerror = function() {
              z(C.error);
            };
          });
        }
        function p(C) {
          var U = new FileReader(), z = f(U);
          return U.readAsArrayBuffer(C), z;
        }
        function g(C) {
          var U = new FileReader(), z = f(U);
          return U.readAsText(C), z;
        }
        function S(C) {
          for (var U = new Uint8Array(C), z = new Array(U.length), j = 0; j < U.length; j++)
            z[j] = String.fromCharCode(U[j]);
          return z.join("");
        }
        function x(C) {
          if (C.slice)
            return C.slice(0);
          var U = new Uint8Array(C.byteLength);
          return U.set(new Uint8Array(C)), U.buffer;
        }
        function E() {
          return this.bodyUsed = !1, this._initBody = function(C) {
            this.bodyUsed = this.bodyUsed, this._bodyInit = C, C ? typeof C == "string" ? this._bodyText = C : d.blob && Blob.prototype.isPrototypeOf(C) ? this._bodyBlob = C : d.formData && FormData.prototype.isPrototypeOf(C) ? this._bodyFormData = C : d.searchParams && URLSearchParams.prototype.isPrototypeOf(C) ? this._bodyText = C.toString() : d.arrayBuffer && d.blob && h(C) ? (this._bodyArrayBuffer = x(C.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : d.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(C) || y(C)) ? this._bodyArrayBuffer = x(C) : this._bodyText = C = Object.prototype.toString.call(C) : this._bodyText = "", this.headers.get("content-type") || (typeof C == "string" ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : d.searchParams && URLSearchParams.prototype.isPrototypeOf(C) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
          }, d.blob && (this.blob = function() {
            var C = u(this);
            if (C)
              return C;
            if (this._bodyBlob)
              return Promise.resolve(this._bodyBlob);
            if (this._bodyArrayBuffer)
              return Promise.resolve(new Blob([this._bodyArrayBuffer]));
            if (this._bodyFormData)
              throw new Error("could not read FormData body as blob");
            return Promise.resolve(new Blob([this._bodyText]));
          }, this.arrayBuffer = function() {
            if (this._bodyArrayBuffer) {
              var C = u(this);
              return C || (ArrayBuffer.isView(this._bodyArrayBuffer) ? Promise.resolve(
                this._bodyArrayBuffer.buffer.slice(
                  this._bodyArrayBuffer.byteOffset,
                  this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength
                )
              ) : Promise.resolve(this._bodyArrayBuffer));
            } else
              return this.blob().then(p);
          }), this.text = function() {
            var C = u(this);
            if (C)
              return C;
            if (this._bodyBlob)
              return g(this._bodyBlob);
            if (this._bodyArrayBuffer)
              return Promise.resolve(S(this._bodyArrayBuffer));
            if (this._bodyFormData)
              throw new Error("could not read FormData body as text");
            return Promise.resolve(this._bodyText);
          }, d.formData && (this.formData = function() {
            return this.text().then(T);
          }), this.json = function() {
            return this.text().then(JSON.parse);
          }, this;
        }
        var k = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];
        function R(C) {
          var U = C.toUpperCase();
          return k.indexOf(U) > -1 ? U : C;
        }
        function O(C, U) {
          if (!(this instanceof O))
            throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
          U = U || {};
          var z = U.body;
          if (C instanceof O) {
            if (C.bodyUsed)
              throw new TypeError("Already read");
            this.url = C.url, this.credentials = C.credentials, U.headers || (this.headers = new o(C.headers)), this.method = C.method, this.mode = C.mode, this.signal = C.signal, !z && C._bodyInit != null && (z = C._bodyInit, C.bodyUsed = !0);
          } else
            this.url = String(C);
          if (this.credentials = U.credentials || this.credentials || "same-origin", (U.headers || !this.headers) && (this.headers = new o(U.headers)), this.method = R(U.method || this.method || "GET"), this.mode = U.mode || this.mode || null, this.signal = U.signal || this.signal, this.referrer = null, (this.method === "GET" || this.method === "HEAD") && z)
            throw new TypeError("Body not allowed for GET or HEAD requests");
          if (this._initBody(z), (this.method === "GET" || this.method === "HEAD") && (U.cache === "no-store" || U.cache === "no-cache")) {
            var j = /([?&])_=[^&]*/;
            if (j.test(this.url))
              this.url = this.url.replace(j, "$1_=" + (/* @__PURE__ */ new Date()).getTime());
            else {
              var F = /\?/;
              this.url += (F.test(this.url) ? "&" : "?") + "_=" + (/* @__PURE__ */ new Date()).getTime();
            }
          }
        }
        O.prototype.clone = function() {
          return new O(this, { body: this._bodyInit });
        };
        function T(C) {
          var U = new FormData();
          return C.trim().split("&").forEach(function(z) {
            if (z) {
              var j = z.split("="), F = j.shift().replace(/\+/g, " "), q = j.join("=").replace(/\+/g, " ");
              U.append(decodeURIComponent(F), decodeURIComponent(q));
            }
          }), U;
        }
        function D(C) {
          var U = new o(), z = C.replace(/\r?\n[\t ]+/g, " ");
          return z.split("\r").map(function(j) {
            return j.indexOf(`
`) === 0 ? j.substr(1, j.length) : j;
          }).forEach(function(j) {
            var F = j.split(":"), q = F.shift().trim();
            if (q) {
              var W = F.join(":").trim();
              U.append(q, W);
            }
          }), U;
        }
        E.call(O.prototype);
        function P(C, U) {
          if (!(this instanceof P))
            throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
          U || (U = {}), this.type = "default", this.status = U.status === void 0 ? 200 : U.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = U.statusText === void 0 ? "" : "" + U.statusText, this.headers = new o(U.headers), this.url = U.url || "", this._initBody(C);
        }
        E.call(P.prototype), P.prototype.clone = function() {
          return new P(this._bodyInit, {
            status: this.status,
            statusText: this.statusText,
            headers: new o(this.headers),
            url: this.url
          });
        }, P.error = function() {
          var C = new P(null, { status: 0, statusText: "" });
          return C.type = "error", C;
        };
        var N = [301, 302, 303, 307, 308];
        P.redirect = function(C, U) {
          if (N.indexOf(U) === -1)
            throw new RangeError("Invalid status code");
          return new P(null, { status: U, headers: { location: C } });
        }, c.DOMException = l.DOMException;
        try {
          new c.DOMException();
        } catch {
          c.DOMException = function(U, z) {
            this.message = U, this.name = z;
            var j = Error(U);
            this.stack = j.stack;
          }, c.DOMException.prototype = Object.create(Error.prototype), c.DOMException.prototype.constructor = c.DOMException;
        }
        function I(C, U) {
          return new Promise(function(z, j) {
            var F = new O(C, U);
            if (F.signal && F.signal.aborted)
              return j(new c.DOMException("Aborted", "AbortError"));
            var q = new XMLHttpRequest();
            function W() {
              q.abort();
            }
            q.onload = function() {
              var Q = {
                status: q.status,
                statusText: q.statusText,
                headers: D(q.getAllResponseHeaders() || "")
              };
              Q.url = "responseURL" in q ? q.responseURL : Q.headers.get("X-Request-URL");
              var G = "response" in q ? q.response : q.responseText;
              setTimeout(function() {
                z(new P(G, Q));
              }, 0);
            }, q.onerror = function() {
              setTimeout(function() {
                j(new TypeError("Network request failed"));
              }, 0);
            }, q.ontimeout = function() {
              setTimeout(function() {
                j(new TypeError("Network request failed"));
              }, 0);
            }, q.onabort = function() {
              setTimeout(function() {
                j(new c.DOMException("Aborted", "AbortError"));
              }, 0);
            };
            function K(Q) {
              try {
                return Q === "" && l.location.href ? l.location.href : Q;
              } catch {
                return Q;
              }
            }
            q.open(F.method, K(F.url), !0), F.credentials === "include" ? q.withCredentials = !0 : F.credentials === "omit" && (q.withCredentials = !1), "responseType" in q && (d.blob ? q.responseType = "blob" : d.arrayBuffer && F.headers.get("Content-Type") && F.headers.get("Content-Type").indexOf("application/octet-stream") !== -1 && (q.responseType = "arraybuffer")), U && typeof U.headers == "object" && !(U.headers instanceof o) ? Object.getOwnPropertyNames(U.headers).forEach(function(Q) {
              q.setRequestHeader(Q, v(U.headers[Q]));
            }) : F.headers.forEach(function(Q, G) {
              q.setRequestHeader(G, Q);
            }), F.signal && (F.signal.addEventListener("abort", W), q.onreadystatechange = function() {
              q.readyState === 4 && F.signal.removeEventListener("abort", W);
            }), q.send(typeof F._bodyInit > "u" ? null : F._bodyInit);
          });
        }
        return I.polyfill = !0, l.fetch || (l.fetch = I, l.Headers = o, l.Request = O, l.Response = P), c.Headers = o, c.Request = O, c.Response = P, c.fetch = I, c;
      })({});
    })(s), s.fetch.ponyfill = !0, delete s.fetch.polyfill;
    var r = t.fetch ? t : s;
    e = r.fetch, e.default = r.fetch, e.fetch = r.fetch, e.Headers = r.Headers, e.Request = r.Request, e.Response = r.Response, n.exports = e;
  }(Rs, Rs.exports)), Rs.exports;
}
(function(n, e) {
  var t;
  if (typeof fetch == "function" && (typeof Zn < "u" && Zn.fetch ? t = Zn.fetch : typeof window < "u" && window.fetch ? t = window.fetch : t = fetch), typeof Jf < "u" && typeof window > "u") {
    var s = t || Zf();
    s.default && (s = s.default), e.default = s, n.exports = e.default;
  }
})(To, To.exports);
var pu = To.exports;
const mu = /* @__PURE__ */ ms(pu), el = /* @__PURE__ */ uf({
  __proto__: null,
  default: mu
}, [pu]);
function tl(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(n);
    e && (s = s.filter(function(r) {
      return Object.getOwnPropertyDescriptor(n, r).enumerable;
    })), t.push.apply(t, s);
  }
  return t;
}
function il(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? tl(Object(t), !0).forEach(function(s) {
      Qf(n, s, t[s]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : tl(Object(t)).forEach(function(s) {
      Object.defineProperty(n, s, Object.getOwnPropertyDescriptor(t, s));
    });
  }
  return n;
}
function Qf(n, e, t) {
  return (e = Xf(e)) in n ? Object.defineProperty(n, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : n[e] = t, n;
}
function Xf(n) {
  var e = _f(n, "string");
  return $i(e) == "symbol" ? e : e + "";
}
function _f(n, e) {
  if ($i(n) != "object" || !n)
    return n;
  var t = n[Symbol.toPrimitive];
  if (t !== void 0) {
    var s = t.call(n, e || "default");
    if ($i(s) != "object")
      return s;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(n);
}
function $i(n) {
  "@babel/helpers - typeof";
  return $i = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, $i(n);
}
var wi;
typeof fetch == "function" && (typeof global < "u" && global.fetch ? wi = global.fetch : typeof window < "u" && window.fetch ? wi = window.fetch : wi = fetch);
var ns;
hu() && (typeof global < "u" && global.XMLHttpRequest ? ns = global.XMLHttpRequest : typeof window < "u" && window.XMLHttpRequest && (ns = window.XMLHttpRequest));
var fr;
typeof ActiveXObject == "function" && (typeof global < "u" && global.ActiveXObject ? fr = global.ActiveXObject : typeof window < "u" && window.ActiveXObject && (fr = window.ActiveXObject));
!wi && el && !ns && !fr && (wi = mu || el);
typeof wi != "function" && (wi = void 0);
var Io = function(e, t) {
  if (t && $i(t) === "object") {
    var s = "";
    for (var r in t)
      s += "&" + encodeURIComponent(r) + "=" + encodeURIComponent(t[r]);
    if (!s)
      return e;
    e = e + (e.indexOf("?") !== -1 ? "&" : "?") + s.slice(1);
  }
  return e;
}, nl = function(e, t, s, r) {
  var a = function(d) {
    if (!d.ok)
      return s(d.statusText || "Error", {
        status: d.status
      });
    d.text().then(function(h) {
      s(null, {
        status: d.status,
        data: h
      });
    }).catch(s);
  };
  if (r) {
    var c = r(e, t);
    if (c instanceof Promise) {
      c.then(a).catch(s);
      return;
    }
  }
  typeof fetch == "function" ? fetch(e, t).then(a).catch(s) : wi(e, t).then(a).catch(s);
}, sl = !1, $f = function(e, t, s, r) {
  e.queryStringParams && (t = Io(t, e.queryStringParams));
  var a = il({}, typeof e.customHeaders == "function" ? e.customHeaders() : e.customHeaders);
  typeof window > "u" && typeof global < "u" && typeof global.process < "u" && global.process.versions && global.process.versions.node && (a["User-Agent"] = "i18next-http-backend (node/".concat(global.process.version, "; ").concat(global.process.platform, " ").concat(global.process.arch, ")")), s && (a["Content-Type"] = "application/json");
  var c = typeof e.requestOptions == "function" ? e.requestOptions(s) : e.requestOptions, l = il({
    method: s ? "POST" : "GET",
    body: s ? e.stringify(s) : void 0,
    headers: a
  }, sl ? {} : c), d = typeof e.alternateFetch == "function" && e.alternateFetch.length >= 1 ? e.alternateFetch : void 0;
  try {
    nl(t, l, r, d);
  } catch (h) {
    if (!c || Object.keys(c).length === 0 || !h.message || h.message.indexOf("not implemented") < 0)
      return r(h);
    try {
      Object.keys(c).forEach(function(m) {
        delete l[m];
      }), nl(t, l, r, d), sl = !0;
    } catch (m) {
      r(m);
    }
  }
}, eh = function(e, t, s, r) {
  s && $i(s) === "object" && (s = Io("", s).slice(1)), e.queryStringParams && (t = Io(t, e.queryStringParams));
  try {
    var a;
    ns ? a = new ns() : a = new fr("MSXML2.XMLHTTP.3.0"), a.open(s ? "POST" : "GET", t, 1), e.crossDomain || a.setRequestHeader("X-Requested-With", "XMLHttpRequest"), a.withCredentials = !!e.withCredentials, s && a.setRequestHeader("Content-Type", "application/x-www-form-urlencoded"), a.overrideMimeType && a.overrideMimeType("application/json");
    var c = e.customHeaders;
    if (c = typeof c == "function" ? c() : c, c)
      for (var l in c)
        a.setRequestHeader(l, c[l]);
    a.onreadystatechange = function() {
      a.readyState > 3 && r(a.status >= 400 ? a.statusText : null, {
        status: a.status,
        data: a.responseText
      });
    }, a.send(s);
  } catch (d) {
    console && console.log(d);
  }
}, th = function(e, t, s, r) {
  if (typeof s == "function" && (r = s, s = void 0), r = r || function() {
  }, wi && t.indexOf("file:") !== 0)
    return $f(e, t, s, r);
  if (hu() || typeof ActiveXObject == "function")
    return eh(e, t, s, r);
  r(new Error("No fetch and no xhr implementation found!"));
};
function vn(n) {
  "@babel/helpers - typeof";
  return vn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, vn(n);
}
function rl(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(n);
    e && (s = s.filter(function(r) {
      return Object.getOwnPropertyDescriptor(n, r).enumerable;
    })), t.push.apply(t, s);
  }
  return t;
}
function Qr(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? rl(Object(t), !0).forEach(function(s) {
      gu(n, s, t[s]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : rl(Object(t)).forEach(function(s) {
      Object.defineProperty(n, s, Object.getOwnPropertyDescriptor(t, s));
    });
  }
  return n;
}
function ih(n, e) {
  if (!(n instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function ol(n, e) {
  for (var t = 0; t < e.length; t++) {
    var s = e[t];
    s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(n, yu(s.key), s);
  }
}
function nh(n, e, t) {
  return e && ol(n.prototype, e), t && ol(n, t), Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
function gu(n, e, t) {
  return (e = yu(e)) in n ? Object.defineProperty(n, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : n[e] = t, n;
}
function yu(n) {
  var e = sh(n, "string");
  return vn(e) == "symbol" ? e : e + "";
}
function sh(n, e) {
  if (vn(n) != "object" || !n)
    return n;
  var t = n[Symbol.toPrimitive];
  if (t !== void 0) {
    var s = t.call(n, e || "default");
    if (vn(s) != "object")
      return s;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(n);
}
var rh = function() {
  return {
    loadPath: "/locales/{{lng}}/{{ns}}.json",
    addPath: "/locales/add/{{lng}}/{{ns}}",
    parse: function(t) {
      return JSON.parse(t);
    },
    stringify: JSON.stringify,
    parsePayload: function(t, s, r) {
      return gu({}, s, r || "");
    },
    parseLoadPayload: function(t, s) {
    },
    request: th,
    reloadInterval: typeof window < "u" ? !1 : 60 * 60 * 1e3,
    customHeaders: {},
    queryStringParams: {},
    crossDomain: !1,
    withCredentials: !1,
    overrideMimeType: !1,
    requestOptions: {
      mode: "cors",
      credentials: "same-origin",
      cache: "default"
    }
  };
}, vu = function() {
  function n(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    ih(this, n), this.services = e, this.options = t, this.allOptions = s, this.type = "backend", this.init(e, t, s);
  }
  return nh(n, [{
    key: "init",
    value: function(t) {
      var s = this, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      if (this.services = t, this.options = Qr(Qr(Qr({}, rh()), this.options || {}), r), this.allOptions = a, this.services && this.options.reloadInterval) {
        var c = setInterval(function() {
          return s.reload();
        }, this.options.reloadInterval);
        vn(c) === "object" && typeof c.unref == "function" && c.unref();
      }
    }
  }, {
    key: "readMulti",
    value: function(t, s, r) {
      this._readAny(t, t, s, s, r);
    }
  }, {
    key: "read",
    value: function(t, s, r) {
      this._readAny([t], t, [s], s, r);
    }
  }, {
    key: "_readAny",
    value: function(t, s, r, a, c) {
      var l = this, d = this.options.loadPath;
      typeof this.options.loadPath == "function" && (d = this.options.loadPath(t, r)), d = Yf(d), d.then(function(h) {
        if (!h)
          return c(null, {});
        var m = l.services.interpolator.interpolate(h, {
          lng: t.join("+"),
          ns: r.join("+")
        });
        l.loadUrl(m, c, s, a);
      });
    }
  }, {
    key: "loadUrl",
    value: function(t, s, r, a) {
      var c = this, l = typeof r == "string" ? [r] : r, d = typeof a == "string" ? [a] : a, h = this.options.parseLoadPayload(l, d);
      this.options.request(this.options, t, h, function(m, y) {
        if (y && (y.status >= 500 && y.status < 600 || !y.status))
          return s("failed loading " + t + "; status code: " + y.status, !0);
        if (y && y.status >= 400 && y.status < 500)
          return s("failed loading " + t + "; status code: " + y.status, !1);
        if (!y && m && m.message) {
          var b = m.message.toLowerCase(), v = ["failed", "fetch", "network", "load"].find(function(u) {
            return b.indexOf(u) > -1;
          });
          if (v)
            return s("failed loading " + t + ": " + m.message, !0);
        }
        if (m)
          return s(m, !1);
        var w, o;
        try {
          typeof y.data == "string" ? w = c.options.parse(y.data, r, a) : w = y.data;
        } catch {
          o = "failed parsing " + t + " to json";
        }
        if (o)
          return s(o, !1);
        s(null, w);
      });
    }
  }, {
    key: "create",
    value: function(t, s, r, a, c) {
      var l = this;
      if (this.options.addPath) {
        typeof t == "string" && (t = [t]);
        var d = this.options.parsePayload(s, r, a), h = 0, m = [], y = [];
        t.forEach(function(b) {
          var v = l.options.addPath;
          typeof l.options.addPath == "function" && (v = l.options.addPath(b, s));
          var w = l.services.interpolator.interpolate(v, {
            lng: b,
            ns: s
          });
          l.options.request(l.options, w, d, function(o, u) {
            h += 1, m.push(o), y.push(u), h === t.length && typeof c == "function" && c(m, y);
          });
        });
      }
    }
  }, {
    key: "reload",
    value: function() {
      var t = this, s = this.services, r = s.backendConnector, a = s.languageUtils, c = s.logger, l = r.language;
      if (!(l && l.toLowerCase() === "cimode")) {
        var d = [], h = function(y) {
          var b = a.toResolveHierarchy(y);
          b.forEach(function(v) {
            d.indexOf(v) < 0 && d.push(v);
          });
        };
        h(l), this.allOptions.preload && this.allOptions.preload.forEach(function(m) {
          return h(m);
        }), d.forEach(function(m) {
          t.allOptions.ns.forEach(function(y) {
            r.read(m, y, "read", null, null, function(b, v) {
              b && c.warn("loading namespace ".concat(y, " for language ").concat(m, " failed"), b), !b && v && c.log("loaded namespace ".concat(y, " for language ").concat(m), v), r.loaded("".concat(m, "|").concat(y), b, v);
            });
          });
        });
      }
    }
  }]);
}();
vu.type = "backend";
function oh() {
  if (console && console.warn) {
    for (var n = arguments.length, e = new Array(n), t = 0; t < n; t++)
      e[t] = arguments[t];
    Zi(e[0]) && (e[0] = `react-i18next:: ${e[0]}`), console.warn(...e);
  }
}
const al = {};
function Uo() {
  for (var n = arguments.length, e = new Array(n), t = 0; t < n; t++)
    e[t] = arguments[t];
  Zi(e[0]) && al[e[0]] || (Zi(e[0]) && (al[e[0]] = /* @__PURE__ */ new Date()), oh(...e));
}
const bu = (n, e) => () => {
  if (n.isInitialized)
    e();
  else {
    const t = () => {
      setTimeout(() => {
        n.off("initialized", t);
      }, 0), e();
    };
    n.on("initialized", t);
  }
}, ll = (n, e, t) => {
  n.loadNamespaces(e, bu(n, t));
}, cl = (n, e, t, s) => {
  Zi(t) && (t = [t]), t.forEach((r) => {
    n.options.ns.indexOf(r) < 0 && n.options.ns.push(r);
  }), n.loadLanguages(e, bu(n, s));
}, ah = function(n, e) {
  let t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  const s = e.languages[0], r = e.options ? e.options.fallbackLng : !1, a = e.languages[e.languages.length - 1];
  if (s.toLowerCase() === "cimode")
    return !0;
  const c = (l, d) => {
    const h = e.services.backendConnector.state[`${l}|${d}`];
    return h === -1 || h === 2;
  };
  return t.bindI18n && t.bindI18n.indexOf("languageChanging") > -1 && e.services.backendConnector.backend && e.isLanguageChangingTo && !c(e.isLanguageChangingTo, n) ? !1 : !!(e.hasResourceBundle(s, n) || !e.services.backendConnector.backend || e.options.resources && !e.options.partialBundledLanguages || c(s, n) && (!r || c(a, n)));
}, lh = function(n, e) {
  let t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  return !e.languages || !e.languages.length ? (Uo("i18n.languages were undefined or empty", e.languages), !0) : e.options.ignoreJSONStructure !== void 0 ? e.hasLoadedNamespace(n, {
    lng: t.lng,
    precheck: (r, a) => {
      if (t.bindI18n && t.bindI18n.indexOf("languageChanging") > -1 && r.services.backendConnector.backend && r.isLanguageChangingTo && !a(r.isLanguageChangingTo, n))
        return !1;
    }
  }) : ah(n, e, t);
}, Zi = (n) => typeof n == "string", ch = (n) => typeof n == "object" && n !== null, uh = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g, dh = {
  "&amp;": "&",
  "&#38;": "&",
  "&lt;": "<",
  "&#60;": "<",
  "&gt;": ">",
  "&#62;": ">",
  "&apos;": "'",
  "&#39;": "'",
  "&quot;": '"',
  "&#34;": '"',
  "&nbsp;": " ",
  "&#160;": " ",
  "&copy;": "©",
  "&#169;": "©",
  "&reg;": "®",
  "&#174;": "®",
  "&hellip;": "…",
  "&#8230;": "…",
  "&#x2F;": "/",
  "&#47;": "/"
}, fh = (n) => dh[n], hh = (n) => n.replace(uh, fh);
let zo = {
  bindI18n: "languageChanged",
  bindI18nStore: "",
  transEmptyNodeValue: "",
  transSupportBasicHtmlNodes: !0,
  transWrapTextNodes: "",
  transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
  useSuspense: !0,
  unescape: hh
};
const ph = function() {
  let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  zo = {
    ...zo,
    ...n
  };
}, mh = () => zo;
let xu;
const gh = (n) => {
  xu = n;
}, yh = () => xu, vh = {
  type: "3rdParty",
  init(n) {
    ph(n.options.react), gh(n);
  }
}, bh = kn();
class xh {
  constructor() {
    oe(this, "getUsedNamespaces", () => Object.keys(this.usedNamespaces));
    this.usedNamespaces = {};
  }
  addUsedNamespaces(e) {
    e.forEach((t) => {
      this.usedNamespaces[t] || (this.usedNamespaces[t] = !0);
    });
  }
}
const Sh = (n, e) => {
  const t = Re();
  return ee(() => {
    t.current = e ? t.current : n;
  }, [n, e]), t.current;
}, Su = (n, e, t, s) => n.getFixedT(e, t, s), wh = (n, e, t, s) => He(Su(n, e, t, s), [n, e, t, s]), Ze = function(n) {
  let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    i18n: t
  } = e, {
    i18n: s,
    defaultNS: r
  } = ia(bh) || {}, a = t || s || yh();
  if (a && !a.reportNamespaces && (a.reportNamespaces = new xh()), !a) {
    Uo("You will need to pass in an i18next instance by using initReactI18next");
    const S = (E, k) => Zi(k) ? k : ch(k) && Zi(k.defaultValue) ? k.defaultValue : Array.isArray(E) ? E[E.length - 1] : E, x = [S, {}, !1];
    return x.t = S, x.i18n = {}, x.ready = !1, x;
  }
  a.options.react && a.options.react.wait !== void 0 && Uo("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
  const c = {
    ...mh(),
    ...a.options.react,
    ...e
  }, {
    useSuspense: l,
    keyPrefix: d
  } = c;
  let h = n || r || a.options && a.options.defaultNS;
  h = Zi(h) ? [h] : h || ["translation"], a.reportNamespaces.addUsedNamespaces && a.reportNamespaces.addUsedNamespaces(h);
  const m = (a.isInitialized || a.initializedStoreOnce) && h.every((S) => lh(S, a, c)), y = wh(a, e.lng || null, c.nsMode === "fallback" ? h : h[0], d), b = () => y, v = () => Su(a, e.lng || null, c.nsMode === "fallback" ? h : h[0], d), [w, o] = X(b);
  let u = h.join();
  e.lng && (u = `${e.lng}${u}`);
  const f = Sh(u), p = Re(!0);
  ee(() => {
    const {
      bindI18n: S,
      bindI18nStore: x
    } = c;
    p.current = !0, !m && !l && (e.lng ? cl(a, e.lng, h, () => {
      p.current && o(v);
    }) : ll(a, h, () => {
      p.current && o(v);
    })), m && f && f !== u && p.current && o(v);
    const E = () => {
      p.current && o(v);
    };
    return S && a && a.on(S, E), x && a && a.store.on(x, E), () => {
      p.current = !1, S && a && S.split(" ").forEach((k) => a.off(k, E)), x && a && x.split(" ").forEach((k) => a.store.off(k, E));
    };
  }, [a, u]), ee(() => {
    p.current && m && o(b);
  }, [a, d, m]);
  const g = [w, a, m];
  if (g.t = w, g.i18n = a, g.ready = m, m || !m && !l)
    return g;
  throw new Promise((S) => {
    e.lng ? cl(a, e.lng, h, () => S()) : ll(a, h, () => S());
  });
};
function Ah(n, e) {
  if (!(n instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function ss(n) {
  "@babel/helpers - typeof";
  return ss = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, ss(n);
}
function Ch(n, e) {
  if (ss(n) != "object" || !n)
    return n;
  var t = n[Symbol.toPrimitive];
  if (t !== void 0) {
    var s = t.call(n, e || "default");
    if (ss(s) != "object")
      return s;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(n);
}
function Eh(n) {
  var e = Ch(n, "string");
  return ss(e) == "symbol" ? e : e + "";
}
function ul(n, e) {
  for (var t = 0; t < e.length; t++) {
    var s = e[t];
    s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(n, Eh(s.key), s);
  }
}
function kh(n, e, t) {
  return e && ul(n.prototype, e), t && ul(n, t), Object.defineProperty(n, "prototype", {
    writable: !1
  }), n;
}
var wu = [], Oh = wu.forEach, Th = wu.slice;
function Ih(n) {
  return Oh.call(Th.call(arguments, 1), function(e) {
    if (e)
      for (var t in e)
        n[t] === void 0 && (n[t] = e[t]);
  }), n;
}
var dl = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/, Uh = function(e, t, s) {
  var r = s || {};
  r.path = r.path || "/";
  var a = encodeURIComponent(t), c = "".concat(e, "=").concat(a);
  if (r.maxAge > 0) {
    var l = r.maxAge - 0;
    if (Number.isNaN(l))
      throw new Error("maxAge should be a Number");
    c += "; Max-Age=".concat(Math.floor(l));
  }
  if (r.domain) {
    if (!dl.test(r.domain))
      throw new TypeError("option domain is invalid");
    c += "; Domain=".concat(r.domain);
  }
  if (r.path) {
    if (!dl.test(r.path))
      throw new TypeError("option path is invalid");
    c += "; Path=".concat(r.path);
  }
  if (r.expires) {
    if (typeof r.expires.toUTCString != "function")
      throw new TypeError("option expires is invalid");
    c += "; Expires=".concat(r.expires.toUTCString());
  }
  if (r.httpOnly && (c += "; HttpOnly"), r.secure && (c += "; Secure"), r.sameSite) {
    var d = typeof r.sameSite == "string" ? r.sameSite.toLowerCase() : r.sameSite;
    switch (d) {
      case !0:
        c += "; SameSite=Strict";
        break;
      case "lax":
        c += "; SameSite=Lax";
        break;
      case "strict":
        c += "; SameSite=Strict";
        break;
      case "none":
        c += "; SameSite=None";
        break;
      default:
        throw new TypeError("option sameSite is invalid");
    }
  }
  return c;
}, fl = {
  create: function(e, t, s, r) {
    var a = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      path: "/",
      sameSite: "strict"
    };
    s && (a.expires = /* @__PURE__ */ new Date(), a.expires.setTime(a.expires.getTime() + s * 60 * 1e3)), r && (a.domain = r), document.cookie = Uh(e, encodeURIComponent(t), a);
  },
  read: function(e) {
    for (var t = "".concat(e, "="), s = document.cookie.split(";"), r = 0; r < s.length; r++) {
      for (var a = s[r]; a.charAt(0) === " "; )
        a = a.substring(1, a.length);
      if (a.indexOf(t) === 0)
        return a.substring(t.length, a.length);
    }
    return null;
  },
  remove: function(e) {
    this.create(e, "", -1);
  }
}, zh = {
  name: "cookie",
  lookup: function(e) {
    var t;
    if (e.lookupCookie && typeof document < "u") {
      var s = fl.read(e.lookupCookie);
      s && (t = s);
    }
    return t;
  },
  cacheUserLanguage: function(e, t) {
    t.lookupCookie && typeof document < "u" && fl.create(t.lookupCookie, e, t.cookieMinutes, t.cookieDomain, t.cookieOptions);
  }
}, Rh = {
  name: "querystring",
  lookup: function(e) {
    var t;
    if (typeof window < "u") {
      var s = window.location.search;
      !window.location.search && window.location.hash && window.location.hash.indexOf("?") > -1 && (s = window.location.hash.substring(window.location.hash.indexOf("?")));
      for (var r = s.substring(1), a = r.split("&"), c = 0; c < a.length; c++) {
        var l = a[c].indexOf("=");
        if (l > 0) {
          var d = a[c].substring(0, l);
          d === e.lookupQuerystring && (t = a[c].substring(l + 1));
        }
      }
    }
    return t;
  }
}, Pn = null, hl = function() {
  if (Pn !== null)
    return Pn;
  try {
    Pn = window !== "undefined" && window.localStorage !== null;
    var e = "i18next.translate.boo";
    window.localStorage.setItem(e, "foo"), window.localStorage.removeItem(e);
  } catch {
    Pn = !1;
  }
  return Pn;
}, Ph = {
  name: "localStorage",
  lookup: function(e) {
    var t;
    if (e.lookupLocalStorage && hl()) {
      var s = window.localStorage.getItem(e.lookupLocalStorage);
      s && (t = s);
    }
    return t;
  },
  cacheUserLanguage: function(e, t) {
    t.lookupLocalStorage && hl() && window.localStorage.setItem(t.lookupLocalStorage, e);
  }
}, Mn = null, pl = function() {
  if (Mn !== null)
    return Mn;
  try {
    Mn = window !== "undefined" && window.sessionStorage !== null;
    var e = "i18next.translate.boo";
    window.sessionStorage.setItem(e, "foo"), window.sessionStorage.removeItem(e);
  } catch {
    Mn = !1;
  }
  return Mn;
}, Mh = {
  name: "sessionStorage",
  lookup: function(e) {
    var t;
    if (e.lookupSessionStorage && pl()) {
      var s = window.sessionStorage.getItem(e.lookupSessionStorage);
      s && (t = s);
    }
    return t;
  },
  cacheUserLanguage: function(e, t) {
    t.lookupSessionStorage && pl() && window.sessionStorage.setItem(t.lookupSessionStorage, e);
  }
}, jh = {
  name: "navigator",
  lookup: function(e) {
    var t = [];
    if (typeof navigator < "u") {
      if (navigator.languages)
        for (var s = 0; s < navigator.languages.length; s++)
          t.push(navigator.languages[s]);
      navigator.userLanguage && t.push(navigator.userLanguage), navigator.language && t.push(navigator.language);
    }
    return t.length > 0 ? t : void 0;
  }
}, Lh = {
  name: "htmlTag",
  lookup: function(e) {
    var t, s = e.htmlTag || (typeof document < "u" ? document.documentElement : null);
    return s && typeof s.getAttribute == "function" && (t = s.getAttribute("lang")), t;
  }
}, Dh = {
  name: "path",
  lookup: function(e) {
    var t;
    if (typeof window < "u") {
      var s = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
      if (s instanceof Array)
        if (typeof e.lookupFromPathIndex == "number") {
          if (typeof s[e.lookupFromPathIndex] != "string")
            return;
          t = s[e.lookupFromPathIndex].replace("/", "");
        } else
          t = s[0].replace("/", "");
    }
    return t;
  }
}, Nh = {
  name: "subdomain",
  lookup: function(e) {
    var t = typeof e.lookupFromSubdomainIndex == "number" ? e.lookupFromSubdomainIndex + 1 : 1, s = typeof window < "u" && window.location && window.location.hostname && window.location.hostname.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i);
    if (s)
      return s[t];
  }
};
function Fh() {
  return {
    order: ["querystring", "cookie", "localStorage", "sessionStorage", "navigator", "htmlTag"],
    lookupQuerystring: "lng",
    lookupCookie: "i18next",
    lookupLocalStorage: "i18nextLng",
    lookupSessionStorage: "i18nextLng",
    // cache user language
    caches: ["localStorage"],
    excludeCacheFor: ["cimode"],
    // cookieMinutes: 10,
    // cookieDomain: 'myDomain'
    convertDetectedLanguage: function(e) {
      return e;
    }
  };
}
var Au = /* @__PURE__ */ function() {
  function n(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    Ah(this, n), this.type = "languageDetector", this.detectors = {}, this.init(e, t);
  }
  return kh(n, [{
    key: "init",
    value: function(t) {
      var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      this.services = t || {
        languageUtils: {}
      }, this.options = Ih(s, this.options || {}, Fh()), typeof this.options.convertDetectedLanguage == "string" && this.options.convertDetectedLanguage.indexOf("15897") > -1 && (this.options.convertDetectedLanguage = function(a) {
        return a.replace("-", "_");
      }), this.options.lookupFromUrlIndex && (this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex), this.i18nOptions = r, this.addDetector(zh), this.addDetector(Rh), this.addDetector(Ph), this.addDetector(Mh), this.addDetector(jh), this.addDetector(Lh), this.addDetector(Dh), this.addDetector(Nh);
    }
  }, {
    key: "addDetector",
    value: function(t) {
      return this.detectors[t.name] = t, this;
    }
  }, {
    key: "detect",
    value: function(t) {
      var s = this;
      t || (t = this.options.order);
      var r = [];
      return t.forEach(function(a) {
        if (s.detectors[a]) {
          var c = s.detectors[a].lookup(s.options);
          c && typeof c == "string" && (c = [c]), c && (r = r.concat(c));
        }
      }), r = r.map(function(a) {
        return s.options.convertDetectedLanguage(a);
      }), this.services.languageUtils.getBestMatchFromCodes ? r : r.length > 0 ? r[0] : null;
    }
  }, {
    key: "cacheUserLanguage",
    value: function(t, s) {
      var r = this;
      s || (s = this.options.caches), s && (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(t) > -1 || s.forEach(function(a) {
        r.detectors[a] && r.detectors[a].cacheUserLanguage(t, r.options);
      }));
    }
  }]), n;
}();
Au.type = "languageDetector";
const Bh = "voltar", qh = "Carregando", Hh = "Campo obrigatório", Vh = "Preencha esse campo", Gh = "Mostrar senha", Wh = "Esconder senha", Kh = "Nome não pode conter caracteres especiais", Yh = "Nome inválido", Jh = "E-mail inválido", Zh = "Telefone inválido", Qh = "Data inválida", Xh = "URL inválida", _h = "<strong>Todo mundo comete erros <span style='font-size: 1.5rem; vertical-align: middle'>☹</span></strong><br />Desta vez foram nossos servidores, mas já estamos corrigindo! Tente novamente mais tarde.", $h = "Arquivo(s) selecionado(s)", ep = "Arquivo muito grande", tp = "Tamanho recomendado: {{width}}px por {{height}}px", ip = "Adicionar Mídia", np = {
  password: {
    lessThanEight: "Mínimo de 8 caracteres",
    noNumber: "Mínimo de 1 número",
    noUppercase: "Letra maiúscula",
    noLowercase: "Letra minúscula"
  },
  multiSelect: {
    maxOptionsSelected_one: "No máximo {{ count }} opção",
    maxOptionsSelected_other: "No máximo {{ count }} opções",
    qtdTags_one: "{{ count }} opção selecionada",
    qtdTags_other: "{{ count }} opções selecionadas"
  }
}, sp = "Buscar", rp = "Preencha com o estado", op = "Não há mais dados disponíveis", ap = "há {{ value }} anos", lp = "há {{ value }} ano", cp = "há {{ value }} meses", up = "há {{ value }} mês", dp = "há {{ value }} dias", fp = "há {{ value }} dia", hp = "há {{ value }} horas", pp = "há {{ value }} hora", mp = "Hoje", gp = "Data não pode ser maior que {{ maxDate }}", yp = {
  default: "<p class='text-bold'>Todo mundo erra. Desta vez foram nossos servidores, mas já estamos dando um jeito! Tente novamente mais tarde.</p>",
  login: {
    contract_refused: "<span class='text-medium'><h5 class='mb-1 text-black display-block'>Contrato não aceito <span style='font-size: 1.5rem; vertical-align: middle'>☹</span></h5>Aceite o contrato para poder acessar a plataforma!</span>",
    mail_verified: "<span class='text-medium'><h5 class='mb-1 text-black display-block'>E-mail não confirmado</h5> Você ainda não confirmou seu endereço de e-mail, acesse sua caixa de entrada e clique em 'Verificar e-mail'! Se ainda não recebeu a mensagem de confirmação, <a>CLIQUE AQUI</a></span>",
    unregistered_user: "<span class='text-medium'><h5 class='mb-1 text-black display-block'>Usuário não encontrado <span style='font-size: 1.5rem; vertical-align: middle'>☹</span></h5> Você digitou um e-mail que não foi encontrado na nossa plataforma. Se ainda não tem cadastro, <a>Clique aqui</a> para realizar o cadastro.</span>",
    unregistered_user_mq: "<span class='text-medium'><h5 class='mb-1 text-black display-block'>Usuário não encontrado nesta plataforma <span style='font-size: 1.5rem; vertical-align: middle'>☹</span></h5> Você digitou um e-mail que não está vinculado a esta plataforma. Se ainda não tem cadastro, <a>Clique aqui</a> para realizar o cadastro.</span>",
    too_many_attempts: "<span class='text-medium'><h5 class='mb-1 text-black display-block'>Detectamos atividade suspeita!</h5> Esta conta está bloqueada devido ao numero de tentativas. Tente novamente mais tarde.</span>",
    access_denied: "<span class='text-medium'><h5 class='mb-1 text-black display-block'>Senha inválida <span style='font-size: 1.5rem; vertical-align: middle'>☹</span></h5> Você digitou a senha incorreta, tente novamente ou em 'Esqueci minha senha' para redefinir a sua senha.</span>",
    unexpected: "<span class='text-medium'><h5 class='mb-1 text-black display-block'>Todo mundo erra <span style='font-size: 1.5rem; vertical-align: middle'>☹</span></h5>Desta vez foram nossos servidores, mas já estamos dando um jeito! Tente novamente mais tarde.</span>",
    unauthorized: "<span class='text-medium'><h5 class='mb-1 text-black display-block'>Usuário não autorizado</h5>Seu usuário não está autorizado a logar na plataforma, contate o suporte.</span>",
    not_allowed: "<span class='text-medium'><h5 class='mb-1 text-black display-block'>Usuário não autorizado</h5>Você não tem permissão para acessar a plataforma.</span>",
    resendEmail: "<span class='text-medium'><h5 class='mb-1 text-black display-block'>E-mail de confirmação enviado!</h5>Agora acesse a caixa de entrada do seu e-mail e clique em 'Verificar E-mail' para poder navegar em nosso portal!</span>"
  },
  payments: {
    bankDocumentNotEqual: "Os documentos CPF do titular deve ser igual ao do cadastro.",
    bankSaveError: "Ocorreu um problema ao salvar seus dados. Tente novamente mais tarde!",
    blockedFields: "Temporariamente esses dados não podem ser editados."
  }
}, vp = {
  back: Bh,
  loading: qh,
  required: Hh,
  emptyField: Vh,
  showPassword: Gh,
  hidenPassword: Wh,
  nameSpecialChars: Kh,
  invalidName: Yh,
  invalidEmail: Jh,
  invalidPhone: Zh,
  invalidDate: Qh,
  invalidUrl: Xh,
  unexpected: _h,
  selectedFiles: $h,
  fileSize: ep,
  resolution: tp,
  mediaLabel: ip,
  fields: np,
  search: sp,
  placeholderState: rp,
  endScroll: op,
  year_other: ap,
  year_one: lp,
  month_other: cp,
  month_one: up,
  day_other: dp,
  day_one: fp,
  hour_other: hp,
  hour_one: pp,
  today: mp,
  biggerThanMaxDate: gp,
  errors: yp
}, bp = "back", xp = "Loading", Sp = "Required field", wp = "Fill this field", Ap = "Show password", Cp = "Hide password", Ep = "Name cannot contain special characters", kp = "Invalid name", Op = "Invalid Email", Tp = "Invalid Phone", Ip = "Invalid Date", Up = "Invalid URL", zp = "<strong>Everyone makes mistakes <span style='font-size: 1.5rem; vertical-align: middle'>☹</span></strong><br />This time it was our servers, but we're already fixing it! Try again later.", Rp = "Selected Files", Pp = "File too large", Mp = "Recommended size: {{width}}px by {{height}}px", jp = "Add Media", Lp = {
  password: {
    isEmpty: "Required field",
    lessThanEight: "Minimum 8 characters",
    noNumber: "Minimum 1 number",
    noUppercase: "Uppercase",
    noLowercase: "Lowercase"
  },
  multiSelect: {
    maxOptionsSelected_one: "Maximum {{ count }} option",
    maxOptionsSelected_other: "Maximum {{ count }} options",
    qtdTags_one: "{{ count }} selected option",
    qtdTags_other: "{{ count }} selected options"
  }
}, Dp = "Search", Np = "Fill in with state", Fp = "No more data available", Bp = "{{ value }} years ago", qp = "{{ value }} year ago", Hp = "{{ value }} months ago", Vp = "{{ value }} month ago", Gp = "{{ value }} days ago", Wp = "{{ value }} day ago", Kp = "{{ value }} hours ago", Yp = "{{ value }} hour ago", Jp = "Today", Zp = "Date cannot be greater than {{ maxDate }}", Qp = {
  default: "<span class='text-medium'><h5 class='mb-1 text-black display-block'>Everybody gets it wrong <span style='font-size: 1.5rem; vertical-align: middle'>☹</span></h5>This time it was our servers, but we're already fixing it! Please try again later.</span>",
  login: {
    contract_refused: "<span class='text-medium'><h5 class='mb-1 text-black display-block'>Contract not accepted <span style='font-size: 1.5rem; vertical-align: middle'>☹</span></h5>Accept the contract to access the platform !</span>",
    mail_verified: "<span class='text-medium'><h5 class='mb-1 text-black display-block'>Unverified email</h5> You have not yet confirmed your email address , go to your inbox and click 'Verify email'! If you have not yet received the confirmation message, <a>CLICK HERE</a></span>",
    unregistered_user: "<span class='text-medium'><h5 class='mb-1 text-black display-block'>User not found <span style='font-size: 1.5rem; vertical-align: middle'>☹</span></h5> You entered an email that could not be found on our platform. If you have not yet registered, <a>Click here</a> to register.</span>",
    unregistered_user_mq: "<span class='text-medium'><h5 class='mb-1 text-black display-block'>User not found on this platform <span style='font-size: 1.5rem; vertical-align: middle'>☹</span></h5> You entered an email that is not is linked to this platform. If you have not yet registered, <a>Click here</a> to register.</span>",
    too_many_attempts: "<span class='text-medium'><h5 class='mb-1 text-black display-block'>We detected suspicious activity!</h5> This account is blocked due to the number of attempts. Try it again later.</span>",
    access_denied: "<span class='text-medium'><h5 class='mb-1 text-black display-block'>Invalid password <span style='font-size: 1.5rem; vertical-align: middle'>☹</span></h5> You entered the wrong password, please try again or in ' I forgot my password' to reset your password.</span>",
    unexpected: "<span class='text-medium'><h5 class='mb-1 text-black display-block'>Everyone makes mistakes <span style='font-size: 1.5rem; vertical-align: middle'>☹</span></h5>This time it was our servers, but we are already giving a way! Please try again later.</span>",
    unauthorized: "<span class='text-medium'><h5 class='mb-1 text-black display-block'>Unauthorized User</h5>Your user is not authorized to login to the platform, contact the support.</span>",
    not_allowed: "<span class='text-medium'><h5 class='mb-1 text-black display-block'>Unauthorized User</h5>You do not have permission to access the platform.</span>",
    resendEmail: "<span class='text-medium'><h5 class='mb-1 text-black display-block'>Confirmation email sent!</h5>Now access your e-mail and click on 'Verify E-mail' to be able to browse our portal!</span>"
  },
  payments: {
    bankDocumentNotEqual: "The documents must be the same as the registration.",
    bankSaveError: "There was a problem saving your data. Try again later",
    blockedFields: "Temporarily this data cannot be edited."
  }
}, Xp = {
  back: bp,
  loading: xp,
  required: Sp,
  emptyField: wp,
  showPassword: Ap,
  hidenPassword: Cp,
  nameSpecialChars: Ep,
  invalidName: kp,
  invalidEmail: Op,
  invalidPhone: Tp,
  invalidDate: Ip,
  invalidUrl: Up,
  unexpected: zp,
  selectedFiles: Rp,
  fileSize: Pp,
  resolution: Mp,
  mediaLabel: jp,
  fields: Lp,
  search: Dp,
  placeholderState: Np,
  endScroll: Fp,
  year_other: Bp,
  year_one: qp,
  month_other: Hp,
  month_one: Vp,
  day_other: Gp,
  day_one: Wp,
  hour_other: Kp,
  hour_one: Yp,
  today: Jp,
  biggerThanMaxDate: Zp,
  errors: Qp
}, _p = "devolver", $p = "Cargando", em = "Campo requerido", tm = "Rellena este campo", im = "Mostrar contraseña", nm = "Ocultar contraseña", sm = "El nombre no puede contener caracteres especiales", rm = "Nombre inválido", om = "Correo electrónico no válido", am = "Teléfono inválido", lm = "Fecha Invalida", cm = "URL no válida", um = "<strong>Todo el mundo comete errores <span style='font-size: 1.5rem; vertical-align: middle'>☹</span></strong><br />Esta vez fueron nuestros servidores, ¡pero ya lo estamos arreglando! Vuelve a intentarlo más tarde.", dm = "Archivos seleccionados", fm = "Archivo demasiado grande", hm = "Tamaño recomendado: {{width}}px por {{height}}px", pm = "Agregar medios", mm = {
  password: {
    isEmpty: "Campo obligatorio",
    lessThanEight: "Mínimo 8 caracteres",
    noNumber: "Mínimo 1 número",
    noUppercase: "Mayúsculas",
    noLowercase: "En minúsculas"
  },
  multiSelect: {
    maxOptionsSelected_one: "Opción {{ count }} máxima",
    maxOptionsSelected_other: "{{ count }} opciones máximas",
    qtdTags_one: "{{ count }} opción seleccionada",
    qtdTags_other: "{{ count }} opciones seleccionadas"
  }
}, gm = "Búsqueda", ym = "Rellenar con el estado", vm = "No hay más datos disponibles", bm = "hace {{ value }} años", xm = "hace {{ value }} años", Sm = "hace {{ value }} meses", wm = "hace {{ value }} meses", Am = "hace {{ value }} días", Cm = "hace {{ value }} días", Em = "hace {{ value }} horas", km = "hace {{ value }} horas", Om = "Este Dia", Tm = "La fecha no puede ser mayor que {{ maxDate }}", Im = {
  default: "<span class='text-medium'><h5 class='mb-1 text-black display-block'>Todos cometemos errores <span style='font-size: 1.5rem; vertical-align: middle'>☹</span></h5>Esta vez fueron nuestros servidores, pero nosotros ya está dando un paso! Vuelva a intentarlo más tarde.</span>",
  login: {
    contract_refused: "<span class='text-medium'><h5 class='mb-1 text-black display-block'>Contrato no aceptado <span style='font-size: 1.5rem; vertical-align: middle'>☹</span></h5>¡Acepta el contrato para acceder a la plataforma!</span>",
    mail_verified: "<span class='text-medium'><h5 class='mb-1 text-black display-block'>Correo electrónico no verificado</h5> Aún no ha confirmado su dirección de correo electrónico, vaya a su bandeja de entrada y haga clic en 'Verificar correo electrónico'. Si aún no ha recibido el mensaje de confirmación, <a>HAGA CLIC AQUÍ</a></span>",
    unregistered_user: "<span class='text-medium'><h5 class='mb-1 text-black display-block'>Usuario no encontrado <span style='font-size: 1.5rem; vertical-align: middle'>☹</span></h5> Ingresó un correo electrónico que no se pudo encontrar en nuestra plataforma. Si aún no se ha registrado, <a>Haga clic aquí</a> para registrarse.</span>",
    unregistered_user_mq: "<span class='text-medium'><h5 class='mb-1 text-black display-block'>Usuario no encontrado en esta plataforma <span style='font-size: 1.5rem; vertical-align: middle'>☹</span></h5> Ingresó un correo electrónico que no es está vinculado a esta plataforma. Si aún no se ha registrado, <a>Haga clic aquí</a> para registrarse.</span>",
    too_many_attempts: "<span class='text-medium'><h5 class='mb-1 text-black display-block'>¡Detectamos actividad sospechosa!</h5> Esta cuenta está bloqueada debido a la cantidad de intentos . Vuelve a intentarlo más tarde.</span>",
    access_denied: "<span class='text-medium'><h5 class='mb-1 text-black display-block'>Contraseña no válida <span style='font-size: 1.5rem; vertical-align: middle'>☹</span></h5> Ingresó una contraseña incorrecta, intente nuevamente o en 'Olvidé mi contraseña' para restablecer tu contraseña.</span>",
    unexpected: "<span class='text-medium'><h5 class='mb-1 text-black display-block'>Todos cometemos errores <span style='font-size: 1.5rem; vertical-align: middle'>☹</span></h5>Esta vez fueron nuestros servidores, pero nosotros ya está dando un paso! Vuelva a intentarlo más tarde.</span>",
    unauthorized: "<span class='text-medium'><h5 class='mb-1 text-black display-block'>Usuario no autorizado</h5>Su usuario no está autorizado para iniciar sesión en la plataforma, comuníquese con el apoyo.</span>",
    not_allowed: "<span class='text-medium'><h5 class='mb-1 text-black display-block'>Usuario no autorizado</h5>No tienes permiso para acceder a la plataforma.</span>",
    resendEmail: "<span class='text-medium'><h5 class='mb-1 text-black display-block'>¡Correo electrónico de confirmación enviado!</h5>Ahora acceda a su correo electrónico y haga clic en 'Verificar E-mail' para poder navegar por nuestro portal!</span>"
  },
  payments: {
    bankDocumentNotEqual: "Los documentos deben ser los mismos que el registro.",
    bankSaveError: "Hubo un problema al guardar tus datos. Vuelve a intentarlo más tarde!",
    blockedFields: "Temporalmente estos datos no se pueden editar."
  }
}, Um = {
  back: _p,
  loading: $p,
  required: em,
  emptyField: tm,
  showPassword: im,
  hidenPassword: nm,
  nameSpecialChars: sm,
  invalidName: rm,
  invalidEmail: om,
  invalidPhone: am,
  invalidDate: lm,
  invalidUrl: cm,
  unexpected: um,
  selectedFiles: dm,
  fileSize: fm,
  resolution: hm,
  mediaLabel: pm,
  fields: mm,
  search: gm,
  placeholderState: ym,
  endScroll: vm,
  year_other: bm,
  year_one: xm,
  month_other: Sm,
  month_one: wm,
  day_other: Am,
  day_one: Cm,
  hour_other: Em,
  hour_one: km,
  today: Om,
  biggerThanMaxDate: Tm,
  errors: Im
}, zm = "Média - ", Rm = "O <strong>influencer #1 com mais {{type}} atingiu {{firstValue}}.</strong> Você ficou <strong>{{positionFirst}} {{userPercentageDiff}} </strong> de {{type}} dessa campanha e na posição #{{userPosition}}.", Pm = "acima da média", Mm = "abaixo da média", jm = {
  impressions: "impressões",
  reach: "alcance",
  effectiveReach: "alcance efetivo",
  engagementRate: "taxa de engajamento",
  engagement: "engajamento",
  totalClicks: "cliques",
  uniqueClicks: "cliques",
  ctr: "ctr",
  convertions_count: "conversões",
  convertions_value: "conversões"
}, Lm = {
  average: zm,
  description: Rm,
  aboveAverage: Pm,
  belowAverage: Mm,
  metrics: jm
}, Dm = "Average - ", Nm = "The <strong>influencer #1 with the most {{type}} reached {{firstValue}}.</strong> You got <strong>{{positionFirst}} {{userPercentageDiff}} </strong> of {{type}} campaign and at position #{{userPosition}}.", Fm = "above average", Bm = "below average", qm = {
  impressions: "impressions",
  reach: "reach",
  effectiveReach: "effective reach",
  engagementRate: "engagement rate",
  engagement: "engagement",
  totalClicks: "clicks",
  uniqueClicks: "clicks",
  ctr: "ctr",
  convertions_count: "convertions",
  convertions_value: "convertions"
}, Hm = {
  average: Dm,
  description: Nm,
  aboveAverage: Fm,
  belowAverage: Bm,
  metrics: qm
}, Vm = "Promedio - ", Gm = "El <strong>influencer #1 con la mayor cantidad de {{type}} llegó a {{firstValue}}.</strong> Obtuviste <strong>{{positionFirst}} {{userPercentageDiff}} </strong> de {{type}} campaña y en la posición #{{userPosition}}.", Wm = "por encima del promedio", Km = "por debajo del promedio", Ym = {
  impressions: "impresiones",
  reach: "alcance",
  effectiveReach: "alcance efectivo",
  engagementRate: "tasa de participación",
  engagement: "compromiso",
  totalClicks: "clics",
  uniqueClicks: "clics",
  ctr: "ctr",
  convertions_count: "conversiones",
  convertions_value: "conversiones"
}, Jm = {
  average: Vm,
  description: Gm,
  aboveAverage: Wm,
  belowAverage: Km,
  metrics: Ym
}, Zm = "Link copiado!", Qm = "Copiar Link", Xm = "O link foi copiado", _m = {
  messageCopySuccess: Zm,
  messageToCopy: Qm,
  urlCopied: Xm
}, $m = "Link copied!", eg = "Copy link", tg = "The link was copied", ig = {
  messageCopySuccess: $m,
  messageToCopy: eg,
  urlCopied: tg
}, ng = "¡Enlace copiado!", sg = "Copiar enlace", rg = "El enlace fue copiado", og = {
  messageCopySuccess: ng,
  messageToCopy: sg,
  urlCopied: rg
}, ag = "Data de Nascimento", lg = "É preciso ter 18 anos ou mais", cg = "Idade máxima permitida é de 100 anos", ug = {
  label: ag,
  ageUnder18: lg,
  overThan100: cg
}, dg = "Date of Birth", fg = "Must be 18 or older", hg = "Maximum age allowed is 100 years old", pg = {
  label: dg,
  ageUnder18: fg,
  overThan100: hg
}, mg = "Fecha de Nacimiento", gg = "Debe tener 18 años o más", yg = "La edad máxima permitida es de 100 años", vg = {
  label: mg,
  ageUnder18: gg,
  overThan100: yg
}, bg = "Campo obrigatório", xg = {
  required: bg,
  "invalid-number": "Número inválido"
}, Sg = "Required field", wg = {
  required: Sg,
  "invalid-number": "Invalid number"
}, Ag = "Campo requerido", Cg = {
  required: Ag,
  "invalid-number": "Número invalido"
}, Eg = "Campo obrigatório", kg = "Preencha esse campo", Og = "CNPJ inválido", Tg = {
  required: Eg,
  emptyField: kg,
  invalidCnpj: Og
}, Ig = "Required field", Ug = "Fill this field", zg = "Invalid CNPJ", Rg = {
  required: Ig,
  emptyField: Ug,
  invalidCnpj: zg
}, Pg = "Campo requerido", Mg = "Rellena este campo", jg = "CNPJ inválido", Lg = {
  required: Pg,
  emptyField: Mg,
  invalidCnpj: jg
}, Dg = "Campo obrigatório", Ng = "CPF inválido", Fg = "RUT inválido", Bg = "Preencha esse campo", qg = "Ops! Esse CPF já está sendo utilizado com outro email. Por favor entre em contato com o suporte clicando <a href='{{url}}' target='_blank' rel='noopener noreferrer'>aqui</a>", Hg = "Ops! Esse RUT já está sendo utilizado com outro email. Por favor entre em contato com o suporte clicando <a href='{{url}}' target='_blank' rel='noopener noreferrer'>aqui</a>", Vg = "Ops! Esse ID já está sendo utilizado com outro email. Por favor entre em contato com o suporte clicando <a href='{{url}}' target='_blank' rel='noopener noreferrer'>aqui</a>", Gg = "Documento não autorizado para cadastro!", Wg = {
  required: Dg,
  invalidCPF: Ng,
  invalidRUT: Fg,
  emptyField: Bg,
  repeatCPF: qg,
  repeatRUT: Hg,
  repeatID: Vg,
  unauthorized: Gg
}, Kg = "Required field", Yg = "Invalid CPF", Jg = "Invalid RUT", Zg = "Fill this field", Qg = "Oops! This CPF is already being used with another email. Please contact support by clicking <a href='{{url}}' target='_blank' rel='noopener noreferrer'>here</a>", Xg = "Oops! This RUT is already being used with another email. Please contact support by clicking <a href='{{url}}' target='_blank' rel='noopener noreferrer'>here</a>", _g = "Oops! This ID is already being used with another email. Please contact support by clicking <a href='{{url}}' target='_blank' rel='noopener noreferrer'>here</a>", $g = "Document not authorized for registration!", ey = {
  required: Kg,
  invalidCPF: Yg,
  invalidRUT: Jg,
  emptyField: Zg,
  repeatCPF: Qg,
  repeatRUT: Xg,
  repeatID: _g,
  unauthorized: $g
}, ty = "Campo requerido", iy = "CPF inválido", ny = "RUT inválido", sy = "Rellena este campo", ry = "¡UPS! Este CPF ya se está utilizando con otro correo electrónico. Póngase en contacto con el servicio de asistencia haciendo clic <a href='{{url}}' target='_blank' rel='noopener noreferrer'> aquí </a>", oy = "¡UPS! Este RUT ya se está utilizando con otro correo electrónico. Póngase en contacto con el servicio de asistencia haciendo clic <a href='{{url}}' target='_blank' rel='noopener noreferrer'> aquí </a>", ay = "¡UPS! Este documento ya se está utilizando con otro correo electrónico. Póngase en contacto con el servicio de asistencia haciendo clic <a href='{{url}}' target='_blank' rel='noopener noreferrer'> aquí </a>", ly = "¡Documento no autorizado para registro!", cy = {
  required: ty,
  invalidCPF: iy,
  invalidRUT: ny,
  emptyField: sy,
  repeatCPF: ry,
  repeatRUT: oy,
  repeatID: ay,
  unauthorized: ly
}, uy = "Campo obrigatório", dy = "CPF inválido", fy = "RUT inválido", hy = "Documento inválido", py = "Preencha esse campo", my = "Ops! Esse CPF já está sendo utilizado com outro email. Por favor entre em contato com o suporte clicando <a href='{{url}}' target='_blank' rel='noopener noreferrer'>aqui</a>", gy = "Ops! Esse RUT já está sendo utilizado com outro email. Por favor entre em contato com o suporte clicando <a href='{{url}}' target='_blank' rel='noopener noreferrer'>aqui</a>", yy = "Ops! Esse ID já está sendo utilizado com outro email. Por favor entre em contato com o suporte clicando <a href='{{url}}' target='_blank' rel='noopener noreferrer'>aqui</a>", vy = "Documento não autorizado para cadastro!", by = {
  required: uy,
  invalidCPF: dy,
  invalidRUT: fy,
  invalidID: hy,
  emptyField: py,
  repeatCPF: my,
  repeatRUT: gy,
  repeatID: yy,
  unauthorized: vy
}, xy = "Required field", Sy = "Invalid CPF", wy = "Invalid RUT", Ay = "Invalid ID", Cy = "Fill this field", Ey = "Oops! This CPF is already being used with another email. Please contact support by clicking <a href='{{url}}' target='_blank' rel='noopener noreferrer'>here</a>", ky = "Oops! This RUT is already being used with another email. Please contact support by clicking <a href='{{url}}' target='_blank' rel='noopener noreferrer'>here</a>", Oy = "Oops! This ID is already being used with another email. Please contact support by clicking <a href='{{url}}' target='_blank' rel='noopener noreferrer'>here</a>", Ty = "Document not authorized for registration!", Iy = {
  required: xy,
  invalidCPF: Sy,
  invalidRUT: wy,
  invalidID: Ay,
  emptyField: Cy,
  repeatCPF: Ey,
  repeatRUT: ky,
  repeatID: Oy,
  unauthorized: Ty
}, Uy = "Campo requerido", zy = "CPF inválido", Ry = "RUT inválido", Py = "Documento inválido", My = "Rellena este campo", jy = "¡UPS! Este CPF ya se está utilizando con otro correo electrónico. Póngase en contacto con el servicio de asistencia haciendo clic <a href='{{url}}' target='_blank' rel='noopener noreferrer'> aquí </a>", Ly = "¡UPS! Este RUT ya se está utilizando con otro correo electrónico. Póngase en contacto con el servicio de asistencia haciendo clic <a href='{{url}}' target='_blank' rel='noopener noreferrer'> aquí </a>", Dy = "¡UPS! Este documento ya se está utilizando con otro correo electrónico. Póngase en contacto con el servicio de asistencia haciendo clic <a href='{{url}}' target='_blank' rel='noopener noreferrer'> aquí </a>", Ny = "¡Documento no autorizado para registro!", Fy = {
  required: Uy,
  invalidCPF: zy,
  invalidRUT: Ry,
  invalidID: Py,
  emptyField: My,
  repeatCPF: jy,
  repeatRUT: Ly,
  repeatID: Dy,
  unauthorized: Ny
}, By = "Campo obrigatório", qy = "CPF inválido", Hy = "RUT inválido", Vy = "Preencha esse campo", Gy = "Ops! Esse CPF já está sendo utilizado com outro email. Por favor entre em contato com o suporte clicando <a href='{{url}}' target='_blank' rel='noopener noreferrer'>aqui</a>", Wy = "Ops! Esse RUT já está sendo utilizado com outro email. Por favor entre em contato com o suporte clicando <a href='{{url}}' target='_blank' rel='noopener noreferrer'>aqui</a>", Ky = "Ops! Esse ID já está sendo utilizado com outro email. Por favor entre em contato com o suporte clicando <a href='{{url}}' target='_blank' rel='noopener noreferrer'>aqui</a>", Yy = "Documento não autorizado para cadastro!", Jy = {
  required: By,
  invalidCPF: qy,
  invalidRUT: Hy,
  emptyField: Vy,
  repeatCPF: Gy,
  repeatRUT: Wy,
  repeatID: Ky,
  unauthorized: Yy
}, Zy = "Required field", Qy = "Invalid CPF", Xy = "Invalid RUT", _y = "Fill this field", $y = "Oops! This CPF is already being used with another email. Please contact support by clicking <a href='{{url}}' target='_blank' rel='noopener noreferrer'>here</a>", ev = "Oops! This RUT is already being used with another email. Please contact support by clicking <a href='{{url}}' target='_blank' rel='noopener noreferrer'>here</a>", tv = "Oops! This ID is already being used with another email. Please contact support by clicking <a href='{{url}}' target='_blank' rel='noopener noreferrer'>here</a>", iv = "Document not authorized for registration!", nv = {
  required: Zy,
  invalidCPF: Qy,
  invalidRUT: Xy,
  emptyField: _y,
  repeatCPF: $y,
  repeatRUT: ev,
  repeatID: tv,
  unauthorized: iv
}, sv = "Campo requerido", rv = "CPF inválido", ov = "RUT inválido", av = "Rellena este campo", lv = "¡UPS! Este CPF ya se está utilizando con otro correo electrónico. Póngase en contacto con el servicio de asistencia haciendo clic <a href='{{url}}' target='_blank' rel='noopener noreferrer'> aquí </a>", cv = "¡UPS! Este RUT ya se está utilizando con otro correo electrónico. Póngase en contacto con el servicio de asistencia haciendo clic <a href='{{url}}' target='_blank' rel='noopener noreferrer'> aquí </a>", uv = "¡UPS! Este documento ya se está utilizando con otro correo electrónico. Póngase en contacto con el servicio de asistencia haciendo clic <a href='{{url}}' target='_blank' rel='noopener noreferrer'> aquí </a>", dv = "¡Documento no autorizado para registro!", fv = {
  required: sv,
  invalidCPF: rv,
  invalidRUT: ov,
  emptyField: av,
  repeatCPF: lv,
  repeatRUT: cv,
  repeatID: uv,
  unauthorized: dv
}, hv = "Campo obrigatório", pv = "Nome não pode conter caracteres especiais", mv = "Digite seu nome completo", gv = {
  required: hv,
  nameSpecialChars: pv,
  fullNameRequired: mv
}, yv = "Required field", vv = "Name cannot contain special characters", bv = "Enter your full name", xv = {
  required: yv,
  nameSpecialChars: vv,
  fullNameRequired: bv
}, Sv = "Campo requerido", wv = "El nombre no puede contener caracteres especiales", Av = "Ingresa tu nombre completo", Cv = {
  required: Sv,
  nameSpecialChars: wv,
  fullNameRequired: Av
}, Ev = "Próximo", kv = {
  title: "Bem vindo ao Creators Insights",
  description: "Explore métricas relevantes e visões detalhadas para melhorar e expandir sua presença."
}, Ov = {
  title: "Inteligência a seu Favor",
  description: "Encontre insights personalizadas com base nos dados dos seus posts para aumentar seu engajamento."
}, Tv = {
  title: "Veja Seus Melhores Resultados",
  description: "Identifique os posts de maior impacto e acompanhe suas métricas"
}, Iv = {
  next: Ev,
  firstPage: kv,
  secondPage: Ov,
  thirdPage: Tv
}, Uv = "Next", zv = {
  title: "Welcome to Creators Insights",
  description: "Explore relevant metrics and detailed insights to improve and grow your presence."
}, Rv = {
  title: "Intelligence on Your Side",
  description: "Find personalized insights based on your post data to increase your engagement."
}, Pv = {
  title: "See Your Top Results",
  description: "Identify the most impactful posts and track their metrics"
}, Mv = {
  next: Uv,
  firstPage: zv,
  secondPage: Rv,
  thirdPage: Pv
}, jv = "Siguiente", Lv = {
  title: "Bienvenido a Creators Insights",
  description: "Explore métricas relevantes e información detallada para mejorar y ampliar su presencia"
}, Dv = {
  title: "Inteligencia para ti",
  description: "Encuentre información personalizada basada en los datos de sus publicaciones para aumentar su participación"
}, Nv = {
  title: "Vea sus mejores resultados",
  description: "Identifica las publicaciones con mayor impacto y realiza un seguimiento de sus métricas"
}, Fv = {
  next: jv,
  firstPage: Lv,
  secondPage: Dv,
  thirdPage: Nv
}, Bv = "Ativar Creators Insights", qv = "Tornar a página visível", Hv = "Ao tornar sua página visível, você amplia sua visibilidade para marcas e empresas, facilitando o acesso às suas informações e aumentando suas oportunidades. Compartilhe o link com potenciais interessados para maximizar seu alcance.", Vv = "Para tornar sua página visível e compartilhar seu perfil com amigos ou marcas interessadas, é necessário preencher todas as informações de cadastro no Hub, vincular uma rede social com definição de custo por conteúdo e ativar seu perfil no Creators Insights..", Gv = "Quais das redes sociais você quer ativar para o Creator Insights?", Wv = "No momento, nossos insights e métricas estão disponíveis apenas para o <i class='fa-brands fa-{{socialNetwork}}' style='display: inline-block; vertical-align: middle; margin: 0 2px; font-size: 1.2rem;'></i> Instagram", Kv = "Feito!", Yv = {
  activateCreatorsInsights: Bv,
  makeProfilePublic: qv,
  tipForInfo: Hv,
  tipForAlert: Vv,
  activationQuestion: Gv,
  insightsText: Wv,
  buttonDone: Kv
}, Jv = "Activate Creators Insights", Zv = "Make the page visible", Qv = "By making your page visible, you increase your visibility to brands and companies, making it easier for them to access your information and enhancing your opportunities. Share the link with potential interested parties to maximize your reach.", Xv = "To make your page visible and share your profile with friends or interested brands, you need to fill out all the registration information on the Hub, link a social network with cost per content settings, and activate your profile on Creators Insights.", _v = "Which social networks do you want to activate for Creator Insights?", $v = "At the moment, our insights and metrics are available only for <i class='fa-brands fa-{{socialNetwork}}' style='display: inline-block; vertical-align: middle; margin: 0 2px; font-size: 1.2rem;'></i> Instagram.", eb = "Done!", tb = {
  activateCreatorsInsights: Jv,
  makeProfilePublic: Zv,
  tipForInfo: Qv,
  tipForAlert: Xv,
  activationQuestion: _v,
  insightsText: $v,
  buttonDone: eb
}, ib = "Activar Ideas de Creadores", nb = "Hacer visible la página", sb = "Al hacer visible tu página, aumentas tu visibilidad para marcas y empresas, facilitando el acceso a tu información y aumentando tus oportunidades. Comparte el enlace con potenciales interesados para maximizar tu alcance.", rb = "Para hacer visible tu página y compartir tu perfil con amigos o marcas interesadas, es necesario completar toda la información de registro en el Hub, vincular una red social con definición de costo por contenido y activar tu perfil en Creators Insights.", ob = "¿Qué redes sociales quieres activar para Creator Insights?", ab = "En este momento, nuestros insights y métricas están disponibles solo para <i class='fa-brands fa-{{socialNetwork}}' style='display: inline-block; vertical-align: middle; margin: 0 2px; font-size: 1.2rem;'></i> Instagram.", lb = "¡Hecho!", cb = {
  activateCreatorsInsights: ib,
  makeProfilePublic: nb,
  tipForInfo: sb,
  tipForAlert: rb,
  activationQuestion: ob,
  insightsText: ab,
  buttonDone: lb
}, ub = "Male", db = "Female", fb = "Not declared", hb = {
  male: ub,
  female: db,
  unisex: fb
}, pb = "Masculino", mb = "Feminino", gb = "Não declarado", yb = {
  male: pb,
  female: mb,
  unisex: gb
}, vb = "Masculino", bb = "Feminino", xb = "No declarado", Sb = {
  male: vb,
  female: bb,
  unisex: xb
}, wb = "Dados insuficientes", Ab = {
  insufficientData: wb
}, Cb = "Insufficient data", Eb = {
  insufficientData: Cb
}, kb = "Datos insuficientes", Ob = {
  insufficientData: kb
}, Tb = "Valores do seu Conteúdo", Ib = "Atualize os valores", Ub = "Insira aqui os valores que em média pratica no mercado. Os valores poderão ser negociados de acordo com a campanha.", zb = "Cancelar", Rb = "Salvar", Pb = {
  posts_one: "{{count}} Post",
  posts_other: "{{count}} Posts",
  stories_one: "{{count}} Story",
  stories_other: "{{count}} Stories",
  videos_one: "{{count}} Vídeo",
  videos_other: "{{count}} Vídeos",
  reels_one: "{{count}} Reel",
  reels_other: "{{count}} Reels"
}, Mb = {
  title: Tb,
  updateValues: Ib,
  description: Ub,
  cancel: zb,
  save: Rb,
  labels: Pb
}, jb = "Values of your Content", Lb = "Update the values", Db = "Enter here the values that are on average in the market. Prices can be negotiated according to the campaign.", Nb = "Cancel", Fb = "Save", Bb = {
  posts_one: "{{count}} Post",
  posts_other: "{{count}} Posts",
  stories_one: "{{count}} Story",
  stories_other: "{{count}} Stories",
  videos_one: "{{count}} Video",
  videos_other: "{{count}} Videos",
  reels_one: "{{count}} Reel",
  reels_other: "{{count}} Reels"
}, qb = {
  title: jb,
  updateValues: Lb,
  description: Db,
  cancel: Nb,
  save: Fb,
  labels: Bb
}, Hb = "Valores do seu Conteúdo", Vb = "Atualize os valores", Gb = "Insira aqui os valores que em média pratica no mercado. Os valores poderão ser negociados de acordo com a campanha.", Wb = "Cancelar", Kb = "Salvar", Yb = {
  posts_one: "{{count}} Post",
  posts_other: "{{count}} Posts",
  stories_one: "{{count}} Story",
  stories_other: "{{count}} Stories",
  videos_one: "{{count}} Vídeo",
  videos_other: "{{count}} Vídeos",
  reels_one: "{{count}} Reel",
  reels_other: "{{count}} Reels"
}, Jb = {
  title: Hb,
  updateValues: Vb,
  description: Gb,
  cancel: Wb,
  save: Kb,
  labels: Yb
}, Zb = "Data de Nascimento", Qb = "É preciso ter 18 anos ou mais", Xb = "Idade máxima permitida é de 100 anos", _b = "Campo obrigatório", $b = {
  label: Zb,
  ageUnder18: Qb,
  overThan100: Xb,
  required: _b
}, ex = "Fecha de Nacimiento", tx = "Debe tener 18 años o más", ix = "La edad máxima permitida es de 100 años", nx = "Campo obligatorio", sx = {
  label: ex,
  ageUnder18: tx,
  overThan100: ix,
  required: nx
}, rx = "Date of Birth", ox = "Must be 18 or older", ax = "Maximum age allowed is 100 years old", lx = "Required field", cx = {
  label: rx,
  ageUnder18: ox,
  overThan100: ax,
  required: lx
}, ux = "Seg", dx = "Ter", fx = "Qua", hx = "Qui", px = "Sex", mx = "Sáb", gx = "Dom", yx = "Engajamento médio", vx = {
  monday: ux,
  tuesday: dx,
  wednesday: fx,
  thursday: hx,
  friday: px,
  saturday: mx,
  sunday: gx,
  averageEngagement: yx
}, bx = "Mon", xx = "Tue", Sx = "Wed", wx = "Thu", Ax = "Fri", Cx = "Sat", Ex = "Sun", kx = "Engajamento médio", Ox = {
  monday: bx,
  tuesday: xx,
  wednesday: Sx,
  thursday: wx,
  friday: Ax,
  saturday: Cx,
  sunday: Ex,
  averageEngagement: kx
}, Tx = "Lun", Ix = "Mar", Ux = "Mié", zx = "Jue", Rx = "Vie", Px = "Sáb", Mx = "Dom", jx = "Engagement promedio", Lx = {
  monday: Tx,
  tuesday: Ix,
  wednesday: Ux,
  thursday: zx,
  friday: Rx,
  saturday: Px,
  sunday: Mx,
  averageEngagement: jx
}, na = () => ({
  en: {
    globals: Xp,
    sqMetricChart: Hm,
    sqButtonCopyText: ig,
    sqInputBirthday: pg,
    sqInputDigits: wg,
    sqInputDocumentCnpj: Rg,
    sqInputDocumentCpf: ey,
    sqInputDocumentInternational: Iy,
    sqInputDocumentRut: nv,
    sqInputName: xv,
    sqModalWelcomeCreatorsInsights: Mv,
    sqModalActivation: tb,
    sqGroupVerticalBarChart: hb,
    sqInsufficientData: Eb,
    sqModalProfileCache: qb,
    sqInputBirthdaySimple: cx,
    averageEngagementChart: Ox
  },
  pt: {
    globals: vp,
    sqMetricChart: Lm,
    sqButtonCopyText: _m,
    sqInputBirthday: ug,
    sqInputDigits: xg,
    sqInputDocumentCnpj: Tg,
    sqInputDocumentCpf: Wg,
    sqInputDocumentInternational: by,
    sqInputDocumentRut: Jy,
    sqInputName: gv,
    sqModalWelcomeCreatorsInsights: Iv,
    sqModalActivation: Yv,
    sqGroupVerticalBarChart: yb,
    sqInsufficientData: Ab,
    sqModalProfileCache: Mb,
    sqInputBirthdaySimple: $b,
    averageEngagementChart: vx
  },
  es: {
    globals: Um,
    sqMetricChart: Jm,
    sqButtonCopyText: og,
    sqInputBirthday: vg,
    sqInputDigits: Cg,
    sqInputDocumentCnpj: Lg,
    sqInputDocumentCpf: cy,
    sqInputDocumentInternational: Fy,
    sqInputDocumentRut: fv,
    sqInputName: Cv,
    sqModalWelcomeCreatorsInsights: Fv,
    sqModalActivation: cb,
    sqGroupVerticalBarChart: Sb,
    sqInsufficientData: Ob,
    sqModalProfileCache: Jb,
    sqInputBirthdaySimple: sx,
    averageEngagementChart: Lx
  }
}), Dx = "globals";
let hn = na();
const hi = ["sqInput"], w2 = (n) => {
  n != null && n.length ? n.forEach((e) => {
    Object.keys(e).forEach((t) => {
      Nx(t, e[t]);
    });
  }) : hn = na();
}, Nx = (n, e) => {
  var t;
  if ((t = n == null ? void 0 : n[0]) == null || t.toLocaleLowerCase(), e) {
    const s = hn.en[hi != null && hi.includes(n) ? "globals" : n], r = hn.pt[hi != null && hi.includes(n) ? "globals" : n], a = hn.es[hi != null && hi.includes(n) ? "globals" : n];
    Object.assign(s, e.en), Object.assign(r, e.pt), Object.assign(a, e.es);
  } else
    hn = na();
};
var nu;
qe.use(Au).use(vu).use(vh).init({
  defaultNS: Dx,
  ns: [
    "globals",
    "sqMetricChart",
    "sqButtonCopyText",
    "sqInputBirthday",
    "sqInputDigits",
    "sqInputDocumentCnpj",
    "sqInputDocumentCpf",
    "sqInputDocumentInternational",
    "sqInputDocumentRut",
    "sqInputName",
    "sqModalWelcomeCreatorsInsights",
    "sqGroupVerticalBarChart",
    "sqInputBirthdaySimple",
    "averageEngagementChart"
  ],
  load: "all",
  supportedLngs: ["en", "pt", "es"],
  debug: !1,
  lng: ((nu = navigator.language) == null ? void 0 : nu.split("-")[0]) || "en",
  cache: { enable: !1 },
  interpolation: { escapeValue: !1 },
  fallbackLng: "en",
  resources: hn
});
var Ro = { exports: {} }, jn = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ml;
function Fx() {
  if (ml)
    return jn;
  ml = 1;
  var n = Fe, e = Symbol.for("react.element"), t = Symbol.for("react.fragment"), s = Object.prototype.hasOwnProperty, r = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, a = { key: !0, ref: !0, __self: !0, __source: !0 };
  function c(l, d, h) {
    var m, y = {}, b = null, v = null;
    h !== void 0 && (b = "" + h), d.key !== void 0 && (b = "" + d.key), d.ref !== void 0 && (v = d.ref);
    for (m in d)
      s.call(d, m) && !a.hasOwnProperty(m) && (y[m] = d[m]);
    if (l && l.defaultProps)
      for (m in d = l.defaultProps, d)
        y[m] === void 0 && (y[m] = d[m]);
    return { $$typeof: e, type: l, key: b, ref: v, props: y, _owner: r.current };
  }
  return jn.Fragment = t, jn.jsx = c, jn.jsxs = c, jn;
}
var Ln = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var gl;
function Bx() {
  return gl || (gl = 1, process.env.NODE_ENV !== "production" && function() {
    var n = Fe, e = Symbol.for("react.element"), t = Symbol.for("react.portal"), s = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), c = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), h = Symbol.for("react.suspense"), m = Symbol.for("react.suspense_list"), y = Symbol.for("react.memo"), b = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), w = Symbol.iterator, o = "@@iterator";
    function u(B) {
      if (B === null || typeof B != "object")
        return null;
      var Y = w && B[w] || B[o];
      return typeof Y == "function" ? Y : null;
    }
    var f = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function p(B) {
      {
        for (var Y = arguments.length, ie = new Array(Y > 1 ? Y - 1 : 0), xe = 1; xe < Y; xe++)
          ie[xe - 1] = arguments[xe];
        g("error", B, ie);
      }
    }
    function g(B, Y, ie) {
      {
        var xe = f.ReactDebugCurrentFrame, De = xe.getStackAddendum();
        De !== "" && (Y += "%s", ie = ie.concat([De]));
        var We = ie.map(function(Ne) {
          return String(Ne);
        });
        We.unshift("Warning: " + Y), Function.prototype.apply.call(console[B], console, We);
      }
    }
    var S = !1, x = !1, E = !1, k = !1, R = !1, O;
    O = Symbol.for("react.module.reference");
    function T(B) {
      return !!(typeof B == "string" || typeof B == "function" || B === s || B === a || R || B === r || B === h || B === m || k || B === v || S || x || E || typeof B == "object" && B !== null && (B.$$typeof === b || B.$$typeof === y || B.$$typeof === c || B.$$typeof === l || B.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      B.$$typeof === O || B.getModuleId !== void 0));
    }
    function D(B, Y, ie) {
      var xe = B.displayName;
      if (xe)
        return xe;
      var De = Y.displayName || Y.name || "";
      return De !== "" ? ie + "(" + De + ")" : ie;
    }
    function P(B) {
      return B.displayName || "Context";
    }
    function N(B) {
      if (B == null)
        return null;
      if (typeof B.tag == "number" && p("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof B == "function")
        return B.displayName || B.name || null;
      if (typeof B == "string")
        return B;
      switch (B) {
        case s:
          return "Fragment";
        case t:
          return "Portal";
        case a:
          return "Profiler";
        case r:
          return "StrictMode";
        case h:
          return "Suspense";
        case m:
          return "SuspenseList";
      }
      if (typeof B == "object")
        switch (B.$$typeof) {
          case l:
            var Y = B;
            return P(Y) + ".Consumer";
          case c:
            var ie = B;
            return P(ie._context) + ".Provider";
          case d:
            return D(B, B.render, "ForwardRef");
          case y:
            var xe = B.displayName || null;
            return xe !== null ? xe : N(B.type) || "Memo";
          case b: {
            var De = B, We = De._payload, Ne = De._init;
            try {
              return N(Ne(We));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var I = Object.assign, C = 0, U, z, j, F, q, W, K;
    function Q() {
    }
    Q.__reactDisabledLog = !0;
    function G() {
      {
        if (C === 0) {
          U = console.log, z = console.info, j = console.warn, F = console.error, q = console.group, W = console.groupCollapsed, K = console.groupEnd;
          var B = {
            configurable: !0,
            enumerable: !0,
            value: Q,
            writable: !0
          };
          Object.defineProperties(console, {
            info: B,
            log: B,
            warn: B,
            error: B,
            group: B,
            groupCollapsed: B,
            groupEnd: B
          });
        }
        C++;
      }
    }
    function M() {
      {
        if (C--, C === 0) {
          var B = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: I({}, B, {
              value: U
            }),
            info: I({}, B, {
              value: z
            }),
            warn: I({}, B, {
              value: j
            }),
            error: I({}, B, {
              value: F
            }),
            group: I({}, B, {
              value: q
            }),
            groupCollapsed: I({}, B, {
              value: W
            }),
            groupEnd: I({}, B, {
              value: K
            })
          });
        }
        C < 0 && p("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var te = f.ReactCurrentDispatcher, ce;
    function he(B, Y, ie) {
      {
        if (ce === void 0)
          try {
            throw Error();
          } catch (De) {
            var xe = De.stack.trim().match(/\n( *(at )?)/);
            ce = xe && xe[1] || "";
          }
        return `
` + ce + B;
      }
    }
    var Ue = !1, $;
    {
      var ne = typeof WeakMap == "function" ? WeakMap : Map;
      $ = new ne();
    }
    function ye(B, Y) {
      if (!B || Ue)
        return "";
      {
        var ie = $.get(B);
        if (ie !== void 0)
          return ie;
      }
      var xe;
      Ue = !0;
      var De = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var We;
      We = te.current, te.current = null, G();
      try {
        if (Y) {
          var Ne = function() {
            throw Error();
          };
          if (Object.defineProperty(Ne.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(Ne, []);
            } catch (fe) {
              xe = fe;
            }
            Reflect.construct(B, [], Ne);
          } else {
            try {
              Ne.call();
            } catch (fe) {
              xe = fe;
            }
            B.call(Ne.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (fe) {
            xe = fe;
          }
          B();
        }
      } catch (fe) {
        if (fe && xe && typeof fe.stack == "string") {
          for (var Ie = fe.stack.split(`
`), Oe = xe.stack.split(`
`), L = Ie.length - 1, H = Oe.length - 1; L >= 1 && H >= 0 && Ie[L] !== Oe[H]; )
            H--;
          for (; L >= 1 && H >= 0; L--, H--)
            if (Ie[L] !== Oe[H]) {
              if (L !== 1 || H !== 1)
                do
                  if (L--, H--, H < 0 || Ie[L] !== Oe[H]) {
                    var J = `
` + Ie[L].replace(" at new ", " at ");
                    return B.displayName && J.includes("<anonymous>") && (J = J.replace("<anonymous>", B.displayName)), typeof B == "function" && $.set(B, J), J;
                  }
                while (L >= 1 && H >= 0);
              break;
            }
        }
      } finally {
        Ue = !1, te.current = We, M(), Error.prepareStackTrace = De;
      }
      var _ = B ? B.displayName || B.name : "", me = _ ? he(_) : "";
      return typeof B == "function" && $.set(B, me), me;
    }
    function ue(B, Y, ie) {
      return ye(B, !1);
    }
    function je(B) {
      var Y = B.prototype;
      return !!(Y && Y.isReactComponent);
    }
    function V(B, Y, ie) {
      if (B == null)
        return "";
      if (typeof B == "function")
        return ye(B, je(B));
      if (typeof B == "string")
        return he(B);
      switch (B) {
        case h:
          return he("Suspense");
        case m:
          return he("SuspenseList");
      }
      if (typeof B == "object")
        switch (B.$$typeof) {
          case d:
            return ue(B.render);
          case y:
            return V(B.type, Y, ie);
          case b: {
            var xe = B, De = xe._payload, We = xe._init;
            try {
              return V(We(De), Y, ie);
            } catch {
            }
          }
        }
      return "";
    }
    var Z = Object.prototype.hasOwnProperty, re = {}, be = f.ReactDebugCurrentFrame;
    function se(B) {
      if (B) {
        var Y = B._owner, ie = V(B.type, B._source, Y ? Y.type : null);
        be.setExtraStackFrame(ie);
      } else
        be.setExtraStackFrame(null);
    }
    function Se(B, Y, ie, xe, De) {
      {
        var We = Function.call.bind(Z);
        for (var Ne in B)
          if (We(B, Ne)) {
            var Ie = void 0;
            try {
              if (typeof B[Ne] != "function") {
                var Oe = Error((xe || "React class") + ": " + ie + " type `" + Ne + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof B[Ne] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Oe.name = "Invariant Violation", Oe;
              }
              Ie = B[Ne](Y, Ne, xe, ie, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (L) {
              Ie = L;
            }
            Ie && !(Ie instanceof Error) && (se(De), p("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", xe || "React class", ie, Ne, typeof Ie), se(null)), Ie instanceof Error && !(Ie.message in re) && (re[Ie.message] = !0, se(De), p("Failed %s type: %s", ie, Ie.message), se(null));
          }
      }
    }
    var Ce = Array.isArray;
    function Me(B) {
      return Ce(B);
    }
    function de(B) {
      {
        var Y = typeof Symbol == "function" && Symbol.toStringTag, ie = Y && B[Symbol.toStringTag] || B.constructor.name || "Object";
        return ie;
      }
    }
    function ve(B) {
      try {
        return Ee(B), !1;
      } catch {
        return !0;
      }
    }
    function Ee(B) {
      return "" + B;
    }
    function le(B) {
      if (ve(B))
        return p("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", de(B)), Ee(B);
    }
    var pe = f.ReactCurrentOwner, Ve = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, lt, tt, ct;
    ct = {};
    function wt(B) {
      if (Z.call(B, "ref")) {
        var Y = Object.getOwnPropertyDescriptor(B, "ref").get;
        if (Y && Y.isReactWarning)
          return !1;
      }
      return B.ref !== void 0;
    }
    function mt(B) {
      if (Z.call(B, "key")) {
        var Y = Object.getOwnPropertyDescriptor(B, "key").get;
        if (Y && Y.isReactWarning)
          return !1;
      }
      return B.key !== void 0;
    }
    function ze(B, Y) {
      if (typeof B.ref == "string" && pe.current && Y && pe.current.stateNode !== Y) {
        var ie = N(pe.current.type);
        ct[ie] || (p('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', N(pe.current.type), B.ref), ct[ie] = !0);
      }
    }
    function jt(B, Y) {
      {
        var ie = function() {
          lt || (lt = !0, p("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Y));
        };
        ie.isReactWarning = !0, Object.defineProperty(B, "key", {
          get: ie,
          configurable: !0
        });
      }
    }
    function Lt(B, Y) {
      {
        var ie = function() {
          tt || (tt = !0, p("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Y));
        };
        ie.isReactWarning = !0, Object.defineProperty(B, "ref", {
          get: ie,
          configurable: !0
        });
      }
    }
    var Yt = function(B, Y, ie, xe, De, We, Ne) {
      var Ie = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: e,
        // Built-in properties that belong on the element
        type: B,
        key: Y,
        ref: ie,
        props: Ne,
        // Record the component responsible for creating this element.
        _owner: We
      };
      return Ie._store = {}, Object.defineProperty(Ie._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Ie, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: xe
      }), Object.defineProperty(Ie, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: De
      }), Object.freeze && (Object.freeze(Ie.props), Object.freeze(Ie)), Ie;
    };
    function Dt(B, Y, ie, xe, De) {
      {
        var We, Ne = {}, Ie = null, Oe = null;
        ie !== void 0 && (le(ie), Ie = "" + ie), mt(Y) && (le(Y.key), Ie = "" + Y.key), wt(Y) && (Oe = Y.ref, ze(Y, De));
        for (We in Y)
          Z.call(Y, We) && !Ve.hasOwnProperty(We) && (Ne[We] = Y[We]);
        if (B && B.defaultProps) {
          var L = B.defaultProps;
          for (We in L)
            Ne[We] === void 0 && (Ne[We] = L[We]);
        }
        if (Ie || Oe) {
          var H = typeof B == "function" ? B.displayName || B.name || "Unknown" : B;
          Ie && jt(Ne, H), Oe && Lt(Ne, H);
        }
        return Yt(B, Ie, Oe, De, xe, pe.current, Ne);
      }
    }
    var kt = f.ReactCurrentOwner, $t = f.ReactDebugCurrentFrame;
    function Ot(B) {
      if (B) {
        var Y = B._owner, ie = V(B.type, B._source, Y ? Y.type : null);
        $t.setExtraStackFrame(ie);
      } else
        $t.setExtraStackFrame(null);
    }
    var Jt;
    Jt = !1;
    function ei(B) {
      return typeof B == "object" && B !== null && B.$$typeof === e;
    }
    function it() {
      {
        if (kt.current) {
          var B = N(kt.current.type);
          if (B)
            return `

Check the render method of \`` + B + "`.";
        }
        return "";
      }
    }
    function gt(B) {
      {
        if (B !== void 0) {
          var Y = B.fileName.replace(/^.*[\\\/]/, ""), ie = B.lineNumber;
          return `

Check your code at ` + Y + ":" + ie + ".";
        }
        return "";
      }
    }
    var ge = {};
    function Le(B) {
      {
        var Y = it();
        if (!Y) {
          var ie = typeof B == "string" ? B : B.displayName || B.name;
          ie && (Y = `

Check the top-level render call using <` + ie + ">.");
        }
        return Y;
      }
    }
    function yt(B, Y) {
      {
        if (!B._store || B._store.validated || B.key != null)
          return;
        B._store.validated = !0;
        var ie = Le(Y);
        if (ge[ie])
          return;
        ge[ie] = !0;
        var xe = "";
        B && B._owner && B._owner !== kt.current && (xe = " It was passed a child from " + N(B._owner.type) + "."), Ot(B), p('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', ie, xe), Ot(null);
      }
    }
    function Nt(B, Y) {
      {
        if (typeof B != "object")
          return;
        if (Me(B))
          for (var ie = 0; ie < B.length; ie++) {
            var xe = B[ie];
            ei(xe) && yt(xe, Y);
          }
        else if (ei(B))
          B._store && (B._store.validated = !0);
        else if (B) {
          var De = u(B);
          if (typeof De == "function" && De !== B.entries)
            for (var We = De.call(B), Ne; !(Ne = We.next()).done; )
              ei(Ne.value) && yt(Ne.value, Y);
        }
      }
    }
    function ae(B) {
      {
        var Y = B.type;
        if (Y == null || typeof Y == "string")
          return;
        var ie;
        if (typeof Y == "function")
          ie = Y.propTypes;
        else if (typeof Y == "object" && (Y.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        Y.$$typeof === y))
          ie = Y.propTypes;
        else
          return;
        if (ie) {
          var xe = N(Y);
          Se(ie, B.props, "prop", xe, B);
        } else if (Y.PropTypes !== void 0 && !Jt) {
          Jt = !0;
          var De = N(Y);
          p("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", De || "Unknown");
        }
        typeof Y.getDefaultProps == "function" && !Y.getDefaultProps.isReactClassApproved && p("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function we(B) {
      {
        for (var Y = Object.keys(B.props), ie = 0; ie < Y.length; ie++) {
          var xe = Y[ie];
          if (xe !== "children" && xe !== "key") {
            Ot(B), p("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", xe), Ot(null);
            break;
          }
        }
        B.ref !== null && (Ot(B), p("Invalid attribute `ref` supplied to `React.Fragment`."), Ot(null));
      }
    }
    var Ae = {};
    function Je(B, Y, ie, xe, De, We) {
      {
        var Ne = T(B);
        if (!Ne) {
          var Ie = "";
          (B === void 0 || typeof B == "object" && B !== null && Object.keys(B).length === 0) && (Ie += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Oe = gt(De);
          Oe ? Ie += Oe : Ie += it();
          var L;
          B === null ? L = "null" : Me(B) ? L = "array" : B !== void 0 && B.$$typeof === e ? (L = "<" + (N(B.type) || "Unknown") + " />", Ie = " Did you accidentally export a JSX literal instead of a component?") : L = typeof B, p("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", L, Ie);
        }
        var H = Dt(B, Y, ie, De, We);
        if (H == null)
          return H;
        if (Ne) {
          var J = Y.children;
          if (J !== void 0)
            if (xe)
              if (Me(J)) {
                for (var _ = 0; _ < J.length; _++)
                  Nt(J[_], B);
                Object.freeze && Object.freeze(J);
              } else
                p("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Nt(J, B);
        }
        if (Z.call(Y, "key")) {
          var me = N(B), fe = Object.keys(Y).filter(function($e) {
            return $e !== "key";
          }), ke = fe.length > 0 ? "{key: someKey, " + fe.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Ae[me + ke]) {
            var Qe = fe.length > 0 ? "{" + fe.join(": ..., ") + ": ...}" : "{}";
            p(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, ke, me, Qe, me), Ae[me + ke] = !0;
          }
        }
        return B === s ? we(H) : ae(H), H;
      }
    }
    function dt(B, Y, ie) {
      return Je(B, Y, ie, !0);
    }
    function Tt(B, Y, ie) {
      return Je(B, Y, ie, !1);
    }
    var It = Tt, nt = dt;
    Ln.Fragment = s, Ln.jsx = It, Ln.jsxs = nt;
  }()), Ln;
}
process.env.NODE_ENV === "production" ? Ro.exports = Fx() : Ro.exports = Bx();
var A = Ro.exports;
class Cu {
  getCssVariableValue(e) {
    var s, r;
    const t = (r = (s = e == null ? void 0 : e.replace("var(", "")) == null ? void 0 : s.replace(")", "")) == null ? void 0 : r.trim();
    return getComputedStyle(document.documentElement).getPropertyValue(t) || e;
  }
  lightenDarkenColor(e, t) {
    var d, h;
    e = e == null ? void 0 : e.trim();
    let s = e == null ? void 0 : e.replace("#", "");
    (s == null ? void 0 : s.length) === 3 && (s = (h = (d = s == null ? void 0 : s.split("")) == null ? void 0 : d.map((m) => `${m}${m}`)) == null ? void 0 : h.join(""));
    const r = (m) => {
      let y = Math.max(Math.min(255, parseInt(m, 16) + t), 0).toString(16);
      return (y == null ? void 0 : y.length) < 2 && (y = `0${y}`), y;
    }, a = r(s == null ? void 0 : s.substring(0, 2)), c = r(s == null ? void 0 : s.substring(2, 4)), l = r(s == null ? void 0 : s.substring(4, 6));
    return `#${a}${c}${l}`;
  }
}
const Et = ({ color: n = "pink", customSize: e, size: t = "", borderSize: s, className: r = "", style: a }) => /* @__PURE__ */ A.jsx(
  "div",
  {
    className: `loader ${t} ${r}`,
    role: "status",
    style: {
      ...a,
      borderWidth: s,
      height: e,
      width: e,
      borderColor: n,
      color: n
    },
    children: /* @__PURE__ */ A.jsx("span", { className: "visually-hidden", children: "Loading" })
  }
);
const Mi = ({
  children: n,
  hideChildrenOnLoading: e,
  customPadding: t,
  width: s,
  borderStyle: r,
  id: a,
  size: c,
  onHover: l,
  onClick: d,
  loading: h = !1,
  disabled: m = !1,
  className: y = "",
  inverted: b,
  invertedHover: v,
  rounded: w,
  color: o = "primary",
  textColor: u = "",
  borderColor: f = "",
  loaderColor: p = "",
  type: g = "button",
  style: S
}) => {
  const [x, E] = X(!1), k = new Cu(), R = `random-id-${(1 + Date.now() + Math.random()).toString().replace(".", "")}`, O = [
    "neutral",
    "purple",
    "pink",
    "red",
    "orange",
    "yellow",
    "green",
    "aqua",
    "blue",
    "lilac",
    "instagram",
    "youtube",
    "pinterest",
    "google",
    "whatsapp",
    "twitter",
    "linkedin",
    "facebook",
    "x",
    "tiktok",
    "twitch",
    "primary"
  ], T = (C) => {
    !h && !m && d && typeof d == "function" && d(C);
  }, D = (C) => k == null ? void 0 : k.lightenDarkenColor(k == null ? void 0 : k.getCssVariableValue(C), -50), P = () => D(v ? u : o), N = () => D(v ? o !== "transparent" ? o : "var(--white-html)" : u !== "transparent" ? u : "var(--white-html)"), I = (C = !1) => {
    E(C), l && typeof l == "function" && l(C);
  };
  return /* @__PURE__ */ A.jsxs(
    "button",
    {
      type: g,
      onClick: (C) => T(C),
      onMouseOver: () => I(!0),
      onFocus: () => null,
      onMouseLeave: () => I(!1),
      className: `button button-${o} ${w ? "rounded " : ""}${b ? "inverted " : ""}${c ? `button-${c} ` : ""}${m ? "disabled " : ""}${h ? "loading " : ""}${y}`,
      id: a || R,
      style: {
        backgroundColor: O.includes(o) ? void 0 : x ? P() : o,
        borderColor: O.includes(o) ? void 0 : x ? D(f || u) : f || u,
        borderStyle: r,
        color: O.includes(o) ? void 0 : x ? N() : u,
        padding: t,
        width: s,
        ...S
      },
      disabled: m,
      children: [
        e && h ? null : n,
        h ? /* @__PURE__ */ A.jsx(Et, { className: "ml-3", size: "small", color: p || o }) : null
      ]
    }
  );
};
const A2 = ({
  disabled: n = !1,
  loading: e = !1,
  className: t = "",
  width: s,
  customPadding: r,
  onClick: a,
  onHover: c,
  id: l,
  textLayout: d = !1,
  circleLayout: h = !1,
  onReferrerFalseUrl: m = "/"
}) => {
  const y = `random-id-${(1 + Date.now() + Math.random()).toString().replace(".", "")}`, { t: b } = Ze(), [v, w] = X(!1), o = (f) => {
    const p = document.referrer;
    !e && !n && (a && typeof a == "function" ? a(f) : p.includes(window.location.origin) ? history.back() : history.pushState({}, "", m));
  }, u = (f = !1) => {
    w(f), c && typeof c == "function" && c(f);
  };
  return /* @__PURE__ */ A.jsxs(
    "button",
    {
      type: "button",
      onClick: (f) => o(f),
      onMouseOver: () => u(!0),
      onFocus: () => null,
      onMouseLeave: () => u(!1),
      className: `button-back ${n ? "disabled " : ""}${e ? "loading " : ""}${t} ${d ? "text-layout" : ""}${h ? "circle-layout" : ""}`,
      id: l || y,
      style: {
        padding: r,
        width: s
      },
      disabled: n,
      children: [
        e ? null : /* @__PURE__ */ A.jsx("i", { className: `fa-regular ${d ? "fa-chevron-left" : "fa-arrow-left"}` }),
        d ? b("back") : null,
        e ? /* @__PURE__ */ A.jsx(Et, { size: "small", color: "gray" }) : null
      ]
    }
  );
};
class qx {
  constructor() {
    oe(this, "toast", {
      success: (e, t) => this.toastLogSrr(e, t),
      error: (e, t) => this.toastLogSrr(e, t),
      inverted: (e, t) => this.toastLogSrr(e, t),
      info: (e, t) => this.toastLogSrr(e, t),
      warning: (e, t) => this.toastLogSrr(e, t),
      grayscale: (e, t) => this.toastLogSrr(e, t),
      custom: (e, t) => this.toastLogSrr(e, t),
      default: (e, t) => this.toastLogSrr(e, t),
      show: (e, t) => this.toastLogSrr(e, t),
      theme: (e, t) => this.toastLogSrr(e, t)
    });
    this.toast = window.Toast;
  }
  toastLogSrr(e, t) {
    return {
      message: e,
      config: t
    };
  }
}
const Hx = ({
  content: n,
  textColor: e,
  maxWidth: t,
  className: s = "",
  color: r = "var(--primary_color)",
  backgroundColor: a = "var(primary_color)",
  noMargin: c = !1,
  size: l = "lg",
  style: d
}) => {
  const h = xt(() => new qx().toast, []), [m, y] = X(!1), [b] = Ze("sqButtonCopyText"), v = He(async () => {
    var o;
    typeof n == "object" ? await navigator.clipboard.writeText((o = n == null ? void 0 : n.props) == null ? void 0 : o.children) : await navigator.clipboard.writeText(n), y(!0), setTimeout(() => {
      y(!1);
    }, 3e3), h.success(b("urlCopied"), {
      closeButton: !0,
      className: "full text-bold",
      position: `${window.innerWidth > 991 ? "top" : "bottom"} center`,
      notOverClick: !0,
      immediately: !0
    });
  }, [n, b, h]), w = {
    maxWidth: t,
    backgroundColor: a,
    borderTopColor: a,
    ...d
  };
  return c && (w.padding = 0), /* @__PURE__ */ A.jsxs("div", { className: `button-copy-text ${s}`, style: { ...w }, children: [
    /* @__PURE__ */ A.jsx("span", { className: "button-copy", style: { backgroundColor: a, color: e }, children: n }),
    /* @__PURE__ */ A.jsx("button", { onClick: v, className: "icon-card", style: { backgroundColor: a }, children: m ? /* @__PURE__ */ A.jsx("i", { className: "far fa-check green" }) : /* @__PURE__ */ A.jsx("i", { className: "far fa-copy", style: { color: r } }) })
  ] });
};
class Vx {
  setIcon(e) {
    return e === "twitter" ? "x" : e;
  }
  setColor(e) {
    return e === "twitter" ? "x" : e;
  }
}
const C2 = ({
  className: n = "",
  disabled: e = !1,
  loading: t = !1,
  onClick: s,
  onHover: r,
  size: a = "md",
  socialNetwork: c = "instagram",
  id: l,
  width: d
}) => {
  const [h, m] = X({
    name: "Instagram",
    color: "var(--instagram)",
    icon: "instagram"
  }), [y, b] = X(!1), v = new Vx();
  ee(() => {
    switch (c) {
      case "facebook":
        m({
          name: "Facebook",
          color: "facebook",
          icon: "facebook"
        });
        break;
      case "youtube":
        m({
          name: "Youtube",
          color: "youtube",
          icon: "youtube"
        });
        break;
      case "twitter":
        m({
          name: "Twitter",
          color: "x",
          icon: "twitter"
        });
        break;
      case "tiktok":
        m({
          name: "TikTok",
          color: "tiktok",
          icon: "tiktok"
        });
        break;
      default:
        m({
          name: "Instagram",
          color: "instagram",
          icon: "instagram"
        });
        break;
    }
  }, [c]);
  const w = (o) => {
    b(o), r && typeof r == "function" && r(o);
  };
  return /* @__PURE__ */ A.jsx(
    Mi,
    {
      disabled: e,
      loading: t,
      onClick: s,
      onHover: w,
      size: a,
      className: `${n} button-social-network `,
      id: l,
      color: h.color,
      width: d,
      children: /* @__PURE__ */ A.jsxs("div", { className: "display-flex justify-content-center", children: [
        /* @__PURE__ */ A.jsx("i", { className: `fa-brands fa-${v.setIcon(h == null ? void 0 : h.icon)} mr-3`, style: { fontSize: "22px", color: "inherit" } }),
        /* @__PURE__ */ A.jsx("span", { style: { color: "inherit", fontWeight: "bold" }, dangerouslySetInnerHTML: { __html: h.name } })
      ] })
    }
  );
};
class Ai {
  constructor() {
    oe(this, "Fn", {
      validaRut: function(e) {
        if (e = e.replace(/\./g, "").replace("‐", "-"), !/^[0-9]+[-|‐]{1}[0-9kK]{1}$/.test(e))
          return !1;
        const t = e.split("-");
        let s = t[1];
        const r = t[0];
        return s == "K" && (s = "k"), this.dv(r) == s;
      },
      dv: function(e) {
        let t = 0, s = 1;
        for (; e; e = Math.floor(e / 10))
          s = (s + e % 10 * (9 - t++ % 6)) % 11;
        return s ? s - 1 : "k";
      }
    });
    oe(this, "setCpfMask", (e) => {
      const t = e.replace(/[^\d]/g, ""), s = t.length;
      return s <= 6 ? e = t.replace(/(\d{3})(\d{1,3})/g, "$1.$2") : s <= 9 ? e = t.replace(/(\d{3})(\d{3})(\d{1,3})/g, "$1.$2.$3") : e = t.replace(/(\d{3})(\d{3})(\d{3})(\d{1,2})/g, "$1.$2.$3-$4"), e;
    });
    oe(this, "setCnpjMask", (e) => {
      const t = e.replace(/[^\d]/g, ""), s = t.length;
      return s <= 5 ? e = t.replace(/(\d{2})(\d{1,3})/g, "$1.$2") : s <= 8 ? e = t.replace(/(\d{2})(\d{3})(\d{1,3})/g, "$1.$2.$3") : s <= 12 ? e = t.replace(/(\d{2})(\d{3})(\d{3})(\d{1,4})/g, "$1.$2.$3/$4") : e = t.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{1,2})/g, "$1.$2.$3/$4-$5"), e;
    });
  }
  xor(e, t) {
    return (e || t) && !(e && t);
  }
  nameSpecialChars(e) {
    return /^[a-záàâãéèêíïóôõöúçñ ]+$/i.test(e);
  }
  fullName(e) {
    const s = e.trim().split(" ");
    if (s.length < 2)
      return !1;
    for (const r of s)
      if (!/^[a-záàâãéèêíïóôõöúçñ ]+$/i.test(r))
        return !1;
    return !0;
  }
  email(e) {
    return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i.test(
      e
    );
  }
  ageLessThan(e, t) {
    const s = /* @__PURE__ */ new Date(), r = new Date(e);
    let a = s.getFullYear() - r.getFullYear();
    const c = s.getMonth() - r.getMonth();
    return (c < 0 || c === 0 && s.getDate() <= r.getDate()) && a--, a < t;
  }
  ageOverThan(e, t) {
    const s = /* @__PURE__ */ new Date(), r = new Date(e);
    let a = s.getFullYear() - r.getFullYear();
    const c = s.getMonth() - r.getMonth();
    return (c < 0 || c === 0 && s.getDate() <= r.getDate()) && a--, a > t;
  }
  url(e) {
    return !!new RegExp(
      "^(https?:\\/\\/)?((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|((\\d{1,3}\\.){3}\\d{1,3}))(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*(\\?[;&a-z\\d%_.~+=-]*)?(\\#[-a-z\\d_]*)?$",
      "i"
    ).test(e);
  }
  date(e) {
    return !!Date.parse(e);
  }
  cnpj(e = "") {
    if (e.length !== 14)
      return !1;
    for (const l of Array.from(Array(10).keys()))
      if (Array(14).fill(l).join("") === e)
        return !1;
    let t = e.length - 2, s = e == null ? void 0 : e.substring(0, t);
    const r = e == null ? void 0 : e.substring(t);
    let a = 0, c = t - 7;
    for (let l = t; l >= 1; l--)
      a += s.charAt(t - l) * c--, c < 2 && (c = 9);
    if (!(a % 11 < 2) && 11 - a % 11 !== parseInt(r.charAt(0), 10))
      return !1;
    t = t + 1, s = e == null ? void 0 : e.substring(0, t), a = 0, c = t - 7;
    for (let l = t; l >= 1; l--)
      a += s.charAt(s - l) * c--, c < 2 && (c = 9);
    return !(!(a % 11 < 2) && 11 - a % 11 !== parseInt(r.charAt(1), 10));
  }
  phone(e = "") {
    const t = /(\d{2})(\d{0,1})(\d{4})(\d{4})/;
    return e.match(t) !== null;
  }
  cpf(e = "") {
    let t = 0, s;
    if (/^(.)\1+$/.test(e))
      return !1;
    for (let r = 1; r <= 9; r++)
      t = t + parseInt(e == null ? void 0 : e.substring(r - 1, r), 10) * (11 - r);
    if (s = t * 10 % 11, (s === 10 || s === 11) && (s = 0), s !== parseInt(e == null ? void 0 : e.substring(9, 10), 10))
      return !1;
    t = 0;
    for (let r = 1; r <= 10; r++)
      t = t + parseInt(e == null ? void 0 : e.substring(r - 1, r), 10) * (12 - r);
    return s = t * 10 % 11, (s === 10 || s === 11) && (s = 0), s === parseInt(e == null ? void 0 : e.substring(10, 11), 10);
  }
  recordEmployment(e = "") {
    let t = 0, s = 0, r = "";
    if (e === "00000000000")
      return !1;
    for (let a = 0, c = "3298765432", l = 0; a <= 9; a++)
      l = Number(e.slice(a, a + 1)) * Number(c.slice(a, a + 1)), t = t + l;
    return s = t % 11, s !== 0 && (s = 11 - s), (s === 10 || s === 11) && (r = s.toString(), s = Number(r.slice(1, 2))), s === Number(e.slice(10, 11));
  }
}
const Gx = 800, sa = ({
  label: n,
  disabled: e = !1,
  readOnly: t = !1,
  errorSpan: s = !0,
  noCounting: r = !1,
  maxLength: a,
  loading: c,
  required: l,
  requiredOnLoad: d = !1,
  externalError: h,
  errorIcon: m = /* @__PURE__ */ A.jsx("i", { className: "fa-regular fa-exclamation-triangle" }),
  id: y,
  name: b,
  type: v = "text",
  leftLabel: w,
  rightLabel: o,
  externalIcon: u,
  value: f = "",
  placeholder: p,
  min: g,
  max: S,
  backgroundColor: x = "",
  autoComplete: E = "off",
  className: k = "",
  autoFocus: R = !1,
  onChange: O,
  onValidate: T,
  onTimeout: D,
  style: P,
  onBlur: N
}) => {
  var Q;
  const I = `random-id-${(1 + Date.now() + Math.random()).toString().replace(".", "")}`, C = xt(() => new Ai(), []), [U, z] = X(null), [j, F] = X({
    value: f,
    error: ""
  }), { t: q } = Ze();
  ee(() => {
    j.value !== f && K(f);
  }, [f, j.value]), ee(() => () => {
    clearTimeout(U);
  }, [U]);
  const W = He(
    (G) => {
      N && typeof N == "function" && N(j.value, G);
    },
    [N, j.value]
  ), K = (G) => {
    var M;
    j.value = ((M = G == null ? void 0 : G.target) == null ? void 0 : M.value) || (G != null && G.length ? G : ""), h ? j.error = "" : l && (!j.value || j.value.length < 1) && j.value !== 0 ? j.error = q("required") : v === "email" && !C.email(j.value) ? j.error = q("invalidEmail") : v === "tel" && !C.phone(j.value) ? j.error = q("invalidPhone") : v === "url" && j.value && j.value.length && !C.url(j.value) ? j.error = q("invalidUrl") : j.error = "", F({ ...j }), T && typeof T == "function" && T(!j.error && !h), O && typeof O == "function" && O(j.value), D && typeof D == "function" && (D(!1), U && clearTimeout(U), z(
      setTimeout(() => {
        D(!0);
      }, Gx)
    ));
  };
  return /* @__PURE__ */ A.jsxs("div", { className: `wrapper-all-inside-input ${k}`, children: [
    n ? /* @__PURE__ */ A.jsx("label", { className: `label ${h || j.error ? "error " : ""}`, htmlFor: y || I, children: n }) : null,
    /* @__PURE__ */ A.jsxs(
      "div",
      {
        className: `no-padding wrapper-input wrapper-input-squid ${h || j.error ? "error " : ""}${v === "textarea" ? "textarea " : ""}`,
        children: [
          w ? /* @__PURE__ */ A.jsx("span", { className: "input-group-text", children: w }) : null,
          v !== "textarea" ? /* @__PURE__ */ A.jsx(
            "input",
            {
              className: `col input ${t ? "readonly " : ""}${e ? "disabled " : ""}${c ? "loading " : ""}${v === "number" ? "has-icon-extra-padding " : ""}${h || j.error ? "error " : ""}${u ? "has-icon-external " : ""}`,
              style: {
                backgroundColor: x,
                ...P
              },
              id: y || I,
              type: v || "text",
              name: b || I,
              placeholder: p || "",
              value: j.value,
              maxLength: a,
              required: l,
              disabled: e,
              readOnly: t || c,
              min: g,
              max: S,
              onChange: K,
              autoComplete: E,
              autoFocus: R,
              onBlur: W
            }
          ) : /* @__PURE__ */ A.jsx(
            "textarea",
            {
              className: `col textarea scrollbar ${h || j.error ? "error " : ""}${t ? "readonly " : ""}${e ? "disabled " : ""}${c ? "loading " : ""}${u ? "has-icon-external " : ""}`,
              style: {
                backgroundColor: x
              },
              id: y || I,
              name: b || I,
              placeholder: p || "",
              maxLength: a,
              required: l,
              disabled: e,
              readOnly: t,
              onChange: K,
              value: j.value,
              autoFocus: R,
              onBlur: W
            }
          ),
          o ? /* @__PURE__ */ A.jsx("span", { className: "input-group-text", children: o }) : null
        ]
      }
    ),
    c ? /* @__PURE__ */ A.jsx(Et, { size: "small", className: `display-block loader-input ${n ? "" : "no-label"}`, style: { position: "absolute" } }) : null,
    u && !c ? /* @__PURE__ */ A.jsx("span", { className: `icon icon-external ${v === "textarea" ? "textarea-icon " : ""}${n ? "" : "no-label "}`, children: u }) : null,
    s ? /* @__PURE__ */ A.jsxs("div", { className: `box-validation box-invalid show ${a ? "has-max-length " : ""}`, children: [
      d && !j.value && !j.error && !h ? /* @__PURE__ */ A.jsxs("div", { children: [
        /* @__PURE__ */ A.jsx("i", { className: "fa-solid fa-diamond-exclamation gold" }),
        "Fill this field"
      ] }) : null,
      j.error || h ? m || /* @__PURE__ */ A.jsx("i", { className: "fa-regular fa-exclamation-triangle" }) : null,
      h || "",
      j.error && !h ? j.error : "",
      a && !r ? /* @__PURE__ */ A.jsx("span", { className: "max-length-name", children: a - ((Q = j.value) == null ? void 0 : Q.length) }) : null
    ] }) : null
  ] });
};
const Wx = 800, Kx = ({
  label: n,
  disabled: e = !1,
  readOnly: t = !1,
  requiredOnLoad: s = !1,
  errorSpan: r = !0,
  required: a,
  externalError: c,
  errorIcon: l = /* @__PURE__ */ A.jsx("i", { className: "fa-regular fa-exclamation-triangle" }),
  id: d,
  name: h,
  type: m = "date",
  leftLabel: y,
  rightLabel: b,
  value: v = "",
  placeholder: w,
  backgroundColor: o = "",
  autoComplete: u = "off",
  className: f = "",
  maxDate: p = "9999-12-31",
  onChange: g,
  onValidate: S,
  onTimeout: x
}) => {
  const E = `random-id-${(1 + Date.now() + Math.random()).toString().replace(".", "")}`, k = new Ai(), [R, O] = X(null), [T, D] = X({
    value: v,
    error: "",
    dateObject: "",
    type: "date"
  }), { t: P, i18n: N } = Ze();
  function I(F) {
    const q = F == null ? void 0 : F.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
    return q ? `${q[3]}-${q[2]}-${q[1]}` : F;
  }
  const C = He(() => {
    const F = { ...T };
    v = I((v == null ? void 0 : v.split("T")[0]) || v), F.dateObject = new Date(v), m === "month" && (F.value = U(v)), m === "date" && (F.value = z(v)), F.type = m === "text" ? "date" : m, j(F.value);
  }, [T, v, m]), U = (F) => `${F.split("-")[0]}-${F.split("-")[1]}`, z = (F) => {
    var q;
    try {
      return (q = new Date(F == null ? void 0 : F.replace(/\//g, "-")).toISOString()) == null ? void 0 : q.split("T")[0];
    } catch {
      return "";
    }
  }, j = (F) => {
    var q, W;
    T.value = ((q = F == null ? void 0 : F.target) == null ? void 0 : q.value) || "", T.type === "date" && (T.dateObject = (W = F == null ? void 0 : F.target) == null ? void 0 : W.valueAsDate), T.type === "month" && (T.dateObject = new Date(T.value)), c ? T.error = "" : a && (!T.value || T.value.length < 1) ? T.error = P("required") : k.date(T.value) ? p && new Date(T.value) > new Date(p) ? T.error = P("biggerThanMaxDate", { maxDate: new Date(p).toLocaleDateString(N == null ? void 0 : N.language) }) : T.error = "" : T.error = P("invalidDate"), D({ ...T }), S && typeof S == "function" && S(!T.error && !c), g && typeof g == "function" && g(T.value), x && typeof x == "function" && (x(!1), R && clearTimeout(R), O(
      setTimeout(() => {
        x(!0);
      }, Wx)
    ));
  };
  return ee(() => {
    (T.value !== v || v.includes("T")) && C();
  }, [v, C, T]), ee(() => () => {
    clearTimeout(R);
  }, [R]), /* @__PURE__ */ A.jsxs("div", { className: `wrapper-all-inside-input date-input ${f}`, children: [
    n ? /* @__PURE__ */ A.jsx("label", { className: `label ${c || T.error ? "error " : ""}`, htmlFor: d || E, children: n }) : null,
    /* @__PURE__ */ A.jsxs("div", { className: `no-padding wrapper-input wrapper-input-squid ${c || T.error ? "error " : ""}`, children: [
      y ? /* @__PURE__ */ A.jsx("span", { className: "input-group-text", children: y }) : null,
      /* @__PURE__ */ A.jsx(
        "input",
        {
          className: `col input ${t ? "readonly " : ""}${e ? "disabled " : ""}${c || T.error ? "error " : ""}`,
          style: {
            backgroundColor: o
          },
          id: d || E,
          type: m,
          name: h || E,
          placeholder: w || "",
          value: T == null ? void 0 : T.value,
          required: a,
          disabled: e,
          readOnly: t,
          onChange: j,
          autoComplete: u,
          max: p
        }
      ),
      b ? /* @__PURE__ */ A.jsx("span", { className: "input-group-text", children: b }) : null
    ] }),
    r ? /* @__PURE__ */ A.jsxs("div", { className: "box-validation box-invalid show", children: [
      s && !T.value && !T.error && !c ? /* @__PURE__ */ A.jsxs("div", { children: [
        /* @__PURE__ */ A.jsx("i", { className: "fa-solid fa-diamond-exclamation gold" }),
        P("emptyField")
      ] }) : null,
      T.error || c ? l || /* @__PURE__ */ A.jsx("i", { className: "fa-regular fa-exclamation-triangle" }) : null,
      c || "",
      T.error && !c ? T.error : ""
    ] }) : null
  ] });
}, Yx = 800, E2 = ({
  label: n,
  disabled: e = !1,
  readOnly: t = !1,
  errorSpan: s = !0,
  requiredOnLoad: r = !1,
  required: a,
  externalError: c,
  errorIcon: l,
  id: d,
  name: h,
  type: m = "text",
  leftLabel: y,
  rightLabel: b,
  value: v = "",
  placeholder: w,
  backgroundColor: o = "",
  autoComplete: u = "off",
  className: f = "",
  onChange: p,
  onValidate: g,
  onTimeout: S
}) => {
  const x = xt(() => new Ai(), []), { t: E } = Ze("sqInputBirthday"), [k, R] = X(!1), [O, T] = X(null), [D, P] = X({
    value: v,
    error: "",
    dateObject: "",
    type: "date"
  }), N = (I) => {
    const C = x.ageLessThan(I, 18), U = x.ageOverThan(I, 100);
    let z = "";
    C ? z = E("ageUnder18") : U && (z = E("overThan100")), P((j) => ({ ...j, value: I, error: z })), g && typeof g == "function" && g(!z && !c), p && typeof p == "function" && p(I), S && typeof S == "function" && (S(!1), O && clearTimeout(O), T(
      setTimeout(() => {
        S(!0);
      }, Yx)
    ));
  };
  return ee(() => {
    D.value !== v && N(v);
  }, [v, D]), ee(() => () => {
    clearTimeout(O);
  }, [O]), /* @__PURE__ */ A.jsx(
    Kx,
    {
      label: n,
      value: v,
      name: h,
      id: d,
      className: f,
      type: m,
      requiredOnLoad: r,
      placeholder: w,
      onChange: N,
      onValidate: (I) => R(I),
      externalError: c || D.error,
      readOnly: t,
      autoComplete: u,
      required: a,
      disabled: e,
      errorSpan: s,
      errorIcon: l,
      leftLabel: y,
      rightLabel: b,
      backgroundColor: o
    }
  );
};
const Jx = 800, k2 = ({
  label: n,
  maxLength: e,
  disabled: t = !1,
  readOnly: s = !1,
  errorSpan: r = !0,
  loading: a,
  requiredOnLoad: c = !1,
  required: l,
  externalError: d,
  id: h,
  name: m,
  errorIcon: y = /* @__PURE__ */ A.jsx("i", { className: "fa-regular fa-exclamation-triangle" }),
  externalIcon: b,
  value: v = "",
  backgroundColor: w = "",
  className: o = "",
  type: u = "text",
  placeholder: f = "",
  onTimeout: p,
  onChange: g,
  onValidate: S
}) => {
  const { t: x } = Ze("sqInputDigits"), E = `random-id-${(1 + Date.now() + Math.random()).toString().replace(".", "")}`, [k, R] = X(null), [O, T] = X({
    value: v,
    error: "",
    validatedDocument: !1
  });
  ee(() => {
    v !== O.value && D(v);
  }, [O.value, v]), ee(() => () => {
    clearTimeout(k);
  }, [k]);
  const D = (P) => {
    var I;
    O.value = ((I = P == null ? void 0 : P.target) == null ? void 0 : I.value) || (P != null && P.length ? P : "");
    const N = new RegExp(/^[0-9]+$/);
    d ? (O.error = "", O.validatedDocument = !0) : l && (!O.value || O.value.length < 1) ? (O.error = x("required"), O.validatedDocument = !1) : O.value && !N.test(O.value) ? (O.error = x("invalid-number"), O.validatedDocument = !1) : (O.error = "", O.validatedDocument = !0), T({ ...O }), S && typeof S == "function" && S(!O.error && !d), g && typeof g == "function" && g(O.value), p && typeof p == "function" && (p(!1), k && clearTimeout(k), R(
      setTimeout(() => {
        p(!0);
      }, Jx)
    ));
  };
  return /* @__PURE__ */ A.jsxs("div", { className: `wrapper-all-inside-input ${o}`, children: [
    n ? /* @__PURE__ */ A.jsx("label", { className: `label ${d || O.error ? "error " : ""}`, htmlFor: h || E, children: n }) : null,
    /* @__PURE__ */ A.jsx("div", { className: `no-padding wrapper-input wrapper-input-squid ${d || O.error ? "error " : ""}`, children: /* @__PURE__ */ A.jsx(
      "input",
      {
        className: `col input ${s ? "readonly " : ""}${t ? "disabled " : ""}${a ? "loading " : ""}${d || O.error ? "error " : ""}${b ? "has-icon-external " : ""}`,
        style: {
          backgroundColor: w
        },
        id: h || E,
        type: u,
        inputMode: "numeric",
        maxLength: e,
        name: m || E,
        placeholder: f,
        value: O.value,
        required: l,
        disabled: t,
        readOnly: s || a,
        onChange: D
      }
    ) }),
    a ? /* @__PURE__ */ A.jsx(Et, { size: "small", className: `display-block loader-input ${n ? "" : "no-label"}`, style: { position: "absolute" } }) : null,
    b && !a ? /* @__PURE__ */ A.jsx("span", { className: `icon icon-external ${n ? "" : "no-label "}`, children: b }) : null,
    r ? /* @__PURE__ */ A.jsxs("div", { className: "box-validation box-invalid show ", children: [
      c && !O.value && !O.error && !d ? /* @__PURE__ */ A.jsxs("div", { children: [
        /* @__PURE__ */ A.jsx("i", { className: "fa-solid fa-diamond-triangle gold" }),
        x("globals:emptyField")
      ] }) : null,
      O.error || d ? y || /* @__PURE__ */ A.jsx("i", { className: "fa-regular fa-exclamation-triangle" }) : null,
      d || "",
      O.error && !d ? /* @__PURE__ */ A.jsx("span", { className: "message-error", dangerouslySetInnerHTML: { __html: O.error } }) : ""
    ] }) : null
  ] });
};
const Zx = 800, O2 = ({
  label: n,
  disabled: e = !1,
  readOnly: t = !1,
  errorSpan: s = !0,
  loading: r,
  requiredOnLoad: a = !1,
  required: c,
  externalError: l,
  id: d,
  name: h,
  errorIcon: m = /* @__PURE__ */ A.jsx("i", { className: "fa-regular fa-triangle-exclamation" }),
  externalIcon: y,
  value: b = "",
  backgroundColor: v = "",
  className: w = "",
  type: o = "text",
  onChange: u,
  onValidate: f,
  onTimeout: p
}) => {
  const g = `random-id-${(1 + Date.now() + Math.random()).toString().replace(".", "")}`, S = xt(() => new Ai(), []), { t: x } = Ze("sqInputDocumentCnpj"), [E, k] = X(null), [R, O] = X({
    value: "",
    error: "",
    validatedDocument: !1
  }), T = He((P) => {
    const N = P.replace(/[^\d]/g, ""), I = N.length;
    return I <= 5 ? P = N.replace(/(\d{2})(\d{1,3})/g, "$1.$2") : I <= 8 ? P = N.replace(/(\d{2})(\d{3})(\d{1,3})/g, "$1.$2.$3") : I <= 12 ? P = N.replace(/(\d{2})(\d{3})(\d{3})(\d{1,4})/g, "$1.$2.$3/$4") : P = N.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{1,2})/g, "$1.$2.$3/$4-$5"), P;
  }, []);
  ee(() => {
    R.value !== b && O((P) => ({
      ...P,
      value: T(b)
    }));
  }, [R.value, b, T]);
  const D = async (P) => {
    const N = P.target.value, I = { value: "", validatedDocument: !1, error: "" };
    I.value = N, O((U) => ({ ...U, value: T(I.value) }));
    const C = async () => {
      var U;
      l ? (I.error = "", I.validatedDocument = !0) : c && (!I.value || I.value.length < 1) ? (I.error = x("required"), I.validatedDocument = !1) : !S.cnpj(I.value.toString().replace(/\D/g, "")) || ((U = I == null ? void 0 : I.value) == null ? void 0 : U.replace(/[^0-9k]/gi, "").length) < 11 ? (I.error = x("invalidCnpj"), I.validatedDocument = !1) : (I.error = "", I.validatedDocument = !0), O((z) => ({ ...z, validatedDocument: I.validatedDocument, error: I.error })), f && typeof f == "function" && f(!I.error && !l && I.validatedDocument), u && typeof u == "function" && u(I.value);
    };
    p && typeof p == "function" ? (p(!1), E && clearTimeout(E), k(
      setTimeout(async () => {
        await C(), p(!0);
      }, Zx)
    )) : await C();
  };
  return /* @__PURE__ */ A.jsxs("div", { className: `wrapper-all-inside-input ${w}`, children: [
    n ? /* @__PURE__ */ A.jsx("label", { className: `label ${l || R.error ? "error " : ""}`, htmlFor: d || g, children: n }) : null,
    /* @__PURE__ */ A.jsx("div", { className: `no-padding wrapper-input wrapper-input-squid ${l || R.error ? "error " : ""}`, children: /* @__PURE__ */ A.jsx(
      "input",
      {
        className: `col input ${t ? "readonly " : ""}${e ? "disabled " : ""}${r ? "loading " : ""}${l || R.error ? "error " : ""}${y ? "has-icon-external " : ""}`,
        style: {
          backgroundColor: v
        },
        id: d || g,
        type: o,
        inputMode: "numeric",
        maxLength: 18,
        name: h || g,
        placeholder: "##.###.###/####-##",
        value: R.value,
        required: c,
        disabled: e,
        readOnly: t || r,
        onChange: D
      }
    ) }),
    r ? /* @__PURE__ */ A.jsx(Et, { size: "small", className: `display-block loader-input ${n ? "" : "no-label"}` }) : null,
    y && !r ? /* @__PURE__ */ A.jsx("span", { className: `icon icon-external ${n ? "" : "no-label "}`, children: y }) : null,
    s ? /* @__PURE__ */ A.jsxs("div", { className: "box-validation box-invalid show ", children: [
      a && !R.value && !R.error && !l ? /* @__PURE__ */ A.jsxs("div", { children: [
        /* @__PURE__ */ A.jsx("i", { className: "fa-solid fa-diamond-exclamation", style: { color: "var(--gold)" } }),
        x("globalPayments:emptyField")
      ] }) : null,
      R.error || l ? m || /* @__PURE__ */ A.jsx("i", { className: "fa-regular fa-triangle-exclamation" }) : null,
      l,
      R.error && !l ? /* @__PURE__ */ A.jsx("span", { className: "message-error", dangerouslySetInnerHTML: { __html: R.error } }) : ""
    ] }) : null
  ] });
};
const Qx = 800, T2 = ({
  label: n,
  disabled: e = !1,
  readOnly: t = !1,
  errorSpan: s = !0,
  loading: r,
  requiredOnLoad: a = !1,
  required: c,
  externalError: l,
  id: d,
  name: h,
  leftLabel: m,
  errorIcon: y = /* @__PURE__ */ A.jsx("i", { className: "fa-regular fa-exclamation-triangle" }),
  rightLabel: b,
  externalIcon: v,
  value: w = "",
  backgroundColor: o = "",
  isNew: u = !1,
  canRepeat: f = !1,
  originalValue: p,
  className: g = "",
  type: S = "text",
  onChange: x,
  onValidate: E,
  onTimeout: k
}) => {
  const R = `random-id-${(1 + Date.now() + Math.random()).toString().replace(".", "")}`, O = xt(() => new Ai(), []), [T, D] = X(null), [P, N] = X({
    value: w,
    error: "",
    validatedDocument: !1
  }), { t: I } = Ze("sqInputDocumentCpf"), C = (z) => {
    const j = z == null ? void 0 : z.replace(/[^\d]/g, ""), F = j == null ? void 0 : j.length;
    return F <= 6 ? z = j == null ? void 0 : j.replace(/(\d{3})(\d{1,3})/g, "$1.$2") : F <= 9 ? z = j == null ? void 0 : j.replace(/(\d{3})(\d{3})(\d{1,3})/g, "$1.$2.$3") : z = j == null ? void 0 : j.replace(/(\d{3})(\d{3})(\d{3})(\d{1,2})/g, "$1.$2.$3-$4"), z;
  }, U = async (z) => {
    const j = z.target.value, F = { value: "", validatedDocument: !1, error: "" };
    F.value = j, N((W) => ({ ...W, value: C(F.value) }));
    const q = async () => {
      var W;
      l ? (F.error = "", F.validatedDocument = !0) : c && (!F.value || F.value.length < 1) ? (F.error = I("required"), F.validatedDocument = !1) : !O.cpf(F.value.toString().replace(/\D/g, "")) || ((W = F == null ? void 0 : F.value) == null ? void 0 : W.replace(/[^0-9k]/gi, "").length) < 11 ? (F.error = I("invalidCPF"), F.validatedDocument = !1) : (F.error = "", F.validatedDocument = !0), N((K) => ({ ...K, validatedDocument: F.validatedDocument, error: F.error })), E && typeof E == "function" && E(!F.error && !l && F.validatedDocument), x && typeof x == "function" && x(F.value);
    };
    k && typeof k == "function" ? (k(!1), T && clearTimeout(T), D(
      setTimeout(async () => {
        await q(), k(!0);
      }, Qx)
    )) : await q();
  };
  return ee(() => {
    P.value && P.value.length < 11 ? (N((z) => ({ value: C(z.value), validatedDocument: !1, error: I("invalidCPF") })), E && typeof E == "function" && E(!1)) : N((z) => ({ ...z, value: C(z.value) }));
  }, [P.value]), ee(() => () => {
    clearTimeout(T);
  }, [T]), /* @__PURE__ */ A.jsxs("div", { className: `wrapper-all-inside-input ${g}`, children: [
    n ? /* @__PURE__ */ A.jsx("label", { className: `label ${l || P.error ? "error " : ""}`, htmlFor: d || R, children: n }) : null,
    /* @__PURE__ */ A.jsxs("div", { className: `no-padding wrapper-input wrapper-input-squid ${l || P.error ? "error " : ""}`, children: [
      m ? /* @__PURE__ */ A.jsx("span", { className: "input-group-text", children: m }) : null,
      /* @__PURE__ */ A.jsx(
        "input",
        {
          className: `col input ${t ? "readonly " : ""}${e ? "disabled " : ""}${r ? "loading " : ""}${!r && (l || P.error) ? "error " : ""}${v ? "has-icon-external " : ""}`,
          style: {
            backgroundColor: o
          },
          id: d || R,
          type: S,
          inputMode: "numeric",
          maxLength: 14,
          name: h || R,
          placeholder: "###.###.###-##",
          value: P.value,
          required: c,
          disabled: e,
          readOnly: t,
          onChange: U
        }
      ),
      b ? /* @__PURE__ */ A.jsx("span", { className: "input-group-text", children: b }) : null
    ] }),
    r ? /* @__PURE__ */ A.jsx(Et, { size: "small", className: `display-block loader-input ${n ? "" : "no-label"}`, style: { position: "absolute" } }) : null,
    v && !r ? /* @__PURE__ */ A.jsx("span", { className: `icon icon-external ${n ? "" : "no-label "}`, children: v }) : null,
    s ? /* @__PURE__ */ A.jsx("div", { className: "box-validation box-invalid show ", children: !r && /* @__PURE__ */ A.jsxs("div", { children: [
      a && !P.value && !P.error && !l ? /* @__PURE__ */ A.jsxs("div", { children: [
        /* @__PURE__ */ A.jsx("i", { className: "fa-solid fa-diamond-exclamation gold" }),
        I("globals:emptyField")
      ] }) : null,
      P.error || l ? y || /* @__PURE__ */ A.jsx("i", { className: "fa-regular fa-exclamation-triangle" }) : null,
      l || "",
      P.error && !l ? /* @__PURE__ */ A.jsx("span", { className: "message-error", dangerouslySetInnerHTML: { __html: P.error } }) : ""
    ] }) }) : null
  ] });
};
const Xx = 800, I2 = ({
  label: n,
  disabled: e = !1,
  readOnly: t = !1,
  errorSpan: s = !0,
  loading: r,
  required: a,
  externalError: c,
  id: l,
  name: d,
  errorIcon: h = /* @__PURE__ */ A.jsx("i", { className: "fa-regular fa-exclamation-triangle" }),
  leftLabel: m,
  rightLabel: y,
  externalIcon: b,
  originalValue: v,
  value: w = "",
  isNew: o = !1,
  placeholder: u,
  nationality: f,
  backgroundColor: p = "",
  className: g = "",
  requiredOnLoad: S = !1,
  onChange: x,
  onValidate: E,
  onTimeout: k
}) => {
  Re(void 0), X("");
  const R = `random-id-${(1 + Date.now() + Math.random()).toString().replace(".", "")}`, [O, T] = X(null), [D, P] = X({
    value: w,
    error: "",
    validatedDocument: !1
  }), { t: N } = Ze("sqInputDocumentInternational"), I = (U = "") => {
    if (U) {
      const z = /(?=(?:.*\d){3})^[aA-zZ\d]*$/gm, j = U.trim().toUpperCase();
      return !!z.test(j);
    }
  }, C = async (U) => {
    const z = U.target.value, j = { value: "", validatedDocument: !1, error: "" };
    j.value = z.toUpperCase(), P((q) => ({ ...q, value: j.value.toUpperCase() }));
    const F = async () => {
      c ? (j.error = "", j.validatedDocument = !0) : a && (!z || z.length < 1) ? (j.error = N("required"), j.validatedDocument = !1) : I(z) ? (j.error = "", j.validatedDocument = !0) : (j.error = N("invalidID"), j.validatedDocument = !1), P((q) => ({ ...q, validatedDocument: j.validatedDocument, error: j.error })), E && typeof E == "function" && E(!j.error && !c && j.validatedDocument), x && typeof x == "function" && x(j.value);
    };
    k && typeof k == "function" ? (k(!1), O && clearTimeout(O), T(
      setTimeout(async () => {
        await F(), k(!0);
      }, Xx)
    )) : F();
  };
  return ee(() => {
    D.value !== w && P((U) => ({ ...U, value: D.value.toUpperCase() }));
  }, [D.value, w]), ee(() => () => {
    clearTimeout(O);
  }, [O]), /* @__PURE__ */ A.jsxs("div", { className: `wrapper-all-inside-input ${g}`, children: [
    n ? /* @__PURE__ */ A.jsx("label", { className: `label ${c || D.error ? "error " : ""}`, htmlFor: l || R, children: n }) : null,
    /* @__PURE__ */ A.jsxs("div", { className: `no-padding wrapper-input wrapper-input-squid ${c || D.error ? "error " : ""}`, children: [
      m ? /* @__PURE__ */ A.jsx("span", { className: "input-group-text", children: m }) : null,
      /* @__PURE__ */ A.jsx(
        "input",
        {
          className: `col input ${t ? "readonly " : ""}${e ? "disabled " : ""}${r ? "loading " : ""}${!r && (c || D.error) ? "error " : ""}${b ? "has-icon-external " : ""}`,
          style: {
            backgroundColor: p
          },
          id: l || R,
          type: "text",
          name: d || R,
          placeholder: u || "",
          value: D.value,
          required: a,
          disabled: e,
          readOnly: t,
          onChange: C
        }
      ),
      y ? /* @__PURE__ */ A.jsx("span", { className: "input-group-text", children: y }) : null
    ] }),
    r ? /* @__PURE__ */ A.jsx(Et, { size: "small", className: `display-block loader-input ${n ? "" : "no-label"}`, style: { position: "absolute" } }) : null,
    b && !r ? /* @__PURE__ */ A.jsx("span", { className: `icon icon-external ${n ? "" : "no-label "}`, children: b }) : null,
    s ? /* @__PURE__ */ A.jsx("div", { className: "box-validation box-invalid show ", children: !r && /* @__PURE__ */ A.jsxs("div", { children: [
      S && !D.value && !D.error && !c ? /* @__PURE__ */ A.jsxs("div", { children: [
        /* @__PURE__ */ A.jsx("i", { className: "fa-solid fa-diamond-exclamation gold" }),
        N("globals:emptyField")
      ] }) : null,
      D.error || c ? h || /* @__PURE__ */ A.jsx("i", { className: "fa-regular fa-exclamation-triangle" }) : null,
      c || "",
      D.error && !c ? /* @__PURE__ */ A.jsx("span", { className: "message-error", dangerouslySetInnerHTML: { __html: D.error } }) : ""
    ] }) }) : null
  ] });
};
const _x = 800, U2 = ({
  label: n,
  disabled: e = !1,
  readOnly: t = !1,
  errorSpan: s = !0,
  loading: r,
  required: a,
  errorIcon: c,
  externalError: l,
  id: d,
  name: h,
  leftLabel: m,
  rightLabel: y,
  externalIcon: b,
  value: v = "",
  isNew: w = !1,
  originalValue: o,
  backgroundColor: u = "",
  className: f = "",
  requiredOnLoad: p = !1,
  onChange: g,
  onValidate: S,
  onTimeout: x
}) => {
  Re(void 0), X("");
  const E = `random-id-${(1 + Date.now() + Math.random()).toString().replace(".", "")}`, k = xt(() => new Ai(), []), [R, O] = X(null), [T, D] = X({
    value: v,
    error: "",
    validatedDocument: !1
  }), { t: P } = Ze("sqInputDocumentRut"), N = (U) => {
    const z = U.replace(/[^\dkK]/g, ""), j = z.length;
    return j <= 6 ? U = z.replace(/(\d{1})(\d{1,3})/g, "$1.$2") : j <= 7 ? U = z.replace(/(\d{1})(\d{3})(\d{1,3})/g, "$1.$2.$3") : U = z.replace(/(\d{1,2})(\d{3})(\d{3})([\dkK])/g, "$1.$2.$3-$4"), U;
  }, I = async (U) => {
    const z = { value: "", validatedDocument: !1, error: "" };
    z.value = U, D((F) => ({ ...F, value: N(z.value.toUpperCase()) }));
    const j = async () => {
      var F;
      l ? (z.error = "", z.validatedDocument = !0) : a && (!z.value || z.value.length < 1) ? (z.error = P("required"), z.validatedDocument = !1) : !k.Fn.validaRut(z.value) || ((F = z == null ? void 0 : z.value) == null ? void 0 : F.replace(/[^0-9k]/gi, "").length) < 8 ? (z.error = P("invalidRUT"), z.validatedDocument = !1) : (z.error = "", z.validatedDocument = !0), D((q) => ({ ...q, validatedDocument: z.validatedDocument, error: z.error })), S && typeof S == "function" && S(!z.error && !l && z.validatedDocument), g && typeof g == "function" && g(z.value);
    };
    x && typeof x == "function" ? (x(!1), R && clearTimeout(R), O(
      setTimeout(async () => {
        await j(), x(!0);
      }, _x)
    )) : await j();
  }, C = async (U) => {
    I(U.target.value);
  };
  return ee(() => {
    T.value && I(T.value);
  }, [T.value]), ee(() => () => {
    clearTimeout(R);
  }, [R]), /* @__PURE__ */ A.jsxs("div", { className: `wrapper-all-inside-input ${f}`, children: [
    n ? /* @__PURE__ */ A.jsx("label", { className: `label ${l || T.error ? "error " : ""}`, htmlFor: d || E, children: n }) : null,
    /* @__PURE__ */ A.jsxs("div", { className: `no-padding wrapper-input wrapper-input-squid ${l || T.error ? "error " : ""}`, children: [
      m ? /* @__PURE__ */ A.jsx("span", { className: "input-group-text", children: m }) : null,
      /* @__PURE__ */ A.jsx(
        "input",
        {
          className: `col input ${t ? "readonly " : ""}${e ? "disabled " : ""}${r ? "loading " : ""}${!r && (l || T.error) ? "error " : ""}${b ? "has-icon-external " : ""}`,
          style: {
            backgroundColor: u
          },
          id: d || E,
          type: "text",
          maxLength: 12,
          name: h || E,
          placeholder: "#.###.##-#",
          value: T.value,
          required: a,
          disabled: e,
          readOnly: t,
          onChange: C
        }
      ),
      y ? /* @__PURE__ */ A.jsx("span", { className: "input-group-text", children: y }) : null
    ] }),
    r ? /* @__PURE__ */ A.jsx(Et, { size: "small", className: `display-block loader-input ${n ? "" : "no-label"}`, style: { position: "absolute" } }) : null,
    b && !r ? /* @__PURE__ */ A.jsx("span", { className: `icon icon-external ${n ? "" : "no-label "}`, children: b }) : null,
    s ? /* @__PURE__ */ A.jsx("div", { className: "box-validation box-invalid show ", children: !r && /* @__PURE__ */ A.jsxs("div", { children: [
      p && !T.value && !T.error && !l ? /* @__PURE__ */ A.jsxs("div", { children: [
        /* @__PURE__ */ A.jsx("i", { className: "fa-solid fa-diamond-exclamation gold" }),
        P("globals:emptyField")
      ] }) : null,
      T.error || l ? c || /* @__PURE__ */ A.jsx("i", { className: "fa-regular fa-exclamation-triangle" }) : null,
      l || "",
      T.error && !l ? /* @__PURE__ */ A.jsx("span", { className: "message-error", dangerouslySetInnerHTML: { __html: T.error } }) : ""
    ] }) }) : null
  ] });
};
class ra {
  compareObjects(e, t) {
    if (e === t)
      return !0;
    if (!(e instanceof Object) || !(t instanceof Object) || e.constructor !== t.constructor)
      return !1;
    for (const s in e)
      if (e.hasOwnProperty(s)) {
        if (!t.hasOwnProperty(s))
          return !1;
        if (e[s] !== t[s] && (typeof e[s] != "object" || !this.compareObjects(e[s], t[s])))
          return !1;
      }
    for (const s in t)
      if (t.hasOwnProperty(s) && !e.hasOwnProperty(s))
        return !1;
    return !0;
  }
  compareArrays(e, t) {
    if (!e || !t)
      return !1;
    if (e === t)
      return !0;
    if (e.length != t.length)
      return !1;
    for (let s = 0, r = e.length; s < r; s++)
      if (e[s] instanceof Array && t[s] instanceof Array) {
        if (!e[s].equals(t[s]))
          return !1;
      } else if (e[s] != t[s])
        return !1;
    return !0;
  }
  sumPerKey(e, t) {
    return e.reduce((s, r) => s + (r[t] || 0), 0);
  }
  sumPerKeyList(e, t) {
    let s = 0;
    for (const r of t)
      s += e[r] || 0;
    return s;
  }
  parseQueryStringToObject(e = "") {
    e = e.startsWith("?") ? e.substring(1) : e;
    const t = {}, s = e.split("&");
    for (const r of s) {
      const a = r.split("=");
      t[decodeURIComponent(a[0])] = decodeURIComponent(a[1] || "");
    }
    return t;
  }
  getProperty(e, t, s = !0) {
    return e != null && e[t] ? e[t] : s ? 0 : null;
  }
  arraysMatch(e, t) {
    if (e.length !== t.length)
      return !1;
    for (let s = 0; s < e.length; s++)
      if (e[s] !== t[s])
        return !1;
    return !0;
  }
  arraySum(e) {
    let t = 0;
    for (const s of e)
      t += s;
    return t;
  }
  getArrayDiff(e = [], t = []) {
    return e.filter((s) => !t.includes(s)).concat(t.filter((s) => !e.includes(s)));
  }
  getObjectArrayDiff(e, t) {
    return (s) => e.filter((r) => r[t] ? r[t] === s[t] : !1).length === 0;
  }
}
const $x = ({
  className: n = "",
  id: e = "",
  name: t = "",
  label: s = "",
  disabled: r = !1,
  errorSpan: a = !0,
  loading: c = !1,
  required: l = !1,
  externalError: d = "",
  errorIcon: h = "",
  value: m = "",
  placeholder: y = "",
  textColor: b = "var(--secondary_color)",
  backgroundColor: v = "var(--primary_color)",
  borderColor: w = "var(--primary_color)",
  accept: o = "*.*",
  maxFileSize: u = null,
  multiple: f = !1,
  onChange: p,
  onValidate: g,
  children: S,
  showButton: x = !0,
  requiredOnLoad: E = !1,
  buttonStyle: k,
  buttonInverted: R = !1,
  buttonInvertedHover: O = !1,
  buttonRounded: T = !1,
  buttonSize: D,
  showFileName: P = !0
}) => {
  var M, te;
  const N = `random-id-${(1 + Date.now() + Math.random()).toString().replace(".", "")}`, I = new Cu(), C = new ra(), [U, z] = X({
    value: [],
    error: ""
  }), [j, F] = X(!1), { t: q } = Ze(), W = (ce) => I == null ? void 0 : I.lightenDarkenColor(I == null ? void 0 : I.getCssVariableValue(ce), -50), K = () => W(O ? b : v), Q = () => W(O ? v !== "transparent" ? v : "var(--white-html)" : b !== "transparent" ? b : "var(--white-html)"), G = (ce) => {
    var he;
    if (U.value = ((he = ce == null ? void 0 : ce.target) == null ? void 0 : he.files) || ce || [], d)
      U.error = "";
    else if (l && (!U.value || U.value.length < 1) && U.value !== 0)
      U.error = "required";
    else if (u && u > 0) {
      let Ue = 0;
      for (const $ of U.value)
        $.size > u && Ue++;
      Ue > 0 ? U.error = "fileSize" : U.error = "";
    } else
      U.error = "";
    z({ ...U }), g && typeof g == "function" && g(!U.error && !d), p && typeof p == "function" && p(U.value);
  };
  return ee(() => {
    m && !C.compareObjects(m, U == null ? void 0 : U.value) && G(m);
  }, [m, U.value, C]), /* @__PURE__ */ A.jsxs("div", { className: `wrapper-all-inside-input ${n}`, children: [
    s ? /* @__PURE__ */ A.jsx("label", { className: "label", htmlFor: e || N, children: s }) : null,
    /* @__PURE__ */ A.jsx(
      "input",
      {
        id: e || N,
        name: t || N,
        type: "file",
        className: "input-file",
        accept: o,
        onChange: G,
        multiple: f,
        disabled: r || c
      }
    ),
    x ? /* @__PURE__ */ A.jsxs(
      "label",
      {
        htmlFor: e || N,
        onMouseOver: () => F(!0),
        onMouseLeave: () => F(!1),
        onFocus: () => null,
        className: `button button-${v} ${T ? "rounded " : ""}${R ? "inverted " : ""}${D ? `button-${D} ` : ""}${r ? "disabled " : ""}${c ? "loading " : ""}${n}`,
        style: {
          backgroundColor: j ? K() : v,
          borderColor: j ? W(w || b) : w || b,
          color: j ? Q() : b,
          ...k
        },
        children: [
          y,
          c ? /* @__PURE__ */ A.jsx(Et, { className: "ml-3", size: "small", color: v, style: { position: "absolute" } }) : null
        ]
      }
    ) : null,
    S ? /* @__PURE__ */ A.jsx("label", { htmlFor: e || N, className: "children", children: S }) : null,
    a ? /* @__PURE__ */ A.jsxs("div", { className: "box-validation box-invalid show ", children: [
      E && !U.value && !U.error && !d ? /* @__PURE__ */ A.jsxs("div", { children: [
        /* @__PURE__ */ A.jsx("i", { className: "fa-solid-fa-diamond-exclamation gold" }),
        q("emptyField")
      ] }) : null,
      U.error || d ? h || /* @__PURE__ */ A.jsx("i", { className: "fa-regular fa-exclamation-triangle" }) : null,
      d || "",
      U.error && !d ? U.error : ""
    ] }) : null,
    P ? /* @__PURE__ */ A.jsx("div", { className: "file-name", children: ((M = U == null ? void 0 : U.value) == null ? void 0 : M.length) > 0 ? /* @__PURE__ */ A.jsxs(A.Fragment, { children: [
      /* @__PURE__ */ A.jsxs("span", { children: [
        q("selectedFiles"),
        ":"
      ] }),
      /* @__PURE__ */ A.jsx("ul", { children: (te = Array.from(U == null ? void 0 : U.value)) == null ? void 0 : te.map((ce, he) => /* @__PURE__ */ A.jsx("li", { children: ce == null ? void 0 : ce.name }, he)) })
    ] }) : null }) : null
  ] });
};
const z2 = ({
  className: n = "",
  id: e = "",
  name: t = "",
  label: s = "",
  disabled: r = !1,
  errorSpan: a = !0,
  loading: c = !1,
  required: l = !1,
  externalError: d = "",
  errorIcon: h = "",
  value: m = "",
  maxFileSize: y = null,
  onChange: b,
  onValidate: v,
  showFileName: w = !1,
  resolution: o,
  mediaUrl: u = "",
  multiple: f = !1
}) => {
  var O;
  const p = `random-id-${(1 + Date.now() + Math.random()).toString().replace(".", "")}`, [g] = Ze(""), S = new ra(), [x, E] = X([]), k = He(
    (T) => {
      var P;
      const D = ((P = T == null ? void 0 : T.target) == null ? void 0 : P.files) || T || [];
      E(D), b && typeof b == "function" && b(D);
    },
    [b]
  ), R = He((T) => {
    let D;
    try {
      D = new URL(T);
    } catch {
      return !1;
    }
    return D.protocol === "http:" || D.protocol === "https:";
  }, []);
  return ee(() => {
    m && !S.compareObjects(m, x) && k(m);
  }, [m, x, S]), ee(() => {
    u && R(u) && k([
      {
        name: u == null ? void 0 : u.substring((u == null ? void 0 : u.lastIndexOf("/")) + 1),
        type: "image/jpeg",
        url: u
      }
    ]);
  }, [u]), /* @__PURE__ */ A.jsx(
    $x,
    {
      value: x,
      disabled: r,
      loading: c,
      required: l,
      showFileName: w,
      maxFileSize: y,
      externalError: d,
      errorIcon: h,
      errorSpan: a,
      name: p || t,
      id: p || e,
      className: n,
      accept: "image/*, video/*",
      showButton: !1,
      onValidate: v,
      onChange: k,
      multiple: f,
      children: /* @__PURE__ */ A.jsx("div", { className: "wrapper-input-media", children: (x == null ? void 0 : x.length) > 0 ? /* @__PURE__ */ A.jsxs("div", { className: "wrapper-input-media-medias", children: [
        /* @__PURE__ */ A.jsx("span", { className: "change-icon", children: /* @__PURE__ */ A.jsx("i", { className: "fa-regular fa-arrows-repeat" }) }),
        (O = Array.from(x)) == null ? void 0 : O.map((T, D) => {
          var P, N;
          return (P = T == null ? void 0 : T.type) != null && P.includes("image") ? /* @__PURE__ */ A.jsxs("figure", { className: "wrapper-input-media-media", children: [
            /* @__PURE__ */ A.jsx("img", { className: "image img-fluid", src: (T == null ? void 0 : T.url) || URL.createObjectURL(T), alt: T == null ? void 0 : T.name, title: T == null ? void 0 : T.name }),
            /* @__PURE__ */ A.jsx("legend", { className: "legend", children: T == null ? void 0 : T.name })
          ] }, D) : (N = T == null ? void 0 : T.type) != null && N.includes("video") ? /* @__PURE__ */ A.jsxs("div", { className: "wrapper-input-media-media", children: [
            /* @__PURE__ */ A.jsx("video", { className: "video img-fluid", src: (T == null ? void 0 : T.url) || URL.createObjectURL(T), title: T == null ? void 0 : T.name }),
            /* @__PURE__ */ A.jsx("legend", { className: "legend", children: T == null ? void 0 : T.name })
          ] }, D) : /* @__PURE__ */ A.jsx("div", { className: "wrapper-input-media-text", children: T == null ? void 0 : T.name }, D);
        })
      ] }) : /* @__PURE__ */ A.jsxs("div", { className: "wrapper-input-media-texts", children: [
        /* @__PURE__ */ A.jsx("i", { className: "fa-light fa-image icon-media" }),
        /* @__PURE__ */ A.jsx("p", { children: s || g("mediaLabel") }),
        o != null && o.width && (o != null && o.height) ? /* @__PURE__ */ A.jsx("span", { children: g("resolution", { width: o == null ? void 0 : o.width, height: o == null ? void 0 : o.height }) }) : null
      ] }) })
    }
  );
}, eS = 800, R2 = ({
  label: n,
  disabled: e = !1,
  readOnly: t = !1,
  errorSpan: s = !0,
  maxLength: r,
  loading: a,
  required: c,
  externalError: l,
  id: d,
  name: h,
  leftLabel: m,
  rightLabel: y,
  externalIcon: b,
  errorIcon: v,
  value: w = "",
  placeholder: o,
  min: u,
  max: f,
  backgroundColor: p = "",
  autoComplete: g = "off",
  className: S = "",
  onChange: x,
  onValidate: E,
  onTimeout: k,
  requiredOnLoad: R = !1
}) => {
  const O = xt(() => new Ai(), []), [T, D] = X(!1), [P, N] = X(null), [I, C] = X({
    value: w,
    error: ""
  }), { t: U } = Ze("sqInputName"), z = (j) => {
    let F = "";
    !j || j === "" || j.length < 1 ? F = U("required") : O.nameSpecialChars(j) ? O.fullName(j) || (F = U("fullNameRequired")) : F = U("nameSpecialChars"), C((q) => ({ ...q, value: j, error: F })), E && typeof E == "function" && E(!F && !l), x && typeof x == "function" && x(j), k && typeof k == "function" && (k(!1), P && clearTimeout(P), N(
      setTimeout(() => {
        k(!0);
      }, eS)
    ));
  };
  return ee(() => {
    I.value !== w && z(w);
  }, [w, I]), ee(() => () => {
    clearTimeout(P);
  }, [P]), /* @__PURE__ */ A.jsx(
    sa,
    {
      label: n,
      value: w,
      className: S,
      placeholder: o,
      name: h,
      id: d,
      onChange: z,
      onValidate: (j) => D(j),
      externalError: l || I.error,
      readOnly: t,
      autoComplete: g,
      required: c,
      disabled: e,
      errorSpan: s,
      leftLabel: m,
      requiredOnLoad: R,
      errorIcon: v,
      rightLabel: y,
      backgroundColor: p,
      maxLength: r,
      loading: a,
      type: "text",
      externalIcon: b,
      min: u,
      max: f
    }
  );
};
const tS = 800, P2 = ({
  label: n,
  disabled: e = !1,
  readOnly: t = !1,
  errorSpan: s = !0,
  required: r,
  externalError: a,
  id: c,
  name: l,
  leftLabel: d,
  rightLabel: h,
  errorIcon: m,
  value: y = "",
  placeholder: b,
  showValidation: v,
  backgroundColor: w = "",
  autoComplete: o = "off",
  className: u = "",
  requiredOnLoad: f = !1,
  onChange: p,
  onValidate: g,
  onTimeout: S
}) => {
  var I;
  const { t: x } = Ze(), E = `random-id-${(1 + Date.now() + Math.random()).toString().replace(".", "")}`, [k, R] = X(null), [O, T] = X({
    value: y,
    error: "",
    type: "password",
    labelRules: []
  }), D = He(() => ({
    lessThanEight: (C) => ({
      message: x("fields.password.lessThanEight"),
      type: C.length < 8 ? "error" : "success"
    }),
    noNumber: (C) => ({
      message: x("fields.password.noNumber"),
      type: C.split("").some((U) => /[0-9]/.test(U)) ? "success" : "error"
    }),
    noUppercase: (C) => ({
      message: x("fields.password.noUppercase"),
      type: C.split("").some((U) => /[A-Z]/.test(U)) ? "success" : "error"
    }),
    noLowercase: (C) => ({
      message: x("fields.password.noLowercase"),
      type: C.split("").some((U) => /[a-z]/.test(U)) ? "success" : "error"
    })
  }), [x]), P = He(
    (C) => {
      let U = [];
      const z = D();
      for (const j in z)
        U = [...U, z[j](C)];
      return C.length === 0 && (U = []), U;
    },
    [D]
  ), N = (C) => {
    var z;
    O.value = ((z = C == null ? void 0 : C.target) == null ? void 0 : z.value) || (C != null && C.length ? C : ""), a ? O.error = "" : r && (!O.value || O.value.length < 1) ? O.error = x("required") : O.error = "";
    const U = P(O.value);
    O.labelRules = U, T({ ...O }), g && typeof g == "function" && g(v ? !O.error && !a && O.labelRules.filter(({ type: j }) => j === "error").length === 0 : !O.error && !a), p && typeof p == "function" && p(O.value), S && typeof S == "function" && (S(!1), k && clearTimeout(k), R(
      setTimeout(() => {
        S(!0);
      }, tS)
    ));
  };
  return ee(() => {
    O.value !== y && N(y);
  }, [y, O]), ee(() => () => {
    clearTimeout(k);
  }, [k]), /* @__PURE__ */ A.jsxs("div", { className: `wrapper-all-inside-input password-input ${u}`, children: [
    n ? /* @__PURE__ */ A.jsx("label", { className: `label ${a || O.error ? "error " : ""}`, htmlFor: c || E, children: n }) : null,
    /* @__PURE__ */ A.jsxs("div", { className: `no-padding wrapper-input wrapper-input-squid ${a || O.error ? "error " : ""}`, children: [
      d ? /* @__PURE__ */ A.jsx("span", { className: "input-group-text", children: d }) : null,
      /* @__PURE__ */ A.jsx(
        "input",
        {
          className: `col input ${t ? "readonly " : ""}${e ? "disabled " : ""}${a || O.error ? "error " : ""}`,
          style: {
            backgroundColor: w
          },
          id: c || E,
          type: O.type,
          name: l || E,
          placeholder: b || "",
          value: O.value,
          required: r,
          disabled: e,
          readOnly: t,
          onChange: N,
          autoComplete: o
        }
      ),
      h ? /* @__PURE__ */ A.jsx("span", { className: "input-group-text", children: h }) : null
    ] }),
    /* @__PURE__ */ A.jsx(
      "button",
      {
        className: `button-show-password ${n ? "" : "no-label"}`,
        type: "button",
        title: O.type === "password" ? x("showPassword") : x("hidenPassword"),
        onClick: () => T({ ...O, type: O.type === "password" ? "text" : "password" }),
        children: O.type === "password" ? /* @__PURE__ */ A.jsx("i", { className: "fa-regular fa-eye" }) : /* @__PURE__ */ A.jsx("i", { className: "fa-regular fa-eye-slash" })
      }
    ),
    s ? /* @__PURE__ */ A.jsxs("div", { className: "box-validation box-invalid show", children: [
      f && !O.value && !O.error && !a ? /* @__PURE__ */ A.jsxs("div", { children: [
        /* @__PURE__ */ A.jsx("i", { className: "fa-solid fa-diamond-exclamation gold" }),
        x("emptyField")
      ] }) : null,
      O.error || a ? m || /* @__PURE__ */ A.jsx("i", { className: "fa-regular fa-exclamation-triangle" }) : null,
      a || "",
      v ? (I = O.labelRules) == null ? void 0 : I.map(({ message: C, type: U }, z) => /* @__PURE__ */ A.jsxs("p", { className: "rules-validations", children: [
        U === "success" ? /* @__PURE__ */ A.jsx("i", { className: "fa-regular fa-check green" }) : /* @__PURE__ */ A.jsx("i", { className: "fa-regular fa-times red" }),
        C
      ] }, z)) : null,
      O.error && !a ? O.error : ""
    ] }) : null
  ] });
};
var iS = function(n) {
  var e = {};
  function t(s) {
    if (e[s])
      return e[s].exports;
    var r = e[s] = { i: s, l: !1, exports: {} };
    return n[s].call(r.exports, r, r.exports, t), r.l = !0, r.exports;
  }
  return t.m = n, t.c = e, t.d = function(s, r, a) {
    t.o(s, r) || Object.defineProperty(s, r, { enumerable: !0, get: a });
  }, t.r = function(s) {
    typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(s, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(s, "__esModule", { value: !0 });
  }, t.t = function(s, r) {
    if (1 & r && (s = t(s)), 8 & r || 4 & r && typeof s == "object" && s && s.__esModule)
      return s;
    var a = /* @__PURE__ */ Object.create(null);
    if (t.r(a), Object.defineProperty(a, "default", { enumerable: !0, value: s }), 2 & r && typeof s != "string")
      for (var c in s)
        t.d(a, c, (function(l) {
          return s[l];
        }).bind(null, c));
    return a;
  }, t.n = function(s) {
    var r = s && s.__esModule ? function() {
      return s.default;
    } : function() {
      return s;
    };
    return t.d(r, "a", r), r;
  }, t.o = function(s, r) {
    return Object.prototype.hasOwnProperty.call(s, r);
  }, t.p = "", t(t.s = 9);
}([function(n, e) {
  n.exports = Fe;
}, function(n, e, t) {
  var s;
  /*!
    Copyright (c) 2017 Jed Watson.
    Licensed under the MIT License (MIT), see
    http://jedwatson.github.io/classnames
  */
  (function() {
    var r = {}.hasOwnProperty;
    function a() {
      for (var c = [], l = 0; l < arguments.length; l++) {
        var d = arguments[l];
        if (d) {
          var h = typeof d;
          if (h === "string" || h === "number")
            c.push(d);
          else if (Array.isArray(d) && d.length) {
            var m = a.apply(null, d);
            m && c.push(m);
          } else if (h === "object")
            for (var y in d)
              r.call(d, y) && d[y] && c.push(y);
        }
      }
      return c.join(" ");
    }
    n.exports ? (a.default = a, n.exports = a) : (s = (function() {
      return a;
    }).apply(e, [])) === void 0 || (n.exports = s);
  })();
}, function(n, e, t) {
  (function(s) {
    var r = /^\s+|\s+$/g, a = /^[-+]0x[0-9a-f]+$/i, c = /^0b[01]+$/i, l = /^0o[0-7]+$/i, d = parseInt, h = typeof s == "object" && s && s.Object === Object && s, m = typeof self == "object" && self && self.Object === Object && self, y = h || m || Function("return this")(), b = Object.prototype.toString, v = y.Symbol, w = v ? v.prototype : void 0, o = w ? w.toString : void 0;
    function u(S) {
      if (typeof S == "string")
        return S;
      if (p(S))
        return o ? o.call(S) : "";
      var x = S + "";
      return x == "0" && 1 / S == -1 / 0 ? "-0" : x;
    }
    function f(S) {
      var x = typeof S;
      return !!S && (x == "object" || x == "function");
    }
    function p(S) {
      return typeof S == "symbol" || function(x) {
        return !!x && typeof x == "object";
      }(S) && b.call(S) == "[object Symbol]";
    }
    function g(S) {
      return S ? (S = function(x) {
        if (typeof x == "number")
          return x;
        if (p(x))
          return NaN;
        if (f(x)) {
          var E = typeof x.valueOf == "function" ? x.valueOf() : x;
          x = f(E) ? E + "" : E;
        }
        if (typeof x != "string")
          return x === 0 ? x : +x;
        x = x.replace(r, "");
        var k = c.test(x);
        return k || l.test(x) ? d(x.slice(2), k ? 2 : 8) : a.test(x) ? NaN : +x;
      }(S)) === 1 / 0 || S === -1 / 0 ? 17976931348623157e292 * (S < 0 ? -1 : 1) : S == S ? S : 0 : S === 0 ? S : 0;
    }
    n.exports = function(S, x, E) {
      var k, R, O, T;
      return S = (k = S) == null ? "" : u(k), R = function(D) {
        var P = g(D), N = P % 1;
        return P == P ? N ? P - N : P : 0;
      }(E), O = 0, T = S.length, R == R && (T !== void 0 && (R = R <= T ? R : T), O !== void 0 && (R = R >= O ? R : O)), E = R, x = u(x), S.slice(E, E + x.length) == x;
    };
  }).call(this, t(3));
}, function(n, e) {
  var t;
  t = function() {
    return this;
  }();
  try {
    t = t || new Function("return this")();
  } catch {
    typeof window == "object" && (t = window);
  }
  n.exports = t;
}, function(n, e, t) {
  (function(s) {
    var r = /^\[object .+?Constructor\]$/, a = typeof s == "object" && s && s.Object === Object && s, c = typeof self == "object" && self && self.Object === Object && self, l = a || c || Function("return this")(), d, h = Array.prototype, m = Function.prototype, y = Object.prototype, b = l["__core-js_shared__"], v = (d = /[^.]+$/.exec(b && b.keys && b.keys.IE_PROTO || "")) ? "Symbol(src)_1." + d : "", w = m.toString, o = y.hasOwnProperty, u = y.toString, f = RegExp("^" + w.call(o).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), p = h.splice, g = D(l, "Map"), S = D(Object, "create");
    function x(I) {
      var C = -1, U = I ? I.length : 0;
      for (this.clear(); ++C < U; ) {
        var z = I[C];
        this.set(z[0], z[1]);
      }
    }
    function E(I) {
      var C = -1, U = I ? I.length : 0;
      for (this.clear(); ++C < U; ) {
        var z = I[C];
        this.set(z[0], z[1]);
      }
    }
    function k(I) {
      var C = -1, U = I ? I.length : 0;
      for (this.clear(); ++C < U; ) {
        var z = I[C];
        this.set(z[0], z[1]);
      }
    }
    function R(I, C) {
      for (var U, z, j = I.length; j--; )
        if ((U = I[j][0]) === (z = C) || U != U && z != z)
          return j;
      return -1;
    }
    function O(I) {
      return !(!N(I) || (C = I, v && v in C)) && (function(U) {
        var z = N(U) ? u.call(U) : "";
        return z == "[object Function]" || z == "[object GeneratorFunction]";
      }(I) || function(U) {
        var z = !1;
        if (U != null && typeof U.toString != "function")
          try {
            z = !!(U + "");
          } catch {
          }
        return z;
      }(I) ? f : r).test(function(U) {
        if (U != null) {
          try {
            return w.call(U);
          } catch {
          }
          try {
            return U + "";
          } catch {
          }
        }
        return "";
      }(I));
      var C;
    }
    function T(I, C) {
      var U, z, j = I.__data__;
      return ((z = typeof (U = C)) == "string" || z == "number" || z == "symbol" || z == "boolean" ? U !== "__proto__" : U === null) ? j[typeof C == "string" ? "string" : "hash"] : j.map;
    }
    function D(I, C) {
      var U = function(z, j) {
        return z == null ? void 0 : z[j];
      }(I, C);
      return O(U) ? U : void 0;
    }
    function P(I, C) {
      if (typeof I != "function" || C && typeof C != "function")
        throw new TypeError("Expected a function");
      var U = function() {
        var z = arguments, j = C ? C.apply(this, z) : z[0], F = U.cache;
        if (F.has(j))
          return F.get(j);
        var q = I.apply(this, z);
        return U.cache = F.set(j, q), q;
      };
      return U.cache = new (P.Cache || k)(), U;
    }
    function N(I) {
      var C = typeof I;
      return !!I && (C == "object" || C == "function");
    }
    x.prototype.clear = function() {
      this.__data__ = S ? S(null) : {};
    }, x.prototype.delete = function(I) {
      return this.has(I) && delete this.__data__[I];
    }, x.prototype.get = function(I) {
      var C = this.__data__;
      if (S) {
        var U = C[I];
        return U === "__lodash_hash_undefined__" ? void 0 : U;
      }
      return o.call(C, I) ? C[I] : void 0;
    }, x.prototype.has = function(I) {
      var C = this.__data__;
      return S ? C[I] !== void 0 : o.call(C, I);
    }, x.prototype.set = function(I, C) {
      return this.__data__[I] = S && C === void 0 ? "__lodash_hash_undefined__" : C, this;
    }, E.prototype.clear = function() {
      this.__data__ = [];
    }, E.prototype.delete = function(I) {
      var C = this.__data__, U = R(C, I);
      return !(U < 0) && (U == C.length - 1 ? C.pop() : p.call(C, U, 1), !0);
    }, E.prototype.get = function(I) {
      var C = this.__data__, U = R(C, I);
      return U < 0 ? void 0 : C[U][1];
    }, E.prototype.has = function(I) {
      return R(this.__data__, I) > -1;
    }, E.prototype.set = function(I, C) {
      var U = this.__data__, z = R(U, I);
      return z < 0 ? U.push([I, C]) : U[z][1] = C, this;
    }, k.prototype.clear = function() {
      this.__data__ = { hash: new x(), map: new (g || E)(), string: new x() };
    }, k.prototype.delete = function(I) {
      return T(this, I).delete(I);
    }, k.prototype.get = function(I) {
      return T(this, I).get(I);
    }, k.prototype.has = function(I) {
      return T(this, I).has(I);
    }, k.prototype.set = function(I, C) {
      return T(this, I).set(I, C), this;
    }, P.Cache = k, n.exports = P;
  }).call(this, t(3));
}, function(n, e, t) {
  (function(s) {
    var r = /^\s+|\s+$/g, a = /^[-+]0x[0-9a-f]+$/i, c = /^0b[01]+$/i, l = /^0o[0-7]+$/i, d = parseInt, h = typeof s == "object" && s && s.Object === Object && s, m = typeof self == "object" && self && self.Object === Object && self, y = h || m || Function("return this")(), b = Object.prototype.toString, v = Math.max, w = Math.min, o = function() {
      return y.Date.now();
    };
    function u(p) {
      var g = typeof p;
      return !!p && (g == "object" || g == "function");
    }
    function f(p) {
      if (typeof p == "number")
        return p;
      if (function(x) {
        return typeof x == "symbol" || function(E) {
          return !!E && typeof E == "object";
        }(x) && b.call(x) == "[object Symbol]";
      }(p))
        return NaN;
      if (u(p)) {
        var g = typeof p.valueOf == "function" ? p.valueOf() : p;
        p = u(g) ? g + "" : g;
      }
      if (typeof p != "string")
        return p === 0 ? p : +p;
      p = p.replace(r, "");
      var S = c.test(p);
      return S || l.test(p) ? d(p.slice(2), S ? 2 : 8) : a.test(p) ? NaN : +p;
    }
    n.exports = function(p, g, S) {
      var x, E, k, R, O, T, D = 0, P = !1, N = !1, I = !0;
      if (typeof p != "function")
        throw new TypeError("Expected a function");
      function C(W) {
        var K = x, Q = E;
        return x = E = void 0, D = W, R = p.apply(Q, K);
      }
      function U(W) {
        return D = W, O = setTimeout(j, g), P ? C(W) : R;
      }
      function z(W) {
        var K = W - T;
        return T === void 0 || K >= g || K < 0 || N && W - D >= k;
      }
      function j() {
        var W = o();
        if (z(W))
          return F(W);
        O = setTimeout(j, function(K) {
          var Q = g - (K - T);
          return N ? w(Q, k - (K - D)) : Q;
        }(W));
      }
      function F(W) {
        return O = void 0, I && x ? C(W) : (x = E = void 0, R);
      }
      function q() {
        var W = o(), K = z(W);
        if (x = arguments, E = this, T = W, K) {
          if (O === void 0)
            return U(T);
          if (N)
            return O = setTimeout(j, g), C(T);
        }
        return O === void 0 && (O = setTimeout(j, g)), R;
      }
      return g = f(g) || 0, u(S) && (P = !!S.leading, k = (N = "maxWait" in S) ? v(f(S.maxWait) || 0, g) : k, I = "trailing" in S ? !!S.trailing : I), q.cancel = function() {
        O !== void 0 && clearTimeout(O), D = 0, x = T = E = O = void 0;
      }, q.flush = function() {
        return O === void 0 ? R : F(o());
      }, q;
    };
  }).call(this, t(3));
}, function(n, e, t) {
  (function(s, r) {
    var a = "[object Arguments]", c = "[object Map]", l = "[object Object]", d = "[object Set]", h = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, m = /^\w*$/, y = /^\./, b = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, v = /\\(\\)?/g, w = /^\[object .+?Constructor\]$/, o = /^(?:0|[1-9]\d*)$/, u = {};
    u["[object Float32Array]"] = u["[object Float64Array]"] = u["[object Int8Array]"] = u["[object Int16Array]"] = u["[object Int32Array]"] = u["[object Uint8Array]"] = u["[object Uint8ClampedArray]"] = u["[object Uint16Array]"] = u["[object Uint32Array]"] = !0, u[a] = u["[object Array]"] = u["[object ArrayBuffer]"] = u["[object Boolean]"] = u["[object DataView]"] = u["[object Date]"] = u["[object Error]"] = u["[object Function]"] = u[c] = u["[object Number]"] = u[l] = u["[object RegExp]"] = u[d] = u["[object String]"] = u["[object WeakMap]"] = !1;
    var f = typeof s == "object" && s && s.Object === Object && s, p = typeof self == "object" && self && self.Object === Object && self, g = f || p || Function("return this")(), S = e && !e.nodeType && e, x = S && typeof r == "object" && r && !r.nodeType && r, E = x && x.exports === S && f.process, k = function() {
      try {
        return E && E.binding("util");
      } catch {
      }
    }(), R = k && k.isTypedArray;
    function O(L, H, J, _) {
      var me = -1, fe = L ? L.length : 0;
      for (_ && fe && (J = L[++me]); ++me < fe; )
        J = H(J, L[me], me, L);
      return J;
    }
    function T(L, H) {
      for (var J = -1, _ = L ? L.length : 0; ++J < _; )
        if (H(L[J], J, L))
          return !0;
      return !1;
    }
    function D(L, H, J, _, me) {
      return me(L, function(fe, ke, Qe) {
        J = _ ? (_ = !1, fe) : H(J, fe, ke, Qe);
      }), J;
    }
    function P(L) {
      var H = !1;
      if (L != null && typeof L.toString != "function")
        try {
          H = !!(L + "");
        } catch {
        }
      return H;
    }
    function N(L) {
      var H = -1, J = Array(L.size);
      return L.forEach(function(_, me) {
        J[++H] = [me, _];
      }), J;
    }
    function I(L) {
      var H = -1, J = Array(L.size);
      return L.forEach(function(_) {
        J[++H] = _;
      }), J;
    }
    var C, U, z, j = Array.prototype, F = Function.prototype, q = Object.prototype, W = g["__core-js_shared__"], K = (C = /[^.]+$/.exec(W && W.keys && W.keys.IE_PROTO || "")) ? "Symbol(src)_1." + C : "", Q = F.toString, G = q.hasOwnProperty, M = q.toString, te = RegExp("^" + Q.call(G).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), ce = g.Symbol, he = g.Uint8Array, Ue = q.propertyIsEnumerable, $ = j.splice, ne = (U = Object.keys, z = Object, function(L) {
      return U(z(L));
    }), ye = gt(g, "DataView"), ue = gt(g, "Map"), je = gt(g, "Promise"), V = gt(g, "Set"), Z = gt(g, "WeakMap"), re = gt(Object, "create"), be = Je(ye), se = Je(ue), Se = Je(je), Ce = Je(V), Me = Je(Z), de = ce ? ce.prototype : void 0, ve = de ? de.valueOf : void 0, Ee = de ? de.toString : void 0;
    function le(L) {
      var H = -1, J = L ? L.length : 0;
      for (this.clear(); ++H < J; ) {
        var _ = L[H];
        this.set(_[0], _[1]);
      }
    }
    function pe(L) {
      var H = -1, J = L ? L.length : 0;
      for (this.clear(); ++H < J; ) {
        var _ = L[H];
        this.set(_[0], _[1]);
      }
    }
    function Ve(L) {
      var H = -1, J = L ? L.length : 0;
      for (this.clear(); ++H < J; ) {
        var _ = L[H];
        this.set(_[0], _[1]);
      }
    }
    function lt(L) {
      var H = -1, J = L ? L.length : 0;
      for (this.__data__ = new Ve(); ++H < J; )
        this.add(L[H]);
    }
    function tt(L) {
      this.__data__ = new pe(L);
    }
    function ct(L, H) {
      var J = nt(L) || It(L) ? function(ke, Qe) {
        for (var $e = -1, Ye = Array(ke); ++$e < ke; )
          Ye[$e] = Qe($e);
        return Ye;
      }(L.length, String) : [], _ = J.length, me = !!_;
      for (var fe in L)
        !H && !G.call(L, fe) || me && (fe == "length" || Le(fe, _)) || J.push(fe);
      return J;
    }
    function wt(L, H) {
      for (var J = L.length; J--; )
        if (Tt(L[J][0], H))
          return J;
      return -1;
    }
    le.prototype.clear = function() {
      this.__data__ = re ? re(null) : {};
    }, le.prototype.delete = function(L) {
      return this.has(L) && delete this.__data__[L];
    }, le.prototype.get = function(L) {
      var H = this.__data__;
      if (re) {
        var J = H[L];
        return J === "__lodash_hash_undefined__" ? void 0 : J;
      }
      return G.call(H, L) ? H[L] : void 0;
    }, le.prototype.has = function(L) {
      var H = this.__data__;
      return re ? H[L] !== void 0 : G.call(H, L);
    }, le.prototype.set = function(L, H) {
      return this.__data__[L] = re && H === void 0 ? "__lodash_hash_undefined__" : H, this;
    }, pe.prototype.clear = function() {
      this.__data__ = [];
    }, pe.prototype.delete = function(L) {
      var H = this.__data__, J = wt(H, L);
      return !(J < 0) && (J == H.length - 1 ? H.pop() : $.call(H, J, 1), !0);
    }, pe.prototype.get = function(L) {
      var H = this.__data__, J = wt(H, L);
      return J < 0 ? void 0 : H[J][1];
    }, pe.prototype.has = function(L) {
      return wt(this.__data__, L) > -1;
    }, pe.prototype.set = function(L, H) {
      var J = this.__data__, _ = wt(J, L);
      return _ < 0 ? J.push([L, H]) : J[_][1] = H, this;
    }, Ve.prototype.clear = function() {
      this.__data__ = { hash: new le(), map: new (ue || pe)(), string: new le() };
    }, Ve.prototype.delete = function(L) {
      return it(this, L).delete(L);
    }, Ve.prototype.get = function(L) {
      return it(this, L).get(L);
    }, Ve.prototype.has = function(L) {
      return it(this, L).has(L);
    }, Ve.prototype.set = function(L, H) {
      return it(this, L).set(L, H), this;
    }, lt.prototype.add = lt.prototype.push = function(L) {
      return this.__data__.set(L, "__lodash_hash_undefined__"), this;
    }, lt.prototype.has = function(L) {
      return this.__data__.has(L);
    }, tt.prototype.clear = function() {
      this.__data__ = new pe();
    }, tt.prototype.delete = function(L) {
      return this.__data__.delete(L);
    }, tt.prototype.get = function(L) {
      return this.__data__.get(L);
    }, tt.prototype.has = function(L) {
      return this.__data__.has(L);
    }, tt.prototype.set = function(L, H) {
      var J = this.__data__;
      if (J instanceof pe) {
        var _ = J.__data__;
        if (!ue || _.length < 199)
          return _.push([L, H]), this;
        J = this.__data__ = new Ve(_);
      }
      return J.set(L, H), this;
    };
    var mt, ze = (mt = function(L, H) {
      return L && jt(L, H, Ie);
    }, function(L, H) {
      if (L == null)
        return L;
      if (!B(L))
        return mt(L, H);
      for (var J = L.length, _ = -1, me = Object(L); ++_ < J && H(me[_], _, me) !== !1; )
        ;
      return L;
    }), jt = function(L) {
      return function(H, J, _) {
        for (var me = -1, fe = Object(H), ke = _(H), Qe = ke.length; Qe--; ) {
          var $e = ke[L ? Qe : ++me];
          if (J(fe[$e], $e, fe) === !1)
            break;
        }
        return H;
      };
    }();
    function Lt(L, H) {
      for (var J = 0, _ = (H = yt(H, L) ? [H] : Jt(H)).length; L != null && J < _; )
        L = L[Ae(H[J++])];
      return J && J == _ ? L : void 0;
    }
    function Yt(L, H) {
      return L != null && H in Object(L);
    }
    function Dt(L, H, J, _, me) {
      return L === H || (L == null || H == null || !xe(L) && !De(H) ? L != L && H != H : function(fe, ke, Qe, $e, Ye, Ke) {
        var Zt = nt(fe), Qt = nt(ke), at = "[object Array]", St = "[object Array]";
        Zt || (at = (at = ge(fe)) == a ? l : at), Qt || (St = (St = ge(ke)) == a ? l : St);
        var Ft = at == l && !P(fe), Fi = St == l && !P(ke), Ci = at == St;
        if (Ci && !Ft)
          return Ke || (Ke = new tt()), Zt || Ne(fe) ? ei(fe, ke, Qe, $e, Ye, Ke) : function(et, Xe, Gr, Bi, As, Bt, fi) {
            switch (Gr) {
              case "[object DataView]":
                if (et.byteLength != Xe.byteLength || et.byteOffset != Xe.byteOffset)
                  return !1;
                et = et.buffer, Xe = Xe.buffer;
              case "[object ArrayBuffer]":
                return !(et.byteLength != Xe.byteLength || !Bi(new he(et), new he(Xe)));
              case "[object Boolean]":
              case "[object Date]":
              case "[object Number]":
                return Tt(+et, +Xe);
              case "[object Error]":
                return et.name == Xe.name && et.message == Xe.message;
              case "[object RegExp]":
              case "[object String]":
                return et == Xe + "";
              case c:
                var Ei = N;
              case d:
                var zn = 2 & Bt;
                if (Ei || (Ei = I), et.size != Xe.size && !zn)
                  return !1;
                var Cs = fi.get(et);
                if (Cs)
                  return Cs == Xe;
                Bt |= 1, fi.set(et, Xe);
                var an = ei(Ei(et), Ei(Xe), Bi, As, Bt, fi);
                return fi.delete(et), an;
              case "[object Symbol]":
                if (ve)
                  return ve.call(et) == ve.call(Xe);
            }
            return !1;
          }(fe, ke, at, Qe, $e, Ye, Ke);
        if (!(2 & Ye)) {
          var Un = Ft && G.call(fe, "__wrapped__"), Ma = Fi && G.call(ke, "__wrapped__");
          if (Un || Ma) {
            var sf = Un ? fe.value() : fe, rf = Ma ? ke.value() : ke;
            return Ke || (Ke = new tt()), Qe(sf, rf, $e, Ye, Ke);
          }
        }
        return Ci ? (Ke || (Ke = new tt()), function(et, Xe, Gr, Bi, As, Bt) {
          var fi = 2 & As, Ei = Ie(et), zn = Ei.length, Cs = Ie(Xe).length;
          if (zn != Cs && !fi)
            return !1;
          for (var an = zn; an--; ) {
            var ki = Ei[an];
            if (!(fi ? ki in Xe : G.call(Xe, ki)))
              return !1;
          }
          var ja = Bt.get(et);
          if (ja && Bt.get(Xe))
            return ja == Xe;
          var Es = !0;
          Bt.set(et, Xe), Bt.set(Xe, et);
          for (var Wr = fi; ++an < zn; ) {
            ki = Ei[an];
            var ks = et[ki], Os = Xe[ki];
            if (Bi)
              var La = fi ? Bi(Os, ks, ki, Xe, et, Bt) : Bi(ks, Os, ki, et, Xe, Bt);
            if (!(La === void 0 ? ks === Os || Gr(ks, Os, Bi, As, Bt) : La)) {
              Es = !1;
              break;
            }
            Wr || (Wr = ki == "constructor");
          }
          if (Es && !Wr) {
            var Ts = et.constructor, Is = Xe.constructor;
            Ts == Is || !("constructor" in et) || !("constructor" in Xe) || typeof Ts == "function" && Ts instanceof Ts && typeof Is == "function" && Is instanceof Is || (Es = !1);
          }
          return Bt.delete(et), Bt.delete(Xe), Es;
        }(fe, ke, Qe, $e, Ye, Ke)) : !1;
      }(L, H, Dt, J, _, me));
    }
    function kt(L) {
      return !(!xe(L) || function(H) {
        return !!K && K in H;
      }(L)) && (Y(L) || P(L) ? te : w).test(Je(L));
    }
    function $t(L) {
      return typeof L == "function" ? L : L == null ? Oe : typeof L == "object" ? nt(L) ? function(_, me) {
        return yt(_) && Nt(me) ? ae(Ae(_), me) : function(fe) {
          var ke = function(Qe, $e, Ye) {
            var Ke = Qe == null ? void 0 : Lt(Qe, $e);
            return Ke === void 0 ? Ye : Ke;
          }(fe, _);
          return ke === void 0 && ke === me ? function(Qe, $e) {
            return Qe != null && function(Ye, Ke, Zt) {
              Ke = yt(Ke, Ye) ? [Ke] : Jt(Ke);
              for (var Qt, at = -1, St = Ke.length; ++at < St; ) {
                var Ft = Ae(Ke[at]);
                if (!(Qt = Ye != null && Zt(Ye, Ft)))
                  break;
                Ye = Ye[Ft];
              }
              return Qt || !!(St = Ye ? Ye.length : 0) && ie(St) && Le(Ft, St) && (nt(Ye) || It(Ye));
            }(Qe, $e, Yt);
          }(fe, _) : Dt(me, ke, void 0, 3);
        };
      }(L[0], L[1]) : function(_) {
        var me = function(fe) {
          for (var ke = Ie(fe), Qe = ke.length; Qe--; ) {
            var $e = ke[Qe], Ye = fe[$e];
            ke[Qe] = [$e, Ye, Nt(Ye)];
          }
          return ke;
        }(_);
        return me.length == 1 && me[0][2] ? ae(me[0][0], me[0][1]) : function(fe) {
          return fe === _ || function(ke, Qe, $e, Ye) {
            var Ke = $e.length, Zt = Ke, Qt = !Ye;
            if (ke == null)
              return !Zt;
            for (ke = Object(ke); Ke--; ) {
              var at = $e[Ke];
              if (Qt && at[2] ? at[1] !== ke[at[0]] : !(at[0] in ke))
                return !1;
            }
            for (; ++Ke < Zt; ) {
              var St = (at = $e[Ke])[0], Ft = ke[St], Fi = at[1];
              if (Qt && at[2]) {
                if (Ft === void 0 && !(St in ke))
                  return !1;
              } else {
                var Ci = new tt();
                if (Ye)
                  var Un = Ye(Ft, Fi, St, ke, Qe, Ci);
                if (!(Un === void 0 ? Dt(Fi, Ft, Ye, 3, Ci) : Un))
                  return !1;
              }
            }
            return !0;
          }(fe, _, me);
        };
      }(L) : yt(H = L) ? (J = Ae(H), function(_) {
        return _ == null ? void 0 : _[J];
      }) : function(_) {
        return function(me) {
          return Lt(me, _);
        };
      }(H);
      var H, J;
    }
    function Ot(L) {
      if (J = (H = L) && H.constructor, _ = typeof J == "function" && J.prototype || q, H !== _)
        return ne(L);
      var H, J, _, me = [];
      for (var fe in Object(L))
        G.call(L, fe) && fe != "constructor" && me.push(fe);
      return me;
    }
    function Jt(L) {
      return nt(L) ? L : we(L);
    }
    function ei(L, H, J, _, me, fe) {
      var ke = 2 & me, Qe = L.length, $e = H.length;
      if (Qe != $e && !(ke && $e > Qe))
        return !1;
      var Ye = fe.get(L);
      if (Ye && fe.get(H))
        return Ye == H;
      var Ke = -1, Zt = !0, Qt = 1 & me ? new lt() : void 0;
      for (fe.set(L, H), fe.set(H, L); ++Ke < Qe; ) {
        var at = L[Ke], St = H[Ke];
        if (_)
          var Ft = ke ? _(St, at, Ke, H, L, fe) : _(at, St, Ke, L, H, fe);
        if (Ft !== void 0) {
          if (Ft)
            continue;
          Zt = !1;
          break;
        }
        if (Qt) {
          if (!T(H, function(Fi, Ci) {
            if (!Qt.has(Ci) && (at === Fi || J(at, Fi, _, me, fe)))
              return Qt.add(Ci);
          })) {
            Zt = !1;
            break;
          }
        } else if (at !== St && !J(at, St, _, me, fe)) {
          Zt = !1;
          break;
        }
      }
      return fe.delete(L), fe.delete(H), Zt;
    }
    function it(L, H) {
      var J, _, me = L.__data__;
      return ((_ = typeof (J = H)) == "string" || _ == "number" || _ == "symbol" || _ == "boolean" ? J !== "__proto__" : J === null) ? me[typeof H == "string" ? "string" : "hash"] : me.map;
    }
    function gt(L, H) {
      var J = function(_, me) {
        return _ == null ? void 0 : _[me];
      }(L, H);
      return kt(J) ? J : void 0;
    }
    var ge = function(L) {
      return M.call(L);
    };
    function Le(L, H) {
      return !!(H = H ?? 9007199254740991) && (typeof L == "number" || o.test(L)) && L > -1 && L % 1 == 0 && L < H;
    }
    function yt(L, H) {
      if (nt(L))
        return !1;
      var J = typeof L;
      return !(J != "number" && J != "symbol" && J != "boolean" && L != null && !We(L)) || m.test(L) || !h.test(L) || H != null && L in Object(H);
    }
    function Nt(L) {
      return L == L && !xe(L);
    }
    function ae(L, H) {
      return function(J) {
        return J != null && J[L] === H && (H !== void 0 || L in Object(J));
      };
    }
    (ye && ge(new ye(new ArrayBuffer(1))) != "[object DataView]" || ue && ge(new ue()) != c || je && ge(je.resolve()) != "[object Promise]" || V && ge(new V()) != d || Z && ge(new Z()) != "[object WeakMap]") && (ge = function(L) {
      var H = M.call(L), J = H == l ? L.constructor : void 0, _ = J ? Je(J) : void 0;
      if (_)
        switch (_) {
          case be:
            return "[object DataView]";
          case se:
            return c;
          case Se:
            return "[object Promise]";
          case Ce:
            return d;
          case Me:
            return "[object WeakMap]";
        }
      return H;
    });
    var we = dt(function(L) {
      var H;
      L = (H = L) == null ? "" : function(_) {
        if (typeof _ == "string")
          return _;
        if (We(_))
          return Ee ? Ee.call(_) : "";
        var me = _ + "";
        return me == "0" && 1 / _ == -1 / 0 ? "-0" : me;
      }(H);
      var J = [];
      return y.test(L) && J.push(""), L.replace(b, function(_, me, fe, ke) {
        J.push(fe ? ke.replace(v, "$1") : me || _);
      }), J;
    });
    function Ae(L) {
      if (typeof L == "string" || We(L))
        return L;
      var H = L + "";
      return H == "0" && 1 / L == -1 / 0 ? "-0" : H;
    }
    function Je(L) {
      if (L != null) {
        try {
          return Q.call(L);
        } catch {
        }
        try {
          return L + "";
        } catch {
        }
      }
      return "";
    }
    function dt(L, H) {
      if (typeof L != "function" || H && typeof H != "function")
        throw new TypeError("Expected a function");
      var J = function() {
        var _ = arguments, me = H ? H.apply(this, _) : _[0], fe = J.cache;
        if (fe.has(me))
          return fe.get(me);
        var ke = L.apply(this, _);
        return J.cache = fe.set(me, ke), ke;
      };
      return J.cache = new (dt.Cache || Ve)(), J;
    }
    function Tt(L, H) {
      return L === H || L != L && H != H;
    }
    function It(L) {
      return function(H) {
        return De(H) && B(H);
      }(L) && G.call(L, "callee") && (!Ue.call(L, "callee") || M.call(L) == a);
    }
    dt.Cache = Ve;
    var nt = Array.isArray;
    function B(L) {
      return L != null && ie(L.length) && !Y(L);
    }
    function Y(L) {
      var H = xe(L) ? M.call(L) : "";
      return H == "[object Function]" || H == "[object GeneratorFunction]";
    }
    function ie(L) {
      return typeof L == "number" && L > -1 && L % 1 == 0 && L <= 9007199254740991;
    }
    function xe(L) {
      var H = typeof L;
      return !!L && (H == "object" || H == "function");
    }
    function De(L) {
      return !!L && typeof L == "object";
    }
    function We(L) {
      return typeof L == "symbol" || De(L) && M.call(L) == "[object Symbol]";
    }
    var Ne = R ? function(L) {
      return function(H) {
        return L(H);
      };
    }(R) : function(L) {
      return De(L) && ie(L.length) && !!u[M.call(L)];
    };
    function Ie(L) {
      return B(L) ? ct(L) : Ot(L);
    }
    function Oe(L) {
      return L;
    }
    r.exports = function(L, H, J) {
      var _ = nt(L) ? O : D, me = arguments.length < 3;
      return _(L, $t(H), J, me, ze);
    };
  }).call(this, t(3), t(7)(n));
}, function(n, e) {
  n.exports = function(t) {
    return t.webpackPolyfill || (t.deprecate = function() {
    }, t.paths = [], t.children || (t.children = []), Object.defineProperty(t, "loaded", { enumerable: !0, get: function() {
      return t.l;
    } }), Object.defineProperty(t, "id", { enumerable: !0, get: function() {
      return t.i;
    } }), t.webpackPolyfill = 1), t;
  };
}, function(n, e) {
  String.prototype.padEnd || (String.prototype.padEnd = function(t, s) {
    return t >>= 0, s = String(s !== void 0 ? s : " "), this.length > t ? String(this) : ((t -= this.length) > s.length && (s += s.repeat(t / s.length)), String(this) + s.slice(0, t));
  });
}, function(n, e, t) {
  function s(q, W, K) {
    return W in q ? Object.defineProperty(q, W, { value: K, enumerable: !0, configurable: !0, writable: !0 }) : q[W] = K, q;
  }
  function r(q) {
    if (Symbol.iterator in Object(q) || Object.prototype.toString.call(q) === "[object Arguments]")
      return Array.from(q);
  }
  function a(q) {
    return function(W) {
      if (Array.isArray(W)) {
        for (var K = 0, Q = new Array(W.length); K < W.length; K++)
          Q[K] = W[K];
        return Q;
      }
    }(q) || r(q) || function() {
      throw new TypeError("Invalid attempt to spread non-iterable instance");
    }();
  }
  function c(q) {
    if (Array.isArray(q))
      return q;
  }
  function l() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  }
  function d(q, W) {
    if (!(q instanceof W))
      throw new TypeError("Cannot call a class as a function");
  }
  function h(q, W) {
    for (var K = 0; K < W.length; K++) {
      var Q = W[K];
      Q.enumerable = Q.enumerable || !1, Q.configurable = !0, "value" in Q && (Q.writable = !0), Object.defineProperty(q, Q.key, Q);
    }
  }
  function m(q) {
    return (m = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(W) {
      return typeof W;
    } : function(W) {
      return W && typeof Symbol == "function" && W.constructor === Symbol && W !== Symbol.prototype ? "symbol" : typeof W;
    })(q);
  }
  function y(q) {
    return (y = typeof Symbol == "function" && m(Symbol.iterator) === "symbol" ? function(W) {
      return m(W);
    } : function(W) {
      return W && typeof Symbol == "function" && W.constructor === Symbol && W !== Symbol.prototype ? "symbol" : m(W);
    })(q);
  }
  function b(q) {
    if (q === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return q;
  }
  function v(q) {
    return (v = Object.setPrototypeOf ? Object.getPrototypeOf : function(W) {
      return W.__proto__ || Object.getPrototypeOf(W);
    })(q);
  }
  function w(q, W) {
    return (w = Object.setPrototypeOf || function(K, Q) {
      return K.__proto__ = Q, K;
    })(q, W);
  }
  t.r(e);
  var o = t(0), u = t.n(o), f = t(5), p = t.n(f), g = t(4), S = t.n(g), x = t(6), E = t.n(x), k = t(2), R = t.n(k), O = t(1), T = t.n(O);
  t(8);
  function D(q, W) {
    return c(q) || function(K, Q) {
      var G = [], M = !0, te = !1, ce = void 0;
      try {
        for (var he, Ue = K[Symbol.iterator](); !(M = (he = Ue.next()).done) && (G.push(he.value), !Q || G.length !== Q); M = !0)
          ;
      } catch ($) {
        te = !0, ce = $;
      } finally {
        try {
          M || Ue.return == null || Ue.return();
        } finally {
          if (te)
            throw ce;
        }
      }
      return G;
    }(q, W) || l();
  }
  var P = [["Afghanistan", ["asia"], "af", "93"], ["Albania", ["europe"], "al", "355"], ["Algeria", ["africa", "north-africa"], "dz", "213"], ["Andorra", ["europe"], "ad", "376"], ["Angola", ["africa"], "ao", "244"], ["Antigua and Barbuda", ["america", "carribean"], "ag", "1268"], ["Argentina", ["america", "south-america"], "ar", "54", "(..) ........", 0, ["11", "221", "223", "261", "264", "2652", "280", "2905", "291", "2920", "2966", "299", "341", "342", "343", "351", "376", "379", "381", "3833", "385", "387", "388"]], ["Armenia", ["asia", "ex-ussr"], "am", "374", ".. ......"], ["Aruba", ["america", "carribean"], "aw", "297"], ["Australia", ["oceania"], "au", "61", "(..) .... ....", 0, ["2", "3", "4", "7", "8", "02", "03", "04", "07", "08"]], ["Austria", ["europe", "eu-union"], "at", "43"], ["Azerbaijan", ["asia", "ex-ussr"], "az", "994", "(..) ... .. .."], ["Bahamas", ["america", "carribean"], "bs", "1242"], ["Bahrain", ["middle-east"], "bh", "973"], ["Bangladesh", ["asia"], "bd", "880"], ["Barbados", ["america", "carribean"], "bb", "1246"], ["Belarus", ["europe", "ex-ussr"], "by", "375", "(..) ... .. .."], ["Belgium", ["europe", "eu-union"], "be", "32", "... .. .. .."], ["Belize", ["america", "central-america"], "bz", "501"], ["Benin", ["africa"], "bj", "229"], ["Bhutan", ["asia"], "bt", "975"], ["Bolivia", ["america", "south-america"], "bo", "591"], ["Bosnia and Herzegovina", ["europe", "ex-yugos"], "ba", "387"], ["Botswana", ["africa"], "bw", "267"], ["Brazil", ["america", "south-america"], "br", "55", "(..) ........."], ["British Indian Ocean Territory", ["asia"], "io", "246"], ["Brunei", ["asia"], "bn", "673"], ["Bulgaria", ["europe", "eu-union"], "bg", "359"], ["Burkina Faso", ["africa"], "bf", "226"], ["Burundi", ["africa"], "bi", "257"], ["Cambodia", ["asia"], "kh", "855"], ["Cameroon", ["africa"], "cm", "237"], ["Canada", ["america", "north-america"], "ca", "1", "(...) ...-....", 1, ["204", "226", "236", "249", "250", "289", "306", "343", "365", "387", "403", "416", "418", "431", "437", "438", "450", "506", "514", "519", "548", "579", "581", "587", "604", "613", "639", "647", "672", "705", "709", "742", "778", "780", "782", "807", "819", "825", "867", "873", "902", "905"]], ["Cape Verde", ["africa"], "cv", "238"], ["Caribbean Netherlands", ["america", "carribean"], "bq", "599", "", 1], ["Central African Republic", ["africa"], "cf", "236"], ["Chad", ["africa"], "td", "235"], ["Chile", ["america", "south-america"], "cl", "56"], ["China", ["asia"], "cn", "86", "..-........."], ["Colombia", ["america", "south-america"], "co", "57", "... ... ...."], ["Comoros", ["africa"], "km", "269"], ["Congo", ["africa"], "cd", "243"], ["Congo", ["africa"], "cg", "242"], ["Costa Rica", ["america", "central-america"], "cr", "506", "....-...."], ["Côte d’Ivoire", ["africa"], "ci", "225", ".. .. .. .."], ["Croatia", ["europe", "eu-union", "ex-yugos"], "hr", "385"], ["Cuba", ["america", "carribean"], "cu", "53"], ["Curaçao", ["america", "carribean"], "cw", "599", "", 0], ["Cyprus", ["europe", "eu-union"], "cy", "357", ".. ......"], ["Czech Republic", ["europe", "eu-union"], "cz", "420", "... ... ..."], ["Denmark", ["europe", "eu-union", "baltic"], "dk", "45", ".. .. .. .."], ["Djibouti", ["africa"], "dj", "253"], ["Dominica", ["america", "carribean"], "dm", "1767"], ["Dominican Republic", ["america", "carribean"], "do", "1", "", 2, ["809", "829", "849"]], ["Ecuador", ["america", "south-america"], "ec", "593"], ["Egypt", ["africa", "north-africa"], "eg", "20"], ["El Salvador", ["america", "central-america"], "sv", "503", "....-...."], ["Equatorial Guinea", ["africa"], "gq", "240"], ["Eritrea", ["africa"], "er", "291"], ["Estonia", ["europe", "eu-union", "ex-ussr", "baltic"], "ee", "372", ".... ......"], ["Ethiopia", ["africa"], "et", "251"], ["Fiji", ["oceania"], "fj", "679"], ["Finland", ["europe", "eu-union", "baltic"], "fi", "358", ".. ... .. .."], ["France", ["europe", "eu-union"], "fr", "33", ". .. .. .. .."], ["French Guiana", ["america", "south-america"], "gf", "594"], ["French Polynesia", ["oceania"], "pf", "689"], ["Gabon", ["africa"], "ga", "241"], ["Gambia", ["africa"], "gm", "220"], ["Georgia", ["asia", "ex-ussr"], "ge", "995"], ["Germany", ["europe", "eu-union", "baltic"], "de", "49", ".... ........"], ["Ghana", ["africa"], "gh", "233"], ["Greece", ["europe", "eu-union"], "gr", "30"], ["Grenada", ["america", "carribean"], "gd", "1473"], ["Guadeloupe", ["america", "carribean"], "gp", "590", "", 0], ["Guam", ["oceania"], "gu", "1671"], ["Guatemala", ["america", "central-america"], "gt", "502", "....-...."], ["Guinea", ["africa"], "gn", "224"], ["Guinea-Bissau", ["africa"], "gw", "245"], ["Guyana", ["america", "south-america"], "gy", "592"], ["Haiti", ["america", "carribean"], "ht", "509", "....-...."], ["Honduras", ["america", "central-america"], "hn", "504"], ["Hong Kong", ["asia"], "hk", "852", ".... ...."], ["Hungary", ["europe", "eu-union"], "hu", "36"], ["Iceland", ["europe"], "is", "354", "... ...."], ["India", ["asia"], "in", "91", ".....-....."], ["Indonesia", ["asia"], "id", "62"], ["Iran", ["middle-east"], "ir", "98", "... ... ...."], ["Iraq", ["middle-east"], "iq", "964"], ["Ireland", ["europe", "eu-union"], "ie", "353", ".. ......."], ["Israel", ["middle-east"], "il", "972", "... ... ...."], ["Italy", ["europe", "eu-union"], "it", "39", "... .......", 0], ["Jamaica", ["america", "carribean"], "jm", "1876"], ["Japan", ["asia"], "jp", "81", ".. .... ...."], ["Jordan", ["middle-east"], "jo", "962"], ["Kazakhstan", ["asia", "ex-ussr"], "kz", "7", "... ...-..-..", 1, ["310", "311", "312", "313", "315", "318", "321", "324", "325", "326", "327", "336", "7172", "73622"]], ["Kenya", ["africa"], "ke", "254"], ["Kiribati", ["oceania"], "ki", "686"], ["Kosovo", ["europe", "ex-yugos"], "xk", "383"], ["Kuwait", ["middle-east"], "kw", "965"], ["Kyrgyzstan", ["asia", "ex-ussr"], "kg", "996", "... ... ..."], ["Laos", ["asia"], "la", "856"], ["Latvia", ["europe", "eu-union", "ex-ussr", "baltic"], "lv", "371", ".. ... ..."], ["Lebanon", ["middle-east"], "lb", "961"], ["Lesotho", ["africa"], "ls", "266"], ["Liberia", ["africa"], "lr", "231"], ["Libya", ["africa", "north-africa"], "ly", "218"], ["Liechtenstein", ["europe"], "li", "423"], ["Lithuania", ["europe", "eu-union", "ex-ussr", "baltic"], "lt", "370"], ["Luxembourg", ["europe", "eu-union"], "lu", "352"], ["Macau", ["asia"], "mo", "853"], ["Macedonia", ["europe", "ex-yugos"], "mk", "389"], ["Madagascar", ["africa"], "mg", "261"], ["Malawi", ["africa"], "mw", "265"], ["Malaysia", ["asia"], "my", "60", "..-....-...."], ["Maldives", ["asia"], "mv", "960"], ["Mali", ["africa"], "ml", "223"], ["Malta", ["europe", "eu-union"], "mt", "356"], ["Marshall Islands", ["oceania"], "mh", "692"], ["Martinique", ["america", "carribean"], "mq", "596"], ["Mauritania", ["africa"], "mr", "222"], ["Mauritius", ["africa"], "mu", "230"], ["Mexico", ["america", "central-america"], "mx", "52", "... ... ....", 0, ["55", "81", "33", "656", "664", "998", "774", "229"]], ["Micronesia", ["oceania"], "fm", "691"], ["Moldova", ["europe"], "md", "373", "(..) ..-..-.."], ["Monaco", ["europe"], "mc", "377"], ["Mongolia", ["asia"], "mn", "976"], ["Montenegro", ["europe", "ex-yugos"], "me", "382"], ["Morocco", ["africa", "north-africa"], "ma", "212"], ["Mozambique", ["africa"], "mz", "258"], ["Myanmar", ["asia"], "mm", "95"], ["Namibia", ["africa"], "na", "264"], ["Nauru", ["africa"], "nr", "674"], ["Nepal", ["asia"], "np", "977"], ["Netherlands", ["europe", "eu-union"], "nl", "31", ".. ........"], ["New Caledonia", ["oceania"], "nc", "687"], ["New Zealand", ["oceania"], "nz", "64", "...-...-...."], ["Nicaragua", ["america", "central-america"], "ni", "505"], ["Niger", ["africa"], "ne", "227"], ["Nigeria", ["africa"], "ng", "234"], ["North Korea", ["asia"], "kp", "850"], ["Norway", ["europe", "baltic"], "no", "47", "... .. ..."], ["Oman", ["middle-east"], "om", "968"], ["Pakistan", ["asia"], "pk", "92", "...-......."], ["Palau", ["oceania"], "pw", "680"], ["Palestine", ["middle-east"], "ps", "970"], ["Panama", ["america", "central-america"], "pa", "507"], ["Papua New Guinea", ["oceania"], "pg", "675"], ["Paraguay", ["america", "south-america"], "py", "595"], ["Peru", ["america", "south-america"], "pe", "51"], ["Philippines", ["asia"], "ph", "63", ".... ......."], ["Poland", ["europe", "eu-union", "baltic"], "pl", "48", "...-...-..."], ["Portugal", ["europe", "eu-union"], "pt", "351"], ["Puerto Rico", ["america", "carribean"], "pr", "1", "", 3, ["787", "939"]], ["Qatar", ["middle-east"], "qa", "974"], ["Réunion", ["africa"], "re", "262"], ["Romania", ["europe", "eu-union"], "ro", "40"], ["Russia", ["europe", "asia", "ex-ussr", "baltic"], "ru", "7", "(...) ...-..-..", 0], ["Rwanda", ["africa"], "rw", "250"], ["Saint Kitts and Nevis", ["america", "carribean"], "kn", "1869"], ["Saint Lucia", ["america", "carribean"], "lc", "1758"], ["Saint Vincent and the Grenadines", ["america", "carribean"], "vc", "1784"], ["Samoa", ["oceania"], "ws", "685"], ["San Marino", ["europe"], "sm", "378"], ["São Tomé and Príncipe", ["africa"], "st", "239"], ["Saudi Arabia", ["middle-east"], "sa", "966"], ["Senegal", ["africa"], "sn", "221"], ["Serbia", ["europe", "ex-yugos"], "rs", "381"], ["Seychelles", ["africa"], "sc", "248"], ["Sierra Leone", ["africa"], "sl", "232"], ["Singapore", ["asia"], "sg", "65", "....-...."], ["Slovakia", ["europe", "eu-union"], "sk", "421"], ["Slovenia", ["europe", "eu-union", "ex-yugos"], "si", "386"], ["Solomon Islands", ["oceania"], "sb", "677"], ["Somalia", ["africa"], "so", "252"], ["South Africa", ["africa"], "za", "27"], ["South Korea", ["asia"], "kr", "82", "... .... ...."], ["South Sudan", ["africa", "north-africa"], "ss", "211"], ["Spain", ["europe", "eu-union"], "es", "34", "... ... ..."], ["Sri Lanka", ["asia"], "lk", "94"], ["Sudan", ["africa"], "sd", "249"], ["Suriname", ["america", "south-america"], "sr", "597"], ["Swaziland", ["africa"], "sz", "268"], ["Sweden", ["europe", "eu-union", "baltic"], "se", "46", "(...) ...-..."], ["Switzerland", ["europe"], "ch", "41", ".. ... .. .."], ["Syria", ["middle-east"], "sy", "963"], ["Taiwan", ["asia"], "tw", "886"], ["Tajikistan", ["asia", "ex-ussr"], "tj", "992"], ["Tanzania", ["africa"], "tz", "255"], ["Thailand", ["asia"], "th", "66"], ["Timor-Leste", ["asia"], "tl", "670"], ["Togo", ["africa"], "tg", "228"], ["Tonga", ["oceania"], "to", "676"], ["Trinidad and Tobago", ["america", "carribean"], "tt", "1868"], ["Tunisia", ["africa", "north-africa"], "tn", "216"], ["Turkey", ["europe"], "tr", "90", "... ... .. .."], ["Turkmenistan", ["asia", "ex-ussr"], "tm", "993"], ["Tuvalu", ["asia"], "tv", "688"], ["Uganda", ["africa"], "ug", "256"], ["Ukraine", ["europe", "ex-ussr"], "ua", "380", "(..) ... .. .."], ["United Arab Emirates", ["middle-east"], "ae", "971"], ["United Kingdom", ["europe", "eu-union"], "gb", "44", ".... ......"], ["United States", ["america", "north-america"], "us", "1", "(...) ...-....", 0, ["907", "205", "251", "256", "334", "479", "501", "870", "480", "520", "602", "623", "928", "209", "213", "310", "323", "408", "415", "510", "530", "559", "562", "619", "626", "650", "661", "707", "714", "760", "805", "818", "831", "858", "909", "916", "925", "949", "951", "303", "719", "970", "203", "860", "202", "302", "239", "305", "321", "352", "386", "407", "561", "727", "772", "813", "850", "863", "904", "941", "954", "229", "404", "478", "706", "770", "912", "808", "319", "515", "563", "641", "712", "208", "217", "309", "312", "618", "630", "708", "773", "815", "847", "219", "260", "317", "574", "765", "812", "316", "620", "785", "913", "270", "502", "606", "859", "225", "318", "337", "504", "985", "413", "508", "617", "781", "978", "301", "410", "207", "231", "248", "269", "313", "517", "586", "616", "734", "810", "906", "989", "218", "320", "507", "612", "651", "763", "952", "314", "417", "573", "636", "660", "816", "228", "601", "662", "406", "252", "336", "704", "828", "910", "919", "701", "308", "402", "603", "201", "609", "732", "856", "908", "973", "505", "575", "702", "775", "212", "315", "516", "518", "585", "607", "631", "716", "718", "845", "914", "216", "330", "419", "440", "513", "614", "740", "937", "405", "580", "918", "503", "541", "215", "412", "570", "610", "717", "724", "814", "401", "803", "843", "864", "605", "423", "615", "731", "865", "901", "931", "210", "214", "254", "281", "325", "361", "409", "432", "512", "713", "806", "817", "830", "903", "915", "936", "940", "956", "972", "979", "435", "801", "276", "434", "540", "703", "757", "804", "802", "206", "253", "360", "425", "509", "262", "414", "608", "715", "920", "304", "307"]], ["Uruguay", ["america", "south-america"], "uy", "598"], ["Uzbekistan", ["asia", "ex-ussr"], "uz", "998", ".. ... .. .."], ["Vanuatu", ["oceania"], "vu", "678"], ["Vatican City", ["europe"], "va", "39", ".. .... ....", 1], ["Venezuela", ["america", "south-america"], "ve", "58"], ["Vietnam", ["asia"], "vn", "84"], ["Yemen", ["middle-east"], "ye", "967"], ["Zambia", ["africa"], "zm", "260"], ["Zimbabwe", ["africa"], "zw", "263"]], N = [["American Samoa", ["oceania"], "as", "1684"], ["Anguilla", ["america", "carribean"], "ai", "1264"], ["Bermuda", ["america", "north-america"], "bm", "1441"], ["British Virgin Islands", ["america", "carribean"], "vg", "1284"], ["Cayman Islands", ["america", "carribean"], "ky", "1345"], ["Cook Islands", ["oceania"], "ck", "682"], ["Falkland Islands", ["america", "south-america"], "fk", "500"], ["Faroe Islands", ["europe"], "fo", "298"], ["Gibraltar", ["europe"], "gi", "350"], ["Greenland", ["america"], "gl", "299"], ["Jersey", ["europe", "eu-union"], "je", "44", ".... ......"], ["Montserrat", ["america", "carribean"], "ms", "1664"], ["Niue", ["asia"], "nu", "683"], ["Norfolk Island", ["oceania"], "nf", "672"], ["Northern Mariana Islands", ["oceania"], "mp", "1670"], ["Saint Barthélemy", ["america", "carribean"], "bl", "590", "", 1], ["Saint Helena", ["africa"], "sh", "290"], ["Saint Martin", ["america", "carribean"], "mf", "590", "", 2], ["Saint Pierre and Miquelon", ["america", "north-america"], "pm", "508"], ["Sint Maarten", ["america", "carribean"], "sx", "1721"], ["Tokelau", ["oceania"], "tk", "690"], ["Turks and Caicos Islands", ["america", "carribean"], "tc", "1649"], ["U.S. Virgin Islands", ["america", "carribean"], "vi", "1340"], ["Wallis and Futuna", ["oceania"], "wf", "681"]];
  function I(q, W, K, Q, G) {
    return !K || G ? q + "".padEnd(W.length, ".") + " " + Q : q + "".padEnd(W.length, ".") + " " + K;
  }
  function C(q, W, K, Q, G) {
    var M, te, ce = [];
    return te = W === !0, [(M = []).concat.apply(M, a(q.map(function(he) {
      var Ue = { name: he[0], regions: he[1], iso2: he[2], countryCode: he[3], dialCode: he[3], format: I(K, he[3], he[4], Q, G), priority: he[5] || 0 }, $ = [];
      return he[6] && he[6].map(function(ne) {
        var ye = function(ue) {
          for (var je = 1; je < arguments.length; je++) {
            var V = arguments[je] != null ? arguments[je] : {}, Z = Object.keys(V);
            typeof Object.getOwnPropertySymbols == "function" && (Z = Z.concat(Object.getOwnPropertySymbols(V).filter(function(re) {
              return Object.getOwnPropertyDescriptor(V, re).enumerable;
            }))), Z.forEach(function(re) {
              s(ue, re, V[re]);
            });
          }
          return ue;
        }({}, Ue);
        ye.dialCode = he[3] + ne, ye.isAreaCode = !0, ye.areaCodeLength = ne.length, $.push(ye);
      }), $.length > 0 ? (Ue.mainCode = !0, te || W.constructor.name === "Array" && W.includes(he[2]) ? (Ue.hasAreaCodes = !0, [Ue].concat($)) : (ce = ce.concat($), [Ue])) : [Ue];
    }))), ce];
  }
  function U(q, W, K, Q) {
    if (K !== null) {
      var G = Object.keys(K), M = Object.values(K);
      G.forEach(function(te, ce) {
        if (Q)
          return q.push([te, M[ce]]);
        var he = q.findIndex(function($) {
          return $[0] === te;
        });
        if (he === -1) {
          var Ue = [te];
          Ue[W] = M[ce], q.push(Ue);
        } else
          q[he][W] = M[ce];
      });
    }
  }
  function z(q, W) {
    return W.length === 0 ? q : q.map(function(K) {
      var Q = W.findIndex(function(M) {
        return M[0] === K[2];
      });
      if (Q === -1)
        return K;
      var G = W[Q];
      return G[1] && (K[4] = G[1]), G[3] && (K[5] = G[3]), G[2] && (K[6] = G[2]), K;
    });
  }
  var j = function q(W, K, Q, G, M, te, ce, he, Ue, $, ne, ye, ue, je) {
    d(this, q), this.filterRegions = function(de, ve) {
      if (typeof de == "string") {
        var Ee = de;
        return ve.filter(function(le) {
          return le.regions.some(function(pe) {
            return pe === Ee;
          });
        });
      }
      return ve.filter(function(le) {
        return de.map(function(pe) {
          return le.regions.some(function(Ve) {
            return Ve === pe;
          });
        }).some(function(pe) {
          return pe;
        });
      });
    }, this.sortTerritories = function(de, ve) {
      var Ee = [].concat(a(de), a(ve));
      return Ee.sort(function(le, pe) {
        return le.name < pe.name ? -1 : le.name > pe.name ? 1 : 0;
      }), Ee;
    }, this.getFilteredCountryList = function(de, ve, Ee) {
      return de.length === 0 ? ve : Ee ? de.map(function(le) {
        var pe = ve.find(function(Ve) {
          return Ve.iso2 === le;
        });
        if (pe)
          return pe;
      }).filter(function(le) {
        return le;
      }) : ve.filter(function(le) {
        return de.some(function(pe) {
          return pe === le.iso2;
        });
      });
    }, this.localizeCountries = function(de, ve, Ee) {
      for (var le = 0; le < de.length; le++)
        ve[de[le].iso2] !== void 0 ? de[le].localName = ve[de[le].iso2] : ve[de[le].name] !== void 0 && (de[le].localName = ve[de[le].name]);
      return Ee || de.sort(function(pe, Ve) {
        return pe.localName < Ve.localName ? -1 : pe.localName > Ve.localName ? 1 : 0;
      }), de;
    }, this.getCustomAreas = function(de, ve) {
      for (var Ee = [], le = 0; le < ve.length; le++) {
        var pe = JSON.parse(JSON.stringify(de));
        pe.dialCode += ve[le], Ee.push(pe);
      }
      return Ee;
    }, this.excludeCountries = function(de, ve) {
      return ve.length === 0 ? de : de.filter(function(Ee) {
        return !ve.includes(Ee.iso2);
      });
    };
    var V = function(de, ve, Ee) {
      var le = [];
      return U(le, 1, de, !0), U(le, 3, ve), U(le, 2, Ee), le;
    }(he, Ue, $), Z = z(JSON.parse(JSON.stringify(P)), V), re = z(JSON.parse(JSON.stringify(N)), V), be = D(C(Z, W, ye, ue, je), 2), se = be[0], Se = be[1];
    if (K) {
      var Ce = D(C(re, W, ye, ue, je), 2), Me = Ce[0];
      Ce[1], se = this.sortTerritories(Me, se);
    }
    Q && (se = this.filterRegions(Q, se)), this.onlyCountries = this.localizeCountries(this.excludeCountries(this.getFilteredCountryList(G, se, ce.includes("onlyCountries")), te), ne, ce.includes("onlyCountries")), this.preferredCountries = M.length === 0 ? [] : this.localizeCountries(this.getFilteredCountryList(M, se, ce.includes("preferredCountries")), ne, ce.includes("preferredCountries")), this.hiddenAreaCodes = this.excludeCountries(this.getFilteredCountryList(G, Se), te);
  }, F = function(q) {
    function W(G) {
      var M;
      d(this, W), (M = function(V, Z) {
        return !Z || y(Z) !== "object" && typeof Z != "function" ? b(V) : Z;
      }(this, v(W).call(this, G))).getProbableCandidate = S()(function(V) {
        return V && V.length !== 0 ? M.state.onlyCountries.filter(function(Z) {
          return R()(Z.name.toLowerCase(), V.toLowerCase());
        }, b(b(M)))[0] : null;
      }), M.guessSelectedCountry = S()(function(V, Z, re, be) {
        var se;
        if (M.props.enableAreaCodes === !1 && (be.some(function(Me) {
          if (R()(V, Me.dialCode))
            return re.some(function(de) {
              if (Me.iso2 === de.iso2 && de.mainCode)
                return se = de, !0;
            }), !0;
        }), se))
          return se;
        var Se = re.find(function(Me) {
          return Me.iso2 == Z;
        });
        if (V.trim() === "")
          return Se;
        var Ce = re.reduce(function(Me, de) {
          return R()(V, de.dialCode) && (de.dialCode.length > Me.dialCode.length || de.dialCode.length === Me.dialCode.length && de.priority < Me.priority) ? de : Me;
        }, { dialCode: "", priority: 10001 }, b(b(M)));
        return Ce.name ? Ce : Se;
      }), M.updateCountry = function(V) {
        var Z, re = M.state.onlyCountries;
        (Z = V.indexOf(0) >= "0" && V.indexOf(0) <= "9" ? re.find(function(be) {
          return be.dialCode == +V;
        }) : re.find(function(be) {
          return be.iso2 == V;
        })) && Z.dialCode && M.setState({ selectedCountry: Z, formattedNumber: M.props.disableCountryCode ? "" : M.formatNumber(Z.dialCode, Z) });
      }, M.scrollTo = function(V, Z) {
        if (V) {
          var re = M.dropdownRef;
          if (re && document.body) {
            var be = re.offsetHeight, se = re.getBoundingClientRect().top + document.body.scrollTop, Se = se + be, Ce = V, Me = Ce.getBoundingClientRect(), de = Ce.offsetHeight, ve = Me.top + document.body.scrollTop, Ee = ve + de, le = ve - se + re.scrollTop, pe = be / 2 - de / 2;
            if (M.props.enableSearch ? ve < se + 32 : ve < se)
              Z && (le -= pe), re.scrollTop = le;
            else if (Ee > Se) {
              Z && (le += pe);
              var Ve = be - de;
              re.scrollTop = le - Ve;
            }
          }
        }
      }, M.scrollToTop = function() {
        var V = M.dropdownRef;
        V && document.body && (V.scrollTop = 0);
      }, M.formatNumber = function(V, Z) {
        if (!Z)
          return V;
        var re, be = Z.format, se = M.props, Se = se.disableCountryCode, Ce = se.enableAreaCodeStretch, Me = se.enableLongNumbers, de = se.autoFormat;
        if (Se ? ((re = be.split(" ")).shift(), re = re.join(" ")) : Ce && Z.isAreaCode ? ((re = be.split(" "))[1] = re[1].replace(/\.+/, "".padEnd(Z.areaCodeLength, ".")), re = re.join(" ")) : re = be, !V || V.length === 0)
          return Se ? "" : M.props.prefix;
        if (V && V.length < 2 || !re || !de)
          return Se ? V : M.props.prefix + V;
        var ve, Ee = E()(re, function(le, pe) {
          if (le.remainingText.length === 0)
            return le;
          if (pe !== ".")
            return { formattedText: le.formattedText + pe, remainingText: le.remainingText };
          var Ve, lt = c(Ve = le.remainingText) || r(Ve) || l(), tt = lt[0], ct = lt.slice(1);
          return { formattedText: le.formattedText + tt, remainingText: ct };
        }, { formattedText: "", remainingText: V.split("") });
        return (ve = Me ? Ee.formattedText + Ee.remainingText.join("") : Ee.formattedText).includes("(") && !ve.includes(")") && (ve += ")"), ve;
      }, M.cursorToEnd = function() {
        var V = M.numberInputRef;
        if (document.activeElement === V) {
          V.focus();
          var Z = V.value.length;
          V.value.charAt(Z - 1) === ")" && (Z -= 1), V.setSelectionRange(Z, Z);
        }
      }, M.getElement = function(V) {
        return M["flag_no_".concat(V)];
      }, M.getCountryData = function() {
        return M.state.selectedCountry ? { name: M.state.selectedCountry.name || "", dialCode: M.state.selectedCountry.dialCode || "", countryCode: M.state.selectedCountry.iso2 || "", format: M.state.selectedCountry.format || "" } : {};
      }, M.handleFlagDropdownClick = function(V) {
        if (V.preventDefault(), M.state.showDropdown || !M.props.disabled) {
          var Z = M.state, re = Z.preferredCountries, be = Z.onlyCountries, se = Z.selectedCountry, Se = M.concatPreferredCountries(re, be).findIndex(function(Ce) {
            return Ce.dialCode === se.dialCode && Ce.iso2 === se.iso2;
          });
          M.setState({ showDropdown: !M.state.showDropdown, highlightCountryIndex: Se }, function() {
            M.state.showDropdown && M.scrollTo(M.getElement(M.state.highlightCountryIndex));
          });
        }
      }, M.handleInput = function(V) {
        var Z = V.target.value, re = M.props, be = re.prefix, se = re.onChange, Se = M.props.disableCountryCode ? "" : be, Ce = M.state.selectedCountry, Me = M.state.freezeSelection;
        if (!M.props.countryCodeEditable) {
          var de = be + (Ce.hasAreaCodes ? M.state.onlyCountries.find(function(ze) {
            return ze.iso2 === Ce.iso2 && ze.mainCode;
          }).dialCode : Ce.dialCode);
          if (Z.slice(0, de.length) !== de)
            return;
        }
        if (Z === be)
          return se && se("", M.getCountryData(), V, ""), M.setState({ formattedNumber: "" });
        if (!(Z.replace(/\D/g, "").length > 15 && (M.props.enableLongNumbers === !1 || typeof M.props.enableLongNumbers == "number" && Z.replace(/\D/g, "").length > M.props.enableLongNumbers)) && Z !== M.state.formattedNumber) {
          V.preventDefault ? V.preventDefault() : V.returnValue = !1;
          var ve = M.props.country, Ee = M.state, le = Ee.onlyCountries, pe = Ee.selectedCountry, Ve = Ee.hiddenAreaCodes;
          if (se && V.persist(), Z.length > 0) {
            var lt = Z.replace(/\D/g, "");
            (!M.state.freezeSelection || pe && pe.dialCode.length > lt.length) && (Ce = M.props.disableCountryGuess ? pe : M.guessSelectedCountry(lt.substring(0, 6), ve, le, Ve) || pe, Me = !1), Se = M.formatNumber(lt, Ce), Ce = Ce.dialCode ? Ce : pe;
          }
          var tt = V.target.selectionStart, ct = V.target.selectionStart, wt = M.state.formattedNumber, mt = Se.length - wt.length;
          M.setState({ formattedNumber: Se, freezeSelection: Me, selectedCountry: Ce }, function() {
            mt > 0 && (ct -= mt), Se.charAt(Se.length - 1) == ")" ? M.numberInputRef.setSelectionRange(Se.length - 1, Se.length - 1) : ct > 0 && wt.length >= Se.length ? M.numberInputRef.setSelectionRange(ct, ct) : tt < wt.length && M.numberInputRef.setSelectionRange(tt, tt), se && se(Se.replace(/[^0-9]+/g, ""), M.getCountryData(), V, Se);
          });
        }
      }, M.handleInputClick = function(V) {
        M.setState({ showDropdown: !1 }), M.props.onClick && M.props.onClick(V, M.getCountryData());
      }, M.handleDoubleClick = function(V) {
        var Z = V.target.value.length;
        V.target.setSelectionRange(0, Z);
      }, M.handleFlagItemClick = function(V, Z) {
        var re = M.state.selectedCountry, be = M.state.onlyCountries.find(function(Me) {
          return Me == V;
        });
        if (be) {
          var se = M.state.formattedNumber.replace(" ", "").replace("(", "").replace(")", "").replace("-", ""), Se = se.length > 1 ? se.replace(re.dialCode, be.dialCode) : be.dialCode, Ce = M.formatNumber(Se.replace(/\D/g, ""), be);
          M.setState({ showDropdown: !1, selectedCountry: be, freezeSelection: !0, formattedNumber: Ce, searchValue: "" }, function() {
            M.cursorToEnd(), M.props.onChange && M.props.onChange(Ce.replace(/[^0-9]+/g, ""), M.getCountryData(), Z, Ce);
          });
        }
      }, M.handleInputFocus = function(V) {
        M.numberInputRef && M.numberInputRef.value === M.props.prefix && M.state.selectedCountry && !M.props.disableCountryCode && M.setState({ formattedNumber: M.props.prefix + M.state.selectedCountry.dialCode }, function() {
          M.props.jumpCursorToEnd && setTimeout(M.cursorToEnd, 0);
        }), M.setState({ placeholder: "" }), M.props.onFocus && M.props.onFocus(V, M.getCountryData()), M.props.jumpCursorToEnd && setTimeout(M.cursorToEnd, 0);
      }, M.handleInputBlur = function(V) {
        V.target.value || M.setState({ placeholder: M.props.placeholder }), M.props.onBlur && M.props.onBlur(V, M.getCountryData());
      }, M.handleInputCopy = function(V) {
        if (M.props.copyNumbersOnly) {
          var Z = window.getSelection().toString().replace(/[^0-9]+/g, "");
          V.clipboardData.setData("text/plain", Z), V.preventDefault();
        }
      }, M.getHighlightCountryIndex = function(V) {
        var Z = M.state.highlightCountryIndex + V;
        return Z < 0 || Z >= M.state.onlyCountries.length + M.state.preferredCountries.length ? Z - V : M.props.enableSearch && Z > M.getSearchFilteredCountries().length ? 0 : Z;
      }, M.searchCountry = function() {
        var V = M.getProbableCandidate(M.state.queryString) || M.state.onlyCountries[0], Z = M.state.onlyCountries.findIndex(function(re) {
          return re == V;
        }) + M.state.preferredCountries.length;
        M.scrollTo(M.getElement(Z), !0), M.setState({ queryString: "", highlightCountryIndex: Z });
      }, M.handleKeydown = function(V) {
        var Z = M.props.keys, re = V.target.className;
        if (re.includes("selected-flag") && V.which === Z.ENTER && !M.state.showDropdown)
          return M.handleFlagDropdownClick(V);
        if (re.includes("form-control") && (V.which === Z.ENTER || V.which === Z.ESC))
          return V.target.blur();
        if (M.state.showDropdown && !M.props.disabled && (!re.includes("search-box") || V.which === Z.UP || V.which === Z.DOWN || V.which === Z.ENTER || V.which === Z.ESC && V.target.value === "")) {
          V.preventDefault ? V.preventDefault() : V.returnValue = !1;
          var be = function(se) {
            M.setState({ highlightCountryIndex: M.getHighlightCountryIndex(se) }, function() {
              M.scrollTo(M.getElement(M.state.highlightCountryIndex), !0);
            });
          };
          switch (V.which) {
            case Z.DOWN:
              be(1);
              break;
            case Z.UP:
              be(-1);
              break;
            case Z.ENTER:
              M.props.enableSearch ? M.handleFlagItemClick(M.getSearchFilteredCountries()[M.state.highlightCountryIndex] || M.getSearchFilteredCountries()[0], V) : M.handleFlagItemClick([].concat(a(M.state.preferredCountries), a(M.state.onlyCountries))[M.state.highlightCountryIndex], V);
              break;
            case Z.ESC:
            case Z.TAB:
              M.setState({ showDropdown: !1 }, M.cursorToEnd);
              break;
            default:
              (V.which >= Z.A && V.which <= Z.Z || V.which === Z.SPACE) && M.setState({ queryString: M.state.queryString + String.fromCharCode(V.which) }, M.state.debouncedQueryStingSearcher);
          }
        }
      }, M.handleInputKeyDown = function(V) {
        var Z = M.props, re = Z.keys, be = Z.onEnterKeyPress, se = Z.onKeyDown;
        V.which === re.ENTER && be && be(V), se && se(V);
      }, M.handleClickOutside = function(V) {
        M.dropdownRef && !M.dropdownContainerRef.contains(V.target) && M.state.showDropdown && M.setState({ showDropdown: !1 });
      }, M.handleSearchChange = function(V) {
        var Z = V.currentTarget.value, re = M.state, be = re.preferredCountries, se = re.selectedCountry, Se = 0;
        if (Z === "" && se) {
          var Ce = M.state.onlyCountries;
          Se = M.concatPreferredCountries(be, Ce).findIndex(function(Me) {
            return Me == se;
          }), setTimeout(function() {
            return M.scrollTo(M.getElement(Se));
          }, 100);
        }
        M.setState({ searchValue: Z, highlightCountryIndex: Se });
      }, M.concatPreferredCountries = function(V, Z) {
        return V.length > 0 ? a(new Set(V.concat(Z))) : Z;
      }, M.getDropdownCountryName = function(V) {
        return V.localName || V.name;
      }, M.getSearchFilteredCountries = function() {
        var V = M.state, Z = V.preferredCountries, re = V.onlyCountries, be = V.searchValue, se = M.props.enableSearch, Se = M.concatPreferredCountries(Z, re), Ce = be.trim().toLowerCase().replace("+", "");
        if (se && Ce) {
          if (/^\d+$/.test(Ce))
            return Se.filter(function(ve) {
              var Ee = ve.dialCode;
              return ["".concat(Ee)].some(function(le) {
                return le.toLowerCase().includes(Ce);
              });
            });
          var Me = Se.filter(function(ve) {
            var Ee = ve.iso2;
            return ["".concat(Ee)].some(function(le) {
              return le.toLowerCase().includes(Ce);
            });
          }), de = Se.filter(function(ve) {
            var Ee = ve.name, le = ve.localName;
            return ve.iso2, ["".concat(Ee), "".concat(le || "")].some(function(pe) {
              return pe.toLowerCase().includes(Ce);
            });
          });
          return M.scrollToTop(), a(new Set([].concat(Me, de)));
        }
        return Se;
      }, M.getCountryDropdownList = function() {
        var V = M.state, Z = V.preferredCountries, re = V.highlightCountryIndex, be = V.showDropdown, se = V.searchValue, Se = M.props, Ce = Se.disableDropdown, Me = Se.prefix, de = M.props, ve = de.enableSearch, Ee = de.searchNotFound, le = de.disableSearchIcon, pe = de.searchClass, Ve = de.searchStyle, lt = de.searchPlaceholder, tt = de.autocompleteSearch, ct = M.getSearchFilteredCountries().map(function(ze, jt) {
          var Lt = re === jt, Yt = T()({ country: !0, preferred: ze.iso2 === "us" || ze.iso2 === "gb", active: ze.iso2 === "us", highlight: Lt }), Dt = "flag ".concat(ze.iso2);
          return u.a.createElement("li", Object.assign({ ref: function(kt) {
            return M["flag_no_".concat(jt)] = kt;
          }, key: "flag_no_".concat(jt), "data-flag-key": "flag_no_".concat(jt), className: Yt, "data-dial-code": "1", tabIndex: Ce ? "-1" : "0", "data-country-code": ze.iso2, onClick: function(kt) {
            return M.handleFlagItemClick(ze, kt);
          }, role: "option" }, Lt ? { "aria-selected": !0 } : {}), u.a.createElement("div", { className: Dt }), u.a.createElement("span", { className: "country-name" }, M.getDropdownCountryName(ze)), u.a.createElement("span", { className: "dial-code" }, ze.format ? M.formatNumber(ze.dialCode, ze) : Me + ze.dialCode));
        }), wt = u.a.createElement("li", { key: "dashes", className: "divider" });
        Z.length > 0 && (!ve || ve && !se.trim()) && ct.splice(Z.length, 0, wt);
        var mt = T()(s({ "country-list": !0, hide: !be }, M.props.dropdownClass, !0));
        return u.a.createElement("ul", { ref: function(ze) {
          return !ve && ze && ze.focus(), M.dropdownRef = ze;
        }, className: mt, style: M.props.dropdownStyle, role: "listbox", tabIndex: "0" }, ve && u.a.createElement("li", { className: T()(s({ search: !0 }, pe, pe)) }, !le && u.a.createElement("span", { className: T()(s({ "search-emoji": !0 }, "".concat(pe, "-emoji"), pe)), role: "img", "aria-label": "Magnifying glass" }, "🔎"), u.a.createElement("input", { className: T()(s({ "search-box": !0 }, "".concat(pe, "-box"), pe)), style: Ve, type: "search", placeholder: lt, autoFocus: !0, autoComplete: tt ? "on" : "off", value: se, onChange: M.handleSearchChange })), ct.length > 0 ? ct : u.a.createElement("li", { className: "no-entries-message" }, u.a.createElement("span", null, Ee)));
      };
      var te, ce = new j(G.enableAreaCodes, G.enableTerritories, G.regions, G.onlyCountries, G.preferredCountries, G.excludeCountries, G.preserveOrder, G.masks, G.priority, G.areaCodes, G.localization, G.prefix, G.defaultMask, G.alwaysDefaultMask), he = ce.onlyCountries, Ue = ce.preferredCountries, $ = ce.hiddenAreaCodes, ne = G.value ? G.value.replace(/\D/g, "") : "";
      te = G.disableInitialCountryGuess ? 0 : ne.length > 1 ? M.guessSelectedCountry(ne.substring(0, 6), G.country, he, $) || 0 : G.country && he.find(function(V) {
        return V.iso2 == G.country;
      }) || 0;
      var ye, ue = ne.length < 2 && te && !R()(ne, te.dialCode) ? te.dialCode : "";
      ye = ne === "" && te === 0 ? "" : M.formatNumber((G.disableCountryCode ? "" : ue) + ne, te.name ? te : void 0);
      var je = he.findIndex(function(V) {
        return V == te;
      });
      return M.state = { showDropdown: G.showDropdown, formattedNumber: ye, onlyCountries: he, preferredCountries: Ue, hiddenAreaCodes: $, selectedCountry: te, highlightCountryIndex: je, queryString: "", freezeSelection: !1, debouncedQueryStingSearcher: p()(M.searchCountry, 250), searchValue: "" }, M;
    }
    var K, Q;
    return function(G, M) {
      if (typeof M != "function" && M !== null)
        throw new TypeError("Super expression must either be null or a function");
      G.prototype = Object.create(M && M.prototype, { constructor: { value: G, writable: !0, configurable: !0 } }), M && w(G, M);
    }(W, q), K = W, (Q = [{ key: "componentDidMount", value: function() {
      document.addEventListener && this.props.enableClickOutside && document.addEventListener("mousedown", this.handleClickOutside), this.props.onMount && this.props.onMount(this.state.formattedNumber.replace(/[^0-9]+/g, ""), this.getCountryData(), this.state.formattedNumber);
    } }, { key: "componentWillUnmount", value: function() {
      document.removeEventListener && this.props.enableClickOutside && document.removeEventListener("mousedown", this.handleClickOutside);
    } }, { key: "componentDidUpdate", value: function(G, M, te) {
      G.country !== this.props.country ? this.updateCountry(this.props.country) : G.value !== this.props.value && this.updateFormattedNumber(this.props.value);
    } }, { key: "updateFormattedNumber", value: function(G) {
      if (G === null)
        return this.setState({ selectedCountry: 0, formattedNumber: "" });
      var M = this.state, te = M.onlyCountries, ce = M.selectedCountry, he = M.hiddenAreaCodes, Ue = this.props, $ = Ue.country, ne = Ue.prefix;
      if (G === "")
        return this.setState({ selectedCountry: ce, formattedNumber: "" });
      var ye, ue, je = G.replace(/\D/g, "");
      if (ce && R()(G, ne + ce.dialCode))
        ue = this.formatNumber(je, ce), this.setState({ formattedNumber: ue });
      else {
        var V = (ye = this.props.disableCountryGuess ? ce : this.guessSelectedCountry(je.substring(0, 6), $, te, he) || ce) && R()(je, ne + ye.dialCode) ? ye.dialCode : "";
        ue = this.formatNumber((this.props.disableCountryCode ? "" : V) + je, ye || void 0), this.setState({ selectedCountry: ye, formattedNumber: ue });
      }
    } }, { key: "render", value: function() {
      var G, M, te, ce = this, he = this.state, Ue = he.onlyCountries, $ = he.selectedCountry, ne = he.showDropdown, ye = he.formattedNumber, ue = he.hiddenAreaCodes, je = this.props, V = je.disableDropdown, Z = je.renderStringAsFlag, re = je.isValid, be = je.defaultErrorMessage, se = je.specialLabel;
      if (typeof re == "boolean")
        M = re;
      else {
        var Se = re(ye.replace(/\D/g, ""), $, Ue, ue);
        typeof Se == "boolean" ? (M = Se) === !1 && (te = be) : (M = !1, te = Se);
      }
      var Ce = T()((s(G = {}, this.props.containerClass, !0), s(G, "react-tel-input", !0), G)), Me = T()({ arrow: !0, up: ne }), de = T()(s({ "form-control": !0, "invalid-number": !M, open: ne }, this.props.inputClass, !0)), ve = T()({ "selected-flag": !0, open: ne }), Ee = T()(s({ "flag-dropdown": !0, "invalid-number": !M, open: ne }, this.props.buttonClass, !0)), le = "flag ".concat($ && $.iso2);
      return u.a.createElement("div", { className: "".concat(Ce, " ").concat(this.props.className), style: this.props.style || this.props.containerStyle, onKeyDown: this.handleKeydown }, se && u.a.createElement("div", { className: "special-label" }, se), te && u.a.createElement("div", { className: "invalid-number-message" }, te), u.a.createElement("input", Object.assign({ className: de, style: this.props.inputStyle, onChange: this.handleInput, onClick: this.handleInputClick, onDoubleClick: this.handleDoubleClick, onFocus: this.handleInputFocus, onBlur: this.handleInputBlur, onCopy: this.handleInputCopy, value: ye, onKeyDown: this.handleInputKeyDown, placeholder: this.props.placeholder, disabled: this.props.disabled, type: "tel" }, this.props.inputProps, { ref: function(pe) {
        ce.numberInputRef = pe, typeof ce.props.inputProps.ref == "function" ? ce.props.inputProps.ref(pe) : typeof ce.props.inputProps.ref == "object" && (ce.props.inputProps.ref.current = pe);
      } })), u.a.createElement("div", { className: Ee, style: this.props.buttonStyle, ref: function(pe) {
        return ce.dropdownContainerRef = pe;
      } }, Z ? u.a.createElement("div", { className: ve }, Z) : u.a.createElement("div", { onClick: V ? void 0 : this.handleFlagDropdownClick, className: ve, title: $ ? "".concat($.localName || $.name, ": + ").concat($.dialCode) : "", tabIndex: V ? "-1" : "0", role: "button", "aria-haspopup": "listbox", "aria-expanded": !!ne || void 0 }, u.a.createElement("div", { className: le }, !V && u.a.createElement("div", { className: Me }))), ne && this.getCountryDropdownList()));
    } }]) && h(K.prototype, Q), W;
  }(u.a.Component);
  F.defaultProps = { country: "", value: "", onlyCountries: [], preferredCountries: [], excludeCountries: [], placeholder: "1 (702) 123-4567", searchPlaceholder: "search", searchNotFound: "No entries to show", flagsImagePath: "./flags.png", disabled: !1, containerStyle: {}, inputStyle: {}, buttonStyle: {}, dropdownStyle: {}, searchStyle: {}, containerClass: "", inputClass: "", buttonClass: "", dropdownClass: "", searchClass: "", className: "", autoFormat: !0, enableAreaCodes: !1, enableTerritories: !1, disableCountryCode: !1, disableDropdown: !1, enableLongNumbers: !1, countryCodeEditable: !0, enableSearch: !1, disableSearchIcon: !1, disableInitialCountryGuess: !1, disableCountryGuess: !1, regions: "", inputProps: {}, localization: {}, masks: null, priority: null, areaCodes: null, preserveOrder: [], defaultMask: "... ... ... ... ..", alwaysDefaultMask: !1, prefix: "+", copyNumbersOnly: !0, renderStringAsFlag: "", autocompleteSearch: !1, jumpCursorToEnd: !0, enableAreaCodeStretch: !1, enableClickOutside: !0, showDropdown: !1, isValid: !0, defaultErrorMessage: "", specialLabel: "Phone", onEnterKeyPress: null, keys: { UP: 38, DOWN: 40, RIGHT: 39, LEFT: 37, ENTER: 13, ESC: 27, PLUS: 43, A: 65, Z: 90, SPACE: 32, TAB: 9 } }, e.default = F;
}]);
const nS = /* @__PURE__ */ ms(iS), sS = "Afganistán", rS = "Albania", oS = "Alemania", aS = "Andorra", lS = "Angola", cS = "Anguila", uS = "Antártida", dS = "Antigua y Barbuda", fS = "Arabia Saudí", hS = "Argelia", pS = "Argentina", mS = "Armenia", gS = "Aruba", yS = "Australia", vS = "Austria", bS = "Azerbaiyán", xS = "Bahamas", SS = "Bangladés", wS = "Barbados", AS = "Baréin", CS = "Bélgica", ES = "Belice", kS = "Benín", OS = "Bermudas", TS = "Bielorrusia", IS = "Bolivia", US = "Bosnia y Herzegovina", zS = "Botsuana", RS = "Brasil", PS = "Brunéi", MS = "Bulgaria", jS = "Burkina Faso", LS = "Burundi", DS = "Bután", NS = "Cabo Verde", FS = "Camboya", BS = "Camerún", qS = "Canadá", HS = "Canarias", VS = "Caribe neerlandés", GS = "Catar", WS = "Ceuta y Melilla", KS = "Chad", YS = "Chequia", JS = "Chile", ZS = "China", QS = "Chipre", XS = "Ciudad del Vaticano", _S = "Colombia", $S = "Comoras", e0 = "Congo", t0 = "Corea del Norte", i0 = "Corea del Sur", n0 = "Costa Rica", s0 = "Côte d’Ivoire", r0 = "Croacia", o0 = "Cuba", a0 = "Curazao", l0 = "Diego García", c0 = "Dinamarca", u0 = "Dominica", d0 = "Ecuador", f0 = "Egipto", h0 = "El Salvador", p0 = "Emiratos Árabes Unidos", m0 = "Eritrea", g0 = "Eslovaquia", y0 = "Eslovenia", v0 = "España", b0 = "Estados Unidos", x0 = "Estonia", S0 = "Esuatini", w0 = "Etiopía", A0 = "Filipinas", C0 = "Finlandia", E0 = "Fiyi", k0 = "Francia", O0 = "Gabón", T0 = "Gambia", I0 = "Georgia", U0 = "Ghana", z0 = "Gibraltar", R0 = "Granada", P0 = "Grecia", M0 = "Groenlandia", j0 = "Guadalupe", L0 = "Guam", D0 = "Guatemala", N0 = "Guayana Francesa", F0 = "Guernsey", B0 = "Guinea", q0 = "Guinea Ecuatorial", H0 = "Guinea-Bisáu", V0 = "Guyana", G0 = "Haití", W0 = "Honduras", K0 = "Hungría", Y0 = "Indonesia", J0 = "Irak", Z0 = "Irán", Q0 = "Irlanda", X0 = "Isla de la Ascensión", _0 = "Isla de Man", $0 = "Isla de Navidad", ew = "Isla Norfolk", tw = "Islandia", iw = "Islas Åland", nw = "Islas Caimán", sw = "Islas Cocos", rw = "Islas Cook", ow = "Islas Feroe", aw = "Islas Georgia del Sur y Sandwich del Sur", lw = "Islas Malvinas", cw = "Islas Marianas del Norte", uw = "Islas Marshall", dw = "Islas menores alejadas de EE. UU.", fw = "Islas Pitcairn", hw = "Islas Salomón", pw = "Islas Turcas y Caicos", mw = "Islas Vírgenes Británicas", gw = "Islas Vírgenes de EE. UU.", yw = "Israel", vw = "Italia", bw = "Jamaica", xw = "Japón", Sw = "Jersey", ww = "Jordania", Aw = "Kazajistán", Cw = "Kenia", Ew = "Kirguistán", kw = "Kiribati", Ow = "Kosovo", Tw = "Kuwait", Iw = "Laos", Uw = "Lesoto", zw = "Letonia", Rw = "Líbano", Pw = "Liberia", Mw = "Libia", jw = "Liechtenstein", Lw = "Lituania", Dw = "Luxemburgo", Nw = "Macedonia", Fw = "Madagascar", Bw = "Malasia", qw = "Malaui", Hw = "Maldivas", Vw = "Mali", Gw = "Malta", Ww = "Marruecos", Kw = "Martinica", Yw = "Mauricio", Jw = "Mauritania", Zw = "Mayotte", Qw = "México", Xw = "Micronesia", _w = "Moldavia", $w = "Mónaco", eA = "Mongolia", tA = "Montenegro", iA = "Montserrat", nA = "Mozambique", sA = "Myanmar", rA = "Namibia", oA = "Nauru", aA = "Nepal", lA = "Nicaragua", cA = "Níger", uA = "Nigeria", dA = "Niue", fA = "Noruega", hA = "Nueva Caledonia", pA = "Nueva Zelanda", mA = "Omán", gA = "Países Bajos", yA = "Pakistán", vA = "Palaos", bA = "Panamá", xA = "Papúa Nueva Guinea", SA = "Paraguay", wA = "Perú", AA = "Polinesia Francesa", CA = "Polonia", EA = "Portugal", kA = "Puerto Rico", OA = "RAE de Hong Kong", TA = "RAE de Macao", IA = "Reino Unido", UA = "República Centroafricana", zA = "República Democrática del Congo", RA = "Reunión", PA = "Ruanda", MA = "Rumanía", jA = "Rusia", LA = "Sáhara Occidental", DA = "Samoa", NA = "Samoa Americana", FA = "San Bartolomé", BA = "San Cristóbal y Nieves", qA = "San Marino", HA = "San Martín", VA = "San Pedro y Miquelón", GA = "San Vicente y las Granadinas", WA = "Santa Elena", KA = "Santa Lucía", YA = "Santo Tomé y Príncipe", JA = "Senegal", ZA = "Serbia", QA = "Seychelles", XA = "Sierra Leona", _A = "Singapur", $A = "Sint Maarten", e1 = "Siria", t1 = "Somalia", i1 = "Sri Lanka", n1 = "Sudáfrica", s1 = "Sudán", r1 = "Sudán del Sur", o1 = "Suecia", a1 = "Suiza", l1 = "Surinam", c1 = "Svalbard y Jan Mayen", u1 = "Tailandia", d1 = "Taiwán", f1 = "Tanzania", h1 = "Tayikistán", p1 = "Territorio Británico del Océano Índico", m1 = "Territorios Australes Franceses", g1 = "Territorios Palestinos", y1 = "Timor-Leste", v1 = "Togo", b1 = "Tokelau", x1 = "Tonga", S1 = "Trinidad y Tobago", w1 = "Tristán de Acuña", A1 = "Túnez", C1 = "Turkmenistán", E1 = "Turquía", k1 = "Tuvalu", O1 = "Ucrania", T1 = "Uganda", I1 = "Uruguay", U1 = "Uzbekistán", z1 = "Vanuatu", R1 = "Venezuela", P1 = "Vietnam", M1 = "Wallis y Futuna", j1 = "Yemen", L1 = "Yibuti", D1 = "Zambia", N1 = "Zimbabue", F1 = {
  af: sS,
  al: rS,
  de: oS,
  ad: aS,
  ao: lS,
  ai: cS,
  aq: uS,
  ag: dS,
  sa: fS,
  dz: hS,
  ar: pS,
  am: mS,
  aw: gS,
  au: yS,
  at: vS,
  az: bS,
  bs: xS,
  bd: SS,
  bb: wS,
  bh: AS,
  be: CS,
  bz: ES,
  bj: kS,
  bm: OS,
  by: TS,
  bo: IS,
  ba: US,
  bw: zS,
  br: RS,
  bn: PS,
  bg: MS,
  bf: jS,
  bi: LS,
  bt: DS,
  cv: NS,
  kh: FS,
  cm: BS,
  ca: qS,
  ic: HS,
  bq: VS,
  qa: GS,
  ea: WS,
  td: KS,
  cz: YS,
  cl: JS,
  cn: ZS,
  cy: QS,
  va: XS,
  co: _S,
  km: $S,
  cg: e0,
  kp: t0,
  kr: i0,
  cr: n0,
  ci: s0,
  hr: r0,
  cu: o0,
  cw: a0,
  dg: l0,
  dk: c0,
  dm: u0,
  ec: d0,
  eg: f0,
  sv: h0,
  ae: p0,
  er: m0,
  sk: g0,
  si: y0,
  es: v0,
  us: b0,
  ee: x0,
  sz: S0,
  et: w0,
  ph: A0,
  fi: C0,
  fj: E0,
  fr: k0,
  ga: O0,
  gm: T0,
  ge: I0,
  gh: U0,
  gi: z0,
  gd: R0,
  gr: P0,
  gl: M0,
  gp: j0,
  gu: L0,
  gt: D0,
  gf: N0,
  gg: F0,
  gn: B0,
  gq: q0,
  gw: H0,
  gy: V0,
  ht: G0,
  hn: W0,
  hu: K0,
  in: "India",
  id: Y0,
  iq: J0,
  ir: Z0,
  ie: Q0,
  ac: X0,
  im: _0,
  cx: $0,
  nf: ew,
  is: tw,
  ax: iw,
  ky: nw,
  cc: sw,
  ck: rw,
  fo: ow,
  gs: aw,
  fk: lw,
  mp: cw,
  mh: uw,
  um: dw,
  pn: fw,
  sb: hw,
  tc: pw,
  vg: mw,
  vi: gw,
  il: yw,
  it: vw,
  jm: bw,
  jp: xw,
  je: Sw,
  jo: ww,
  kz: Aw,
  ke: Cw,
  kg: Ew,
  ki: kw,
  xk: Ow,
  kw: Tw,
  la: Iw,
  ls: Uw,
  lv: zw,
  lb: Rw,
  lr: Pw,
  ly: Mw,
  li: jw,
  lt: Lw,
  lu: Dw,
  mk: Nw,
  mg: Fw,
  my: Bw,
  mw: qw,
  mv: Hw,
  ml: Vw,
  mt: Gw,
  ma: Ww,
  mq: Kw,
  mu: Yw,
  mr: Jw,
  yt: Zw,
  mx: Qw,
  fm: Xw,
  md: _w,
  mc: $w,
  mn: eA,
  me: tA,
  ms: iA,
  mz: nA,
  mm: sA,
  na: rA,
  nr: oA,
  np: aA,
  ni: lA,
  ne: cA,
  ng: uA,
  nu: dA,
  no: fA,
  nc: hA,
  nz: pA,
  om: mA,
  nl: gA,
  pk: yA,
  pw: vA,
  pa: bA,
  pg: xA,
  py: SA,
  pe: wA,
  pf: AA,
  pl: CA,
  pt: EA,
  pr: kA,
  hk: OA,
  mo: TA,
  gb: IA,
  cf: UA,
  cd: zA,
  do: "República Dominicana",
  re: RA,
  rw: PA,
  ro: MA,
  ru: jA,
  eh: LA,
  ws: DA,
  as: NA,
  bl: FA,
  kn: BA,
  sm: qA,
  mf: HA,
  pm: VA,
  vc: GA,
  sh: WA,
  lc: KA,
  st: YA,
  sn: JA,
  rs: ZA,
  sc: QA,
  sl: XA,
  sg: _A,
  sx: $A,
  sy: e1,
  so: t1,
  lk: i1,
  za: n1,
  sd: s1,
  ss: r1,
  se: o1,
  ch: a1,
  sr: l1,
  sj: c1,
  th: u1,
  tw: d1,
  tz: f1,
  tj: h1,
  io: p1,
  tf: m1,
  ps: g1,
  tl: y1,
  tg: v1,
  tk: b1,
  to: x1,
  tt: S1,
  ta: w1,
  tn: A1,
  tm: C1,
  tr: E1,
  tv: k1,
  ua: O1,
  ug: T1,
  uy: I1,
  uz: U1,
  vu: z1,
  ve: R1,
  vn: P1,
  wf: M1,
  ye: j1,
  dj: L1,
  zm: D1,
  zw: N1
}, B1 = "Afeganistão", q1 = "África do Sul", H1 = "Albânia", V1 = "Alemanha", G1 = "Andorra", W1 = "Angola", K1 = "Anguila", Y1 = "Antártida", J1 = "Antígua e Barbuda", Z1 = "Arábia Saudita", Q1 = "Argélia", X1 = "Argentina", _1 = "Armênia", $1 = "Aruba", eC = "Austrália", tC = "Áustria", iC = "Azerbaijão", nC = "Bahamas", sC = "Bahrein", rC = "Bangladesh", oC = "Barbados", aC = "Bélgica", lC = "Belize", cC = "Benin", uC = "Bermudas", dC = "Bielorrússia", fC = "Bolívia", hC = "Bósnia e Herzegovina", pC = "Botsuana", mC = "Brasil", gC = "Brunei", yC = "Bulgária", vC = "Burquina Faso", bC = "Burundi", xC = "Butão", SC = "Cabo Verde", wC = "Camarões", AC = "Camboja", CC = "Canadá", EC = "Catar", kC = "Cazaquistão", OC = "Ceuta e Melilla", TC = "Chade", IC = "Chile", UC = "China", zC = "Chipre", RC = "Cidade do Vaticano", PC = "Colômbia", MC = "Comores", jC = "Congo - Kinshasa", LC = "Coreia do Norte", DC = "Coreia do Sul", NC = "Costa do Marfim", FC = "Costa Rica", BC = "Croácia", qC = "Cuba", HC = "Curaçao", VC = "Diego Garcia", GC = "Dinamarca", WC = "Djibuti", KC = "Dominica", YC = "Egito", JC = "El Salvador", ZC = "Emirados Árabes Unidos", QC = "Equador", XC = "Eritreia", _C = "Eslováquia", $C = "Eslovênia", eE = "Espanha", tE = "Estados Unidos", iE = "Estônia", nE = "Etiópia", sE = "Fiji", rE = "Filipinas", oE = "Finlândia", aE = "França", lE = "Gabão", cE = "Gâmbia", uE = "Gana", dE = "Geórgia", fE = "Gibraltar", hE = "Granada", pE = "Grécia", mE = "Groenlândia", gE = "Guadalupe", yE = "Guam", vE = "Guatemala", bE = "Guernsey", xE = "Guiana", SE = "Guiana Francesa", wE = "Guiné", AE = "Guiné Equatorial", CE = "Guiné-Bissau", EE = "Haiti", kE = "Honduras", OE = "Hong Kong, RAE da China", TE = "Hungria", IE = "Iêmen", UE = "Ilha Christmas", zE = "Ilha de Ascensão", RE = "Ilha de Man", PE = "Ilha Norfolk", ME = "Ilhas Aland", jE = "Ilhas Canárias", LE = "Ilhas Cayman", DE = "Ilhas Cocos", NE = "Ilhas Cook", FE = "Ilhas Faroe", BE = "Ilhas Geórgia do Sul e Sandwich do Sul", qE = "Ilhas Malvinas", HE = "Ilhas Marianas do Norte", VE = "Ilhas Marshall", GE = "Ilhas Menores Distantes dos EUA", WE = "Ilhas Pitcairn", KE = "Ilhas Salomão", YE = "Ilhas Turcas e Caicos", JE = "Ilhas Virgens Americanas", ZE = "Ilhas Virgens Britânicas", QE = "Indonésia", XE = "Irã", _E = "Iraque", $E = "Irlanda", ek = "Islândia", tk = "Israel", ik = "Itália", nk = "Jamaica", sk = "Japão", rk = "Jersey", ok = "Jordânia", ak = "Kosovo", lk = "Kuwait", ck = "Laos", uk = "Lesoto", dk = "Letônia", fk = "Líbano", hk = "Libéria", pk = "Líbia", mk = "Liechtenstein", gk = "Lituânia", yk = "Luxemburgo", vk = "Macau, RAE da China", bk = "Macedônia do Norte", xk = "Madagascar", Sk = "Malásia", wk = "Malaui", Ak = "Maldivas", Ck = "Mali", Ek = "Malta", kk = "Marrocos", Ok = "Martinica", Tk = "Maurício", Ik = "Mauritânia", Uk = "Mayotte", zk = "México", Rk = "Mianmar", Pk = "Micronésia", Mk = "Moçambique", jk = "Moldova", Lk = "Mônaco", Dk = "Mongólia", Nk = "Montenegro", Fk = "Montserrat", Bk = "Namíbia", qk = "Nauru", Hk = "Nepal", Vk = "Nicarágua", Gk = "Níger", Wk = "Nigéria", Kk = "Niue", Yk = "Noruega", Jk = "Nova Caledônia", Zk = "Nova Zelândia", Qk = "Omã", Xk = "Países Baixos", _k = "Países Baixos Caribenhos", $k = "Palau", eO = "Panamá", tO = "Papua-Nova Guiné", iO = "Paquistão", nO = "Paraguai", sO = "Peru", rO = "Polinésia Francesa", oO = "Polônia", aO = "Porto Rico", lO = "Portugal", cO = "Quênia", uO = "Quirguistão", dO = "Quiribati", fO = "Reino Unido", hO = "República Centro-Africana", pO = "República do Congo", mO = "Reunião", gO = "Romênia", yO = "Ruanda", vO = "Rússia", bO = "Saara Ocidental", xO = "Samoa", SO = "Samoa Americana", wO = "San Marino", AO = "Santa Helena", CO = "Santa Lúcia", EO = "São Bartolomeu", kO = "São Cristóvão e Névis", OO = "São Martinho", TO = "São Pedro e Miquelão", IO = "São Tomé e Príncipe", UO = "São Vicente e Granadinas", zO = "Seicheles", RO = "Senegal", PO = "Serra Leoa", MO = "Sérvia", jO = "Singapura", LO = "Sint Maarten", DO = "Síria", NO = "Somália", FO = "Sri Lanka", BO = "Suazilândia", qO = "Sudão", HO = "Sudão do Sul", VO = "Suécia", GO = "Suíça", WO = "Suriname", KO = "Svalbard e Jan Mayen", YO = "Tadjiquistão", JO = "Tailândia", ZO = "Taiwan", QO = "Tanzânia", XO = "Tchéquia", _O = "Território Britânico do Oceano Índico", $O = "Territórios Franceses do Sul", eT = "Territórios palestinos", tT = "Timor-Leste", iT = "Togo", nT = "Tokelau", sT = "Tonga", rT = "Trinidad e Tobago", oT = "Tristão da Cunha", aT = "Tunísia", lT = "Turcomenistão", cT = "Turquia", uT = "Tuvalu", dT = "Ucrânia", fT = "Uganda", hT = "Uruguai", pT = "Uzbequistão", mT = "Vanuatu", gT = "Venezuela", yT = "Vietnã", vT = "Wallis e Futuna", bT = "Zâmbia", xT = "Zimbábue", Eu = {
  af: B1,
  za: q1,
  al: H1,
  de: V1,
  ad: G1,
  ao: W1,
  ai: K1,
  aq: Y1,
  ag: J1,
  sa: Z1,
  dz: Q1,
  ar: X1,
  am: _1,
  aw: $1,
  au: eC,
  at: tC,
  az: iC,
  bs: nC,
  bh: sC,
  bd: rC,
  bb: oC,
  be: aC,
  bz: lC,
  bj: cC,
  bm: uC,
  by: dC,
  bo: fC,
  ba: hC,
  bw: pC,
  br: mC,
  bn: gC,
  bg: yC,
  bf: vC,
  bi: bC,
  bt: xC,
  cv: SC,
  cm: wC,
  kh: AC,
  ca: CC,
  qa: EC,
  kz: kC,
  ea: OC,
  td: TC,
  cl: IC,
  cn: UC,
  cy: zC,
  va: RC,
  co: PC,
  km: MC,
  cd: jC,
  kp: LC,
  kr: DC,
  ci: NC,
  cr: FC,
  hr: BC,
  cu: qC,
  cw: HC,
  dg: VC,
  dk: GC,
  dj: WC,
  dm: KC,
  eg: YC,
  sv: JC,
  ae: ZC,
  ec: QC,
  er: XC,
  sk: _C,
  si: $C,
  es: eE,
  us: tE,
  ee: iE,
  et: nE,
  fj: sE,
  ph: rE,
  fi: oE,
  fr: aE,
  ga: lE,
  gm: cE,
  gh: uE,
  ge: dE,
  gi: fE,
  gd: hE,
  gr: pE,
  gl: mE,
  gp: gE,
  gu: yE,
  gt: vE,
  gg: bE,
  gy: xE,
  gf: SE,
  gn: wE,
  gq: AE,
  gw: CE,
  ht: EE,
  hn: kE,
  hk: OE,
  hu: TE,
  ye: IE,
  cx: UE,
  ac: zE,
  im: RE,
  nf: PE,
  ax: ME,
  ic: jE,
  ky: LE,
  cc: DE,
  ck: NE,
  fo: FE,
  gs: BE,
  fk: qE,
  mp: HE,
  mh: VE,
  um: GE,
  pn: WE,
  sb: KE,
  tc: YE,
  vi: JE,
  vg: ZE,
  in: "Índia",
  id: QE,
  ir: XE,
  iq: _E,
  ie: $E,
  is: ek,
  il: tk,
  it: ik,
  jm: nk,
  jp: sk,
  je: rk,
  jo: ok,
  xk: ak,
  kw: lk,
  la: ck,
  ls: uk,
  lv: dk,
  lb: fk,
  lr: hk,
  ly: pk,
  li: mk,
  lt: gk,
  lu: yk,
  mo: vk,
  mk: bk,
  mg: xk,
  my: Sk,
  mw: wk,
  mv: Ak,
  ml: Ck,
  mt: Ek,
  ma: kk,
  mq: Ok,
  mu: Tk,
  mr: Ik,
  yt: Uk,
  mx: zk,
  mm: Rk,
  fm: Pk,
  mz: Mk,
  md: jk,
  mc: Lk,
  mn: Dk,
  me: Nk,
  ms: Fk,
  na: Bk,
  nr: qk,
  np: Hk,
  ni: Vk,
  ne: Gk,
  ng: Wk,
  nu: Kk,
  no: Yk,
  nc: Jk,
  nz: Zk,
  om: Qk,
  nl: Xk,
  bq: _k,
  pw: $k,
  pa: eO,
  pg: tO,
  pk: iO,
  py: nO,
  pe: sO,
  pf: rO,
  pl: oO,
  pr: aO,
  pt: lO,
  ke: cO,
  kg: uO,
  ki: dO,
  gb: fO,
  cf: hO,
  cg: pO,
  do: "República Dominicana",
  re: mO,
  ro: gO,
  rw: yO,
  ru: vO,
  eh: bO,
  ws: xO,
  as: SO,
  sm: wO,
  sh: AO,
  lc: CO,
  bl: EO,
  kn: kO,
  mf: OO,
  pm: TO,
  st: IO,
  vc: UO,
  sc: zO,
  sn: RO,
  sl: PO,
  rs: MO,
  sg: jO,
  sx: LO,
  sy: DO,
  so: NO,
  lk: FO,
  sz: BO,
  sd: qO,
  ss: HO,
  se: VO,
  ch: GO,
  sr: WO,
  sj: KO,
  tj: YO,
  th: JO,
  tw: ZO,
  tz: QO,
  cz: XO,
  io: _O,
  tf: $O,
  ps: eT,
  tl: tT,
  tg: iT,
  tk: nT,
  to: sT,
  tt: rT,
  ta: oT,
  tn: aT,
  tm: lT,
  tr: cT,
  tv: uT,
  ua: dT,
  ug: fT,
  uy: hT,
  uz: pT,
  vu: mT,
  ve: gT,
  vn: yT,
  wf: vT,
  zm: bT,
  zw: xT
};
const ST = 800, wT = {
  pt: Eu,
  es: F1
}, M2 = ({
  value: n,
  externalError: e,
  required: t,
  type: s,
  label: r,
  className: a = "",
  id: c,
  country: l = "br",
  leftLabel: d,
  rightLabel: h,
  errorIcon: m = /* @__PURE__ */ A.jsx("i", { className: "fa-regular fa-exclamation-triangle" }),
  loading: y,
  externalIcon: b,
  errorSpan: v = !0,
  requiredOnLoad: w = !1,
  maxLength: o,
  placeholder: u = "XX XXXX - XXXX",
  disabled: f = !1,
  backgroundColor: p = "var(--background)",
  onValidate: g,
  onChange: S,
  onTimeout: x
}) => {
  var z;
  const { t: E, i18n: k } = Ze(), R = `random-id-${(1 + Date.now() + Math.random()).toString().replace(".", "")}`, O = new Ai(), [T, D] = X(wT[k == null ? void 0 : k.language]), [P, N] = X(null), [I, C] = X({
    value: n,
    error: ""
  });
  ee(() => {
    I.value !== n && U(n);
  }, [n, I.value]), ee(() => () => {
    clearTimeout(P);
  }, [P]);
  const U = (j) => {
    const F = { value: "", error: "" };
    F.value = j || "", e ? F.error = "" : t && (!F.value || F.value.length < 1) && F.value !== 0 ? F.error = E("required") : s === "tel" && !O.phone(F.value) ? F.error = E("invalidPhone") : F.error = "", C({ ...F }), g && typeof g == "function" && g(!F.error && !e), S && typeof S == "function" && S(j), x && typeof x == "function" && (x(!1), P && clearTimeout(P), N(
      setTimeout(() => {
        x(!0);
      }, ST)
    ));
  };
  return y ? /* @__PURE__ */ A.jsx(Et, {}) : /* @__PURE__ */ A.jsxs("div", { className: `wrapper-all-inside-input ${a}`, children: [
    r ? /* @__PURE__ */ A.jsx("label", { className: `label ${e || I.error ? "error " : ""}`, htmlFor: c || R, children: r }) : null,
    /* @__PURE__ */ A.jsxs("div", { className: `no-padding wrapper-input wrapper-input-squid ${e || I.error ? "error " : ""}`, children: [
      d ? /* @__PURE__ */ A.jsx("span", { className: "input-group-text", children: d }) : null,
      /* @__PURE__ */ A.jsx(
        nS,
        {
          inputClass: `col select ${f ? "disabled " : ""}${y ? "loading " : ""}${e || I.error ? "error " : ""}${b ? "has-icon-external " : ""}`,
          country: l,
          value: I.value,
          onChange: U,
          placeholder: u,
          inputStyle: {
            width: "100%",
            minHeight: "44px",
            borderColor: !I.error && !e ? "var(--border_color)" : "var(--red)",
            backgroundColor: p,
            color: "var(--text_color)"
          },
          buttonStyle: {
            borderColor: !I.error && !e ? "var(--border_color)" : "var(--red)",
            backgroundColor: p,
            borderRight: "none",
            color: "var(--text_color)"
          },
          dropdownStyle: { backgroundColor: "var(--background)", color: "var(--text_color)" },
          searchStyle: { backgroundColor: "var(--background)", color: "var(--text_color)" },
          containerStyle: { backgroundColor: p },
          enableSearch: !0,
          disableSearchIcon: !0,
          disabled: f,
          searchPlaceholder: E("search"),
          isValid: () => !I.error && !e,
          localization: T || Eu
        }
      ),
      h ? /* @__PURE__ */ A.jsx("span", { className: "input-group-text", children: h }) : null
    ] }),
    y ? /* @__PURE__ */ A.jsx(Et, { size: "small", className: `display-block loader-input ${r ? "" : "no-label"}`, style: { position: "absolute" } }) : null,
    b && !y ? /* @__PURE__ */ A.jsx("span", { className: `icon icon-external ${r ? "" : "no-label "}`, children: b }) : null,
    v ? /* @__PURE__ */ A.jsxs("div", { className: `box-validation box-invalid show ${o ? "has-max-length " : ""}`, children: [
      w && !I.value && !I.error && !e ? /* @__PURE__ */ A.jsxs("div", { children: [
        /* @__PURE__ */ A.jsx("i", { className: "fa-solid fa-diamond-exclamation gold" }),
        E("emptyField")
      ] }) : null,
      I.error || e ? m || /* @__PURE__ */ A.jsx("i", { className: "fa-regular fa-exclamation-triangle" }) : null,
      e || "",
      I.error && !e ? I.error : "",
      o ? /* @__PURE__ */ A.jsx("span", { className: "max-length-name", children: o - ((z = I.value) == null ? void 0 : z.length) }) : null
    ] }) : null
  ] });
};
const Po = ({
  type: n = "checkbox",
  name: e,
  id: t,
  value: s = "",
  checked: r = !1,
  disabled: a,
  readOnly: c,
  required: l,
  toggle: d,
  rightLabel: h,
  leftLabel: m,
  externalError: y,
  errorIcon: b = /* @__PURE__ */ A.jsx("i", { className: "fa-regular fa-exclamation-triangle" }),
  errorSpan: v = !0,
  hideInput: w,
  requiredOnLoad: o = !1,
  boxBgSecondary: u = !1,
  onChange: f,
  onEmitValue: p,
  onValidate: g,
  className: S = "",
  wrapperClass: x = "",
  labelFontSize: E = "1rem",
  style: k
}) => {
  const R = `random-id-${(1 + Date.now() + Math.random()).toString().replace(".", "")}`, [O, T] = X({
    value: s,
    error: "",
    checked: !1
  }), { t: D } = Ze();
  ee(() => {
    O.value !== s && T({ ...O, value: s }), O.checked !== r && T({ ...O, checked: r });
  }, [s, r, O]);
  const P = (N) => {
    var I;
    O.checked = ((I = N == null ? void 0 : N.target) == null ? void 0 : I.checked) || !1, y ? O.error = "" : l && !O.checked ? O.error = D("required") : O.error = "", T({ ...O }), g && typeof g == "function" && g(!O.error && !y), p && typeof p == "function" && p(O.value), f && typeof f == "function" && f(O.checked);
  };
  return /* @__PURE__ */ A.jsxs("div", { className: `selector ${S}`, children: [
    /* @__PURE__ */ A.jsxs(
      "div",
      {
        className: `wrapper-selectors ${r ? "checked " : ""}${O.error ? "error " : ""}${d ? "toggle " : ""} ${x}`,
        children: [
          m ? /* @__PURE__ */ A.jsx(
            "label",
            {
              className: `mr-2 label ${c ? "readonly " : ""}${y || O.error ? "error " : ""}`,
              htmlFor: t || R,
              style: { fontSize: E },
              children: m
            }
          ) : null,
          /* @__PURE__ */ A.jsx(
            "input",
            {
              id: t || R,
              name: e || R,
              type: n,
              onChange: P,
              required: l,
              disabled: a || c,
              readOnly: c,
              checked: r,
              value: s,
              style: { ...k }
            }
          ),
          /* @__PURE__ */ A.jsx(
            "label",
            {
              htmlFor: t || R,
              className: `checkbox ${n} ${a ? "disabled " : ""}${c ? "readonly " : ""}${w ? "hide-input " : ""}${u && !r ? "bg-secondary " : ""}`
            }
          ),
          h ? /* @__PURE__ */ A.jsx(
            "label",
            {
              className: `label ${c ? "readonly " : ""}${y || O.error ? "error " : ""}`,
              htmlFor: t || R,
              style: { fontSize: E },
              children: h
            }
          ) : null
        ]
      }
    ),
    v ? /* @__PURE__ */ A.jsxs("div", { className: "box-validation box-invalid show", children: [
      o && !O.value && !O.error && !y ? /* @__PURE__ */ A.jsxs("div", { children: [
        /* @__PURE__ */ A.jsx("i", { className: "fa-solid fa-diamond-exclamation gold" }),
        D("emptyField")
      ] }) : null,
      O.error || y ? b || /* @__PURE__ */ A.jsx("i", { className: "fa-regular fa-exclamation-triangle" }) : null,
      y || "",
      O.error && !y ? O.error : ""
    ] }) : null
  ] });
};
const j2 = ({
  className: n = "",
  label: e = "",
  externalError: t,
  leftLabel: s,
  rightLabel: r,
  id: a,
  name: c,
  autoComplete: l = "off",
  loading: d,
  externalIcon: h,
  errorSpan: m = !0,
  requiredOnLoad: y = !1,
  required: b,
  errorIcon: v = /* @__PURE__ */ A.jsx("i", { className: "fa-regular fa-exclamation-triangle" }),
  placeholder: w,
  maxSelectedOptions: o = null,
  disabled: u,
  readOnly: f,
  backgroundColor: p = "var(--background)",
  options: g,
  value: S,
  onChange: x,
  onValidate: E
}) => {
  var M, te, ce, he, Ue;
  const k = `random-id-${(1 + Date.now() + Math.random()).toString().replace(".", "")}`, R = xt(() => new ra(), []), O = Re(null), T = Re(null), [D, P] = X(0), [N, I] = X(!1), [C, U] = X({
    selectedOptions: [],
    availableOptions: g,
    searchFilter: "",
    error: ""
  }), [z, j] = X({
    selectedOptions: !1,
    searchFilter: !1
  }), { t: F } = Ze(), q = He(
    ($) => {
      x && typeof x == "function" && x($);
    },
    [x]
  ), W = He(
    ($) => {
      E && typeof E == "function" && E($);
    },
    [E]
  ), K = He(
    ($) => {
      var ne, ye;
      ($ && o && C.selectedOptions.length < o || !o) && (C.selectedOptions = [...C == null ? void 0 : C.selectedOptions], $ && C.selectedOptions.push($), t ? C.error = "" : b && !((ne = C == null ? void 0 : C.selectedOptions) != null && ne.length) ? C.error = F("required") : C.error = "", U({ ...C }), q(C == null ? void 0 : C.selectedOptions), W(!!b && ((ye = C == null ? void 0 : C.selectedOptions) == null ? void 0 : ye.length) < 1));
    },
    [t, o, b, C, F, q, W]
  ), Q = He(
    ($) => {
      var ne, ye, ue;
      $ && (C.selectedOptions = (ne = C == null ? void 0 : C.selectedOptions) == null ? void 0 : ne.filter((je) => (je == null ? void 0 : je.id) !== ($ == null ? void 0 : $.id)), t ? C.error = "" : b && !((ye = C == null ? void 0 : C.selectedOptions) != null && ye.length) ? C.error = F("required") : C.error = "", U({ ...C }), q(C == null ? void 0 : C.selectedOptions), W(!!((ue = C == null ? void 0 : C.selectedOptions) != null && ue.length)));
    },
    [t, b, C, F, q, W]
  ), G = He(
    ($, ne) => {
      $ ? K(g.find((ye) => (ye == null ? void 0 : ye.id) === (ne == null ? void 0 : ne.id))) : Q(g.find((ye) => (ye == null ? void 0 : ye.id) === (ne == null ? void 0 : ne.id)));
    },
    [Q, K, g]
  );
  return ee(() => {
    S && !(R != null && R.compareObjects(S, C.selectedOptions)) && (S == null || S.forEach(($) => K($)));
  }, [S, K, R, C.selectedOptions]), ee(() => {
    function $(ne) {
      O.current && !O.current.contains(ne.target) && I(!1);
    }
    return document.addEventListener("mousedown", $), () => {
      document.removeEventListener("mousedown", $);
    };
  }), On(() => {
    var ne;
    const { height: $ } = ((ne = T.current) == null ? void 0 : ne.getBoundingClientRect()) || { height: 0 };
    P($ + 14);
  }, [C == null ? void 0 : C.selectedOptions]), /* @__PURE__ */ A.jsxs("div", { className: `wrapper-all-inside-input ${n}`, children: [
    e ? /* @__PURE__ */ A.jsxs("label", { className: `label ${t || C.error ? "error " : ""}`, htmlFor: a || k, children: [
      e,
      o ? /* @__PURE__ */ A.jsx("span", { className: "gray", children: ` (${F("fields.multiSelect.maxOptionsSelected", { count: o })})` }) : null
    ] }) : null,
    /* @__PURE__ */ A.jsxs("div", { className: `no-padding wrapper-input wrapper-input-squid ${t || C.error ? "error " : ""}`, children: [
      s ? /* @__PURE__ */ A.jsx("span", { className: "input-group-text", children: s }) : null,
      /* @__PURE__ */ A.jsx(
        "select",
        {
          className: `col select has-icon-extra-padding ${u ? "disabled " : ""}${f ? "readonly " : ""}${d ? "loading " : ""}${t || C.error ? "error " : ""}${h ? "has-icon-external " : ""}`,
          style: {
            backgroundColor: p,
            height: (M = C == null ? void 0 : C.selectedOptions) != null && M.length ? `${D}px` : "auto",
            borderRadius: "5px"
          },
          id: a || k,
          name: c || k,
          required: b,
          disabled: u || f || o && C.selectedOptions.length >= o || !((te = C == null ? void 0 : C.availableOptions) != null && te.length),
          onMouseDown: ($) => ($.preventDefault(), I(!0), !1),
          onClick: () => I(!0),
          autoComplete: l
        }
      ),
      /* @__PURE__ */ A.jsx("div", { className: "options-selected display-flex justify-content-start mx-3", style: { flexWrap: "wrap" }, ref: T, children: C == null ? void 0 : C.selectedOptions.map(($, ne) => /* @__PURE__ */ A.jsxs(
        Mi,
        {
          className: "option-selected-tag",
          onClick: () => Q($),
          color: "var(--background_secondary)",
          borderColor: "var(--border_color)",
          textColor: "var(--text_color)",
          style: { padding: "0 5px", border: "1px solid var(--gray_light)", display: "flex", gap: "5px" },
          children: [
            /* @__PURE__ */ A.jsx("span", { className: "text-normal", style: { fontWeight: "400" }, children: $ == null ? void 0 : $.label }),
            /* @__PURE__ */ A.jsx("span", { className: "text-bold", style: { fontWeight: "400" }, children: "x" })
          ]
        },
        `option-selected-tag-${ne}`
      )) }),
      r ? /* @__PURE__ */ A.jsx("span", { className: "input-group-text", children: r }) : null,
      N && /* @__PURE__ */ A.jsxs("div", { className: "box-options", ref: O, children: [
        /* @__PURE__ */ A.jsx(
          sa,
          {
            value: C == null ? void 0 : C.searchFilter,
            type: "text",
            className: "search-filter-multi-select-input p-3",
            name: "search-filter-multi-select-input",
            id: "search-filter-multi-select-input",
            onChange: ($) => U((ne) => ({ ...ne, searchFilter: $ })),
            onValidate: ($) => j((ne) => ({ ...ne, searchFilter: $ })),
            rightLabel: /* @__PURE__ */ A.jsx("i", { className: "fa-solid fa-search" }),
            errorSpan: !1,
            placeholder: F("search")
          }
        ),
        /* @__PURE__ */ A.jsx("ul", { className: "list-options scrollbar", children: (he = (ce = C == null ? void 0 : C.availableOptions) == null ? void 0 : ce.filter(($) => new RegExp((C == null ? void 0 : C.searchFilter) || "", "i").test($ == null ? void 0 : $.label))) == null ? void 0 : he.map(($, ne) => {
          var ye;
          return /* @__PURE__ */ A.jsx("li", { className: "option", style: { overflow: "hidden", padding: "1rem" }, children: /* @__PURE__ */ A.jsx(
            Po,
            {
              errorSpan: !1,
              type: "checkbox",
              value: $ == null ? void 0 : $.id,
              checked: !!((ye = C == null ? void 0 : C.selectedOptions) != null && ye.find((ue) => (ue == null ? void 0 : ue.id) === ($ == null ? void 0 : $.id))),
              rightLabel: $ == null ? void 0 : $.label,
              onChange: (ue) => G(ue, $)
            },
            `option-${ne}`
          ) }, `option-item-${ne}`);
        }) })
      ] })
    ] }),
    d ? /* @__PURE__ */ A.jsx(Et, { size: "small", className: `display-block loader-select ${e ? "" : "no-label"}`, style: { position: "absolute" } }) : null,
    h && !d ? /* @__PURE__ */ A.jsx("span", { className: `icon icon-external ${e ? "" : "no-label "}`, children: h }) : null,
    m ? /* @__PURE__ */ A.jsxs("div", { className: "box-validation box-invalid show", children: [
      y && !((Ue = C == null ? void 0 : C.selectedOptions) != null && Ue.length) && !C.error && !t ? /* @__PURE__ */ A.jsxs("div", { children: [
        /* @__PURE__ */ A.jsx("i", { className: "fa-solid fa-diamond-exclamation gold" }),
        F("emptyField")
      ] }) : null,
      C.error || t ? v || /* @__PURE__ */ A.jsx("i", { className: "fa-regular fa-exclamation-triangle" }) : null,
      t || "",
      C.error && !t ? C.error : ""
    ] }) : null
  ] });
};
const L2 = ({
  label: n,
  disabled: e,
  readOnly: t,
  errorSpan: s = !0,
  loading: r,
  required: a,
  externalError: c,
  errorIcon: l = /* @__PURE__ */ A.jsx("i", { className: "fa-regular fa-exclamation-triangle" }),
  id: d,
  name: h,
  leftLabel: m,
  rightLabel: y,
  externalIcon: b,
  value: v = "",
  placeholder: w,
  backgroundColor: o = "",
  autoComplete: u = "off",
  onChange: f,
  onValidate: p,
  className: g = "",
  children: S,
  requiredOnLoad: x = !1
}) => {
  const E = `random-id-${(1 + Date.now() + Math.random()).toString().replace(".", "")}`, [k, R] = X({
    value: v,
    error: ""
  }), { t: O } = Ze();
  ee(() => {
    k.value !== v && T(v);
  }, [v, k]);
  const T = (D) => {
    var P;
    k.value = ((P = D == null ? void 0 : D.target) == null ? void 0 : P.value) || (D != null && D.length ? D : ""), c ? k.error = "" : a && (!k.value || k.value.length < 1) && k.value !== 0 ? k.error = O("required") : k.error = "", R({ ...k }), p && typeof p == "function" && p(!k.error && !c), f && typeof f == "function" && f(k.value);
  };
  return /* @__PURE__ */ A.jsxs("div", { className: `wrapper-all-inside-input ${g}`, children: [
    n ? /* @__PURE__ */ A.jsx("label", { className: `label ${c || k.error ? "error " : ""}`, htmlFor: d || E, children: n }) : null,
    /* @__PURE__ */ A.jsxs("div", { className: `no-padding wrapper-input wrapper-input-squid ${c || k.error ? "error " : ""}`, children: [
      m ? /* @__PURE__ */ A.jsx("span", { className: "input-group-text", children: m }) : null,
      /* @__PURE__ */ A.jsxs(
        "select",
        {
          className: `col select has-icon-extra-padding ${e ? "disabled " : ""}${t ? "readonly " : ""}${r ? "loading " : ""}${c || k.error ? "error " : ""}${b ? "has-icon-external " : ""}`,
          style: {
            backgroundColor: o
          },
          id: d || E,
          name: h || E,
          value: k.value,
          required: a,
          disabled: e || t,
          onChange: T,
          autoComplete: u,
          children: [
            w ? /* @__PURE__ */ A.jsx("option", { value: "", disabled: !0, children: w }) : null,
            S
          ]
        }
      ),
      y ? /* @__PURE__ */ A.jsx("span", { className: "input-group-text", children: y }) : null
    ] }),
    r ? /* @__PURE__ */ A.jsx(Et, { size: "small", className: `display-block loader-select ${n ? "" : "no-label"}`, style: { position: "absolute" } }) : null,
    b && !r ? /* @__PURE__ */ A.jsx("span", { className: `icon icon-external ${n ? "" : "no-label "}`, children: b }) : null,
    s ? /* @__PURE__ */ A.jsxs("div", { className: "box-validation box-invalid show", children: [
      x && !k.value && !k.error && !c ? /* @__PURE__ */ A.jsxs("div", { children: [
        /* @__PURE__ */ A.jsx("i", { className: "fa-solid fa-diamond-exclamation gold" }),
        O("emptyField")
      ] }) : null,
      k.error || c ? l || /* @__PURE__ */ A.jsx("i", { className: "fa-regular fa-exclamation-triangle" }) : null,
      c || "",
      k.error && !c ? k.error : ""
    ] }) : null
  ] });
}, AT = 800, D2 = ({
  className: n = "",
  label: e = "",
  externalError: t,
  errorSpan: s = !0,
  requiredOnLoad: r = !1,
  noCounting: a = !1,
  errorIcon: c = /* @__PURE__ */ A.jsx("i", { className: "fa-regular fa-exclamation-triangle" }),
  name: l,
  id: d,
  leftLabel: h,
  rightLabel: m,
  readOnly: y = !1,
  disabled: b = !1,
  loading: v,
  externalIcon: w,
  backgroundColor: o = "",
  style: u,
  placeholder: f,
  maxLength: p,
  required: g,
  min: S,
  max: x,
  onChange: E,
  onValidate: k,
  onTimeout: R,
  onBlur: O,
  autoComplete: T = "off",
  autoFocus: D = !1,
  value: P = "",
  type: N = "text",
  lang: I = "en",
  ...C
}) => {
  var $;
  const U = xt(() => new Ai(), []), z = `random-id-${(1 + Date.now() + Math.random()).toString().replace(".", "")}`, [j, F] = X(null), [q, W] = X(""), [K, Q] = X({
    value: P,
    error: ""
  }), [G, M] = X("en-us"), { t: te } = Ze("sqInputBirthdaySimple");
  ee(() => {
    K.value !== P && he(P);
  }, [P, K.value]), ee(() => () => {
    clearTimeout(j);
  }, [j]), ee(() => {
    const ne = navigator.language.toLowerCase();
    I ? M(I) : ["pt-br", "es-es", "en-us"].includes(ne) && M(ne);
  }, [I]);
  const ce = (ne) => {
    if ((ne == null ? void 0 : ne.length) === 10) {
      const ye = ne.replace(/\D/g, ""), ue = ye.slice(0, 2), je = ye.slice(2, 4);
      return `${ye.slice(4, 8)}-${je}-${ue}`;
    }
    return "";
  }, he = (ne) => {
    var be;
    const ye = ((be = ne == null ? void 0 : ne.target) == null ? void 0 : be.value) || (ne != null && ne.length ? ne : ""), ue = ye == null ? void 0 : ye.replace(/\D/g, "");
    let je = !1, V = ue;
    G === "pt-br" || G === "es-es" ? ((ue == null ? void 0 : ue.length) > 2 && (V = (ue == null ? void 0 : ue.slice(0, 2)) + "/" + (ue == null ? void 0 : ue.slice(2))), (ue == null ? void 0 : ue.length) > 4 && (V = (ue == null ? void 0 : ue.slice(0, 2)) + "/" + (ue == null ? void 0 : ue.slice(2, 4)) + "/" + (ue == null ? void 0 : ue.slice(4, 8))), K.value = V) : (ue.length > 2 && (V = ue.slice(0, 2) + "/" + ue.slice(2)), ue.length > 4 && (V = ue.slice(0, 2) + "/" + ue.slice(2, 4) + "/" + ue.slice(4, 8))), je = (V == null ? void 0 : V.length) === 10;
    const Z = U.ageLessThan(ce(ye), 18), re = U.ageOverThan(ce(ye), 100);
    t ? K.error = "" : g && !V && K.value !== 0 ? K.error = te("required") : Z ? K.error = te("ageUnder18") : re ? K.error = te("overThan100") : K.error = "", W(V), K.value = ce(ye), Q({ ...K }), k && typeof k == "function" && k(!K.error && !t && je), E && typeof E == "function" && E(K.value), R && typeof R == "function" && (R(!1), j && clearTimeout(j), F(
      setTimeout(() => {
        R(!0);
      }, AT)
    ));
  }, Ue = He(
    (ne) => {
      O && typeof O == "function" && O(K.value, ne);
    },
    [O, K.value]
  );
  return /* @__PURE__ */ A.jsxs("div", { className: `wrapper-all-inside-input ${n}`, ...C, children: [
    e ? /* @__PURE__ */ A.jsx("label", { className: `label ${t || K.error ? "error " : ""}`, htmlFor: d || z, children: e }) : null,
    /* @__PURE__ */ A.jsxs("div", { className: `no-padding wrapper-input wrapper-input-squid ${t || K.error ? "error " : ""}`, children: [
      h ? /* @__PURE__ */ A.jsx("span", { className: "input-group-text", children: h }) : null,
      /* @__PURE__ */ A.jsx(
        "input",
        {
          className: `col input ${y ? "readonly " : ""}${b ? "disabled " : ""}${v ? "loading " : ""}${t || K.error ? "error " : ""}${w ? "has-icon-external " : ""}`,
          style: {
            backgroundColor: o,
            ...u
          },
          id: d || z,
          type: "text",
          inputMode: "numeric",
          name: l || z,
          placeholder: f || "",
          value: q,
          maxLength: p,
          required: g,
          disabled: b,
          readOnly: y || v,
          min: S,
          max: x,
          onChange: he,
          autoComplete: T,
          autoFocus: D,
          onBlur: Ue
        }
      ),
      m ? /* @__PURE__ */ A.jsx("span", { className: "input-group-text", children: m }) : null
    ] }),
    v ? /* @__PURE__ */ A.jsx(Et, { size: "small", className: `display-block loader-input ${e ? "" : "no-label"}`, style: { position: "absolute" } }) : null,
    w && !v ? /* @__PURE__ */ A.jsx("span", { className: `icon icon-external ${e ? "" : "no-label "}`, children: w }) : null,
    s ? /* @__PURE__ */ A.jsxs("div", { className: `box-validation box-invalid show ${p ? "has-max-length " : ""}`, children: [
      r && !K.value && !K.error && !t ? /* @__PURE__ */ A.jsxs("div", { children: [
        /* @__PURE__ */ A.jsx("i", { className: "fa-solid fa-diamond-exclamation gold" }),
        "Fill this field"
      ] }) : null,
      K.error || t ? c || /* @__PURE__ */ A.jsx("i", { className: "fa-regular fa-exclamation-triangle" }) : null,
      t || "",
      K.error && !t ? K.error : "",
      p && !a ? /* @__PURE__ */ A.jsx("span", { className: "max-length-name", children: p - (($ = K.value) == null ? void 0 : $.length) }) : null
    ] }) : null
  ] });
};
const Xr = ({
  title: n,
  children: e,
  open: t = !1,
  className: s,
  style: r,
  headerJustify: a = "center",
  headerBorder: c,
  backgroundColor: l = "transparent",
  disabled: d,
  loading: h,
  colorIcons: m = "var(--primary_color)",
  colorBackgroundIcon: y = "transparent",
  fontSizeIcon: b = "0.9rem",
  heightIcon: v = "",
  bodyBorder: w,
  noPadding: o,
  addMarginLoopCollapse: u = !0,
  index: f = 0,
  onToggleAccordion: p
}) => {
  const [g, S] = X(t), x = He(() => {
    !d && !h && (S((E) => !E), p && typeof p == "function" && p(f));
  }, [f, p, d, h]);
  return ee(() => {
    S(t);
  }, [t]), /* @__PURE__ */ A.jsxs(
    "div",
    {
      className: `collapse wrapper-collapse
        ${s} ${g ? "active" : ""}
        ${d ? "collapse-disabled" : ""}
        ${h ? "collapse-loading" : ""}
        ${u ? "mb-2" : ""}`,
      style: r,
      children: [
        /* @__PURE__ */ A.jsxs(
          "header",
          {
            role: "presentation",
            onClick: () => {
              x();
            },
            className: `collapse-title
          display-flex justify-content-${a}
          ${o ? "no-padding" : ""}`,
            style: {
              backgroundColor: `${l}`,
              border: `${c}`
            },
            children: [
              n,
              /* @__PURE__ */ A.jsx(
                "span",
                {
                  className: "icon",
                  style: {
                    color: m,
                    backgroundColor: y,
                    fontSize: b,
                    height: v,
                    lineHeight: v
                  },
                  children: h ? /* @__PURE__ */ A.jsx(Et, {}) : /* @__PURE__ */ A.jsx("i", { className: "fa-solid fa-chevron-down" })
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ A.jsx(
          "div",
          {
            className: `collapse-body content
          ${g && !d && !h ? "open" : ""}
          ${d ? "collapse-disabled" : ""}
          ${h ? "collapse-loading" : ""}
          ${w ? "body-border" : ""}`,
            children: e
          }
        )
      ]
    }
  );
};
const N2 = ({ children: n, onlyOne: e = !1, containerCollapseClass: t = "", openFirst: s = !1 }) => {
  var d, h;
  const [r, a] = X({}), c = (m) => {
    a(e ? (y) => {
      const b = { ...y };
      return Object.keys(b).forEach((v) => {
        b[v] = !1;
      }), b[m] = !0, b;
    } : (y) => {
      const b = { ...y };
      return b[m] = !b[m], b;
    });
  }, l = (m, y) => {
    const b = [], v = [y.displayName || y.name];
    return Fe.Children.forEach(m, (w) => {
      var u, f;
      const o = ((u = w == null ? void 0 : w.type) == null ? void 0 : u.displayName) || ((f = w == null ? void 0 : w.type) == null ? void 0 : f.name);
      v.includes(o) && b.push(w);
    }), b;
  };
  return ee(() => {
    l(n, Xr).forEach((m, y) => {
      a(
        (b) => typeof (b == null ? void 0 : b[y]) > "u" ? { ...b, [y]: !!m.props.open } : { ...b }
      );
    });
  }, [Fe.Children.count(n), n]), ee(() => {
    if (s) {
      const m = {};
      l(n, Xr).forEach((y, b) => {
        m[b] = b === 0;
      }), a(m);
    }
  }, []), /* @__PURE__ */ A.jsx("div", { className: "accordion", children: (h = l(
    (d = Fe.Children) == null ? void 0 : d.map(n, (m, y) => m ? Fe.cloneElement(m, {
      onToggleAccordion: c,
      key: y,
      open: !!r[y],
      index: y
    }) : null),
    Xr
  )) == null ? void 0 : h.map((m, y) => /* @__PURE__ */ A.jsx("div", { className: t, children: m }, y)) });
};
const F2 = ({
  children: n,
  title: e,
  backgroundColor: t = "var(--background)",
  figure: s,
  textColor: r = "var(--text_color)",
  className: a = "",
  style: c
}) => /* @__PURE__ */ A.jsxs("section", { className: `banner-container ${a}`, style: { backgroundColor: t, color: r, ...c }, children: [
  /* @__PURE__ */ A.jsx("div", { className: "banner-figure", children: s }),
  /* @__PURE__ */ A.jsxs("div", { className: "content", children: [
    /* @__PURE__ */ A.jsx("h5", { className: "title", children: e }),
    /* @__PURE__ */ A.jsx("div", { className: "text", children: n })
  ] })
] });
class Tn {
  constructor() {
    oe(this, "formatPercent", (e = 0, t = "pt") => {
      const s = (e * 100).toFixed(1);
      return `${parseFloat(s).toLocaleString(t)}%`;
    });
    oe(this, "formatStandardNumber", ({ lang: e = "en", number: t = 0 }) => Intl.NumberFormat(e, { notation: "standard" }).format(t));
    oe(this, "formatCompactNumber", ({ lang: e = "en", number: t = 0 }) => Intl.NumberFormat(e, { notation: "compact" }).format(t));
    oe(this, "percentageDifference", (e, t, s = "pt") => `${Math.abs((t - e) / e * 100).toLocaleString(s, { maximumFractionDigits: 1 })}%`);
    oe(this, "convertMoneyValue", (e, t = "pt", s = "BRL") => {
      const r = new Intl.NumberFormat(t, {
        style: "currency",
        currency: s,
        maximumFractionDigits: 2
      }).format(e);
      return r != null && r.includes("NaN") ? e : r;
    });
  }
  thousandTransform(e, t = 0) {
    const s = ["k", "M", "G", "T", "P", "E"];
    if (Number.isNaN(e) || e === null || !e && e !== 0)
      return "∞";
    if (e < 1e3)
      return e;
    const r = Math.floor(Math.log(e) / Math.log(1e3));
    return (e / Math.pow(1e3, r)).toFixed(t) + s[r - 1];
  }
  fileSize(e) {
    if (e === 0)
      return "0 Bytes";
    const t = 1024, s = ["Bytes", "KB", "MB", "GB", "TB"], r = Math.floor(Math.log(e) / Math.log(t));
    return parseFloat((e / Math.pow(t, r)).toFixed(2)) + " " + s[r];
  }
}
function _r(n) {
  let e = {
    bottom: 0,
    height: 0,
    left: 0,
    right: 0,
    top: 0,
    width: 0
  };
  return n && (e = n.getBoundingClientRect()), e;
}
function yl(n) {
  const [e, t] = X(n && n.current ? _r(n.current) : _r()), s = He(() => {
    n.current && t(_r(n.current));
  }, [n]);
  return On(() => {
    const r = n.current;
    if (r)
      if (s(), typeof ResizeObserver == "function") {
        let a = new ResizeObserver(() => s());
        return a.observe(r), () => {
          a && (a.disconnect(), a = null);
        };
      } else
        return window.addEventListener("resize", s), () => window.removeEventListener("resize", s);
  }, [s, n]), e;
}
const CT = ({ value: n, pinValue: e = n, total: t, percentage: s = !1, labelPin: r = null, colorBar: a = "var(--primary_color)" }) => {
  const c = xt(() => t || (s ? 1 : 100), [s, t]), l = xt(() => new Tn(), []), { formatCompactNumber: d, formatPercent: h } = l, m = Re(null), y = Re(null), b = yl(m), v = yl(y), w = (p, g) => (p * 100 / g).toFixed(0), o = c, u = w(n, o), f = w(e, o);
  return On(() => {
    const { left: p, width: g } = b, { left: S, width: x } = v;
    m.current && p < S && x <= g && (m.current.style.transform = `translate(-${x}px, -50%)`);
  }), /* @__PURE__ */ A.jsxs("div", { className: "bar-chart", children: [
    /* @__PURE__ */ A.jsx("div", { className: "value-bar", style: { width: `${parseInt(u)}%`, backgroundColor: a } }),
    /* @__PURE__ */ A.jsx("div", { className: "pin-bar-chart", style: { width: `${parseInt(f)}%` }, ref: y, children: /* @__PURE__ */ A.jsx("div", { className: "pin-container", children: /* @__PURE__ */ A.jsx("div", { className: "pin-bar-chart-content", children: /* @__PURE__ */ A.jsx("div", { className: "pin", children: /* @__PURE__ */ A.jsxs("div", { className: "description-pin", ref: m, children: [
      r,
      /* @__PURE__ */ A.jsx("span", { className: "text-bold", children: s ? h(e) : d({ lang: qe == null ? void 0 : qe.language, number: e }) })
    ] }) }) }) }) })
  ] });
};
const bn = Math.min, Qi = Math.max, hr = Math.round, Ps = Math.floor, ci = (n) => ({
  x: n,
  y: n
}), ET = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, kT = {
  start: "end",
  end: "start"
};
function Mo(n, e, t) {
  return Qi(n, bn(e, t));
}
function gs(n, e) {
  return typeof n == "function" ? n(e) : n;
}
function en(n) {
  return n.split("-")[0];
}
function ys(n) {
  return n.split("-")[1];
}
function ku(n) {
  return n === "x" ? "y" : "x";
}
function oa(n) {
  return n === "y" ? "height" : "width";
}
function xn(n) {
  return ["top", "bottom"].includes(en(n)) ? "y" : "x";
}
function aa(n) {
  return ku(xn(n));
}
function OT(n, e, t) {
  t === void 0 && (t = !1);
  const s = ys(n), r = aa(n), a = oa(r);
  let c = r === "x" ? s === (t ? "end" : "start") ? "right" : "left" : s === "start" ? "bottom" : "top";
  return e.reference[a] > e.floating[a] && (c = pr(c)), [c, pr(c)];
}
function TT(n) {
  const e = pr(n);
  return [jo(n), e, jo(e)];
}
function jo(n) {
  return n.replace(/start|end/g, (e) => kT[e]);
}
function IT(n, e, t) {
  const s = ["left", "right"], r = ["right", "left"], a = ["top", "bottom"], c = ["bottom", "top"];
  switch (n) {
    case "top":
    case "bottom":
      return t ? e ? r : s : e ? s : r;
    case "left":
    case "right":
      return e ? a : c;
    default:
      return [];
  }
}
function UT(n, e, t, s) {
  const r = ys(n);
  let a = IT(en(n), t === "start", s);
  return r && (a = a.map((c) => c + "-" + r), e && (a = a.concat(a.map(jo)))), a;
}
function pr(n) {
  return n.replace(/left|right|bottom|top/g, (e) => ET[e]);
}
function zT(n) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...n
  };
}
function Ou(n) {
  return typeof n != "number" ? zT(n) : {
    top: n,
    right: n,
    bottom: n,
    left: n
  };
}
function mr(n) {
  const {
    x: e,
    y: t,
    width: s,
    height: r
  } = n;
  return {
    width: s,
    height: r,
    top: t,
    left: e,
    right: e + s,
    bottom: t + r,
    x: e,
    y: t
  };
}
function vl(n, e, t) {
  let {
    reference: s,
    floating: r
  } = n;
  const a = xn(e), c = aa(e), l = oa(c), d = en(e), h = a === "y", m = s.x + s.width / 2 - r.width / 2, y = s.y + s.height / 2 - r.height / 2, b = s[l] / 2 - r[l] / 2;
  let v;
  switch (d) {
    case "top":
      v = {
        x: m,
        y: s.y - r.height
      };
      break;
    case "bottom":
      v = {
        x: m,
        y: s.y + s.height
      };
      break;
    case "right":
      v = {
        x: s.x + s.width,
        y
      };
      break;
    case "left":
      v = {
        x: s.x - r.width,
        y
      };
      break;
    default:
      v = {
        x: s.x,
        y: s.y
      };
  }
  switch (ys(e)) {
    case "start":
      v[c] -= b * (t && h ? -1 : 1);
      break;
    case "end":
      v[c] += b * (t && h ? -1 : 1);
      break;
  }
  return v;
}
const RT = async (n, e, t) => {
  const {
    placement: s = "bottom",
    strategy: r = "absolute",
    middleware: a = [],
    platform: c
  } = t, l = a.filter(Boolean), d = await (c.isRTL == null ? void 0 : c.isRTL(e));
  let h = await c.getElementRects({
    reference: n,
    floating: e,
    strategy: r
  }), {
    x: m,
    y
  } = vl(h, s, d), b = s, v = {}, w = 0;
  for (let o = 0; o < l.length; o++) {
    const {
      name: u,
      fn: f
    } = l[o], {
      x: p,
      y: g,
      data: S,
      reset: x
    } = await f({
      x: m,
      y,
      initialPlacement: s,
      placement: b,
      strategy: r,
      middlewareData: v,
      rects: h,
      platform: c,
      elements: {
        reference: n,
        floating: e
      }
    });
    m = p ?? m, y = g ?? y, v = {
      ...v,
      [u]: {
        ...v[u],
        ...S
      }
    }, x && w <= 50 && (w++, typeof x == "object" && (x.placement && (b = x.placement), x.rects && (h = x.rects === !0 ? await c.getElementRects({
      reference: n,
      floating: e,
      strategy: r
    }) : x.rects), {
      x: m,
      y
    } = vl(h, b, d)), o = -1);
  }
  return {
    x: m,
    y,
    placement: b,
    strategy: r,
    middlewareData: v
  };
};
async function Tu(n, e) {
  var t;
  e === void 0 && (e = {});
  const {
    x: s,
    y: r,
    platform: a,
    rects: c,
    elements: l,
    strategy: d
  } = n, {
    boundary: h = "clippingAncestors",
    rootBoundary: m = "viewport",
    elementContext: y = "floating",
    altBoundary: b = !1,
    padding: v = 0
  } = gs(e, n), w = Ou(v), u = l[b ? y === "floating" ? "reference" : "floating" : y], f = mr(await a.getClippingRect({
    element: (t = await (a.isElement == null ? void 0 : a.isElement(u))) == null || t ? u : u.contextElement || await (a.getDocumentElement == null ? void 0 : a.getDocumentElement(l.floating)),
    boundary: h,
    rootBoundary: m,
    strategy: d
  })), p = y === "floating" ? {
    x: s,
    y: r,
    width: c.floating.width,
    height: c.floating.height
  } : c.reference, g = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(l.floating)), S = await (a.isElement == null ? void 0 : a.isElement(g)) ? await (a.getScale == null ? void 0 : a.getScale(g)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, x = mr(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: l,
    rect: p,
    offsetParent: g,
    strategy: d
  }) : p);
  return {
    top: (f.top - x.top + w.top) / S.y,
    bottom: (x.bottom - f.bottom + w.bottom) / S.y,
    left: (f.left - x.left + w.left) / S.x,
    right: (x.right - f.right + w.right) / S.x
  };
}
const PT = (n) => ({
  name: "arrow",
  options: n,
  async fn(e) {
    const {
      x: t,
      y: s,
      placement: r,
      rects: a,
      platform: c,
      elements: l,
      middlewareData: d
    } = e, {
      element: h,
      padding: m = 0
    } = gs(n, e) || {};
    if (h == null)
      return {};
    const y = Ou(m), b = {
      x: t,
      y: s
    }, v = aa(r), w = oa(v), o = await c.getDimensions(h), u = v === "y", f = u ? "top" : "left", p = u ? "bottom" : "right", g = u ? "clientHeight" : "clientWidth", S = a.reference[w] + a.reference[v] - b[v] - a.floating[w], x = b[v] - a.reference[v], E = await (c.getOffsetParent == null ? void 0 : c.getOffsetParent(h));
    let k = E ? E[g] : 0;
    (!k || !await (c.isElement == null ? void 0 : c.isElement(E))) && (k = l.floating[g] || a.floating[w]);
    const R = S / 2 - x / 2, O = k / 2 - o[w] / 2 - 1, T = bn(y[f], O), D = bn(y[p], O), P = T, N = k - o[w] - D, I = k / 2 - o[w] / 2 + R, C = Mo(P, I, N), U = !d.arrow && ys(r) != null && I !== C && a.reference[w] / 2 - (I < P ? T : D) - o[w] / 2 < 0, z = U ? I < P ? I - P : I - N : 0;
    return {
      [v]: b[v] + z,
      data: {
        [v]: C,
        centerOffset: I - C - z,
        ...U && {
          alignmentOffset: z
        }
      },
      reset: U
    };
  }
}), MT = function(n) {
  return n === void 0 && (n = {}), {
    name: "flip",
    options: n,
    async fn(e) {
      var t, s;
      const {
        placement: r,
        middlewareData: a,
        rects: c,
        initialPlacement: l,
        platform: d,
        elements: h
      } = e, {
        mainAxis: m = !0,
        crossAxis: y = !0,
        fallbackPlacements: b,
        fallbackStrategy: v = "bestFit",
        fallbackAxisSideDirection: w = "none",
        flipAlignment: o = !0,
        ...u
      } = gs(n, e);
      if ((t = a.arrow) != null && t.alignmentOffset)
        return {};
      const f = en(r), p = xn(l), g = en(l) === l, S = await (d.isRTL == null ? void 0 : d.isRTL(h.floating)), x = b || (g || !o ? [pr(l)] : TT(l)), E = w !== "none";
      !b && E && x.push(...UT(l, o, w, S));
      const k = [l, ...x], R = await Tu(e, u), O = [];
      let T = ((s = a.flip) == null ? void 0 : s.overflows) || [];
      if (m && O.push(R[f]), y) {
        const I = OT(r, c, S);
        O.push(R[I[0]], R[I[1]]);
      }
      if (T = [...T, {
        placement: r,
        overflows: O
      }], !O.every((I) => I <= 0)) {
        var D, P;
        const I = (((D = a.flip) == null ? void 0 : D.index) || 0) + 1, C = k[I];
        if (C)
          return {
            data: {
              index: I,
              overflows: T
            },
            reset: {
              placement: C
            }
          };
        let U = (P = T.filter((z) => z.overflows[0] <= 0).sort((z, j) => z.overflows[1] - j.overflows[1])[0]) == null ? void 0 : P.placement;
        if (!U)
          switch (v) {
            case "bestFit": {
              var N;
              const z = (N = T.filter((j) => {
                if (E) {
                  const F = xn(j.placement);
                  return F === p || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  F === "y";
                }
                return !0;
              }).map((j) => [j.placement, j.overflows.filter((F) => F > 0).reduce((F, q) => F + q, 0)]).sort((j, F) => j[1] - F[1])[0]) == null ? void 0 : N[0];
              z && (U = z);
              break;
            }
            case "initialPlacement":
              U = l;
              break;
          }
        if (r !== U)
          return {
            reset: {
              placement: U
            }
          };
      }
      return {};
    }
  };
};
async function jT(n, e) {
  const {
    placement: t,
    platform: s,
    elements: r
  } = n, a = await (s.isRTL == null ? void 0 : s.isRTL(r.floating)), c = en(t), l = ys(t), d = xn(t) === "y", h = ["left", "top"].includes(c) ? -1 : 1, m = a && d ? -1 : 1, y = gs(e, n);
  let {
    mainAxis: b,
    crossAxis: v,
    alignmentAxis: w
  } = typeof y == "number" ? {
    mainAxis: y,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: y.mainAxis || 0,
    crossAxis: y.crossAxis || 0,
    alignmentAxis: y.alignmentAxis
  };
  return l && typeof w == "number" && (v = l === "end" ? w * -1 : w), d ? {
    x: v * m,
    y: b * h
  } : {
    x: b * h,
    y: v * m
  };
}
const LT = function(n) {
  return n === void 0 && (n = 0), {
    name: "offset",
    options: n,
    async fn(e) {
      var t, s;
      const {
        x: r,
        y: a,
        placement: c,
        middlewareData: l
      } = e, d = await jT(e, n);
      return c === ((t = l.offset) == null ? void 0 : t.placement) && (s = l.arrow) != null && s.alignmentOffset ? {} : {
        x: r + d.x,
        y: a + d.y,
        data: {
          ...d,
          placement: c
        }
      };
    }
  };
}, DT = function(n) {
  return n === void 0 && (n = {}), {
    name: "shift",
    options: n,
    async fn(e) {
      const {
        x: t,
        y: s,
        placement: r
      } = e, {
        mainAxis: a = !0,
        crossAxis: c = !1,
        limiter: l = {
          fn: (u) => {
            let {
              x: f,
              y: p
            } = u;
            return {
              x: f,
              y: p
            };
          }
        },
        ...d
      } = gs(n, e), h = {
        x: t,
        y: s
      }, m = await Tu(e, d), y = xn(en(r)), b = ku(y);
      let v = h[b], w = h[y];
      if (a) {
        const u = b === "y" ? "top" : "left", f = b === "y" ? "bottom" : "right", p = v + m[u], g = v - m[f];
        v = Mo(p, v, g);
      }
      if (c) {
        const u = y === "y" ? "top" : "left", f = y === "y" ? "bottom" : "right", p = w + m[u], g = w - m[f];
        w = Mo(p, w, g);
      }
      const o = l.fn({
        ...e,
        [b]: v,
        [y]: w
      });
      return {
        ...o,
        data: {
          x: o.x - t,
          y: o.y - s,
          enabled: {
            [b]: a,
            [y]: c
          }
        }
      };
    }
  };
};
function Pr() {
  return typeof window < "u";
}
function In(n) {
  return Iu(n) ? (n.nodeName || "").toLowerCase() : "#document";
}
function Wt(n) {
  var e;
  return (n == null || (e = n.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function di(n) {
  var e;
  return (e = (Iu(n) ? n.ownerDocument : n.document) || window.document) == null ? void 0 : e.documentElement;
}
function Iu(n) {
  return Pr() ? n instanceof Node || n instanceof Wt(n).Node : !1;
}
function ii(n) {
  return Pr() ? n instanceof Element || n instanceof Wt(n).Element : !1;
}
function ui(n) {
  return Pr() ? n instanceof HTMLElement || n instanceof Wt(n).HTMLElement : !1;
}
function bl(n) {
  return !Pr() || typeof ShadowRoot > "u" ? !1 : n instanceof ShadowRoot || n instanceof Wt(n).ShadowRoot;
}
function vs(n) {
  const {
    overflow: e,
    overflowX: t,
    overflowY: s,
    display: r
  } = ni(n);
  return /auto|scroll|overlay|hidden|clip/.test(e + s + t) && !["inline", "contents"].includes(r);
}
function NT(n) {
  return ["table", "td", "th"].includes(In(n));
}
function Mr(n) {
  return [":popover-open", ":modal"].some((e) => {
    try {
      return n.matches(e);
    } catch {
      return !1;
    }
  });
}
function la(n) {
  const e = ca(), t = ii(n) ? ni(n) : n;
  return t.transform !== "none" || t.perspective !== "none" || (t.containerType ? t.containerType !== "normal" : !1) || !e && (t.backdropFilter ? t.backdropFilter !== "none" : !1) || !e && (t.filter ? t.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((s) => (t.willChange || "").includes(s)) || ["paint", "layout", "strict", "content"].some((s) => (t.contain || "").includes(s));
}
function FT(n) {
  let e = ji(n);
  for (; ui(e) && !Sn(e); ) {
    if (la(e))
      return e;
    if (Mr(e))
      return null;
    e = ji(e);
  }
  return null;
}
function ca() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function Sn(n) {
  return ["html", "body", "#document"].includes(In(n));
}
function ni(n) {
  return Wt(n).getComputedStyle(n);
}
function jr(n) {
  return ii(n) ? {
    scrollLeft: n.scrollLeft,
    scrollTop: n.scrollTop
  } : {
    scrollLeft: n.scrollX,
    scrollTop: n.scrollY
  };
}
function ji(n) {
  if (In(n) === "html")
    return n;
  const e = (
    // Step into the shadow DOM of the parent of a slotted node.
    n.assignedSlot || // DOM Element detected.
    n.parentNode || // ShadowRoot detected.
    bl(n) && n.host || // Fallback.
    di(n)
  );
  return bl(e) ? e.host : e;
}
function Uu(n) {
  const e = ji(n);
  return Sn(e) ? n.ownerDocument ? n.ownerDocument.body : n.body : ui(e) && vs(e) ? e : Uu(e);
}
function rs(n, e, t) {
  var s;
  e === void 0 && (e = []), t === void 0 && (t = !0);
  const r = Uu(n), a = r === ((s = n.ownerDocument) == null ? void 0 : s.body), c = Wt(r);
  if (a) {
    const l = Lo(c);
    return e.concat(c, c.visualViewport || [], vs(r) ? r : [], l && t ? rs(l) : []);
  }
  return e.concat(r, rs(r, [], t));
}
function Lo(n) {
  return n.parent && Object.getPrototypeOf(n.parent) ? n.frameElement : null;
}
function zu(n) {
  const e = ni(n);
  let t = parseFloat(e.width) || 0, s = parseFloat(e.height) || 0;
  const r = ui(n), a = r ? n.offsetWidth : t, c = r ? n.offsetHeight : s, l = hr(t) !== a || hr(s) !== c;
  return l && (t = a, s = c), {
    width: t,
    height: s,
    $: l
  };
}
function ua(n) {
  return ii(n) ? n : n.contextElement;
}
function pn(n) {
  const e = ua(n);
  if (!ui(e))
    return ci(1);
  const t = e.getBoundingClientRect(), {
    width: s,
    height: r,
    $: a
  } = zu(e);
  let c = (a ? hr(t.width) : t.width) / s, l = (a ? hr(t.height) : t.height) / r;
  return (!c || !Number.isFinite(c)) && (c = 1), (!l || !Number.isFinite(l)) && (l = 1), {
    x: c,
    y: l
  };
}
const BT = /* @__PURE__ */ ci(0);
function Ru(n) {
  const e = Wt(n);
  return !ca() || !e.visualViewport ? BT : {
    x: e.visualViewport.offsetLeft,
    y: e.visualViewport.offsetTop
  };
}
function qT(n, e, t) {
  return e === void 0 && (e = !1), !t || e && t !== Wt(n) ? !1 : e;
}
function tn(n, e, t, s) {
  e === void 0 && (e = !1), t === void 0 && (t = !1);
  const r = n.getBoundingClientRect(), a = ua(n);
  let c = ci(1);
  e && (s ? ii(s) && (c = pn(s)) : c = pn(n));
  const l = qT(a, t, s) ? Ru(a) : ci(0);
  let d = (r.left + l.x) / c.x, h = (r.top + l.y) / c.y, m = r.width / c.x, y = r.height / c.y;
  if (a) {
    const b = Wt(a), v = s && ii(s) ? Wt(s) : s;
    let w = b, o = Lo(w);
    for (; o && s && v !== w; ) {
      const u = pn(o), f = o.getBoundingClientRect(), p = ni(o), g = f.left + (o.clientLeft + parseFloat(p.paddingLeft)) * u.x, S = f.top + (o.clientTop + parseFloat(p.paddingTop)) * u.y;
      d *= u.x, h *= u.y, m *= u.x, y *= u.y, d += g, h += S, w = Wt(o), o = Lo(w);
    }
  }
  return mr({
    width: m,
    height: y,
    x: d,
    y: h
  });
}
function da(n, e) {
  const t = jr(n).scrollLeft;
  return e ? e.left + t : tn(di(n)).left + t;
}
function Pu(n, e, t) {
  t === void 0 && (t = !1);
  const s = n.getBoundingClientRect(), r = s.left + e.scrollLeft - (t ? 0 : (
    // RTL <body> scrollbar.
    da(n, s)
  )), a = s.top + e.scrollTop;
  return {
    x: r,
    y: a
  };
}
function HT(n) {
  let {
    elements: e,
    rect: t,
    offsetParent: s,
    strategy: r
  } = n;
  const a = r === "fixed", c = di(s), l = e ? Mr(e.floating) : !1;
  if (s === c || l && a)
    return t;
  let d = {
    scrollLeft: 0,
    scrollTop: 0
  }, h = ci(1);
  const m = ci(0), y = ui(s);
  if ((y || !y && !a) && ((In(s) !== "body" || vs(c)) && (d = jr(s)), ui(s))) {
    const v = tn(s);
    h = pn(s), m.x = v.x + s.clientLeft, m.y = v.y + s.clientTop;
  }
  const b = c && !y && !a ? Pu(c, d, !0) : ci(0);
  return {
    width: t.width * h.x,
    height: t.height * h.y,
    x: t.x * h.x - d.scrollLeft * h.x + m.x + b.x,
    y: t.y * h.y - d.scrollTop * h.y + m.y + b.y
  };
}
function VT(n) {
  return Array.from(n.getClientRects());
}
function GT(n) {
  const e = di(n), t = jr(n), s = n.ownerDocument.body, r = Qi(e.scrollWidth, e.clientWidth, s.scrollWidth, s.clientWidth), a = Qi(e.scrollHeight, e.clientHeight, s.scrollHeight, s.clientHeight);
  let c = -t.scrollLeft + da(n);
  const l = -t.scrollTop;
  return ni(s).direction === "rtl" && (c += Qi(e.clientWidth, s.clientWidth) - r), {
    width: r,
    height: a,
    x: c,
    y: l
  };
}
function WT(n, e) {
  const t = Wt(n), s = di(n), r = t.visualViewport;
  let a = s.clientWidth, c = s.clientHeight, l = 0, d = 0;
  if (r) {
    a = r.width, c = r.height;
    const h = ca();
    (!h || h && e === "fixed") && (l = r.offsetLeft, d = r.offsetTop);
  }
  return {
    width: a,
    height: c,
    x: l,
    y: d
  };
}
function KT(n, e) {
  const t = tn(n, !0, e === "fixed"), s = t.top + n.clientTop, r = t.left + n.clientLeft, a = ui(n) ? pn(n) : ci(1), c = n.clientWidth * a.x, l = n.clientHeight * a.y, d = r * a.x, h = s * a.y;
  return {
    width: c,
    height: l,
    x: d,
    y: h
  };
}
function xl(n, e, t) {
  let s;
  if (e === "viewport")
    s = WT(n, t);
  else if (e === "document")
    s = GT(di(n));
  else if (ii(e))
    s = KT(e, t);
  else {
    const r = Ru(n);
    s = {
      x: e.x - r.x,
      y: e.y - r.y,
      width: e.width,
      height: e.height
    };
  }
  return mr(s);
}
function Mu(n, e) {
  const t = ji(n);
  return t === e || !ii(t) || Sn(t) ? !1 : ni(t).position === "fixed" || Mu(t, e);
}
function YT(n, e) {
  const t = e.get(n);
  if (t)
    return t;
  let s = rs(n, [], !1).filter((l) => ii(l) && In(l) !== "body"), r = null;
  const a = ni(n).position === "fixed";
  let c = a ? ji(n) : n;
  for (; ii(c) && !Sn(c); ) {
    const l = ni(c), d = la(c);
    !d && l.position === "fixed" && (r = null), (a ? !d && !r : !d && l.position === "static" && !!r && ["absolute", "fixed"].includes(r.position) || vs(c) && !d && Mu(n, c)) ? s = s.filter((m) => m !== c) : r = l, c = ji(c);
  }
  return e.set(n, s), s;
}
function JT(n) {
  let {
    element: e,
    boundary: t,
    rootBoundary: s,
    strategy: r
  } = n;
  const c = [...t === "clippingAncestors" ? Mr(e) ? [] : YT(e, this._c) : [].concat(t), s], l = c[0], d = c.reduce((h, m) => {
    const y = xl(e, m, r);
    return h.top = Qi(y.top, h.top), h.right = bn(y.right, h.right), h.bottom = bn(y.bottom, h.bottom), h.left = Qi(y.left, h.left), h;
  }, xl(e, l, r));
  return {
    width: d.right - d.left,
    height: d.bottom - d.top,
    x: d.left,
    y: d.top
  };
}
function ZT(n) {
  const {
    width: e,
    height: t
  } = zu(n);
  return {
    width: e,
    height: t
  };
}
function QT(n, e, t) {
  const s = ui(e), r = di(e), a = t === "fixed", c = tn(n, !0, a, e);
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const d = ci(0);
  if (s || !s && !a)
    if ((In(e) !== "body" || vs(r)) && (l = jr(e)), s) {
      const b = tn(e, !0, a, e);
      d.x = b.x + e.clientLeft, d.y = b.y + e.clientTop;
    } else
      r && (d.x = da(r));
  const h = r && !s && !a ? Pu(r, l) : ci(0), m = c.left + l.scrollLeft - d.x - h.x, y = c.top + l.scrollTop - d.y - h.y;
  return {
    x: m,
    y,
    width: c.width,
    height: c.height
  };
}
function $r(n) {
  return ni(n).position === "static";
}
function Sl(n, e) {
  if (!ui(n) || ni(n).position === "fixed")
    return null;
  if (e)
    return e(n);
  let t = n.offsetParent;
  return di(n) === t && (t = t.ownerDocument.body), t;
}
function ju(n, e) {
  const t = Wt(n);
  if (Mr(n))
    return t;
  if (!ui(n)) {
    let r = ji(n);
    for (; r && !Sn(r); ) {
      if (ii(r) && !$r(r))
        return r;
      r = ji(r);
    }
    return t;
  }
  let s = Sl(n, e);
  for (; s && NT(s) && $r(s); )
    s = Sl(s, e);
  return s && Sn(s) && $r(s) && !la(s) ? t : s || FT(n) || t;
}
const XT = async function(n) {
  const e = this.getOffsetParent || ju, t = this.getDimensions, s = await t(n.floating);
  return {
    reference: QT(n.reference, await e(n.floating), n.strategy),
    floating: {
      x: 0,
      y: 0,
      width: s.width,
      height: s.height
    }
  };
};
function _T(n) {
  return ni(n).direction === "rtl";
}
const $T = {
  convertOffsetParentRelativeRectToViewportRelativeRect: HT,
  getDocumentElement: di,
  getClippingRect: JT,
  getOffsetParent: ju,
  getElementRects: XT,
  getClientRects: VT,
  getDimensions: ZT,
  getScale: pn,
  isElement: ii,
  isRTL: _T
};
function eI(n, e) {
  let t = null, s;
  const r = di(n);
  function a() {
    var l;
    clearTimeout(s), (l = t) == null || l.disconnect(), t = null;
  }
  function c(l, d) {
    l === void 0 && (l = !1), d === void 0 && (d = 1), a();
    const {
      left: h,
      top: m,
      width: y,
      height: b
    } = n.getBoundingClientRect();
    if (l || e(), !y || !b)
      return;
    const v = Ps(m), w = Ps(r.clientWidth - (h + y)), o = Ps(r.clientHeight - (m + b)), u = Ps(h), p = {
      rootMargin: -v + "px " + -w + "px " + -o + "px " + -u + "px",
      threshold: Qi(0, bn(1, d)) || 1
    };
    let g = !0;
    function S(x) {
      const E = x[0].intersectionRatio;
      if (E !== d) {
        if (!g)
          return c();
        E ? c(!1, E) : s = setTimeout(() => {
          c(!1, 1e-7);
        }, 1e3);
      }
      g = !1;
    }
    try {
      t = new IntersectionObserver(S, {
        ...p,
        // Handle <iframe>s
        root: r.ownerDocument
      });
    } catch {
      t = new IntersectionObserver(S, p);
    }
    t.observe(n);
  }
  return c(!0), a;
}
function tI(n, e, t, s) {
  s === void 0 && (s = {});
  const {
    ancestorScroll: r = !0,
    ancestorResize: a = !0,
    elementResize: c = typeof ResizeObserver == "function",
    layoutShift: l = typeof IntersectionObserver == "function",
    animationFrame: d = !1
  } = s, h = ua(n), m = r || a ? [...h ? rs(h) : [], ...rs(e)] : [];
  m.forEach((f) => {
    r && f.addEventListener("scroll", t, {
      passive: !0
    }), a && f.addEventListener("resize", t);
  });
  const y = h && l ? eI(h, t) : null;
  let b = -1, v = null;
  c && (v = new ResizeObserver((f) => {
    let [p] = f;
    p && p.target === h && v && (v.unobserve(e), cancelAnimationFrame(b), b = requestAnimationFrame(() => {
      var g;
      (g = v) == null || g.observe(e);
    })), t();
  }), h && !d && v.observe(h), v.observe(e));
  let w, o = d ? tn(n) : null;
  d && u();
  function u() {
    const f = tn(n);
    o && (f.x !== o.x || f.y !== o.y || f.width !== o.width || f.height !== o.height) && t(), o = f, w = requestAnimationFrame(u);
  }
  return t(), () => {
    var f;
    m.forEach((p) => {
      r && p.removeEventListener("scroll", t), a && p.removeEventListener("resize", t);
    }), y == null || y(), (f = v) == null || f.disconnect(), v = null, d && cancelAnimationFrame(w);
  };
}
const iI = LT, nI = DT, sI = MT, rI = PT, wl = (n, e, t) => {
  const s = /* @__PURE__ */ new Map(), r = {
    platform: $T,
    ...t
  }, a = {
    ...r.platform,
    _c: s
  };
  return RT(n, e, {
    ...r,
    platform: a
  });
};
var Lu = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(n) {
  (function() {
    var e = {}.hasOwnProperty;
    function t() {
      for (var a = "", c = 0; c < arguments.length; c++) {
        var l = arguments[c];
        l && (a = r(a, s(l)));
      }
      return a;
    }
    function s(a) {
      if (typeof a == "string" || typeof a == "number")
        return a;
      if (typeof a != "object")
        return "";
      if (Array.isArray(a))
        return t.apply(null, a);
      if (a.toString !== Object.prototype.toString && !a.toString.toString().includes("[native code]"))
        return a.toString();
      var c = "";
      for (var l in a)
        e.call(a, l) && a[l] && (c = r(c, l));
      return c;
    }
    function r(a, c) {
      return c ? a ? a + " " + c : a + c : a;
    }
    n.exports ? (t.default = t, n.exports = t) : window.classNames = t;
  })();
})(Lu);
var oI = Lu.exports;
const Do = /* @__PURE__ */ ms(oI);
/*
* React Tooltip
* {@link https://github.com/ReactTooltip/react-tooltip}
* @copyright ReactTooltip Team
* @license MIT
*/
const aI = "react-tooltip-core-styles", lI = "react-tooltip-base-styles", Al = { core: !1, base: !1 };
function Cl({ css: n, id: e = lI, type: t = "base", ref: s }) {
  var r, a;
  if (!n || typeof document > "u" || Al[t] || t === "core" && typeof process < "u" && (!((r = process == null ? void 0 : process.env) === null || r === void 0) && r.REACT_TOOLTIP_DISABLE_CORE_STYLES) || t !== "base" && typeof process < "u" && (!((a = process == null ? void 0 : process.env) === null || a === void 0) && a.REACT_TOOLTIP_DISABLE_BASE_STYLES))
    return;
  t === "core" && (e = aI), s || (s = {});
  const { insertAt: c } = s;
  if (document.getElementById(e))
    return;
  const l = document.head || document.getElementsByTagName("head")[0], d = document.createElement("style");
  d.id = e, d.type = "text/css", c === "top" && l.firstChild ? l.insertBefore(d, l.firstChild) : l.appendChild(d), d.styleSheet ? d.styleSheet.cssText = n : d.appendChild(document.createTextNode(n)), Al[t] = !0;
}
const El = async ({ elementReference: n = null, tooltipReference: e = null, tooltipArrowReference: t = null, place: s = "top", offset: r = 10, strategy: a = "absolute", middlewares: c = [iI(Number(r)), sI({ fallbackAxisSideDirection: "start" }), nI({ padding: 5 })], border: l }) => {
  if (!n)
    return { tooltipStyles: {}, tooltipArrowStyles: {}, place: s };
  if (e === null)
    return { tooltipStyles: {}, tooltipArrowStyles: {}, place: s };
  const d = c;
  return t ? (d.push(rI({ element: t, padding: 5 })), wl(n, e, { placement: s, strategy: a, middleware: d }).then(({ x: h, y: m, placement: y, middlewareData: b }) => {
    var v, w;
    const o = { left: `${h}px`, top: `${m}px`, border: l }, { x: u, y: f } = (v = b.arrow) !== null && v !== void 0 ? v : { x: 0, y: 0 }, p = (w = { top: "bottom", right: "left", bottom: "top", left: "right" }[y.split("-")[0]]) !== null && w !== void 0 ? w : "bottom", g = l && { borderBottom: l, borderRight: l };
    let S = 0;
    if (l) {
      const x = `${l}`.match(/(\d+)px/);
      S = x != null && x[1] ? Number(x[1]) : 1;
    }
    return { tooltipStyles: o, tooltipArrowStyles: { left: u != null ? `${u}px` : "", top: f != null ? `${f}px` : "", right: "", bottom: "", ...g, [p]: `-${4 + S}px` }, place: y };
  })) : wl(n, e, { placement: "bottom", strategy: a, middleware: d }).then(({ x: h, y: m, placement: y }) => ({ tooltipStyles: { left: `${h}px`, top: `${m}px` }, tooltipArrowStyles: {}, place: y }));
}, kl = (n, e) => !("CSS" in window && "supports" in window.CSS) || window.CSS.supports(n, e), Ol = (n, e, t) => {
  let s = null;
  const r = function(...a) {
    const c = () => {
      s = null, t || n.apply(this, a);
    };
    t && !s && (n.apply(this, a), s = setTimeout(c, e)), t || (s && clearTimeout(s), s = setTimeout(c, e));
  };
  return r.cancel = () => {
    s && (clearTimeout(s), s = null);
  }, r;
}, Tl = (n) => n !== null && !Array.isArray(n) && typeof n == "object", No = (n, e) => {
  if (n === e)
    return !0;
  if (Array.isArray(n) && Array.isArray(e))
    return n.length === e.length && n.every((r, a) => No(r, e[a]));
  if (Array.isArray(n) !== Array.isArray(e))
    return !1;
  if (!Tl(n) || !Tl(e))
    return n === e;
  const t = Object.keys(n), s = Object.keys(e);
  return t.length === s.length && t.every((r) => No(n[r], e[r]));
}, cI = (n) => {
  if (!(n instanceof HTMLElement || n instanceof SVGElement))
    return !1;
  const e = getComputedStyle(n);
  return ["overflow", "overflow-x", "overflow-y"].some((t) => {
    const s = e.getPropertyValue(t);
    return s === "auto" || s === "scroll";
  });
}, Il = (n) => {
  if (!n)
    return null;
  let e = n.parentElement;
  for (; e; ) {
    if (cI(e))
      return e;
    e = e.parentElement;
  }
  return document.scrollingElement || document.documentElement;
}, uI = typeof window < "u" ? On : ee, Xt = (n) => {
  n.current && (clearTimeout(n.current), n.current = null);
}, dI = "DEFAULT_TOOLTIP_ID", fI = { anchorRefs: /* @__PURE__ */ new Set(), activeAnchor: { current: null }, attach: () => {
}, detach: () => {
}, setActiveAnchor: () => {
} }, hI = kn({ getTooltipData: () => fI });
function Du(n = dI) {
  return ia(hI).getTooltipData(n);
}
var un = { tooltip: "core-styles-module_tooltip__3vRRp", fixed: "core-styles-module_fixed__pcSol", arrow: "core-styles-module_arrow__cvMwQ", noArrow: "core-styles-module_noArrow__xock6", clickable: "core-styles-module_clickable__ZuTTB", show: "core-styles-module_show__Nt9eE", closing: "core-styles-module_closing__sGnxF" }, eo = { tooltip: "styles-module_tooltip__mnnfp", arrow: "styles-module_arrow__K0L3T", dark: "styles-module_dark__xNqje", light: "styles-module_light__Z6W-X", success: "styles-module_success__A2AKt", warning: "styles-module_warning__SCK0X", error: "styles-module_error__JvumD", info: "styles-module_info__BWdHW" };
const pI = ({ forwardRef: n, id: e, className: t, classNameArrow: s, variant: r = "dark", anchorId: a, anchorSelect: c, place: l = "top", offset: d = 10, events: h = ["hover"], openOnClick: m = !1, positionStrategy: y = "absolute", middlewares: b, wrapper: v, delayShow: w = 0, delayHide: o = 0, float: u = !1, hidden: f = !1, noArrow: p = !1, clickable: g = !1, closeOnEsc: S = !1, closeOnScroll: x = !1, closeOnResize: E = !1, openEvents: k, closeEvents: R, globalCloseEvents: O, imperativeModeOnly: T, style: D, position: P, afterShow: N, afterHide: I, disableTooltip: C, content: U, contentWrapperRef: z, isOpen: j, defaultIsOpen: F = !1, setIsOpen: q, activeAnchor: W, setActiveAnchor: K, border: Q, opacity: G, arrowColor: M, role: te = "tooltip" }) => {
  var ce;
  const he = Re(null), Ue = Re(null), $ = Re(null), ne = Re(null), ye = Re(null), [ue, je] = X({ tooltipStyles: {}, tooltipArrowStyles: {}, place: l }), [V, Z] = X(!1), [re, be] = X(!1), [se, Se] = X(null), Ce = Re(!1), Me = Re(null), { anchorRefs: de, setActiveAnchor: ve } = Du(e), Ee = Re(!1), [le, pe] = X([]), Ve = Re(!1), lt = m || h.includes("click"), tt = lt || (k == null ? void 0 : k.click) || (k == null ? void 0 : k.dblclick) || (k == null ? void 0 : k.mousedown), ct = k ? { ...k } : { mouseover: !0, focus: !0, mouseenter: !1, click: !1, dblclick: !1, mousedown: !1 };
  !k && lt && Object.assign(ct, { mouseenter: !1, focus: !1, mouseover: !1, click: !0 });
  const wt = R ? { ...R } : { mouseout: !0, blur: !0, mouseleave: !1, click: !1, dblclick: !1, mouseup: !1 };
  !R && lt && Object.assign(wt, { mouseleave: !1, blur: !1, mouseout: !1 });
  const mt = O ? { ...O } : { escape: S || !1, scroll: x || !1, resize: E || !1, clickOutsideAnchor: tt || !1 };
  T && (Object.assign(ct, { mouseenter: !1, focus: !1, click: !1, dblclick: !1, mousedown: !1 }), Object.assign(wt, { mouseleave: !1, blur: !1, click: !1, dblclick: !1, mouseup: !1 }), Object.assign(mt, { escape: !1, scroll: !1, resize: !1, clickOutsideAnchor: !1 })), uI(() => (Ve.current = !0, () => {
    Ve.current = !1;
  }), []);
  const ze = (ae) => {
    Ve.current && (ae && be(!0), setTimeout(() => {
      Ve.current && (q == null || q(ae), j === void 0 && Z(ae));
    }, 10));
  };
  ee(() => {
    if (j === void 0)
      return () => null;
    j && be(!0);
    const ae = setTimeout(() => {
      Z(j);
    }, 10);
    return () => {
      clearTimeout(ae);
    };
  }, [j]), ee(() => {
    if (V !== Ce.current)
      if (Xt(ye), Ce.current = V, V)
        N == null || N();
      else {
        const ae = ((we) => {
          const Ae = we.match(/^([\d.]+)(ms|s)$/);
          if (!Ae)
            return 0;
          const [, Je, dt] = Ae;
          return Number(Je) * (dt === "ms" ? 1 : 1e3);
        })(getComputedStyle(document.body).getPropertyValue("--rt-transition-show-delay"));
        ye.current = setTimeout(() => {
          be(!1), Se(null), I == null || I();
        }, ae + 25);
      }
  }, [V]);
  const jt = (ae) => {
    je((we) => No(we, ae) ? we : ae);
  }, Lt = (ae = w) => {
    Xt($), re ? ze(!0) : $.current = setTimeout(() => {
      ze(!0);
    }, ae);
  }, Yt = (ae = o) => {
    Xt(ne), ne.current = setTimeout(() => {
      Ee.current || ze(!1);
    }, ae);
  }, Dt = (ae) => {
    var we;
    if (!ae)
      return;
    const Ae = (we = ae.currentTarget) !== null && we !== void 0 ? we : ae.target;
    if (!(Ae != null && Ae.isConnected))
      return K(null), void ve({ current: null });
    w ? Lt() : ze(!0), K(Ae), ve({ current: Ae }), Xt(ne);
  }, kt = () => {
    g ? Yt(o || 100) : o ? Yt() : ze(!1), Xt($);
  }, $t = ({ x: ae, y: we }) => {
    var Ae;
    const Je = { getBoundingClientRect: () => ({ x: ae, y: we, width: 0, height: 0, top: we, left: ae, right: ae, bottom: we }) };
    El({ place: (Ae = se == null ? void 0 : se.place) !== null && Ae !== void 0 ? Ae : l, offset: d, elementReference: Je, tooltipReference: he.current, tooltipArrowReference: Ue.current, strategy: y, middlewares: b, border: Q }).then((dt) => {
      jt(dt);
    });
  }, Ot = (ae) => {
    if (!ae)
      return;
    const we = ae, Ae = { x: we.clientX, y: we.clientY };
    $t(Ae), Me.current = Ae;
  }, Jt = (ae) => {
    var we;
    if (!V)
      return;
    const Ae = ae.target;
    Ae.isConnected && (!((we = he.current) === null || we === void 0) && we.contains(Ae) || [document.querySelector(`[id='${a}']`), ...le].some((Je) => Je == null ? void 0 : Je.contains(Ae)) || (ze(!1), Xt($)));
  }, ei = Ol(Dt, 50, !0), it = Ol(kt, 50, !0), gt = (ae) => {
    it.cancel(), ei(ae);
  }, ge = () => {
    ei.cancel(), it();
  }, Le = He(() => {
    var ae, we;
    const Ae = (ae = se == null ? void 0 : se.position) !== null && ae !== void 0 ? ae : P;
    Ae ? $t(Ae) : u ? Me.current && $t(Me.current) : W != null && W.isConnected && El({ place: (we = se == null ? void 0 : se.place) !== null && we !== void 0 ? we : l, offset: d, elementReference: W, tooltipReference: he.current, tooltipArrowReference: Ue.current, strategy: y, middlewares: b, border: Q }).then((Je) => {
      Ve.current && jt(Je);
    });
  }, [V, W, U, D, l, se == null ? void 0 : se.place, d, y, P, se == null ? void 0 : se.position, u]);
  ee(() => {
    var ae, we;
    const Ae = new Set(de);
    le.forEach((Oe) => {
      C != null && C(Oe) || Ae.add({ current: Oe });
    });
    const Je = document.querySelector(`[id='${a}']`);
    Je && !(C != null && C(Je)) && Ae.add({ current: Je });
    const dt = () => {
      ze(!1);
    }, Tt = Il(W), It = Il(he.current);
    mt.scroll && (window.addEventListener("scroll", dt), Tt == null || Tt.addEventListener("scroll", dt), It == null || It.addEventListener("scroll", dt));
    let nt = null;
    mt.resize ? window.addEventListener("resize", dt) : W && he.current && (nt = tI(W, he.current, Le, { ancestorResize: !0, elementResize: !0, layoutShift: !0 }));
    const B = (Oe) => {
      Oe.key === "Escape" && ze(!1);
    };
    mt.escape && window.addEventListener("keydown", B), mt.clickOutsideAnchor && window.addEventListener("click", Jt);
    const Y = [], ie = (Oe) => {
      V && (Oe == null ? void 0 : Oe.target) === W || Dt(Oe);
    }, xe = (Oe) => {
      V && (Oe == null ? void 0 : Oe.target) === W && kt();
    }, De = ["mouseover", "mouseout", "mouseenter", "mouseleave", "focus", "blur"], We = ["click", "dblclick", "mousedown", "mouseup"];
    Object.entries(ct).forEach(([Oe, L]) => {
      L && (De.includes(Oe) ? Y.push({ event: Oe, listener: gt }) : We.includes(Oe) && Y.push({ event: Oe, listener: ie }));
    }), Object.entries(wt).forEach(([Oe, L]) => {
      L && (De.includes(Oe) ? Y.push({ event: Oe, listener: ge }) : We.includes(Oe) && Y.push({ event: Oe, listener: xe }));
    }), u && Y.push({ event: "pointermove", listener: Ot });
    const Ne = () => {
      Ee.current = !0;
    }, Ie = () => {
      Ee.current = !1, kt();
    };
    return g && !tt && ((ae = he.current) === null || ae === void 0 || ae.addEventListener("mouseenter", Ne), (we = he.current) === null || we === void 0 || we.addEventListener("mouseleave", Ie)), Y.forEach(({ event: Oe, listener: L }) => {
      Ae.forEach((H) => {
        var J;
        (J = H.current) === null || J === void 0 || J.addEventListener(Oe, L);
      });
    }), () => {
      var Oe, L;
      mt.scroll && (window.removeEventListener("scroll", dt), Tt == null || Tt.removeEventListener("scroll", dt), It == null || It.removeEventListener("scroll", dt)), mt.resize ? window.removeEventListener("resize", dt) : nt == null || nt(), mt.clickOutsideAnchor && window.removeEventListener("click", Jt), mt.escape && window.removeEventListener("keydown", B), g && !tt && ((Oe = he.current) === null || Oe === void 0 || Oe.removeEventListener("mouseenter", Ne), (L = he.current) === null || L === void 0 || L.removeEventListener("mouseleave", Ie)), Y.forEach(({ event: H, listener: J }) => {
        Ae.forEach((_) => {
          var me;
          (me = _.current) === null || me === void 0 || me.removeEventListener(H, J);
        });
      });
    };
  }, [W, Le, re, de, le, k, R, O, lt, w, o]), ee(() => {
    var ae, we;
    let Ae = (we = (ae = se == null ? void 0 : se.anchorSelect) !== null && ae !== void 0 ? ae : c) !== null && we !== void 0 ? we : "";
    !Ae && e && (Ae = `[data-tooltip-id='${e.replace(/'/g, "\\'")}']`);
    const Je = new MutationObserver((dt) => {
      const Tt = [], It = [];
      dt.forEach((nt) => {
        if (nt.type === "attributes" && nt.attributeName === "data-tooltip-id" && (nt.target.getAttribute("data-tooltip-id") === e ? Tt.push(nt.target) : nt.oldValue === e && It.push(nt.target)), nt.type === "childList") {
          if (W) {
            const B = [...nt.removedNodes].filter((Y) => Y.nodeType === 1);
            if (Ae)
              try {
                It.push(...B.filter((Y) => Y.matches(Ae))), It.push(...B.flatMap((Y) => [...Y.querySelectorAll(Ae)]));
              } catch {
              }
            B.some((Y) => {
              var ie;
              return !!(!((ie = Y == null ? void 0 : Y.contains) === null || ie === void 0) && ie.call(Y, W)) && (be(!1), ze(!1), K(null), Xt($), Xt(ne), !0);
            });
          }
          if (Ae)
            try {
              const B = [...nt.addedNodes].filter((Y) => Y.nodeType === 1);
              Tt.push(...B.filter((Y) => Y.matches(Ae))), Tt.push(...B.flatMap((Y) => [...Y.querySelectorAll(Ae)]));
            } catch {
            }
        }
      }), (Tt.length || It.length) && pe((nt) => [...nt.filter((B) => !It.includes(B)), ...Tt]);
    });
    return Je.observe(document.body, { childList: !0, subtree: !0, attributes: !0, attributeFilter: ["data-tooltip-id"], attributeOldValue: !0 }), () => {
      Je.disconnect();
    };
  }, [e, c, se == null ? void 0 : se.anchorSelect, W]), ee(() => {
    Le();
  }, [Le]), ee(() => {
    if (!(z != null && z.current))
      return () => null;
    const ae = new ResizeObserver(() => {
      setTimeout(() => Le());
    });
    return ae.observe(z.current), () => {
      ae.disconnect();
    };
  }, [U, z == null ? void 0 : z.current]), ee(() => {
    var ae;
    const we = document.querySelector(`[id='${a}']`), Ae = [...le, we];
    W && Ae.includes(W) || K((ae = le[0]) !== null && ae !== void 0 ? ae : we);
  }, [a, le, W]), ee(() => (F && ze(!0), () => {
    Xt($), Xt(ne);
  }), []), ee(() => {
    var ae;
    let we = (ae = se == null ? void 0 : se.anchorSelect) !== null && ae !== void 0 ? ae : c;
    if (!we && e && (we = `[data-tooltip-id='${e.replace(/'/g, "\\'")}']`), we)
      try {
        const Ae = Array.from(document.querySelectorAll(we));
        pe(Ae);
      } catch {
        pe([]);
      }
  }, [e, c, se == null ? void 0 : se.anchorSelect]), ee(() => {
    $.current && (Xt($), Lt(w));
  }, [w]);
  const yt = (ce = se == null ? void 0 : se.content) !== null && ce !== void 0 ? ce : U, Nt = V && Object.keys(ue.tooltipStyles).length > 0;
  return lf(n, () => ({ open: (ae) => {
    if (ae != null && ae.anchorSelect)
      try {
        document.querySelector(ae.anchorSelect);
      } catch {
        return void console.warn(`[react-tooltip] "${ae.anchorSelect}" is not a valid CSS selector`);
      }
    Se(ae ?? null), ae != null && ae.delay ? Lt(ae.delay) : ze(!0);
  }, close: (ae) => {
    ae != null && ae.delay ? Yt(ae.delay) : ze(!1);
  }, activeAnchor: W, place: ue.place, isOpen: !!(re && !f && yt && Nt) })), re && !f && yt ? Fe.createElement(v, { id: e, role: te, className: Do("react-tooltip", un.tooltip, eo.tooltip, eo[r], t, `react-tooltip__place-${ue.place}`, un[Nt ? "show" : "closing"], Nt ? "react-tooltip__show" : "react-tooltip__closing", y === "fixed" && un.fixed, g && un.clickable), onTransitionEnd: (ae) => {
    Xt(ye), V || ae.propertyName !== "opacity" || (be(!1), Se(null), I == null || I());
  }, style: { ...D, ...ue.tooltipStyles, opacity: G !== void 0 && Nt ? G : void 0 }, ref: he }, yt, Fe.createElement(v, { className: Do("react-tooltip-arrow", un.arrow, eo.arrow, s, p && un.noArrow), style: { ...ue.tooltipArrowStyles, background: M ? `linear-gradient(to right bottom, transparent 50%, ${M} 50%)` : void 0 }, ref: Ue })) : null;
}, mI = ({ content: n }) => Fe.createElement("span", { dangerouslySetInnerHTML: { __html: n } }), gI = Fe.forwardRef(({ id: n, anchorId: e, anchorSelect: t, content: s, html: r, render: a, className: c, classNameArrow: l, variant: d = "dark", place: h = "top", offset: m = 10, wrapper: y = "div", children: b = null, events: v = ["hover"], openOnClick: w = !1, positionStrategy: o = "absolute", middlewares: u, delayShow: f = 0, delayHide: p = 0, float: g = !1, hidden: S = !1, noArrow: x = !1, clickable: E = !1, closeOnEsc: k = !1, closeOnScroll: R = !1, closeOnResize: O = !1, openEvents: T, closeEvents: D, globalCloseEvents: P, imperativeModeOnly: N = !1, style: I, position: C, isOpen: U, defaultIsOpen: z = !1, disableStyleInjection: j = !1, border: F, opacity: q, arrowColor: W, setIsOpen: K, afterShow: Q, afterHide: G, disableTooltip: M, role: te = "tooltip" }, ce) => {
  const [he, Ue] = X(s), [$, ne] = X(r), [ye, ue] = X(h), [je, V] = X(d), [Z, re] = X(m), [be, se] = X(f), [Se, Ce] = X(p), [Me, de] = X(g), [ve, Ee] = X(S), [le, pe] = X(y), [Ve, lt] = X(v), [tt, ct] = X(o), [wt, mt] = X(null), [ze, jt] = X(null), Lt = Re(j), { anchorRefs: Yt, activeAnchor: Dt } = Du(n), kt = (it) => it == null ? void 0 : it.getAttributeNames().reduce((gt, ge) => {
    var Le;
    return ge.startsWith("data-tooltip-") && (gt[ge.replace(/^data-tooltip-/, "")] = (Le = it == null ? void 0 : it.getAttribute(ge)) !== null && Le !== void 0 ? Le : null), gt;
  }, {}), $t = (it) => {
    const gt = { place: (ge) => {
      var Le;
      ue((Le = ge) !== null && Le !== void 0 ? Le : h);
    }, content: (ge) => {
      Ue(ge ?? s);
    }, html: (ge) => {
      ne(ge ?? r);
    }, variant: (ge) => {
      var Le;
      V((Le = ge) !== null && Le !== void 0 ? Le : d);
    }, offset: (ge) => {
      re(ge === null ? m : Number(ge));
    }, wrapper: (ge) => {
      var Le;
      pe((Le = ge) !== null && Le !== void 0 ? Le : y);
    }, events: (ge) => {
      const Le = ge == null ? void 0 : ge.split(" ");
      lt(Le ?? v);
    }, "position-strategy": (ge) => {
      var Le;
      ct((Le = ge) !== null && Le !== void 0 ? Le : o);
    }, "delay-show": (ge) => {
      se(ge === null ? f : Number(ge));
    }, "delay-hide": (ge) => {
      Ce(ge === null ? p : Number(ge));
    }, float: (ge) => {
      de(ge === null ? g : ge === "true");
    }, hidden: (ge) => {
      Ee(ge === null ? S : ge === "true");
    }, "class-name": (ge) => {
      mt(ge);
    } };
    Object.values(gt).forEach((ge) => ge(null)), Object.entries(it).forEach(([ge, Le]) => {
      var yt;
      (yt = gt[ge]) === null || yt === void 0 || yt.call(gt, Le);
    });
  };
  ee(() => {
    Ue(s);
  }, [s]), ee(() => {
    ne(r);
  }, [r]), ee(() => {
    ue(h);
  }, [h]), ee(() => {
    V(d);
  }, [d]), ee(() => {
    re(m);
  }, [m]), ee(() => {
    se(f);
  }, [f]), ee(() => {
    Ce(p);
  }, [p]), ee(() => {
    de(g);
  }, [g]), ee(() => {
    Ee(S);
  }, [S]), ee(() => {
    ct(o);
  }, [o]), ee(() => {
    Lt.current !== j && console.warn("[react-tooltip] Do not change `disableStyleInjection` dynamically.");
  }, [j]), ee(() => {
    typeof window < "u" && window.dispatchEvent(new CustomEvent("react-tooltip-inject-styles", { detail: { disableCore: j === "core", disableBase: j } }));
  }, []), ee(() => {
    var it;
    const gt = new Set(Yt);
    let ge = t;
    if (!ge && n && (ge = `[data-tooltip-id='${n.replace(/'/g, "\\'")}']`), ge)
      try {
        document.querySelectorAll(ge).forEach((we) => {
          gt.add({ current: we });
        });
      } catch {
        console.warn(`[react-tooltip] "${ge}" is not a valid CSS selector`);
      }
    const Le = document.querySelector(`[id='${e}']`);
    if (Le && gt.add({ current: Le }), !gt.size)
      return () => null;
    const yt = (it = ze ?? Le) !== null && it !== void 0 ? it : Dt.current, Nt = new MutationObserver((we) => {
      we.forEach((Ae) => {
        var Je;
        if (!yt || Ae.type !== "attributes" || !(!((Je = Ae.attributeName) === null || Je === void 0) && Je.startsWith("data-tooltip-")))
          return;
        const dt = kt(yt);
        $t(dt);
      });
    }), ae = { attributes: !0, childList: !1, subtree: !1 };
    if (yt) {
      const we = kt(yt);
      $t(we), Nt.observe(yt, ae);
    }
    return () => {
      Nt.disconnect();
    };
  }, [Yt, Dt, ze, e, t]), ee(() => {
    I != null && I.border && console.warn("[react-tooltip] Do not set `style.border`. Use `border` prop instead."), F && !kl("border", `${F}`) && console.warn(`[react-tooltip] "${F}" is not a valid \`border\`.`), I != null && I.opacity && console.warn("[react-tooltip] Do not set `style.opacity`. Use `opacity` prop instead."), q && !kl("opacity", `${q}`) && console.warn(`[react-tooltip] "${q}" is not a valid \`opacity\`.`);
  }, []);
  let Ot = b;
  const Jt = Re(null);
  if (a) {
    const it = a({ content: (ze == null ? void 0 : ze.getAttribute("data-tooltip-content")) || he || null, activeAnchor: ze });
    Ot = it ? Fe.createElement("div", { ref: Jt, className: "react-tooltip-content-wrapper" }, it) : null;
  } else
    he && (Ot = he);
  $ && (Ot = Fe.createElement(mI, { content: $ }));
  const ei = { forwardRef: ce, id: n, anchorId: e, anchorSelect: t, className: Do(c, wt), classNameArrow: l, content: Ot, contentWrapperRef: Jt, place: ye, variant: je, offset: Z, wrapper: le, events: Ve, openOnClick: w, positionStrategy: tt, middlewares: u, delayShow: be, delayHide: Se, float: Me, hidden: ve, noArrow: x, clickable: E, closeOnEsc: k, closeOnScroll: R, closeOnResize: O, openEvents: T, closeEvents: D, globalCloseEvents: P, imperativeModeOnly: N, style: I, position: C, isOpen: U, defaultIsOpen: z, border: F, opacity: q, arrowColor: W, setIsOpen: K, afterShow: Q, afterHide: G, disableTooltip: M, activeAnchor: ze, setActiveAnchor: (it) => jt(it), role: te };
  return Fe.createElement(pI, { ...ei });
});
typeof window < "u" && window.addEventListener("react-tooltip-inject-styles", (n) => {
  n.detail.disableCore || Cl({ css: ":root{--rt-color-white:#fff;--rt-color-dark:#222;--rt-color-success:#8dc572;--rt-color-error:#be6464;--rt-color-warning:#f0ad4e;--rt-color-info:#337ab7;--rt-opacity:0.9;--rt-transition-show-delay:0.15s;--rt-transition-closing-delay:0.15s}.core-styles-module_tooltip__3vRRp{position:absolute;top:0;left:0;pointer-events:none;opacity:0;will-change:opacity}.core-styles-module_fixed__pcSol{position:fixed}.core-styles-module_arrow__cvMwQ{position:absolute;background:inherit}.core-styles-module_noArrow__xock6{display:none}.core-styles-module_clickable__ZuTTB{pointer-events:auto}.core-styles-module_show__Nt9eE{opacity:var(--rt-opacity);transition:opacity var(--rt-transition-show-delay)ease-out}.core-styles-module_closing__sGnxF{opacity:0;transition:opacity var(--rt-transition-closing-delay)ease-in}", type: "core" }), n.detail.disableBase || Cl({ css: `
.styles-module_tooltip__mnnfp{padding:8px 16px;border-radius:3px;font-size:90%;width:max-content}.styles-module_arrow__K0L3T{width:8px;height:8px}[class*='react-tooltip__place-top']>.styles-module_arrow__K0L3T{transform:rotate(45deg)}[class*='react-tooltip__place-right']>.styles-module_arrow__K0L3T{transform:rotate(135deg)}[class*='react-tooltip__place-bottom']>.styles-module_arrow__K0L3T{transform:rotate(225deg)}[class*='react-tooltip__place-left']>.styles-module_arrow__K0L3T{transform:rotate(315deg)}.styles-module_dark__xNqje{background:var(--rt-color-dark);color:var(--rt-color-white)}.styles-module_light__Z6W-X{background-color:var(--rt-color-white);color:var(--rt-color-dark)}.styles-module_success__A2AKt{background-color:var(--rt-color-success);color:var(--rt-color-white)}.styles-module_warning__SCK0X{background-color:var(--rt-color-warning);color:var(--rt-color-white)}.styles-module_error__JvumD{background-color:var(--rt-color-error);color:var(--rt-color-white)}.styles-module_info__BWdHW{background-color:var(--rt-color-info);color:var(--rt-color-white)}`, type: "base" });
});
const Nu = ({
  className: n = "",
  message: e = "",
  place: t = "top",
  trigger: s = "hover",
  icon: r = "fa-solid fa-circle-info",
  id: a,
  fontSize: c = "16px",
  color: l = null
}) => {
  const d = `random-id-${(1 + Date.now() + Math.random()).toString().replace(".", "")}`, h = Fe.useRef(null), [m, y] = Fe.useState("light");
  Fe.useEffect(() => {
    h.current = new MutationObserver((w) => {
      w.forEach((o) => {
        o.type !== "attributes" && o.attributeName !== "class" || b();
      });
    });
    const v = document.getElementsByTagName("html")[0];
    h.current.observe(v, { attributes: !0 }), b();
  });
  const b = () => {
    const v = document.getElementsByTagName("html")[0];
    v != null && v.classList.contains("dark") ? y("light") : y("dark");
  };
  return /* @__PURE__ */ A.jsxs("span", { className: n, children: [
    /* @__PURE__ */ A.jsx(
      "i",
      {
        className: `icon-tip ${r}`,
        "data-tooltip-content": e,
        "data-html": !0,
        "data-tooltip-id": a || d,
        "data-event": s === "click" ? "click" : null,
        style: { fontSize: c, color: l }
      }
    ),
    /* @__PURE__ */ A.jsx(gI, { className: "tip-class", "aria-haspopup": "true", id: a || d, place: t, variant: m })
  ] });
}, B2 = ({
  value: n,
  total: e,
  percentage: t = !1,
  label: s = "",
  colorBar: r = "var(--primary_color)",
  emoji: a = "",
  tooltip: c = ""
}) => {
  const l = xt(() => e || (t ? 1 : 100), [t, e]), d = xt(() => new Tn(), []), [h, m] = X("en"), { formatPercent: y } = d, w = ((o, u) => `${(o * 100 / u).toFixed(0)}%`)(n, l);
  return ee(() => {
    const o = er == null ? void 0 : er.subscribe((u) => {
      m(u);
    });
    return () => {
      o == null || o.unsubscribe();
    };
  }, []), /* @__PURE__ */ A.jsxs("div", { children: [
    /* @__PURE__ */ A.jsxs("div", { className: "display-flex justify-content-space-between my-2", children: [
      /* @__PURE__ */ A.jsxs("div", { className: "display-flex align-items-center", children: [
        a && /* @__PURE__ */ A.jsx("span", { className: "category-emoji mr-3", children: a }),
        /* @__PURE__ */ A.jsx("div", { className: "text-bold", children: s }),
        c && /* @__PURE__ */ A.jsx(Nu, { message: c, icon: "fa-regular fa-circle-info ml-2" })
      ] }),
      /* @__PURE__ */ A.jsx("div", { className: "text-bold", children: t ? y(n / 100) : d == null ? void 0 : d.formatStandardNumber({ lang: h, number: n }) })
    ] }),
    /* @__PURE__ */ A.jsx("div", { className: "bar-chart", children: /* @__PURE__ */ A.jsx("div", { className: "value-bar", style: { width: w, backgroundColor: r } }) })
  ] });
};
const q2 = ({ children: n, className: e = "", iconColor: t = "var(--primary_color)", title: s = "" }) => /* @__PURE__ */ A.jsxs("section", { className: `border-with-icon ${e}`, children: [
  /* @__PURE__ */ A.jsxs("h4", { children: [
    /* @__PURE__ */ A.jsx("i", { className: "fa-solid fa-bookmark bookmark", style: { color: t } }),
    s
  ] }),
  /* @__PURE__ */ A.jsx("div", { className: "inside-border", children: n })
] });
const H2 = ({
  children: n,
  title: e,
  icon: t = null,
  colorIcon: s = "var(--gold)",
  backgroundColor: r = "var(--background)",
  textColor: a = "var(--text_color)",
  type: c = null,
  className: l = "",
  smallIconStyle: d = !1,
  titleFontSize: h = "1rem",
  iconFontSize: m = "32px",
  bottomChildren: y,
  style: b
}) => {
  var w, o, u, f, p, g;
  const v = {
    danger: {
      backgroundColor: "var(--red_light)",
      textColor: "var(--red_dark)",
      icon: "fa-solid fa-triangle-exclamation",
      colorIcon: "var(--red_dark)"
    },
    info: {
      backgroundColor: "var(--blue_light)",
      textColor: "var(--blue_dark)",
      icon: "fa-regular fa-circle-info",
      colorIcon: "var(--blue_dark)"
    },
    success: {
      backgroundColor: "var(--green_light)",
      textColor: "var(--green_dark)",
      icon: "fa-regular fa-circle-check",
      colorIcon: "var(--green_dark)"
    },
    warning: {
      backgroundColor: "var(--background)",
      textColor: "var(--text_color)",
      icon: "fa-regular fa-diamond-exclamation",
      colorIcon: "var(--gold)"
    }
  };
  return /* @__PURE__ */ A.jsx(
    "section",
    {
      className: `callout-container ${l}`,
      style: {
        backgroundColor: c ? (w = v == null ? void 0 : v[c]) == null ? void 0 : w.backgroundColor : r,
        color: c ? (o = v[c]) == null ? void 0 : o.textColor : a,
        ...b
      },
      children: /* @__PURE__ */ A.jsxs("div", { className: "callout-content", children: [
        /* @__PURE__ */ A.jsx("div", { className: "callout-info", children: /* @__PURE__ */ A.jsxs("div", { className: "labels", children: [
          /* @__PURE__ */ A.jsxs("h6", { className: "title text-bold mb-1", style: { fontSize: h }, children: [
            d ? /* @__PURE__ */ A.jsx(
              "i",
              {
                className: `mr-2 ${c ? (u = v[c]) == null ? void 0 : u.icon : t}`,
                style: { color: c ? (f = v[c]) == null ? void 0 : f.colorIcon : s, fontSize: h }
              }
            ) : null,
            e
          ] }),
          /* @__PURE__ */ A.jsxs("div", { className: "description display-flex", children: [
            t && !d ? /* @__PURE__ */ A.jsx(
              "i",
              {
                className: `m-1 mr-3 ${c ? (p = v[c]) == null ? void 0 : p.icon : t} icon-description display-flex align-items-center`,
                style: { color: c ? (g = v[c]) == null ? void 0 : g.colorIcon : s, fontSize: m }
              }
            ) : null,
            n
          ] })
        ] }) }),
        y ? /* @__PURE__ */ A.jsx("div", { children: y }) : null
      ] })
    }
  );
};
const V2 = ({ title: n, content: e, className: t, style: s }) => /* @__PURE__ */ A.jsxs("div", { className: `card-to-copy ${t}`, style: s, children: [
  /* @__PURE__ */ A.jsx("h6", { className: "title m-0", children: n }),
  /* @__PURE__ */ A.jsx("div", { className: "content-to-copy", children: /* @__PURE__ */ A.jsx(Hx, { content: e, backgroundColor: "transparent", textColor: "var(--gray)", noMargin: !0 }) })
] });
function Ul(n) {
  return n !== null && typeof n == "object" && "constructor" in n && n.constructor === Object;
}
function fa(n, e) {
  n === void 0 && (n = {}), e === void 0 && (e = {}), Object.keys(e).forEach((t) => {
    typeof n[t] > "u" ? n[t] = e[t] : Ul(e[t]) && Ul(n[t]) && Object.keys(e[t]).length > 0 && fa(n[t], e[t]);
  });
}
const Fu = {
  body: {},
  addEventListener() {
  },
  removeEventListener() {
  },
  activeElement: {
    blur() {
    },
    nodeName: ""
  },
  querySelector() {
    return null;
  },
  querySelectorAll() {
    return [];
  },
  getElementById() {
    return null;
  },
  createEvent() {
    return {
      initEvent() {
      }
    };
  },
  createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute() {
      },
      getElementsByTagName() {
        return [];
      }
    };
  },
  createElementNS() {
    return {};
  },
  importNode() {
    return null;
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  }
};
function si() {
  const n = typeof document < "u" ? document : {};
  return fa(n, Fu), n;
}
const yI = {
  document: Fu,
  navigator: {
    userAgent: ""
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  },
  history: {
    replaceState() {
    },
    pushState() {
    },
    go() {
    },
    back() {
    }
  },
  CustomEvent: function() {
    return this;
  },
  addEventListener() {
  },
  removeEventListener() {
  },
  getComputedStyle() {
    return {
      getPropertyValue() {
        return "";
      }
    };
  },
  Image() {
  },
  Date() {
  },
  screen: {},
  setTimeout() {
  },
  clearTimeout() {
  },
  matchMedia() {
    return {};
  },
  requestAnimationFrame(n) {
    return typeof setTimeout > "u" ? (n(), null) : setTimeout(n, 0);
  },
  cancelAnimationFrame(n) {
    typeof setTimeout > "u" || clearTimeout(n);
  }
};
function Mt() {
  const n = typeof window < "u" ? window : {};
  return fa(n, yI), n;
}
function Oi(n) {
  return n === void 0 && (n = ""), n.trim().split(" ").filter((e) => !!e.trim());
}
function vI(n) {
  const e = n;
  Object.keys(e).forEach((t) => {
    try {
      e[t] = null;
    } catch {
    }
    try {
      delete e[t];
    } catch {
    }
  });
}
function gr(n, e) {
  return e === void 0 && (e = 0), setTimeout(n, e);
}
function yr() {
  return Date.now();
}
function bI(n) {
  const e = Mt();
  let t;
  return e.getComputedStyle && (t = e.getComputedStyle(n, null)), !t && n.currentStyle && (t = n.currentStyle), t || (t = n.style), t;
}
function xI(n, e) {
  e === void 0 && (e = "x");
  const t = Mt();
  let s, r, a;
  const c = bI(n);
  return t.WebKitCSSMatrix ? (r = c.transform || c.webkitTransform, r.split(",").length > 6 && (r = r.split(", ").map((l) => l.replace(",", ".")).join(", ")), a = new t.WebKitCSSMatrix(r === "none" ? "" : r)) : (a = c.MozTransform || c.OTransform || c.MsTransform || c.msTransform || c.transform || c.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,"), s = a.toString().split(",")), e === "x" && (t.WebKitCSSMatrix ? r = a.m41 : s.length === 16 ? r = parseFloat(s[12]) : r = parseFloat(s[4])), e === "y" && (t.WebKitCSSMatrix ? r = a.m42 : s.length === 16 ? r = parseFloat(s[13]) : r = parseFloat(s[5])), r || 0;
}
function Ms(n) {
  return typeof n == "object" && n !== null && n.constructor && Object.prototype.toString.call(n).slice(8, -1) === "Object";
}
function SI(n) {
  return typeof window < "u" && typeof window.HTMLElement < "u" ? n instanceof HTMLElement : n && (n.nodeType === 1 || n.nodeType === 11);
}
function Vt() {
  const n = Object(arguments.length <= 0 ? void 0 : arguments[0]), e = ["__proto__", "constructor", "prototype"];
  for (let t = 1; t < arguments.length; t += 1) {
    const s = t < 0 || arguments.length <= t ? void 0 : arguments[t];
    if (s != null && !SI(s)) {
      const r = Object.keys(Object(s)).filter((a) => e.indexOf(a) < 0);
      for (let a = 0, c = r.length; a < c; a += 1) {
        const l = r[a], d = Object.getOwnPropertyDescriptor(s, l);
        d !== void 0 && d.enumerable && (Ms(n[l]) && Ms(s[l]) ? s[l].__swiper__ ? n[l] = s[l] : Vt(n[l], s[l]) : !Ms(n[l]) && Ms(s[l]) ? (n[l] = {}, s[l].__swiper__ ? n[l] = s[l] : Vt(n[l], s[l])) : n[l] = s[l]);
      }
    }
  }
  return n;
}
function Hn(n, e, t) {
  n.style.setProperty(e, t);
}
function Bu(n) {
  let {
    swiper: e,
    targetPosition: t,
    side: s
  } = n;
  const r = Mt(), a = -e.translate;
  let c = null, l;
  const d = e.params.speed;
  e.wrapperEl.style.scrollSnapType = "none", r.cancelAnimationFrame(e.cssModeFrameID);
  const h = t > a ? "next" : "prev", m = (b, v) => h === "next" && b >= v || h === "prev" && b <= v, y = () => {
    l = (/* @__PURE__ */ new Date()).getTime(), c === null && (c = l);
    const b = Math.max(Math.min((l - c) / d, 1), 0), v = 0.5 - Math.cos(b * Math.PI) / 2;
    let w = a + v * (t - a);
    if (m(w, t) && (w = t), e.wrapperEl.scrollTo({
      [s]: w
    }), m(w, t)) {
      e.wrapperEl.style.overflow = "hidden", e.wrapperEl.style.scrollSnapType = "", setTimeout(() => {
        e.wrapperEl.style.overflow = "", e.wrapperEl.scrollTo({
          [s]: w
        });
      }), r.cancelAnimationFrame(e.cssModeFrameID);
      return;
    }
    e.cssModeFrameID = r.requestAnimationFrame(y);
  };
  y();
}
function ti(n, e) {
  e === void 0 && (e = "");
  const t = [...n.children];
  return n instanceof HTMLSlotElement && t.push(...n.assignedElements()), e ? t.filter((s) => s.matches(e)) : t;
}
function wI(n, e) {
  const t = e.contains(n);
  return !t && e instanceof HTMLSlotElement ? [...e.assignedElements()].includes(n) : t;
}
function vr(n) {
  try {
    console.warn(n);
    return;
  } catch {
  }
}
function Li(n, e) {
  e === void 0 && (e = []);
  const t = document.createElement(n);
  return t.classList.add(...Array.isArray(e) ? e : Oi(e)), t;
}
function AI(n) {
  const e = Mt(), t = si(), s = n.getBoundingClientRect(), r = t.body, a = n.clientTop || r.clientTop || 0, c = n.clientLeft || r.clientLeft || 0, l = n === e ? e.scrollY : n.scrollTop, d = n === e ? e.scrollX : n.scrollLeft;
  return {
    top: s.top + l - a,
    left: s.left + d - c
  };
}
function CI(n, e) {
  const t = [];
  for (; n.previousElementSibling; ) {
    const s = n.previousElementSibling;
    e ? s.matches(e) && t.push(s) : t.push(s), n = s;
  }
  return t;
}
function EI(n, e) {
  const t = [];
  for (; n.nextElementSibling; ) {
    const s = n.nextElementSibling;
    e ? s.matches(e) && t.push(s) : t.push(s), n = s;
  }
  return t;
}
function Ti(n, e) {
  return Mt().getComputedStyle(n, null).getPropertyValue(e);
}
function os(n) {
  let e = n, t;
  if (e) {
    for (t = 0; (e = e.previousSibling) !== null; )
      e.nodeType === 1 && (t += 1);
    return t;
  }
}
function qu(n, e) {
  const t = [];
  let s = n.parentElement;
  for (; s; )
    e ? s.matches(e) && t.push(s) : t.push(s), s = s.parentElement;
  return t;
}
function Fo(n, e, t) {
  const s = Mt();
  return t ? n[e === "width" ? "offsetWidth" : "offsetHeight"] + parseFloat(s.getComputedStyle(n, null).getPropertyValue(e === "width" ? "margin-right" : "margin-top")) + parseFloat(s.getComputedStyle(n, null).getPropertyValue(e === "width" ? "margin-left" : "margin-bottom")) : n.offsetWidth;
}
function Be(n) {
  return (Array.isArray(n) ? n : [n]).filter((e) => !!e);
}
let to;
function kI() {
  const n = Mt(), e = si();
  return {
    smoothScroll: e.documentElement && e.documentElement.style && "scrollBehavior" in e.documentElement.style,
    touch: !!("ontouchstart" in n || n.DocumentTouch && e instanceof n.DocumentTouch)
  };
}
function Hu() {
  return to || (to = kI()), to;
}
let io;
function OI(n) {
  let {
    userAgent: e
  } = n === void 0 ? {} : n;
  const t = Hu(), s = Mt(), r = s.navigator.platform, a = e || s.navigator.userAgent, c = {
    ios: !1,
    android: !1
  }, l = s.screen.width, d = s.screen.height, h = a.match(/(Android);?[\s\/]+([\d.]+)?/);
  let m = a.match(/(iPad).*OS\s([\d_]+)/);
  const y = a.match(/(iPod)(.*OS\s([\d_]+))?/), b = !m && a.match(/(iPhone\sOS|iOS)\s([\d_]+)/), v = r === "Win32";
  let w = r === "MacIntel";
  const o = ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"];
  return !m && w && t.touch && o.indexOf(`${l}x${d}`) >= 0 && (m = a.match(/(Version)\/([\d.]+)/), m || (m = [0, 1, "13_0_0"]), w = !1), h && !v && (c.os = "android", c.android = !0), (m || b || y) && (c.os = "ios", c.ios = !0), c;
}
function Vu(n) {
  return n === void 0 && (n = {}), io || (io = OI(n)), io;
}
let no;
function TI() {
  const n = Mt(), e = Vu();
  let t = !1;
  function s() {
    const l = n.navigator.userAgent.toLowerCase();
    return l.indexOf("safari") >= 0 && l.indexOf("chrome") < 0 && l.indexOf("android") < 0;
  }
  if (s()) {
    const l = String(n.navigator.userAgent);
    if (l.includes("Version/")) {
      const [d, h] = l.split("Version/")[1].split(" ")[0].split(".").map((m) => Number(m));
      t = d < 16 || d === 16 && h < 2;
    }
  }
  const r = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(n.navigator.userAgent), a = s(), c = a || r && e.ios;
  return {
    isSafari: t || a,
    needPerspectiveFix: t,
    need3dFix: c,
    isWebView: r
  };
}
function II() {
  return no || (no = TI()), no;
}
function UI(n) {
  let {
    swiper: e,
    on: t,
    emit: s
  } = n;
  const r = Mt();
  let a = null, c = null;
  const l = () => {
    !e || e.destroyed || !e.initialized || (s("beforeResize"), s("resize"));
  }, d = () => {
    !e || e.destroyed || !e.initialized || (a = new ResizeObserver((y) => {
      c = r.requestAnimationFrame(() => {
        const {
          width: b,
          height: v
        } = e;
        let w = b, o = v;
        y.forEach((u) => {
          let {
            contentBoxSize: f,
            contentRect: p,
            target: g
          } = u;
          g && g !== e.el || (w = p ? p.width : (f[0] || f).inlineSize, o = p ? p.height : (f[0] || f).blockSize);
        }), (w !== b || o !== v) && l();
      });
    }), a.observe(e.el));
  }, h = () => {
    c && r.cancelAnimationFrame(c), a && a.unobserve && e.el && (a.unobserve(e.el), a = null);
  }, m = () => {
    !e || e.destroyed || !e.initialized || s("orientationchange");
  };
  t("init", () => {
    if (e.params.resizeObserver && typeof r.ResizeObserver < "u") {
      d();
      return;
    }
    r.addEventListener("resize", l), r.addEventListener("orientationchange", m);
  }), t("destroy", () => {
    h(), r.removeEventListener("resize", l), r.removeEventListener("orientationchange", m);
  });
}
function zI(n) {
  let {
    swiper: e,
    extendParams: t,
    on: s,
    emit: r
  } = n;
  const a = [], c = Mt(), l = function(m, y) {
    y === void 0 && (y = {});
    const b = c.MutationObserver || c.WebkitMutationObserver, v = new b((w) => {
      if (e.__preventObserver__)
        return;
      if (w.length === 1) {
        r("observerUpdate", w[0]);
        return;
      }
      const o = function() {
        r("observerUpdate", w[0]);
      };
      c.requestAnimationFrame ? c.requestAnimationFrame(o) : c.setTimeout(o, 0);
    });
    v.observe(m, {
      attributes: typeof y.attributes > "u" ? !0 : y.attributes,
      childList: e.isElement || (typeof y.childList > "u" ? !0 : y).childList,
      characterData: typeof y.characterData > "u" ? !0 : y.characterData
    }), a.push(v);
  }, d = () => {
    if (e.params.observer) {
      if (e.params.observeParents) {
        const m = qu(e.hostEl);
        for (let y = 0; y < m.length; y += 1)
          l(m[y]);
      }
      l(e.hostEl, {
        childList: e.params.observeSlideChildren
      }), l(e.wrapperEl, {
        attributes: !1
      });
    }
  }, h = () => {
    a.forEach((m) => {
      m.disconnect();
    }), a.splice(0, a.length);
  };
  t({
    observer: !1,
    observeParents: !1,
    observeSlideChildren: !1
  }), s("init", d), s("destroy", h);
}
var RI = {
  on(n, e, t) {
    const s = this;
    if (!s.eventsListeners || s.destroyed || typeof e != "function")
      return s;
    const r = t ? "unshift" : "push";
    return n.split(" ").forEach((a) => {
      s.eventsListeners[a] || (s.eventsListeners[a] = []), s.eventsListeners[a][r](e);
    }), s;
  },
  once(n, e, t) {
    const s = this;
    if (!s.eventsListeners || s.destroyed || typeof e != "function")
      return s;
    function r() {
      s.off(n, r), r.__emitterProxy && delete r.__emitterProxy;
      for (var a = arguments.length, c = new Array(a), l = 0; l < a; l++)
        c[l] = arguments[l];
      e.apply(s, c);
    }
    return r.__emitterProxy = e, s.on(n, r, t);
  },
  onAny(n, e) {
    const t = this;
    if (!t.eventsListeners || t.destroyed || typeof n != "function")
      return t;
    const s = e ? "unshift" : "push";
    return t.eventsAnyListeners.indexOf(n) < 0 && t.eventsAnyListeners[s](n), t;
  },
  offAny(n) {
    const e = this;
    if (!e.eventsListeners || e.destroyed || !e.eventsAnyListeners)
      return e;
    const t = e.eventsAnyListeners.indexOf(n);
    return t >= 0 && e.eventsAnyListeners.splice(t, 1), e;
  },
  off(n, e) {
    const t = this;
    return !t.eventsListeners || t.destroyed || !t.eventsListeners || n.split(" ").forEach((s) => {
      typeof e > "u" ? t.eventsListeners[s] = [] : t.eventsListeners[s] && t.eventsListeners[s].forEach((r, a) => {
        (r === e || r.__emitterProxy && r.__emitterProxy === e) && t.eventsListeners[s].splice(a, 1);
      });
    }), t;
  },
  emit() {
    const n = this;
    if (!n.eventsListeners || n.destroyed || !n.eventsListeners)
      return n;
    let e, t, s;
    for (var r = arguments.length, a = new Array(r), c = 0; c < r; c++)
      a[c] = arguments[c];
    return typeof a[0] == "string" || Array.isArray(a[0]) ? (e = a[0], t = a.slice(1, a.length), s = n) : (e = a[0].events, t = a[0].data, s = a[0].context || n), t.unshift(s), (Array.isArray(e) ? e : e.split(" ")).forEach((d) => {
      n.eventsAnyListeners && n.eventsAnyListeners.length && n.eventsAnyListeners.forEach((h) => {
        h.apply(s, [d, ...t]);
      }), n.eventsListeners && n.eventsListeners[d] && n.eventsListeners[d].forEach((h) => {
        h.apply(s, t);
      });
    }), n;
  }
};
function PI() {
  const n = this;
  let e, t;
  const s = n.el;
  typeof n.params.width < "u" && n.params.width !== null ? e = n.params.width : e = s.clientWidth, typeof n.params.height < "u" && n.params.height !== null ? t = n.params.height : t = s.clientHeight, !(e === 0 && n.isHorizontal() || t === 0 && n.isVertical()) && (e = e - parseInt(Ti(s, "padding-left") || 0, 10) - parseInt(Ti(s, "padding-right") || 0, 10), t = t - parseInt(Ti(s, "padding-top") || 0, 10) - parseInt(Ti(s, "padding-bottom") || 0, 10), Number.isNaN(e) && (e = 0), Number.isNaN(t) && (t = 0), Object.assign(n, {
    width: e,
    height: t,
    size: n.isHorizontal() ? e : t
  }));
}
function MI() {
  const n = this;
  function e(T, D) {
    return parseFloat(T.getPropertyValue(n.getDirectionLabel(D)) || 0);
  }
  const t = n.params, {
    wrapperEl: s,
    slidesEl: r,
    size: a,
    rtlTranslate: c,
    wrongRTL: l
  } = n, d = n.virtual && t.virtual.enabled, h = d ? n.virtual.slides.length : n.slides.length, m = ti(r, `.${n.params.slideClass}, swiper-slide`), y = d ? n.virtual.slides.length : m.length;
  let b = [];
  const v = [], w = [];
  let o = t.slidesOffsetBefore;
  typeof o == "function" && (o = t.slidesOffsetBefore.call(n));
  let u = t.slidesOffsetAfter;
  typeof u == "function" && (u = t.slidesOffsetAfter.call(n));
  const f = n.snapGrid.length, p = n.slidesGrid.length;
  let g = t.spaceBetween, S = -o, x = 0, E = 0;
  if (typeof a > "u")
    return;
  typeof g == "string" && g.indexOf("%") >= 0 ? g = parseFloat(g.replace("%", "")) / 100 * a : typeof g == "string" && (g = parseFloat(g)), n.virtualSize = -g, m.forEach((T) => {
    c ? T.style.marginLeft = "" : T.style.marginRight = "", T.style.marginBottom = "", T.style.marginTop = "";
  }), t.centeredSlides && t.cssMode && (Hn(s, "--swiper-centered-offset-before", ""), Hn(s, "--swiper-centered-offset-after", ""));
  const k = t.grid && t.grid.rows > 1 && n.grid;
  k ? n.grid.initSlides(m) : n.grid && n.grid.unsetSlides();
  let R;
  const O = t.slidesPerView === "auto" && t.breakpoints && Object.keys(t.breakpoints).filter((T) => typeof t.breakpoints[T].slidesPerView < "u").length > 0;
  for (let T = 0; T < y; T += 1) {
    R = 0;
    let D;
    if (m[T] && (D = m[T]), k && n.grid.updateSlide(T, D, m), !(m[T] && Ti(D, "display") === "none")) {
      if (t.slidesPerView === "auto") {
        O && (m[T].style[n.getDirectionLabel("width")] = "");
        const P = getComputedStyle(D), N = D.style.transform, I = D.style.webkitTransform;
        if (N && (D.style.transform = "none"), I && (D.style.webkitTransform = "none"), t.roundLengths)
          R = n.isHorizontal() ? Fo(D, "width", !0) : Fo(D, "height", !0);
        else {
          const C = e(P, "width"), U = e(P, "padding-left"), z = e(P, "padding-right"), j = e(P, "margin-left"), F = e(P, "margin-right"), q = P.getPropertyValue("box-sizing");
          if (q && q === "border-box")
            R = C + j + F;
          else {
            const {
              clientWidth: W,
              offsetWidth: K
            } = D;
            R = C + U + z + j + F + (K - W);
          }
        }
        N && (D.style.transform = N), I && (D.style.webkitTransform = I), t.roundLengths && (R = Math.floor(R));
      } else
        R = (a - (t.slidesPerView - 1) * g) / t.slidesPerView, t.roundLengths && (R = Math.floor(R)), m[T] && (m[T].style[n.getDirectionLabel("width")] = `${R}px`);
      m[T] && (m[T].swiperSlideSize = R), w.push(R), t.centeredSlides ? (S = S + R / 2 + x / 2 + g, x === 0 && T !== 0 && (S = S - a / 2 - g), T === 0 && (S = S - a / 2 - g), Math.abs(S) < 1 / 1e3 && (S = 0), t.roundLengths && (S = Math.floor(S)), E % t.slidesPerGroup === 0 && b.push(S), v.push(S)) : (t.roundLengths && (S = Math.floor(S)), (E - Math.min(n.params.slidesPerGroupSkip, E)) % n.params.slidesPerGroup === 0 && b.push(S), v.push(S), S = S + R + g), n.virtualSize += R + g, x = R, E += 1;
    }
  }
  if (n.virtualSize = Math.max(n.virtualSize, a) + u, c && l && (t.effect === "slide" || t.effect === "coverflow") && (s.style.width = `${n.virtualSize + g}px`), t.setWrapperSize && (s.style[n.getDirectionLabel("width")] = `${n.virtualSize + g}px`), k && n.grid.updateWrapperSize(R, b), !t.centeredSlides) {
    const T = [];
    for (let D = 0; D < b.length; D += 1) {
      let P = b[D];
      t.roundLengths && (P = Math.floor(P)), b[D] <= n.virtualSize - a && T.push(P);
    }
    b = T, Math.floor(n.virtualSize - a) - Math.floor(b[b.length - 1]) > 1 && b.push(n.virtualSize - a);
  }
  if (d && t.loop) {
    const T = w[0] + g;
    if (t.slidesPerGroup > 1) {
      const D = Math.ceil((n.virtual.slidesBefore + n.virtual.slidesAfter) / t.slidesPerGroup), P = T * t.slidesPerGroup;
      for (let N = 0; N < D; N += 1)
        b.push(b[b.length - 1] + P);
    }
    for (let D = 0; D < n.virtual.slidesBefore + n.virtual.slidesAfter; D += 1)
      t.slidesPerGroup === 1 && b.push(b[b.length - 1] + T), v.push(v[v.length - 1] + T), n.virtualSize += T;
  }
  if (b.length === 0 && (b = [0]), g !== 0) {
    const T = n.isHorizontal() && c ? "marginLeft" : n.getDirectionLabel("marginRight");
    m.filter((D, P) => !t.cssMode || t.loop ? !0 : P !== m.length - 1).forEach((D) => {
      D.style[T] = `${g}px`;
    });
  }
  if (t.centeredSlides && t.centeredSlidesBounds) {
    let T = 0;
    w.forEach((P) => {
      T += P + (g || 0);
    }), T -= g;
    const D = T > a ? T - a : 0;
    b = b.map((P) => P <= 0 ? -o : P > D ? D + u : P);
  }
  if (t.centerInsufficientSlides) {
    let T = 0;
    w.forEach((P) => {
      T += P + (g || 0);
    }), T -= g;
    const D = (t.slidesOffsetBefore || 0) + (t.slidesOffsetAfter || 0);
    if (T + D < a) {
      const P = (a - T - D) / 2;
      b.forEach((N, I) => {
        b[I] = N - P;
      }), v.forEach((N, I) => {
        v[I] = N + P;
      });
    }
  }
  if (Object.assign(n, {
    slides: m,
    snapGrid: b,
    slidesGrid: v,
    slidesSizesGrid: w
  }), t.centeredSlides && t.cssMode && !t.centeredSlidesBounds) {
    Hn(s, "--swiper-centered-offset-before", `${-b[0]}px`), Hn(s, "--swiper-centered-offset-after", `${n.size / 2 - w[w.length - 1] / 2}px`);
    const T = -n.snapGrid[0], D = -n.slidesGrid[0];
    n.snapGrid = n.snapGrid.map((P) => P + T), n.slidesGrid = n.slidesGrid.map((P) => P + D);
  }
  if (y !== h && n.emit("slidesLengthChange"), b.length !== f && (n.params.watchOverflow && n.checkOverflow(), n.emit("snapGridLengthChange")), v.length !== p && n.emit("slidesGridLengthChange"), t.watchSlidesProgress && n.updateSlidesOffset(), n.emit("slidesUpdated"), !d && !t.cssMode && (t.effect === "slide" || t.effect === "fade")) {
    const T = `${t.containerModifierClass}backface-hidden`, D = n.el.classList.contains(T);
    y <= t.maxBackfaceHiddenSlides ? D || n.el.classList.add(T) : D && n.el.classList.remove(T);
  }
}
function jI(n) {
  const e = this, t = [], s = e.virtual && e.params.virtual.enabled;
  let r = 0, a;
  typeof n == "number" ? e.setTransition(n) : n === !0 && e.setTransition(e.params.speed);
  const c = (l) => s ? e.slides[e.getSlideIndexByData(l)] : e.slides[l];
  if (e.params.slidesPerView !== "auto" && e.params.slidesPerView > 1)
    if (e.params.centeredSlides)
      (e.visibleSlides || []).forEach((l) => {
        t.push(l);
      });
    else
      for (a = 0; a < Math.ceil(e.params.slidesPerView); a += 1) {
        const l = e.activeIndex + a;
        if (l > e.slides.length && !s)
          break;
        t.push(c(l));
      }
  else
    t.push(c(e.activeIndex));
  for (a = 0; a < t.length; a += 1)
    if (typeof t[a] < "u") {
      const l = t[a].offsetHeight;
      r = l > r ? l : r;
    }
  (r || r === 0) && (e.wrapperEl.style.height = `${r}px`);
}
function LI() {
  const n = this, e = n.slides, t = n.isElement ? n.isHorizontal() ? n.wrapperEl.offsetLeft : n.wrapperEl.offsetTop : 0;
  for (let s = 0; s < e.length; s += 1)
    e[s].swiperSlideOffset = (n.isHorizontal() ? e[s].offsetLeft : e[s].offsetTop) - t - n.cssOverflowAdjustment();
}
const zl = (n, e, t) => {
  e && !n.classList.contains(t) ? n.classList.add(t) : !e && n.classList.contains(t) && n.classList.remove(t);
};
function DI(n) {
  n === void 0 && (n = this && this.translate || 0);
  const e = this, t = e.params, {
    slides: s,
    rtlTranslate: r,
    snapGrid: a
  } = e;
  if (s.length === 0)
    return;
  typeof s[0].swiperSlideOffset > "u" && e.updateSlidesOffset();
  let c = -n;
  r && (c = n), e.visibleSlidesIndexes = [], e.visibleSlides = [];
  let l = t.spaceBetween;
  typeof l == "string" && l.indexOf("%") >= 0 ? l = parseFloat(l.replace("%", "")) / 100 * e.size : typeof l == "string" && (l = parseFloat(l));
  for (let d = 0; d < s.length; d += 1) {
    const h = s[d];
    let m = h.swiperSlideOffset;
    t.cssMode && t.centeredSlides && (m -= s[0].swiperSlideOffset);
    const y = (c + (t.centeredSlides ? e.minTranslate() : 0) - m) / (h.swiperSlideSize + l), b = (c - a[0] + (t.centeredSlides ? e.minTranslate() : 0) - m) / (h.swiperSlideSize + l), v = -(c - m), w = v + e.slidesSizesGrid[d], o = v >= 0 && v <= e.size - e.slidesSizesGrid[d], u = v >= 0 && v < e.size - 1 || w > 1 && w <= e.size || v <= 0 && w >= e.size;
    u && (e.visibleSlides.push(h), e.visibleSlidesIndexes.push(d)), zl(h, u, t.slideVisibleClass), zl(h, o, t.slideFullyVisibleClass), h.progress = r ? -y : y, h.originalProgress = r ? -b : b;
  }
}
function NI(n) {
  const e = this;
  if (typeof n > "u") {
    const m = e.rtlTranslate ? -1 : 1;
    n = e && e.translate && e.translate * m || 0;
  }
  const t = e.params, s = e.maxTranslate() - e.minTranslate();
  let {
    progress: r,
    isBeginning: a,
    isEnd: c,
    progressLoop: l
  } = e;
  const d = a, h = c;
  if (s === 0)
    r = 0, a = !0, c = !0;
  else {
    r = (n - e.minTranslate()) / s;
    const m = Math.abs(n - e.minTranslate()) < 1, y = Math.abs(n - e.maxTranslate()) < 1;
    a = m || r <= 0, c = y || r >= 1, m && (r = 0), y && (r = 1);
  }
  if (t.loop) {
    const m = e.getSlideIndexByData(0), y = e.getSlideIndexByData(e.slides.length - 1), b = e.slidesGrid[m], v = e.slidesGrid[y], w = e.slidesGrid[e.slidesGrid.length - 1], o = Math.abs(n);
    o >= b ? l = (o - b) / w : l = (o + w - v) / w, l > 1 && (l -= 1);
  }
  Object.assign(e, {
    progress: r,
    progressLoop: l,
    isBeginning: a,
    isEnd: c
  }), (t.watchSlidesProgress || t.centeredSlides && t.autoHeight) && e.updateSlidesProgress(n), a && !d && e.emit("reachBeginning toEdge"), c && !h && e.emit("reachEnd toEdge"), (d && !a || h && !c) && e.emit("fromEdge"), e.emit("progress", r);
}
const so = (n, e, t) => {
  e && !n.classList.contains(t) ? n.classList.add(t) : !e && n.classList.contains(t) && n.classList.remove(t);
};
function FI() {
  const n = this, {
    slides: e,
    params: t,
    slidesEl: s,
    activeIndex: r
  } = n, a = n.virtual && t.virtual.enabled, c = n.grid && t.grid && t.grid.rows > 1, l = (y) => ti(s, `.${t.slideClass}${y}, swiper-slide${y}`)[0];
  let d, h, m;
  if (a)
    if (t.loop) {
      let y = r - n.virtual.slidesBefore;
      y < 0 && (y = n.virtual.slides.length + y), y >= n.virtual.slides.length && (y -= n.virtual.slides.length), d = l(`[data-swiper-slide-index="${y}"]`);
    } else
      d = l(`[data-swiper-slide-index="${r}"]`);
  else
    c ? (d = e.filter((y) => y.column === r)[0], m = e.filter((y) => y.column === r + 1)[0], h = e.filter((y) => y.column === r - 1)[0]) : d = e[r];
  d && (c || (m = EI(d, `.${t.slideClass}, swiper-slide`)[0], t.loop && !m && (m = e[0]), h = CI(d, `.${t.slideClass}, swiper-slide`)[0], t.loop && !h === 0 && (h = e[e.length - 1]))), e.forEach((y) => {
    so(y, y === d, t.slideActiveClass), so(y, y === m, t.slideNextClass), so(y, y === h, t.slidePrevClass);
  }), n.emitSlidesClasses();
}
const tr = (n, e) => {
  if (!n || n.destroyed || !n.params)
    return;
  const t = () => n.isElement ? "swiper-slide" : `.${n.params.slideClass}`, s = e.closest(t());
  if (s) {
    let r = s.querySelector(`.${n.params.lazyPreloaderClass}`);
    !r && n.isElement && (s.shadowRoot ? r = s.shadowRoot.querySelector(`.${n.params.lazyPreloaderClass}`) : requestAnimationFrame(() => {
      s.shadowRoot && (r = s.shadowRoot.querySelector(`.${n.params.lazyPreloaderClass}`), r && r.remove());
    })), r && r.remove();
  }
}, ro = (n, e) => {
  if (!n.slides[e])
    return;
  const t = n.slides[e].querySelector('[loading="lazy"]');
  t && t.removeAttribute("loading");
}, Bo = (n) => {
  if (!n || n.destroyed || !n.params)
    return;
  let e = n.params.lazyPreloadPrevNext;
  const t = n.slides.length;
  if (!t || !e || e < 0)
    return;
  e = Math.min(e, t);
  const s = n.params.slidesPerView === "auto" ? n.slidesPerViewDynamic() : Math.ceil(n.params.slidesPerView), r = n.activeIndex;
  if (n.params.grid && n.params.grid.rows > 1) {
    const c = r, l = [c - e];
    l.push(...Array.from({
      length: e
    }).map((d, h) => c + s + h)), n.slides.forEach((d, h) => {
      l.includes(d.column) && ro(n, h);
    });
    return;
  }
  const a = r + s - 1;
  if (n.params.rewind || n.params.loop)
    for (let c = r - e; c <= a + e; c += 1) {
      const l = (c % t + t) % t;
      (l < r || l > a) && ro(n, l);
    }
  else
    for (let c = Math.max(r - e, 0); c <= Math.min(a + e, t - 1); c += 1)
      c !== r && (c > a || c < r) && ro(n, c);
};
function BI(n) {
  const {
    slidesGrid: e,
    params: t
  } = n, s = n.rtlTranslate ? n.translate : -n.translate;
  let r;
  for (let a = 0; a < e.length; a += 1)
    typeof e[a + 1] < "u" ? s >= e[a] && s < e[a + 1] - (e[a + 1] - e[a]) / 2 ? r = a : s >= e[a] && s < e[a + 1] && (r = a + 1) : s >= e[a] && (r = a);
  return t.normalizeSlideIndex && (r < 0 || typeof r > "u") && (r = 0), r;
}
function qI(n) {
  const e = this, t = e.rtlTranslate ? e.translate : -e.translate, {
    snapGrid: s,
    params: r,
    activeIndex: a,
    realIndex: c,
    snapIndex: l
  } = e;
  let d = n, h;
  const m = (v) => {
    let w = v - e.virtual.slidesBefore;
    return w < 0 && (w = e.virtual.slides.length + w), w >= e.virtual.slides.length && (w -= e.virtual.slides.length), w;
  };
  if (typeof d > "u" && (d = BI(e)), s.indexOf(t) >= 0)
    h = s.indexOf(t);
  else {
    const v = Math.min(r.slidesPerGroupSkip, d);
    h = v + Math.floor((d - v) / r.slidesPerGroup);
  }
  if (h >= s.length && (h = s.length - 1), d === a && !e.params.loop) {
    h !== l && (e.snapIndex = h, e.emit("snapIndexChange"));
    return;
  }
  if (d === a && e.params.loop && e.virtual && e.params.virtual.enabled) {
    e.realIndex = m(d);
    return;
  }
  const y = e.grid && r.grid && r.grid.rows > 1;
  let b;
  if (e.virtual && r.virtual.enabled && r.loop)
    b = m(d);
  else if (y) {
    const v = e.slides.filter((o) => o.column === d)[0];
    let w = parseInt(v.getAttribute("data-swiper-slide-index"), 10);
    Number.isNaN(w) && (w = Math.max(e.slides.indexOf(v), 0)), b = Math.floor(w / r.grid.rows);
  } else if (e.slides[d]) {
    const v = e.slides[d].getAttribute("data-swiper-slide-index");
    v ? b = parseInt(v, 10) : b = d;
  } else
    b = d;
  Object.assign(e, {
    previousSnapIndex: l,
    snapIndex: h,
    previousRealIndex: c,
    realIndex: b,
    previousIndex: a,
    activeIndex: d
  }), e.initialized && Bo(e), e.emit("activeIndexChange"), e.emit("snapIndexChange"), (e.initialized || e.params.runCallbacksOnInit) && (c !== b && e.emit("realIndexChange"), e.emit("slideChange"));
}
function HI(n, e) {
  const t = this, s = t.params;
  let r = n.closest(`.${s.slideClass}, swiper-slide`);
  !r && t.isElement && e && e.length > 1 && e.includes(n) && [...e.slice(e.indexOf(n) + 1, e.length)].forEach((l) => {
    !r && l.matches && l.matches(`.${s.slideClass}, swiper-slide`) && (r = l);
  });
  let a = !1, c;
  if (r) {
    for (let l = 0; l < t.slides.length; l += 1)
      if (t.slides[l] === r) {
        a = !0, c = l;
        break;
      }
  }
  if (r && a)
    t.clickedSlide = r, t.virtual && t.params.virtual.enabled ? t.clickedIndex = parseInt(r.getAttribute("data-swiper-slide-index"), 10) : t.clickedIndex = c;
  else {
    t.clickedSlide = void 0, t.clickedIndex = void 0;
    return;
  }
  s.slideToClickedSlide && t.clickedIndex !== void 0 && t.clickedIndex !== t.activeIndex && t.slideToClickedSlide();
}
var VI = {
  updateSize: PI,
  updateSlides: MI,
  updateAutoHeight: jI,
  updateSlidesOffset: LI,
  updateSlidesProgress: DI,
  updateProgress: NI,
  updateSlidesClasses: FI,
  updateActiveIndex: qI,
  updateClickedSlide: HI
};
function GI(n) {
  n === void 0 && (n = this.isHorizontal() ? "x" : "y");
  const e = this, {
    params: t,
    rtlTranslate: s,
    translate: r,
    wrapperEl: a
  } = e;
  if (t.virtualTranslate)
    return s ? -r : r;
  if (t.cssMode)
    return r;
  let c = xI(a, n);
  return c += e.cssOverflowAdjustment(), s && (c = -c), c || 0;
}
function WI(n, e) {
  const t = this, {
    rtlTranslate: s,
    params: r,
    wrapperEl: a,
    progress: c
  } = t;
  let l = 0, d = 0;
  const h = 0;
  t.isHorizontal() ? l = s ? -n : n : d = n, r.roundLengths && (l = Math.floor(l), d = Math.floor(d)), t.previousTranslate = t.translate, t.translate = t.isHorizontal() ? l : d, r.cssMode ? a[t.isHorizontal() ? "scrollLeft" : "scrollTop"] = t.isHorizontal() ? -l : -d : r.virtualTranslate || (t.isHorizontal() ? l -= t.cssOverflowAdjustment() : d -= t.cssOverflowAdjustment(), a.style.transform = `translate3d(${l}px, ${d}px, ${h}px)`);
  let m;
  const y = t.maxTranslate() - t.minTranslate();
  y === 0 ? m = 0 : m = (n - t.minTranslate()) / y, m !== c && t.updateProgress(n), t.emit("setTranslate", t.translate, e);
}
function KI() {
  return -this.snapGrid[0];
}
function YI() {
  return -this.snapGrid[this.snapGrid.length - 1];
}
function JI(n, e, t, s, r) {
  n === void 0 && (n = 0), e === void 0 && (e = this.params.speed), t === void 0 && (t = !0), s === void 0 && (s = !0);
  const a = this, {
    params: c,
    wrapperEl: l
  } = a;
  if (a.animating && c.preventInteractionOnTransition)
    return !1;
  const d = a.minTranslate(), h = a.maxTranslate();
  let m;
  if (s && n > d ? m = d : s && n < h ? m = h : m = n, a.updateProgress(m), c.cssMode) {
    const y = a.isHorizontal();
    if (e === 0)
      l[y ? "scrollLeft" : "scrollTop"] = -m;
    else {
      if (!a.support.smoothScroll)
        return Bu({
          swiper: a,
          targetPosition: -m,
          side: y ? "left" : "top"
        }), !0;
      l.scrollTo({
        [y ? "left" : "top"]: -m,
        behavior: "smooth"
      });
    }
    return !0;
  }
  return e === 0 ? (a.setTransition(0), a.setTranslate(m), t && (a.emit("beforeTransitionStart", e, r), a.emit("transitionEnd"))) : (a.setTransition(e), a.setTranslate(m), t && (a.emit("beforeTransitionStart", e, r), a.emit("transitionStart")), a.animating || (a.animating = !0, a.onTranslateToWrapperTransitionEnd || (a.onTranslateToWrapperTransitionEnd = function(b) {
    !a || a.destroyed || b.target === this && (a.wrapperEl.removeEventListener("transitionend", a.onTranslateToWrapperTransitionEnd), a.onTranslateToWrapperTransitionEnd = null, delete a.onTranslateToWrapperTransitionEnd, a.animating = !1, t && a.emit("transitionEnd"));
  }), a.wrapperEl.addEventListener("transitionend", a.onTranslateToWrapperTransitionEnd))), !0;
}
var ZI = {
  getTranslate: GI,
  setTranslate: WI,
  minTranslate: KI,
  maxTranslate: YI,
  translateTo: JI
};
function QI(n, e) {
  const t = this;
  t.params.cssMode || (t.wrapperEl.style.transitionDuration = `${n}ms`, t.wrapperEl.style.transitionDelay = n === 0 ? "0ms" : ""), t.emit("setTransition", n, e);
}
function Gu(n) {
  let {
    swiper: e,
    runCallbacks: t,
    direction: s,
    step: r
  } = n;
  const {
    activeIndex: a,
    previousIndex: c
  } = e;
  let l = s;
  if (l || (a > c ? l = "next" : a < c ? l = "prev" : l = "reset"), e.emit(`transition${r}`), t && a !== c) {
    if (l === "reset") {
      e.emit(`slideResetTransition${r}`);
      return;
    }
    e.emit(`slideChangeTransition${r}`), l === "next" ? e.emit(`slideNextTransition${r}`) : e.emit(`slidePrevTransition${r}`);
  }
}
function XI(n, e) {
  n === void 0 && (n = !0);
  const t = this, {
    params: s
  } = t;
  s.cssMode || (s.autoHeight && t.updateAutoHeight(), Gu({
    swiper: t,
    runCallbacks: n,
    direction: e,
    step: "Start"
  }));
}
function _I(n, e) {
  n === void 0 && (n = !0);
  const t = this, {
    params: s
  } = t;
  t.animating = !1, !s.cssMode && (t.setTransition(0), Gu({
    swiper: t,
    runCallbacks: n,
    direction: e,
    step: "End"
  }));
}
var $I = {
  setTransition: QI,
  transitionStart: XI,
  transitionEnd: _I
};
function eU(n, e, t, s, r) {
  n === void 0 && (n = 0), t === void 0 && (t = !0), typeof n == "string" && (n = parseInt(n, 10));
  const a = this;
  let c = n;
  c < 0 && (c = 0);
  const {
    params: l,
    snapGrid: d,
    slidesGrid: h,
    previousIndex: m,
    activeIndex: y,
    rtlTranslate: b,
    wrapperEl: v,
    enabled: w
  } = a;
  if (!w && !s && !r || a.destroyed || a.animating && l.preventInteractionOnTransition)
    return !1;
  typeof e > "u" && (e = a.params.speed);
  const o = Math.min(a.params.slidesPerGroupSkip, c);
  let u = o + Math.floor((c - o) / a.params.slidesPerGroup);
  u >= d.length && (u = d.length - 1);
  const f = -d[u];
  if (l.normalizeSlideIndex)
    for (let x = 0; x < h.length; x += 1) {
      const E = -Math.floor(f * 100), k = Math.floor(h[x] * 100), R = Math.floor(h[x + 1] * 100);
      typeof h[x + 1] < "u" ? E >= k && E < R - (R - k) / 2 ? c = x : E >= k && E < R && (c = x + 1) : E >= k && (c = x);
    }
  if (a.initialized && c !== y && (!a.allowSlideNext && (b ? f > a.translate && f > a.minTranslate() : f < a.translate && f < a.minTranslate()) || !a.allowSlidePrev && f > a.translate && f > a.maxTranslate() && (y || 0) !== c))
    return !1;
  c !== (m || 0) && t && a.emit("beforeSlideChangeStart"), a.updateProgress(f);
  let p;
  c > y ? p = "next" : c < y ? p = "prev" : p = "reset";
  const g = a.virtual && a.params.virtual.enabled;
  if (!(g && r) && (b && -f === a.translate || !b && f === a.translate))
    return a.updateActiveIndex(c), l.autoHeight && a.updateAutoHeight(), a.updateSlidesClasses(), l.effect !== "slide" && a.setTranslate(f), p !== "reset" && (a.transitionStart(t, p), a.transitionEnd(t, p)), !1;
  if (l.cssMode) {
    const x = a.isHorizontal(), E = b ? f : -f;
    if (e === 0)
      g && (a.wrapperEl.style.scrollSnapType = "none", a._immediateVirtual = !0), g && !a._cssModeVirtualInitialSet && a.params.initialSlide > 0 ? (a._cssModeVirtualInitialSet = !0, requestAnimationFrame(() => {
        v[x ? "scrollLeft" : "scrollTop"] = E;
      })) : v[x ? "scrollLeft" : "scrollTop"] = E, g && requestAnimationFrame(() => {
        a.wrapperEl.style.scrollSnapType = "", a._immediateVirtual = !1;
      });
    else {
      if (!a.support.smoothScroll)
        return Bu({
          swiper: a,
          targetPosition: E,
          side: x ? "left" : "top"
        }), !0;
      v.scrollTo({
        [x ? "left" : "top"]: E,
        behavior: "smooth"
      });
    }
    return !0;
  }
  return a.setTransition(e), a.setTranslate(f), a.updateActiveIndex(c), a.updateSlidesClasses(), a.emit("beforeTransitionStart", e, s), a.transitionStart(t, p), e === 0 ? a.transitionEnd(t, p) : a.animating || (a.animating = !0, a.onSlideToWrapperTransitionEnd || (a.onSlideToWrapperTransitionEnd = function(E) {
    !a || a.destroyed || E.target === this && (a.wrapperEl.removeEventListener("transitionend", a.onSlideToWrapperTransitionEnd), a.onSlideToWrapperTransitionEnd = null, delete a.onSlideToWrapperTransitionEnd, a.transitionEnd(t, p));
  }), a.wrapperEl.addEventListener("transitionend", a.onSlideToWrapperTransitionEnd)), !0;
}
function tU(n, e, t, s) {
  n === void 0 && (n = 0), t === void 0 && (t = !0), typeof n == "string" && (n = parseInt(n, 10));
  const r = this;
  if (r.destroyed)
    return;
  typeof e > "u" && (e = r.params.speed);
  const a = r.grid && r.params.grid && r.params.grid.rows > 1;
  let c = n;
  if (r.params.loop)
    if (r.virtual && r.params.virtual.enabled)
      c = c + r.virtual.slidesBefore;
    else {
      let l;
      if (a) {
        const b = c * r.params.grid.rows;
        l = r.slides.filter((v) => v.getAttribute("data-swiper-slide-index") * 1 === b)[0].column;
      } else
        l = r.getSlideIndexByData(c);
      const d = a ? Math.ceil(r.slides.length / r.params.grid.rows) : r.slides.length, {
        centeredSlides: h
      } = r.params;
      let m = r.params.slidesPerView;
      m === "auto" ? m = r.slidesPerViewDynamic() : (m = Math.ceil(parseFloat(r.params.slidesPerView, 10)), h && m % 2 === 0 && (m = m + 1));
      let y = d - l < m;
      if (h && (y = y || l < Math.ceil(m / 2)), s && h && r.params.slidesPerView !== "auto" && !a && (y = !1), y) {
        const b = h ? l < r.activeIndex ? "prev" : "next" : l - r.activeIndex - 1 < r.params.slidesPerView ? "next" : "prev";
        r.loopFix({
          direction: b,
          slideTo: !0,
          activeSlideIndex: b === "next" ? l + 1 : l - d + 1,
          slideRealIndex: b === "next" ? r.realIndex : void 0
        });
      }
      if (a) {
        const b = c * r.params.grid.rows;
        c = r.slides.filter((v) => v.getAttribute("data-swiper-slide-index") * 1 === b)[0].column;
      } else
        c = r.getSlideIndexByData(c);
    }
  return requestAnimationFrame(() => {
    r.slideTo(c, e, t, s);
  }), r;
}
function iU(n, e, t) {
  e === void 0 && (e = !0);
  const s = this, {
    enabled: r,
    params: a,
    animating: c
  } = s;
  if (!r || s.destroyed)
    return s;
  typeof n > "u" && (n = s.params.speed);
  let l = a.slidesPerGroup;
  a.slidesPerView === "auto" && a.slidesPerGroup === 1 && a.slidesPerGroupAuto && (l = Math.max(s.slidesPerViewDynamic("current", !0), 1));
  const d = s.activeIndex < a.slidesPerGroupSkip ? 1 : l, h = s.virtual && a.virtual.enabled;
  if (a.loop) {
    if (c && !h && a.loopPreventsSliding)
      return !1;
    if (s.loopFix({
      direction: "next"
    }), s._clientLeft = s.wrapperEl.clientLeft, s.activeIndex === s.slides.length - 1 && a.cssMode)
      return requestAnimationFrame(() => {
        s.slideTo(s.activeIndex + d, n, e, t);
      }), !0;
  }
  return a.rewind && s.isEnd ? s.slideTo(0, n, e, t) : s.slideTo(s.activeIndex + d, n, e, t);
}
function nU(n, e, t) {
  e === void 0 && (e = !0);
  const s = this, {
    params: r,
    snapGrid: a,
    slidesGrid: c,
    rtlTranslate: l,
    enabled: d,
    animating: h
  } = s;
  if (!d || s.destroyed)
    return s;
  typeof n > "u" && (n = s.params.speed);
  const m = s.virtual && r.virtual.enabled;
  if (r.loop) {
    if (h && !m && r.loopPreventsSliding)
      return !1;
    s.loopFix({
      direction: "prev"
    }), s._clientLeft = s.wrapperEl.clientLeft;
  }
  const y = l ? s.translate : -s.translate;
  function b(f) {
    return f < 0 ? -Math.floor(Math.abs(f)) : Math.floor(f);
  }
  const v = b(y), w = a.map((f) => b(f));
  let o = a[w.indexOf(v) - 1];
  if (typeof o > "u" && r.cssMode) {
    let f;
    a.forEach((p, g) => {
      v >= p && (f = g);
    }), typeof f < "u" && (o = a[f > 0 ? f - 1 : f]);
  }
  let u = 0;
  if (typeof o < "u" && (u = c.indexOf(o), u < 0 && (u = s.activeIndex - 1), r.slidesPerView === "auto" && r.slidesPerGroup === 1 && r.slidesPerGroupAuto && (u = u - s.slidesPerViewDynamic("previous", !0) + 1, u = Math.max(u, 0))), r.rewind && s.isBeginning) {
    const f = s.params.virtual && s.params.virtual.enabled && s.virtual ? s.virtual.slides.length - 1 : s.slides.length - 1;
    return s.slideTo(f, n, e, t);
  } else if (r.loop && s.activeIndex === 0 && r.cssMode)
    return requestAnimationFrame(() => {
      s.slideTo(u, n, e, t);
    }), !0;
  return s.slideTo(u, n, e, t);
}
function sU(n, e, t) {
  e === void 0 && (e = !0);
  const s = this;
  if (!s.destroyed)
    return typeof n > "u" && (n = s.params.speed), s.slideTo(s.activeIndex, n, e, t);
}
function rU(n, e, t, s) {
  e === void 0 && (e = !0), s === void 0 && (s = 0.5);
  const r = this;
  if (r.destroyed)
    return;
  typeof n > "u" && (n = r.params.speed);
  let a = r.activeIndex;
  const c = Math.min(r.params.slidesPerGroupSkip, a), l = c + Math.floor((a - c) / r.params.slidesPerGroup), d = r.rtlTranslate ? r.translate : -r.translate;
  if (d >= r.snapGrid[l]) {
    const h = r.snapGrid[l], m = r.snapGrid[l + 1];
    d - h > (m - h) * s && (a += r.params.slidesPerGroup);
  } else {
    const h = r.snapGrid[l - 1], m = r.snapGrid[l];
    d - h <= (m - h) * s && (a -= r.params.slidesPerGroup);
  }
  return a = Math.max(a, 0), a = Math.min(a, r.slidesGrid.length - 1), r.slideTo(a, n, e, t);
}
function oU() {
  const n = this;
  if (n.destroyed)
    return;
  const {
    params: e,
    slidesEl: t
  } = n, s = e.slidesPerView === "auto" ? n.slidesPerViewDynamic() : e.slidesPerView;
  let r = n.clickedIndex, a;
  const c = n.isElement ? "swiper-slide" : `.${e.slideClass}`;
  if (e.loop) {
    if (n.animating)
      return;
    a = parseInt(n.clickedSlide.getAttribute("data-swiper-slide-index"), 10), e.centeredSlides ? r < n.loopedSlides - s / 2 || r > n.slides.length - n.loopedSlides + s / 2 ? (n.loopFix(), r = n.getSlideIndex(ti(t, `${c}[data-swiper-slide-index="${a}"]`)[0]), gr(() => {
      n.slideTo(r);
    })) : n.slideTo(r) : r > n.slides.length - s ? (n.loopFix(), r = n.getSlideIndex(ti(t, `${c}[data-swiper-slide-index="${a}"]`)[0]), gr(() => {
      n.slideTo(r);
    })) : n.slideTo(r);
  } else
    n.slideTo(r);
}
var aU = {
  slideTo: eU,
  slideToLoop: tU,
  slideNext: iU,
  slidePrev: nU,
  slideReset: sU,
  slideToClosest: rU,
  slideToClickedSlide: oU
};
function lU(n) {
  const e = this, {
    params: t,
    slidesEl: s
  } = e;
  if (!t.loop || e.virtual && e.params.virtual.enabled)
    return;
  const r = () => {
    ti(s, `.${t.slideClass}, swiper-slide`).forEach((y, b) => {
      y.setAttribute("data-swiper-slide-index", b);
    });
  }, a = e.grid && t.grid && t.grid.rows > 1, c = t.slidesPerGroup * (a ? t.grid.rows : 1), l = e.slides.length % c !== 0, d = a && e.slides.length % t.grid.rows !== 0, h = (m) => {
    for (let y = 0; y < m; y += 1) {
      const b = e.isElement ? Li("swiper-slide", [t.slideBlankClass]) : Li("div", [t.slideClass, t.slideBlankClass]);
      e.slidesEl.append(b);
    }
  };
  if (l) {
    if (t.loopAddBlankSlides) {
      const m = c - e.slides.length % c;
      h(m), e.recalcSlides(), e.updateSlides();
    } else
      vr("Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
    r();
  } else if (d) {
    if (t.loopAddBlankSlides) {
      const m = t.grid.rows - e.slides.length % t.grid.rows;
      h(m), e.recalcSlides(), e.updateSlides();
    } else
      vr("Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
    r();
  } else
    r();
  e.loopFix({
    slideRealIndex: n,
    direction: t.centeredSlides ? void 0 : "next"
  });
}
function cU(n) {
  let {
    slideRealIndex: e,
    slideTo: t = !0,
    direction: s,
    setTranslate: r,
    activeSlideIndex: a,
    byController: c,
    byMousewheel: l
  } = n === void 0 ? {} : n;
  const d = this;
  if (!d.params.loop)
    return;
  d.emit("beforeLoopFix");
  const {
    slides: h,
    allowSlidePrev: m,
    allowSlideNext: y,
    slidesEl: b,
    params: v
  } = d, {
    centeredSlides: w
  } = v;
  if (d.allowSlidePrev = !0, d.allowSlideNext = !0, d.virtual && v.virtual.enabled) {
    t && (!v.centeredSlides && d.snapIndex === 0 ? d.slideTo(d.virtual.slides.length, 0, !1, !0) : v.centeredSlides && d.snapIndex < v.slidesPerView ? d.slideTo(d.virtual.slides.length + d.snapIndex, 0, !1, !0) : d.snapIndex === d.snapGrid.length - 1 && d.slideTo(d.virtual.slidesBefore, 0, !1, !0)), d.allowSlidePrev = m, d.allowSlideNext = y, d.emit("loopFix");
    return;
  }
  let o = v.slidesPerView;
  o === "auto" ? o = d.slidesPerViewDynamic() : (o = Math.ceil(parseFloat(v.slidesPerView, 10)), w && o % 2 === 0 && (o = o + 1));
  const u = v.slidesPerGroupAuto ? o : v.slidesPerGroup;
  let f = u;
  f % u !== 0 && (f += u - f % u), f += v.loopAdditionalSlides, d.loopedSlides = f;
  const p = d.grid && v.grid && v.grid.rows > 1;
  h.length < o + f ? vr("Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled and not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters") : p && v.grid.fill === "row" && vr("Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`");
  const g = [], S = [];
  let x = d.activeIndex;
  typeof a > "u" ? a = d.getSlideIndex(h.filter((N) => N.classList.contains(v.slideActiveClass))[0]) : x = a;
  const E = s === "next" || !s, k = s === "prev" || !s;
  let R = 0, O = 0;
  const T = p ? Math.ceil(h.length / v.grid.rows) : h.length, P = (p ? h[a].column : a) + (w && typeof r > "u" ? -o / 2 + 0.5 : 0);
  if (P < f) {
    R = Math.max(f - P, u);
    for (let N = 0; N < f - P; N += 1) {
      const I = N - Math.floor(N / T) * T;
      if (p) {
        const C = T - I - 1;
        for (let U = h.length - 1; U >= 0; U -= 1)
          h[U].column === C && g.push(U);
      } else
        g.push(T - I - 1);
    }
  } else if (P + o > T - f) {
    O = Math.max(P - (T - f * 2), u);
    for (let N = 0; N < O; N += 1) {
      const I = N - Math.floor(N / T) * T;
      p ? h.forEach((C, U) => {
        C.column === I && S.push(U);
      }) : S.push(I);
    }
  }
  if (d.__preventObserver__ = !0, requestAnimationFrame(() => {
    d.__preventObserver__ = !1;
  }), k && g.forEach((N) => {
    h[N].swiperLoopMoveDOM = !0, b.prepend(h[N]), h[N].swiperLoopMoveDOM = !1;
  }), E && S.forEach((N) => {
    h[N].swiperLoopMoveDOM = !0, b.append(h[N]), h[N].swiperLoopMoveDOM = !1;
  }), d.recalcSlides(), v.slidesPerView === "auto" ? d.updateSlides() : p && (g.length > 0 && k || S.length > 0 && E) && d.slides.forEach((N, I) => {
    d.grid.updateSlide(I, N, d.slides);
  }), v.watchSlidesProgress && d.updateSlidesOffset(), t) {
    if (g.length > 0 && k) {
      if (typeof e > "u") {
        const N = d.slidesGrid[x], C = d.slidesGrid[x + R] - N;
        l ? d.setTranslate(d.translate - C) : (d.slideTo(x + Math.ceil(R), 0, !1, !0), r && (d.touchEventsData.startTranslate = d.touchEventsData.startTranslate - C, d.touchEventsData.currentTranslate = d.touchEventsData.currentTranslate - C));
      } else if (r) {
        const N = p ? g.length / v.grid.rows : g.length;
        d.slideTo(d.activeIndex + N, 0, !1, !0), d.touchEventsData.currentTranslate = d.translate;
      }
    } else if (S.length > 0 && E)
      if (typeof e > "u") {
        const N = d.slidesGrid[x], C = d.slidesGrid[x - O] - N;
        l ? d.setTranslate(d.translate - C) : (d.slideTo(x - O, 0, !1, !0), r && (d.touchEventsData.startTranslate = d.touchEventsData.startTranslate - C, d.touchEventsData.currentTranslate = d.touchEventsData.currentTranslate - C));
      } else {
        const N = p ? S.length / v.grid.rows : S.length;
        d.slideTo(d.activeIndex - N, 0, !1, !0);
      }
  }
  if (d.allowSlidePrev = m, d.allowSlideNext = y, d.controller && d.controller.control && !c) {
    const N = {
      slideRealIndex: e,
      direction: s,
      setTranslate: r,
      activeSlideIndex: a,
      byController: !0
    };
    Array.isArray(d.controller.control) ? d.controller.control.forEach((I) => {
      !I.destroyed && I.params.loop && I.loopFix({
        ...N,
        slideTo: I.params.slidesPerView === v.slidesPerView ? t : !1
      });
    }) : d.controller.control instanceof d.constructor && d.controller.control.params.loop && d.controller.control.loopFix({
      ...N,
      slideTo: d.controller.control.params.slidesPerView === v.slidesPerView ? t : !1
    });
  }
  d.emit("loopFix");
}
function uU() {
  const n = this, {
    params: e,
    slidesEl: t
  } = n;
  if (!e.loop || n.virtual && n.params.virtual.enabled)
    return;
  n.recalcSlides();
  const s = [];
  n.slides.forEach((r) => {
    const a = typeof r.swiperSlideIndex > "u" ? r.getAttribute("data-swiper-slide-index") * 1 : r.swiperSlideIndex;
    s[a] = r;
  }), n.slides.forEach((r) => {
    r.removeAttribute("data-swiper-slide-index");
  }), s.forEach((r) => {
    t.append(r);
  }), n.recalcSlides(), n.slideTo(n.realIndex, 0);
}
var dU = {
  loopCreate: lU,
  loopFix: cU,
  loopDestroy: uU
};
function fU(n) {
  const e = this;
  if (!e.params.simulateTouch || e.params.watchOverflow && e.isLocked || e.params.cssMode)
    return;
  const t = e.params.touchEventsTarget === "container" ? e.el : e.wrapperEl;
  e.isElement && (e.__preventObserver__ = !0), t.style.cursor = "move", t.style.cursor = n ? "grabbing" : "grab", e.isElement && requestAnimationFrame(() => {
    e.__preventObserver__ = !1;
  });
}
function hU() {
  const n = this;
  n.params.watchOverflow && n.isLocked || n.params.cssMode || (n.isElement && (n.__preventObserver__ = !0), n[n.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "", n.isElement && requestAnimationFrame(() => {
    n.__preventObserver__ = !1;
  }));
}
var pU = {
  setGrabCursor: fU,
  unsetGrabCursor: hU
};
function mU(n, e) {
  e === void 0 && (e = this);
  function t(s) {
    if (!s || s === si() || s === Mt())
      return null;
    s.assignedSlot && (s = s.assignedSlot);
    const r = s.closest(n);
    return !r && !s.getRootNode ? null : r || t(s.getRootNode().host);
  }
  return t(e);
}
function Rl(n, e, t) {
  const s = Mt(), {
    params: r
  } = n, a = r.edgeSwipeDetection, c = r.edgeSwipeThreshold;
  return a && (t <= c || t >= s.innerWidth - c) ? a === "prevent" ? (e.preventDefault(), !0) : !1 : !0;
}
function gU(n) {
  const e = this, t = si();
  let s = n;
  s.originalEvent && (s = s.originalEvent);
  const r = e.touchEventsData;
  if (s.type === "pointerdown") {
    if (r.pointerId !== null && r.pointerId !== s.pointerId)
      return;
    r.pointerId = s.pointerId;
  } else
    s.type === "touchstart" && s.targetTouches.length === 1 && (r.touchId = s.targetTouches[0].identifier);
  if (s.type === "touchstart") {
    Rl(e, s, s.targetTouches[0].pageX);
    return;
  }
  const {
    params: a,
    touches: c,
    enabled: l
  } = e;
  if (!l || !a.simulateTouch && s.pointerType === "mouse" || e.animating && a.preventInteractionOnTransition)
    return;
  !e.animating && a.cssMode && a.loop && e.loopFix();
  let d = s.target;
  if (a.touchEventsTarget === "wrapper" && !wI(d, e.wrapperEl) || "which" in s && s.which === 3 || "button" in s && s.button > 0 || r.isTouched && r.isMoved)
    return;
  const h = !!a.noSwipingClass && a.noSwipingClass !== "", m = s.composedPath ? s.composedPath() : s.path;
  h && s.target && s.target.shadowRoot && m && (d = m[0]);
  const y = a.noSwipingSelector ? a.noSwipingSelector : `.${a.noSwipingClass}`, b = !!(s.target && s.target.shadowRoot);
  if (a.noSwiping && (b ? mU(y, d) : d.closest(y))) {
    e.allowClick = !0;
    return;
  }
  if (a.swipeHandler && !d.closest(a.swipeHandler))
    return;
  c.currentX = s.pageX, c.currentY = s.pageY;
  const v = c.currentX, w = c.currentY;
  if (!Rl(e, s, v))
    return;
  Object.assign(r, {
    isTouched: !0,
    isMoved: !1,
    allowTouchCallbacks: !0,
    isScrolling: void 0,
    startMoving: void 0
  }), c.startX = v, c.startY = w, r.touchStartTime = yr(), e.allowClick = !0, e.updateSize(), e.swipeDirection = void 0, a.threshold > 0 && (r.allowThresholdMove = !1);
  let o = !0;
  d.matches(r.focusableElements) && (o = !1, d.nodeName === "SELECT" && (r.isTouched = !1)), t.activeElement && t.activeElement.matches(r.focusableElements) && t.activeElement !== d && (s.pointerType === "mouse" || s.pointerType !== "mouse" && !d.matches(r.focusableElements)) && t.activeElement.blur();
  const u = o && e.allowTouchMove && a.touchStartPreventDefault;
  (a.touchStartForcePreventDefault || u) && !d.isContentEditable && s.preventDefault(), a.freeMode && a.freeMode.enabled && e.freeMode && e.animating && !a.cssMode && e.freeMode.onTouchStart(), e.emit("touchStart", s);
}
function yU(n) {
  const e = si(), t = this, s = t.touchEventsData, {
    params: r,
    touches: a,
    rtlTranslate: c,
    enabled: l
  } = t;
  if (!l || !r.simulateTouch && n.pointerType === "mouse")
    return;
  let d = n;
  if (d.originalEvent && (d = d.originalEvent), d.type === "pointermove" && (s.touchId !== null || d.pointerId !== s.pointerId))
    return;
  let h;
  if (d.type === "touchmove") {
    if (h = [...d.changedTouches].filter((E) => E.identifier === s.touchId)[0], !h || h.identifier !== s.touchId)
      return;
  } else
    h = d;
  if (!s.isTouched) {
    s.startMoving && s.isScrolling && t.emit("touchMoveOpposite", d);
    return;
  }
  const m = h.pageX, y = h.pageY;
  if (d.preventedByNestedSwiper) {
    a.startX = m, a.startY = y;
    return;
  }
  if (!t.allowTouchMove) {
    d.target.matches(s.focusableElements) || (t.allowClick = !1), s.isTouched && (Object.assign(a, {
      startX: m,
      startY: y,
      currentX: m,
      currentY: y
    }), s.touchStartTime = yr());
    return;
  }
  if (r.touchReleaseOnEdges && !r.loop) {
    if (t.isVertical()) {
      if (y < a.startY && t.translate <= t.maxTranslate() || y > a.startY && t.translate >= t.minTranslate()) {
        s.isTouched = !1, s.isMoved = !1;
        return;
      }
    } else if (m < a.startX && t.translate <= t.maxTranslate() || m > a.startX && t.translate >= t.minTranslate())
      return;
  }
  if (e.activeElement && e.activeElement.matches(s.focusableElements) && e.activeElement !== d.target && d.pointerType !== "mouse" && e.activeElement.blur(), e.activeElement && d.target === e.activeElement && d.target.matches(s.focusableElements)) {
    s.isMoved = !0, t.allowClick = !1;
    return;
  }
  s.allowTouchCallbacks && t.emit("touchMove", d), a.previousX = a.currentX, a.previousY = a.currentY, a.currentX = m, a.currentY = y;
  const b = a.currentX - a.startX, v = a.currentY - a.startY;
  if (t.params.threshold && Math.sqrt(b ** 2 + v ** 2) < t.params.threshold)
    return;
  if (typeof s.isScrolling > "u") {
    let E;
    t.isHorizontal() && a.currentY === a.startY || t.isVertical() && a.currentX === a.startX ? s.isScrolling = !1 : b * b + v * v >= 25 && (E = Math.atan2(Math.abs(v), Math.abs(b)) * 180 / Math.PI, s.isScrolling = t.isHorizontal() ? E > r.touchAngle : 90 - E > r.touchAngle);
  }
  if (s.isScrolling && t.emit("touchMoveOpposite", d), typeof s.startMoving > "u" && (a.currentX !== a.startX || a.currentY !== a.startY) && (s.startMoving = !0), s.isScrolling || d.type === "touchmove" && s.preventTouchMoveFromPointerMove) {
    s.isTouched = !1;
    return;
  }
  if (!s.startMoving)
    return;
  t.allowClick = !1, !r.cssMode && d.cancelable && d.preventDefault(), r.touchMoveStopPropagation && !r.nested && d.stopPropagation();
  let w = t.isHorizontal() ? b : v, o = t.isHorizontal() ? a.currentX - a.previousX : a.currentY - a.previousY;
  r.oneWayMovement && (w = Math.abs(w) * (c ? 1 : -1), o = Math.abs(o) * (c ? 1 : -1)), a.diff = w, w *= r.touchRatio, c && (w = -w, o = -o);
  const u = t.touchesDirection;
  t.swipeDirection = w > 0 ? "prev" : "next", t.touchesDirection = o > 0 ? "prev" : "next";
  const f = t.params.loop && !r.cssMode, p = t.touchesDirection === "next" && t.allowSlideNext || t.touchesDirection === "prev" && t.allowSlidePrev;
  if (!s.isMoved) {
    if (f && p && t.loopFix({
      direction: t.swipeDirection
    }), s.startTranslate = t.getTranslate(), t.setTransition(0), t.animating) {
      const E = new window.CustomEvent("transitionend", {
        bubbles: !0,
        cancelable: !0,
        detail: {
          bySwiperTouchMove: !0
        }
      });
      t.wrapperEl.dispatchEvent(E);
    }
    s.allowMomentumBounce = !1, r.grabCursor && (t.allowSlideNext === !0 || t.allowSlidePrev === !0) && t.setGrabCursor(!0), t.emit("sliderFirstMove", d);
  }
  let g;
  if ((/* @__PURE__ */ new Date()).getTime(), s.isMoved && s.allowThresholdMove && u !== t.touchesDirection && f && p && Math.abs(w) >= 1) {
    Object.assign(a, {
      startX: m,
      startY: y,
      currentX: m,
      currentY: y,
      startTranslate: s.currentTranslate
    }), s.loopSwapReset = !0, s.startTranslate = s.currentTranslate;
    return;
  }
  t.emit("sliderMove", d), s.isMoved = !0, s.currentTranslate = w + s.startTranslate;
  let S = !0, x = r.resistanceRatio;
  if (r.touchReleaseOnEdges && (x = 0), w > 0 ? (f && p && !g && s.allowThresholdMove && s.currentTranslate > (r.centeredSlides ? t.minTranslate() - t.slidesSizesGrid[t.activeIndex + 1] - (r.slidesPerView !== "auto" && t.slides.length - r.slidesPerView >= 2 ? t.slidesSizesGrid[t.activeIndex + 1] + t.params.spaceBetween : 0) - t.params.spaceBetween : t.minTranslate()) && t.loopFix({
    direction: "prev",
    setTranslate: !0,
    activeSlideIndex: 0
  }), s.currentTranslate > t.minTranslate() && (S = !1, r.resistance && (s.currentTranslate = t.minTranslate() - 1 + (-t.minTranslate() + s.startTranslate + w) ** x))) : w < 0 && (f && p && !g && s.allowThresholdMove && s.currentTranslate < (r.centeredSlides ? t.maxTranslate() + t.slidesSizesGrid[t.slidesSizesGrid.length - 1] + t.params.spaceBetween + (r.slidesPerView !== "auto" && t.slides.length - r.slidesPerView >= 2 ? t.slidesSizesGrid[t.slidesSizesGrid.length - 1] + t.params.spaceBetween : 0) : t.maxTranslate()) && t.loopFix({
    direction: "next",
    setTranslate: !0,
    activeSlideIndex: t.slides.length - (r.slidesPerView === "auto" ? t.slidesPerViewDynamic() : Math.ceil(parseFloat(r.slidesPerView, 10)))
  }), s.currentTranslate < t.maxTranslate() && (S = !1, r.resistance && (s.currentTranslate = t.maxTranslate() + 1 - (t.maxTranslate() - s.startTranslate - w) ** x))), S && (d.preventedByNestedSwiper = !0), !t.allowSlideNext && t.swipeDirection === "next" && s.currentTranslate < s.startTranslate && (s.currentTranslate = s.startTranslate), !t.allowSlidePrev && t.swipeDirection === "prev" && s.currentTranslate > s.startTranslate && (s.currentTranslate = s.startTranslate), !t.allowSlidePrev && !t.allowSlideNext && (s.currentTranslate = s.startTranslate), r.threshold > 0)
    if (Math.abs(w) > r.threshold || s.allowThresholdMove) {
      if (!s.allowThresholdMove) {
        s.allowThresholdMove = !0, a.startX = a.currentX, a.startY = a.currentY, s.currentTranslate = s.startTranslate, a.diff = t.isHorizontal() ? a.currentX - a.startX : a.currentY - a.startY;
        return;
      }
    } else {
      s.currentTranslate = s.startTranslate;
      return;
    }
  !r.followFinger || r.cssMode || ((r.freeMode && r.freeMode.enabled && t.freeMode || r.watchSlidesProgress) && (t.updateActiveIndex(), t.updateSlidesClasses()), r.freeMode && r.freeMode.enabled && t.freeMode && t.freeMode.onTouchMove(), t.updateProgress(s.currentTranslate), t.setTranslate(s.currentTranslate));
}
function vU(n) {
  const e = this, t = e.touchEventsData;
  let s = n;
  s.originalEvent && (s = s.originalEvent);
  let r;
  if (s.type === "touchend" || s.type === "touchcancel") {
    if (r = [...s.changedTouches].filter((x) => x.identifier === t.touchId)[0], !r || r.identifier !== t.touchId)
      return;
  } else {
    if (t.touchId !== null || s.pointerId !== t.pointerId)
      return;
    r = s;
  }
  if (["pointercancel", "pointerout", "pointerleave", "contextmenu"].includes(s.type) && !(["pointercancel", "contextmenu"].includes(s.type) && (e.browser.isSafari || e.browser.isWebView)))
    return;
  t.pointerId = null, t.touchId = null;
  const {
    params: c,
    touches: l,
    rtlTranslate: d,
    slidesGrid: h,
    enabled: m
  } = e;
  if (!m || !c.simulateTouch && s.pointerType === "mouse")
    return;
  if (t.allowTouchCallbacks && e.emit("touchEnd", s), t.allowTouchCallbacks = !1, !t.isTouched) {
    t.isMoved && c.grabCursor && e.setGrabCursor(!1), t.isMoved = !1, t.startMoving = !1;
    return;
  }
  c.grabCursor && t.isMoved && t.isTouched && (e.allowSlideNext === !0 || e.allowSlidePrev === !0) && e.setGrabCursor(!1);
  const y = yr(), b = y - t.touchStartTime;
  if (e.allowClick) {
    const x = s.path || s.composedPath && s.composedPath();
    e.updateClickedSlide(x && x[0] || s.target, x), e.emit("tap click", s), b < 300 && y - t.lastClickTime < 300 && e.emit("doubleTap doubleClick", s);
  }
  if (t.lastClickTime = yr(), gr(() => {
    e.destroyed || (e.allowClick = !0);
  }), !t.isTouched || !t.isMoved || !e.swipeDirection || l.diff === 0 && !t.loopSwapReset || t.currentTranslate === t.startTranslate && !t.loopSwapReset) {
    t.isTouched = !1, t.isMoved = !1, t.startMoving = !1;
    return;
  }
  t.isTouched = !1, t.isMoved = !1, t.startMoving = !1;
  let v;
  if (c.followFinger ? v = d ? e.translate : -e.translate : v = -t.currentTranslate, c.cssMode)
    return;
  if (c.freeMode && c.freeMode.enabled) {
    e.freeMode.onTouchEnd({
      currentPos: v
    });
    return;
  }
  const w = v >= -e.maxTranslate() && !e.params.loop;
  let o = 0, u = e.slidesSizesGrid[0];
  for (let x = 0; x < h.length; x += x < c.slidesPerGroupSkip ? 1 : c.slidesPerGroup) {
    const E = x < c.slidesPerGroupSkip - 1 ? 1 : c.slidesPerGroup;
    typeof h[x + E] < "u" ? (w || v >= h[x] && v < h[x + E]) && (o = x, u = h[x + E] - h[x]) : (w || v >= h[x]) && (o = x, u = h[h.length - 1] - h[h.length - 2]);
  }
  let f = null, p = null;
  c.rewind && (e.isBeginning ? p = c.virtual && c.virtual.enabled && e.virtual ? e.virtual.slides.length - 1 : e.slides.length - 1 : e.isEnd && (f = 0));
  const g = (v - h[o]) / u, S = o < c.slidesPerGroupSkip - 1 ? 1 : c.slidesPerGroup;
  if (b > c.longSwipesMs) {
    if (!c.longSwipes) {
      e.slideTo(e.activeIndex);
      return;
    }
    e.swipeDirection === "next" && (g >= c.longSwipesRatio ? e.slideTo(c.rewind && e.isEnd ? f : o + S) : e.slideTo(o)), e.swipeDirection === "prev" && (g > 1 - c.longSwipesRatio ? e.slideTo(o + S) : p !== null && g < 0 && Math.abs(g) > c.longSwipesRatio ? e.slideTo(p) : e.slideTo(o));
  } else {
    if (!c.shortSwipes) {
      e.slideTo(e.activeIndex);
      return;
    }
    e.navigation && (s.target === e.navigation.nextEl || s.target === e.navigation.prevEl) ? s.target === e.navigation.nextEl ? e.slideTo(o + S) : e.slideTo(o) : (e.swipeDirection === "next" && e.slideTo(f !== null ? f : o + S), e.swipeDirection === "prev" && e.slideTo(p !== null ? p : o));
  }
}
function Pl() {
  const n = this, {
    params: e,
    el: t
  } = n;
  if (t && t.offsetWidth === 0)
    return;
  e.breakpoints && n.setBreakpoint();
  const {
    allowSlideNext: s,
    allowSlidePrev: r,
    snapGrid: a
  } = n, c = n.virtual && n.params.virtual.enabled;
  n.allowSlideNext = !0, n.allowSlidePrev = !0, n.updateSize(), n.updateSlides(), n.updateSlidesClasses();
  const l = c && e.loop;
  (e.slidesPerView === "auto" || e.slidesPerView > 1) && n.isEnd && !n.isBeginning && !n.params.centeredSlides && !l ? n.slideTo(n.slides.length - 1, 0, !1, !0) : n.params.loop && !c ? n.slideToLoop(n.realIndex, 0, !1, !0) : n.slideTo(n.activeIndex, 0, !1, !0), n.autoplay && n.autoplay.running && n.autoplay.paused && (clearTimeout(n.autoplay.resizeTimeout), n.autoplay.resizeTimeout = setTimeout(() => {
    n.autoplay && n.autoplay.running && n.autoplay.paused && n.autoplay.resume();
  }, 500)), n.allowSlidePrev = r, n.allowSlideNext = s, n.params.watchOverflow && a !== n.snapGrid && n.checkOverflow();
}
function bU(n) {
  const e = this;
  e.enabled && (e.allowClick || (e.params.preventClicks && n.preventDefault(), e.params.preventClicksPropagation && e.animating && (n.stopPropagation(), n.stopImmediatePropagation())));
}
function xU() {
  const n = this, {
    wrapperEl: e,
    rtlTranslate: t,
    enabled: s
  } = n;
  if (!s)
    return;
  n.previousTranslate = n.translate, n.isHorizontal() ? n.translate = -e.scrollLeft : n.translate = -e.scrollTop, n.translate === 0 && (n.translate = 0), n.updateActiveIndex(), n.updateSlidesClasses();
  let r;
  const a = n.maxTranslate() - n.minTranslate();
  a === 0 ? r = 0 : r = (n.translate - n.minTranslate()) / a, r !== n.progress && n.updateProgress(t ? -n.translate : n.translate), n.emit("setTranslate", n.translate, !1);
}
function SU(n) {
  const e = this;
  tr(e, n.target), !(e.params.cssMode || e.params.slidesPerView !== "auto" && !e.params.autoHeight) && e.update();
}
function wU() {
  const n = this;
  n.documentTouchHandlerProceeded || (n.documentTouchHandlerProceeded = !0, n.params.touchReleaseOnEdges && (n.el.style.touchAction = "auto"));
}
const Wu = (n, e) => {
  const t = si(), {
    params: s,
    el: r,
    wrapperEl: a,
    device: c
  } = n, l = !!s.nested, d = e === "on" ? "addEventListener" : "removeEventListener", h = e;
  !r || typeof r == "string" || (t[d]("touchstart", n.onDocumentTouchStart, {
    passive: !1,
    capture: l
  }), r[d]("touchstart", n.onTouchStart, {
    passive: !1
  }), r[d]("pointerdown", n.onTouchStart, {
    passive: !1
  }), t[d]("touchmove", n.onTouchMove, {
    passive: !1,
    capture: l
  }), t[d]("pointermove", n.onTouchMove, {
    passive: !1,
    capture: l
  }), t[d]("touchend", n.onTouchEnd, {
    passive: !0
  }), t[d]("pointerup", n.onTouchEnd, {
    passive: !0
  }), t[d]("pointercancel", n.onTouchEnd, {
    passive: !0
  }), t[d]("touchcancel", n.onTouchEnd, {
    passive: !0
  }), t[d]("pointerout", n.onTouchEnd, {
    passive: !0
  }), t[d]("pointerleave", n.onTouchEnd, {
    passive: !0
  }), t[d]("contextmenu", n.onTouchEnd, {
    passive: !0
  }), (s.preventClicks || s.preventClicksPropagation) && r[d]("click", n.onClick, !0), s.cssMode && a[d]("scroll", n.onScroll), s.updateOnWindowResize ? n[h](c.ios || c.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", Pl, !0) : n[h]("observerUpdate", Pl, !0), r[d]("load", n.onLoad, {
    capture: !0
  }));
};
function AU() {
  const n = this, {
    params: e
  } = n;
  n.onTouchStart = gU.bind(n), n.onTouchMove = yU.bind(n), n.onTouchEnd = vU.bind(n), n.onDocumentTouchStart = wU.bind(n), e.cssMode && (n.onScroll = xU.bind(n)), n.onClick = bU.bind(n), n.onLoad = SU.bind(n), Wu(n, "on");
}
function CU() {
  Wu(this, "off");
}
var EU = {
  attachEvents: AU,
  detachEvents: CU
};
const Ml = (n, e) => n.grid && e.grid && e.grid.rows > 1;
function kU() {
  const n = this, {
    realIndex: e,
    initialized: t,
    params: s,
    el: r
  } = n, a = s.breakpoints;
  if (!a || a && Object.keys(a).length === 0)
    return;
  const c = n.getBreakpoint(a, n.params.breakpointsBase, n.el);
  if (!c || n.currentBreakpoint === c)
    return;
  const d = (c in a ? a[c] : void 0) || n.originalParams, h = Ml(n, s), m = Ml(n, d), y = n.params.grabCursor, b = d.grabCursor, v = s.enabled;
  h && !m ? (r.classList.remove(`${s.containerModifierClass}grid`, `${s.containerModifierClass}grid-column`), n.emitContainerClasses()) : !h && m && (r.classList.add(`${s.containerModifierClass}grid`), (d.grid.fill && d.grid.fill === "column" || !d.grid.fill && s.grid.fill === "column") && r.classList.add(`${s.containerModifierClass}grid-column`), n.emitContainerClasses()), y && !b ? n.unsetGrabCursor() : !y && b && n.setGrabCursor(), ["navigation", "pagination", "scrollbar"].forEach((g) => {
    if (typeof d[g] > "u")
      return;
    const S = s[g] && s[g].enabled, x = d[g] && d[g].enabled;
    S && !x && n[g].disable(), !S && x && n[g].enable();
  });
  const w = d.direction && d.direction !== s.direction, o = s.loop && (d.slidesPerView !== s.slidesPerView || w), u = s.loop;
  w && t && n.changeDirection(), Vt(n.params, d);
  const f = n.params.enabled, p = n.params.loop;
  Object.assign(n, {
    allowTouchMove: n.params.allowTouchMove,
    allowSlideNext: n.params.allowSlideNext,
    allowSlidePrev: n.params.allowSlidePrev
  }), v && !f ? n.disable() : !v && f && n.enable(), n.currentBreakpoint = c, n.emit("_beforeBreakpoint", d), t && (o ? (n.loopDestroy(), n.loopCreate(e), n.updateSlides()) : !u && p ? (n.loopCreate(e), n.updateSlides()) : u && !p && n.loopDestroy()), n.emit("breakpoint", d);
}
function OU(n, e, t) {
  if (e === void 0 && (e = "window"), !n || e === "container" && !t)
    return;
  let s = !1;
  const r = Mt(), a = e === "window" ? r.innerHeight : t.clientHeight, c = Object.keys(n).map((l) => {
    if (typeof l == "string" && l.indexOf("@") === 0) {
      const d = parseFloat(l.substr(1));
      return {
        value: a * d,
        point: l
      };
    }
    return {
      value: l,
      point: l
    };
  });
  c.sort((l, d) => parseInt(l.value, 10) - parseInt(d.value, 10));
  for (let l = 0; l < c.length; l += 1) {
    const {
      point: d,
      value: h
    } = c[l];
    e === "window" ? r.matchMedia(`(min-width: ${h}px)`).matches && (s = d) : h <= t.clientWidth && (s = d);
  }
  return s || "max";
}
var TU = {
  setBreakpoint: kU,
  getBreakpoint: OU
};
function IU(n, e) {
  const t = [];
  return n.forEach((s) => {
    typeof s == "object" ? Object.keys(s).forEach((r) => {
      s[r] && t.push(e + r);
    }) : typeof s == "string" && t.push(e + s);
  }), t;
}
function UU() {
  const n = this, {
    classNames: e,
    params: t,
    rtl: s,
    el: r,
    device: a
  } = n, c = IU(["initialized", t.direction, {
    "free-mode": n.params.freeMode && t.freeMode.enabled
  }, {
    autoheight: t.autoHeight
  }, {
    rtl: s
  }, {
    grid: t.grid && t.grid.rows > 1
  }, {
    "grid-column": t.grid && t.grid.rows > 1 && t.grid.fill === "column"
  }, {
    android: a.android
  }, {
    ios: a.ios
  }, {
    "css-mode": t.cssMode
  }, {
    centered: t.cssMode && t.centeredSlides
  }, {
    "watch-progress": t.watchSlidesProgress
  }], t.containerModifierClass);
  e.push(...c), r.classList.add(...e), n.emitContainerClasses();
}
function zU() {
  const n = this, {
    el: e,
    classNames: t
  } = n;
  !e || typeof e == "string" || (e.classList.remove(...t), n.emitContainerClasses());
}
var RU = {
  addClasses: UU,
  removeClasses: zU
};
function PU() {
  const n = this, {
    isLocked: e,
    params: t
  } = n, {
    slidesOffsetBefore: s
  } = t;
  if (s) {
    const r = n.slides.length - 1, a = n.slidesGrid[r] + n.slidesSizesGrid[r] + s * 2;
    n.isLocked = n.size > a;
  } else
    n.isLocked = n.snapGrid.length === 1;
  t.allowSlideNext === !0 && (n.allowSlideNext = !n.isLocked), t.allowSlidePrev === !0 && (n.allowSlidePrev = !n.isLocked), e && e !== n.isLocked && (n.isEnd = !1), e !== n.isLocked && n.emit(n.isLocked ? "lock" : "unlock");
}
var MU = {
  checkOverflow: PU
}, qo = {
  init: !0,
  direction: "horizontal",
  oneWayMovement: !1,
  swiperElementNodeName: "SWIPER-CONTAINER",
  touchEventsTarget: "wrapper",
  initialSlide: 0,
  speed: 300,
  cssMode: !1,
  updateOnWindowResize: !0,
  resizeObserver: !0,
  nested: !1,
  createElements: !1,
  eventsPrefix: "swiper",
  enabled: !0,
  focusableElements: "input, select, option, textarea, button, video, label",
  // Overrides
  width: null,
  height: null,
  //
  preventInteractionOnTransition: !1,
  // ssr
  userAgent: null,
  url: null,
  // To support iOS's swipe-to-go-back gesture (when being used in-app).
  edgeSwipeDetection: !1,
  edgeSwipeThreshold: 20,
  // Autoheight
  autoHeight: !1,
  // Set wrapper width
  setWrapperSize: !1,
  // Virtual Translate
  virtualTranslate: !1,
  // Effects
  effect: "slide",
  // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
  // Breakpoints
  breakpoints: void 0,
  breakpointsBase: "window",
  // Slides grid
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerGroup: 1,
  slidesPerGroupSkip: 0,
  slidesPerGroupAuto: !1,
  centeredSlides: !1,
  centeredSlidesBounds: !1,
  slidesOffsetBefore: 0,
  // in px
  slidesOffsetAfter: 0,
  // in px
  normalizeSlideIndex: !0,
  centerInsufficientSlides: !1,
  // Disable swiper and hide navigation when container not overflow
  watchOverflow: !0,
  // Round length
  roundLengths: !1,
  // Touches
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: !0,
  shortSwipes: !0,
  longSwipes: !0,
  longSwipesRatio: 0.5,
  longSwipesMs: 300,
  followFinger: !0,
  allowTouchMove: !0,
  threshold: 5,
  touchMoveStopPropagation: !1,
  touchStartPreventDefault: !0,
  touchStartForcePreventDefault: !1,
  touchReleaseOnEdges: !1,
  // Unique Navigation Elements
  uniqueNavElements: !0,
  // Resistance
  resistance: !0,
  resistanceRatio: 0.85,
  // Progress
  watchSlidesProgress: !1,
  // Cursor
  grabCursor: !1,
  // Clicks
  preventClicks: !0,
  preventClicksPropagation: !0,
  slideToClickedSlide: !1,
  // loop
  loop: !1,
  loopAddBlankSlides: !0,
  loopAdditionalSlides: 0,
  loopPreventsSliding: !0,
  // rewind
  rewind: !1,
  // Swiping/no swiping
  allowSlidePrev: !0,
  allowSlideNext: !0,
  swipeHandler: null,
  // '.swipe-handler',
  noSwiping: !0,
  noSwipingClass: "swiper-no-swiping",
  noSwipingSelector: null,
  // Passive Listeners
  passiveListeners: !0,
  maxBackfaceHiddenSlides: 10,
  // NS
  containerModifierClass: "swiper-",
  // NEW
  slideClass: "swiper-slide",
  slideBlankClass: "swiper-slide-blank",
  slideActiveClass: "swiper-slide-active",
  slideVisibleClass: "swiper-slide-visible",
  slideFullyVisibleClass: "swiper-slide-fully-visible",
  slideNextClass: "swiper-slide-next",
  slidePrevClass: "swiper-slide-prev",
  wrapperClass: "swiper-wrapper",
  lazyPreloaderClass: "swiper-lazy-preloader",
  lazyPreloadPrevNext: 0,
  // Callbacks
  runCallbacksOnInit: !0,
  // Internals
  _emitClasses: !1
};
function jU(n, e) {
  return function(s) {
    s === void 0 && (s = {});
    const r = Object.keys(s)[0], a = s[r];
    if (typeof a != "object" || a === null) {
      Vt(e, s);
      return;
    }
    if (n[r] === !0 && (n[r] = {
      enabled: !0
    }), r === "navigation" && n[r] && n[r].enabled && !n[r].prevEl && !n[r].nextEl && (n[r].auto = !0), ["pagination", "scrollbar"].indexOf(r) >= 0 && n[r] && n[r].enabled && !n[r].el && (n[r].auto = !0), !(r in n && "enabled" in a)) {
      Vt(e, s);
      return;
    }
    typeof n[r] == "object" && !("enabled" in n[r]) && (n[r].enabled = !0), n[r] || (n[r] = {
      enabled: !1
    }), Vt(e, s);
  };
}
const oo = {
  eventsEmitter: RI,
  update: VI,
  translate: ZI,
  transition: $I,
  slide: aU,
  loop: dU,
  grabCursor: pU,
  events: EU,
  breakpoints: TU,
  checkOverflow: MU,
  classes: RU
}, ao = {};
let ha = class mi {
  constructor() {
    let e, t;
    for (var s = arguments.length, r = new Array(s), a = 0; a < s; a++)
      r[a] = arguments[a];
    r.length === 1 && r[0].constructor && Object.prototype.toString.call(r[0]).slice(8, -1) === "Object" ? t = r[0] : [e, t] = r, t || (t = {}), t = Vt({}, t), e && !t.el && (t.el = e);
    const c = si();
    if (t.el && typeof t.el == "string" && c.querySelectorAll(t.el).length > 1) {
      const m = [];
      return c.querySelectorAll(t.el).forEach((y) => {
        const b = Vt({}, t, {
          el: y
        });
        m.push(new mi(b));
      }), m;
    }
    const l = this;
    l.__swiper__ = !0, l.support = Hu(), l.device = Vu({
      userAgent: t.userAgent
    }), l.browser = II(), l.eventsListeners = {}, l.eventsAnyListeners = [], l.modules = [...l.__modules__], t.modules && Array.isArray(t.modules) && l.modules.push(...t.modules);
    const d = {};
    l.modules.forEach((m) => {
      m({
        params: t,
        swiper: l,
        extendParams: jU(t, d),
        on: l.on.bind(l),
        once: l.once.bind(l),
        off: l.off.bind(l),
        emit: l.emit.bind(l)
      });
    });
    const h = Vt({}, qo, d);
    return l.params = Vt({}, h, ao, t), l.originalParams = Vt({}, l.params), l.passedParams = Vt({}, t), l.params && l.params.on && Object.keys(l.params.on).forEach((m) => {
      l.on(m, l.params.on[m]);
    }), l.params && l.params.onAny && l.onAny(l.params.onAny), Object.assign(l, {
      enabled: l.params.enabled,
      el: e,
      // Classes
      classNames: [],
      // Slides
      slides: [],
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],
      // isDirection
      isHorizontal() {
        return l.params.direction === "horizontal";
      },
      isVertical() {
        return l.params.direction === "vertical";
      },
      // Indexes
      activeIndex: 0,
      realIndex: 0,
      //
      isBeginning: !0,
      isEnd: !1,
      // Props
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: !1,
      cssOverflowAdjustment() {
        return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
      },
      // Locks
      allowSlideNext: l.params.allowSlideNext,
      allowSlidePrev: l.params.allowSlidePrev,
      // Touch Events
      touchEventsData: {
        isTouched: void 0,
        isMoved: void 0,
        allowTouchCallbacks: void 0,
        touchStartTime: void 0,
        isScrolling: void 0,
        currentTranslate: void 0,
        startTranslate: void 0,
        allowThresholdMove: void 0,
        // Form elements to match
        focusableElements: l.params.focusableElements,
        // Last click time
        lastClickTime: 0,
        clickTimeout: void 0,
        // Velocities
        velocities: [],
        allowMomentumBounce: void 0,
        startMoving: void 0,
        pointerId: null,
        touchId: null
      },
      // Clicks
      allowClick: !0,
      // Touches
      allowTouchMove: l.params.allowTouchMove,
      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },
      // Images
      imagesToLoad: [],
      imagesLoaded: 0
    }), l.emit("_swiper"), l.params.init && l.init(), l;
  }
  getDirectionLabel(e) {
    return this.isHorizontal() ? e : {
      width: "height",
      "margin-top": "margin-left",
      "margin-bottom ": "margin-right",
      "margin-left": "margin-top",
      "margin-right": "margin-bottom",
      "padding-left": "padding-top",
      "padding-right": "padding-bottom",
      marginRight: "marginBottom"
    }[e];
  }
  getSlideIndex(e) {
    const {
      slidesEl: t,
      params: s
    } = this, r = ti(t, `.${s.slideClass}, swiper-slide`), a = os(r[0]);
    return os(e) - a;
  }
  getSlideIndexByData(e) {
    return this.getSlideIndex(this.slides.filter((t) => t.getAttribute("data-swiper-slide-index") * 1 === e)[0]);
  }
  recalcSlides() {
    const e = this, {
      slidesEl: t,
      params: s
    } = e;
    e.slides = ti(t, `.${s.slideClass}, swiper-slide`);
  }
  enable() {
    const e = this;
    e.enabled || (e.enabled = !0, e.params.grabCursor && e.setGrabCursor(), e.emit("enable"));
  }
  disable() {
    const e = this;
    e.enabled && (e.enabled = !1, e.params.grabCursor && e.unsetGrabCursor(), e.emit("disable"));
  }
  setProgress(e, t) {
    const s = this;
    e = Math.min(Math.max(e, 0), 1);
    const r = s.minTranslate(), c = (s.maxTranslate() - r) * e + r;
    s.translateTo(c, typeof t > "u" ? 0 : t), s.updateActiveIndex(), s.updateSlidesClasses();
  }
  emitContainerClasses() {
    const e = this;
    if (!e.params._emitClasses || !e.el)
      return;
    const t = e.el.className.split(" ").filter((s) => s.indexOf("swiper") === 0 || s.indexOf(e.params.containerModifierClass) === 0);
    e.emit("_containerClasses", t.join(" "));
  }
  getSlideClasses(e) {
    const t = this;
    return t.destroyed ? "" : e.className.split(" ").filter((s) => s.indexOf("swiper-slide") === 0 || s.indexOf(t.params.slideClass) === 0).join(" ");
  }
  emitSlidesClasses() {
    const e = this;
    if (!e.params._emitClasses || !e.el)
      return;
    const t = [];
    e.slides.forEach((s) => {
      const r = e.getSlideClasses(s);
      t.push({
        slideEl: s,
        classNames: r
      }), e.emit("_slideClass", s, r);
    }), e.emit("_slideClasses", t);
  }
  slidesPerViewDynamic(e, t) {
    e === void 0 && (e = "current"), t === void 0 && (t = !1);
    const s = this, {
      params: r,
      slides: a,
      slidesGrid: c,
      slidesSizesGrid: l,
      size: d,
      activeIndex: h
    } = s;
    let m = 1;
    if (typeof r.slidesPerView == "number")
      return r.slidesPerView;
    if (r.centeredSlides) {
      let y = a[h] ? Math.ceil(a[h].swiperSlideSize) : 0, b;
      for (let v = h + 1; v < a.length; v += 1)
        a[v] && !b && (y += Math.ceil(a[v].swiperSlideSize), m += 1, y > d && (b = !0));
      for (let v = h - 1; v >= 0; v -= 1)
        a[v] && !b && (y += a[v].swiperSlideSize, m += 1, y > d && (b = !0));
    } else if (e === "current")
      for (let y = h + 1; y < a.length; y += 1)
        (t ? c[y] + l[y] - c[h] < d : c[y] - c[h] < d) && (m += 1);
    else
      for (let y = h - 1; y >= 0; y -= 1)
        c[h] - c[y] < d && (m += 1);
    return m;
  }
  update() {
    const e = this;
    if (!e || e.destroyed)
      return;
    const {
      snapGrid: t,
      params: s
    } = e;
    s.breakpoints && e.setBreakpoint(), [...e.el.querySelectorAll('[loading="lazy"]')].forEach((c) => {
      c.complete && tr(e, c);
    }), e.updateSize(), e.updateSlides(), e.updateProgress(), e.updateSlidesClasses();
    function r() {
      const c = e.rtlTranslate ? e.translate * -1 : e.translate, l = Math.min(Math.max(c, e.maxTranslate()), e.minTranslate());
      e.setTranslate(l), e.updateActiveIndex(), e.updateSlidesClasses();
    }
    let a;
    if (s.freeMode && s.freeMode.enabled && !s.cssMode)
      r(), s.autoHeight && e.updateAutoHeight();
    else {
      if ((s.slidesPerView === "auto" || s.slidesPerView > 1) && e.isEnd && !s.centeredSlides) {
        const c = e.virtual && s.virtual.enabled ? e.virtual.slides : e.slides;
        a = e.slideTo(c.length - 1, 0, !1, !0);
      } else
        a = e.slideTo(e.activeIndex, 0, !1, !0);
      a || r();
    }
    s.watchOverflow && t !== e.snapGrid && e.checkOverflow(), e.emit("update");
  }
  changeDirection(e, t) {
    t === void 0 && (t = !0);
    const s = this, r = s.params.direction;
    return e || (e = r === "horizontal" ? "vertical" : "horizontal"), e === r || e !== "horizontal" && e !== "vertical" || (s.el.classList.remove(`${s.params.containerModifierClass}${r}`), s.el.classList.add(`${s.params.containerModifierClass}${e}`), s.emitContainerClasses(), s.params.direction = e, s.slides.forEach((a) => {
      e === "vertical" ? a.style.width = "" : a.style.height = "";
    }), s.emit("changeDirection"), t && s.update()), s;
  }
  changeLanguageDirection(e) {
    const t = this;
    t.rtl && e === "rtl" || !t.rtl && e === "ltr" || (t.rtl = e === "rtl", t.rtlTranslate = t.params.direction === "horizontal" && t.rtl, t.rtl ? (t.el.classList.add(`${t.params.containerModifierClass}rtl`), t.el.dir = "rtl") : (t.el.classList.remove(`${t.params.containerModifierClass}rtl`), t.el.dir = "ltr"), t.update());
  }
  mount(e) {
    const t = this;
    if (t.mounted)
      return !0;
    let s = e || t.params.el;
    if (typeof s == "string" && (s = document.querySelector(s)), !s)
      return !1;
    s.swiper = t, s.parentNode && s.parentNode.host && s.parentNode.host.nodeName === t.params.swiperElementNodeName.toUpperCase() && (t.isElement = !0);
    const r = () => `.${(t.params.wrapperClass || "").trim().split(" ").join(".")}`;
    let c = (() => s && s.shadowRoot && s.shadowRoot.querySelector ? s.shadowRoot.querySelector(r()) : ti(s, r())[0])();
    return !c && t.params.createElements && (c = Li("div", t.params.wrapperClass), s.append(c), ti(s, `.${t.params.slideClass}`).forEach((l) => {
      c.append(l);
    })), Object.assign(t, {
      el: s,
      wrapperEl: c,
      slidesEl: t.isElement && !s.parentNode.host.slideSlots ? s.parentNode.host : c,
      hostEl: t.isElement ? s.parentNode.host : s,
      mounted: !0,
      // RTL
      rtl: s.dir.toLowerCase() === "rtl" || Ti(s, "direction") === "rtl",
      rtlTranslate: t.params.direction === "horizontal" && (s.dir.toLowerCase() === "rtl" || Ti(s, "direction") === "rtl"),
      wrongRTL: Ti(c, "display") === "-webkit-box"
    }), !0;
  }
  init(e) {
    const t = this;
    if (t.initialized || t.mount(e) === !1)
      return t;
    t.emit("beforeInit"), t.params.breakpoints && t.setBreakpoint(), t.addClasses(), t.updateSize(), t.updateSlides(), t.params.watchOverflow && t.checkOverflow(), t.params.grabCursor && t.enabled && t.setGrabCursor(), t.params.loop && t.virtual && t.params.virtual.enabled ? t.slideTo(t.params.initialSlide + t.virtual.slidesBefore, 0, t.params.runCallbacksOnInit, !1, !0) : t.slideTo(t.params.initialSlide, 0, t.params.runCallbacksOnInit, !1, !0), t.params.loop && t.loopCreate(), t.attachEvents();
    const r = [...t.el.querySelectorAll('[loading="lazy"]')];
    return t.isElement && r.push(...t.hostEl.querySelectorAll('[loading="lazy"]')), r.forEach((a) => {
      a.complete ? tr(t, a) : a.addEventListener("load", (c) => {
        tr(t, c.target);
      });
    }), Bo(t), t.initialized = !0, Bo(t), t.emit("init"), t.emit("afterInit"), t;
  }
  destroy(e, t) {
    e === void 0 && (e = !0), t === void 0 && (t = !0);
    const s = this, {
      params: r,
      el: a,
      wrapperEl: c,
      slides: l
    } = s;
    return typeof s.params > "u" || s.destroyed || (s.emit("beforeDestroy"), s.initialized = !1, s.detachEvents(), r.loop && s.loopDestroy(), t && (s.removeClasses(), a && typeof a != "string" && a.removeAttribute("style"), c && c.removeAttribute("style"), l && l.length && l.forEach((d) => {
      d.classList.remove(r.slideVisibleClass, r.slideFullyVisibleClass, r.slideActiveClass, r.slideNextClass, r.slidePrevClass), d.removeAttribute("style"), d.removeAttribute("data-swiper-slide-index");
    })), s.emit("destroy"), Object.keys(s.eventsListeners).forEach((d) => {
      s.off(d);
    }), e !== !1 && (s.el && typeof s.el != "string" && (s.el.swiper = null), vI(s)), s.destroyed = !0), null;
  }
  static extendDefaults(e) {
    Vt(ao, e);
  }
  static get extendedDefaults() {
    return ao;
  }
  static get defaults() {
    return qo;
  }
  static installModule(e) {
    mi.prototype.__modules__ || (mi.prototype.__modules__ = []);
    const t = mi.prototype.__modules__;
    typeof e == "function" && t.indexOf(e) < 0 && t.push(e);
  }
  static use(e) {
    return Array.isArray(e) ? (e.forEach((t) => mi.installModule(t)), mi) : (mi.installModule(e), mi);
  }
};
Object.keys(oo).forEach((n) => {
  Object.keys(oo[n]).forEach((e) => {
    ha.prototype[e] = oo[n][e];
  });
});
ha.use([UI, zI]);
const Ku = [
  "eventsPrefix",
  "injectStyles",
  "injectStylesUrls",
  "modules",
  "init",
  "_direction",
  "oneWayMovement",
  "swiperElementNodeName",
  "touchEventsTarget",
  "initialSlide",
  "_speed",
  "cssMode",
  "updateOnWindowResize",
  "resizeObserver",
  "nested",
  "focusableElements",
  "_enabled",
  "_width",
  "_height",
  "preventInteractionOnTransition",
  "userAgent",
  "url",
  "_edgeSwipeDetection",
  "_edgeSwipeThreshold",
  "_freeMode",
  "_autoHeight",
  "setWrapperSize",
  "virtualTranslate",
  "_effect",
  "breakpoints",
  "breakpointsBase",
  "_spaceBetween",
  "_slidesPerView",
  "maxBackfaceHiddenSlides",
  "_grid",
  "_slidesPerGroup",
  "_slidesPerGroupSkip",
  "_slidesPerGroupAuto",
  "_centeredSlides",
  "_centeredSlidesBounds",
  "_slidesOffsetBefore",
  "_slidesOffsetAfter",
  "normalizeSlideIndex",
  "_centerInsufficientSlides",
  "_watchOverflow",
  "roundLengths",
  "touchRatio",
  "touchAngle",
  "simulateTouch",
  "_shortSwipes",
  "_longSwipes",
  "longSwipesRatio",
  "longSwipesMs",
  "_followFinger",
  "allowTouchMove",
  "_threshold",
  "touchMoveStopPropagation",
  "touchStartPreventDefault",
  "touchStartForcePreventDefault",
  "touchReleaseOnEdges",
  "uniqueNavElements",
  "_resistance",
  "_resistanceRatio",
  "_watchSlidesProgress",
  "_grabCursor",
  "preventClicks",
  "preventClicksPropagation",
  "_slideToClickedSlide",
  "_loop",
  "loopAdditionalSlides",
  "loopAddBlankSlides",
  "loopPreventsSliding",
  "_rewind",
  "_allowSlidePrev",
  "_allowSlideNext",
  "_swipeHandler",
  "_noSwiping",
  "noSwipingClass",
  "noSwipingSelector",
  "passiveListeners",
  "containerModifierClass",
  "slideClass",
  "slideActiveClass",
  "slideVisibleClass",
  "slideFullyVisibleClass",
  "slideNextClass",
  "slidePrevClass",
  "slideBlankClass",
  "wrapperClass",
  "lazyPreloaderClass",
  "lazyPreloadPrevNext",
  "runCallbacksOnInit",
  "observer",
  "observeParents",
  "observeSlideChildren",
  // modules
  "a11y",
  "_autoplay",
  "_controller",
  "coverflowEffect",
  "cubeEffect",
  "fadeEffect",
  "flipEffect",
  "creativeEffect",
  "cardsEffect",
  "hashNavigation",
  "history",
  "keyboard",
  "mousewheel",
  "_navigation",
  "_pagination",
  "parallax",
  "_scrollbar",
  "_thumbs",
  "virtual",
  "zoom",
  "control"
];
function nn(n) {
  return typeof n == "object" && n !== null && n.constructor && Object.prototype.toString.call(n).slice(8, -1) === "Object" && !n.__swiper__;
}
function mn(n, e) {
  const t = ["__proto__", "constructor", "prototype"];
  Object.keys(e).filter((s) => t.indexOf(s) < 0).forEach((s) => {
    typeof n[s] > "u" ? n[s] = e[s] : nn(e[s]) && nn(n[s]) && Object.keys(e[s]).length > 0 ? e[s].__swiper__ ? n[s] = e[s] : mn(n[s], e[s]) : n[s] = e[s];
  });
}
function Yu(n) {
  return n === void 0 && (n = {}), n.navigation && typeof n.navigation.nextEl > "u" && typeof n.navigation.prevEl > "u";
}
function Ju(n) {
  return n === void 0 && (n = {}), n.pagination && typeof n.pagination.el > "u";
}
function Zu(n) {
  return n === void 0 && (n = {}), n.scrollbar && typeof n.scrollbar.el > "u";
}
function Qu(n) {
  n === void 0 && (n = "");
  const e = n.split(" ").map((s) => s.trim()).filter((s) => !!s), t = [];
  return e.forEach((s) => {
    t.indexOf(s) < 0 && t.push(s);
  }), t.join(" ");
}
function LU(n) {
  return n === void 0 && (n = ""), n ? n.includes("swiper-wrapper") ? n : `swiper-wrapper ${n}` : "swiper-wrapper";
}
function DU(n) {
  let {
    swiper: e,
    slides: t,
    passedParams: s,
    changedParams: r,
    nextEl: a,
    prevEl: c,
    scrollbarEl: l,
    paginationEl: d
  } = n;
  const h = r.filter((O) => O !== "children" && O !== "direction" && O !== "wrapperClass"), {
    params: m,
    pagination: y,
    navigation: b,
    scrollbar: v,
    virtual: w,
    thumbs: o
  } = e;
  let u, f, p, g, S, x, E, k;
  r.includes("thumbs") && s.thumbs && s.thumbs.swiper && m.thumbs && !m.thumbs.swiper && (u = !0), r.includes("controller") && s.controller && s.controller.control && m.controller && !m.controller.control && (f = !0), r.includes("pagination") && s.pagination && (s.pagination.el || d) && (m.pagination || m.pagination === !1) && y && !y.el && (p = !0), r.includes("scrollbar") && s.scrollbar && (s.scrollbar.el || l) && (m.scrollbar || m.scrollbar === !1) && v && !v.el && (g = !0), r.includes("navigation") && s.navigation && (s.navigation.prevEl || c) && (s.navigation.nextEl || a) && (m.navigation || m.navigation === !1) && b && !b.prevEl && !b.nextEl && (S = !0);
  const R = (O) => {
    e[O] && (e[O].destroy(), O === "navigation" ? (e.isElement && (e[O].prevEl.remove(), e[O].nextEl.remove()), m[O].prevEl = void 0, m[O].nextEl = void 0, e[O].prevEl = void 0, e[O].nextEl = void 0) : (e.isElement && e[O].el.remove(), m[O].el = void 0, e[O].el = void 0));
  };
  r.includes("loop") && e.isElement && (m.loop && !s.loop ? x = !0 : !m.loop && s.loop ? E = !0 : k = !0), h.forEach((O) => {
    if (nn(m[O]) && nn(s[O]))
      Object.assign(m[O], s[O]), (O === "navigation" || O === "pagination" || O === "scrollbar") && "enabled" in s[O] && !s[O].enabled && R(O);
    else {
      const T = s[O];
      (T === !0 || T === !1) && (O === "navigation" || O === "pagination" || O === "scrollbar") ? T === !1 && R(O) : m[O] = s[O];
    }
  }), h.includes("controller") && !f && e.controller && e.controller.control && m.controller && m.controller.control && (e.controller.control = m.controller.control), r.includes("children") && t && w && m.virtual.enabled ? (w.slides = t, w.update(!0)) : r.includes("virtual") && w && m.virtual.enabled && (t && (w.slides = t), w.update(!0)), r.includes("children") && t && m.loop && (k = !0), u && o.init() && o.update(!0), f && (e.controller.control = m.controller.control), p && (e.isElement && (!d || typeof d == "string") && (d = document.createElement("div"), d.classList.add("swiper-pagination"), d.part.add("pagination"), e.el.appendChild(d)), d && (m.pagination.el = d), y.init(), y.render(), y.update()), g && (e.isElement && (!l || typeof l == "string") && (l = document.createElement("div"), l.classList.add("swiper-scrollbar"), l.part.add("scrollbar"), e.el.appendChild(l)), l && (m.scrollbar.el = l), v.init(), v.updateSize(), v.setTranslate()), S && (e.isElement && ((!a || typeof a == "string") && (a = document.createElement("div"), a.classList.add("swiper-button-next"), a.innerHTML = e.hostEl.constructor.nextButtonSvg, a.part.add("button-next"), e.el.appendChild(a)), (!c || typeof c == "string") && (c = document.createElement("div"), c.classList.add("swiper-button-prev"), c.innerHTML = e.hostEl.constructor.prevButtonSvg, c.part.add("button-prev"), e.el.appendChild(c))), a && (m.navigation.nextEl = a), c && (m.navigation.prevEl = c), b.init(), b.update()), r.includes("allowSlideNext") && (e.allowSlideNext = s.allowSlideNext), r.includes("allowSlidePrev") && (e.allowSlidePrev = s.allowSlidePrev), r.includes("direction") && e.changeDirection(s.direction, !1), (x || k) && e.loopDestroy(), (E || k) && e.loopCreate(), e.update();
}
function NU(n, e) {
  n === void 0 && (n = {}), e === void 0 && (e = !0);
  const t = {
    on: {}
  }, s = {}, r = {};
  mn(t, qo), t._emitClasses = !0, t.init = !1;
  const a = {}, c = Ku.map((d) => d.replace(/_/, "")), l = Object.assign({}, n);
  return Object.keys(l).forEach((d) => {
    typeof n[d] > "u" || (c.indexOf(d) >= 0 ? nn(n[d]) ? (t[d] = {}, r[d] = {}, mn(t[d], n[d]), mn(r[d], n[d])) : (t[d] = n[d], r[d] = n[d]) : d.search(/on[A-Z]/) === 0 && typeof n[d] == "function" ? e ? s[`${d[2].toLowerCase()}${d.substr(3)}`] = n[d] : t.on[`${d[2].toLowerCase()}${d.substr(3)}`] = n[d] : a[d] = n[d]);
  }), ["navigation", "pagination", "scrollbar"].forEach((d) => {
    t[d] === !0 && (t[d] = {}), t[d] === !1 && delete t[d];
  }), {
    params: t,
    passedParams: r,
    rest: a,
    events: s
  };
}
function FU(n, e) {
  let {
    el: t,
    nextEl: s,
    prevEl: r,
    paginationEl: a,
    scrollbarEl: c,
    swiper: l
  } = n;
  Yu(e) && s && r && (l.params.navigation.nextEl = s, l.originalParams.navigation.nextEl = s, l.params.navigation.prevEl = r, l.originalParams.navigation.prevEl = r), Ju(e) && a && (l.params.pagination.el = a, l.originalParams.pagination.el = a), Zu(e) && c && (l.params.scrollbar.el = c, l.originalParams.scrollbar.el = c), l.init(t);
}
function BU(n, e, t, s, r) {
  const a = [];
  if (!e)
    return a;
  const c = (d) => {
    a.indexOf(d) < 0 && a.push(d);
  };
  if (t && s) {
    const d = s.map(r), h = t.map(r);
    d.join("") !== h.join("") && c("children"), s.length !== t.length && c("children");
  }
  return Ku.filter((d) => d[0] === "_").map((d) => d.replace(/_/, "")).forEach((d) => {
    if (d in n && d in e)
      if (nn(n[d]) && nn(e[d])) {
        const h = Object.keys(n[d]), m = Object.keys(e[d]);
        h.length !== m.length ? c(d) : (h.forEach((y) => {
          n[d][y] !== e[d][y] && c(d);
        }), m.forEach((y) => {
          n[d][y] !== e[d][y] && c(d);
        }));
      } else
        n[d] !== e[d] && c(d);
  }), a;
}
const qU = (n) => {
  !n || n.destroyed || !n.params.virtual || n.params.virtual && !n.params.virtual.enabled || (n.updateSlides(), n.updateProgress(), n.updateSlidesClasses(), n.parallax && n.params.parallax && n.params.parallax.enabled && n.parallax.setTranslate());
};
function br() {
  return br = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var s in t)
        Object.prototype.hasOwnProperty.call(t, s) && (n[s] = t[s]);
    }
    return n;
  }, br.apply(this, arguments);
}
function Xu(n) {
  return n.type && n.type.displayName && n.type.displayName.includes("SwiperSlide");
}
function _u(n) {
  const e = [];
  return Fe.Children.toArray(n).forEach((t) => {
    Xu(t) ? e.push(t) : t.props && t.props.children && _u(t.props.children).forEach((s) => e.push(s));
  }), e;
}
function HU(n) {
  const e = [], t = {
    "container-start": [],
    "container-end": [],
    "wrapper-start": [],
    "wrapper-end": []
  };
  return Fe.Children.toArray(n).forEach((s) => {
    if (Xu(s))
      e.push(s);
    else if (s.props && s.props.slot && t[s.props.slot])
      t[s.props.slot].push(s);
    else if (s.props && s.props.children) {
      const r = _u(s.props.children);
      r.length > 0 ? r.forEach((a) => e.push(a)) : t["container-end"].push(s);
    } else
      t["container-end"].push(s);
  }), {
    slides: e,
    slots: t
  };
}
function VU(n, e, t) {
  if (!t)
    return null;
  const s = (m) => {
    let y = m;
    return m < 0 ? y = e.length + m : y >= e.length && (y = y - e.length), y;
  }, r = n.isHorizontal() ? {
    [n.rtlTranslate ? "right" : "left"]: `${t.offset}px`
  } : {
    top: `${t.offset}px`
  }, {
    from: a,
    to: c
  } = t, l = n.params.loop ? -e.length : 0, d = n.params.loop ? e.length * 2 : e.length, h = [];
  for (let m = l; m < d; m += 1)
    m >= a && m <= c && h.push(e[s(m)]);
  return h.map((m, y) => /* @__PURE__ */ Fe.cloneElement(m, {
    swiper: n,
    style: r,
    key: m.props.virtualIndex || m.key || `slide-${y}`
  }));
}
function Qn(n, e) {
  return typeof window > "u" ? ee(n, e) : On(n, e);
}
const jl = /* @__PURE__ */ kn(null), GU = /* @__PURE__ */ kn(null), $u = /* @__PURE__ */ su(function(n, e) {
  let {
    className: t,
    tag: s = "div",
    wrapperTag: r = "div",
    children: a,
    onSwiper: c,
    ...l
  } = n === void 0 ? {} : n, d = !1;
  const [h, m] = X("swiper"), [y, b] = X(null), [v, w] = X(!1), o = Re(!1), u = Re(null), f = Re(null), p = Re(null), g = Re(null), S = Re(null), x = Re(null), E = Re(null), k = Re(null), {
    params: R,
    passedParams: O,
    rest: T,
    events: D
  } = NU(l), {
    slides: P,
    slots: N
  } = HU(a), I = () => {
    w(!v);
  };
  Object.assign(R.on, {
    _containerClasses(F, q) {
      m(q);
    }
  });
  const C = () => {
    Object.assign(R.on, D), d = !0;
    const F = {
      ...R
    };
    if (delete F.wrapperClass, f.current = new ha(F), f.current.virtual && f.current.params.virtual.enabled) {
      f.current.virtual.slides = P;
      const q = {
        cache: !1,
        slides: P,
        renderExternal: b,
        renderExternalUpdate: !1
      };
      mn(f.current.params.virtual, q), mn(f.current.originalParams.virtual, q);
    }
  };
  u.current || C(), f.current && f.current.on("_beforeBreakpoint", I);
  const U = () => {
    d || !D || !f.current || Object.keys(D).forEach((F) => {
      f.current.on(F, D[F]);
    });
  }, z = () => {
    !D || !f.current || Object.keys(D).forEach((F) => {
      f.current.off(F, D[F]);
    });
  };
  ee(() => () => {
    f.current && f.current.off("_beforeBreakpoint", I);
  }), ee(() => {
    !o.current && f.current && (f.current.emitSlidesClasses(), o.current = !0);
  }), Qn(() => {
    if (e && (e.current = u.current), !!u.current)
      return f.current.destroyed && C(), FU({
        el: u.current,
        nextEl: S.current,
        prevEl: x.current,
        paginationEl: E.current,
        scrollbarEl: k.current,
        swiper: f.current
      }, R), c && !f.current.destroyed && c(f.current), () => {
        f.current && !f.current.destroyed && f.current.destroy(!0, !1);
      };
  }, []), Qn(() => {
    U();
    const F = BU(O, p.current, P, g.current, (q) => q.key);
    return p.current = O, g.current = P, F.length && f.current && !f.current.destroyed && DU({
      swiper: f.current,
      slides: P,
      passedParams: O,
      changedParams: F,
      nextEl: S.current,
      prevEl: x.current,
      scrollbarEl: k.current,
      paginationEl: E.current
    }), () => {
      z();
    };
  }), Qn(() => {
    qU(f.current);
  }, [y]);
  function j() {
    return R.virtual ? VU(f.current, P, y) : P.map((F, q) => /* @__PURE__ */ Fe.cloneElement(F, {
      swiper: f.current,
      swiperSlideIndex: q
    }));
  }
  return /* @__PURE__ */ Fe.createElement(s, br({
    ref: u,
    className: Qu(`${h}${t ? ` ${t}` : ""}`)
  }, T), /* @__PURE__ */ Fe.createElement(GU.Provider, {
    value: f.current
  }, N["container-start"], /* @__PURE__ */ Fe.createElement(r, {
    className: LU(R.wrapperClass)
  }, N["wrapper-start"], j(), N["wrapper-end"]), Yu(R) && /* @__PURE__ */ Fe.createElement(Fe.Fragment, null, /* @__PURE__ */ Fe.createElement("div", {
    ref: x,
    className: "swiper-button-prev"
  }), /* @__PURE__ */ Fe.createElement("div", {
    ref: S,
    className: "swiper-button-next"
  })), Zu(R) && /* @__PURE__ */ Fe.createElement("div", {
    ref: k,
    className: "swiper-scrollbar"
  }), Ju(R) && /* @__PURE__ */ Fe.createElement("div", {
    ref: E,
    className: "swiper-pagination"
  }), N["container-end"]));
});
$u.displayName = "Swiper";
const ed = /* @__PURE__ */ su(function(n, e) {
  let {
    tag: t = "div",
    children: s,
    className: r = "",
    swiper: a,
    zoom: c,
    lazy: l,
    virtualIndex: d,
    swiperSlideIndex: h,
    ...m
  } = n === void 0 ? {} : n;
  const y = Re(null), [b, v] = X("swiper-slide"), [w, o] = X(!1);
  function u(S, x, E) {
    x === y.current && v(E);
  }
  Qn(() => {
    if (typeof h < "u" && (y.current.swiperSlideIndex = h), e && (e.current = y.current), !(!y.current || !a)) {
      if (a.destroyed) {
        b !== "swiper-slide" && v("swiper-slide");
        return;
      }
      return a.on("_slideClass", u), () => {
        a && a.off("_slideClass", u);
      };
    }
  }), Qn(() => {
    a && y.current && !a.destroyed && v(a.getSlideClasses(y.current));
  }, [a]);
  const f = {
    isActive: b.indexOf("swiper-slide-active") >= 0,
    isVisible: b.indexOf("swiper-slide-visible") >= 0,
    isPrev: b.indexOf("swiper-slide-prev") >= 0,
    isNext: b.indexOf("swiper-slide-next") >= 0
  }, p = () => typeof s == "function" ? s(f) : s, g = () => {
    o(!0);
  };
  return /* @__PURE__ */ Fe.createElement(t, br({
    ref: y,
    className: Qu(`${b}${r ? ` ${r}` : ""}`),
    "data-swiper-slide-index": d,
    onLoad: g
  }, m), c && /* @__PURE__ */ Fe.createElement(jl.Provider, {
    value: f
  }, /* @__PURE__ */ Fe.createElement("div", {
    className: "swiper-zoom-container",
    "data-swiper-zoom": typeof c == "number" ? c : void 0
  }, p(), l && !w && /* @__PURE__ */ Fe.createElement("div", {
    className: "swiper-lazy-preloader"
  }))), !c && /* @__PURE__ */ Fe.createElement(jl.Provider, {
    value: f
  }, p(), l && !w && /* @__PURE__ */ Fe.createElement("div", {
    className: "swiper-lazy-preloader"
  })));
});
ed.displayName = "SwiperSlide";
function WU(n) {
  let {
    swiper: e,
    extendParams: t,
    on: s,
    emit: r
  } = n;
  t({
    virtual: {
      enabled: !1,
      slides: [],
      cache: !0,
      renderSlide: null,
      renderExternal: null,
      renderExternalUpdate: !0,
      addSlidesBefore: 0,
      addSlidesAfter: 0
    }
  });
  let a;
  const c = si();
  e.virtual = {
    cache: {},
    from: void 0,
    to: void 0,
    slides: [],
    offset: 0,
    slidesGrid: []
  };
  const l = c.createElement("div");
  function d(w, o) {
    const u = e.params.virtual;
    if (u.cache && e.virtual.cache[o])
      return e.virtual.cache[o];
    let f;
    return u.renderSlide ? (f = u.renderSlide.call(e, w, o), typeof f == "string" && (l.innerHTML = f, f = l.children[0])) : e.isElement ? f = Li("swiper-slide") : f = Li("div", e.params.slideClass), f.setAttribute("data-swiper-slide-index", o), u.renderSlide || (f.innerHTML = w), u.cache && (e.virtual.cache[o] = f), f;
  }
  function h(w, o) {
    const {
      slidesPerView: u,
      slidesPerGroup: f,
      centeredSlides: p,
      loop: g,
      initialSlide: S
    } = e.params;
    if (o && !g && S > 0)
      return;
    const {
      addSlidesBefore: x,
      addSlidesAfter: E
    } = e.params.virtual, {
      from: k,
      to: R,
      slides: O,
      slidesGrid: T,
      offset: D
    } = e.virtual;
    e.params.cssMode || e.updateActiveIndex();
    const P = e.activeIndex || 0;
    let N;
    e.rtlTranslate ? N = "right" : N = e.isHorizontal() ? "left" : "top";
    let I, C;
    p ? (I = Math.floor(u / 2) + f + E, C = Math.floor(u / 2) + f + x) : (I = u + (f - 1) + E, C = (g ? u : f) + x);
    let U = P - C, z = P + I;
    g || (U = Math.max(U, 0), z = Math.min(z, O.length - 1));
    let j = (e.slidesGrid[U] || 0) - (e.slidesGrid[0] || 0);
    g && P >= C ? (U -= C, p || (j += e.slidesGrid[0])) : g && P < C && (U = -C, p && (j += e.slidesGrid[0])), Object.assign(e.virtual, {
      from: U,
      to: z,
      offset: j,
      slidesGrid: e.slidesGrid,
      slidesBefore: C,
      slidesAfter: I
    });
    function F() {
      e.updateSlides(), e.updateProgress(), e.updateSlidesClasses(), r("virtualUpdate");
    }
    if (k === U && R === z && !w) {
      e.slidesGrid !== T && j !== D && e.slides.forEach((M) => {
        M.style[N] = `${j - Math.abs(e.cssOverflowAdjustment())}px`;
      }), e.updateProgress(), r("virtualUpdate");
      return;
    }
    if (e.params.virtual.renderExternal) {
      e.params.virtual.renderExternal.call(e, {
        offset: j,
        from: U,
        to: z,
        slides: function() {
          const te = [];
          for (let ce = U; ce <= z; ce += 1)
            te.push(O[ce]);
          return te;
        }()
      }), e.params.virtual.renderExternalUpdate ? F() : r("virtualUpdate");
      return;
    }
    const q = [], W = [], K = (M) => {
      let te = M;
      return M < 0 ? te = O.length + M : te >= O.length && (te = te - O.length), te;
    };
    if (w)
      e.slides.filter((M) => M.matches(`.${e.params.slideClass}, swiper-slide`)).forEach((M) => {
        M.remove();
      });
    else
      for (let M = k; M <= R; M += 1)
        if (M < U || M > z) {
          const te = K(M);
          e.slides.filter((ce) => ce.matches(`.${e.params.slideClass}[data-swiper-slide-index="${te}"], swiper-slide[data-swiper-slide-index="${te}"]`)).forEach((ce) => {
            ce.remove();
          });
        }
    const Q = g ? -O.length : 0, G = g ? O.length * 2 : O.length;
    for (let M = Q; M < G; M += 1)
      if (M >= U && M <= z) {
        const te = K(M);
        typeof R > "u" || w ? W.push(te) : (M > R && W.push(te), M < k && q.push(te));
      }
    if (W.forEach((M) => {
      e.slidesEl.append(d(O[M], M));
    }), g)
      for (let M = q.length - 1; M >= 0; M -= 1) {
        const te = q[M];
        e.slidesEl.prepend(d(O[te], te));
      }
    else
      q.sort((M, te) => te - M), q.forEach((M) => {
        e.slidesEl.prepend(d(O[M], M));
      });
    ti(e.slidesEl, ".swiper-slide, swiper-slide").forEach((M) => {
      M.style[N] = `${j - Math.abs(e.cssOverflowAdjustment())}px`;
    }), F();
  }
  function m(w) {
    if (typeof w == "object" && "length" in w)
      for (let o = 0; o < w.length; o += 1)
        w[o] && e.virtual.slides.push(w[o]);
    else
      e.virtual.slides.push(w);
    h(!0);
  }
  function y(w) {
    const o = e.activeIndex;
    let u = o + 1, f = 1;
    if (Array.isArray(w)) {
      for (let p = 0; p < w.length; p += 1)
        w[p] && e.virtual.slides.unshift(w[p]);
      u = o + w.length, f = w.length;
    } else
      e.virtual.slides.unshift(w);
    if (e.params.virtual.cache) {
      const p = e.virtual.cache, g = {};
      Object.keys(p).forEach((S) => {
        const x = p[S], E = x.getAttribute("data-swiper-slide-index");
        E && x.setAttribute("data-swiper-slide-index", parseInt(E, 10) + f), g[parseInt(S, 10) + f] = x;
      }), e.virtual.cache = g;
    }
    h(!0), e.slideTo(u, 0);
  }
  function b(w) {
    if (typeof w > "u" || w === null)
      return;
    let o = e.activeIndex;
    if (Array.isArray(w))
      for (let u = w.length - 1; u >= 0; u -= 1)
        e.params.virtual.cache && (delete e.virtual.cache[w[u]], Object.keys(e.virtual.cache).forEach((f) => {
          f > w && (e.virtual.cache[f - 1] = e.virtual.cache[f], e.virtual.cache[f - 1].setAttribute("data-swiper-slide-index", f - 1), delete e.virtual.cache[f]);
        })), e.virtual.slides.splice(w[u], 1), w[u] < o && (o -= 1), o = Math.max(o, 0);
    else
      e.params.virtual.cache && (delete e.virtual.cache[w], Object.keys(e.virtual.cache).forEach((u) => {
        u > w && (e.virtual.cache[u - 1] = e.virtual.cache[u], e.virtual.cache[u - 1].setAttribute("data-swiper-slide-index", u - 1), delete e.virtual.cache[u]);
      })), e.virtual.slides.splice(w, 1), w < o && (o -= 1), o = Math.max(o, 0);
    h(!0), e.slideTo(o, 0);
  }
  function v() {
    e.virtual.slides = [], e.params.virtual.cache && (e.virtual.cache = {}), h(!0), e.slideTo(0, 0);
  }
  s("beforeInit", () => {
    if (!e.params.virtual.enabled)
      return;
    let w;
    if (typeof e.passedParams.virtual.slides > "u") {
      const o = [...e.slidesEl.children].filter((u) => u.matches(`.${e.params.slideClass}, swiper-slide`));
      o && o.length && (e.virtual.slides = [...o], w = !0, o.forEach((u, f) => {
        u.setAttribute("data-swiper-slide-index", f), e.virtual.cache[f] = u, u.remove();
      }));
    }
    w || (e.virtual.slides = e.params.virtual.slides), e.classNames.push(`${e.params.containerModifierClass}virtual`), e.params.watchSlidesProgress = !0, e.originalParams.watchSlidesProgress = !0, h(!1, !0);
  }), s("setTranslate", () => {
    e.params.virtual.enabled && (e.params.cssMode && !e._immediateVirtual ? (clearTimeout(a), a = setTimeout(() => {
      h();
    }, 100)) : h());
  }), s("init update resize", () => {
    e.params.virtual.enabled && e.params.cssMode && Hn(e.wrapperEl, "--swiper-virtual-size", `${e.virtualSize}px`);
  }), Object.assign(e.virtual, {
    appendSlide: m,
    prependSlide: y,
    removeSlide: b,
    removeAllSlides: v,
    update: h
  });
}
function pa(n, e, t, s) {
  return n.params.createElements && Object.keys(s).forEach((r) => {
    if (!t[r] && t.auto === !0) {
      let a = ti(n.el, `.${s[r]}`)[0];
      a || (a = Li("div", s[r]), a.className = s[r], n.el.append(a)), t[r] = a, e[r] = a;
    }
  }), t;
}
function KU(n) {
  let {
    swiper: e,
    extendParams: t,
    on: s,
    emit: r
  } = n;
  t({
    navigation: {
      nextEl: null,
      prevEl: null,
      hideOnClick: !1,
      disabledClass: "swiper-button-disabled",
      hiddenClass: "swiper-button-hidden",
      lockClass: "swiper-button-lock",
      navigationDisabledClass: "swiper-navigation-disabled"
    }
  }), e.navigation = {
    nextEl: null,
    prevEl: null
  };
  function a(w) {
    let o;
    return w && typeof w == "string" && e.isElement && (o = e.el.querySelector(w) || e.hostEl.querySelector(w), o) ? o : (w && (typeof w == "string" && (o = [...document.querySelectorAll(w)]), e.params.uniqueNavElements && typeof w == "string" && o && o.length > 1 && e.el.querySelectorAll(w).length === 1 ? o = e.el.querySelector(w) : o && o.length === 1 && (o = o[0])), w && !o ? w : o);
  }
  function c(w, o) {
    const u = e.params.navigation;
    w = Be(w), w.forEach((f) => {
      f && (f.classList[o ? "add" : "remove"](...u.disabledClass.split(" ")), f.tagName === "BUTTON" && (f.disabled = o), e.params.watchOverflow && e.enabled && f.classList[e.isLocked ? "add" : "remove"](u.lockClass));
    });
  }
  function l() {
    const {
      nextEl: w,
      prevEl: o
    } = e.navigation;
    if (e.params.loop) {
      c(o, !1), c(w, !1);
      return;
    }
    c(o, e.isBeginning && !e.params.rewind), c(w, e.isEnd && !e.params.rewind);
  }
  function d(w) {
    w.preventDefault(), !(e.isBeginning && !e.params.loop && !e.params.rewind) && (e.slidePrev(), r("navigationPrev"));
  }
  function h(w) {
    w.preventDefault(), !(e.isEnd && !e.params.loop && !e.params.rewind) && (e.slideNext(), r("navigationNext"));
  }
  function m() {
    const w = e.params.navigation;
    if (e.params.navigation = pa(e, e.originalParams.navigation, e.params.navigation, {
      nextEl: "swiper-button-next",
      prevEl: "swiper-button-prev"
    }), !(w.nextEl || w.prevEl))
      return;
    let o = a(w.nextEl), u = a(w.prevEl);
    Object.assign(e.navigation, {
      nextEl: o,
      prevEl: u
    }), o = Be(o), u = Be(u);
    const f = (p, g) => {
      p && p.addEventListener("click", g === "next" ? h : d), !e.enabled && p && p.classList.add(...w.lockClass.split(" "));
    };
    o.forEach((p) => f(p, "next")), u.forEach((p) => f(p, "prev"));
  }
  function y() {
    let {
      nextEl: w,
      prevEl: o
    } = e.navigation;
    w = Be(w), o = Be(o);
    const u = (f, p) => {
      f.removeEventListener("click", p === "next" ? h : d), f.classList.remove(...e.params.navigation.disabledClass.split(" "));
    };
    w.forEach((f) => u(f, "next")), o.forEach((f) => u(f, "prev"));
  }
  s("init", () => {
    e.params.navigation.enabled === !1 ? v() : (m(), l());
  }), s("toEdge fromEdge lock unlock", () => {
    l();
  }), s("destroy", () => {
    y();
  }), s("enable disable", () => {
    let {
      nextEl: w,
      prevEl: o
    } = e.navigation;
    if (w = Be(w), o = Be(o), e.enabled) {
      l();
      return;
    }
    [...w, ...o].filter((u) => !!u).forEach((u) => u.classList.add(e.params.navigation.lockClass));
  }), s("click", (w, o) => {
    let {
      nextEl: u,
      prevEl: f
    } = e.navigation;
    u = Be(u), f = Be(f);
    const p = o.target;
    let g = f.includes(p) || u.includes(p);
    if (e.isElement && !g) {
      const S = o.path || o.composedPath && o.composedPath();
      S && (g = S.find((x) => u.includes(x) || f.includes(x)));
    }
    if (e.params.navigation.hideOnClick && !g) {
      if (e.pagination && e.params.pagination && e.params.pagination.clickable && (e.pagination.el === p || e.pagination.el.contains(p)))
        return;
      let S;
      u.length ? S = u[0].classList.contains(e.params.navigation.hiddenClass) : f.length && (S = f[0].classList.contains(e.params.navigation.hiddenClass)), r(S === !0 ? "navigationShow" : "navigationHide"), [...u, ...f].filter((x) => !!x).forEach((x) => x.classList.toggle(e.params.navigation.hiddenClass));
    }
  });
  const b = () => {
    e.el.classList.remove(...e.params.navigation.navigationDisabledClass.split(" ")), m(), l();
  }, v = () => {
    e.el.classList.add(...e.params.navigation.navigationDisabledClass.split(" ")), y();
  };
  Object.assign(e.navigation, {
    enable: b,
    disable: v,
    update: l,
    init: m,
    destroy: y
  });
}
function bi(n) {
  return n === void 0 && (n = ""), `.${n.trim().replace(/([\.:!+\/])/g, "\\$1").replace(/ /g, ".")}`;
}
function YU(n) {
  let {
    swiper: e,
    extendParams: t,
    on: s,
    emit: r
  } = n;
  const a = "swiper-pagination";
  t({
    pagination: {
      el: null,
      bulletElement: "span",
      clickable: !1,
      hideOnClick: !1,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: !1,
      type: "bullets",
      // 'bullets' or 'progressbar' or 'fraction' or 'custom'
      dynamicBullets: !1,
      dynamicMainBullets: 1,
      formatFractionCurrent: (p) => p,
      formatFractionTotal: (p) => p,
      bulletClass: `${a}-bullet`,
      bulletActiveClass: `${a}-bullet-active`,
      modifierClass: `${a}-`,
      currentClass: `${a}-current`,
      totalClass: `${a}-total`,
      hiddenClass: `${a}-hidden`,
      progressbarFillClass: `${a}-progressbar-fill`,
      progressbarOppositeClass: `${a}-progressbar-opposite`,
      clickableClass: `${a}-clickable`,
      lockClass: `${a}-lock`,
      horizontalClass: `${a}-horizontal`,
      verticalClass: `${a}-vertical`,
      paginationDisabledClass: `${a}-disabled`
    }
  }), e.pagination = {
    el: null,
    bullets: []
  };
  let c, l = 0;
  function d() {
    return !e.params.pagination.el || !e.pagination.el || Array.isArray(e.pagination.el) && e.pagination.el.length === 0;
  }
  function h(p, g) {
    const {
      bulletActiveClass: S
    } = e.params.pagination;
    p && (p = p[`${g === "prev" ? "previous" : "next"}ElementSibling`], p && (p.classList.add(`${S}-${g}`), p = p[`${g === "prev" ? "previous" : "next"}ElementSibling`], p && p.classList.add(`${S}-${g}-${g}`)));
  }
  function m(p, g, S) {
    if (p = p % S, g = g % S, g === p + 1)
      return "next";
    if (g === p - 1)
      return "previous";
  }
  function y(p) {
    const g = p.target.closest(bi(e.params.pagination.bulletClass));
    if (!g)
      return;
    p.preventDefault();
    const S = os(g) * e.params.slidesPerGroup;
    if (e.params.loop) {
      if (e.realIndex === S)
        return;
      const x = m(e.realIndex, S, e.slides.length);
      x === "next" ? e.slideNext() : x === "previous" ? e.slidePrev() : e.slideToLoop(S);
    } else
      e.slideTo(S);
  }
  function b() {
    const p = e.rtl, g = e.params.pagination;
    if (d())
      return;
    let S = e.pagination.el;
    S = Be(S);
    let x, E;
    const k = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.slides.length, R = e.params.loop ? Math.ceil(k / e.params.slidesPerGroup) : e.snapGrid.length;
    if (e.params.loop ? (E = e.previousRealIndex || 0, x = e.params.slidesPerGroup > 1 ? Math.floor(e.realIndex / e.params.slidesPerGroup) : e.realIndex) : typeof e.snapIndex < "u" ? (x = e.snapIndex, E = e.previousSnapIndex) : (E = e.previousIndex || 0, x = e.activeIndex || 0), g.type === "bullets" && e.pagination.bullets && e.pagination.bullets.length > 0) {
      const O = e.pagination.bullets;
      let T, D, P;
      if (g.dynamicBullets && (c = Fo(O[0], e.isHorizontal() ? "width" : "height", !0), S.forEach((N) => {
        N.style[e.isHorizontal() ? "width" : "height"] = `${c * (g.dynamicMainBullets + 4)}px`;
      }), g.dynamicMainBullets > 1 && E !== void 0 && (l += x - (E || 0), l > g.dynamicMainBullets - 1 ? l = g.dynamicMainBullets - 1 : l < 0 && (l = 0)), T = Math.max(x - l, 0), D = T + (Math.min(O.length, g.dynamicMainBullets) - 1), P = (D + T) / 2), O.forEach((N) => {
        const I = [...["", "-next", "-next-next", "-prev", "-prev-prev", "-main"].map((C) => `${g.bulletActiveClass}${C}`)].map((C) => typeof C == "string" && C.includes(" ") ? C.split(" ") : C).flat();
        N.classList.remove(...I);
      }), S.length > 1)
        O.forEach((N) => {
          const I = os(N);
          I === x ? N.classList.add(...g.bulletActiveClass.split(" ")) : e.isElement && N.setAttribute("part", "bullet"), g.dynamicBullets && (I >= T && I <= D && N.classList.add(...`${g.bulletActiveClass}-main`.split(" ")), I === T && h(N, "prev"), I === D && h(N, "next"));
        });
      else {
        const N = O[x];
        if (N && N.classList.add(...g.bulletActiveClass.split(" ")), e.isElement && O.forEach((I, C) => {
          I.setAttribute("part", C === x ? "bullet-active" : "bullet");
        }), g.dynamicBullets) {
          const I = O[T], C = O[D];
          for (let U = T; U <= D; U += 1)
            O[U] && O[U].classList.add(...`${g.bulletActiveClass}-main`.split(" "));
          h(I, "prev"), h(C, "next");
        }
      }
      if (g.dynamicBullets) {
        const N = Math.min(O.length, g.dynamicMainBullets + 4), I = (c * N - c) / 2 - P * c, C = p ? "right" : "left";
        O.forEach((U) => {
          U.style[e.isHorizontal() ? C : "top"] = `${I}px`;
        });
      }
    }
    S.forEach((O, T) => {
      if (g.type === "fraction" && (O.querySelectorAll(bi(g.currentClass)).forEach((D) => {
        D.textContent = g.formatFractionCurrent(x + 1);
      }), O.querySelectorAll(bi(g.totalClass)).forEach((D) => {
        D.textContent = g.formatFractionTotal(R);
      })), g.type === "progressbar") {
        let D;
        g.progressbarOpposite ? D = e.isHorizontal() ? "vertical" : "horizontal" : D = e.isHorizontal() ? "horizontal" : "vertical";
        const P = (x + 1) / R;
        let N = 1, I = 1;
        D === "horizontal" ? N = P : I = P, O.querySelectorAll(bi(g.progressbarFillClass)).forEach((C) => {
          C.style.transform = `translate3d(0,0,0) scaleX(${N}) scaleY(${I})`, C.style.transitionDuration = `${e.params.speed}ms`;
        });
      }
      g.type === "custom" && g.renderCustom ? (O.innerHTML = g.renderCustom(e, x + 1, R), T === 0 && r("paginationRender", O)) : (T === 0 && r("paginationRender", O), r("paginationUpdate", O)), e.params.watchOverflow && e.enabled && O.classList[e.isLocked ? "add" : "remove"](g.lockClass);
    });
  }
  function v() {
    const p = e.params.pagination;
    if (d())
      return;
    const g = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.grid && e.params.grid.rows > 1 ? e.slides.length / Math.ceil(e.params.grid.rows) : e.slides.length;
    let S = e.pagination.el;
    S = Be(S);
    let x = "";
    if (p.type === "bullets") {
      let E = e.params.loop ? Math.ceil(g / e.params.slidesPerGroup) : e.snapGrid.length;
      e.params.freeMode && e.params.freeMode.enabled && E > g && (E = g);
      for (let k = 0; k < E; k += 1)
        p.renderBullet ? x += p.renderBullet.call(e, k, p.bulletClass) : x += `<${p.bulletElement} ${e.isElement ? 'part="bullet"' : ""} class="${p.bulletClass}"></${p.bulletElement}>`;
    }
    p.type === "fraction" && (p.renderFraction ? x = p.renderFraction.call(e, p.currentClass, p.totalClass) : x = `<span class="${p.currentClass}"></span> / <span class="${p.totalClass}"></span>`), p.type === "progressbar" && (p.renderProgressbar ? x = p.renderProgressbar.call(e, p.progressbarFillClass) : x = `<span class="${p.progressbarFillClass}"></span>`), e.pagination.bullets = [], S.forEach((E) => {
      p.type !== "custom" && (E.innerHTML = x || ""), p.type === "bullets" && e.pagination.bullets.push(...E.querySelectorAll(bi(p.bulletClass)));
    }), p.type !== "custom" && r("paginationRender", S[0]);
  }
  function w() {
    e.params.pagination = pa(e, e.originalParams.pagination, e.params.pagination, {
      el: "swiper-pagination"
    });
    const p = e.params.pagination;
    if (!p.el)
      return;
    let g;
    typeof p.el == "string" && e.isElement && (g = e.el.querySelector(p.el)), !g && typeof p.el == "string" && (g = [...document.querySelectorAll(p.el)]), g || (g = p.el), !(!g || g.length === 0) && (e.params.uniqueNavElements && typeof p.el == "string" && Array.isArray(g) && g.length > 1 && (g = [...e.el.querySelectorAll(p.el)], g.length > 1 && (g = g.filter((S) => qu(S, ".swiper")[0] === e.el)[0])), Array.isArray(g) && g.length === 1 && (g = g[0]), Object.assign(e.pagination, {
      el: g
    }), g = Be(g), g.forEach((S) => {
      p.type === "bullets" && p.clickable && S.classList.add(...(p.clickableClass || "").split(" ")), S.classList.add(p.modifierClass + p.type), S.classList.add(e.isHorizontal() ? p.horizontalClass : p.verticalClass), p.type === "bullets" && p.dynamicBullets && (S.classList.add(`${p.modifierClass}${p.type}-dynamic`), l = 0, p.dynamicMainBullets < 1 && (p.dynamicMainBullets = 1)), p.type === "progressbar" && p.progressbarOpposite && S.classList.add(p.progressbarOppositeClass), p.clickable && S.addEventListener("click", y), e.enabled || S.classList.add(p.lockClass);
    }));
  }
  function o() {
    const p = e.params.pagination;
    if (d())
      return;
    let g = e.pagination.el;
    g && (g = Be(g), g.forEach((S) => {
      S.classList.remove(p.hiddenClass), S.classList.remove(p.modifierClass + p.type), S.classList.remove(e.isHorizontal() ? p.horizontalClass : p.verticalClass), p.clickable && (S.classList.remove(...(p.clickableClass || "").split(" ")), S.removeEventListener("click", y));
    })), e.pagination.bullets && e.pagination.bullets.forEach((S) => S.classList.remove(...p.bulletActiveClass.split(" ")));
  }
  s("changeDirection", () => {
    if (!e.pagination || !e.pagination.el)
      return;
    const p = e.params.pagination;
    let {
      el: g
    } = e.pagination;
    g = Be(g), g.forEach((S) => {
      S.classList.remove(p.horizontalClass, p.verticalClass), S.classList.add(e.isHorizontal() ? p.horizontalClass : p.verticalClass);
    });
  }), s("init", () => {
    e.params.pagination.enabled === !1 ? f() : (w(), v(), b());
  }), s("activeIndexChange", () => {
    typeof e.snapIndex > "u" && b();
  }), s("snapIndexChange", () => {
    b();
  }), s("snapGridLengthChange", () => {
    v(), b();
  }), s("destroy", () => {
    o();
  }), s("enable disable", () => {
    let {
      el: p
    } = e.pagination;
    p && (p = Be(p), p.forEach((g) => g.classList[e.enabled ? "remove" : "add"](e.params.pagination.lockClass)));
  }), s("lock unlock", () => {
    b();
  }), s("click", (p, g) => {
    const S = g.target, x = Be(e.pagination.el);
    if (e.params.pagination.el && e.params.pagination.hideOnClick && x && x.length > 0 && !S.classList.contains(e.params.pagination.bulletClass)) {
      if (e.navigation && (e.navigation.nextEl && S === e.navigation.nextEl || e.navigation.prevEl && S === e.navigation.prevEl))
        return;
      const E = x[0].classList.contains(e.params.pagination.hiddenClass);
      r(E === !0 ? "paginationShow" : "paginationHide"), x.forEach((k) => k.classList.toggle(e.params.pagination.hiddenClass));
    }
  });
  const u = () => {
    e.el.classList.remove(e.params.pagination.paginationDisabledClass);
    let {
      el: p
    } = e.pagination;
    p && (p = Be(p), p.forEach((g) => g.classList.remove(e.params.pagination.paginationDisabledClass))), w(), v(), b();
  }, f = () => {
    e.el.classList.add(e.params.pagination.paginationDisabledClass);
    let {
      el: p
    } = e.pagination;
    p && (p = Be(p), p.forEach((g) => g.classList.add(e.params.pagination.paginationDisabledClass))), o();
  };
  Object.assign(e.pagination, {
    enable: u,
    disable: f,
    render: v,
    update: b,
    init: w,
    destroy: o
  });
}
function JU(n) {
  let {
    swiper: e,
    extendParams: t,
    on: s,
    emit: r
  } = n;
  const a = si();
  let c = !1, l = null, d = null, h, m, y, b;
  t({
    scrollbar: {
      el: null,
      dragSize: "auto",
      hide: !1,
      draggable: !1,
      snapOnRelease: !0,
      lockClass: "swiper-scrollbar-lock",
      dragClass: "swiper-scrollbar-drag",
      scrollbarDisabledClass: "swiper-scrollbar-disabled",
      horizontalClass: "swiper-scrollbar-horizontal",
      verticalClass: "swiper-scrollbar-vertical"
    }
  }), e.scrollbar = {
    el: null,
    dragEl: null
  };
  function v() {
    if (!e.params.scrollbar.el || !e.scrollbar.el)
      return;
    const {
      scrollbar: P,
      rtlTranslate: N
    } = e, {
      dragEl: I,
      el: C
    } = P, U = e.params.scrollbar, z = e.params.loop ? e.progressLoop : e.progress;
    let j = m, F = (y - m) * z;
    N ? (F = -F, F > 0 ? (j = m - F, F = 0) : -F + m > y && (j = y + F)) : F < 0 ? (j = m + F, F = 0) : F + m > y && (j = y - F), e.isHorizontal() ? (I.style.transform = `translate3d(${F}px, 0, 0)`, I.style.width = `${j}px`) : (I.style.transform = `translate3d(0px, ${F}px, 0)`, I.style.height = `${j}px`), U.hide && (clearTimeout(l), C.style.opacity = 1, l = setTimeout(() => {
      C.style.opacity = 0, C.style.transitionDuration = "400ms";
    }, 1e3));
  }
  function w(P) {
    !e.params.scrollbar.el || !e.scrollbar.el || (e.scrollbar.dragEl.style.transitionDuration = `${P}ms`);
  }
  function o() {
    if (!e.params.scrollbar.el || !e.scrollbar.el)
      return;
    const {
      scrollbar: P
    } = e, {
      dragEl: N,
      el: I
    } = P;
    N.style.width = "", N.style.height = "", y = e.isHorizontal() ? I.offsetWidth : I.offsetHeight, b = e.size / (e.virtualSize + e.params.slidesOffsetBefore - (e.params.centeredSlides ? e.snapGrid[0] : 0)), e.params.scrollbar.dragSize === "auto" ? m = y * b : m = parseInt(e.params.scrollbar.dragSize, 10), e.isHorizontal() ? N.style.width = `${m}px` : N.style.height = `${m}px`, b >= 1 ? I.style.display = "none" : I.style.display = "", e.params.scrollbar.hide && (I.style.opacity = 0), e.params.watchOverflow && e.enabled && P.el.classList[e.isLocked ? "add" : "remove"](e.params.scrollbar.lockClass);
  }
  function u(P) {
    return e.isHorizontal() ? P.clientX : P.clientY;
  }
  function f(P) {
    const {
      scrollbar: N,
      rtlTranslate: I
    } = e, {
      el: C
    } = N;
    let U;
    U = (u(P) - AI(C)[e.isHorizontal() ? "left" : "top"] - (h !== null ? h : m / 2)) / (y - m), U = Math.max(Math.min(U, 1), 0), I && (U = 1 - U);
    const z = e.minTranslate() + (e.maxTranslate() - e.minTranslate()) * U;
    e.updateProgress(z), e.setTranslate(z), e.updateActiveIndex(), e.updateSlidesClasses();
  }
  function p(P) {
    const N = e.params.scrollbar, {
      scrollbar: I,
      wrapperEl: C
    } = e, {
      el: U,
      dragEl: z
    } = I;
    c = !0, h = P.target === z ? u(P) - P.target.getBoundingClientRect()[e.isHorizontal() ? "left" : "top"] : null, P.preventDefault(), P.stopPropagation(), C.style.transitionDuration = "100ms", z.style.transitionDuration = "100ms", f(P), clearTimeout(d), U.style.transitionDuration = "0ms", N.hide && (U.style.opacity = 1), e.params.cssMode && (e.wrapperEl.style["scroll-snap-type"] = "none"), r("scrollbarDragStart", P);
  }
  function g(P) {
    const {
      scrollbar: N,
      wrapperEl: I
    } = e, {
      el: C,
      dragEl: U
    } = N;
    c && (P.preventDefault && P.cancelable ? P.preventDefault() : P.returnValue = !1, f(P), I.style.transitionDuration = "0ms", C.style.transitionDuration = "0ms", U.style.transitionDuration = "0ms", r("scrollbarDragMove", P));
  }
  function S(P) {
    const N = e.params.scrollbar, {
      scrollbar: I,
      wrapperEl: C
    } = e, {
      el: U
    } = I;
    c && (c = !1, e.params.cssMode && (e.wrapperEl.style["scroll-snap-type"] = "", C.style.transitionDuration = ""), N.hide && (clearTimeout(d), d = gr(() => {
      U.style.opacity = 0, U.style.transitionDuration = "400ms";
    }, 1e3)), r("scrollbarDragEnd", P), N.snapOnRelease && e.slideToClosest());
  }
  function x(P) {
    const {
      scrollbar: N,
      params: I
    } = e, C = N.el;
    if (!C)
      return;
    const U = C, z = I.passiveListeners ? {
      passive: !1,
      capture: !1
    } : !1, j = I.passiveListeners ? {
      passive: !0,
      capture: !1
    } : !1;
    if (!U)
      return;
    const F = P === "on" ? "addEventListener" : "removeEventListener";
    U[F]("pointerdown", p, z), a[F]("pointermove", g, z), a[F]("pointerup", S, j);
  }
  function E() {
    !e.params.scrollbar.el || !e.scrollbar.el || x("on");
  }
  function k() {
    !e.params.scrollbar.el || !e.scrollbar.el || x("off");
  }
  function R() {
    const {
      scrollbar: P,
      el: N
    } = e;
    e.params.scrollbar = pa(e, e.originalParams.scrollbar, e.params.scrollbar, {
      el: "swiper-scrollbar"
    });
    const I = e.params.scrollbar;
    if (!I.el)
      return;
    let C;
    if (typeof I.el == "string" && e.isElement && (C = e.el.querySelector(I.el)), !C && typeof I.el == "string") {
      if (C = a.querySelectorAll(I.el), !C.length)
        return;
    } else
      C || (C = I.el);
    e.params.uniqueNavElements && typeof I.el == "string" && C.length > 1 && N.querySelectorAll(I.el).length === 1 && (C = N.querySelector(I.el)), C.length > 0 && (C = C[0]), C.classList.add(e.isHorizontal() ? I.horizontalClass : I.verticalClass);
    let U;
    C && (U = C.querySelector(bi(e.params.scrollbar.dragClass)), U || (U = Li("div", e.params.scrollbar.dragClass), C.append(U))), Object.assign(P, {
      el: C,
      dragEl: U
    }), I.draggable && E(), C && C.classList[e.enabled ? "remove" : "add"](...Oi(e.params.scrollbar.lockClass));
  }
  function O() {
    const P = e.params.scrollbar, N = e.scrollbar.el;
    N && N.classList.remove(...Oi(e.isHorizontal() ? P.horizontalClass : P.verticalClass)), k();
  }
  s("changeDirection", () => {
    if (!e.scrollbar || !e.scrollbar.el)
      return;
    const P = e.params.scrollbar;
    let {
      el: N
    } = e.scrollbar;
    N = Be(N), N.forEach((I) => {
      I.classList.remove(P.horizontalClass, P.verticalClass), I.classList.add(e.isHorizontal() ? P.horizontalClass : P.verticalClass);
    });
  }), s("init", () => {
    e.params.scrollbar.enabled === !1 ? D() : (R(), o(), v());
  }), s("update resize observerUpdate lock unlock changeDirection", () => {
    o();
  }), s("setTranslate", () => {
    v();
  }), s("setTransition", (P, N) => {
    w(N);
  }), s("enable disable", () => {
    const {
      el: P
    } = e.scrollbar;
    P && P.classList[e.enabled ? "remove" : "add"](...Oi(e.params.scrollbar.lockClass));
  }), s("destroy", () => {
    O();
  });
  const T = () => {
    e.el.classList.remove(...Oi(e.params.scrollbar.scrollbarDisabledClass)), e.scrollbar.el && e.scrollbar.el.classList.remove(...Oi(e.params.scrollbar.scrollbarDisabledClass)), R(), o(), v();
  }, D = () => {
    e.el.classList.add(...Oi(e.params.scrollbar.scrollbarDisabledClass)), e.scrollbar.el && e.scrollbar.el.classList.add(...Oi(e.params.scrollbar.scrollbarDisabledClass)), O();
  };
  Object.assign(e.scrollbar, {
    enable: T,
    disable: D,
    updateSize: o,
    setTranslate: v,
    init: R,
    destroy: O
  });
}
function ZU(n) {
  let {
    swiper: e,
    extendParams: t,
    on: s
  } = n;
  t({
    a11y: {
      enabled: !0,
      notificationClass: "swiper-notification",
      prevSlideMessage: "Previous slide",
      nextSlideMessage: "Next slide",
      firstSlideMessage: "This is the first slide",
      lastSlideMessage: "This is the last slide",
      paginationBulletMessage: "Go to slide {{index}}",
      slideLabelMessage: "{{index}} / {{slidesLength}}",
      containerMessage: null,
      containerRoleDescriptionMessage: null,
      containerRole: null,
      itemRoleDescriptionMessage: null,
      slideRole: "group",
      id: null,
      scrollOnFocus: !0
    }
  }), e.a11y = {
    clicked: !1
  };
  let r = null, a, c, l = (/* @__PURE__ */ new Date()).getTime();
  function d(z) {
    const j = r;
    j.length !== 0 && (j.innerHTML = "", j.innerHTML = z);
  }
  function h(z) {
    z === void 0 && (z = 16);
    const j = () => Math.round(16 * Math.random()).toString(16);
    return "x".repeat(z).replace(/x/g, j);
  }
  function m(z) {
    z = Be(z), z.forEach((j) => {
      j.setAttribute("tabIndex", "0");
    });
  }
  function y(z) {
    z = Be(z), z.forEach((j) => {
      j.setAttribute("tabIndex", "-1");
    });
  }
  function b(z, j) {
    z = Be(z), z.forEach((F) => {
      F.setAttribute("role", j);
    });
  }
  function v(z, j) {
    z = Be(z), z.forEach((F) => {
      F.setAttribute("aria-roledescription", j);
    });
  }
  function w(z, j) {
    z = Be(z), z.forEach((F) => {
      F.setAttribute("aria-controls", j);
    });
  }
  function o(z, j) {
    z = Be(z), z.forEach((F) => {
      F.setAttribute("aria-label", j);
    });
  }
  function u(z, j) {
    z = Be(z), z.forEach((F) => {
      F.setAttribute("id", j);
    });
  }
  function f(z, j) {
    z = Be(z), z.forEach((F) => {
      F.setAttribute("aria-live", j);
    });
  }
  function p(z) {
    z = Be(z), z.forEach((j) => {
      j.setAttribute("aria-disabled", !0);
    });
  }
  function g(z) {
    z = Be(z), z.forEach((j) => {
      j.setAttribute("aria-disabled", !1);
    });
  }
  function S(z) {
    if (z.keyCode !== 13 && z.keyCode !== 32)
      return;
    const j = e.params.a11y, F = z.target;
    if (!(e.pagination && e.pagination.el && (F === e.pagination.el || e.pagination.el.contains(z.target)) && !z.target.matches(bi(e.params.pagination.bulletClass)))) {
      if (e.navigation && e.navigation.prevEl && e.navigation.nextEl) {
        const q = Be(e.navigation.prevEl);
        Be(e.navigation.nextEl).includes(F) && (e.isEnd && !e.params.loop || e.slideNext(), e.isEnd ? d(j.lastSlideMessage) : d(j.nextSlideMessage)), q.includes(F) && (e.isBeginning && !e.params.loop || e.slidePrev(), e.isBeginning ? d(j.firstSlideMessage) : d(j.prevSlideMessage));
      }
      e.pagination && F.matches(bi(e.params.pagination.bulletClass)) && F.click();
    }
  }
  function x() {
    if (e.params.loop || e.params.rewind || !e.navigation)
      return;
    const {
      nextEl: z,
      prevEl: j
    } = e.navigation;
    j && (e.isBeginning ? (p(j), y(j)) : (g(j), m(j))), z && (e.isEnd ? (p(z), y(z)) : (g(z), m(z)));
  }
  function E() {
    return e.pagination && e.pagination.bullets && e.pagination.bullets.length;
  }
  function k() {
    return E() && e.params.pagination.clickable;
  }
  function R() {
    const z = e.params.a11y;
    E() && e.pagination.bullets.forEach((j) => {
      e.params.pagination.clickable && (m(j), e.params.pagination.renderBullet || (b(j, "button"), o(j, z.paginationBulletMessage.replace(/\{\{index\}\}/, os(j) + 1)))), j.matches(bi(e.params.pagination.bulletActiveClass)) ? j.setAttribute("aria-current", "true") : j.removeAttribute("aria-current");
    });
  }
  const O = (z, j, F) => {
    m(z), z.tagName !== "BUTTON" && (b(z, "button"), z.addEventListener("keydown", S)), o(z, F), w(z, j);
  }, T = (z) => {
    c && c !== z.target && !c.contains(z.target) && (a = !0), e.a11y.clicked = !0;
  }, D = () => {
    a = !1, requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        e.destroyed || (e.a11y.clicked = !1);
      });
    });
  }, P = (z) => {
    l = (/* @__PURE__ */ new Date()).getTime();
  }, N = (z) => {
    if (e.a11y.clicked || !e.params.a11y.scrollOnFocus || (/* @__PURE__ */ new Date()).getTime() - l < 100)
      return;
    const j = z.target.closest(`.${e.params.slideClass}, swiper-slide`);
    if (!j || !e.slides.includes(j))
      return;
    c = j;
    const F = e.slides.indexOf(j) === e.activeIndex, q = e.params.watchSlidesProgress && e.visibleSlides && e.visibleSlides.includes(j);
    F || q || z.sourceCapabilities && z.sourceCapabilities.firesTouchEvents || (e.isHorizontal() ? e.el.scrollLeft = 0 : e.el.scrollTop = 0, requestAnimationFrame(() => {
      a || (e.params.loop ? e.slideToLoop(parseInt(j.getAttribute("data-swiper-slide-index")), 0) : e.slideTo(e.slides.indexOf(j), 0), a = !1);
    }));
  }, I = () => {
    const z = e.params.a11y;
    z.itemRoleDescriptionMessage && v(e.slides, z.itemRoleDescriptionMessage), z.slideRole && b(e.slides, z.slideRole);
    const j = e.slides.length;
    z.slideLabelMessage && e.slides.forEach((F, q) => {
      const W = e.params.loop ? parseInt(F.getAttribute("data-swiper-slide-index"), 10) : q, K = z.slideLabelMessage.replace(/\{\{index\}\}/, W + 1).replace(/\{\{slidesLength\}\}/, j);
      o(F, K);
    });
  }, C = () => {
    const z = e.params.a11y;
    e.el.append(r);
    const j = e.el;
    z.containerRoleDescriptionMessage && v(j, z.containerRoleDescriptionMessage), z.containerMessage && o(j, z.containerMessage), z.containerRole && b(j, z.containerRole);
    const F = e.wrapperEl, q = z.id || F.getAttribute("id") || `swiper-wrapper-${h(16)}`, W = e.params.autoplay && e.params.autoplay.enabled ? "off" : "polite";
    u(F, q), f(F, W), I();
    let {
      nextEl: K,
      prevEl: Q
    } = e.navigation ? e.navigation : {};
    K = Be(K), Q = Be(Q), K && K.forEach((M) => O(M, q, z.nextSlideMessage)), Q && Q.forEach((M) => O(M, q, z.prevSlideMessage)), k() && Be(e.pagination.el).forEach((te) => {
      te.addEventListener("keydown", S);
    }), si().addEventListener("visibilitychange", P), e.el.addEventListener("focus", N, !0), e.el.addEventListener("focus", N, !0), e.el.addEventListener("pointerdown", T, !0), e.el.addEventListener("pointerup", D, !0);
  };
  function U() {
    r && r.remove();
    let {
      nextEl: z,
      prevEl: j
    } = e.navigation ? e.navigation : {};
    z = Be(z), j = Be(j), z && z.forEach((q) => q.removeEventListener("keydown", S)), j && j.forEach((q) => q.removeEventListener("keydown", S)), k() && Be(e.pagination.el).forEach((W) => {
      W.removeEventListener("keydown", S);
    }), si().removeEventListener("visibilitychange", P), e.el && typeof e.el != "string" && (e.el.removeEventListener("focus", N, !0), e.el.removeEventListener("pointerdown", T, !0), e.el.removeEventListener("pointerup", D, !0));
  }
  s("beforeInit", () => {
    r = Li("span", e.params.a11y.notificationClass), r.setAttribute("aria-live", "assertive"), r.setAttribute("aria-atomic", "true");
  }), s("afterInit", () => {
    e.params.a11y.enabled && C();
  }), s("slidesLengthChange snapGridLengthChange slidesGridLengthChange", () => {
    e.params.a11y.enabled && I();
  }), s("fromEdge toEdge afterInit lock unlock", () => {
    e.params.a11y.enabled && x();
  }), s("paginationUpdate", () => {
    e.params.a11y.enabled && R();
  }), s("destroy", () => {
    e.params.a11y.enabled && U();
  });
}
const G2 = ({
  slides: n = [],
  slidesPerView: e = 1,
  spaceBetween: t = 0,
  onSwiper: s,
  onSlideChange: r,
  centeredSlides: a = !1,
  showArrows: c = !1,
  showPagination: l = !1,
  effect: d = "slide"
}) => /* @__PURE__ */ A.jsx(
  $u,
  {
    modules: [KU, YU, JU, ZU, WU],
    spaceBetween: t,
    slidesPerView: e,
    navigation: c,
    pagination: l ? { clickable: !0 } : !1,
    scrollbar: { draggable: !0 },
    onSwiper: s,
    onSlideChange: r,
    effect: d,
    virtual: !0,
    autoHeight: !1,
    centeredSlides: a,
    children: n == null ? void 0 : n.map((h, m) => /* @__PURE__ */ A.jsx(ed, { virtualIndex: m, children: h }, h))
  }
);
/*!
 * @kurkle/color v0.3.2
 * https://github.com/kurkle/color#readme
 * (c) 2023 Jukka Kurkela
 * Released under the MIT License
 */
function bs(n) {
  return n + 0.5 | 0;
}
const Ii = (n, e, t) => Math.max(Math.min(n, t), e);
function Vn(n) {
  return Ii(bs(n * 2.55), 0, 255);
}
function Pi(n) {
  return Ii(bs(n * 255), 0, 255);
}
function vi(n) {
  return Ii(bs(n / 2.55) / 100, 0, 1);
}
function Ll(n) {
  return Ii(bs(n * 100), 0, 100);
}
const _t = { 0: 0, 1: 1, 2: 2, 3: 3, 4: 4, 5: 5, 6: 6, 7: 7, 8: 8, 9: 9, A: 10, B: 11, C: 12, D: 13, E: 14, F: 15, a: 10, b: 11, c: 12, d: 13, e: 14, f: 15 }, Ho = [..."0123456789ABCDEF"], QU = (n) => Ho[n & 15], XU = (n) => Ho[(n & 240) >> 4] + Ho[n & 15], js = (n) => (n & 240) >> 4 === (n & 15), _U = (n) => js(n.r) && js(n.g) && js(n.b) && js(n.a);
function $U(n) {
  var e = n.length, t;
  return n[0] === "#" && (e === 4 || e === 5 ? t = {
    r: 255 & _t[n[1]] * 17,
    g: 255 & _t[n[2]] * 17,
    b: 255 & _t[n[3]] * 17,
    a: e === 5 ? _t[n[4]] * 17 : 255
  } : (e === 7 || e === 9) && (t = {
    r: _t[n[1]] << 4 | _t[n[2]],
    g: _t[n[3]] << 4 | _t[n[4]],
    b: _t[n[5]] << 4 | _t[n[6]],
    a: e === 9 ? _t[n[7]] << 4 | _t[n[8]] : 255
  })), t;
}
const ez = (n, e) => n < 255 ? e(n) : "";
function tz(n) {
  var e = _U(n) ? QU : XU;
  return n ? "#" + e(n.r) + e(n.g) + e(n.b) + ez(n.a, e) : void 0;
}
const iz = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function td(n, e, t) {
  const s = e * Math.min(t, 1 - t), r = (a, c = (a + n / 30) % 12) => t - s * Math.max(Math.min(c - 3, 9 - c, 1), -1);
  return [r(0), r(8), r(4)];
}
function nz(n, e, t) {
  const s = (r, a = (r + n / 60) % 6) => t - t * e * Math.max(Math.min(a, 4 - a, 1), 0);
  return [s(5), s(3), s(1)];
}
function sz(n, e, t) {
  const s = td(n, 1, 0.5);
  let r;
  for (e + t > 1 && (r = 1 / (e + t), e *= r, t *= r), r = 0; r < 3; r++)
    s[r] *= 1 - e - t, s[r] += e;
  return s;
}
function rz(n, e, t, s, r) {
  return n === r ? (e - t) / s + (e < t ? 6 : 0) : e === r ? (t - n) / s + 2 : (n - e) / s + 4;
}
function ma(n) {
  const t = n.r / 255, s = n.g / 255, r = n.b / 255, a = Math.max(t, s, r), c = Math.min(t, s, r), l = (a + c) / 2;
  let d, h, m;
  return a !== c && (m = a - c, h = l > 0.5 ? m / (2 - a - c) : m / (a + c), d = rz(t, s, r, m, a), d = d * 60 + 0.5), [d | 0, h || 0, l];
}
function ga(n, e, t, s) {
  return (Array.isArray(e) ? n(e[0], e[1], e[2]) : n(e, t, s)).map(Pi);
}
function ya(n, e, t) {
  return ga(td, n, e, t);
}
function oz(n, e, t) {
  return ga(sz, n, e, t);
}
function az(n, e, t) {
  return ga(nz, n, e, t);
}
function id(n) {
  return (n % 360 + 360) % 360;
}
function lz(n) {
  const e = iz.exec(n);
  let t = 255, s;
  if (!e)
    return;
  e[5] !== s && (t = e[6] ? Vn(+e[5]) : Pi(+e[5]));
  const r = id(+e[2]), a = +e[3] / 100, c = +e[4] / 100;
  return e[1] === "hwb" ? s = oz(r, a, c) : e[1] === "hsv" ? s = az(r, a, c) : s = ya(r, a, c), {
    r: s[0],
    g: s[1],
    b: s[2],
    a: t
  };
}
function cz(n, e) {
  var t = ma(n);
  t[0] = id(t[0] + e), t = ya(t), n.r = t[0], n.g = t[1], n.b = t[2];
}
function uz(n) {
  if (!n)
    return;
  const e = ma(n), t = e[0], s = Ll(e[1]), r = Ll(e[2]);
  return n.a < 255 ? `hsla(${t}, ${s}%, ${r}%, ${vi(n.a)})` : `hsl(${t}, ${s}%, ${r}%)`;
}
const Dl = {
  x: "dark",
  Z: "light",
  Y: "re",
  X: "blu",
  W: "gr",
  V: "medium",
  U: "slate",
  A: "ee",
  T: "ol",
  S: "or",
  B: "ra",
  C: "lateg",
  D: "ights",
  R: "in",
  Q: "turquois",
  E: "hi",
  P: "ro",
  O: "al",
  N: "le",
  M: "de",
  L: "yello",
  F: "en",
  K: "ch",
  G: "arks",
  H: "ea",
  I: "ightg",
  J: "wh"
}, Nl = {
  OiceXe: "f0f8ff",
  antiquewEte: "faebd7",
  aqua: "ffff",
  aquamarRe: "7fffd4",
  azuY: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "0",
  blanKedOmond: "ffebcd",
  Xe: "ff",
  XeviTet: "8a2be2",
  bPwn: "a52a2a",
  burlywood: "deb887",
  caMtXe: "5f9ea0",
  KartYuse: "7fff00",
  KocTate: "d2691e",
  cSO: "ff7f50",
  cSnflowerXe: "6495ed",
  cSnsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "ffff",
  xXe: "8b",
  xcyan: "8b8b",
  xgTMnPd: "b8860b",
  xWay: "a9a9a9",
  xgYF: "6400",
  xgYy: "a9a9a9",
  xkhaki: "bdb76b",
  xmagFta: "8b008b",
  xTivegYF: "556b2f",
  xSange: "ff8c00",
  xScEd: "9932cc",
  xYd: "8b0000",
  xsOmon: "e9967a",
  xsHgYF: "8fbc8f",
  xUXe: "483d8b",
  xUWay: "2f4f4f",
  xUgYy: "2f4f4f",
  xQe: "ced1",
  xviTet: "9400d3",
  dAppRk: "ff1493",
  dApskyXe: "bfff",
  dimWay: "696969",
  dimgYy: "696969",
  dodgerXe: "1e90ff",
  fiYbrick: "b22222",
  flSOwEte: "fffaf0",
  foYstWAn: "228b22",
  fuKsia: "ff00ff",
  gaRsbSo: "dcdcdc",
  ghostwEte: "f8f8ff",
  gTd: "ffd700",
  gTMnPd: "daa520",
  Way: "808080",
  gYF: "8000",
  gYFLw: "adff2f",
  gYy: "808080",
  honeyMw: "f0fff0",
  hotpRk: "ff69b4",
  RdianYd: "cd5c5c",
  Rdigo: "4b0082",
  ivSy: "fffff0",
  khaki: "f0e68c",
  lavFMr: "e6e6fa",
  lavFMrXsh: "fff0f5",
  lawngYF: "7cfc00",
  NmoncEffon: "fffacd",
  ZXe: "add8e6",
  ZcSO: "f08080",
  Zcyan: "e0ffff",
  ZgTMnPdLw: "fafad2",
  ZWay: "d3d3d3",
  ZgYF: "90ee90",
  ZgYy: "d3d3d3",
  ZpRk: "ffb6c1",
  ZsOmon: "ffa07a",
  ZsHgYF: "20b2aa",
  ZskyXe: "87cefa",
  ZUWay: "778899",
  ZUgYy: "778899",
  ZstAlXe: "b0c4de",
  ZLw: "ffffe0",
  lime: "ff00",
  limegYF: "32cd32",
  lRF: "faf0e6",
  magFta: "ff00ff",
  maPon: "800000",
  VaquamarRe: "66cdaa",
  VXe: "cd",
  VScEd: "ba55d3",
  VpurpN: "9370db",
  VsHgYF: "3cb371",
  VUXe: "7b68ee",
  VsprRggYF: "fa9a",
  VQe: "48d1cc",
  VviTetYd: "c71585",
  midnightXe: "191970",
  mRtcYam: "f5fffa",
  mistyPse: "ffe4e1",
  moccasR: "ffe4b5",
  navajowEte: "ffdead",
  navy: "80",
  Tdlace: "fdf5e6",
  Tive: "808000",
  TivedBb: "6b8e23",
  Sange: "ffa500",
  SangeYd: "ff4500",
  ScEd: "da70d6",
  pOegTMnPd: "eee8aa",
  pOegYF: "98fb98",
  pOeQe: "afeeee",
  pOeviTetYd: "db7093",
  papayawEp: "ffefd5",
  pHKpuff: "ffdab9",
  peru: "cd853f",
  pRk: "ffc0cb",
  plum: "dda0dd",
  powMrXe: "b0e0e6",
  purpN: "800080",
  YbeccapurpN: "663399",
  Yd: "ff0000",
  Psybrown: "bc8f8f",
  PyOXe: "4169e1",
  saddNbPwn: "8b4513",
  sOmon: "fa8072",
  sandybPwn: "f4a460",
  sHgYF: "2e8b57",
  sHshell: "fff5ee",
  siFna: "a0522d",
  silver: "c0c0c0",
  skyXe: "87ceeb",
  UXe: "6a5acd",
  UWay: "708090",
  UgYy: "708090",
  snow: "fffafa",
  sprRggYF: "ff7f",
  stAlXe: "4682b4",
  tan: "d2b48c",
  teO: "8080",
  tEstN: "d8bfd8",
  tomato: "ff6347",
  Qe: "40e0d0",
  viTet: "ee82ee",
  JHt: "f5deb3",
  wEte: "ffffff",
  wEtesmoke: "f5f5f5",
  Lw: "ffff00",
  LwgYF: "9acd32"
};
function dz() {
  const n = {}, e = Object.keys(Nl), t = Object.keys(Dl);
  let s, r, a, c, l;
  for (s = 0; s < e.length; s++) {
    for (c = l = e[s], r = 0; r < t.length; r++)
      a = t[r], l = l.replace(a, Dl[a]);
    a = parseInt(Nl[c], 16), n[l] = [a >> 16 & 255, a >> 8 & 255, a & 255];
  }
  return n;
}
let Ls;
function fz(n) {
  Ls || (Ls = dz(), Ls.transparent = [0, 0, 0, 0]);
  const e = Ls[n.toLowerCase()];
  return e && {
    r: e[0],
    g: e[1],
    b: e[2],
    a: e.length === 4 ? e[3] : 255
  };
}
const hz = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function pz(n) {
  const e = hz.exec(n);
  let t = 255, s, r, a;
  if (e) {
    if (e[7] !== s) {
      const c = +e[7];
      t = e[8] ? Vn(c) : Ii(c * 255, 0, 255);
    }
    return s = +e[1], r = +e[3], a = +e[5], s = 255 & (e[2] ? Vn(s) : Ii(s, 0, 255)), r = 255 & (e[4] ? Vn(r) : Ii(r, 0, 255)), a = 255 & (e[6] ? Vn(a) : Ii(a, 0, 255)), {
      r: s,
      g: r,
      b: a,
      a: t
    };
  }
}
function mz(n) {
  return n && (n.a < 255 ? `rgba(${n.r}, ${n.g}, ${n.b}, ${vi(n.a)})` : `rgb(${n.r}, ${n.g}, ${n.b})`);
}
const lo = (n) => n <= 31308e-7 ? n * 12.92 : Math.pow(n, 1 / 2.4) * 1.055 - 0.055, dn = (n) => n <= 0.04045 ? n / 12.92 : Math.pow((n + 0.055) / 1.055, 2.4);
function gz(n, e, t) {
  const s = dn(vi(n.r)), r = dn(vi(n.g)), a = dn(vi(n.b));
  return {
    r: Pi(lo(s + t * (dn(vi(e.r)) - s))),
    g: Pi(lo(r + t * (dn(vi(e.g)) - r))),
    b: Pi(lo(a + t * (dn(vi(e.b)) - a))),
    a: n.a + t * (e.a - n.a)
  };
}
function Ds(n, e, t) {
  if (n) {
    let s = ma(n);
    s[e] = Math.max(0, Math.min(s[e] + s[e] * t, e === 0 ? 360 : 1)), s = ya(s), n.r = s[0], n.g = s[1], n.b = s[2];
  }
}
function nd(n, e) {
  return n && Object.assign(e || {}, n);
}
function Fl(n) {
  var e = { r: 0, g: 0, b: 0, a: 255 };
  return Array.isArray(n) ? n.length >= 3 && (e = { r: n[0], g: n[1], b: n[2], a: 255 }, n.length > 3 && (e.a = Pi(n[3]))) : (e = nd(n, { r: 0, g: 0, b: 0, a: 1 }), e.a = Pi(e.a)), e;
}
function yz(n) {
  return n.charAt(0) === "r" ? pz(n) : lz(n);
}
class as {
  constructor(e) {
    if (e instanceof as)
      return e;
    const t = typeof e;
    let s;
    t === "object" ? s = Fl(e) : t === "string" && (s = $U(e) || fz(e) || yz(e)), this._rgb = s, this._valid = !!s;
  }
  get valid() {
    return this._valid;
  }
  get rgb() {
    var e = nd(this._rgb);
    return e && (e.a = vi(e.a)), e;
  }
  set rgb(e) {
    this._rgb = Fl(e);
  }
  rgbString() {
    return this._valid ? mz(this._rgb) : void 0;
  }
  hexString() {
    return this._valid ? tz(this._rgb) : void 0;
  }
  hslString() {
    return this._valid ? uz(this._rgb) : void 0;
  }
  mix(e, t) {
    if (e) {
      const s = this.rgb, r = e.rgb;
      let a;
      const c = t === a ? 0.5 : t, l = 2 * c - 1, d = s.a - r.a, h = ((l * d === -1 ? l : (l + d) / (1 + l * d)) + 1) / 2;
      a = 1 - h, s.r = 255 & h * s.r + a * r.r + 0.5, s.g = 255 & h * s.g + a * r.g + 0.5, s.b = 255 & h * s.b + a * r.b + 0.5, s.a = c * s.a + (1 - c) * r.a, this.rgb = s;
    }
    return this;
  }
  interpolate(e, t) {
    return e && (this._rgb = gz(this._rgb, e._rgb, t)), this;
  }
  clone() {
    return new as(this.rgb);
  }
  alpha(e) {
    return this._rgb.a = Pi(e), this;
  }
  clearer(e) {
    const t = this._rgb;
    return t.a *= 1 - e, this;
  }
  greyscale() {
    const e = this._rgb, t = bs(e.r * 0.3 + e.g * 0.59 + e.b * 0.11);
    return e.r = e.g = e.b = t, this;
  }
  opaquer(e) {
    const t = this._rgb;
    return t.a *= 1 + e, this;
  }
  negate() {
    const e = this._rgb;
    return e.r = 255 - e.r, e.g = 255 - e.g, e.b = 255 - e.b, this;
  }
  lighten(e) {
    return Ds(this._rgb, 2, e), this;
  }
  darken(e) {
    return Ds(this._rgb, 2, -e), this;
  }
  saturate(e) {
    return Ds(this._rgb, 1, e), this;
  }
  desaturate(e) {
    return Ds(this._rgb, 1, -e), this;
  }
  rotate(e) {
    return cz(this._rgb, e), this;
  }
}
/*!
 * Chart.js v4.4.6
 * https://www.chartjs.org
 * (c) 2024 Chart.js Contributors
 * Released under the MIT License
 */
function pi() {
}
const vz = (() => {
  let n = 0;
  return () => n++;
})();
function rt(n) {
  return n === null || typeof n > "u";
}
function ut(n) {
  if (Array.isArray && Array.isArray(n))
    return !0;
  const e = Object.prototype.toString.call(n);
  return e.slice(0, 7) === "[object" && e.slice(-6) === "Array]";
}
function Ge(n) {
  return n !== null && Object.prototype.toString.call(n) === "[object Object]";
}
function ft(n) {
  return (typeof n == "number" || n instanceof Number) && isFinite(+n);
}
function Ht(n, e) {
  return ft(n) ? n : e;
}
function Pe(n, e) {
  return typeof n > "u" ? e : n;
}
const bz = (n, e) => typeof n == "string" && n.endsWith("%") ? parseFloat(n) / 100 : +n / e, sd = (n, e) => typeof n == "string" && n.endsWith("%") ? parseFloat(n) / 100 * e : +n;
function st(n, e, t) {
  if (n && typeof n.call == "function")
    return n.apply(t, e);
}
function _e(n, e, t, s) {
  let r, a, c;
  if (ut(n))
    if (a = n.length, s)
      for (r = a - 1; r >= 0; r--)
        e.call(t, n[r], r);
    else
      for (r = 0; r < a; r++)
        e.call(t, n[r], r);
  else if (Ge(n))
    for (c = Object.keys(n), a = c.length, r = 0; r < a; r++)
      e.call(t, n[c[r]], c[r]);
}
function xr(n, e) {
  let t, s, r, a;
  if (!n || !e || n.length !== e.length)
    return !1;
  for (t = 0, s = n.length; t < s; ++t)
    if (r = n[t], a = e[t], r.datasetIndex !== a.datasetIndex || r.index !== a.index)
      return !1;
  return !0;
}
function Sr(n) {
  if (ut(n))
    return n.map(Sr);
  if (Ge(n)) {
    const e = /* @__PURE__ */ Object.create(null), t = Object.keys(n), s = t.length;
    let r = 0;
    for (; r < s; ++r)
      e[t[r]] = Sr(n[t[r]]);
    return e;
  }
  return n;
}
function rd(n) {
  return [
    "__proto__",
    "prototype",
    "constructor"
  ].indexOf(n) === -1;
}
function xz(n, e, t, s) {
  if (!rd(n))
    return;
  const r = e[n], a = t[n];
  Ge(r) && Ge(a) ? ls(r, a, s) : e[n] = Sr(a);
}
function ls(n, e, t) {
  const s = ut(e) ? e : [
    e
  ], r = s.length;
  if (!Ge(n))
    return n;
  t = t || {};
  const a = t.merger || xz;
  let c;
  for (let l = 0; l < r; ++l) {
    if (c = s[l], !Ge(c))
      continue;
    const d = Object.keys(c);
    for (let h = 0, m = d.length; h < m; ++h)
      a(d[h], n, c, t);
  }
  return n;
}
function Xn(n, e) {
  return ls(n, e, {
    merger: Sz
  });
}
function Sz(n, e, t) {
  if (!rd(n))
    return;
  const s = e[n], r = t[n];
  Ge(s) && Ge(r) ? Xn(s, r) : Object.prototype.hasOwnProperty.call(e, n) || (e[n] = Sr(r));
}
const Bl = {
  // Chart.helpers.core resolveObjectKey should resolve empty key to root object
  "": (n) => n,
  // default resolvers
  x: (n) => n.x,
  y: (n) => n.y
};
function wz(n) {
  const e = n.split("."), t = [];
  let s = "";
  for (const r of e)
    s += r, s.endsWith("\\") ? s = s.slice(0, -1) + "." : (t.push(s), s = "");
  return t;
}
function Az(n) {
  const e = wz(n);
  return (t) => {
    for (const s of e) {
      if (s === "")
        break;
      t = t && t[s];
    }
    return t;
  };
}
function cs(n, e) {
  return (Bl[e] || (Bl[e] = Az(e)))(n);
}
function va(n) {
  return n.charAt(0).toUpperCase() + n.slice(1);
}
const wr = (n) => typeof n < "u", Di = (n) => typeof n == "function", ql = (n, e) => {
  if (n.size !== e.size)
    return !1;
  for (const t of n)
    if (!e.has(t))
      return !1;
  return !0;
};
function Cz(n) {
  return n.type === "mouseup" || n.type === "click" || n.type === "contextmenu";
}
const pt = Math.PI, ot = 2 * pt, Ez = ot + pt, Ar = Number.POSITIVE_INFINITY, kz = pt / 180, bt = pt / 2, qi = pt / 4, Hl = pt * 2 / 3, Ui = Math.log10, wn = Math.sign;
function _n(n, e, t) {
  return Math.abs(n - e) < t;
}
function Vl(n) {
  const e = Math.round(n);
  n = _n(n, e, n / 1e3) ? e : n;
  const t = Math.pow(10, Math.floor(Ui(n))), s = n / t;
  return (s <= 1 ? 1 : s <= 2 ? 2 : s <= 5 ? 5 : 10) * t;
}
function Oz(n) {
  const e = [], t = Math.sqrt(n);
  let s;
  for (s = 1; s < t; s++)
    n % s === 0 && (e.push(s), e.push(n / s));
  return t === (t | 0) && e.push(t), e.sort((r, a) => r - a).pop(), e;
}
function us(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}
function Tz(n, e) {
  const t = Math.round(n);
  return t - e <= n && t + e >= n;
}
function od(n, e, t) {
  let s, r, a;
  for (s = 0, r = n.length; s < r; s++)
    a = n[s][t], isNaN(a) || (e.min = Math.min(e.min, a), e.max = Math.max(e.max, a));
}
function li(n) {
  return n * (pt / 180);
}
function ba(n) {
  return n * (180 / pt);
}
function Gl(n) {
  if (!ft(n))
    return;
  let e = 1, t = 0;
  for (; Math.round(n * e) / e !== n; )
    e *= 10, t++;
  return t;
}
function ad(n, e) {
  const t = e.x - n.x, s = e.y - n.y, r = Math.sqrt(t * t + s * s);
  let a = Math.atan2(s, t);
  return a < -0.5 * pt && (a += ot), {
    angle: a,
    distance: r
  };
}
function Vo(n, e) {
  return Math.sqrt(Math.pow(e.x - n.x, 2) + Math.pow(e.y - n.y, 2));
}
function Iz(n, e) {
  return (n - e + Ez) % ot - pt;
}
function Gt(n) {
  return (n % ot + ot) % ot;
}
function ds(n, e, t, s) {
  const r = Gt(n), a = Gt(e), c = Gt(t), l = Gt(a - r), d = Gt(c - r), h = Gt(r - a), m = Gt(r - c);
  return r === a || r === c || s && a === c || l > d && h < m;
}
function Ut(n, e, t) {
  return Math.max(e, Math.min(t, n));
}
function Uz(n) {
  return Ut(n, -32768, 32767);
}
function Yi(n, e, t, s = 1e-6) {
  return n >= Math.min(e, t) - s && n <= Math.max(e, t) + s;
}
function xa(n, e, t) {
  t = t || ((c) => n[c] < e);
  let s = n.length - 1, r = 0, a;
  for (; s - r > 1; )
    a = r + s >> 1, t(a) ? r = a : s = a;
  return {
    lo: r,
    hi: s
  };
}
const Ji = (n, e, t, s) => xa(n, t, s ? (r) => {
  const a = n[r][e];
  return a < t || a === t && n[r + 1][e] === t;
} : (r) => n[r][e] < t), zz = (n, e, t) => xa(n, t, (s) => n[s][e] >= t);
function Rz(n, e, t) {
  let s = 0, r = n.length;
  for (; s < r && n[s] < e; )
    s++;
  for (; r > s && n[r - 1] > t; )
    r--;
  return s > 0 || r < n.length ? n.slice(s, r) : n;
}
const ld = [
  "push",
  "pop",
  "shift",
  "splice",
  "unshift"
];
function Pz(n, e) {
  if (n._chartjs) {
    n._chartjs.listeners.push(e);
    return;
  }
  Object.defineProperty(n, "_chartjs", {
    configurable: !0,
    enumerable: !1,
    value: {
      listeners: [
        e
      ]
    }
  }), ld.forEach((t) => {
    const s = "_onData" + va(t), r = n[t];
    Object.defineProperty(n, t, {
      configurable: !0,
      enumerable: !1,
      value(...a) {
        const c = r.apply(this, a);
        return n._chartjs.listeners.forEach((l) => {
          typeof l[s] == "function" && l[s](...a);
        }), c;
      }
    });
  });
}
function Wl(n, e) {
  const t = n._chartjs;
  if (!t)
    return;
  const s = t.listeners, r = s.indexOf(e);
  r !== -1 && s.splice(r, 1), !(s.length > 0) && (ld.forEach((a) => {
    delete n[a];
  }), delete n._chartjs);
}
function Mz(n) {
  const e = new Set(n);
  return e.size === n.length ? n : Array.from(e);
}
const cd = function() {
  return typeof window > "u" ? function(n) {
    return n();
  } : window.requestAnimationFrame;
}();
function ud(n, e) {
  let t = [], s = !1;
  return function(...r) {
    t = r, s || (s = !0, cd.call(window, () => {
      s = !1, n.apply(e, t);
    }));
  };
}
function jz(n, e) {
  let t;
  return function(...s) {
    return e ? (clearTimeout(t), t = setTimeout(n, e, s)) : n.apply(this, s), e;
  };
}
const dd = (n) => n === "start" ? "left" : n === "end" ? "right" : "center", qt = (n, e, t) => n === "start" ? e : n === "end" ? t : (e + t) / 2, Lz = (n, e, t, s) => n === (s ? "left" : "right") ? t : n === "center" ? (e + t) / 2 : e;
function Dz(n, e, t) {
  const s = e.length;
  let r = 0, a = s;
  if (n._sorted) {
    const { iScale: c, _parsed: l } = n, d = c.axis, { min: h, max: m, minDefined: y, maxDefined: b } = c.getUserBounds();
    y && (r = Ut(Math.min(
      // @ts-expect-error Need to type _parsed
      Ji(l, d, h).lo,
      // @ts-expect-error Need to fix types on _lookupByKey
      t ? s : Ji(e, d, c.getPixelForValue(h)).lo
    ), 0, s - 1)), b ? a = Ut(Math.max(
      // @ts-expect-error Need to type _parsed
      Ji(l, c.axis, m, !0).hi + 1,
      // @ts-expect-error Need to fix types on _lookupByKey
      t ? 0 : Ji(e, d, c.getPixelForValue(m), !0).hi + 1
    ), r, s) - r : a = s - r;
  }
  return {
    start: r,
    count: a
  };
}
function Nz(n) {
  const { xScale: e, yScale: t, _scaleRanges: s } = n, r = {
    xmin: e.min,
    xmax: e.max,
    ymin: t.min,
    ymax: t.max
  };
  if (!s)
    return n._scaleRanges = r, !0;
  const a = s.xmin !== e.min || s.xmax !== e.max || s.ymin !== t.min || s.ymax !== t.max;
  return Object.assign(s, r), a;
}
const Ns = (n) => n === 0 || n === 1, Kl = (n, e, t) => -(Math.pow(2, 10 * (n -= 1)) * Math.sin((n - e) * ot / t)), Yl = (n, e, t) => Math.pow(2, -10 * n) * Math.sin((n - e) * ot / t) + 1, $n = {
  linear: (n) => n,
  easeInQuad: (n) => n * n,
  easeOutQuad: (n) => -n * (n - 2),
  easeInOutQuad: (n) => (n /= 0.5) < 1 ? 0.5 * n * n : -0.5 * (--n * (n - 2) - 1),
  easeInCubic: (n) => n * n * n,
  easeOutCubic: (n) => (n -= 1) * n * n + 1,
  easeInOutCubic: (n) => (n /= 0.5) < 1 ? 0.5 * n * n * n : 0.5 * ((n -= 2) * n * n + 2),
  easeInQuart: (n) => n * n * n * n,
  easeOutQuart: (n) => -((n -= 1) * n * n * n - 1),
  easeInOutQuart: (n) => (n /= 0.5) < 1 ? 0.5 * n * n * n * n : -0.5 * ((n -= 2) * n * n * n - 2),
  easeInQuint: (n) => n * n * n * n * n,
  easeOutQuint: (n) => (n -= 1) * n * n * n * n + 1,
  easeInOutQuint: (n) => (n /= 0.5) < 1 ? 0.5 * n * n * n * n * n : 0.5 * ((n -= 2) * n * n * n * n + 2),
  easeInSine: (n) => -Math.cos(n * bt) + 1,
  easeOutSine: (n) => Math.sin(n * bt),
  easeInOutSine: (n) => -0.5 * (Math.cos(pt * n) - 1),
  easeInExpo: (n) => n === 0 ? 0 : Math.pow(2, 10 * (n - 1)),
  easeOutExpo: (n) => n === 1 ? 1 : -Math.pow(2, -10 * n) + 1,
  easeInOutExpo: (n) => Ns(n) ? n : n < 0.5 ? 0.5 * Math.pow(2, 10 * (n * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (n * 2 - 1)) + 2),
  easeInCirc: (n) => n >= 1 ? n : -(Math.sqrt(1 - n * n) - 1),
  easeOutCirc: (n) => Math.sqrt(1 - (n -= 1) * n),
  easeInOutCirc: (n) => (n /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - n * n) - 1) : 0.5 * (Math.sqrt(1 - (n -= 2) * n) + 1),
  easeInElastic: (n) => Ns(n) ? n : Kl(n, 0.075, 0.3),
  easeOutElastic: (n) => Ns(n) ? n : Yl(n, 0.075, 0.3),
  easeInOutElastic(n) {
    return Ns(n) ? n : n < 0.5 ? 0.5 * Kl(n * 2, 0.1125, 0.45) : 0.5 + 0.5 * Yl(n * 2 - 1, 0.1125, 0.45);
  },
  easeInBack(n) {
    return n * n * ((1.70158 + 1) * n - 1.70158);
  },
  easeOutBack(n) {
    return (n -= 1) * n * ((1.70158 + 1) * n + 1.70158) + 1;
  },
  easeInOutBack(n) {
    let e = 1.70158;
    return (n /= 0.5) < 1 ? 0.5 * (n * n * (((e *= 1.525) + 1) * n - e)) : 0.5 * ((n -= 2) * n * (((e *= 1.525) + 1) * n + e) + 2);
  },
  easeInBounce: (n) => 1 - $n.easeOutBounce(1 - n),
  easeOutBounce(n) {
    return n < 1 / 2.75 ? 7.5625 * n * n : n < 2 / 2.75 ? 7.5625 * (n -= 1.5 / 2.75) * n + 0.75 : n < 2.5 / 2.75 ? 7.5625 * (n -= 2.25 / 2.75) * n + 0.9375 : 7.5625 * (n -= 2.625 / 2.75) * n + 0.984375;
  },
  easeInOutBounce: (n) => n < 0.5 ? $n.easeInBounce(n * 2) * 0.5 : $n.easeOutBounce(n * 2 - 1) * 0.5 + 0.5
};
function Sa(n) {
  if (n && typeof n == "object") {
    const e = n.toString();
    return e === "[object CanvasPattern]" || e === "[object CanvasGradient]";
  }
  return !1;
}
function Jl(n) {
  return Sa(n) ? n : new as(n);
}
function co(n) {
  return Sa(n) ? n : new as(n).saturate(0.5).darken(0.1).hexString();
}
const Fz = [
  "x",
  "y",
  "borderWidth",
  "radius",
  "tension"
], Bz = [
  "color",
  "borderColor",
  "backgroundColor"
];
function qz(n) {
  n.set("animation", {
    delay: void 0,
    duration: 1e3,
    easing: "easeOutQuart",
    fn: void 0,
    from: void 0,
    loop: void 0,
    to: void 0,
    type: void 0
  }), n.describe("animation", {
    _fallback: !1,
    _indexable: !1,
    _scriptable: (e) => e !== "onProgress" && e !== "onComplete" && e !== "fn"
  }), n.set("animations", {
    colors: {
      type: "color",
      properties: Bz
    },
    numbers: {
      type: "number",
      properties: Fz
    }
  }), n.describe("animations", {
    _fallback: "animation"
  }), n.set("transitions", {
    active: {
      animation: {
        duration: 400
      }
    },
    resize: {
      animation: {
        duration: 0
      }
    },
    show: {
      animations: {
        colors: {
          from: "transparent"
        },
        visible: {
          type: "boolean",
          duration: 0
        }
      }
    },
    hide: {
      animations: {
        colors: {
          to: "transparent"
        },
        visible: {
          type: "boolean",
          easing: "linear",
          fn: (e) => e | 0
        }
      }
    }
  });
}
function Hz(n) {
  n.set("layout", {
    autoPadding: !0,
    padding: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }
  });
}
const Zl = /* @__PURE__ */ new Map();
function Vz(n, e) {
  e = e || {};
  const t = n + JSON.stringify(e);
  let s = Zl.get(t);
  return s || (s = new Intl.NumberFormat(n, e), Zl.set(t, s)), s;
}
function Lr(n, e, t) {
  return Vz(e, t).format(n);
}
const fd = {
  values(n) {
    return ut(n) ? n : "" + n;
  },
  numeric(n, e, t) {
    if (n === 0)
      return "0";
    const s = this.chart.options.locale;
    let r, a = n;
    if (t.length > 1) {
      const h = Math.max(Math.abs(t[0].value), Math.abs(t[t.length - 1].value));
      (h < 1e-4 || h > 1e15) && (r = "scientific"), a = Gz(n, t);
    }
    const c = Ui(Math.abs(a)), l = isNaN(c) ? 1 : Math.max(Math.min(-1 * Math.floor(c), 20), 0), d = {
      notation: r,
      minimumFractionDigits: l,
      maximumFractionDigits: l
    };
    return Object.assign(d, this.options.ticks.format), Lr(n, s, d);
  },
  logarithmic(n, e, t) {
    if (n === 0)
      return "0";
    const s = t[e].significand || n / Math.pow(10, Math.floor(Ui(n)));
    return [
      1,
      2,
      3,
      5,
      10,
      15
    ].includes(s) || e > 0.8 * t.length ? fd.numeric.call(this, n, e, t) : "";
  }
};
function Gz(n, e) {
  let t = e.length > 3 ? e[2].value - e[1].value : e[1].value - e[0].value;
  return Math.abs(t) >= 1 && n !== Math.floor(n) && (t = n - Math.floor(n)), t;
}
var Dr = {
  formatters: fd
};
function Wz(n) {
  n.set("scale", {
    display: !0,
    offset: !1,
    reverse: !1,
    beginAtZero: !1,
    bounds: "ticks",
    clip: !0,
    grace: 0,
    grid: {
      display: !0,
      lineWidth: 1,
      drawOnChartArea: !0,
      drawTicks: !0,
      tickLength: 8,
      tickWidth: (e, t) => t.lineWidth,
      tickColor: (e, t) => t.color,
      offset: !1
    },
    border: {
      display: !0,
      dash: [],
      dashOffset: 0,
      width: 1
    },
    title: {
      display: !1,
      text: "",
      padding: {
        top: 4,
        bottom: 4
      }
    },
    ticks: {
      minRotation: 0,
      maxRotation: 50,
      mirror: !1,
      textStrokeWidth: 0,
      textStrokeColor: "",
      padding: 3,
      display: !0,
      autoSkip: !0,
      autoSkipPadding: 3,
      labelOffset: 0,
      callback: Dr.formatters.values,
      minor: {},
      major: {},
      align: "center",
      crossAlign: "near",
      showLabelBackdrop: !1,
      backdropColor: "rgba(255, 255, 255, 0.75)",
      backdropPadding: 2
    }
  }), n.route("scale.ticks", "color", "", "color"), n.route("scale.grid", "color", "", "borderColor"), n.route("scale.border", "color", "", "borderColor"), n.route("scale.title", "color", "", "color"), n.describe("scale", {
    _fallback: !1,
    _scriptable: (e) => !e.startsWith("before") && !e.startsWith("after") && e !== "callback" && e !== "parser",
    _indexable: (e) => e !== "borderDash" && e !== "tickBorderDash" && e !== "dash"
  }), n.describe("scales", {
    _fallback: "scale"
  }), n.describe("scale.ticks", {
    _scriptable: (e) => e !== "backdropPadding" && e !== "callback",
    _indexable: (e) => e !== "backdropPadding"
  });
}
const sn = /* @__PURE__ */ Object.create(null), Go = /* @__PURE__ */ Object.create(null);
function es(n, e) {
  if (!e)
    return n;
  const t = e.split(".");
  for (let s = 0, r = t.length; s < r; ++s) {
    const a = t[s];
    n = n[a] || (n[a] = /* @__PURE__ */ Object.create(null));
  }
  return n;
}
function uo(n, e, t) {
  return typeof e == "string" ? ls(es(n, e), t) : ls(es(n, ""), e);
}
class Kz {
  constructor(e, t) {
    this.animation = void 0, this.backgroundColor = "rgba(0,0,0,0.1)", this.borderColor = "rgba(0,0,0,0.1)", this.color = "#666", this.datasets = {}, this.devicePixelRatio = (s) => s.chart.platform.getDevicePixelRatio(), this.elements = {}, this.events = [
      "mousemove",
      "mouseout",
      "click",
      "touchstart",
      "touchmove"
    ], this.font = {
      family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
      size: 12,
      style: "normal",
      lineHeight: 1.2,
      weight: null
    }, this.hover = {}, this.hoverBackgroundColor = (s, r) => co(r.backgroundColor), this.hoverBorderColor = (s, r) => co(r.borderColor), this.hoverColor = (s, r) => co(r.color), this.indexAxis = "x", this.interaction = {
      mode: "nearest",
      intersect: !0,
      includeInvisible: !1
    }, this.maintainAspectRatio = !0, this.onHover = null, this.onClick = null, this.parsing = !0, this.plugins = {}, this.responsive = !0, this.scale = void 0, this.scales = {}, this.showLine = !0, this.drawActiveElementsOnTop = !0, this.describe(e), this.apply(t);
  }
  set(e, t) {
    return uo(this, e, t);
  }
  get(e) {
    return es(this, e);
  }
  describe(e, t) {
    return uo(Go, e, t);
  }
  override(e, t) {
    return uo(sn, e, t);
  }
  route(e, t, s, r) {
    const a = es(this, e), c = es(this, s), l = "_" + t;
    Object.defineProperties(a, {
      [l]: {
        value: a[t],
        writable: !0
      },
      [t]: {
        enumerable: !0,
        get() {
          const d = this[l], h = c[r];
          return Ge(d) ? Object.assign({}, h, d) : Pe(d, h);
        },
        set(d) {
          this[l] = d;
        }
      }
    });
  }
  apply(e) {
    e.forEach((t) => t(this));
  }
}
var ht = /* @__PURE__ */ new Kz({
  _scriptable: (n) => !n.startsWith("on"),
  _indexable: (n) => n !== "events",
  hover: {
    _fallback: "interaction"
  },
  interaction: {
    _scriptable: !1,
    _indexable: !1
  }
}, [
  qz,
  Hz,
  Wz
]);
function Yz(n) {
  return !n || rt(n.size) || rt(n.family) ? null : (n.style ? n.style + " " : "") + (n.weight ? n.weight + " " : "") + n.size + "px " + n.family;
}
function Cr(n, e, t, s, r) {
  let a = e[r];
  return a || (a = e[r] = n.measureText(r).width, t.push(r)), a > s && (s = a), s;
}
function Jz(n, e, t, s) {
  s = s || {};
  let r = s.data = s.data || {}, a = s.garbageCollect = s.garbageCollect || [];
  s.font !== e && (r = s.data = {}, a = s.garbageCollect = [], s.font = e), n.save(), n.font = e;
  let c = 0;
  const l = t.length;
  let d, h, m, y, b;
  for (d = 0; d < l; d++)
    if (y = t[d], y != null && !ut(y))
      c = Cr(n, r, a, c, y);
    else if (ut(y))
      for (h = 0, m = y.length; h < m; h++)
        b = y[h], b != null && !ut(b) && (c = Cr(n, r, a, c, b));
  n.restore();
  const v = a.length / 2;
  if (v > t.length) {
    for (d = 0; d < v; d++)
      delete r[a[d]];
    a.splice(0, v);
  }
  return c;
}
function Hi(n, e, t) {
  const s = n.currentDevicePixelRatio, r = t !== 0 ? Math.max(t / 2, 0.5) : 0;
  return Math.round((e - r) * s) / s + r;
}
function Ql(n, e) {
  !e && !n || (e = e || n.getContext("2d"), e.save(), e.resetTransform(), e.clearRect(0, 0, n.width, n.height), e.restore());
}
function Wo(n, e, t, s) {
  hd(n, e, t, s, null);
}
function hd(n, e, t, s, r) {
  let a, c, l, d, h, m, y, b;
  const v = e.pointStyle, w = e.rotation, o = e.radius;
  let u = (w || 0) * kz;
  if (v && typeof v == "object" && (a = v.toString(), a === "[object HTMLImageElement]" || a === "[object HTMLCanvasElement]")) {
    n.save(), n.translate(t, s), n.rotate(u), n.drawImage(v, -v.width / 2, -v.height / 2, v.width, v.height), n.restore();
    return;
  }
  if (!(isNaN(o) || o <= 0)) {
    switch (n.beginPath(), v) {
      default:
        r ? n.ellipse(t, s, r / 2, o, 0, 0, ot) : n.arc(t, s, o, 0, ot), n.closePath();
        break;
      case "triangle":
        m = r ? r / 2 : o, n.moveTo(t + Math.sin(u) * m, s - Math.cos(u) * o), u += Hl, n.lineTo(t + Math.sin(u) * m, s - Math.cos(u) * o), u += Hl, n.lineTo(t + Math.sin(u) * m, s - Math.cos(u) * o), n.closePath();
        break;
      case "rectRounded":
        h = o * 0.516, d = o - h, c = Math.cos(u + qi) * d, y = Math.cos(u + qi) * (r ? r / 2 - h : d), l = Math.sin(u + qi) * d, b = Math.sin(u + qi) * (r ? r / 2 - h : d), n.arc(t - y, s - l, h, u - pt, u - bt), n.arc(t + b, s - c, h, u - bt, u), n.arc(t + y, s + l, h, u, u + bt), n.arc(t - b, s + c, h, u + bt, u + pt), n.closePath();
        break;
      case "rect":
        if (!w) {
          d = Math.SQRT1_2 * o, m = r ? r / 2 : d, n.rect(t - m, s - d, 2 * m, 2 * d);
          break;
        }
        u += qi;
      case "rectRot":
        y = Math.cos(u) * (r ? r / 2 : o), c = Math.cos(u) * o, l = Math.sin(u) * o, b = Math.sin(u) * (r ? r / 2 : o), n.moveTo(t - y, s - l), n.lineTo(t + b, s - c), n.lineTo(t + y, s + l), n.lineTo(t - b, s + c), n.closePath();
        break;
      case "crossRot":
        u += qi;
      case "cross":
        y = Math.cos(u) * (r ? r / 2 : o), c = Math.cos(u) * o, l = Math.sin(u) * o, b = Math.sin(u) * (r ? r / 2 : o), n.moveTo(t - y, s - l), n.lineTo(t + y, s + l), n.moveTo(t + b, s - c), n.lineTo(t - b, s + c);
        break;
      case "star":
        y = Math.cos(u) * (r ? r / 2 : o), c = Math.cos(u) * o, l = Math.sin(u) * o, b = Math.sin(u) * (r ? r / 2 : o), n.moveTo(t - y, s - l), n.lineTo(t + y, s + l), n.moveTo(t + b, s - c), n.lineTo(t - b, s + c), u += qi, y = Math.cos(u) * (r ? r / 2 : o), c = Math.cos(u) * o, l = Math.sin(u) * o, b = Math.sin(u) * (r ? r / 2 : o), n.moveTo(t - y, s - l), n.lineTo(t + y, s + l), n.moveTo(t + b, s - c), n.lineTo(t - b, s + c);
        break;
      case "line":
        c = r ? r / 2 : Math.cos(u) * o, l = Math.sin(u) * o, n.moveTo(t - c, s - l), n.lineTo(t + c, s + l);
        break;
      case "dash":
        n.moveTo(t, s), n.lineTo(t + Math.cos(u) * (r ? r / 2 : o), s + Math.sin(u) * o);
        break;
      case !1:
        n.closePath();
        break;
    }
    n.fill(), e.borderWidth > 0 && n.stroke();
  }
}
function xi(n, e, t) {
  return t = t || 0.5, !e || n && n.x > e.left - t && n.x < e.right + t && n.y > e.top - t && n.y < e.bottom + t;
}
function Nr(n, e) {
  n.save(), n.beginPath(), n.rect(e.left, e.top, e.right - e.left, e.bottom - e.top), n.clip();
}
function Fr(n) {
  n.restore();
}
function Zz(n, e, t, s, r) {
  if (!e)
    return n.lineTo(t.x, t.y);
  if (r === "middle") {
    const a = (e.x + t.x) / 2;
    n.lineTo(a, e.y), n.lineTo(a, t.y);
  } else
    r === "after" != !!s ? n.lineTo(e.x, t.y) : n.lineTo(t.x, e.y);
  n.lineTo(t.x, t.y);
}
function Qz(n, e, t, s) {
  if (!e)
    return n.lineTo(t.x, t.y);
  n.bezierCurveTo(s ? e.cp1x : e.cp2x, s ? e.cp1y : e.cp2y, s ? t.cp2x : t.cp1x, s ? t.cp2y : t.cp1y, t.x, t.y);
}
function Xz(n, e) {
  e.translation && n.translate(e.translation[0], e.translation[1]), rt(e.rotation) || n.rotate(e.rotation), e.color && (n.fillStyle = e.color), e.textAlign && (n.textAlign = e.textAlign), e.textBaseline && (n.textBaseline = e.textBaseline);
}
function _z(n, e, t, s, r) {
  if (r.strikethrough || r.underline) {
    const a = n.measureText(s), c = e - a.actualBoundingBoxLeft, l = e + a.actualBoundingBoxRight, d = t - a.actualBoundingBoxAscent, h = t + a.actualBoundingBoxDescent, m = r.strikethrough ? (d + h) / 2 : h;
    n.strokeStyle = n.fillStyle, n.beginPath(), n.lineWidth = r.decorationWidth || 2, n.moveTo(c, m), n.lineTo(l, m), n.stroke();
  }
}
function $z(n, e) {
  const t = n.fillStyle;
  n.fillStyle = e.color, n.fillRect(e.left, e.top, e.width, e.height), n.fillStyle = t;
}
function An(n, e, t, s, r, a = {}) {
  const c = ut(e) ? e : [
    e
  ], l = a.strokeWidth > 0 && a.strokeColor !== "";
  let d, h;
  for (n.save(), n.font = r.string, Xz(n, a), d = 0; d < c.length; ++d)
    h = c[d], a.backdrop && $z(n, a.backdrop), l && (a.strokeColor && (n.strokeStyle = a.strokeColor), rt(a.strokeWidth) || (n.lineWidth = a.strokeWidth), n.strokeText(h, t, s, a.maxWidth)), n.fillText(h, t, s, a.maxWidth), _z(n, t, s, h, a), s += Number(r.lineHeight);
  n.restore();
}
function Er(n, e) {
  const { x: t, y: s, w: r, h: a, radius: c } = e;
  n.arc(t + c.topLeft, s + c.topLeft, c.topLeft, 1.5 * pt, pt, !0), n.lineTo(t, s + a - c.bottomLeft), n.arc(t + c.bottomLeft, s + a - c.bottomLeft, c.bottomLeft, pt, bt, !0), n.lineTo(t + r - c.bottomRight, s + a), n.arc(t + r - c.bottomRight, s + a - c.bottomRight, c.bottomRight, bt, 0, !0), n.lineTo(t + r, s + c.topRight), n.arc(t + r - c.topRight, s + c.topRight, c.topRight, 0, -bt, !0), n.lineTo(t + c.topLeft, s);
}
const eR = /^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/, tR = /^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/;
function iR(n, e) {
  const t = ("" + n).match(eR);
  if (!t || t[1] === "normal")
    return e * 1.2;
  switch (n = +t[2], t[3]) {
    case "px":
      return n;
    case "%":
      n /= 100;
      break;
  }
  return e * n;
}
const nR = (n) => +n || 0;
function wa(n, e) {
  const t = {}, s = Ge(e), r = s ? Object.keys(e) : e, a = Ge(n) ? s ? (c) => Pe(n[c], n[e[c]]) : (c) => n[c] : () => n;
  for (const c of r)
    t[c] = nR(a(c));
  return t;
}
function sR(n) {
  return wa(n, {
    top: "y",
    right: "x",
    bottom: "y",
    left: "x"
  });
}
function gn(n) {
  return wa(n, [
    "topLeft",
    "topRight",
    "bottomLeft",
    "bottomRight"
  ]);
}
function zt(n) {
  const e = sR(n);
  return e.width = e.left + e.right, e.height = e.top + e.bottom, e;
}
function Ct(n, e) {
  n = n || {}, e = e || ht.font;
  let t = Pe(n.size, e.size);
  typeof t == "string" && (t = parseInt(t, 10));
  let s = Pe(n.style, e.style);
  s && !("" + s).match(tR) && (console.warn('Invalid font style specified: "' + s + '"'), s = void 0);
  const r = {
    family: Pe(n.family, e.family),
    lineHeight: iR(Pe(n.lineHeight, e.lineHeight), t),
    size: t,
    style: s,
    weight: Pe(n.weight, e.weight),
    string: ""
  };
  return r.string = Yz(r), r;
}
function Fs(n, e, t, s) {
  let r = !0, a, c, l;
  for (a = 0, c = n.length; a < c; ++a)
    if (l = n[a], l !== void 0 && (e !== void 0 && typeof l == "function" && (l = l(e), r = !1), t !== void 0 && ut(l) && (l = l[t % l.length], r = !1), l !== void 0))
      return s && !r && (s.cacheable = !1), l;
}
function rR(n, e, t) {
  const { min: s, max: r } = n, a = sd(e, (r - s) / 2), c = (l, d) => t && l === 0 ? 0 : l + d;
  return {
    min: c(s, -Math.abs(a)),
    max: c(r, a)
  };
}
function Ni(n, e) {
  return Object.assign(Object.create(n), e);
}
function Aa(n, e = [
  ""
], t, s, r = () => n[0]) {
  const a = t || n;
  typeof s > "u" && (s = yd("_fallback", n));
  const c = {
    [Symbol.toStringTag]: "Object",
    _cacheable: !0,
    _scopes: n,
    _rootScopes: a,
    _fallback: s,
    _getTarget: r,
    override: (l) => Aa([
      l,
      ...n
    ], e, a, s)
  };
  return new Proxy(c, {
    /**
    * A trap for the delete operator.
    */
    deleteProperty(l, d) {
      return delete l[d], delete l._keys, delete n[0][d], !0;
    },
    /**
    * A trap for getting property values.
    */
    get(l, d) {
      return md(l, d, () => hR(d, e, n, l));
    },
    /**
    * A trap for Object.getOwnPropertyDescriptor.
    * Also used by Object.hasOwnProperty.
    */
    getOwnPropertyDescriptor(l, d) {
      return Reflect.getOwnPropertyDescriptor(l._scopes[0], d);
    },
    /**
    * A trap for Object.getPrototypeOf.
    */
    getPrototypeOf() {
      return Reflect.getPrototypeOf(n[0]);
    },
    /**
    * A trap for the in operator.
    */
    has(l, d) {
      return _l(l).includes(d);
    },
    /**
    * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
    */
    ownKeys(l) {
      return _l(l);
    },
    /**
    * A trap for setting property values.
    */
    set(l, d, h) {
      const m = l._storage || (l._storage = r());
      return l[d] = m[d] = h, delete l._keys, !0;
    }
  });
}
function Cn(n, e, t, s) {
  const r = {
    _cacheable: !1,
    _proxy: n,
    _context: e,
    _subProxy: t,
    _stack: /* @__PURE__ */ new Set(),
    _descriptors: pd(n, s),
    setContext: (a) => Cn(n, a, t, s),
    override: (a) => Cn(n.override(a), e, t, s)
  };
  return new Proxy(r, {
    /**
    * A trap for the delete operator.
    */
    deleteProperty(a, c) {
      return delete a[c], delete n[c], !0;
    },
    /**
    * A trap for getting property values.
    */
    get(a, c, l) {
      return md(a, c, () => aR(a, c, l));
    },
    /**
    * A trap for Object.getOwnPropertyDescriptor.
    * Also used by Object.hasOwnProperty.
    */
    getOwnPropertyDescriptor(a, c) {
      return a._descriptors.allKeys ? Reflect.has(n, c) ? {
        enumerable: !0,
        configurable: !0
      } : void 0 : Reflect.getOwnPropertyDescriptor(n, c);
    },
    /**
    * A trap for Object.getPrototypeOf.
    */
    getPrototypeOf() {
      return Reflect.getPrototypeOf(n);
    },
    /**
    * A trap for the in operator.
    */
    has(a, c) {
      return Reflect.has(n, c);
    },
    /**
    * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
    */
    ownKeys() {
      return Reflect.ownKeys(n);
    },
    /**
    * A trap for setting property values.
    */
    set(a, c, l) {
      return n[c] = l, delete a[c], !0;
    }
  });
}
function pd(n, e = {
  scriptable: !0,
  indexable: !0
}) {
  const { _scriptable: t = e.scriptable, _indexable: s = e.indexable, _allKeys: r = e.allKeys } = n;
  return {
    allKeys: r,
    scriptable: t,
    indexable: s,
    isScriptable: Di(t) ? t : () => t,
    isIndexable: Di(s) ? s : () => s
  };
}
const oR = (n, e) => n ? n + va(e) : e, Ca = (n, e) => Ge(e) && n !== "adapters" && (Object.getPrototypeOf(e) === null || e.constructor === Object);
function md(n, e, t) {
  if (Object.prototype.hasOwnProperty.call(n, e) || e === "constructor")
    return n[e];
  const s = t();
  return n[e] = s, s;
}
function aR(n, e, t) {
  const { _proxy: s, _context: r, _subProxy: a, _descriptors: c } = n;
  let l = s[e];
  return Di(l) && c.isScriptable(e) && (l = lR(e, l, n, t)), ut(l) && l.length && (l = cR(e, l, n, c.isIndexable)), Ca(e, l) && (l = Cn(l, r, a && a[e], c)), l;
}
function lR(n, e, t, s) {
  const { _proxy: r, _context: a, _subProxy: c, _stack: l } = t;
  if (l.has(n))
    throw new Error("Recursion detected: " + Array.from(l).join("->") + "->" + n);
  l.add(n);
  let d = e(a, c || s);
  return l.delete(n), Ca(n, d) && (d = Ea(r._scopes, r, n, d)), d;
}
function cR(n, e, t, s) {
  const { _proxy: r, _context: a, _subProxy: c, _descriptors: l } = t;
  if (typeof a.index < "u" && s(n))
    return e[a.index % e.length];
  if (Ge(e[0])) {
    const d = e, h = r._scopes.filter((m) => m !== d);
    e = [];
    for (const m of d) {
      const y = Ea(h, r, n, m);
      e.push(Cn(y, a, c && c[n], l));
    }
  }
  return e;
}
function gd(n, e, t) {
  return Di(n) ? n(e, t) : n;
}
const uR = (n, e) => n === !0 ? e : typeof n == "string" ? cs(e, n) : void 0;
function dR(n, e, t, s, r) {
  for (const a of e) {
    const c = uR(t, a);
    if (c) {
      n.add(c);
      const l = gd(c._fallback, t, r);
      if (typeof l < "u" && l !== t && l !== s)
        return l;
    } else if (c === !1 && typeof s < "u" && t !== s)
      return null;
  }
  return !1;
}
function Ea(n, e, t, s) {
  const r = e._rootScopes, a = gd(e._fallback, t, s), c = [
    ...n,
    ...r
  ], l = /* @__PURE__ */ new Set();
  l.add(s);
  let d = Xl(l, c, t, a || t, s);
  return d === null || typeof a < "u" && a !== t && (d = Xl(l, c, a, d, s), d === null) ? !1 : Aa(Array.from(l), [
    ""
  ], r, a, () => fR(e, t, s));
}
function Xl(n, e, t, s, r) {
  for (; t; )
    t = dR(n, e, t, s, r);
  return t;
}
function fR(n, e, t) {
  const s = n._getTarget();
  e in s || (s[e] = {});
  const r = s[e];
  return ut(r) && Ge(t) ? t : r || {};
}
function hR(n, e, t, s) {
  let r;
  for (const a of e)
    if (r = yd(oR(a, n), t), typeof r < "u")
      return Ca(n, r) ? Ea(t, s, n, r) : r;
}
function yd(n, e) {
  for (const t of e) {
    if (!t)
      continue;
    const s = t[n];
    if (typeof s < "u")
      return s;
  }
}
function _l(n) {
  let e = n._keys;
  return e || (e = n._keys = pR(n._scopes)), e;
}
function pR(n) {
  const e = /* @__PURE__ */ new Set();
  for (const t of n)
    for (const s of Object.keys(t).filter((r) => !r.startsWith("_")))
      e.add(s);
  return Array.from(e);
}
const mR = Number.EPSILON || 1e-14, En = (n, e) => e < n.length && !n[e].skip && n[e], vd = (n) => n === "x" ? "y" : "x";
function gR(n, e, t, s) {
  const r = n.skip ? e : n, a = e, c = t.skip ? e : t, l = Vo(a, r), d = Vo(c, a);
  let h = l / (l + d), m = d / (l + d);
  h = isNaN(h) ? 0 : h, m = isNaN(m) ? 0 : m;
  const y = s * h, b = s * m;
  return {
    previous: {
      x: a.x - y * (c.x - r.x),
      y: a.y - y * (c.y - r.y)
    },
    next: {
      x: a.x + b * (c.x - r.x),
      y: a.y + b * (c.y - r.y)
    }
  };
}
function yR(n, e, t) {
  const s = n.length;
  let r, a, c, l, d, h = En(n, 0);
  for (let m = 0; m < s - 1; ++m)
    if (d = h, h = En(n, m + 1), !(!d || !h)) {
      if (_n(e[m], 0, mR)) {
        t[m] = t[m + 1] = 0;
        continue;
      }
      r = t[m] / e[m], a = t[m + 1] / e[m], l = Math.pow(r, 2) + Math.pow(a, 2), !(l <= 9) && (c = 3 / Math.sqrt(l), t[m] = r * c * e[m], t[m + 1] = a * c * e[m]);
    }
}
function vR(n, e, t = "x") {
  const s = vd(t), r = n.length;
  let a, c, l, d = En(n, 0);
  for (let h = 0; h < r; ++h) {
    if (c = l, l = d, d = En(n, h + 1), !l)
      continue;
    const m = l[t], y = l[s];
    c && (a = (m - c[t]) / 3, l[`cp1${t}`] = m - a, l[`cp1${s}`] = y - a * e[h]), d && (a = (d[t] - m) / 3, l[`cp2${t}`] = m + a, l[`cp2${s}`] = y + a * e[h]);
  }
}
function bR(n, e = "x") {
  const t = vd(e), s = n.length, r = Array(s).fill(0), a = Array(s);
  let c, l, d, h = En(n, 0);
  for (c = 0; c < s; ++c)
    if (l = d, d = h, h = En(n, c + 1), !!d) {
      if (h) {
        const m = h[e] - d[e];
        r[c] = m !== 0 ? (h[t] - d[t]) / m : 0;
      }
      a[c] = l ? h ? wn(r[c - 1]) !== wn(r[c]) ? 0 : (r[c - 1] + r[c]) / 2 : r[c - 1] : r[c];
    }
  yR(n, r, a), vR(n, a, e);
}
function Bs(n, e, t) {
  return Math.max(Math.min(n, t), e);
}
function xR(n, e) {
  let t, s, r, a, c, l = xi(n[0], e);
  for (t = 0, s = n.length; t < s; ++t)
    c = a, a = l, l = t < s - 1 && xi(n[t + 1], e), a && (r = n[t], c && (r.cp1x = Bs(r.cp1x, e.left, e.right), r.cp1y = Bs(r.cp1y, e.top, e.bottom)), l && (r.cp2x = Bs(r.cp2x, e.left, e.right), r.cp2y = Bs(r.cp2y, e.top, e.bottom)));
}
function SR(n, e, t, s, r) {
  let a, c, l, d;
  if (e.spanGaps && (n = n.filter((h) => !h.skip)), e.cubicInterpolationMode === "monotone")
    bR(n, r);
  else {
    let h = s ? n[n.length - 1] : n[0];
    for (a = 0, c = n.length; a < c; ++a)
      l = n[a], d = gR(h, l, n[Math.min(a + 1, c - (s ? 0 : 1)) % c], e.tension), l.cp1x = d.previous.x, l.cp1y = d.previous.y, l.cp2x = d.next.x, l.cp2y = d.next.y, h = l;
  }
  e.capBezierPoints && xR(n, t);
}
function ka() {
  return typeof window < "u" && typeof document < "u";
}
function Oa(n) {
  let e = n.parentNode;
  return e && e.toString() === "[object ShadowRoot]" && (e = e.host), e;
}
function kr(n, e, t) {
  let s;
  return typeof n == "string" ? (s = parseInt(n, 10), n.indexOf("%") !== -1 && (s = s / 100 * e.parentNode[t])) : s = n, s;
}
const Br = (n) => n.ownerDocument.defaultView.getComputedStyle(n, null);
function wR(n, e) {
  return Br(n).getPropertyValue(e);
}
const AR = [
  "top",
  "right",
  "bottom",
  "left"
];
function Xi(n, e, t) {
  const s = {};
  t = t ? "-" + t : "";
  for (let r = 0; r < 4; r++) {
    const a = AR[r];
    s[a] = parseFloat(n[e + "-" + a + t]) || 0;
  }
  return s.width = s.left + s.right, s.height = s.top + s.bottom, s;
}
const CR = (n, e, t) => (n > 0 || e > 0) && (!t || !t.shadowRoot);
function ER(n, e) {
  const t = n.touches, s = t && t.length ? t[0] : n, { offsetX: r, offsetY: a } = s;
  let c = !1, l, d;
  if (CR(r, a, n.target))
    l = r, d = a;
  else {
    const h = e.getBoundingClientRect();
    l = s.clientX - h.left, d = s.clientY - h.top, c = !0;
  }
  return {
    x: l,
    y: d,
    box: c
  };
}
function Wi(n, e) {
  if ("native" in n)
    return n;
  const { canvas: t, currentDevicePixelRatio: s } = e, r = Br(t), a = r.boxSizing === "border-box", c = Xi(r, "padding"), l = Xi(r, "border", "width"), { x: d, y: h, box: m } = ER(n, t), y = c.left + (m && l.left), b = c.top + (m && l.top);
  let { width: v, height: w } = e;
  return a && (v -= c.width + l.width, w -= c.height + l.height), {
    x: Math.round((d - y) / v * t.width / s),
    y: Math.round((h - b) / w * t.height / s)
  };
}
function kR(n, e, t) {
  let s, r;
  if (e === void 0 || t === void 0) {
    const a = n && Oa(n);
    if (!a)
      e = n.clientWidth, t = n.clientHeight;
    else {
      const c = a.getBoundingClientRect(), l = Br(a), d = Xi(l, "border", "width"), h = Xi(l, "padding");
      e = c.width - h.width - d.width, t = c.height - h.height - d.height, s = kr(l.maxWidth, a, "clientWidth"), r = kr(l.maxHeight, a, "clientHeight");
    }
  }
  return {
    width: e,
    height: t,
    maxWidth: s || Ar,
    maxHeight: r || Ar
  };
}
const qs = (n) => Math.round(n * 10) / 10;
function OR(n, e, t, s) {
  const r = Br(n), a = Xi(r, "margin"), c = kr(r.maxWidth, n, "clientWidth") || Ar, l = kr(r.maxHeight, n, "clientHeight") || Ar, d = kR(n, e, t);
  let { width: h, height: m } = d;
  if (r.boxSizing === "content-box") {
    const b = Xi(r, "border", "width"), v = Xi(r, "padding");
    h -= v.width + b.width, m -= v.height + b.height;
  }
  return h = Math.max(0, h - a.width), m = Math.max(0, s ? h / s : m - a.height), h = qs(Math.min(h, c, d.maxWidth)), m = qs(Math.min(m, l, d.maxHeight)), h && !m && (m = qs(h / 2)), (e !== void 0 || t !== void 0) && s && d.height && m > d.height && (m = d.height, h = qs(Math.floor(m * s))), {
    width: h,
    height: m
  };
}
function $l(n, e, t) {
  const s = e || 1, r = Math.floor(n.height * s), a = Math.floor(n.width * s);
  n.height = Math.floor(n.height), n.width = Math.floor(n.width);
  const c = n.canvas;
  return c.style && (t || !c.style.height && !c.style.width) && (c.style.height = `${n.height}px`, c.style.width = `${n.width}px`), n.currentDevicePixelRatio !== s || c.height !== r || c.width !== a ? (n.currentDevicePixelRatio = s, c.height = r, c.width = a, n.ctx.setTransform(s, 0, 0, s, 0, 0), !0) : !1;
}
const TR = function() {
  let n = !1;
  try {
    const e = {
      get passive() {
        return n = !0, !1;
      }
    };
    ka() && (window.addEventListener("test", null, e), window.removeEventListener("test", null, e));
  } catch {
  }
  return n;
}();
function ec(n, e) {
  const t = wR(n, e), s = t && t.match(/^(\d+)(\.\d+)?px$/);
  return s ? +s[1] : void 0;
}
function Ki(n, e, t, s) {
  return {
    x: n.x + t * (e.x - n.x),
    y: n.y + t * (e.y - n.y)
  };
}
function IR(n, e, t, s) {
  return {
    x: n.x + t * (e.x - n.x),
    y: s === "middle" ? t < 0.5 ? n.y : e.y : s === "after" ? t < 1 ? n.y : e.y : t > 0 ? e.y : n.y
  };
}
function UR(n, e, t, s) {
  const r = {
    x: n.cp2x,
    y: n.cp2y
  }, a = {
    x: e.cp1x,
    y: e.cp1y
  }, c = Ki(n, r, t), l = Ki(r, a, t), d = Ki(a, e, t), h = Ki(c, l, t), m = Ki(l, d, t);
  return Ki(h, m, t);
}
const zR = function(n, e) {
  return {
    x(t) {
      return n + n + e - t;
    },
    setWidth(t) {
      e = t;
    },
    textAlign(t) {
      return t === "center" ? t : t === "right" ? "left" : "right";
    },
    xPlus(t, s) {
      return t - s;
    },
    leftForLtr(t, s) {
      return t - s;
    }
  };
}, RR = function() {
  return {
    x(n) {
      return n;
    },
    setWidth(n) {
    },
    textAlign(n) {
      return n;
    },
    xPlus(n, e) {
      return n + e;
    },
    leftForLtr(n, e) {
      return n;
    }
  };
};
function yn(n, e, t) {
  return n ? zR(e, t) : RR();
}
function bd(n, e) {
  let t, s;
  (e === "ltr" || e === "rtl") && (t = n.canvas.style, s = [
    t.getPropertyValue("direction"),
    t.getPropertyPriority("direction")
  ], t.setProperty("direction", e, "important"), n.prevTextDirection = s);
}
function xd(n, e) {
  e !== void 0 && (delete n.prevTextDirection, n.canvas.style.setProperty("direction", e[0], e[1]));
}
function Sd(n) {
  return n === "angle" ? {
    between: ds,
    compare: Iz,
    normalize: Gt
  } : {
    between: Yi,
    compare: (e, t) => e - t,
    normalize: (e) => e
  };
}
function tc({ start: n, end: e, count: t, loop: s, style: r }) {
  return {
    start: n % t,
    end: e % t,
    loop: s && (e - n + 1) % t === 0,
    style: r
  };
}
function PR(n, e, t) {
  const { property: s, start: r, end: a } = t, { between: c, normalize: l } = Sd(s), d = e.length;
  let { start: h, end: m, loop: y } = n, b, v;
  if (y) {
    for (h += d, m += d, b = 0, v = d; b < v && c(l(e[h % d][s]), r, a); ++b)
      h--, m--;
    h %= d, m %= d;
  }
  return m < h && (m += d), {
    start: h,
    end: m,
    loop: y,
    style: n.style
  };
}
function wd(n, e, t) {
  if (!t)
    return [
      n
    ];
  const { property: s, start: r, end: a } = t, c = e.length, { compare: l, between: d, normalize: h } = Sd(s), { start: m, end: y, loop: b, style: v } = PR(n, e, t), w = [];
  let o = !1, u = null, f, p, g;
  const S = () => d(r, g, f) && l(r, g) !== 0, x = () => l(a, f) === 0 || d(a, g, f), E = () => o || S(), k = () => !o || x();
  for (let R = m, O = m; R <= y; ++R)
    p = e[R % c], !p.skip && (f = h(p[s]), f !== g && (o = d(f, r, a), u === null && E() && (u = l(f, r) === 0 ? R : O), u !== null && k() && (w.push(tc({
      start: u,
      end: R,
      loop: b,
      count: c,
      style: v
    })), u = null), O = R, g = f));
  return u !== null && w.push(tc({
    start: u,
    end: y,
    loop: b,
    count: c,
    style: v
  })), w;
}
function Ad(n, e) {
  const t = [], s = n.segments;
  for (let r = 0; r < s.length; r++) {
    const a = wd(s[r], n.points, e);
    a.length && t.push(...a);
  }
  return t;
}
function MR(n, e, t, s) {
  let r = 0, a = e - 1;
  if (t && !s)
    for (; r < e && !n[r].skip; )
      r++;
  for (; r < e && n[r].skip; )
    r++;
  for (r %= e, t && (a += r); a > r && n[a % e].skip; )
    a--;
  return a %= e, {
    start: r,
    end: a
  };
}
function jR(n, e, t, s) {
  const r = n.length, a = [];
  let c = e, l = n[e], d;
  for (d = e + 1; d <= t; ++d) {
    const h = n[d % r];
    h.skip || h.stop ? l.skip || (s = !1, a.push({
      start: e % r,
      end: (d - 1) % r,
      loop: s
    }), e = c = h.stop ? d : null) : (c = d, l.skip && (e = d)), l = h;
  }
  return c !== null && a.push({
    start: e % r,
    end: c % r,
    loop: s
  }), a;
}
function LR(n, e) {
  const t = n.points, s = n.options.spanGaps, r = t.length;
  if (!r)
    return [];
  const a = !!n._loop, { start: c, end: l } = MR(t, r, a, s);
  if (s === !0)
    return ic(n, [
      {
        start: c,
        end: l,
        loop: a
      }
    ], t, e);
  const d = l < c ? l + r : l, h = !!n._fullLoop && c === 0 && l === r - 1;
  return ic(n, jR(t, c, d, h), t, e);
}
function ic(n, e, t, s) {
  return !s || !s.setContext || !t ? e : DR(n, e, t, s);
}
function DR(n, e, t, s) {
  const r = n._chart.getContext(), a = nc(n.options), { _datasetIndex: c, options: { spanGaps: l } } = n, d = t.length, h = [];
  let m = a, y = e[0].start, b = y;
  function v(w, o, u, f) {
    const p = l ? -1 : 1;
    if (w !== o) {
      for (w += d; t[w % d].skip; )
        w -= p;
      for (; t[o % d].skip; )
        o += p;
      w % d !== o % d && (h.push({
        start: w % d,
        end: o % d,
        loop: u,
        style: f
      }), m = f, y = o % d);
    }
  }
  for (const w of e) {
    y = l ? y : w.start;
    let o = t[y % d], u;
    for (b = y + 1; b <= w.end; b++) {
      const f = t[b % d];
      u = nc(s.setContext(Ni(r, {
        type: "segment",
        p0: o,
        p1: f,
        p0DataIndex: (b - 1) % d,
        p1DataIndex: b % d,
        datasetIndex: c
      }))), NR(u, m) && v(y, b - 1, w.loop, m), o = f, m = u;
    }
    y < b - 1 && v(y, b - 1, w.loop, m);
  }
  return h;
}
function nc(n) {
  return {
    backgroundColor: n.backgroundColor,
    borderCapStyle: n.borderCapStyle,
    borderDash: n.borderDash,
    borderDashOffset: n.borderDashOffset,
    borderJoinStyle: n.borderJoinStyle,
    borderWidth: n.borderWidth,
    borderColor: n.borderColor
  };
}
function NR(n, e) {
  if (!e)
    return !1;
  const t = [], s = function(r, a) {
    return Sa(a) ? (t.includes(a) || t.push(a), t.indexOf(a)) : a;
  };
  return JSON.stringify(n, s) !== JSON.stringify(e, s);
}
/*!
 * Chart.js v4.4.6
 * https://www.chartjs.org
 * (c) 2024 Chart.js Contributors
 * Released under the MIT License
 */
class FR {
  constructor() {
    this._request = null, this._charts = /* @__PURE__ */ new Map(), this._running = !1, this._lastDate = void 0;
  }
  _notify(e, t, s, r) {
    const a = t.listeners[r], c = t.duration;
    a.forEach((l) => l({
      chart: e,
      initial: t.initial,
      numSteps: c,
      currentStep: Math.min(s - t.start, c)
    }));
  }
  _refresh() {
    this._request || (this._running = !0, this._request = cd.call(window, () => {
      this._update(), this._request = null, this._running && this._refresh();
    }));
  }
  _update(e = Date.now()) {
    let t = 0;
    this._charts.forEach((s, r) => {
      if (!s.running || !s.items.length)
        return;
      const a = s.items;
      let c = a.length - 1, l = !1, d;
      for (; c >= 0; --c)
        d = a[c], d._active ? (d._total > s.duration && (s.duration = d._total), d.tick(e), l = !0) : (a[c] = a[a.length - 1], a.pop());
      l && (r.draw(), this._notify(r, s, e, "progress")), a.length || (s.running = !1, this._notify(r, s, e, "complete"), s.initial = !1), t += a.length;
    }), this._lastDate = e, t === 0 && (this._running = !1);
  }
  _getAnims(e) {
    const t = this._charts;
    let s = t.get(e);
    return s || (s = {
      running: !1,
      initial: !0,
      items: [],
      listeners: {
        complete: [],
        progress: []
      }
    }, t.set(e, s)), s;
  }
  listen(e, t, s) {
    this._getAnims(e).listeners[t].push(s);
  }
  add(e, t) {
    !t || !t.length || this._getAnims(e).items.push(...t);
  }
  has(e) {
    return this._getAnims(e).items.length > 0;
  }
  start(e) {
    const t = this._charts.get(e);
    t && (t.running = !0, t.start = Date.now(), t.duration = t.items.reduce((s, r) => Math.max(s, r._duration), 0), this._refresh());
  }
  running(e) {
    if (!this._running)
      return !1;
    const t = this._charts.get(e);
    return !(!t || !t.running || !t.items.length);
  }
  stop(e) {
    const t = this._charts.get(e);
    if (!t || !t.items.length)
      return;
    const s = t.items;
    let r = s.length - 1;
    for (; r >= 0; --r)
      s[r].cancel();
    t.items = [], this._notify(e, t, Date.now(), "complete");
  }
  remove(e) {
    return this._charts.delete(e);
  }
}
var gi = /* @__PURE__ */ new FR();
const sc = "transparent", BR = {
  boolean(n, e, t) {
    return t > 0.5 ? e : n;
  },
  color(n, e, t) {
    const s = Jl(n || sc), r = s.valid && Jl(e || sc);
    return r && r.valid ? r.mix(s, t).hexString() : e;
  },
  number(n, e, t) {
    return n + (e - n) * t;
  }
};
class qR {
  constructor(e, t, s, r) {
    const a = t[s];
    r = Fs([
      e.to,
      r,
      a,
      e.from
    ]);
    const c = Fs([
      e.from,
      a,
      r
    ]);
    this._active = !0, this._fn = e.fn || BR[e.type || typeof c], this._easing = $n[e.easing] || $n.linear, this._start = Math.floor(Date.now() + (e.delay || 0)), this._duration = this._total = Math.floor(e.duration), this._loop = !!e.loop, this._target = t, this._prop = s, this._from = c, this._to = r, this._promises = void 0;
  }
  active() {
    return this._active;
  }
  update(e, t, s) {
    if (this._active) {
      this._notify(!1);
      const r = this._target[this._prop], a = s - this._start, c = this._duration - a;
      this._start = s, this._duration = Math.floor(Math.max(c, e.duration)), this._total += a, this._loop = !!e.loop, this._to = Fs([
        e.to,
        t,
        r,
        e.from
      ]), this._from = Fs([
        e.from,
        r,
        t
      ]);
    }
  }
  cancel() {
    this._active && (this.tick(Date.now()), this._active = !1, this._notify(!1));
  }
  tick(e) {
    const t = e - this._start, s = this._duration, r = this._prop, a = this._from, c = this._loop, l = this._to;
    let d;
    if (this._active = a !== l && (c || t < s), !this._active) {
      this._target[r] = l, this._notify(!0);
      return;
    }
    if (t < 0) {
      this._target[r] = a;
      return;
    }
    d = t / s % 2, d = c && d > 1 ? 2 - d : d, d = this._easing(Math.min(1, Math.max(0, d))), this._target[r] = this._fn(a, l, d);
  }
  wait() {
    const e = this._promises || (this._promises = []);
    return new Promise((t, s) => {
      e.push({
        res: t,
        rej: s
      });
    });
  }
  _notify(e) {
    const t = e ? "res" : "rej", s = this._promises || [];
    for (let r = 0; r < s.length; r++)
      s[r][t]();
  }
}
class Cd {
  constructor(e, t) {
    this._chart = e, this._properties = /* @__PURE__ */ new Map(), this.configure(t);
  }
  configure(e) {
    if (!Ge(e))
      return;
    const t = Object.keys(ht.animation), s = this._properties;
    Object.getOwnPropertyNames(e).forEach((r) => {
      const a = e[r];
      if (!Ge(a))
        return;
      const c = {};
      for (const l of t)
        c[l] = a[l];
      (ut(a.properties) && a.properties || [
        r
      ]).forEach((l) => {
        (l === r || !s.has(l)) && s.set(l, c);
      });
    });
  }
  _animateOptions(e, t) {
    const s = t.options, r = VR(e, s);
    if (!r)
      return [];
    const a = this._createAnimations(r, s);
    return s.$shared && HR(e.options.$animations, s).then(() => {
      e.options = s;
    }, () => {
    }), a;
  }
  _createAnimations(e, t) {
    const s = this._properties, r = [], a = e.$animations || (e.$animations = {}), c = Object.keys(t), l = Date.now();
    let d;
    for (d = c.length - 1; d >= 0; --d) {
      const h = c[d];
      if (h.charAt(0) === "$")
        continue;
      if (h === "options") {
        r.push(...this._animateOptions(e, t));
        continue;
      }
      const m = t[h];
      let y = a[h];
      const b = s.get(h);
      if (y)
        if (b && y.active()) {
          y.update(b, m, l);
          continue;
        } else
          y.cancel();
      if (!b || !b.duration) {
        e[h] = m;
        continue;
      }
      a[h] = y = new qR(b, e, h, m), r.push(y);
    }
    return r;
  }
  update(e, t) {
    if (this._properties.size === 0) {
      Object.assign(e, t);
      return;
    }
    const s = this._createAnimations(e, t);
    if (s.length)
      return gi.add(this._chart, s), !0;
  }
}
function HR(n, e) {
  const t = [], s = Object.keys(e);
  for (let r = 0; r < s.length; r++) {
    const a = n[s[r]];
    a && a.active() && t.push(a.wait());
  }
  return Promise.all(t);
}
function VR(n, e) {
  if (!e)
    return;
  let t = n.options;
  if (!t) {
    n.options = e;
    return;
  }
  return t.$shared && (n.options = t = Object.assign({}, t, {
    $shared: !1,
    $animations: {}
  })), t;
}
function rc(n, e) {
  const t = n && n.options || {}, s = t.reverse, r = t.min === void 0 ? e : 0, a = t.max === void 0 ? e : 0;
  return {
    start: s ? a : r,
    end: s ? r : a
  };
}
function GR(n, e, t) {
  if (t === !1)
    return !1;
  const s = rc(n, t), r = rc(e, t);
  return {
    top: r.end,
    right: s.end,
    bottom: r.start,
    left: s.start
  };
}
function WR(n) {
  let e, t, s, r;
  return Ge(n) ? (e = n.top, t = n.right, s = n.bottom, r = n.left) : e = t = s = r = n, {
    top: e,
    right: t,
    bottom: s,
    left: r,
    disabled: n === !1
  };
}
function Ed(n, e) {
  const t = [], s = n._getSortedDatasetMetas(e);
  let r, a;
  for (r = 0, a = s.length; r < a; ++r)
    t.push(s[r].index);
  return t;
}
function oc(n, e, t, s = {}) {
  const r = n.keys, a = s.mode === "single";
  let c, l, d, h;
  if (e === null)
    return;
  let m = !1;
  for (c = 0, l = r.length; c < l; ++c) {
    if (d = +r[c], d === t) {
      if (m = !0, s.all)
        continue;
      break;
    }
    h = n.values[d], ft(h) && (a || e === 0 || wn(e) === wn(h)) && (e += h);
  }
  return !m && !s.all ? 0 : e;
}
function KR(n, e) {
  const { iScale: t, vScale: s } = e, r = t.axis === "x" ? "x" : "y", a = s.axis === "x" ? "x" : "y", c = Object.keys(n), l = new Array(c.length);
  let d, h, m;
  for (d = 0, h = c.length; d < h; ++d)
    m = c[d], l[d] = {
      [r]: m,
      [a]: n[m]
    };
  return l;
}
function fo(n, e) {
  const t = n && n.options.stacked;
  return t || t === void 0 && e.stack !== void 0;
}
function YR(n, e, t) {
  return `${n.id}.${e.id}.${t.stack || t.type}`;
}
function JR(n) {
  const { min: e, max: t, minDefined: s, maxDefined: r } = n.getUserBounds();
  return {
    min: s ? e : Number.NEGATIVE_INFINITY,
    max: r ? t : Number.POSITIVE_INFINITY
  };
}
function ZR(n, e, t) {
  const s = n[e] || (n[e] = {});
  return s[t] || (s[t] = {});
}
function ac(n, e, t, s) {
  for (const r of e.getMatchingVisibleMetas(s).reverse()) {
    const a = n[r.index];
    if (t && a > 0 || !t && a < 0)
      return r.index;
  }
  return null;
}
function lc(n, e) {
  const { chart: t, _cachedMeta: s } = n, r = t._stacks || (t._stacks = {}), { iScale: a, vScale: c, index: l } = s, d = a.axis, h = c.axis, m = YR(a, c, s), y = e.length;
  let b;
  for (let v = 0; v < y; ++v) {
    const w = e[v], { [d]: o, [h]: u } = w, f = w._stacks || (w._stacks = {});
    b = f[h] = ZR(r, m, o), b[l] = u, b._top = ac(b, c, !0, s.type), b._bottom = ac(b, c, !1, s.type);
    const p = b._visualValues || (b._visualValues = {});
    p[l] = u;
  }
}
function ho(n, e) {
  const t = n.scales;
  return Object.keys(t).filter((s) => t[s].axis === e).shift();
}
function QR(n, e) {
  return Ni(n, {
    active: !1,
    dataset: void 0,
    datasetIndex: e,
    index: e,
    mode: "default",
    type: "dataset"
  });
}
function XR(n, e, t) {
  return Ni(n, {
    active: !1,
    dataIndex: e,
    parsed: void 0,
    raw: void 0,
    element: t,
    index: e,
    mode: "default",
    type: "data"
  });
}
function Dn(n, e) {
  const t = n.controller.index, s = n.vScale && n.vScale.axis;
  if (s) {
    e = e || n._parsed;
    for (const r of e) {
      const a = r._stacks;
      if (!a || a[s] === void 0 || a[s][t] === void 0)
        return;
      delete a[s][t], a[s]._visualValues !== void 0 && a[s]._visualValues[t] !== void 0 && delete a[s]._visualValues[t];
    }
  }
}
const po = (n) => n === "reset" || n === "none", cc = (n, e) => e ? n : Object.assign({}, n), _R = (n, e, t) => n && !e.hidden && e._stacked && {
  keys: Ed(t, !0),
  values: null
};
class _i {
  constructor(e, t) {
    this.chart = e, this._ctx = e.ctx, this.index = t, this._cachedDataOpts = {}, this._cachedMeta = this.getMeta(), this._type = this._cachedMeta.type, this.options = void 0, this._parsing = !1, this._data = void 0, this._objectData = void 0, this._sharedOptions = void 0, this._drawStart = void 0, this._drawCount = void 0, this.enableOptionSharing = !1, this.supportsDecimation = !1, this.$context = void 0, this._syncList = [], this.datasetElementType = new.target.datasetElementType, this.dataElementType = new.target.dataElementType, this.initialize();
  }
  initialize() {
    const e = this._cachedMeta;
    this.configure(), this.linkScales(), e._stacked = fo(e.vScale, e), this.addElements(), this.options.fill && !this.chart.isPluginEnabled("filler") && console.warn("Tried to use the 'fill' option without the 'Filler' plugin enabled. Please import and register the 'Filler' plugin and make sure it is not disabled in the options");
  }
  updateIndex(e) {
    this.index !== e && Dn(this._cachedMeta), this.index = e;
  }
  linkScales() {
    const e = this.chart, t = this._cachedMeta, s = this.getDataset(), r = (y, b, v, w) => y === "x" ? b : y === "r" ? w : v, a = t.xAxisID = Pe(s.xAxisID, ho(e, "x")), c = t.yAxisID = Pe(s.yAxisID, ho(e, "y")), l = t.rAxisID = Pe(s.rAxisID, ho(e, "r")), d = t.indexAxis, h = t.iAxisID = r(d, a, c, l), m = t.vAxisID = r(d, c, a, l);
    t.xScale = this.getScaleForId(a), t.yScale = this.getScaleForId(c), t.rScale = this.getScaleForId(l), t.iScale = this.getScaleForId(h), t.vScale = this.getScaleForId(m);
  }
  getDataset() {
    return this.chart.data.datasets[this.index];
  }
  getMeta() {
    return this.chart.getDatasetMeta(this.index);
  }
  getScaleForId(e) {
    return this.chart.scales[e];
  }
  _getOtherScale(e) {
    const t = this._cachedMeta;
    return e === t.iScale ? t.vScale : t.iScale;
  }
  reset() {
    this._update("reset");
  }
  _destroy() {
    const e = this._cachedMeta;
    this._data && Wl(this._data, this), e._stacked && Dn(e);
  }
  _dataCheck() {
    const e = this.getDataset(), t = e.data || (e.data = []), s = this._data;
    if (Ge(t)) {
      const r = this._cachedMeta;
      this._data = KR(t, r);
    } else if (s !== t) {
      if (s) {
        Wl(s, this);
        const r = this._cachedMeta;
        Dn(r), r._parsed = [];
      }
      t && Object.isExtensible(t) && Pz(t, this), this._syncList = [], this._data = t;
    }
  }
  addElements() {
    const e = this._cachedMeta;
    this._dataCheck(), this.datasetElementType && (e.dataset = new this.datasetElementType());
  }
  buildOrUpdateElements(e) {
    const t = this._cachedMeta, s = this.getDataset();
    let r = !1;
    this._dataCheck();
    const a = t._stacked;
    t._stacked = fo(t.vScale, t), t.stack !== s.stack && (r = !0, Dn(t), t.stack = s.stack), this._resyncElements(e), (r || a !== t._stacked) && (lc(this, t._parsed), t._stacked = fo(t.vScale, t));
  }
  configure() {
    const e = this.chart.config, t = e.datasetScopeKeys(this._type), s = e.getOptionScopes(this.getDataset(), t, !0);
    this.options = e.createResolver(s, this.getContext()), this._parsing = this.options.parsing, this._cachedDataOpts = {};
  }
  parse(e, t) {
    const { _cachedMeta: s, _data: r } = this, { iScale: a, _stacked: c } = s, l = a.axis;
    let d = e === 0 && t === r.length ? !0 : s._sorted, h = e > 0 && s._parsed[e - 1], m, y, b;
    if (this._parsing === !1)
      s._parsed = r, s._sorted = !0, b = r;
    else {
      ut(r[e]) ? b = this.parseArrayData(s, r, e, t) : Ge(r[e]) ? b = this.parseObjectData(s, r, e, t) : b = this.parsePrimitiveData(s, r, e, t);
      const v = () => y[l] === null || h && y[l] < h[l];
      for (m = 0; m < t; ++m)
        s._parsed[m + e] = y = b[m], d && (v() && (d = !1), h = y);
      s._sorted = d;
    }
    c && lc(this, b);
  }
  parsePrimitiveData(e, t, s, r) {
    const { iScale: a, vScale: c } = e, l = a.axis, d = c.axis, h = a.getLabels(), m = a === c, y = new Array(r);
    let b, v, w;
    for (b = 0, v = r; b < v; ++b)
      w = b + s, y[b] = {
        [l]: m || a.parse(h[w], w),
        [d]: c.parse(t[w], w)
      };
    return y;
  }
  parseArrayData(e, t, s, r) {
    const { xScale: a, yScale: c } = e, l = new Array(r);
    let d, h, m, y;
    for (d = 0, h = r; d < h; ++d)
      m = d + s, y = t[m], l[d] = {
        x: a.parse(y[0], m),
        y: c.parse(y[1], m)
      };
    return l;
  }
  parseObjectData(e, t, s, r) {
    const { xScale: a, yScale: c } = e, { xAxisKey: l = "x", yAxisKey: d = "y" } = this._parsing, h = new Array(r);
    let m, y, b, v;
    for (m = 0, y = r; m < y; ++m)
      b = m + s, v = t[b], h[m] = {
        x: a.parse(cs(v, l), b),
        y: c.parse(cs(v, d), b)
      };
    return h;
  }
  getParsed(e) {
    return this._cachedMeta._parsed[e];
  }
  getDataElement(e) {
    return this._cachedMeta.data[e];
  }
  applyStack(e, t, s) {
    const r = this.chart, a = this._cachedMeta, c = t[e.axis], l = {
      keys: Ed(r, !0),
      values: t._stacks[e.axis]._visualValues
    };
    return oc(l, c, a.index, {
      mode: s
    });
  }
  updateRangeFromParsed(e, t, s, r) {
    const a = s[t.axis];
    let c = a === null ? NaN : a;
    const l = r && s._stacks[t.axis];
    r && l && (r.values = l, c = oc(r, a, this._cachedMeta.index)), e.min = Math.min(e.min, c), e.max = Math.max(e.max, c);
  }
  getMinMax(e, t) {
    const s = this._cachedMeta, r = s._parsed, a = s._sorted && e === s.iScale, c = r.length, l = this._getOtherScale(e), d = _R(t, s, this.chart), h = {
      min: Number.POSITIVE_INFINITY,
      max: Number.NEGATIVE_INFINITY
    }, { min: m, max: y } = JR(l);
    let b, v;
    function w() {
      v = r[b];
      const o = v[l.axis];
      return !ft(v[e.axis]) || m > o || y < o;
    }
    for (b = 0; b < c && !(!w() && (this.updateRangeFromParsed(h, e, v, d), a)); ++b)
      ;
    if (a) {
      for (b = c - 1; b >= 0; --b)
        if (!w()) {
          this.updateRangeFromParsed(h, e, v, d);
          break;
        }
    }
    return h;
  }
  getAllParsedValues(e) {
    const t = this._cachedMeta._parsed, s = [];
    let r, a, c;
    for (r = 0, a = t.length; r < a; ++r)
      c = t[r][e.axis], ft(c) && s.push(c);
    return s;
  }
  getMaxOverflow() {
    return !1;
  }
  getLabelAndValue(e) {
    const t = this._cachedMeta, s = t.iScale, r = t.vScale, a = this.getParsed(e);
    return {
      label: s ? "" + s.getLabelForValue(a[s.axis]) : "",
      value: r ? "" + r.getLabelForValue(a[r.axis]) : ""
    };
  }
  _update(e) {
    const t = this._cachedMeta;
    this.update(e || "default"), t._clip = WR(Pe(this.options.clip, GR(t.xScale, t.yScale, this.getMaxOverflow())));
  }
  update(e) {
  }
  draw() {
    const e = this._ctx, t = this.chart, s = this._cachedMeta, r = s.data || [], a = t.chartArea, c = [], l = this._drawStart || 0, d = this._drawCount || r.length - l, h = this.options.drawActiveElementsOnTop;
    let m;
    for (s.dataset && s.dataset.draw(e, a, l, d), m = l; m < l + d; ++m) {
      const y = r[m];
      y.hidden || (y.active && h ? c.push(y) : y.draw(e, a));
    }
    for (m = 0; m < c.length; ++m)
      c[m].draw(e, a);
  }
  getStyle(e, t) {
    const s = t ? "active" : "default";
    return e === void 0 && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(s) : this.resolveDataElementOptions(e || 0, s);
  }
  getContext(e, t, s) {
    const r = this.getDataset();
    let a;
    if (e >= 0 && e < this._cachedMeta.data.length) {
      const c = this._cachedMeta.data[e];
      a = c.$context || (c.$context = XR(this.getContext(), e, c)), a.parsed = this.getParsed(e), a.raw = r.data[e], a.index = a.dataIndex = e;
    } else
      a = this.$context || (this.$context = QR(this.chart.getContext(), this.index)), a.dataset = r, a.index = a.datasetIndex = this.index;
    return a.active = !!t, a.mode = s, a;
  }
  resolveDatasetElementOptions(e) {
    return this._resolveElementOptions(this.datasetElementType.id, e);
  }
  resolveDataElementOptions(e, t) {
    return this._resolveElementOptions(this.dataElementType.id, t, e);
  }
  _resolveElementOptions(e, t = "default", s) {
    const r = t === "active", a = this._cachedDataOpts, c = e + "-" + t, l = a[c], d = this.enableOptionSharing && wr(s);
    if (l)
      return cc(l, d);
    const h = this.chart.config, m = h.datasetElementScopeKeys(this._type, e), y = r ? [
      `${e}Hover`,
      "hover",
      e,
      ""
    ] : [
      e,
      ""
    ], b = h.getOptionScopes(this.getDataset(), m), v = Object.keys(ht.elements[e]), w = () => this.getContext(s, r, t), o = h.resolveNamedOptions(b, v, w, y);
    return o.$shared && (o.$shared = d, a[c] = Object.freeze(cc(o, d))), o;
  }
  _resolveAnimations(e, t, s) {
    const r = this.chart, a = this._cachedDataOpts, c = `animation-${t}`, l = a[c];
    if (l)
      return l;
    let d;
    if (r.options.animation !== !1) {
      const m = this.chart.config, y = m.datasetAnimationScopeKeys(this._type, t), b = m.getOptionScopes(this.getDataset(), y);
      d = m.createResolver(b, this.getContext(e, s, t));
    }
    const h = new Cd(r, d && d.animations);
    return d && d._cacheable && (a[c] = Object.freeze(h)), h;
  }
  getSharedOptions(e) {
    if (e.$shared)
      return this._sharedOptions || (this._sharedOptions = Object.assign({}, e));
  }
  includeOptions(e, t) {
    return !t || po(e) || this.chart._animationsDisabled;
  }
  _getSharedOptions(e, t) {
    const s = this.resolveDataElementOptions(e, t), r = this._sharedOptions, a = this.getSharedOptions(s), c = this.includeOptions(t, a) || a !== r;
    return this.updateSharedOptions(a, t, s), {
      sharedOptions: a,
      includeOptions: c
    };
  }
  updateElement(e, t, s, r) {
    po(r) ? Object.assign(e, s) : this._resolveAnimations(t, r).update(e, s);
  }
  updateSharedOptions(e, t, s) {
    e && !po(t) && this._resolveAnimations(void 0, t).update(e, s);
  }
  _setStyle(e, t, s, r) {
    e.active = r;
    const a = this.getStyle(t, r);
    this._resolveAnimations(t, s, r).update(e, {
      options: !r && this.getSharedOptions(a) || a
    });
  }
  removeHoverStyle(e, t, s) {
    this._setStyle(e, s, "active", !1);
  }
  setHoverStyle(e, t, s) {
    this._setStyle(e, s, "active", !0);
  }
  _removeDatasetHoverStyle() {
    const e = this._cachedMeta.dataset;
    e && this._setStyle(e, void 0, "active", !1);
  }
  _setDatasetHoverStyle() {
    const e = this._cachedMeta.dataset;
    e && this._setStyle(e, void 0, "active", !0);
  }
  _resyncElements(e) {
    const t = this._data, s = this._cachedMeta.data;
    for (const [l, d, h] of this._syncList)
      this[l](d, h);
    this._syncList = [];
    const r = s.length, a = t.length, c = Math.min(a, r);
    c && this.parse(0, c), a > r ? this._insertElements(r, a - r, e) : a < r && this._removeElements(a, r - a);
  }
  _insertElements(e, t, s = !0) {
    const r = this._cachedMeta, a = r.data, c = e + t;
    let l;
    const d = (h) => {
      for (h.length += t, l = h.length - 1; l >= c; l--)
        h[l] = h[l - t];
    };
    for (d(a), l = e; l < c; ++l)
      a[l] = new this.dataElementType();
    this._parsing && d(r._parsed), this.parse(e, t), s && this.updateElements(a, e, t, "reset");
  }
  updateElements(e, t, s, r) {
  }
  _removeElements(e, t) {
    const s = this._cachedMeta;
    if (this._parsing) {
      const r = s._parsed.splice(e, t);
      s._stacked && Dn(s, r);
    }
    s.data.splice(e, t);
  }
  _sync(e) {
    if (this._parsing)
      this._syncList.push(e);
    else {
      const [t, s, r] = e;
      this[t](s, r);
    }
    this.chart._dataChanges.push([
      this.index,
      ...e
    ]);
  }
  _onDataPush() {
    const e = arguments.length;
    this._sync([
      "_insertElements",
      this.getDataset().data.length - e,
      e
    ]);
  }
  _onDataPop() {
    this._sync([
      "_removeElements",
      this._cachedMeta.data.length - 1,
      1
    ]);
  }
  _onDataShift() {
    this._sync([
      "_removeElements",
      0,
      1
    ]);
  }
  _onDataSplice(e, t) {
    t && this._sync([
      "_removeElements",
      e,
      t
    ]);
    const s = arguments.length - 2;
    s && this._sync([
      "_insertElements",
      e,
      s
    ]);
  }
  _onDataUnshift() {
    this._sync([
      "_insertElements",
      0,
      arguments.length
    ]);
  }
}
oe(_i, "defaults", {}), oe(_i, "datasetElementType", null), oe(_i, "dataElementType", null);
class ir extends _i {
  initialize() {
    this.enableOptionSharing = !0, super.initialize();
  }
  parsePrimitiveData(e, t, s, r) {
    const a = super.parsePrimitiveData(e, t, s, r);
    for (let c = 0; c < a.length; c++)
      a[c]._custom = this.resolveDataElementOptions(c + s).radius;
    return a;
  }
  parseArrayData(e, t, s, r) {
    const a = super.parseArrayData(e, t, s, r);
    for (let c = 0; c < a.length; c++) {
      const l = t[s + c];
      a[c]._custom = Pe(l[2], this.resolveDataElementOptions(c + s).radius);
    }
    return a;
  }
  parseObjectData(e, t, s, r) {
    const a = super.parseObjectData(e, t, s, r);
    for (let c = 0; c < a.length; c++) {
      const l = t[s + c];
      a[c]._custom = Pe(l && l.r && +l.r, this.resolveDataElementOptions(c + s).radius);
    }
    return a;
  }
  getMaxOverflow() {
    const e = this._cachedMeta.data;
    let t = 0;
    for (let s = e.length - 1; s >= 0; --s)
      t = Math.max(t, e[s].size(this.resolveDataElementOptions(s)) / 2);
    return t > 0 && t;
  }
  getLabelAndValue(e) {
    const t = this._cachedMeta, s = this.chart.data.labels || [], { xScale: r, yScale: a } = t, c = this.getParsed(e), l = r.getLabelForValue(c.x), d = a.getLabelForValue(c.y), h = c._custom;
    return {
      label: s[e] || "",
      value: "(" + l + ", " + d + (h ? ", " + h : "") + ")"
    };
  }
  update(e) {
    const t = this._cachedMeta.data;
    this.updateElements(t, 0, t.length, e);
  }
  updateElements(e, t, s, r) {
    const a = r === "reset", { iScale: c, vScale: l } = this._cachedMeta, { sharedOptions: d, includeOptions: h } = this._getSharedOptions(t, r), m = c.axis, y = l.axis;
    for (let b = t; b < t + s; b++) {
      const v = e[b], w = !a && this.getParsed(b), o = {}, u = o[m] = a ? c.getPixelForDecimal(0.5) : c.getPixelForValue(w[m]), f = o[y] = a ? l.getBasePixel() : l.getPixelForValue(w[y]);
      o.skip = isNaN(u) || isNaN(f), h && (o.options = d || this.resolveDataElementOptions(b, v.active ? "active" : r), a && (o.options.radius = 0)), this.updateElement(v, b, o, r);
    }
  }
  resolveDataElementOptions(e, t) {
    const s = this.getParsed(e);
    let r = super.resolveDataElementOptions(e, t);
    r.$shared && (r = Object.assign({}, r, {
      $shared: !1
    }));
    const a = r.radius;
    return t !== "active" && (r.radius = 0), r.radius += Pe(s && s._custom, a), r;
  }
}
oe(ir, "id", "bubble"), oe(ir, "defaults", {
  datasetElementType: !1,
  dataElementType: "point",
  animations: {
    numbers: {
      type: "number",
      properties: [
        "x",
        "y",
        "borderWidth",
        "radius"
      ]
    }
  }
}), oe(ir, "overrides", {
  scales: {
    x: {
      type: "linear"
    },
    y: {
      type: "linear"
    }
  }
});
function $R(n, e, t) {
  let s = 1, r = 1, a = 0, c = 0;
  if (e < ot) {
    const l = n, d = l + e, h = Math.cos(l), m = Math.sin(l), y = Math.cos(d), b = Math.sin(d), v = (g, S, x) => ds(g, l, d, !0) ? 1 : Math.max(S, S * t, x, x * t), w = (g, S, x) => ds(g, l, d, !0) ? -1 : Math.min(S, S * t, x, x * t), o = v(0, h, y), u = v(bt, m, b), f = w(pt, h, y), p = w(pt + bt, m, b);
    s = (o - f) / 2, r = (u - p) / 2, a = -(o + f) / 2, c = -(u + p) / 2;
  }
  return {
    ratioX: s,
    ratioY: r,
    offsetX: a,
    offsetY: c
  };
}
class Gn extends _i {
  constructor(e, t) {
    super(e, t), this.enableOptionSharing = !0, this.innerRadius = void 0, this.outerRadius = void 0, this.offsetX = void 0, this.offsetY = void 0;
  }
  linkScales() {
  }
  parse(e, t) {
    const s = this.getDataset().data, r = this._cachedMeta;
    if (this._parsing === !1)
      r._parsed = s;
    else {
      let a = (d) => +s[d];
      if (Ge(s[e])) {
        const { key: d = "value" } = this._parsing;
        a = (h) => +cs(s[h], d);
      }
      let c, l;
      for (c = e, l = e + t; c < l; ++c)
        r._parsed[c] = a(c);
    }
  }
  _getRotation() {
    return li(this.options.rotation - 90);
  }
  _getCircumference() {
    return li(this.options.circumference);
  }
  _getRotationExtents() {
    let e = ot, t = -ot;
    for (let s = 0; s < this.chart.data.datasets.length; ++s)
      if (this.chart.isDatasetVisible(s) && this.chart.getDatasetMeta(s).type === this._type) {
        const r = this.chart.getDatasetMeta(s).controller, a = r._getRotation(), c = r._getCircumference();
        e = Math.min(e, a), t = Math.max(t, a + c);
      }
    return {
      rotation: e,
      circumference: t - e
    };
  }
  update(e) {
    const t = this.chart, { chartArea: s } = t, r = this._cachedMeta, a = r.data, c = this.getMaxBorderWidth() + this.getMaxOffset(a) + this.options.spacing, l = Math.max((Math.min(s.width, s.height) - c) / 2, 0), d = Math.min(bz(this.options.cutout, l), 1), h = this._getRingWeight(this.index), { circumference: m, rotation: y } = this._getRotationExtents(), { ratioX: b, ratioY: v, offsetX: w, offsetY: o } = $R(y, m, d), u = (s.width - c) / b, f = (s.height - c) / v, p = Math.max(Math.min(u, f) / 2, 0), g = sd(this.options.radius, p), S = Math.max(g * d, 0), x = (g - S) / this._getVisibleDatasetWeightTotal();
    this.offsetX = w * g, this.offsetY = o * g, r.total = this.calculateTotal(), this.outerRadius = g - x * this._getRingWeightOffset(this.index), this.innerRadius = Math.max(this.outerRadius - x * h, 0), this.updateElements(a, 0, a.length, e);
  }
  _circumference(e, t) {
    const s = this.options, r = this._cachedMeta, a = this._getCircumference();
    return t && s.animation.animateRotate || !this.chart.getDataVisibility(e) || r._parsed[e] === null || r.data[e].hidden ? 0 : this.calculateCircumference(r._parsed[e] * a / ot);
  }
  updateElements(e, t, s, r) {
    const a = r === "reset", c = this.chart, l = c.chartArea, h = c.options.animation, m = (l.left + l.right) / 2, y = (l.top + l.bottom) / 2, b = a && h.animateScale, v = b ? 0 : this.innerRadius, w = b ? 0 : this.outerRadius, { sharedOptions: o, includeOptions: u } = this._getSharedOptions(t, r);
    let f = this._getRotation(), p;
    for (p = 0; p < t; ++p)
      f += this._circumference(p, a);
    for (p = t; p < t + s; ++p) {
      const g = this._circumference(p, a), S = e[p], x = {
        x: m + this.offsetX,
        y: y + this.offsetY,
        startAngle: f,
        endAngle: f + g,
        circumference: g,
        outerRadius: w,
        innerRadius: v
      };
      u && (x.options = o || this.resolveDataElementOptions(p, S.active ? "active" : r)), f += g, this.updateElement(S, p, x, r);
    }
  }
  calculateTotal() {
    const e = this._cachedMeta, t = e.data;
    let s = 0, r;
    for (r = 0; r < t.length; r++) {
      const a = e._parsed[r];
      a !== null && !isNaN(a) && this.chart.getDataVisibility(r) && !t[r].hidden && (s += Math.abs(a));
    }
    return s;
  }
  calculateCircumference(e) {
    const t = this._cachedMeta.total;
    return t > 0 && !isNaN(e) ? ot * (Math.abs(e) / t) : 0;
  }
  getLabelAndValue(e) {
    const t = this._cachedMeta, s = this.chart, r = s.data.labels || [], a = Lr(t._parsed[e], s.options.locale);
    return {
      label: r[e] || "",
      value: a
    };
  }
  getMaxBorderWidth(e) {
    let t = 0;
    const s = this.chart;
    let r, a, c, l, d;
    if (!e) {
      for (r = 0, a = s.data.datasets.length; r < a; ++r)
        if (s.isDatasetVisible(r)) {
          c = s.getDatasetMeta(r), e = c.data, l = c.controller;
          break;
        }
    }
    if (!e)
      return 0;
    for (r = 0, a = e.length; r < a; ++r)
      d = l.resolveDataElementOptions(r), d.borderAlign !== "inner" && (t = Math.max(t, d.borderWidth || 0, d.hoverBorderWidth || 0));
    return t;
  }
  getMaxOffset(e) {
    let t = 0;
    for (let s = 0, r = e.length; s < r; ++s) {
      const a = this.resolveDataElementOptions(s);
      t = Math.max(t, a.offset || 0, a.hoverOffset || 0);
    }
    return t;
  }
  _getRingWeightOffset(e) {
    let t = 0;
    for (let s = 0; s < e; ++s)
      this.chart.isDatasetVisible(s) && (t += this._getRingWeight(s));
    return t;
  }
  _getRingWeight(e) {
    return Math.max(Pe(this.chart.data.datasets[e].weight, 1), 0);
  }
  _getVisibleDatasetWeightTotal() {
    return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
  }
}
oe(Gn, "id", "doughnut"), oe(Gn, "defaults", {
  datasetElementType: !1,
  dataElementType: "arc",
  animation: {
    animateRotate: !0,
    animateScale: !1
  },
  animations: {
    numbers: {
      type: "number",
      properties: [
        "circumference",
        "endAngle",
        "innerRadius",
        "outerRadius",
        "startAngle",
        "x",
        "y",
        "offset",
        "borderWidth",
        "spacing"
      ]
    }
  },
  cutout: "50%",
  rotation: 0,
  circumference: 360,
  radius: "100%",
  spacing: 0,
  indexAxis: "r"
}), oe(Gn, "descriptors", {
  _scriptable: (e) => e !== "spacing",
  _indexable: (e) => e !== "spacing" && !e.startsWith("borderDash") && !e.startsWith("hoverBorderDash")
}), oe(Gn, "overrides", {
  aspectRatio: 1,
  plugins: {
    legend: {
      labels: {
        generateLabels(e) {
          const t = e.data;
          if (t.labels.length && t.datasets.length) {
            const { labels: { pointStyle: s, color: r } } = e.legend.options;
            return t.labels.map((a, c) => {
              const d = e.getDatasetMeta(0).controller.getStyle(c);
              return {
                text: a,
                fillStyle: d.backgroundColor,
                strokeStyle: d.borderColor,
                fontColor: r,
                lineWidth: d.borderWidth,
                pointStyle: s,
                hidden: !e.getDataVisibility(c),
                index: c
              };
            });
          }
          return [];
        }
      },
      onClick(e, t, s) {
        s.chart.toggleDataVisibility(t.index), s.chart.update();
      }
    }
  }
});
class nr extends _i {
  initialize() {
    this.enableOptionSharing = !0, this.supportsDecimation = !0, super.initialize();
  }
  update(e) {
    const t = this._cachedMeta, { dataset: s, data: r = [], _dataset: a } = t, c = this.chart._animationsDisabled;
    let { start: l, count: d } = Dz(t, r, c);
    this._drawStart = l, this._drawCount = d, Nz(t) && (l = 0, d = r.length), s._chart = this.chart, s._datasetIndex = this.index, s._decimated = !!a._decimated, s.points = r;
    const h = this.resolveDatasetElementOptions(e);
    this.options.showLine || (h.borderWidth = 0), h.segment = this.options.segment, this.updateElement(s, void 0, {
      animated: !c,
      options: h
    }, e), this.updateElements(r, l, d, e);
  }
  updateElements(e, t, s, r) {
    const a = r === "reset", { iScale: c, vScale: l, _stacked: d, _dataset: h } = this._cachedMeta, { sharedOptions: m, includeOptions: y } = this._getSharedOptions(t, r), b = c.axis, v = l.axis, { spanGaps: w, segment: o } = this.options, u = us(w) ? w : Number.POSITIVE_INFINITY, f = this.chart._animationsDisabled || a || r === "none", p = t + s, g = e.length;
    let S = t > 0 && this.getParsed(t - 1);
    for (let x = 0; x < g; ++x) {
      const E = e[x], k = f ? E : {};
      if (x < t || x >= p) {
        k.skip = !0;
        continue;
      }
      const R = this.getParsed(x), O = rt(R[v]), T = k[b] = c.getPixelForValue(R[b], x), D = k[v] = a || O ? l.getBasePixel() : l.getPixelForValue(d ? this.applyStack(l, R, d) : R[v], x);
      k.skip = isNaN(T) || isNaN(D) || O, k.stop = x > 0 && Math.abs(R[b] - S[b]) > u, o && (k.parsed = R, k.raw = h.data[x]), y && (k.options = m || this.resolveDataElementOptions(x, E.active ? "active" : r)), f || this.updateElement(E, x, k, r), S = R;
    }
  }
  getMaxOverflow() {
    const e = this._cachedMeta, t = e.dataset, s = t.options && t.options.borderWidth || 0, r = e.data || [];
    if (!r.length)
      return s;
    const a = r[0].size(this.resolveDataElementOptions(0)), c = r[r.length - 1].size(this.resolveDataElementOptions(r.length - 1));
    return Math.max(s, a, c) / 2;
  }
  draw() {
    const e = this._cachedMeta;
    e.dataset.updateControlPoints(this.chart.chartArea, e.iScale.axis), super.draw();
  }
}
oe(nr, "id", "line"), oe(nr, "defaults", {
  datasetElementType: "line",
  dataElementType: "point",
  showLine: !0,
  spanGaps: !1
}), oe(nr, "overrides", {
  scales: {
    _index_: {
      type: "category"
    },
    _value_: {
      type: "linear"
    }
  }
});
function Vi() {
  throw new Error("This method is not implemented: Check that a complete date adapter is provided.");
}
class Ta {
  constructor(e) {
    oe(this, "options");
    this.options = e || {};
  }
  /**
  * Override default date adapter methods.
  * Accepts type parameter to define options type.
  * @example
  * Chart._adapters._date.override<{myAdapterOption: string}>({
  *   init() {
  *     console.log(this.options.myAdapterOption);
  *   }
  * })
  */
  static override(e) {
    Object.assign(Ta.prototype, e);
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  init() {
  }
  formats() {
    return Vi();
  }
  parse() {
    return Vi();
  }
  format() {
    return Vi();
  }
  add() {
    return Vi();
  }
  diff() {
    return Vi();
  }
  startOf() {
    return Vi();
  }
  endOf() {
    return Vi();
  }
}
var eP = {
  _date: Ta
};
function tP(n, e, t, s) {
  const { controller: r, data: a, _sorted: c } = n, l = r._cachedMeta.iScale;
  if (l && e === l.axis && e !== "r" && c && a.length) {
    const d = l._reversePixels ? zz : Ji;
    if (s) {
      if (r._sharedOptions) {
        const h = a[0], m = typeof h.getRange == "function" && h.getRange(e);
        if (m) {
          const y = d(a, e, t - m), b = d(a, e, t + m);
          return {
            lo: y.lo,
            hi: b.hi
          };
        }
      }
    } else
      return d(a, e, t);
  }
  return {
    lo: 0,
    hi: a.length - 1
  };
}
function xs(n, e, t, s, r) {
  const a = n.getSortedVisibleDatasetMetas(), c = t[e];
  for (let l = 0, d = a.length; l < d; ++l) {
    const { index: h, data: m } = a[l], { lo: y, hi: b } = tP(a[l], e, c, r);
    for (let v = y; v <= b; ++v) {
      const w = m[v];
      w.skip || s(w, h, v);
    }
  }
}
function iP(n) {
  const e = n.indexOf("x") !== -1, t = n.indexOf("y") !== -1;
  return function(s, r) {
    const a = e ? Math.abs(s.x - r.x) : 0, c = t ? Math.abs(s.y - r.y) : 0;
    return Math.sqrt(Math.pow(a, 2) + Math.pow(c, 2));
  };
}
function mo(n, e, t, s, r) {
  const a = [];
  return !r && !n.isPointInArea(e) || xs(n, t, e, function(l, d, h) {
    !r && !xi(l, n.chartArea, 0) || l.inRange(e.x, e.y, s) && a.push({
      element: l,
      datasetIndex: d,
      index: h
    });
  }, !0), a;
}
function nP(n, e, t, s) {
  let r = [];
  function a(c, l, d) {
    const { startAngle: h, endAngle: m } = c.getProps([
      "startAngle",
      "endAngle"
    ], s), { angle: y } = ad(c, {
      x: e.x,
      y: e.y
    });
    ds(y, h, m) && r.push({
      element: c,
      datasetIndex: l,
      index: d
    });
  }
  return xs(n, t, e, a), r;
}
function sP(n, e, t, s, r, a) {
  let c = [];
  const l = iP(t);
  let d = Number.POSITIVE_INFINITY;
  function h(m, y, b) {
    const v = m.inRange(e.x, e.y, r);
    if (s && !v)
      return;
    const w = m.getCenterPoint(r);
    if (!(!!a || n.isPointInArea(w)) && !v)
      return;
    const u = l(e, w);
    u < d ? (c = [
      {
        element: m,
        datasetIndex: y,
        index: b
      }
    ], d = u) : u === d && c.push({
      element: m,
      datasetIndex: y,
      index: b
    });
  }
  return xs(n, t, e, h), c;
}
function go(n, e, t, s, r, a) {
  return !a && !n.isPointInArea(e) ? [] : t === "r" && !s ? nP(n, e, t, r) : sP(n, e, t, s, r, a);
}
function uc(n, e, t, s, r) {
  const a = [], c = t === "x" ? "inXRange" : "inYRange";
  let l = !1;
  return xs(n, t, e, (d, h, m) => {
    d[c] && d[c](e[t], r) && (a.push({
      element: d,
      datasetIndex: h,
      index: m
    }), l = l || d.inRange(e.x, e.y, r));
  }), s && !l ? [] : a;
}
var rP = {
  evaluateInteractionItems: xs,
  modes: {
    index(n, e, t, s) {
      const r = Wi(e, n), a = t.axis || "x", c = t.includeInvisible || !1, l = t.intersect ? mo(n, r, a, s, c) : go(n, r, a, !1, s, c), d = [];
      return l.length ? (n.getSortedVisibleDatasetMetas().forEach((h) => {
        const m = l[0].index, y = h.data[m];
        y && !y.skip && d.push({
          element: y,
          datasetIndex: h.index,
          index: m
        });
      }), d) : [];
    },
    dataset(n, e, t, s) {
      const r = Wi(e, n), a = t.axis || "xy", c = t.includeInvisible || !1;
      let l = t.intersect ? mo(n, r, a, s, c) : go(n, r, a, !1, s, c);
      if (l.length > 0) {
        const d = l[0].datasetIndex, h = n.getDatasetMeta(d).data;
        l = [];
        for (let m = 0; m < h.length; ++m)
          l.push({
            element: h[m],
            datasetIndex: d,
            index: m
          });
      }
      return l;
    },
    point(n, e, t, s) {
      const r = Wi(e, n), a = t.axis || "xy", c = t.includeInvisible || !1;
      return mo(n, r, a, s, c);
    },
    nearest(n, e, t, s) {
      const r = Wi(e, n), a = t.axis || "xy", c = t.includeInvisible || !1;
      return go(n, r, a, t.intersect, s, c);
    },
    x(n, e, t, s) {
      const r = Wi(e, n);
      return uc(n, r, "x", t.intersect, s);
    },
    y(n, e, t, s) {
      const r = Wi(e, n);
      return uc(n, r, "y", t.intersect, s);
    }
  }
};
const kd = [
  "left",
  "top",
  "right",
  "bottom"
];
function Nn(n, e) {
  return n.filter((t) => t.pos === e);
}
function dc(n, e) {
  return n.filter((t) => kd.indexOf(t.pos) === -1 && t.box.axis === e);
}
function Fn(n, e) {
  return n.sort((t, s) => {
    const r = e ? s : t, a = e ? t : s;
    return r.weight === a.weight ? r.index - a.index : r.weight - a.weight;
  });
}
function oP(n) {
  const e = [];
  let t, s, r, a, c, l;
  for (t = 0, s = (n || []).length; t < s; ++t)
    r = n[t], { position: a, options: { stack: c, stackWeight: l = 1 } } = r, e.push({
      index: t,
      box: r,
      pos: a,
      horizontal: r.isHorizontal(),
      weight: r.weight,
      stack: c && a + c,
      stackWeight: l
    });
  return e;
}
function aP(n) {
  const e = {};
  for (const t of n) {
    const { stack: s, pos: r, stackWeight: a } = t;
    if (!s || !kd.includes(r))
      continue;
    const c = e[s] || (e[s] = {
      count: 0,
      placed: 0,
      weight: 0,
      size: 0
    });
    c.count++, c.weight += a;
  }
  return e;
}
function lP(n, e) {
  const t = aP(n), { vBoxMaxWidth: s, hBoxMaxHeight: r } = e;
  let a, c, l;
  for (a = 0, c = n.length; a < c; ++a) {
    l = n[a];
    const { fullSize: d } = l.box, h = t[l.stack], m = h && l.stackWeight / h.weight;
    l.horizontal ? (l.width = m ? m * s : d && e.availableWidth, l.height = r) : (l.width = s, l.height = m ? m * r : d && e.availableHeight);
  }
  return t;
}
function cP(n) {
  const e = oP(n), t = Fn(e.filter((h) => h.box.fullSize), !0), s = Fn(Nn(e, "left"), !0), r = Fn(Nn(e, "right")), a = Fn(Nn(e, "top"), !0), c = Fn(Nn(e, "bottom")), l = dc(e, "x"), d = dc(e, "y");
  return {
    fullSize: t,
    leftAndTop: s.concat(a),
    rightAndBottom: r.concat(d).concat(c).concat(l),
    chartArea: Nn(e, "chartArea"),
    vertical: s.concat(r).concat(d),
    horizontal: a.concat(c).concat(l)
  };
}
function fc(n, e, t, s) {
  return Math.max(n[t], e[t]) + Math.max(n[s], e[s]);
}
function Od(n, e) {
  n.top = Math.max(n.top, e.top), n.left = Math.max(n.left, e.left), n.bottom = Math.max(n.bottom, e.bottom), n.right = Math.max(n.right, e.right);
}
function uP(n, e, t, s) {
  const { pos: r, box: a } = t, c = n.maxPadding;
  if (!Ge(r)) {
    t.size && (n[r] -= t.size);
    const y = s[t.stack] || {
      size: 0,
      count: 1
    };
    y.size = Math.max(y.size, t.horizontal ? a.height : a.width), t.size = y.size / y.count, n[r] += t.size;
  }
  a.getPadding && Od(c, a.getPadding());
  const l = Math.max(0, e.outerWidth - fc(c, n, "left", "right")), d = Math.max(0, e.outerHeight - fc(c, n, "top", "bottom")), h = l !== n.w, m = d !== n.h;
  return n.w = l, n.h = d, t.horizontal ? {
    same: h,
    other: m
  } : {
    same: m,
    other: h
  };
}
function dP(n) {
  const e = n.maxPadding;
  function t(s) {
    const r = Math.max(e[s] - n[s], 0);
    return n[s] += r, r;
  }
  n.y += t("top"), n.x += t("left"), t("right"), t("bottom");
}
function fP(n, e) {
  const t = e.maxPadding;
  function s(r) {
    const a = {
      left: 0,
      top: 0,
      right: 0,
      bottom: 0
    };
    return r.forEach((c) => {
      a[c] = Math.max(e[c], t[c]);
    }), a;
  }
  return s(n ? [
    "left",
    "right"
  ] : [
    "top",
    "bottom"
  ]);
}
function Wn(n, e, t, s) {
  const r = [];
  let a, c, l, d, h, m;
  for (a = 0, c = n.length, h = 0; a < c; ++a) {
    l = n[a], d = l.box, d.update(l.width || e.w, l.height || e.h, fP(l.horizontal, e));
    const { same: y, other: b } = uP(e, t, l, s);
    h |= y && r.length, m = m || b, d.fullSize || r.push(l);
  }
  return h && Wn(r, e, t, s) || m;
}
function Hs(n, e, t, s, r) {
  n.top = t, n.left = e, n.right = e + s, n.bottom = t + r, n.width = s, n.height = r;
}
function hc(n, e, t, s) {
  const r = t.padding;
  let { x: a, y: c } = e;
  for (const l of n) {
    const d = l.box, h = s[l.stack] || {
      count: 1,
      placed: 0,
      weight: 1
    }, m = l.stackWeight / h.weight || 1;
    if (l.horizontal) {
      const y = e.w * m, b = h.size || d.height;
      wr(h.start) && (c = h.start), d.fullSize ? Hs(d, r.left, c, t.outerWidth - r.right - r.left, b) : Hs(d, e.left + h.placed, c, y, b), h.start = c, h.placed += y, c = d.bottom;
    } else {
      const y = e.h * m, b = h.size || d.width;
      wr(h.start) && (a = h.start), d.fullSize ? Hs(d, a, r.top, b, t.outerHeight - r.bottom - r.top) : Hs(d, a, e.top + h.placed, b, y), h.start = a, h.placed += y, a = d.right;
    }
  }
  e.x = a, e.y = c;
}
var zi = {
  addBox(n, e) {
    n.boxes || (n.boxes = []), e.fullSize = e.fullSize || !1, e.position = e.position || "top", e.weight = e.weight || 0, e._layers = e._layers || function() {
      return [
        {
          z: 0,
          draw(t) {
            e.draw(t);
          }
        }
      ];
    }, n.boxes.push(e);
  },
  removeBox(n, e) {
    const t = n.boxes ? n.boxes.indexOf(e) : -1;
    t !== -1 && n.boxes.splice(t, 1);
  },
  configure(n, e, t) {
    e.fullSize = t.fullSize, e.position = t.position, e.weight = t.weight;
  },
  update(n, e, t, s) {
    if (!n)
      return;
    const r = zt(n.options.layout.padding), a = Math.max(e - r.width, 0), c = Math.max(t - r.height, 0), l = cP(n.boxes), d = l.vertical, h = l.horizontal;
    _e(n.boxes, (o) => {
      typeof o.beforeLayout == "function" && o.beforeLayout();
    });
    const m = d.reduce((o, u) => u.box.options && u.box.options.display === !1 ? o : o + 1, 0) || 1, y = Object.freeze({
      outerWidth: e,
      outerHeight: t,
      padding: r,
      availableWidth: a,
      availableHeight: c,
      vBoxMaxWidth: a / 2 / m,
      hBoxMaxHeight: c / 2
    }), b = Object.assign({}, r);
    Od(b, zt(s));
    const v = Object.assign({
      maxPadding: b,
      w: a,
      h: c,
      x: r.left,
      y: r.top
    }, r), w = lP(d.concat(h), y);
    Wn(l.fullSize, v, y, w), Wn(d, v, y, w), Wn(h, v, y, w) && Wn(d, v, y, w), dP(v), hc(l.leftAndTop, v, y, w), v.x += v.w, v.y += v.h, hc(l.rightAndBottom, v, y, w), n.chartArea = {
      left: v.left,
      top: v.top,
      right: v.left + v.w,
      bottom: v.top + v.h,
      height: v.h,
      width: v.w
    }, _e(l.chartArea, (o) => {
      const u = o.box;
      Object.assign(u, n.chartArea), u.update(v.w, v.h, {
        left: 0,
        top: 0,
        right: 0,
        bottom: 0
      });
    });
  }
};
class Td {
  acquireContext(e, t) {
  }
  releaseContext(e) {
    return !1;
  }
  addEventListener(e, t, s) {
  }
  removeEventListener(e, t, s) {
  }
  getDevicePixelRatio() {
    return 1;
  }
  getMaximumSize(e, t, s, r) {
    return t = Math.max(0, t || e.width), s = s || e.height, {
      width: t,
      height: Math.max(0, r ? Math.floor(t / r) : s)
    };
  }
  isAttached(e) {
    return !0;
  }
  updateConfig(e) {
  }
}
class hP extends Td {
  acquireContext(e) {
    return e && e.getContext && e.getContext("2d") || null;
  }
  updateConfig(e) {
    e.options.animation = !1;
  }
}
const sr = "$chartjs", pP = {
  touchstart: "mousedown",
  touchmove: "mousemove",
  touchend: "mouseup",
  pointerenter: "mouseenter",
  pointerdown: "mousedown",
  pointermove: "mousemove",
  pointerup: "mouseup",
  pointerleave: "mouseout",
  pointerout: "mouseout"
}, pc = (n) => n === null || n === "";
function mP(n, e) {
  const t = n.style, s = n.getAttribute("height"), r = n.getAttribute("width");
  if (n[sr] = {
    initial: {
      height: s,
      width: r,
      style: {
        display: t.display,
        height: t.height,
        width: t.width
      }
    }
  }, t.display = t.display || "block", t.boxSizing = t.boxSizing || "border-box", pc(r)) {
    const a = ec(n, "width");
    a !== void 0 && (n.width = a);
  }
  if (pc(s))
    if (n.style.height === "")
      n.height = n.width / (e || 2);
    else {
      const a = ec(n, "height");
      a !== void 0 && (n.height = a);
    }
  return n;
}
const Id = TR ? {
  passive: !0
} : !1;
function gP(n, e, t) {
  n && n.addEventListener(e, t, Id);
}
function yP(n, e, t) {
  n && n.canvas && n.canvas.removeEventListener(e, t, Id);
}
function vP(n, e) {
  const t = pP[n.type] || n.type, { x: s, y: r } = Wi(n, e);
  return {
    type: t,
    chart: e,
    native: n,
    x: s !== void 0 ? s : null,
    y: r !== void 0 ? r : null
  };
}
function Or(n, e) {
  for (const t of n)
    if (t === e || t.contains(e))
      return !0;
}
function bP(n, e, t) {
  const s = n.canvas, r = new MutationObserver((a) => {
    let c = !1;
    for (const l of a)
      c = c || Or(l.addedNodes, s), c = c && !Or(l.removedNodes, s);
    c && t();
  });
  return r.observe(document, {
    childList: !0,
    subtree: !0
  }), r;
}
function xP(n, e, t) {
  const s = n.canvas, r = new MutationObserver((a) => {
    let c = !1;
    for (const l of a)
      c = c || Or(l.removedNodes, s), c = c && !Or(l.addedNodes, s);
    c && t();
  });
  return r.observe(document, {
    childList: !0,
    subtree: !0
  }), r;
}
const fs = /* @__PURE__ */ new Map();
let mc = 0;
function Ud() {
  const n = window.devicePixelRatio;
  n !== mc && (mc = n, fs.forEach((e, t) => {
    t.currentDevicePixelRatio !== n && e();
  }));
}
function SP(n, e) {
  fs.size || window.addEventListener("resize", Ud), fs.set(n, e);
}
function wP(n) {
  fs.delete(n), fs.size || window.removeEventListener("resize", Ud);
}
function AP(n, e, t) {
  const s = n.canvas, r = s && Oa(s);
  if (!r)
    return;
  const a = ud((l, d) => {
    const h = r.clientWidth;
    t(l, d), h < r.clientWidth && t();
  }, window), c = new ResizeObserver((l) => {
    const d = l[0], h = d.contentRect.width, m = d.contentRect.height;
    h === 0 && m === 0 || a(h, m);
  });
  return c.observe(r), SP(n, a), c;
}
function yo(n, e, t) {
  t && t.disconnect(), e === "resize" && wP(n);
}
function CP(n, e, t) {
  const s = n.canvas, r = ud((a) => {
    n.ctx !== null && t(vP(a, n));
  }, n);
  return gP(s, e, r), r;
}
class EP extends Td {
  acquireContext(e, t) {
    const s = e && e.getContext && e.getContext("2d");
    return s && s.canvas === e ? (mP(e, t), s) : null;
  }
  releaseContext(e) {
    const t = e.canvas;
    if (!t[sr])
      return !1;
    const s = t[sr].initial;
    [
      "height",
      "width"
    ].forEach((a) => {
      const c = s[a];
      rt(c) ? t.removeAttribute(a) : t.setAttribute(a, c);
    });
    const r = s.style || {};
    return Object.keys(r).forEach((a) => {
      t.style[a] = r[a];
    }), t.width = t.width, delete t[sr], !0;
  }
  addEventListener(e, t, s) {
    this.removeEventListener(e, t);
    const r = e.$proxies || (e.$proxies = {}), c = {
      attach: bP,
      detach: xP,
      resize: AP
    }[t] || CP;
    r[t] = c(e, t, s);
  }
  removeEventListener(e, t) {
    const s = e.$proxies || (e.$proxies = {}), r = s[t];
    if (!r)
      return;
    ({
      attach: yo,
      detach: yo,
      resize: yo
    }[t] || yP)(e, t, r), s[t] = void 0;
  }
  getDevicePixelRatio() {
    return window.devicePixelRatio;
  }
  getMaximumSize(e, t, s, r) {
    return OR(e, t, s, r);
  }
  isAttached(e) {
    const t = e && Oa(e);
    return !!(t && t.isConnected);
  }
}
function kP(n) {
  return !ka() || typeof OffscreenCanvas < "u" && n instanceof OffscreenCanvas ? hP : EP;
}
var _s;
let rn = (_s = class {
  constructor() {
    oe(this, "x");
    oe(this, "y");
    oe(this, "active", !1);
    oe(this, "options");
    oe(this, "$animations");
  }
  tooltipPosition(e) {
    const { x: t, y: s } = this.getProps([
      "x",
      "y"
    ], e);
    return {
      x: t,
      y: s
    };
  }
  hasValue() {
    return us(this.x) && us(this.y);
  }
  getProps(e, t) {
    const s = this.$animations;
    if (!t || !s)
      return this;
    const r = {};
    return e.forEach((a) => {
      r[a] = s[a] && s[a].active() ? s[a]._to : this[a];
    }), r;
  }
}, oe(_s, "defaults", {}), oe(_s, "defaultRoutes"), _s);
function OP(n, e) {
  const t = n.options.ticks, s = TP(n), r = Math.min(t.maxTicksLimit || s, s), a = t.major.enabled ? UP(e) : [], c = a.length, l = a[0], d = a[c - 1], h = [];
  if (c > r)
    return zP(e, h, a, c / r), h;
  const m = IP(a, e, r);
  if (c > 0) {
    let y, b;
    const v = c > 1 ? Math.round((d - l) / (c - 1)) : null;
    for (Vs(e, h, m, rt(v) ? 0 : l - v, l), y = 0, b = c - 1; y < b; y++)
      Vs(e, h, m, a[y], a[y + 1]);
    return Vs(e, h, m, d, rt(v) ? e.length : d + v), h;
  }
  return Vs(e, h, m), h;
}
function TP(n) {
  const e = n.options.offset, t = n._tickSize(), s = n._length / t + (e ? 0 : 1), r = n._maxLength / t;
  return Math.floor(Math.min(s, r));
}
function IP(n, e, t) {
  const s = RP(n), r = e.length / t;
  if (!s)
    return Math.max(r, 1);
  const a = Oz(s);
  for (let c = 0, l = a.length - 1; c < l; c++) {
    const d = a[c];
    if (d > r)
      return d;
  }
  return Math.max(r, 1);
}
function UP(n) {
  const e = [];
  let t, s;
  for (t = 0, s = n.length; t < s; t++)
    n[t].major && e.push(t);
  return e;
}
function zP(n, e, t, s) {
  let r = 0, a = t[0], c;
  for (s = Math.ceil(s), c = 0; c < n.length; c++)
    c === a && (e.push(n[c]), r++, a = t[r * s]);
}
function Vs(n, e, t, s, r) {
  const a = Pe(s, 0), c = Math.min(Pe(r, n.length), n.length);
  let l = 0, d, h, m;
  for (t = Math.ceil(t), r && (d = r - s, t = d / Math.floor(d / t)), m = a; m < 0; )
    l++, m = Math.round(a + l * t);
  for (h = Math.max(a, 0); h < c; h++)
    h === m && (e.push(n[h]), l++, m = Math.round(a + l * t));
}
function RP(n) {
  const e = n.length;
  let t, s;
  if (e < 2)
    return !1;
  for (s = n[0], t = 1; t < e; ++t)
    if (n[t] - n[t - 1] !== s)
      return !1;
  return s;
}
const PP = (n) => n === "left" ? "right" : n === "right" ? "left" : n, gc = (n, e, t) => e === "top" || e === "left" ? n[e] + t : n[e] - t, yc = (n, e) => Math.min(e || n, n);
function vc(n, e) {
  const t = [], s = n.length / e, r = n.length;
  let a = 0;
  for (; a < r; a += s)
    t.push(n[Math.floor(a)]);
  return t;
}
function MP(n, e, t) {
  const s = n.ticks.length, r = Math.min(e, s - 1), a = n._startPixel, c = n._endPixel, l = 1e-6;
  let d = n.getPixelForTick(r), h;
  if (!(t && (s === 1 ? h = Math.max(d - a, c - d) : e === 0 ? h = (n.getPixelForTick(1) - d) / 2 : h = (d - n.getPixelForTick(r - 1)) / 2, d += r < e ? h : -h, d < a - l || d > c + l)))
    return d;
}
function jP(n, e) {
  _e(n, (t) => {
    const s = t.gc, r = s.length / 2;
    let a;
    if (r > e) {
      for (a = 0; a < r; ++a)
        delete t.data[s[a]];
      s.splice(0, r);
    }
  });
}
function Bn(n) {
  return n.drawTicks ? n.tickLength : 0;
}
function bc(n, e) {
  if (!n.display)
    return 0;
  const t = Ct(n.font, e), s = zt(n.padding);
  return (ut(n.text) ? n.text.length : 1) * t.lineHeight + s.height;
}
function LP(n, e) {
  return Ni(n, {
    scale: e,
    type: "scale"
  });
}
function DP(n, e, t) {
  return Ni(n, {
    tick: t,
    index: e,
    type: "tick"
  });
}
function NP(n, e, t) {
  let s = dd(n);
  return (t && e !== "right" || !t && e === "right") && (s = PP(s)), s;
}
function FP(n, e, t, s) {
  const { top: r, left: a, bottom: c, right: l, chart: d } = n, { chartArea: h, scales: m } = d;
  let y = 0, b, v, w;
  const o = c - r, u = l - a;
  if (n.isHorizontal()) {
    if (v = qt(s, a, l), Ge(t)) {
      const f = Object.keys(t)[0], p = t[f];
      w = m[f].getPixelForValue(p) + o - e;
    } else
      t === "center" ? w = (h.bottom + h.top) / 2 + o - e : w = gc(n, t, e);
    b = l - a;
  } else {
    if (Ge(t)) {
      const f = Object.keys(t)[0], p = t[f];
      v = m[f].getPixelForValue(p) - u + e;
    } else
      t === "center" ? v = (h.left + h.right) / 2 - u + e : v = gc(n, t, e);
    w = qt(s, c, r), y = t === "left" ? -bt : bt;
  }
  return {
    titleX: v,
    titleY: w,
    maxWidth: b,
    rotation: y
  };
}
class on extends rn {
  constructor(e) {
    super(), this.id = e.id, this.type = e.type, this.options = void 0, this.ctx = e.ctx, this.chart = e.chart, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.width = void 0, this.height = void 0, this._margins = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, this.maxWidth = void 0, this.maxHeight = void 0, this.paddingTop = void 0, this.paddingBottom = void 0, this.paddingLeft = void 0, this.paddingRight = void 0, this.axis = void 0, this.labelRotation = void 0, this.min = void 0, this.max = void 0, this._range = void 0, this.ticks = [], this._gridLineItems = null, this._labelItems = null, this._labelSizes = null, this._length = 0, this._maxLength = 0, this._longestTextCache = {}, this._startPixel = void 0, this._endPixel = void 0, this._reversePixels = !1, this._userMax = void 0, this._userMin = void 0, this._suggestedMax = void 0, this._suggestedMin = void 0, this._ticksLength = 0, this._borderValue = 0, this._cache = {}, this._dataLimitsCached = !1, this.$context = void 0;
  }
  init(e) {
    this.options = e.setContext(this.getContext()), this.axis = e.axis, this._userMin = this.parse(e.min), this._userMax = this.parse(e.max), this._suggestedMin = this.parse(e.suggestedMin), this._suggestedMax = this.parse(e.suggestedMax);
  }
  parse(e, t) {
    return e;
  }
  getUserBounds() {
    let { _userMin: e, _userMax: t, _suggestedMin: s, _suggestedMax: r } = this;
    return e = Ht(e, Number.POSITIVE_INFINITY), t = Ht(t, Number.NEGATIVE_INFINITY), s = Ht(s, Number.POSITIVE_INFINITY), r = Ht(r, Number.NEGATIVE_INFINITY), {
      min: Ht(e, s),
      max: Ht(t, r),
      minDefined: ft(e),
      maxDefined: ft(t)
    };
  }
  getMinMax(e) {
    let { min: t, max: s, minDefined: r, maxDefined: a } = this.getUserBounds(), c;
    if (r && a)
      return {
        min: t,
        max: s
      };
    const l = this.getMatchingVisibleMetas();
    for (let d = 0, h = l.length; d < h; ++d)
      c = l[d].controller.getMinMax(this, e), r || (t = Math.min(t, c.min)), a || (s = Math.max(s, c.max));
    return t = a && t > s ? s : t, s = r && t > s ? t : s, {
      min: Ht(t, Ht(s, t)),
      max: Ht(s, Ht(t, s))
    };
  }
  getPadding() {
    return {
      left: this.paddingLeft || 0,
      top: this.paddingTop || 0,
      right: this.paddingRight || 0,
      bottom: this.paddingBottom || 0
    };
  }
  getTicks() {
    return this.ticks;
  }
  getLabels() {
    const e = this.chart.data;
    return this.options.labels || (this.isHorizontal() ? e.xLabels : e.yLabels) || e.labels || [];
  }
  getLabelItems(e = this.chart.chartArea) {
    return this._labelItems || (this._labelItems = this._computeLabelItems(e));
  }
  beforeLayout() {
    this._cache = {}, this._dataLimitsCached = !1;
  }
  beforeUpdate() {
    st(this.options.beforeUpdate, [
      this
    ]);
  }
  update(e, t, s) {
    const { beginAtZero: r, grace: a, ticks: c } = this.options, l = c.sampleSize;
    this.beforeUpdate(), this.maxWidth = e, this.maxHeight = t, this._margins = s = Object.assign({
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, s), this.ticks = null, this._labelSizes = null, this._gridLineItems = null, this._labelItems = null, this.beforeSetDimensions(), this.setDimensions(), this.afterSetDimensions(), this._maxLength = this.isHorizontal() ? this.width + s.left + s.right : this.height + s.top + s.bottom, this._dataLimitsCached || (this.beforeDataLimits(), this.determineDataLimits(), this.afterDataLimits(), this._range = rR(this, a, r), this._dataLimitsCached = !0), this.beforeBuildTicks(), this.ticks = this.buildTicks() || [], this.afterBuildTicks();
    const d = l < this.ticks.length;
    this._convertTicksToLabels(d ? vc(this.ticks, l) : this.ticks), this.configure(), this.beforeCalculateLabelRotation(), this.calculateLabelRotation(), this.afterCalculateLabelRotation(), c.display && (c.autoSkip || c.source === "auto") && (this.ticks = OP(this, this.ticks), this._labelSizes = null, this.afterAutoSkip()), d && this._convertTicksToLabels(this.ticks), this.beforeFit(), this.fit(), this.afterFit(), this.afterUpdate();
  }
  configure() {
    let e = this.options.reverse, t, s;
    this.isHorizontal() ? (t = this.left, s = this.right) : (t = this.top, s = this.bottom, e = !e), this._startPixel = t, this._endPixel = s, this._reversePixels = e, this._length = s - t, this._alignToPixels = this.options.alignToPixels;
  }
  afterUpdate() {
    st(this.options.afterUpdate, [
      this
    ]);
  }
  beforeSetDimensions() {
    st(this.options.beforeSetDimensions, [
      this
    ]);
  }
  setDimensions() {
    this.isHorizontal() ? (this.width = this.maxWidth, this.left = 0, this.right = this.width) : (this.height = this.maxHeight, this.top = 0, this.bottom = this.height), this.paddingLeft = 0, this.paddingTop = 0, this.paddingRight = 0, this.paddingBottom = 0;
  }
  afterSetDimensions() {
    st(this.options.afterSetDimensions, [
      this
    ]);
  }
  _callHooks(e) {
    this.chart.notifyPlugins(e, this.getContext()), st(this.options[e], [
      this
    ]);
  }
  beforeDataLimits() {
    this._callHooks("beforeDataLimits");
  }
  determineDataLimits() {
  }
  afterDataLimits() {
    this._callHooks("afterDataLimits");
  }
  beforeBuildTicks() {
    this._callHooks("beforeBuildTicks");
  }
  buildTicks() {
    return [];
  }
  afterBuildTicks() {
    this._callHooks("afterBuildTicks");
  }
  beforeTickToLabelConversion() {
    st(this.options.beforeTickToLabelConversion, [
      this
    ]);
  }
  generateTickLabels(e) {
    const t = this.options.ticks;
    let s, r, a;
    for (s = 0, r = e.length; s < r; s++)
      a = e[s], a.label = st(t.callback, [
        a.value,
        s,
        e
      ], this);
  }
  afterTickToLabelConversion() {
    st(this.options.afterTickToLabelConversion, [
      this
    ]);
  }
  beforeCalculateLabelRotation() {
    st(this.options.beforeCalculateLabelRotation, [
      this
    ]);
  }
  calculateLabelRotation() {
    const e = this.options, t = e.ticks, s = yc(this.ticks.length, e.ticks.maxTicksLimit), r = t.minRotation || 0, a = t.maxRotation;
    let c = r, l, d, h;
    if (!this._isVisible() || !t.display || r >= a || s <= 1 || !this.isHorizontal()) {
      this.labelRotation = r;
      return;
    }
    const m = this._getLabelSizes(), y = m.widest.width, b = m.highest.height, v = Ut(this.chart.width - y, 0, this.maxWidth);
    l = e.offset ? this.maxWidth / s : v / (s - 1), y + 6 > l && (l = v / (s - (e.offset ? 0.5 : 1)), d = this.maxHeight - Bn(e.grid) - t.padding - bc(e.title, this.chart.options.font), h = Math.sqrt(y * y + b * b), c = ba(Math.min(Math.asin(Ut((m.highest.height + 6) / l, -1, 1)), Math.asin(Ut(d / h, -1, 1)) - Math.asin(Ut(b / h, -1, 1)))), c = Math.max(r, Math.min(a, c))), this.labelRotation = c;
  }
  afterCalculateLabelRotation() {
    st(this.options.afterCalculateLabelRotation, [
      this
    ]);
  }
  afterAutoSkip() {
  }
  beforeFit() {
    st(this.options.beforeFit, [
      this
    ]);
  }
  fit() {
    const e = {
      width: 0,
      height: 0
    }, { chart: t, options: { ticks: s, title: r, grid: a } } = this, c = this._isVisible(), l = this.isHorizontal();
    if (c) {
      const d = bc(r, t.options.font);
      if (l ? (e.width = this.maxWidth, e.height = Bn(a) + d) : (e.height = this.maxHeight, e.width = Bn(a) + d), s.display && this.ticks.length) {
        const { first: h, last: m, widest: y, highest: b } = this._getLabelSizes(), v = s.padding * 2, w = li(this.labelRotation), o = Math.cos(w), u = Math.sin(w);
        if (l) {
          const f = s.mirror ? 0 : u * y.width + o * b.height;
          e.height = Math.min(this.maxHeight, e.height + f + v);
        } else {
          const f = s.mirror ? 0 : o * y.width + u * b.height;
          e.width = Math.min(this.maxWidth, e.width + f + v);
        }
        this._calculatePadding(h, m, u, o);
      }
    }
    this._handleMargins(), l ? (this.width = this._length = t.width - this._margins.left - this._margins.right, this.height = e.height) : (this.width = e.width, this.height = this._length = t.height - this._margins.top - this._margins.bottom);
  }
  _calculatePadding(e, t, s, r) {
    const { ticks: { align: a, padding: c }, position: l } = this.options, d = this.labelRotation !== 0, h = l !== "top" && this.axis === "x";
    if (this.isHorizontal()) {
      const m = this.getPixelForTick(0) - this.left, y = this.right - this.getPixelForTick(this.ticks.length - 1);
      let b = 0, v = 0;
      d ? h ? (b = r * e.width, v = s * t.height) : (b = s * e.height, v = r * t.width) : a === "start" ? v = t.width : a === "end" ? b = e.width : a !== "inner" && (b = e.width / 2, v = t.width / 2), this.paddingLeft = Math.max((b - m + c) * this.width / (this.width - m), 0), this.paddingRight = Math.max((v - y + c) * this.width / (this.width - y), 0);
    } else {
      let m = t.height / 2, y = e.height / 2;
      a === "start" ? (m = 0, y = e.height) : a === "end" && (m = t.height, y = 0), this.paddingTop = m + c, this.paddingBottom = y + c;
    }
  }
  _handleMargins() {
    this._margins && (this._margins.left = Math.max(this.paddingLeft, this._margins.left), this._margins.top = Math.max(this.paddingTop, this._margins.top), this._margins.right = Math.max(this.paddingRight, this._margins.right), this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom));
  }
  afterFit() {
    st(this.options.afterFit, [
      this
    ]);
  }
  isHorizontal() {
    const { axis: e, position: t } = this.options;
    return t === "top" || t === "bottom" || e === "x";
  }
  isFullSize() {
    return this.options.fullSize;
  }
  _convertTicksToLabels(e) {
    this.beforeTickToLabelConversion(), this.generateTickLabels(e);
    let t, s;
    for (t = 0, s = e.length; t < s; t++)
      rt(e[t].label) && (e.splice(t, 1), s--, t--);
    this.afterTickToLabelConversion();
  }
  _getLabelSizes() {
    let e = this._labelSizes;
    if (!e) {
      const t = this.options.ticks.sampleSize;
      let s = this.ticks;
      t < s.length && (s = vc(s, t)), this._labelSizes = e = this._computeLabelSizes(s, s.length, this.options.ticks.maxTicksLimit);
    }
    return e;
  }
  _computeLabelSizes(e, t, s) {
    const { ctx: r, _longestTextCache: a } = this, c = [], l = [], d = Math.floor(t / yc(t, s));
    let h = 0, m = 0, y, b, v, w, o, u, f, p, g, S, x;
    for (y = 0; y < t; y += d) {
      if (w = e[y].label, o = this._resolveTickFontOptions(y), r.font = u = o.string, f = a[u] = a[u] || {
        data: {},
        gc: []
      }, p = o.lineHeight, g = S = 0, !rt(w) && !ut(w))
        g = Cr(r, f.data, f.gc, g, w), S = p;
      else if (ut(w))
        for (b = 0, v = w.length; b < v; ++b)
          x = w[b], !rt(x) && !ut(x) && (g = Cr(r, f.data, f.gc, g, x), S += p);
      c.push(g), l.push(S), h = Math.max(g, h), m = Math.max(S, m);
    }
    jP(a, t);
    const E = c.indexOf(h), k = l.indexOf(m), R = (O) => ({
      width: c[O] || 0,
      height: l[O] || 0
    });
    return {
      first: R(0),
      last: R(t - 1),
      widest: R(E),
      highest: R(k),
      widths: c,
      heights: l
    };
  }
  getLabelForValue(e) {
    return e;
  }
  getPixelForValue(e, t) {
    return NaN;
  }
  getValueForPixel(e) {
  }
  getPixelForTick(e) {
    const t = this.ticks;
    return e < 0 || e > t.length - 1 ? null : this.getPixelForValue(t[e].value);
  }
  getPixelForDecimal(e) {
    this._reversePixels && (e = 1 - e);
    const t = this._startPixel + e * this._length;
    return Uz(this._alignToPixels ? Hi(this.chart, t, 0) : t);
  }
  getDecimalForPixel(e) {
    const t = (e - this._startPixel) / this._length;
    return this._reversePixels ? 1 - t : t;
  }
  getBasePixel() {
    return this.getPixelForValue(this.getBaseValue());
  }
  getBaseValue() {
    const { min: e, max: t } = this;
    return e < 0 && t < 0 ? t : e > 0 && t > 0 ? e : 0;
  }
  getContext(e) {
    const t = this.ticks || [];
    if (e >= 0 && e < t.length) {
      const s = t[e];
      return s.$context || (s.$context = DP(this.getContext(), e, s));
    }
    return this.$context || (this.$context = LP(this.chart.getContext(), this));
  }
  _tickSize() {
    const e = this.options.ticks, t = li(this.labelRotation), s = Math.abs(Math.cos(t)), r = Math.abs(Math.sin(t)), a = this._getLabelSizes(), c = e.autoSkipPadding || 0, l = a ? a.widest.width + c : 0, d = a ? a.highest.height + c : 0;
    return this.isHorizontal() ? d * s > l * r ? l / s : d / r : d * r < l * s ? d / s : l / r;
  }
  _isVisible() {
    const e = this.options.display;
    return e !== "auto" ? !!e : this.getMatchingVisibleMetas().length > 0;
  }
  _computeGridLineItems(e) {
    const t = this.axis, s = this.chart, r = this.options, { grid: a, position: c, border: l } = r, d = a.offset, h = this.isHorizontal(), y = this.ticks.length + (d ? 1 : 0), b = Bn(a), v = [], w = l.setContext(this.getContext()), o = w.display ? w.width : 0, u = o / 2, f = function(U) {
      return Hi(s, U, o);
    };
    let p, g, S, x, E, k, R, O, T, D, P, N;
    if (c === "top")
      p = f(this.bottom), k = this.bottom - b, O = p - u, D = f(e.top) + u, N = e.bottom;
    else if (c === "bottom")
      p = f(this.top), D = e.top, N = f(e.bottom) - u, k = p + u, O = this.top + b;
    else if (c === "left")
      p = f(this.right), E = this.right - b, R = p - u, T = f(e.left) + u, P = e.right;
    else if (c === "right")
      p = f(this.left), T = e.left, P = f(e.right) - u, E = p + u, R = this.left + b;
    else if (t === "x") {
      if (c === "center")
        p = f((e.top + e.bottom) / 2 + 0.5);
      else if (Ge(c)) {
        const U = Object.keys(c)[0], z = c[U];
        p = f(this.chart.scales[U].getPixelForValue(z));
      }
      D = e.top, N = e.bottom, k = p + u, O = k + b;
    } else if (t === "y") {
      if (c === "center")
        p = f((e.left + e.right) / 2);
      else if (Ge(c)) {
        const U = Object.keys(c)[0], z = c[U];
        p = f(this.chart.scales[U].getPixelForValue(z));
      }
      E = p - u, R = E - b, T = e.left, P = e.right;
    }
    const I = Pe(r.ticks.maxTicksLimit, y), C = Math.max(1, Math.ceil(y / I));
    for (g = 0; g < y; g += C) {
      const U = this.getContext(g), z = a.setContext(U), j = l.setContext(U), F = z.lineWidth, q = z.color, W = j.dash || [], K = j.dashOffset, Q = z.tickWidth, G = z.tickColor, M = z.tickBorderDash || [], te = z.tickBorderDashOffset;
      S = MP(this, g, d), S !== void 0 && (x = Hi(s, S, F), h ? E = R = T = P = x : k = O = D = N = x, v.push({
        tx1: E,
        ty1: k,
        tx2: R,
        ty2: O,
        x1: T,
        y1: D,
        x2: P,
        y2: N,
        width: F,
        color: q,
        borderDash: W,
        borderDashOffset: K,
        tickWidth: Q,
        tickColor: G,
        tickBorderDash: M,
        tickBorderDashOffset: te
      }));
    }
    return this._ticksLength = y, this._borderValue = p, v;
  }
  _computeLabelItems(e) {
    const t = this.axis, s = this.options, { position: r, ticks: a } = s, c = this.isHorizontal(), l = this.ticks, { align: d, crossAlign: h, padding: m, mirror: y } = a, b = Bn(s.grid), v = b + m, w = y ? -m : v, o = -li(this.labelRotation), u = [];
    let f, p, g, S, x, E, k, R, O, T, D, P, N = "middle";
    if (r === "top")
      E = this.bottom - w, k = this._getXAxisLabelAlignment();
    else if (r === "bottom")
      E = this.top + w, k = this._getXAxisLabelAlignment();
    else if (r === "left") {
      const C = this._getYAxisLabelAlignment(b);
      k = C.textAlign, x = C.x;
    } else if (r === "right") {
      const C = this._getYAxisLabelAlignment(b);
      k = C.textAlign, x = C.x;
    } else if (t === "x") {
      if (r === "center")
        E = (e.top + e.bottom) / 2 + v;
      else if (Ge(r)) {
        const C = Object.keys(r)[0], U = r[C];
        E = this.chart.scales[C].getPixelForValue(U) + v;
      }
      k = this._getXAxisLabelAlignment();
    } else if (t === "y") {
      if (r === "center")
        x = (e.left + e.right) / 2 - v;
      else if (Ge(r)) {
        const C = Object.keys(r)[0], U = r[C];
        x = this.chart.scales[C].getPixelForValue(U);
      }
      k = this._getYAxisLabelAlignment(b).textAlign;
    }
    t === "y" && (d === "start" ? N = "top" : d === "end" && (N = "bottom"));
    const I = this._getLabelSizes();
    for (f = 0, p = l.length; f < p; ++f) {
      g = l[f], S = g.label;
      const C = a.setContext(this.getContext(f));
      R = this.getPixelForTick(f) + a.labelOffset, O = this._resolveTickFontOptions(f), T = O.lineHeight, D = ut(S) ? S.length : 1;
      const U = D / 2, z = C.color, j = C.textStrokeColor, F = C.textStrokeWidth;
      let q = k;
      c ? (x = R, k === "inner" && (f === p - 1 ? q = this.options.reverse ? "left" : "right" : f === 0 ? q = this.options.reverse ? "right" : "left" : q = "center"), r === "top" ? h === "near" || o !== 0 ? P = -D * T + T / 2 : h === "center" ? P = -I.highest.height / 2 - U * T + T : P = -I.highest.height + T / 2 : h === "near" || o !== 0 ? P = T / 2 : h === "center" ? P = I.highest.height / 2 - U * T : P = I.highest.height - D * T, y && (P *= -1), o !== 0 && !C.showLabelBackdrop && (x += T / 2 * Math.sin(o))) : (E = R, P = (1 - D) * T / 2);
      let W;
      if (C.showLabelBackdrop) {
        const K = zt(C.backdropPadding), Q = I.heights[f], G = I.widths[f];
        let M = P - K.top, te = 0 - K.left;
        switch (N) {
          case "middle":
            M -= Q / 2;
            break;
          case "bottom":
            M -= Q;
            break;
        }
        switch (k) {
          case "center":
            te -= G / 2;
            break;
          case "right":
            te -= G;
            break;
          case "inner":
            f === p - 1 ? te -= G : f > 0 && (te -= G / 2);
            break;
        }
        W = {
          left: te,
          top: M,
          width: G + K.width,
          height: Q + K.height,
          color: C.backdropColor
        };
      }
      u.push({
        label: S,
        font: O,
        textOffset: P,
        options: {
          rotation: o,
          color: z,
          strokeColor: j,
          strokeWidth: F,
          textAlign: q,
          textBaseline: N,
          translation: [
            x,
            E
          ],
          backdrop: W
        }
      });
    }
    return u;
  }
  _getXAxisLabelAlignment() {
    const { position: e, ticks: t } = this.options;
    if (-li(this.labelRotation))
      return e === "top" ? "left" : "right";
    let r = "center";
    return t.align === "start" ? r = "left" : t.align === "end" ? r = "right" : t.align === "inner" && (r = "inner"), r;
  }
  _getYAxisLabelAlignment(e) {
    const { position: t, ticks: { crossAlign: s, mirror: r, padding: a } } = this.options, c = this._getLabelSizes(), l = e + a, d = c.widest.width;
    let h, m;
    return t === "left" ? r ? (m = this.right + a, s === "near" ? h = "left" : s === "center" ? (h = "center", m += d / 2) : (h = "right", m += d)) : (m = this.right - l, s === "near" ? h = "right" : s === "center" ? (h = "center", m -= d / 2) : (h = "left", m = this.left)) : t === "right" ? r ? (m = this.left + a, s === "near" ? h = "right" : s === "center" ? (h = "center", m -= d / 2) : (h = "left", m -= d)) : (m = this.left + l, s === "near" ? h = "left" : s === "center" ? (h = "center", m += d / 2) : (h = "right", m = this.right)) : h = "right", {
      textAlign: h,
      x: m
    };
  }
  _computeLabelArea() {
    if (this.options.ticks.mirror)
      return;
    const e = this.chart, t = this.options.position;
    if (t === "left" || t === "right")
      return {
        top: 0,
        left: this.left,
        bottom: e.height,
        right: this.right
      };
    if (t === "top" || t === "bottom")
      return {
        top: this.top,
        left: 0,
        bottom: this.bottom,
        right: e.width
      };
  }
  drawBackground() {
    const { ctx: e, options: { backgroundColor: t }, left: s, top: r, width: a, height: c } = this;
    t && (e.save(), e.fillStyle = t, e.fillRect(s, r, a, c), e.restore());
  }
  getLineWidthForValue(e) {
    const t = this.options.grid;
    if (!this._isVisible() || !t.display)
      return 0;
    const r = this.ticks.findIndex((a) => a.value === e);
    return r >= 0 ? t.setContext(this.getContext(r)).lineWidth : 0;
  }
  drawGrid(e) {
    const t = this.options.grid, s = this.ctx, r = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(e));
    let a, c;
    const l = (d, h, m) => {
      !m.width || !m.color || (s.save(), s.lineWidth = m.width, s.strokeStyle = m.color, s.setLineDash(m.borderDash || []), s.lineDashOffset = m.borderDashOffset, s.beginPath(), s.moveTo(d.x, d.y), s.lineTo(h.x, h.y), s.stroke(), s.restore());
    };
    if (t.display)
      for (a = 0, c = r.length; a < c; ++a) {
        const d = r[a];
        t.drawOnChartArea && l({
          x: d.x1,
          y: d.y1
        }, {
          x: d.x2,
          y: d.y2
        }, d), t.drawTicks && l({
          x: d.tx1,
          y: d.ty1
        }, {
          x: d.tx2,
          y: d.ty2
        }, {
          color: d.tickColor,
          width: d.tickWidth,
          borderDash: d.tickBorderDash,
          borderDashOffset: d.tickBorderDashOffset
        });
      }
  }
  drawBorder() {
    const { chart: e, ctx: t, options: { border: s, grid: r } } = this, a = s.setContext(this.getContext()), c = s.display ? a.width : 0;
    if (!c)
      return;
    const l = r.setContext(this.getContext(0)).lineWidth, d = this._borderValue;
    let h, m, y, b;
    this.isHorizontal() ? (h = Hi(e, this.left, c) - c / 2, m = Hi(e, this.right, l) + l / 2, y = b = d) : (y = Hi(e, this.top, c) - c / 2, b = Hi(e, this.bottom, l) + l / 2, h = m = d), t.save(), t.lineWidth = a.width, t.strokeStyle = a.color, t.beginPath(), t.moveTo(h, y), t.lineTo(m, b), t.stroke(), t.restore();
  }
  drawLabels(e) {
    if (!this.options.ticks.display)
      return;
    const s = this.ctx, r = this._computeLabelArea();
    r && Nr(s, r);
    const a = this.getLabelItems(e);
    for (const c of a) {
      const l = c.options, d = c.font, h = c.label, m = c.textOffset;
      An(s, h, 0, m, d, l);
    }
    r && Fr(s);
  }
  drawTitle() {
    const { ctx: e, options: { position: t, title: s, reverse: r } } = this;
    if (!s.display)
      return;
    const a = Ct(s.font), c = zt(s.padding), l = s.align;
    let d = a.lineHeight / 2;
    t === "bottom" || t === "center" || Ge(t) ? (d += c.bottom, ut(s.text) && (d += a.lineHeight * (s.text.length - 1))) : d += c.top;
    const { titleX: h, titleY: m, maxWidth: y, rotation: b } = FP(this, d, t, l);
    An(e, s.text, 0, 0, a, {
      color: s.color,
      maxWidth: y,
      rotation: b,
      textAlign: NP(l, t, r),
      textBaseline: "middle",
      translation: [
        h,
        m
      ]
    });
  }
  draw(e) {
    this._isVisible() && (this.drawBackground(), this.drawGrid(e), this.drawBorder(), this.drawTitle(), this.drawLabels(e));
  }
  _layers() {
    const e = this.options, t = e.ticks && e.ticks.z || 0, s = Pe(e.grid && e.grid.z, -1), r = Pe(e.border && e.border.z, 0);
    return !this._isVisible() || this.draw !== on.prototype.draw ? [
      {
        z: t,
        draw: (a) => {
          this.draw(a);
        }
      }
    ] : [
      {
        z: s,
        draw: (a) => {
          this.drawBackground(), this.drawGrid(a), this.drawTitle();
        }
      },
      {
        z: r,
        draw: () => {
          this.drawBorder();
        }
      },
      {
        z: t,
        draw: (a) => {
          this.drawLabels(a);
        }
      }
    ];
  }
  getMatchingVisibleMetas(e) {
    const t = this.chart.getSortedVisibleDatasetMetas(), s = this.axis + "AxisID", r = [];
    let a, c;
    for (a = 0, c = t.length; a < c; ++a) {
      const l = t[a];
      l[s] === this.id && (!e || l.type === e) && r.push(l);
    }
    return r;
  }
  _resolveTickFontOptions(e) {
    const t = this.options.ticks.setContext(this.getContext(e));
    return Ct(t.font);
  }
  _maxDigits() {
    const e = this._resolveTickFontOptions(0).lineHeight;
    return (this.isHorizontal() ? this.width : this.height) / e;
  }
}
class Gs {
  constructor(e, t, s) {
    this.type = e, this.scope = t, this.override = s, this.items = /* @__PURE__ */ Object.create(null);
  }
  isForType(e) {
    return Object.prototype.isPrototypeOf.call(this.type.prototype, e.prototype);
  }
  register(e) {
    const t = Object.getPrototypeOf(e);
    let s;
    HP(t) && (s = this.register(t));
    const r = this.items, a = e.id, c = this.scope + "." + a;
    if (!a)
      throw new Error("class does not have id: " + e);
    return a in r || (r[a] = e, BP(e, c, s), this.override && ht.override(e.id, e.overrides)), c;
  }
  get(e) {
    return this.items[e];
  }
  unregister(e) {
    const t = this.items, s = e.id, r = this.scope;
    s in t && delete t[s], r && s in ht[r] && (delete ht[r][s], this.override && delete sn[s]);
  }
}
function BP(n, e, t) {
  const s = ls(/* @__PURE__ */ Object.create(null), [
    t ? ht.get(t) : {},
    ht.get(e),
    n.defaults
  ]);
  ht.set(e, s), n.defaultRoutes && qP(e, n.defaultRoutes), n.descriptors && ht.describe(e, n.descriptors);
}
function qP(n, e) {
  Object.keys(e).forEach((t) => {
    const s = t.split("."), r = s.pop(), a = [
      n
    ].concat(s).join("."), c = e[t].split("."), l = c.pop(), d = c.join(".");
    ht.route(a, r, d, l);
  });
}
function HP(n) {
  return "id" in n && "defaults" in n;
}
class VP {
  constructor() {
    this.controllers = new Gs(_i, "datasets", !0), this.elements = new Gs(rn, "elements"), this.plugins = new Gs(Object, "plugins"), this.scales = new Gs(on, "scales"), this._typedRegistries = [
      this.controllers,
      this.scales,
      this.elements
    ];
  }
  add(...e) {
    this._each("register", e);
  }
  remove(...e) {
    this._each("unregister", e);
  }
  addControllers(...e) {
    this._each("register", e, this.controllers);
  }
  addElements(...e) {
    this._each("register", e, this.elements);
  }
  addPlugins(...e) {
    this._each("register", e, this.plugins);
  }
  addScales(...e) {
    this._each("register", e, this.scales);
  }
  getController(e) {
    return this._get(e, this.controllers, "controller");
  }
  getElement(e) {
    return this._get(e, this.elements, "element");
  }
  getPlugin(e) {
    return this._get(e, this.plugins, "plugin");
  }
  getScale(e) {
    return this._get(e, this.scales, "scale");
  }
  removeControllers(...e) {
    this._each("unregister", e, this.controllers);
  }
  removeElements(...e) {
    this._each("unregister", e, this.elements);
  }
  removePlugins(...e) {
    this._each("unregister", e, this.plugins);
  }
  removeScales(...e) {
    this._each("unregister", e, this.scales);
  }
  _each(e, t, s) {
    [
      ...t
    ].forEach((r) => {
      const a = s || this._getRegistryForType(r);
      s || a.isForType(r) || a === this.plugins && r.id ? this._exec(e, a, r) : _e(r, (c) => {
        const l = s || this._getRegistryForType(c);
        this._exec(e, l, c);
      });
    });
  }
  _exec(e, t, s) {
    const r = va(e);
    st(s["before" + r], [], s), t[e](s), st(s["after" + r], [], s);
  }
  _getRegistryForType(e) {
    for (let t = 0; t < this._typedRegistries.length; t++) {
      const s = this._typedRegistries[t];
      if (s.isForType(e))
        return s;
    }
    return this.plugins;
  }
  _get(e, t, s) {
    const r = t.get(e);
    if (r === void 0)
      throw new Error('"' + e + '" is not a registered ' + s + ".");
    return r;
  }
}
var oi = /* @__PURE__ */ new VP();
class GP {
  constructor() {
    this._init = [];
  }
  notify(e, t, s, r) {
    t === "beforeInit" && (this._init = this._createDescriptors(e, !0), this._notify(this._init, e, "install"));
    const a = r ? this._descriptors(e).filter(r) : this._descriptors(e), c = this._notify(a, e, t, s);
    return t === "afterDestroy" && (this._notify(a, e, "stop"), this._notify(this._init, e, "uninstall")), c;
  }
  _notify(e, t, s, r) {
    r = r || {};
    for (const a of e) {
      const c = a.plugin, l = c[s], d = [
        t,
        r,
        a.options
      ];
      if (st(l, d, c) === !1 && r.cancelable)
        return !1;
    }
    return !0;
  }
  invalidate() {
    rt(this._cache) || (this._oldCache = this._cache, this._cache = void 0);
  }
  _descriptors(e) {
    if (this._cache)
      return this._cache;
    const t = this._cache = this._createDescriptors(e);
    return this._notifyStateChanges(e), t;
  }
  _createDescriptors(e, t) {
    const s = e && e.config, r = Pe(s.options && s.options.plugins, {}), a = WP(s);
    return r === !1 && !t ? [] : YP(e, a, r, t);
  }
  _notifyStateChanges(e) {
    const t = this._oldCache || [], s = this._cache, r = (a, c) => a.filter((l) => !c.some((d) => l.plugin.id === d.plugin.id));
    this._notify(r(t, s), e, "stop"), this._notify(r(s, t), e, "start");
  }
}
function WP(n) {
  const e = {}, t = [], s = Object.keys(oi.plugins.items);
  for (let a = 0; a < s.length; a++)
    t.push(oi.getPlugin(s[a]));
  const r = n.plugins || [];
  for (let a = 0; a < r.length; a++) {
    const c = r[a];
    t.indexOf(c) === -1 && (t.push(c), e[c.id] = !0);
  }
  return {
    plugins: t,
    localIds: e
  };
}
function KP(n, e) {
  return !e && n === !1 ? null : n === !0 ? {} : n;
}
function YP(n, { plugins: e, localIds: t }, s, r) {
  const a = [], c = n.getContext();
  for (const l of e) {
    const d = l.id, h = KP(s[d], r);
    h !== null && a.push({
      plugin: l,
      options: JP(n.config, {
        plugin: l,
        local: t[d]
      }, h, c)
    });
  }
  return a;
}
function JP(n, { plugin: e, local: t }, s, r) {
  const a = n.pluginScopeKeys(e), c = n.getOptionScopes(s, a);
  return t && e.defaults && c.push(e.defaults), n.createResolver(c, r, [
    ""
  ], {
    scriptable: !1,
    indexable: !1,
    allKeys: !0
  });
}
function Ko(n, e) {
  const t = ht.datasets[n] || {};
  return ((e.datasets || {})[n] || {}).indexAxis || e.indexAxis || t.indexAxis || "x";
}
function ZP(n, e) {
  let t = n;
  return n === "_index_" ? t = e : n === "_value_" && (t = e === "x" ? "y" : "x"), t;
}
function QP(n, e) {
  return n === e ? "_index_" : "_value_";
}
function xc(n) {
  if (n === "x" || n === "y" || n === "r")
    return n;
}
function XP(n) {
  if (n === "top" || n === "bottom")
    return "x";
  if (n === "left" || n === "right")
    return "y";
}
function Yo(n, ...e) {
  if (xc(n))
    return n;
  for (const t of e) {
    const s = t.axis || XP(t.position) || n.length > 1 && xc(n[0].toLowerCase());
    if (s)
      return s;
  }
  throw new Error(`Cannot determine type of '${n}' axis. Please provide 'axis' or 'position' option.`);
}
function Sc(n, e, t) {
  if (t[e + "AxisID"] === n)
    return {
      axis: e
    };
}
function _P(n, e) {
  if (e.data && e.data.datasets) {
    const t = e.data.datasets.filter((s) => s.xAxisID === n || s.yAxisID === n);
    if (t.length)
      return Sc(n, "x", t[0]) || Sc(n, "y", t[0]);
  }
  return {};
}
function $P(n, e) {
  const t = sn[n.type] || {
    scales: {}
  }, s = e.scales || {}, r = Ko(n.type, e), a = /* @__PURE__ */ Object.create(null);
  return Object.keys(s).forEach((c) => {
    const l = s[c];
    if (!Ge(l))
      return console.error(`Invalid scale configuration for scale: ${c}`);
    if (l._proxy)
      return console.warn(`Ignoring resolver passed as options for scale: ${c}`);
    const d = Yo(c, l, _P(c, n), ht.scales[l.type]), h = QP(d, r), m = t.scales || {};
    a[c] = Xn(/* @__PURE__ */ Object.create(null), [
      {
        axis: d
      },
      l,
      m[d],
      m[h]
    ]);
  }), n.data.datasets.forEach((c) => {
    const l = c.type || n.type, d = c.indexAxis || Ko(l, e), m = (sn[l] || {}).scales || {};
    Object.keys(m).forEach((y) => {
      const b = ZP(y, d), v = c[b + "AxisID"] || b;
      a[v] = a[v] || /* @__PURE__ */ Object.create(null), Xn(a[v], [
        {
          axis: b
        },
        s[v],
        m[y]
      ]);
    });
  }), Object.keys(a).forEach((c) => {
    const l = a[c];
    Xn(l, [
      ht.scales[l.type],
      ht.scale
    ]);
  }), a;
}
function zd(n) {
  const e = n.options || (n.options = {});
  e.plugins = Pe(e.plugins, {}), e.scales = $P(n, e);
}
function Rd(n) {
  return n = n || {}, n.datasets = n.datasets || [], n.labels = n.labels || [], n;
}
function eM(n) {
  return n = n || {}, n.data = Rd(n.data), zd(n), n;
}
const wc = /* @__PURE__ */ new Map(), Pd = /* @__PURE__ */ new Set();
function Ws(n, e) {
  let t = wc.get(n);
  return t || (t = e(), wc.set(n, t), Pd.add(t)), t;
}
const qn = (n, e, t) => {
  const s = cs(e, t);
  s !== void 0 && n.add(s);
};
class tM {
  constructor(e) {
    this._config = eM(e), this._scopeCache = /* @__PURE__ */ new Map(), this._resolverCache = /* @__PURE__ */ new Map();
  }
  get platform() {
    return this._config.platform;
  }
  get type() {
    return this._config.type;
  }
  set type(e) {
    this._config.type = e;
  }
  get data() {
    return this._config.data;
  }
  set data(e) {
    this._config.data = Rd(e);
  }
  get options() {
    return this._config.options;
  }
  set options(e) {
    this._config.options = e;
  }
  get plugins() {
    return this._config.plugins;
  }
  update() {
    const e = this._config;
    this.clearCache(), zd(e);
  }
  clearCache() {
    this._scopeCache.clear(), this._resolverCache.clear();
  }
  datasetScopeKeys(e) {
    return Ws(e, () => [
      [
        `datasets.${e}`,
        ""
      ]
    ]);
  }
  datasetAnimationScopeKeys(e, t) {
    return Ws(`${e}.transition.${t}`, () => [
      [
        `datasets.${e}.transitions.${t}`,
        `transitions.${t}`
      ],
      [
        `datasets.${e}`,
        ""
      ]
    ]);
  }
  datasetElementScopeKeys(e, t) {
    return Ws(`${e}-${t}`, () => [
      [
        `datasets.${e}.elements.${t}`,
        `datasets.${e}`,
        `elements.${t}`,
        ""
      ]
    ]);
  }
  pluginScopeKeys(e) {
    const t = e.id, s = this.type;
    return Ws(`${s}-plugin-${t}`, () => [
      [
        `plugins.${t}`,
        ...e.additionalOptionScopes || []
      ]
    ]);
  }
  _cachedScopes(e, t) {
    const s = this._scopeCache;
    let r = s.get(e);
    return (!r || t) && (r = /* @__PURE__ */ new Map(), s.set(e, r)), r;
  }
  getOptionScopes(e, t, s) {
    const { options: r, type: a } = this, c = this._cachedScopes(e, s), l = c.get(t);
    if (l)
      return l;
    const d = /* @__PURE__ */ new Set();
    t.forEach((m) => {
      e && (d.add(e), m.forEach((y) => qn(d, e, y))), m.forEach((y) => qn(d, r, y)), m.forEach((y) => qn(d, sn[a] || {}, y)), m.forEach((y) => qn(d, ht, y)), m.forEach((y) => qn(d, Go, y));
    });
    const h = Array.from(d);
    return h.length === 0 && h.push(/* @__PURE__ */ Object.create(null)), Pd.has(t) && c.set(t, h), h;
  }
  chartOptionScopes() {
    const { options: e, type: t } = this;
    return [
      e,
      sn[t] || {},
      ht.datasets[t] || {},
      {
        type: t
      },
      ht,
      Go
    ];
  }
  resolveNamedOptions(e, t, s, r = [
    ""
  ]) {
    const a = {
      $shared: !0
    }, { resolver: c, subPrefixes: l } = Ac(this._resolverCache, e, r);
    let d = c;
    if (nM(c, t)) {
      a.$shared = !1, s = Di(s) ? s() : s;
      const h = this.createResolver(e, s, l);
      d = Cn(c, s, h);
    }
    for (const h of t)
      a[h] = d[h];
    return a;
  }
  createResolver(e, t, s = [
    ""
  ], r) {
    const { resolver: a } = Ac(this._resolverCache, e, s);
    return Ge(t) ? Cn(a, t, void 0, r) : a;
  }
}
function Ac(n, e, t) {
  let s = n.get(e);
  s || (s = /* @__PURE__ */ new Map(), n.set(e, s));
  const r = t.join();
  let a = s.get(r);
  return a || (a = {
    resolver: Aa(e, t),
    subPrefixes: t.filter((l) => !l.toLowerCase().includes("hover"))
  }, s.set(r, a)), a;
}
const iM = (n) => Ge(n) && Object.getOwnPropertyNames(n).some((e) => Di(n[e]));
function nM(n, e) {
  const { isScriptable: t, isIndexable: s } = pd(n);
  for (const r of e) {
    const a = t(r), c = s(r), l = (c || a) && n[r];
    if (a && (Di(l) || iM(l)) || c && ut(l))
      return !0;
  }
  return !1;
}
var sM = "4.4.6";
const rM = [
  "top",
  "bottom",
  "left",
  "right",
  "chartArea"
];
function Cc(n, e) {
  return n === "top" || n === "bottom" || rM.indexOf(n) === -1 && e === "x";
}
function Ec(n, e) {
  return function(t, s) {
    return t[n] === s[n] ? t[e] - s[e] : t[n] - s[n];
  };
}
function kc(n) {
  const e = n.chart, t = e.options.animation;
  e.notifyPlugins("afterRender"), st(t && t.onComplete, [
    n
  ], e);
}
function oM(n) {
  const e = n.chart, t = e.options.animation;
  st(t && t.onProgress, [
    n
  ], e);
}
function Md(n) {
  return ka() && typeof n == "string" ? n = document.getElementById(n) : n && n.length && (n = n[0]), n && n.canvas && (n = n.canvas), n;
}
const rr = {}, Oc = (n) => {
  const e = Md(n);
  return Object.values(rr).filter((t) => t.canvas === e).pop();
};
function aM(n, e, t) {
  const s = Object.keys(n);
  for (const r of s) {
    const a = +r;
    if (a >= e) {
      const c = n[r];
      delete n[r], (t > 0 || a > e) && (n[a + t] = c);
    }
  }
}
function lM(n, e, t, s) {
  return !t || n.type === "mouseout" ? null : s ? e : n;
}
function Ks(n, e, t) {
  return n.options.clip ? n[t] : e[t];
}
function cM(n, e) {
  const { xScale: t, yScale: s } = n;
  return t && s ? {
    left: Ks(t, e, "left"),
    right: Ks(t, e, "right"),
    top: Ks(s, e, "top"),
    bottom: Ks(s, e, "bottom")
  } : e;
}
class At {
  static register(...e) {
    oi.add(...e), Tc();
  }
  static unregister(...e) {
    oi.remove(...e), Tc();
  }
  constructor(e, t) {
    const s = this.config = new tM(t), r = Md(e), a = Oc(r);
    if (a)
      throw new Error("Canvas is already in use. Chart with ID '" + a.id + "' must be destroyed before the canvas with ID '" + a.canvas.id + "' can be reused.");
    const c = s.createResolver(s.chartOptionScopes(), this.getContext());
    this.platform = new (s.platform || kP(r))(), this.platform.updateConfig(s);
    const l = this.platform.acquireContext(r, c.aspectRatio), d = l && l.canvas, h = d && d.height, m = d && d.width;
    if (this.id = vz(), this.ctx = l, this.canvas = d, this.width = m, this.height = h, this._options = c, this._aspectRatio = this.aspectRatio, this._layers = [], this._metasets = [], this._stacks = void 0, this.boxes = [], this.currentDevicePixelRatio = void 0, this.chartArea = void 0, this._active = [], this._lastEvent = void 0, this._listeners = {}, this._responsiveListeners = void 0, this._sortedMetasets = [], this.scales = {}, this._plugins = new GP(), this.$proxies = {}, this._hiddenIndices = {}, this.attached = !1, this._animationsDisabled = void 0, this.$context = void 0, this._doResize = jz((y) => this.update(y), c.resizeDelay || 0), this._dataChanges = [], rr[this.id] = this, !l || !d) {
      console.error("Failed to create chart: can't acquire context from the given item");
      return;
    }
    gi.listen(this, "complete", kc), gi.listen(this, "progress", oM), this._initialize(), this.attached && this.update();
  }
  get aspectRatio() {
    const { options: { aspectRatio: e, maintainAspectRatio: t }, width: s, height: r, _aspectRatio: a } = this;
    return rt(e) ? t && a ? a : r ? s / r : null : e;
  }
  get data() {
    return this.config.data;
  }
  set data(e) {
    this.config.data = e;
  }
  get options() {
    return this._options;
  }
  set options(e) {
    this.config.options = e;
  }
  get registry() {
    return oi;
  }
  _initialize() {
    return this.notifyPlugins("beforeInit"), this.options.responsive ? this.resize() : $l(this, this.options.devicePixelRatio), this.bindEvents(), this.notifyPlugins("afterInit"), this;
  }
  clear() {
    return Ql(this.canvas, this.ctx), this;
  }
  stop() {
    return gi.stop(this), this;
  }
  resize(e, t) {
    gi.running(this) ? this._resizeBeforeDraw = {
      width: e,
      height: t
    } : this._resize(e, t);
  }
  _resize(e, t) {
    const s = this.options, r = this.canvas, a = s.maintainAspectRatio && this.aspectRatio, c = this.platform.getMaximumSize(r, e, t, a), l = s.devicePixelRatio || this.platform.getDevicePixelRatio(), d = this.width ? "resize" : "attach";
    this.width = c.width, this.height = c.height, this._aspectRatio = this.aspectRatio, $l(this, l, !0) && (this.notifyPlugins("resize", {
      size: c
    }), st(s.onResize, [
      this,
      c
    ], this), this.attached && this._doResize(d) && this.render());
  }
  ensureScalesHaveIDs() {
    const t = this.options.scales || {};
    _e(t, (s, r) => {
      s.id = r;
    });
  }
  buildOrUpdateScales() {
    const e = this.options, t = e.scales, s = this.scales, r = Object.keys(s).reduce((c, l) => (c[l] = !1, c), {});
    let a = [];
    t && (a = a.concat(Object.keys(t).map((c) => {
      const l = t[c], d = Yo(c, l), h = d === "r", m = d === "x";
      return {
        options: l,
        dposition: h ? "chartArea" : m ? "bottom" : "left",
        dtype: h ? "radialLinear" : m ? "category" : "linear"
      };
    }))), _e(a, (c) => {
      const l = c.options, d = l.id, h = Yo(d, l), m = Pe(l.type, c.dtype);
      (l.position === void 0 || Cc(l.position, h) !== Cc(c.dposition)) && (l.position = c.dposition), r[d] = !0;
      let y = null;
      if (d in s && s[d].type === m)
        y = s[d];
      else {
        const b = oi.getScale(m);
        y = new b({
          id: d,
          type: m,
          ctx: this.ctx,
          chart: this
        }), s[y.id] = y;
      }
      y.init(l, e);
    }), _e(r, (c, l) => {
      c || delete s[l];
    }), _e(s, (c) => {
      zi.configure(this, c, c.options), zi.addBox(this, c);
    });
  }
  _updateMetasets() {
    const e = this._metasets, t = this.data.datasets.length, s = e.length;
    if (e.sort((r, a) => r.index - a.index), s > t) {
      for (let r = t; r < s; ++r)
        this._destroyDatasetMeta(r);
      e.splice(t, s - t);
    }
    this._sortedMetasets = e.slice(0).sort(Ec("order", "index"));
  }
  _removeUnreferencedMetasets() {
    const { _metasets: e, data: { datasets: t } } = this;
    e.length > t.length && delete this._stacks, e.forEach((s, r) => {
      t.filter((a) => a === s._dataset).length === 0 && this._destroyDatasetMeta(r);
    });
  }
  buildOrUpdateControllers() {
    const e = [], t = this.data.datasets;
    let s, r;
    for (this._removeUnreferencedMetasets(), s = 0, r = t.length; s < r; s++) {
      const a = t[s];
      let c = this.getDatasetMeta(s);
      const l = a.type || this.config.type;
      if (c.type && c.type !== l && (this._destroyDatasetMeta(s), c = this.getDatasetMeta(s)), c.type = l, c.indexAxis = a.indexAxis || Ko(l, this.options), c.order = a.order || 0, c.index = s, c.label = "" + a.label, c.visible = this.isDatasetVisible(s), c.controller)
        c.controller.updateIndex(s), c.controller.linkScales();
      else {
        const d = oi.getController(l), { datasetElementType: h, dataElementType: m } = ht.datasets[l];
        Object.assign(d, {
          dataElementType: oi.getElement(m),
          datasetElementType: h && oi.getElement(h)
        }), c.controller = new d(this, s), e.push(c.controller);
      }
    }
    return this._updateMetasets(), e;
  }
  _resetElements() {
    _e(this.data.datasets, (e, t) => {
      this.getDatasetMeta(t).controller.reset();
    }, this);
  }
  reset() {
    this._resetElements(), this.notifyPlugins("reset");
  }
  update(e) {
    const t = this.config;
    t.update();
    const s = this._options = t.createResolver(t.chartOptionScopes(), this.getContext()), r = this._animationsDisabled = !s.animation;
    if (this._updateScales(), this._checkEventBindings(), this._updateHiddenIndices(), this._plugins.invalidate(), this.notifyPlugins("beforeUpdate", {
      mode: e,
      cancelable: !0
    }) === !1)
      return;
    const a = this.buildOrUpdateControllers();
    this.notifyPlugins("beforeElementsUpdate");
    let c = 0;
    for (let h = 0, m = this.data.datasets.length; h < m; h++) {
      const { controller: y } = this.getDatasetMeta(h), b = !r && a.indexOf(y) === -1;
      y.buildOrUpdateElements(b), c = Math.max(+y.getMaxOverflow(), c);
    }
    c = this._minPadding = s.layout.autoPadding ? c : 0, this._updateLayout(c), r || _e(a, (h) => {
      h.reset();
    }), this._updateDatasets(e), this.notifyPlugins("afterUpdate", {
      mode: e
    }), this._layers.sort(Ec("z", "_idx"));
    const { _active: l, _lastEvent: d } = this;
    d ? this._eventHandler(d, !0) : l.length && this._updateHoverStyles(l, l, !0), this.render();
  }
  _updateScales() {
    _e(this.scales, (e) => {
      zi.removeBox(this, e);
    }), this.ensureScalesHaveIDs(), this.buildOrUpdateScales();
  }
  _checkEventBindings() {
    const e = this.options, t = new Set(Object.keys(this._listeners)), s = new Set(e.events);
    (!ql(t, s) || !!this._responsiveListeners !== e.responsive) && (this.unbindEvents(), this.bindEvents());
  }
  _updateHiddenIndices() {
    const { _hiddenIndices: e } = this, t = this._getUniformDataChanges() || [];
    for (const { method: s, start: r, count: a } of t) {
      const c = s === "_removeElements" ? -a : a;
      aM(e, r, c);
    }
  }
  _getUniformDataChanges() {
    const e = this._dataChanges;
    if (!e || !e.length)
      return;
    this._dataChanges = [];
    const t = this.data.datasets.length, s = (a) => new Set(e.filter((c) => c[0] === a).map((c, l) => l + "," + c.splice(1).join(","))), r = s(0);
    for (let a = 1; a < t; a++)
      if (!ql(r, s(a)))
        return;
    return Array.from(r).map((a) => a.split(",")).map((a) => ({
      method: a[1],
      start: +a[2],
      count: +a[3]
    }));
  }
  _updateLayout(e) {
    if (this.notifyPlugins("beforeLayout", {
      cancelable: !0
    }) === !1)
      return;
    zi.update(this, this.width, this.height, e);
    const t = this.chartArea, s = t.width <= 0 || t.height <= 0;
    this._layers = [], _e(this.boxes, (r) => {
      s && r.position === "chartArea" || (r.configure && r.configure(), this._layers.push(...r._layers()));
    }, this), this._layers.forEach((r, a) => {
      r._idx = a;
    }), this.notifyPlugins("afterLayout");
  }
  _updateDatasets(e) {
    if (this.notifyPlugins("beforeDatasetsUpdate", {
      mode: e,
      cancelable: !0
    }) !== !1) {
      for (let t = 0, s = this.data.datasets.length; t < s; ++t)
        this.getDatasetMeta(t).controller.configure();
      for (let t = 0, s = this.data.datasets.length; t < s; ++t)
        this._updateDataset(t, Di(e) ? e({
          datasetIndex: t
        }) : e);
      this.notifyPlugins("afterDatasetsUpdate", {
        mode: e
      });
    }
  }
  _updateDataset(e, t) {
    const s = this.getDatasetMeta(e), r = {
      meta: s,
      index: e,
      mode: t,
      cancelable: !0
    };
    this.notifyPlugins("beforeDatasetUpdate", r) !== !1 && (s.controller._update(t), r.cancelable = !1, this.notifyPlugins("afterDatasetUpdate", r));
  }
  render() {
    this.notifyPlugins("beforeRender", {
      cancelable: !0
    }) !== !1 && (gi.has(this) ? this.attached && !gi.running(this) && gi.start(this) : (this.draw(), kc({
      chart: this
    })));
  }
  draw() {
    let e;
    if (this._resizeBeforeDraw) {
      const { width: s, height: r } = this._resizeBeforeDraw;
      this._resizeBeforeDraw = null, this._resize(s, r);
    }
    if (this.clear(), this.width <= 0 || this.height <= 0 || this.notifyPlugins("beforeDraw", {
      cancelable: !0
    }) === !1)
      return;
    const t = this._layers;
    for (e = 0; e < t.length && t[e].z <= 0; ++e)
      t[e].draw(this.chartArea);
    for (this._drawDatasets(); e < t.length; ++e)
      t[e].draw(this.chartArea);
    this.notifyPlugins("afterDraw");
  }
  _getSortedDatasetMetas(e) {
    const t = this._sortedMetasets, s = [];
    let r, a;
    for (r = 0, a = t.length; r < a; ++r) {
      const c = t[r];
      (!e || c.visible) && s.push(c);
    }
    return s;
  }
  getSortedVisibleDatasetMetas() {
    return this._getSortedDatasetMetas(!0);
  }
  _drawDatasets() {
    if (this.notifyPlugins("beforeDatasetsDraw", {
      cancelable: !0
    }) === !1)
      return;
    const e = this.getSortedVisibleDatasetMetas();
    for (let t = e.length - 1; t >= 0; --t)
      this._drawDataset(e[t]);
    this.notifyPlugins("afterDatasetsDraw");
  }
  _drawDataset(e) {
    const t = this.ctx, s = e._clip, r = !s.disabled, a = cM(e, this.chartArea), c = {
      meta: e,
      index: e.index,
      cancelable: !0
    };
    this.notifyPlugins("beforeDatasetDraw", c) !== !1 && (r && Nr(t, {
      left: s.left === !1 ? 0 : a.left - s.left,
      right: s.right === !1 ? this.width : a.right + s.right,
      top: s.top === !1 ? 0 : a.top - s.top,
      bottom: s.bottom === !1 ? this.height : a.bottom + s.bottom
    }), e.controller.draw(), r && Fr(t), c.cancelable = !1, this.notifyPlugins("afterDatasetDraw", c));
  }
  isPointInArea(e) {
    return xi(e, this.chartArea, this._minPadding);
  }
  getElementsAtEventForMode(e, t, s, r) {
    const a = rP.modes[t];
    return typeof a == "function" ? a(this, e, s, r) : [];
  }
  getDatasetMeta(e) {
    const t = this.data.datasets[e], s = this._metasets;
    let r = s.filter((a) => a && a._dataset === t).pop();
    return r || (r = {
      type: null,
      data: [],
      dataset: null,
      controller: null,
      hidden: null,
      xAxisID: null,
      yAxisID: null,
      order: t && t.order || 0,
      index: e,
      _dataset: t,
      _parsed: [],
      _sorted: !1
    }, s.push(r)), r;
  }
  getContext() {
    return this.$context || (this.$context = Ni(null, {
      chart: this,
      type: "chart"
    }));
  }
  getVisibleDatasetCount() {
    return this.getSortedVisibleDatasetMetas().length;
  }
  isDatasetVisible(e) {
    const t = this.data.datasets[e];
    if (!t)
      return !1;
    const s = this.getDatasetMeta(e);
    return typeof s.hidden == "boolean" ? !s.hidden : !t.hidden;
  }
  setDatasetVisibility(e, t) {
    const s = this.getDatasetMeta(e);
    s.hidden = !t;
  }
  toggleDataVisibility(e) {
    this._hiddenIndices[e] = !this._hiddenIndices[e];
  }
  getDataVisibility(e) {
    return !this._hiddenIndices[e];
  }
  _updateVisibility(e, t, s) {
    const r = s ? "show" : "hide", a = this.getDatasetMeta(e), c = a.controller._resolveAnimations(void 0, r);
    wr(t) ? (a.data[t].hidden = !s, this.update()) : (this.setDatasetVisibility(e, s), c.update(a, {
      visible: s
    }), this.update((l) => l.datasetIndex === e ? r : void 0));
  }
  hide(e, t) {
    this._updateVisibility(e, t, !1);
  }
  show(e, t) {
    this._updateVisibility(e, t, !0);
  }
  _destroyDatasetMeta(e) {
    const t = this._metasets[e];
    t && t.controller && t.controller._destroy(), delete this._metasets[e];
  }
  _stop() {
    let e, t;
    for (this.stop(), gi.remove(this), e = 0, t = this.data.datasets.length; e < t; ++e)
      this._destroyDatasetMeta(e);
  }
  destroy() {
    this.notifyPlugins("beforeDestroy");
    const { canvas: e, ctx: t } = this;
    this._stop(), this.config.clearCache(), e && (this.unbindEvents(), Ql(e, t), this.platform.releaseContext(t), this.canvas = null, this.ctx = null), delete rr[this.id], this.notifyPlugins("afterDestroy");
  }
  toBase64Image(...e) {
    return this.canvas.toDataURL(...e);
  }
  bindEvents() {
    this.bindUserEvents(), this.options.responsive ? this.bindResponsiveEvents() : this.attached = !0;
  }
  bindUserEvents() {
    const e = this._listeners, t = this.platform, s = (a, c) => {
      t.addEventListener(this, a, c), e[a] = c;
    }, r = (a, c, l) => {
      a.offsetX = c, a.offsetY = l, this._eventHandler(a);
    };
    _e(this.options.events, (a) => s(a, r));
  }
  bindResponsiveEvents() {
    this._responsiveListeners || (this._responsiveListeners = {});
    const e = this._responsiveListeners, t = this.platform, s = (d, h) => {
      t.addEventListener(this, d, h), e[d] = h;
    }, r = (d, h) => {
      e[d] && (t.removeEventListener(this, d, h), delete e[d]);
    }, a = (d, h) => {
      this.canvas && this.resize(d, h);
    };
    let c;
    const l = () => {
      r("attach", l), this.attached = !0, this.resize(), s("resize", a), s("detach", c);
    };
    c = () => {
      this.attached = !1, r("resize", a), this._stop(), this._resize(0, 0), s("attach", l);
    }, t.isAttached(this.canvas) ? l() : c();
  }
  unbindEvents() {
    _e(this._listeners, (e, t) => {
      this.platform.removeEventListener(this, t, e);
    }), this._listeners = {}, _e(this._responsiveListeners, (e, t) => {
      this.platform.removeEventListener(this, t, e);
    }), this._responsiveListeners = void 0;
  }
  updateHoverStyle(e, t, s) {
    const r = s ? "set" : "remove";
    let a, c, l, d;
    for (t === "dataset" && (a = this.getDatasetMeta(e[0].datasetIndex), a.controller["_" + r + "DatasetHoverStyle"]()), l = 0, d = e.length; l < d; ++l) {
      c = e[l];
      const h = c && this.getDatasetMeta(c.datasetIndex).controller;
      h && h[r + "HoverStyle"](c.element, c.datasetIndex, c.index);
    }
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(e) {
    const t = this._active || [], s = e.map(({ datasetIndex: a, index: c }) => {
      const l = this.getDatasetMeta(a);
      if (!l)
        throw new Error("No dataset found at index " + a);
      return {
        datasetIndex: a,
        element: l.data[c],
        index: c
      };
    });
    !xr(s, t) && (this._active = s, this._lastEvent = null, this._updateHoverStyles(s, t));
  }
  notifyPlugins(e, t, s) {
    return this._plugins.notify(this, e, t, s);
  }
  isPluginEnabled(e) {
    return this._plugins._cache.filter((t) => t.plugin.id === e).length === 1;
  }
  _updateHoverStyles(e, t, s) {
    const r = this.options.hover, a = (d, h) => d.filter((m) => !h.some((y) => m.datasetIndex === y.datasetIndex && m.index === y.index)), c = a(t, e), l = s ? e : a(e, t);
    c.length && this.updateHoverStyle(c, r.mode, !1), l.length && r.mode && this.updateHoverStyle(l, r.mode, !0);
  }
  _eventHandler(e, t) {
    const s = {
      event: e,
      replay: t,
      cancelable: !0,
      inChartArea: this.isPointInArea(e)
    }, r = (c) => (c.options.events || this.options.events).includes(e.native.type);
    if (this.notifyPlugins("beforeEvent", s, r) === !1)
      return;
    const a = this._handleEvent(e, t, s.inChartArea);
    return s.cancelable = !1, this.notifyPlugins("afterEvent", s, r), (a || s.changed) && this.render(), this;
  }
  _handleEvent(e, t, s) {
    const { _active: r = [], options: a } = this, c = t, l = this._getActiveElements(e, r, s, c), d = Cz(e), h = lM(e, this._lastEvent, s, d);
    s && (this._lastEvent = null, st(a.onHover, [
      e,
      l,
      this
    ], this), d && st(a.onClick, [
      e,
      l,
      this
    ], this));
    const m = !xr(l, r);
    return (m || t) && (this._active = l, this._updateHoverStyles(l, r, t)), this._lastEvent = h, m;
  }
  _getActiveElements(e, t, s, r) {
    if (e.type === "mouseout")
      return [];
    if (!s)
      return t;
    const a = this.options.hover;
    return this.getElementsAtEventForMode(e, a.mode, a, r);
  }
}
oe(At, "defaults", ht), oe(At, "instances", rr), oe(At, "overrides", sn), oe(At, "registry", oi), oe(At, "version", sM), oe(At, "getChart", Oc);
function Tc() {
  return _e(At.instances, (n) => n._plugins.invalidate());
}
function uM(n, e, t) {
  const { startAngle: s, pixelMargin: r, x: a, y: c, outerRadius: l, innerRadius: d } = e;
  let h = r / l;
  n.beginPath(), n.arc(a, c, l, s - h, t + h), d > r ? (h = r / d, n.arc(a, c, d, t + h, s - h, !0)) : n.arc(a, c, r, t + bt, s - bt), n.closePath(), n.clip();
}
function dM(n) {
  return wa(n, [
    "outerStart",
    "outerEnd",
    "innerStart",
    "innerEnd"
  ]);
}
function fM(n, e, t, s) {
  const r = dM(n.options.borderRadius), a = (t - e) / 2, c = Math.min(a, s * e / 2), l = (d) => {
    const h = (t - Math.min(a, d)) * s / 2;
    return Ut(d, 0, Math.min(a, h));
  };
  return {
    outerStart: l(r.outerStart),
    outerEnd: l(r.outerEnd),
    innerStart: Ut(r.innerStart, 0, c),
    innerEnd: Ut(r.innerEnd, 0, c)
  };
}
function fn(n, e, t, s) {
  return {
    x: t + n * Math.cos(e),
    y: s + n * Math.sin(e)
  };
}
function Tr(n, e, t, s, r, a) {
  const { x: c, y: l, startAngle: d, pixelMargin: h, innerRadius: m } = e, y = Math.max(e.outerRadius + s + t - h, 0), b = m > 0 ? m + s + t + h : 0;
  let v = 0;
  const w = r - d;
  if (s) {
    const C = m > 0 ? m - s : 0, U = y > 0 ? y - s : 0, z = (C + U) / 2, j = z !== 0 ? w * z / (z + s) : w;
    v = (w - j) / 2;
  }
  const o = Math.max(1e-3, w * y - t / pt) / y, u = (w - o) / 2, f = d + u + v, p = r - u - v, { outerStart: g, outerEnd: S, innerStart: x, innerEnd: E } = fM(e, b, y, p - f), k = y - g, R = y - S, O = f + g / k, T = p - S / R, D = b + x, P = b + E, N = f + x / D, I = p - E / P;
  if (n.beginPath(), a) {
    const C = (O + T) / 2;
    if (n.arc(c, l, y, O, C), n.arc(c, l, y, C, T), S > 0) {
      const F = fn(R, T, c, l);
      n.arc(F.x, F.y, S, T, p + bt);
    }
    const U = fn(P, p, c, l);
    if (n.lineTo(U.x, U.y), E > 0) {
      const F = fn(P, I, c, l);
      n.arc(F.x, F.y, E, p + bt, I + Math.PI);
    }
    const z = (p - E / b + (f + x / b)) / 2;
    if (n.arc(c, l, b, p - E / b, z, !0), n.arc(c, l, b, z, f + x / b, !0), x > 0) {
      const F = fn(D, N, c, l);
      n.arc(F.x, F.y, x, N + Math.PI, f - bt);
    }
    const j = fn(k, f, c, l);
    if (n.lineTo(j.x, j.y), g > 0) {
      const F = fn(k, O, c, l);
      n.arc(F.x, F.y, g, f - bt, O);
    }
  } else {
    n.moveTo(c, l);
    const C = Math.cos(O) * y + c, U = Math.sin(O) * y + l;
    n.lineTo(C, U);
    const z = Math.cos(T) * y + c, j = Math.sin(T) * y + l;
    n.lineTo(z, j);
  }
  n.closePath();
}
function hM(n, e, t, s, r) {
  const { fullCircles: a, startAngle: c, circumference: l } = e;
  let d = e.endAngle;
  if (a) {
    Tr(n, e, t, s, d, r);
    for (let h = 0; h < a; ++h)
      n.fill();
    isNaN(l) || (d = c + (l % ot || ot));
  }
  return Tr(n, e, t, s, d, r), n.fill(), d;
}
function pM(n, e, t, s, r) {
  const { fullCircles: a, startAngle: c, circumference: l, options: d } = e, { borderWidth: h, borderJoinStyle: m, borderDash: y, borderDashOffset: b } = d, v = d.borderAlign === "inner";
  if (!h)
    return;
  n.setLineDash(y || []), n.lineDashOffset = b, v ? (n.lineWidth = h * 2, n.lineJoin = m || "round") : (n.lineWidth = h, n.lineJoin = m || "bevel");
  let w = e.endAngle;
  if (a) {
    Tr(n, e, t, s, w, r);
    for (let o = 0; o < a; ++o)
      n.stroke();
    isNaN(l) || (w = c + (l % ot || ot));
  }
  v && uM(n, e, w), a || (Tr(n, e, t, s, w, r), n.stroke());
}
class Kn extends rn {
  constructor(t) {
    super();
    oe(this, "circumference");
    oe(this, "endAngle");
    oe(this, "fullCircles");
    oe(this, "innerRadius");
    oe(this, "outerRadius");
    oe(this, "pixelMargin");
    oe(this, "startAngle");
    this.options = void 0, this.circumference = void 0, this.startAngle = void 0, this.endAngle = void 0, this.innerRadius = void 0, this.outerRadius = void 0, this.pixelMargin = 0, this.fullCircles = 0, t && Object.assign(this, t);
  }
  inRange(t, s, r) {
    const a = this.getProps([
      "x",
      "y"
    ], r), { angle: c, distance: l } = ad(a, {
      x: t,
      y: s
    }), { startAngle: d, endAngle: h, innerRadius: m, outerRadius: y, circumference: b } = this.getProps([
      "startAngle",
      "endAngle",
      "innerRadius",
      "outerRadius",
      "circumference"
    ], r), v = (this.options.spacing + this.options.borderWidth) / 2, w = Pe(b, h - d), o = ds(c, d, h) && d !== h, u = w >= ot || o, f = Yi(l, m + v, y + v);
    return u && f;
  }
  getCenterPoint(t) {
    const { x: s, y: r, startAngle: a, endAngle: c, innerRadius: l, outerRadius: d } = this.getProps([
      "x",
      "y",
      "startAngle",
      "endAngle",
      "innerRadius",
      "outerRadius"
    ], t), { offset: h, spacing: m } = this.options, y = (a + c) / 2, b = (l + d + m + h) / 2;
    return {
      x: s + Math.cos(y) * b,
      y: r + Math.sin(y) * b
    };
  }
  tooltipPosition(t) {
    return this.getCenterPoint(t);
  }
  draw(t) {
    const { options: s, circumference: r } = this, a = (s.offset || 0) / 4, c = (s.spacing || 0) / 2, l = s.circular;
    if (this.pixelMargin = s.borderAlign === "inner" ? 0.33 : 0, this.fullCircles = r > ot ? Math.floor(r / ot) : 0, r === 0 || this.innerRadius < 0 || this.outerRadius < 0)
      return;
    t.save();
    const d = (this.startAngle + this.endAngle) / 2;
    t.translate(Math.cos(d) * a, Math.sin(d) * a);
    const h = 1 - Math.sin(Math.min(pt, r || 0)), m = a * h;
    t.fillStyle = s.backgroundColor, t.strokeStyle = s.borderColor, hM(t, this, m, c, l), pM(t, this, m, c, l), t.restore();
  }
}
oe(Kn, "id", "arc"), oe(Kn, "defaults", {
  borderAlign: "center",
  borderColor: "#fff",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: void 0,
  borderRadius: 0,
  borderWidth: 2,
  offset: 0,
  spacing: 0,
  angle: void 0,
  circular: !0
}), oe(Kn, "defaultRoutes", {
  backgroundColor: "backgroundColor"
}), oe(Kn, "descriptors", {
  _scriptable: !0,
  _indexable: (t) => t !== "borderDash"
});
function jd(n, e, t = e) {
  n.lineCap = Pe(t.borderCapStyle, e.borderCapStyle), n.setLineDash(Pe(t.borderDash, e.borderDash)), n.lineDashOffset = Pe(t.borderDashOffset, e.borderDashOffset), n.lineJoin = Pe(t.borderJoinStyle, e.borderJoinStyle), n.lineWidth = Pe(t.borderWidth, e.borderWidth), n.strokeStyle = Pe(t.borderColor, e.borderColor);
}
function mM(n, e, t) {
  n.lineTo(t.x, t.y);
}
function gM(n) {
  return n.stepped ? Zz : n.tension || n.cubicInterpolationMode === "monotone" ? Qz : mM;
}
function Ld(n, e, t = {}) {
  const s = n.length, { start: r = 0, end: a = s - 1 } = t, { start: c, end: l } = e, d = Math.max(r, c), h = Math.min(a, l), m = r < c && a < c || r > l && a > l;
  return {
    count: s,
    start: d,
    loop: e.loop,
    ilen: h < d && !m ? s + h - d : h - d
  };
}
function yM(n, e, t, s) {
  const { points: r, options: a } = e, { count: c, start: l, loop: d, ilen: h } = Ld(r, t, s), m = gM(a);
  let { move: y = !0, reverse: b } = s || {}, v, w, o;
  for (v = 0; v <= h; ++v)
    w = r[(l + (b ? h - v : v)) % c], !w.skip && (y ? (n.moveTo(w.x, w.y), y = !1) : m(n, o, w, b, a.stepped), o = w);
  return d && (w = r[(l + (b ? h : 0)) % c], m(n, o, w, b, a.stepped)), !!d;
}
function vM(n, e, t, s) {
  const r = e.points, { count: a, start: c, ilen: l } = Ld(r, t, s), { move: d = !0, reverse: h } = s || {};
  let m = 0, y = 0, b, v, w, o, u, f;
  const p = (S) => (c + (h ? l - S : S)) % a, g = () => {
    o !== u && (n.lineTo(m, u), n.lineTo(m, o), n.lineTo(m, f));
  };
  for (d && (v = r[p(0)], n.moveTo(v.x, v.y)), b = 0; b <= l; ++b) {
    if (v = r[p(b)], v.skip)
      continue;
    const S = v.x, x = v.y, E = S | 0;
    E === w ? (x < o ? o = x : x > u && (u = x), m = (y * m + S) / ++y) : (g(), n.lineTo(S, x), w = E, y = 0, o = u = x), f = x;
  }
  g();
}
function Jo(n) {
  const e = n.options, t = e.borderDash && e.borderDash.length;
  return !n._decimated && !n._loop && !e.tension && e.cubicInterpolationMode !== "monotone" && !e.stepped && !t ? vM : yM;
}
function bM(n) {
  return n.stepped ? IR : n.tension || n.cubicInterpolationMode === "monotone" ? UR : Ki;
}
function xM(n, e, t, s) {
  let r = e._path;
  r || (r = e._path = new Path2D(), e.path(r, t, s) && r.closePath()), jd(n, e.options), n.stroke(r);
}
function SM(n, e, t, s) {
  const { segments: r, options: a } = e, c = Jo(e);
  for (const l of r)
    jd(n, a, l.style), n.beginPath(), c(n, e, l, {
      start: t,
      end: t + s - 1
    }) && n.closePath(), n.stroke();
}
const wM = typeof Path2D == "function";
function AM(n, e, t, s) {
  wM && !e.options.segment ? xM(n, e, t, s) : SM(n, e, t, s);
}
class Ri extends rn {
  constructor(e) {
    super(), this.animated = !0, this.options = void 0, this._chart = void 0, this._loop = void 0, this._fullLoop = void 0, this._path = void 0, this._points = void 0, this._segments = void 0, this._decimated = !1, this._pointsUpdated = !1, this._datasetIndex = void 0, e && Object.assign(this, e);
  }
  updateControlPoints(e, t) {
    const s = this.options;
    if ((s.tension || s.cubicInterpolationMode === "monotone") && !s.stepped && !this._pointsUpdated) {
      const r = s.spanGaps ? this._loop : this._fullLoop;
      SR(this._points, s, e, r, t), this._pointsUpdated = !0;
    }
  }
  set points(e) {
    this._points = e, delete this._segments, delete this._path, this._pointsUpdated = !1;
  }
  get points() {
    return this._points;
  }
  get segments() {
    return this._segments || (this._segments = LR(this, this.options.segment));
  }
  first() {
    const e = this.segments, t = this.points;
    return e.length && t[e[0].start];
  }
  last() {
    const e = this.segments, t = this.points, s = e.length;
    return s && t[e[s - 1].end];
  }
  interpolate(e, t) {
    const s = this.options, r = e[t], a = this.points, c = Ad(this, {
      property: t,
      start: r,
      end: r
    });
    if (!c.length)
      return;
    const l = [], d = bM(s);
    let h, m;
    for (h = 0, m = c.length; h < m; ++h) {
      const { start: y, end: b } = c[h], v = a[y], w = a[b];
      if (v === w) {
        l.push(v);
        continue;
      }
      const o = Math.abs((r - v[t]) / (w[t] - v[t])), u = d(v, w, o, s.stepped);
      u[t] = e[t], l.push(u);
    }
    return l.length === 1 ? l[0] : l;
  }
  pathSegment(e, t, s) {
    return Jo(this)(e, this, t, s);
  }
  path(e, t, s) {
    const r = this.segments, a = Jo(this);
    let c = this._loop;
    t = t || 0, s = s || this.points.length - t;
    for (const l of r)
      c &= a(e, this, l, {
        start: t,
        end: t + s - 1
      });
    return !!c;
  }
  draw(e, t, s, r) {
    const a = this.options || {};
    (this.points || []).length && a.borderWidth && (e.save(), AM(e, this, s, r), e.restore()), this.animated && (this._pointsUpdated = !1, this._path = void 0);
  }
}
oe(Ri, "id", "line"), oe(Ri, "defaults", {
  borderCapStyle: "butt",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: "miter",
  borderWidth: 3,
  capBezierPoints: !0,
  cubicInterpolationMode: "default",
  fill: !1,
  spanGaps: !1,
  stepped: !1,
  tension: 0
}), oe(Ri, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
}), oe(Ri, "descriptors", {
  _scriptable: !0,
  _indexable: (e) => e !== "borderDash" && e !== "fill"
});
function Ic(n, e, t, s) {
  const r = n.options, { [t]: a } = n.getProps([
    t
  ], s);
  return Math.abs(e - a) < r.radius + r.hitRadius;
}
class ts extends rn {
  constructor(t) {
    super();
    oe(this, "parsed");
    oe(this, "skip");
    oe(this, "stop");
    this.options = void 0, this.parsed = void 0, this.skip = void 0, this.stop = void 0, t && Object.assign(this, t);
  }
  inRange(t, s, r) {
    const a = this.options, { x: c, y: l } = this.getProps([
      "x",
      "y"
    ], r);
    return Math.pow(t - c, 2) + Math.pow(s - l, 2) < Math.pow(a.hitRadius + a.radius, 2);
  }
  inXRange(t, s) {
    return Ic(this, t, "x", s);
  }
  inYRange(t, s) {
    return Ic(this, t, "y", s);
  }
  getCenterPoint(t) {
    const { x: s, y: r } = this.getProps([
      "x",
      "y"
    ], t);
    return {
      x: s,
      y: r
    };
  }
  size(t) {
    t = t || this.options || {};
    let s = t.radius || 0;
    s = Math.max(s, s && t.hoverRadius || 0);
    const r = s && t.borderWidth || 0;
    return (s + r) * 2;
  }
  draw(t, s) {
    const r = this.options;
    this.skip || r.radius < 0.1 || !xi(this, s, this.size(r) / 2) || (t.strokeStyle = r.borderColor, t.lineWidth = r.borderWidth, t.fillStyle = r.backgroundColor, Wo(t, r, this.x, this.y));
  }
  getRange() {
    const t = this.options || {};
    return t.radius + t.hitRadius;
  }
}
oe(ts, "id", "point"), /**
* @type {any}
*/
oe(ts, "defaults", {
  borderWidth: 1,
  hitRadius: 1,
  hoverBorderWidth: 1,
  hoverRadius: 4,
  pointStyle: "circle",
  radius: 3,
  rotation: 0
}), /**
* @type {any}
*/
oe(ts, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
});
function CM(n, e, t) {
  const s = n.segments, r = n.points, a = e.points, c = [];
  for (const l of s) {
    let { start: d, end: h } = l;
    h = Ia(d, h, r);
    const m = Zo(t, r[d], r[h], l.loop);
    if (!e.segments) {
      c.push({
        source: l,
        target: m,
        start: r[d],
        end: r[h]
      });
      continue;
    }
    const y = Ad(e, m);
    for (const b of y) {
      const v = Zo(t, a[b.start], a[b.end], b.loop), w = wd(l, r, v);
      for (const o of w)
        c.push({
          source: o,
          target: b,
          start: {
            [t]: Uc(m, v, "start", Math.max)
          },
          end: {
            [t]: Uc(m, v, "end", Math.min)
          }
        });
    }
  }
  return c;
}
function Zo(n, e, t, s) {
  if (s)
    return;
  let r = e[n], a = t[n];
  return n === "angle" && (r = Gt(r), a = Gt(a)), {
    property: n,
    start: r,
    end: a
  };
}
function EM(n, e) {
  const { x: t = null, y: s = null } = n || {}, r = e.points, a = [];
  return e.segments.forEach(({ start: c, end: l }) => {
    l = Ia(c, l, r);
    const d = r[c], h = r[l];
    s !== null ? (a.push({
      x: d.x,
      y: s
    }), a.push({
      x: h.x,
      y: s
    })) : t !== null && (a.push({
      x: t,
      y: d.y
    }), a.push({
      x: t,
      y: h.y
    }));
  }), a;
}
function Ia(n, e, t) {
  for (; e > n; e--) {
    const s = t[e];
    if (!isNaN(s.x) && !isNaN(s.y))
      break;
  }
  return e;
}
function Uc(n, e, t, s) {
  return n && e ? s(n[t], e[t]) : n ? n[t] : e ? e[t] : 0;
}
function Dd(n, e) {
  let t = [], s = !1;
  return ut(n) ? (s = !0, t = n) : t = EM(n, e), t.length ? new Ri({
    points: t,
    options: {
      tension: 0
    },
    _loop: s,
    _fullLoop: s
  }) : null;
}
function zc(n) {
  return n && n.fill !== !1;
}
function kM(n, e, t) {
  let r = n[e].fill;
  const a = [
    e
  ];
  let c;
  if (!t)
    return r;
  for (; r !== !1 && a.indexOf(r) === -1; ) {
    if (!ft(r))
      return r;
    if (c = n[r], !c)
      return !1;
    if (c.visible)
      return r;
    a.push(r), r = c.fill;
  }
  return !1;
}
function OM(n, e, t) {
  const s = zM(n);
  if (Ge(s))
    return isNaN(s.value) ? !1 : s;
  let r = parseFloat(s);
  return ft(r) && Math.floor(r) === r ? TM(s[0], e, r, t) : [
    "origin",
    "start",
    "end",
    "stack",
    "shape"
  ].indexOf(s) >= 0 && s;
}
function TM(n, e, t, s) {
  return (n === "-" || n === "+") && (t = e + t), t === e || t < 0 || t >= s ? !1 : t;
}
function IM(n, e) {
  let t = null;
  return n === "start" ? t = e.bottom : n === "end" ? t = e.top : Ge(n) ? t = e.getPixelForValue(n.value) : e.getBasePixel && (t = e.getBasePixel()), t;
}
function UM(n, e, t) {
  let s;
  return n === "start" ? s = t : n === "end" ? s = e.options.reverse ? e.min : e.max : Ge(n) ? s = n.value : s = e.getBaseValue(), s;
}
function zM(n) {
  const e = n.options, t = e.fill;
  let s = Pe(t && t.target, t);
  return s === void 0 && (s = !!e.backgroundColor), s === !1 || s === null ? !1 : s === !0 ? "origin" : s;
}
function RM(n) {
  const { scale: e, index: t, line: s } = n, r = [], a = s.segments, c = s.points, l = PM(e, t);
  l.push(Dd({
    x: null,
    y: e.bottom
  }, s));
  for (let d = 0; d < a.length; d++) {
    const h = a[d];
    for (let m = h.start; m <= h.end; m++)
      MM(r, c[m], l);
  }
  return new Ri({
    points: r,
    options: {}
  });
}
function PM(n, e) {
  const t = [], s = n.getMatchingVisibleMetas("line");
  for (let r = 0; r < s.length; r++) {
    const a = s[r];
    if (a.index === e)
      break;
    a.hidden || t.unshift(a.dataset);
  }
  return t;
}
function MM(n, e, t) {
  const s = [];
  for (let r = 0; r < t.length; r++) {
    const a = t[r], { first: c, last: l, point: d } = jM(a, e, "x");
    if (!(!d || c && l)) {
      if (c)
        s.unshift(d);
      else if (n.push(d), !l)
        break;
    }
  }
  n.push(...s);
}
function jM(n, e, t) {
  const s = n.interpolate(e, t);
  if (!s)
    return {};
  const r = s[t], a = n.segments, c = n.points;
  let l = !1, d = !1;
  for (let h = 0; h < a.length; h++) {
    const m = a[h], y = c[m.start][t], b = c[m.end][t];
    if (Yi(r, y, b)) {
      l = r === y, d = r === b;
      break;
    }
  }
  return {
    first: l,
    last: d,
    point: s
  };
}
class Nd {
  constructor(e) {
    this.x = e.x, this.y = e.y, this.radius = e.radius;
  }
  pathSegment(e, t, s) {
    const { x: r, y: a, radius: c } = this;
    return t = t || {
      start: 0,
      end: ot
    }, e.arc(r, a, c, t.end, t.start, !0), !s.bounds;
  }
  interpolate(e) {
    const { x: t, y: s, radius: r } = this, a = e.angle;
    return {
      x: t + Math.cos(a) * r,
      y: s + Math.sin(a) * r,
      angle: a
    };
  }
}
function LM(n) {
  const { chart: e, fill: t, line: s } = n;
  if (ft(t))
    return DM(e, t);
  if (t === "stack")
    return RM(n);
  if (t === "shape")
    return !0;
  const r = NM(n);
  return r instanceof Nd ? r : Dd(r, s);
}
function DM(n, e) {
  const t = n.getDatasetMeta(e);
  return t && n.isDatasetVisible(e) ? t.dataset : null;
}
function NM(n) {
  return (n.scale || {}).getPointPositionForValue ? BM(n) : FM(n);
}
function FM(n) {
  const { scale: e = {}, fill: t } = n, s = IM(t, e);
  if (ft(s)) {
    const r = e.isHorizontal();
    return {
      x: r ? s : null,
      y: r ? null : s
    };
  }
  return null;
}
function BM(n) {
  const { scale: e, fill: t } = n, s = e.options, r = e.getLabels().length, a = s.reverse ? e.max : e.min, c = UM(t, e, a), l = [];
  if (s.grid.circular) {
    const d = e.getPointPositionForValue(0, a);
    return new Nd({
      x: d.x,
      y: d.y,
      radius: e.getDistanceFromCenterForValue(c)
    });
  }
  for (let d = 0; d < r; ++d)
    l.push(e.getPointPositionForValue(d, c));
  return l;
}
function vo(n, e, t) {
  const s = LM(e), { line: r, scale: a, axis: c } = e, l = r.options, d = l.fill, h = l.backgroundColor, { above: m = h, below: y = h } = d || {};
  s && r.points.length && (Nr(n, t), qM(n, {
    line: r,
    target: s,
    above: m,
    below: y,
    area: t,
    scale: a,
    axis: c
  }), Fr(n));
}
function qM(n, e) {
  const { line: t, target: s, above: r, below: a, area: c, scale: l } = e, d = t._loop ? "angle" : e.axis;
  n.save(), d === "x" && a !== r && (Rc(n, s, c.top), Pc(n, {
    line: t,
    target: s,
    color: r,
    scale: l,
    property: d
  }), n.restore(), n.save(), Rc(n, s, c.bottom)), Pc(n, {
    line: t,
    target: s,
    color: a,
    scale: l,
    property: d
  }), n.restore();
}
function Rc(n, e, t) {
  const { segments: s, points: r } = e;
  let a = !0, c = !1;
  n.beginPath();
  for (const l of s) {
    const { start: d, end: h } = l, m = r[d], y = r[Ia(d, h, r)];
    a ? (n.moveTo(m.x, m.y), a = !1) : (n.lineTo(m.x, t), n.lineTo(m.x, m.y)), c = !!e.pathSegment(n, l, {
      move: c
    }), c ? n.closePath() : n.lineTo(y.x, t);
  }
  n.lineTo(e.first().x, t), n.closePath(), n.clip();
}
function Pc(n, e) {
  const { line: t, target: s, property: r, color: a, scale: c } = e, l = CM(t, s, r);
  for (const { source: d, target: h, start: m, end: y } of l) {
    const { style: { backgroundColor: b = a } = {} } = d, v = s !== !0;
    n.save(), n.fillStyle = b, HM(n, c, v && Zo(r, m, y)), n.beginPath();
    const w = !!t.pathSegment(n, d);
    let o;
    if (v) {
      w ? n.closePath() : Mc(n, s, y, r);
      const u = !!s.pathSegment(n, h, {
        move: w,
        reverse: !0
      });
      o = w && u, o || Mc(n, s, m, r);
    }
    n.closePath(), n.fill(o ? "evenodd" : "nonzero"), n.restore();
  }
}
function HM(n, e, t) {
  const { top: s, bottom: r } = e.chart.chartArea, { property: a, start: c, end: l } = t || {};
  a === "x" && (n.beginPath(), n.rect(c, s, l - c, r - s), n.clip());
}
function Mc(n, e, t, s) {
  const r = e.interpolate(t, s);
  r && n.lineTo(r.x, r.y);
}
var VM = {
  id: "filler",
  afterDatasetsUpdate(n, e, t) {
    const s = (n.data.datasets || []).length, r = [];
    let a, c, l, d;
    for (c = 0; c < s; ++c)
      a = n.getDatasetMeta(c), l = a.dataset, d = null, l && l.options && l instanceof Ri && (d = {
        visible: n.isDatasetVisible(c),
        index: c,
        fill: OM(l, c, s),
        chart: n,
        axis: a.controller.options.indexAxis,
        scale: a.vScale,
        line: l
      }), a.$filler = d, r.push(d);
    for (c = 0; c < s; ++c)
      d = r[c], !(!d || d.fill === !1) && (d.fill = kM(r, c, t.propagate));
  },
  beforeDraw(n, e, t) {
    const s = t.drawTime === "beforeDraw", r = n.getSortedVisibleDatasetMetas(), a = n.chartArea;
    for (let c = r.length - 1; c >= 0; --c) {
      const l = r[c].$filler;
      l && (l.line.updateControlPoints(a, l.axis), s && l.fill && vo(n.ctx, l, a));
    }
  },
  beforeDatasetsDraw(n, e, t) {
    if (t.drawTime !== "beforeDatasetsDraw")
      return;
    const s = n.getSortedVisibleDatasetMetas();
    for (let r = s.length - 1; r >= 0; --r) {
      const a = s[r].$filler;
      zc(a) && vo(n.ctx, a, n.chartArea);
    }
  },
  beforeDatasetDraw(n, e, t) {
    const s = e.meta.$filler;
    !zc(s) || t.drawTime !== "beforeDatasetDraw" || vo(n.ctx, s, n.chartArea);
  },
  defaults: {
    propagate: !0,
    drawTime: "beforeDatasetDraw"
  }
};
const jc = (n, e) => {
  let { boxHeight: t = e, boxWidth: s = e } = n;
  return n.usePointStyle && (t = Math.min(t, e), s = n.pointStyleWidth || Math.min(s, e)), {
    boxWidth: s,
    boxHeight: t,
    itemHeight: Math.max(e, t)
  };
}, GM = (n, e) => n !== null && e !== null && n.datasetIndex === e.datasetIndex && n.index === e.index;
class Lc extends rn {
  constructor(e) {
    super(), this._added = !1, this.legendHitBoxes = [], this._hoveredItem = null, this.doughnutMode = !1, this.chart = e.chart, this.options = e.options, this.ctx = e.ctx, this.legendItems = void 0, this.columnSizes = void 0, this.lineWidths = void 0, this.maxHeight = void 0, this.maxWidth = void 0, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.height = void 0, this.width = void 0, this._margins = void 0, this.position = void 0, this.weight = void 0, this.fullSize = void 0;
  }
  update(e, t, s) {
    this.maxWidth = e, this.maxHeight = t, this._margins = s, this.setDimensions(), this.buildLabels(), this.fit();
  }
  setDimensions() {
    this.isHorizontal() ? (this.width = this.maxWidth, this.left = this._margins.left, this.right = this.width) : (this.height = this.maxHeight, this.top = this._margins.top, this.bottom = this.height);
  }
  buildLabels() {
    const e = this.options.labels || {};
    let t = st(e.generateLabels, [
      this.chart
    ], this) || [];
    e.filter && (t = t.filter((s) => e.filter(s, this.chart.data))), e.sort && (t = t.sort((s, r) => e.sort(s, r, this.chart.data))), this.options.reverse && t.reverse(), this.legendItems = t;
  }
  fit() {
    const { options: e, ctx: t } = this;
    if (!e.display) {
      this.width = this.height = 0;
      return;
    }
    const s = e.labels, r = Ct(s.font), a = r.size, c = this._computeTitleHeight(), { boxWidth: l, itemHeight: d } = jc(s, a);
    let h, m;
    t.font = r.string, this.isHorizontal() ? (h = this.maxWidth, m = this._fitRows(c, a, l, d) + 10) : (m = this.maxHeight, h = this._fitCols(c, r, l, d) + 10), this.width = Math.min(h, e.maxWidth || this.maxWidth), this.height = Math.min(m, e.maxHeight || this.maxHeight);
  }
  _fitRows(e, t, s, r) {
    const { ctx: a, maxWidth: c, options: { labels: { padding: l } } } = this, d = this.legendHitBoxes = [], h = this.lineWidths = [
      0
    ], m = r + l;
    let y = e;
    a.textAlign = "left", a.textBaseline = "middle";
    let b = -1, v = -m;
    return this.legendItems.forEach((w, o) => {
      const u = s + t / 2 + a.measureText(w.text).width;
      (o === 0 || h[h.length - 1] + u + 2 * l > c) && (y += m, h[h.length - (o > 0 ? 0 : 1)] = 0, v += m, b++), d[o] = {
        left: 0,
        top: v,
        row: b,
        width: u,
        height: r
      }, h[h.length - 1] += u + l;
    }), y;
  }
  _fitCols(e, t, s, r) {
    const { ctx: a, maxHeight: c, options: { labels: { padding: l } } } = this, d = this.legendHitBoxes = [], h = this.columnSizes = [], m = c - e;
    let y = l, b = 0, v = 0, w = 0, o = 0;
    return this.legendItems.forEach((u, f) => {
      const { itemWidth: p, itemHeight: g } = WM(s, t, a, u, r);
      f > 0 && v + g + 2 * l > m && (y += b + l, h.push({
        width: b,
        height: v
      }), w += b + l, o++, b = v = 0), d[f] = {
        left: w,
        top: v,
        col: o,
        width: p,
        height: g
      }, b = Math.max(b, p), v += g + l;
    }), y += b, h.push({
      width: b,
      height: v
    }), y;
  }
  adjustHitBoxes() {
    if (!this.options.display)
      return;
    const e = this._computeTitleHeight(), { legendHitBoxes: t, options: { align: s, labels: { padding: r }, rtl: a } } = this, c = yn(a, this.left, this.width);
    if (this.isHorizontal()) {
      let l = 0, d = qt(s, this.left + r, this.right - this.lineWidths[l]);
      for (const h of t)
        l !== h.row && (l = h.row, d = qt(s, this.left + r, this.right - this.lineWidths[l])), h.top += this.top + e + r, h.left = c.leftForLtr(c.x(d), h.width), d += h.width + r;
    } else {
      let l = 0, d = qt(s, this.top + e + r, this.bottom - this.columnSizes[l].height);
      for (const h of t)
        h.col !== l && (l = h.col, d = qt(s, this.top + e + r, this.bottom - this.columnSizes[l].height)), h.top = d, h.left += this.left + r, h.left = c.leftForLtr(c.x(h.left), h.width), d += h.height + r;
    }
  }
  isHorizontal() {
    return this.options.position === "top" || this.options.position === "bottom";
  }
  draw() {
    if (this.options.display) {
      const e = this.ctx;
      Nr(e, this), this._draw(), Fr(e);
    }
  }
  _draw() {
    const { options: e, columnSizes: t, lineWidths: s, ctx: r } = this, { align: a, labels: c } = e, l = ht.color, d = yn(e.rtl, this.left, this.width), h = Ct(c.font), { padding: m } = c, y = h.size, b = y / 2;
    let v;
    this.drawTitle(), r.textAlign = d.textAlign("left"), r.textBaseline = "middle", r.lineWidth = 0.5, r.font = h.string;
    const { boxWidth: w, boxHeight: o, itemHeight: u } = jc(c, y), f = function(E, k, R) {
      if (isNaN(w) || w <= 0 || isNaN(o) || o < 0)
        return;
      r.save();
      const O = Pe(R.lineWidth, 1);
      if (r.fillStyle = Pe(R.fillStyle, l), r.lineCap = Pe(R.lineCap, "butt"), r.lineDashOffset = Pe(R.lineDashOffset, 0), r.lineJoin = Pe(R.lineJoin, "miter"), r.lineWidth = O, r.strokeStyle = Pe(R.strokeStyle, l), r.setLineDash(Pe(R.lineDash, [])), c.usePointStyle) {
        const T = {
          radius: o * Math.SQRT2 / 2,
          pointStyle: R.pointStyle,
          rotation: R.rotation,
          borderWidth: O
        }, D = d.xPlus(E, w / 2), P = k + b;
        hd(r, T, D, P, c.pointStyleWidth && w);
      } else {
        const T = k + Math.max((y - o) / 2, 0), D = d.leftForLtr(E, w), P = gn(R.borderRadius);
        r.beginPath(), Object.values(P).some((N) => N !== 0) ? Er(r, {
          x: D,
          y: T,
          w,
          h: o,
          radius: P
        }) : r.rect(D, T, w, o), r.fill(), O !== 0 && r.stroke();
      }
      r.restore();
    }, p = function(E, k, R) {
      An(r, R.text, E, k + u / 2, h, {
        strikethrough: R.hidden,
        textAlign: d.textAlign(R.textAlign)
      });
    }, g = this.isHorizontal(), S = this._computeTitleHeight();
    g ? v = {
      x: qt(a, this.left + m, this.right - s[0]),
      y: this.top + m + S,
      line: 0
    } : v = {
      x: this.left + m,
      y: qt(a, this.top + S + m, this.bottom - t[0].height),
      line: 0
    }, bd(this.ctx, e.textDirection);
    const x = u + m;
    this.legendItems.forEach((E, k) => {
      r.strokeStyle = E.fontColor, r.fillStyle = E.fontColor;
      const R = r.measureText(E.text).width, O = d.textAlign(E.textAlign || (E.textAlign = c.textAlign)), T = w + b + R;
      let D = v.x, P = v.y;
      d.setWidth(this.width), g ? k > 0 && D + T + m > this.right && (P = v.y += x, v.line++, D = v.x = qt(a, this.left + m, this.right - s[v.line])) : k > 0 && P + x > this.bottom && (D = v.x = D + t[v.line].width + m, v.line++, P = v.y = qt(a, this.top + S + m, this.bottom - t[v.line].height));
      const N = d.x(D);
      if (f(N, P, E), D = Lz(O, D + w + b, g ? D + T : this.right, e.rtl), p(d.x(D), P, E), g)
        v.x += T + m;
      else if (typeof E.text != "string") {
        const I = h.lineHeight;
        v.y += Fd(E, I) + m;
      } else
        v.y += x;
    }), xd(this.ctx, e.textDirection);
  }
  drawTitle() {
    const e = this.options, t = e.title, s = Ct(t.font), r = zt(t.padding);
    if (!t.display)
      return;
    const a = yn(e.rtl, this.left, this.width), c = this.ctx, l = t.position, d = s.size / 2, h = r.top + d;
    let m, y = this.left, b = this.width;
    if (this.isHorizontal())
      b = Math.max(...this.lineWidths), m = this.top + h, y = qt(e.align, y, this.right - b);
    else {
      const w = this.columnSizes.reduce((o, u) => Math.max(o, u.height), 0);
      m = h + qt(e.align, this.top, this.bottom - w - e.labels.padding - this._computeTitleHeight());
    }
    const v = qt(l, y, y + b);
    c.textAlign = a.textAlign(dd(l)), c.textBaseline = "middle", c.strokeStyle = t.color, c.fillStyle = t.color, c.font = s.string, An(c, t.text, v, m, s);
  }
  _computeTitleHeight() {
    const e = this.options.title, t = Ct(e.font), s = zt(e.padding);
    return e.display ? t.lineHeight + s.height : 0;
  }
  _getLegendItemAt(e, t) {
    let s, r, a;
    if (Yi(e, this.left, this.right) && Yi(t, this.top, this.bottom)) {
      for (a = this.legendHitBoxes, s = 0; s < a.length; ++s)
        if (r = a[s], Yi(e, r.left, r.left + r.width) && Yi(t, r.top, r.top + r.height))
          return this.legendItems[s];
    }
    return null;
  }
  handleEvent(e) {
    const t = this.options;
    if (!JM(e.type, t))
      return;
    const s = this._getLegendItemAt(e.x, e.y);
    if (e.type === "mousemove" || e.type === "mouseout") {
      const r = this._hoveredItem, a = GM(r, s);
      r && !a && st(t.onLeave, [
        e,
        r,
        this
      ], this), this._hoveredItem = s, s && !a && st(t.onHover, [
        e,
        s,
        this
      ], this);
    } else
      s && st(t.onClick, [
        e,
        s,
        this
      ], this);
  }
}
function WM(n, e, t, s, r) {
  const a = KM(s, n, e, t), c = YM(r, s, e.lineHeight);
  return {
    itemWidth: a,
    itemHeight: c
  };
}
function KM(n, e, t, s) {
  let r = n.text;
  return r && typeof r != "string" && (r = r.reduce((a, c) => a.length > c.length ? a : c)), e + t.size / 2 + s.measureText(r).width;
}
function YM(n, e, t) {
  let s = n;
  return typeof e.text != "string" && (s = Fd(e, t)), s;
}
function Fd(n, e) {
  const t = n.text ? n.text.length : 0;
  return e * t;
}
function JM(n, e) {
  return !!((n === "mousemove" || n === "mouseout") && (e.onHover || e.onLeave) || e.onClick && (n === "click" || n === "mouseup"));
}
var ZM = {
  id: "legend",
  _element: Lc,
  start(n, e, t) {
    const s = n.legend = new Lc({
      ctx: n.ctx,
      options: t,
      chart: n
    });
    zi.configure(n, s, t), zi.addBox(n, s);
  },
  stop(n) {
    zi.removeBox(n, n.legend), delete n.legend;
  },
  beforeUpdate(n, e, t) {
    const s = n.legend;
    zi.configure(n, s, t), s.options = t;
  },
  afterUpdate(n) {
    const e = n.legend;
    e.buildLabels(), e.adjustHitBoxes();
  },
  afterEvent(n, e) {
    e.replay || n.legend.handleEvent(e.event);
  },
  defaults: {
    display: !0,
    position: "top",
    align: "center",
    fullSize: !0,
    reverse: !1,
    weight: 1e3,
    onClick(n, e, t) {
      const s = e.datasetIndex, r = t.chart;
      r.isDatasetVisible(s) ? (r.hide(s), e.hidden = !0) : (r.show(s), e.hidden = !1);
    },
    onHover: null,
    onLeave: null,
    labels: {
      color: (n) => n.chart.options.color,
      boxWidth: 40,
      padding: 10,
      generateLabels(n) {
        const e = n.data.datasets, { labels: { usePointStyle: t, pointStyle: s, textAlign: r, color: a, useBorderRadius: c, borderRadius: l } } = n.legend.options;
        return n._getSortedDatasetMetas().map((d) => {
          const h = d.controller.getStyle(t ? 0 : void 0), m = zt(h.borderWidth);
          return {
            text: e[d.index].label,
            fillStyle: h.backgroundColor,
            fontColor: a,
            hidden: !d.visible,
            lineCap: h.borderCapStyle,
            lineDash: h.borderDash,
            lineDashOffset: h.borderDashOffset,
            lineJoin: h.borderJoinStyle,
            lineWidth: (m.width + m.height) / 4,
            strokeStyle: h.borderColor,
            pointStyle: s || h.pointStyle,
            rotation: h.rotation,
            textAlign: r || h.textAlign,
            borderRadius: c && (l || h.borderRadius),
            datasetIndex: d.index
          };
        }, this);
      }
    },
    title: {
      color: (n) => n.chart.options.color,
      display: !1,
      position: "center",
      text: ""
    }
  },
  descriptors: {
    _scriptable: (n) => !n.startsWith("on"),
    labels: {
      _scriptable: (n) => ![
        "generateLabels",
        "filter",
        "sort"
      ].includes(n)
    }
  }
};
const Yn = {
  average(n) {
    if (!n.length)
      return !1;
    let e, t, s = /* @__PURE__ */ new Set(), r = 0, a = 0;
    for (e = 0, t = n.length; e < t; ++e) {
      const l = n[e].element;
      if (l && l.hasValue()) {
        const d = l.tooltipPosition();
        s.add(d.x), r += d.y, ++a;
      }
    }
    return a === 0 || s.size === 0 ? !1 : {
      x: [
        ...s
      ].reduce((l, d) => l + d) / s.size,
      y: r / a
    };
  },
  nearest(n, e) {
    if (!n.length)
      return !1;
    let t = e.x, s = e.y, r = Number.POSITIVE_INFINITY, a, c, l;
    for (a = 0, c = n.length; a < c; ++a) {
      const d = n[a].element;
      if (d && d.hasValue()) {
        const h = d.getCenterPoint(), m = Vo(e, h);
        m < r && (r = m, l = d);
      }
    }
    if (l) {
      const d = l.tooltipPosition();
      t = d.x, s = d.y;
    }
    return {
      x: t,
      y: s
    };
  }
};
function ri(n, e) {
  return e && (ut(e) ? Array.prototype.push.apply(n, e) : n.push(e)), n;
}
function yi(n) {
  return (typeof n == "string" || n instanceof String) && n.indexOf(`
`) > -1 ? n.split(`
`) : n;
}
function QM(n, e) {
  const { element: t, datasetIndex: s, index: r } = e, a = n.getDatasetMeta(s).controller, { label: c, value: l } = a.getLabelAndValue(r);
  return {
    chart: n,
    label: c,
    parsed: a.getParsed(r),
    raw: n.data.datasets[s].data[r],
    formattedValue: l,
    dataset: a.getDataset(),
    dataIndex: r,
    datasetIndex: s,
    element: t
  };
}
function Dc(n, e) {
  const t = n.chart.ctx, { body: s, footer: r, title: a } = n, { boxWidth: c, boxHeight: l } = e, d = Ct(e.bodyFont), h = Ct(e.titleFont), m = Ct(e.footerFont), y = a.length, b = r.length, v = s.length, w = zt(e.padding);
  let o = w.height, u = 0, f = s.reduce((S, x) => S + x.before.length + x.lines.length + x.after.length, 0);
  if (f += n.beforeBody.length + n.afterBody.length, y && (o += y * h.lineHeight + (y - 1) * e.titleSpacing + e.titleMarginBottom), f) {
    const S = e.displayColors ? Math.max(l, d.lineHeight) : d.lineHeight;
    o += v * S + (f - v) * d.lineHeight + (f - 1) * e.bodySpacing;
  }
  b && (o += e.footerMarginTop + b * m.lineHeight + (b - 1) * e.footerSpacing);
  let p = 0;
  const g = function(S) {
    u = Math.max(u, t.measureText(S).width + p);
  };
  return t.save(), t.font = h.string, _e(n.title, g), t.font = d.string, _e(n.beforeBody.concat(n.afterBody), g), p = e.displayColors ? c + 2 + e.boxPadding : 0, _e(s, (S) => {
    _e(S.before, g), _e(S.lines, g), _e(S.after, g);
  }), p = 0, t.font = m.string, _e(n.footer, g), t.restore(), u += w.width, {
    width: u,
    height: o
  };
}
function XM(n, e) {
  const { y: t, height: s } = e;
  return t < s / 2 ? "top" : t > n.height - s / 2 ? "bottom" : "center";
}
function _M(n, e, t, s) {
  const { x: r, width: a } = s, c = t.caretSize + t.caretPadding;
  if (n === "left" && r + a + c > e.width || n === "right" && r - a - c < 0)
    return !0;
}
function $M(n, e, t, s) {
  const { x: r, width: a } = t, { width: c, chartArea: { left: l, right: d } } = n;
  let h = "center";
  return s === "center" ? h = r <= (l + d) / 2 ? "left" : "right" : r <= a / 2 ? h = "left" : r >= c - a / 2 && (h = "right"), _M(h, n, e, t) && (h = "center"), h;
}
function Nc(n, e, t) {
  const s = t.yAlign || e.yAlign || XM(n, t);
  return {
    xAlign: t.xAlign || e.xAlign || $M(n, e, t, s),
    yAlign: s
  };
}
function ej(n, e) {
  let { x: t, width: s } = n;
  return e === "right" ? t -= s : e === "center" && (t -= s / 2), t;
}
function tj(n, e, t) {
  let { y: s, height: r } = n;
  return e === "top" ? s += t : e === "bottom" ? s -= r + t : s -= r / 2, s;
}
function Fc(n, e, t, s) {
  const { caretSize: r, caretPadding: a, cornerRadius: c } = n, { xAlign: l, yAlign: d } = t, h = r + a, { topLeft: m, topRight: y, bottomLeft: b, bottomRight: v } = gn(c);
  let w = ej(e, l);
  const o = tj(e, d, h);
  return d === "center" ? l === "left" ? w += h : l === "right" && (w -= h) : l === "left" ? w -= Math.max(m, b) + r : l === "right" && (w += Math.max(y, v) + r), {
    x: Ut(w, 0, s.width - e.width),
    y: Ut(o, 0, s.height - e.height)
  };
}
function Ys(n, e, t) {
  const s = zt(t.padding);
  return e === "center" ? n.x + n.width / 2 : e === "right" ? n.x + n.width - s.right : n.x + s.left;
}
function Bc(n) {
  return ri([], yi(n));
}
function ij(n, e, t) {
  return Ni(n, {
    tooltip: e,
    tooltipItems: t,
    type: "tooltip"
  });
}
function qc(n, e) {
  const t = e && e.dataset && e.dataset.tooltip && e.dataset.tooltip.callbacks;
  return t ? n.override(t) : n;
}
const Bd = {
  beforeTitle: pi,
  title(n) {
    if (n.length > 0) {
      const e = n[0], t = e.chart.data.labels, s = t ? t.length : 0;
      if (this && this.options && this.options.mode === "dataset")
        return e.dataset.label || "";
      if (e.label)
        return e.label;
      if (s > 0 && e.dataIndex < s)
        return t[e.dataIndex];
    }
    return "";
  },
  afterTitle: pi,
  beforeBody: pi,
  beforeLabel: pi,
  label(n) {
    if (this && this.options && this.options.mode === "dataset")
      return n.label + ": " + n.formattedValue || n.formattedValue;
    let e = n.dataset.label || "";
    e && (e += ": ");
    const t = n.formattedValue;
    return rt(t) || (e += t), e;
  },
  labelColor(n) {
    const t = n.chart.getDatasetMeta(n.datasetIndex).controller.getStyle(n.dataIndex);
    return {
      borderColor: t.borderColor,
      backgroundColor: t.backgroundColor,
      borderWidth: t.borderWidth,
      borderDash: t.borderDash,
      borderDashOffset: t.borderDashOffset,
      borderRadius: 0
    };
  },
  labelTextColor() {
    return this.options.bodyColor;
  },
  labelPointStyle(n) {
    const t = n.chart.getDatasetMeta(n.datasetIndex).controller.getStyle(n.dataIndex);
    return {
      pointStyle: t.pointStyle,
      rotation: t.rotation
    };
  },
  afterLabel: pi,
  afterBody: pi,
  beforeFooter: pi,
  footer: pi,
  afterFooter: pi
};
function Rt(n, e, t, s) {
  const r = n[e].call(t, s);
  return typeof r > "u" ? Bd[e].call(t, s) : r;
}
class Qo extends rn {
  constructor(e) {
    super(), this.opacity = 0, this._active = [], this._eventPosition = void 0, this._size = void 0, this._cachedAnimations = void 0, this._tooltipItems = [], this.$animations = void 0, this.$context = void 0, this.chart = e.chart, this.options = e.options, this.dataPoints = void 0, this.title = void 0, this.beforeBody = void 0, this.body = void 0, this.afterBody = void 0, this.footer = void 0, this.xAlign = void 0, this.yAlign = void 0, this.x = void 0, this.y = void 0, this.height = void 0, this.width = void 0, this.caretX = void 0, this.caretY = void 0, this.labelColors = void 0, this.labelPointStyles = void 0, this.labelTextColors = void 0;
  }
  initialize(e) {
    this.options = e, this._cachedAnimations = void 0, this.$context = void 0;
  }
  _resolveAnimations() {
    const e = this._cachedAnimations;
    if (e)
      return e;
    const t = this.chart, s = this.options.setContext(this.getContext()), r = s.enabled && t.options.animation && s.animations, a = new Cd(this.chart, r);
    return r._cacheable && (this._cachedAnimations = Object.freeze(a)), a;
  }
  getContext() {
    return this.$context || (this.$context = ij(this.chart.getContext(), this, this._tooltipItems));
  }
  getTitle(e, t) {
    const { callbacks: s } = t, r = Rt(s, "beforeTitle", this, e), a = Rt(s, "title", this, e), c = Rt(s, "afterTitle", this, e);
    let l = [];
    return l = ri(l, yi(r)), l = ri(l, yi(a)), l = ri(l, yi(c)), l;
  }
  getBeforeBody(e, t) {
    return Bc(Rt(t.callbacks, "beforeBody", this, e));
  }
  getBody(e, t) {
    const { callbacks: s } = t, r = [];
    return _e(e, (a) => {
      const c = {
        before: [],
        lines: [],
        after: []
      }, l = qc(s, a);
      ri(c.before, yi(Rt(l, "beforeLabel", this, a))), ri(c.lines, Rt(l, "label", this, a)), ri(c.after, yi(Rt(l, "afterLabel", this, a))), r.push(c);
    }), r;
  }
  getAfterBody(e, t) {
    return Bc(Rt(t.callbacks, "afterBody", this, e));
  }
  getFooter(e, t) {
    const { callbacks: s } = t, r = Rt(s, "beforeFooter", this, e), a = Rt(s, "footer", this, e), c = Rt(s, "afterFooter", this, e);
    let l = [];
    return l = ri(l, yi(r)), l = ri(l, yi(a)), l = ri(l, yi(c)), l;
  }
  _createItems(e) {
    const t = this._active, s = this.chart.data, r = [], a = [], c = [];
    let l = [], d, h;
    for (d = 0, h = t.length; d < h; ++d)
      l.push(QM(this.chart, t[d]));
    return e.filter && (l = l.filter((m, y, b) => e.filter(m, y, b, s))), e.itemSort && (l = l.sort((m, y) => e.itemSort(m, y, s))), _e(l, (m) => {
      const y = qc(e.callbacks, m);
      r.push(Rt(y, "labelColor", this, m)), a.push(Rt(y, "labelPointStyle", this, m)), c.push(Rt(y, "labelTextColor", this, m));
    }), this.labelColors = r, this.labelPointStyles = a, this.labelTextColors = c, this.dataPoints = l, l;
  }
  update(e, t) {
    const s = this.options.setContext(this.getContext()), r = this._active;
    let a, c = [];
    if (!r.length)
      this.opacity !== 0 && (a = {
        opacity: 0
      });
    else {
      const l = Yn[s.position].call(this, r, this._eventPosition);
      c = this._createItems(s), this.title = this.getTitle(c, s), this.beforeBody = this.getBeforeBody(c, s), this.body = this.getBody(c, s), this.afterBody = this.getAfterBody(c, s), this.footer = this.getFooter(c, s);
      const d = this._size = Dc(this, s), h = Object.assign({}, l, d), m = Nc(this.chart, s, h), y = Fc(s, h, m, this.chart);
      this.xAlign = m.xAlign, this.yAlign = m.yAlign, a = {
        opacity: 1,
        x: y.x,
        y: y.y,
        width: d.width,
        height: d.height,
        caretX: l.x,
        caretY: l.y
      };
    }
    this._tooltipItems = c, this.$context = void 0, a && this._resolveAnimations().update(this, a), e && s.external && s.external.call(this, {
      chart: this.chart,
      tooltip: this,
      replay: t
    });
  }
  drawCaret(e, t, s, r) {
    const a = this.getCaretPosition(e, s, r);
    t.lineTo(a.x1, a.y1), t.lineTo(a.x2, a.y2), t.lineTo(a.x3, a.y3);
  }
  getCaretPosition(e, t, s) {
    const { xAlign: r, yAlign: a } = this, { caretSize: c, cornerRadius: l } = s, { topLeft: d, topRight: h, bottomLeft: m, bottomRight: y } = gn(l), { x: b, y: v } = e, { width: w, height: o } = t;
    let u, f, p, g, S, x;
    return a === "center" ? (S = v + o / 2, r === "left" ? (u = b, f = u - c, g = S + c, x = S - c) : (u = b + w, f = u + c, g = S - c, x = S + c), p = u) : (r === "left" ? f = b + Math.max(d, m) + c : r === "right" ? f = b + w - Math.max(h, y) - c : f = this.caretX, a === "top" ? (g = v, S = g - c, u = f - c, p = f + c) : (g = v + o, S = g + c, u = f + c, p = f - c), x = g), {
      x1: u,
      x2: f,
      x3: p,
      y1: g,
      y2: S,
      y3: x
    };
  }
  drawTitle(e, t, s) {
    const r = this.title, a = r.length;
    let c, l, d;
    if (a) {
      const h = yn(s.rtl, this.x, this.width);
      for (e.x = Ys(this, s.titleAlign, s), t.textAlign = h.textAlign(s.titleAlign), t.textBaseline = "middle", c = Ct(s.titleFont), l = s.titleSpacing, t.fillStyle = s.titleColor, t.font = c.string, d = 0; d < a; ++d)
        t.fillText(r[d], h.x(e.x), e.y + c.lineHeight / 2), e.y += c.lineHeight + l, d + 1 === a && (e.y += s.titleMarginBottom - l);
    }
  }
  _drawColorBox(e, t, s, r, a) {
    const c = this.labelColors[s], l = this.labelPointStyles[s], { boxHeight: d, boxWidth: h } = a, m = Ct(a.bodyFont), y = Ys(this, "left", a), b = r.x(y), v = d < m.lineHeight ? (m.lineHeight - d) / 2 : 0, w = t.y + v;
    if (a.usePointStyle) {
      const o = {
        radius: Math.min(h, d) / 2,
        pointStyle: l.pointStyle,
        rotation: l.rotation,
        borderWidth: 1
      }, u = r.leftForLtr(b, h) + h / 2, f = w + d / 2;
      e.strokeStyle = a.multiKeyBackground, e.fillStyle = a.multiKeyBackground, Wo(e, o, u, f), e.strokeStyle = c.borderColor, e.fillStyle = c.backgroundColor, Wo(e, o, u, f);
    } else {
      e.lineWidth = Ge(c.borderWidth) ? Math.max(...Object.values(c.borderWidth)) : c.borderWidth || 1, e.strokeStyle = c.borderColor, e.setLineDash(c.borderDash || []), e.lineDashOffset = c.borderDashOffset || 0;
      const o = r.leftForLtr(b, h), u = r.leftForLtr(r.xPlus(b, 1), h - 2), f = gn(c.borderRadius);
      Object.values(f).some((p) => p !== 0) ? (e.beginPath(), e.fillStyle = a.multiKeyBackground, Er(e, {
        x: o,
        y: w,
        w: h,
        h: d,
        radius: f
      }), e.fill(), e.stroke(), e.fillStyle = c.backgroundColor, e.beginPath(), Er(e, {
        x: u,
        y: w + 1,
        w: h - 2,
        h: d - 2,
        radius: f
      }), e.fill()) : (e.fillStyle = a.multiKeyBackground, e.fillRect(o, w, h, d), e.strokeRect(o, w, h, d), e.fillStyle = c.backgroundColor, e.fillRect(u, w + 1, h - 2, d - 2));
    }
    e.fillStyle = this.labelTextColors[s];
  }
  drawBody(e, t, s) {
    const { body: r } = this, { bodySpacing: a, bodyAlign: c, displayColors: l, boxHeight: d, boxWidth: h, boxPadding: m } = s, y = Ct(s.bodyFont);
    let b = y.lineHeight, v = 0;
    const w = yn(s.rtl, this.x, this.width), o = function(R) {
      t.fillText(R, w.x(e.x + v), e.y + b / 2), e.y += b + a;
    }, u = w.textAlign(c);
    let f, p, g, S, x, E, k;
    for (t.textAlign = c, t.textBaseline = "middle", t.font = y.string, e.x = Ys(this, u, s), t.fillStyle = s.bodyColor, _e(this.beforeBody, o), v = l && u !== "right" ? c === "center" ? h / 2 + m : h + 2 + m : 0, S = 0, E = r.length; S < E; ++S) {
      for (f = r[S], p = this.labelTextColors[S], t.fillStyle = p, _e(f.before, o), g = f.lines, l && g.length && (this._drawColorBox(t, e, S, w, s), b = Math.max(y.lineHeight, d)), x = 0, k = g.length; x < k; ++x)
        o(g[x]), b = y.lineHeight;
      _e(f.after, o);
    }
    v = 0, b = y.lineHeight, _e(this.afterBody, o), e.y -= a;
  }
  drawFooter(e, t, s) {
    const r = this.footer, a = r.length;
    let c, l;
    if (a) {
      const d = yn(s.rtl, this.x, this.width);
      for (e.x = Ys(this, s.footerAlign, s), e.y += s.footerMarginTop, t.textAlign = d.textAlign(s.footerAlign), t.textBaseline = "middle", c = Ct(s.footerFont), t.fillStyle = s.footerColor, t.font = c.string, l = 0; l < a; ++l)
        t.fillText(r[l], d.x(e.x), e.y + c.lineHeight / 2), e.y += c.lineHeight + s.footerSpacing;
    }
  }
  drawBackground(e, t, s, r) {
    const { xAlign: a, yAlign: c } = this, { x: l, y: d } = e, { width: h, height: m } = s, { topLeft: y, topRight: b, bottomLeft: v, bottomRight: w } = gn(r.cornerRadius);
    t.fillStyle = r.backgroundColor, t.strokeStyle = r.borderColor, t.lineWidth = r.borderWidth, t.beginPath(), t.moveTo(l + y, d), c === "top" && this.drawCaret(e, t, s, r), t.lineTo(l + h - b, d), t.quadraticCurveTo(l + h, d, l + h, d + b), c === "center" && a === "right" && this.drawCaret(e, t, s, r), t.lineTo(l + h, d + m - w), t.quadraticCurveTo(l + h, d + m, l + h - w, d + m), c === "bottom" && this.drawCaret(e, t, s, r), t.lineTo(l + v, d + m), t.quadraticCurveTo(l, d + m, l, d + m - v), c === "center" && a === "left" && this.drawCaret(e, t, s, r), t.lineTo(l, d + y), t.quadraticCurveTo(l, d, l + y, d), t.closePath(), t.fill(), r.borderWidth > 0 && t.stroke();
  }
  _updateAnimationTarget(e) {
    const t = this.chart, s = this.$animations, r = s && s.x, a = s && s.y;
    if (r || a) {
      const c = Yn[e.position].call(this, this._active, this._eventPosition);
      if (!c)
        return;
      const l = this._size = Dc(this, e), d = Object.assign({}, c, this._size), h = Nc(t, e, d), m = Fc(e, d, h, t);
      (r._to !== m.x || a._to !== m.y) && (this.xAlign = h.xAlign, this.yAlign = h.yAlign, this.width = l.width, this.height = l.height, this.caretX = c.x, this.caretY = c.y, this._resolveAnimations().update(this, m));
    }
  }
  _willRender() {
    return !!this.opacity;
  }
  draw(e) {
    const t = this.options.setContext(this.getContext());
    let s = this.opacity;
    if (!s)
      return;
    this._updateAnimationTarget(t);
    const r = {
      width: this.width,
      height: this.height
    }, a = {
      x: this.x,
      y: this.y
    };
    s = Math.abs(s) < 1e-3 ? 0 : s;
    const c = zt(t.padding), l = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
    t.enabled && l && (e.save(), e.globalAlpha = s, this.drawBackground(a, e, r, t), bd(e, t.textDirection), a.y += c.top, this.drawTitle(a, e, t), this.drawBody(a, e, t), this.drawFooter(a, e, t), xd(e, t.textDirection), e.restore());
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(e, t) {
    const s = this._active, r = e.map(({ datasetIndex: l, index: d }) => {
      const h = this.chart.getDatasetMeta(l);
      if (!h)
        throw new Error("Cannot find a dataset at index " + l);
      return {
        datasetIndex: l,
        element: h.data[d],
        index: d
      };
    }), a = !xr(s, r), c = this._positionChanged(r, t);
    (a || c) && (this._active = r, this._eventPosition = t, this._ignoreReplayEvents = !0, this.update(!0));
  }
  handleEvent(e, t, s = !0) {
    if (t && this._ignoreReplayEvents)
      return !1;
    this._ignoreReplayEvents = !1;
    const r = this.options, a = this._active || [], c = this._getActiveElements(e, a, t, s), l = this._positionChanged(c, e), d = t || !xr(c, a) || l;
    return d && (this._active = c, (r.enabled || r.external) && (this._eventPosition = {
      x: e.x,
      y: e.y
    }, this.update(!0, t))), d;
  }
  _getActiveElements(e, t, s, r) {
    const a = this.options;
    if (e.type === "mouseout")
      return [];
    if (!r)
      return t.filter((l) => this.chart.data.datasets[l.datasetIndex] && this.chart.getDatasetMeta(l.datasetIndex).controller.getParsed(l.index) !== void 0);
    const c = this.chart.getElementsAtEventForMode(e, a.mode, a, s);
    return a.reverse && c.reverse(), c;
  }
  _positionChanged(e, t) {
    const { caretX: s, caretY: r, options: a } = this, c = Yn[a.position].call(this, e, t);
    return c !== !1 && (s !== c.x || r !== c.y);
  }
}
oe(Qo, "positioners", Yn);
var qd = {
  id: "tooltip",
  _element: Qo,
  positioners: Yn,
  afterInit(n, e, t) {
    t && (n.tooltip = new Qo({
      chart: n,
      options: t
    }));
  },
  beforeUpdate(n, e, t) {
    n.tooltip && n.tooltip.initialize(t);
  },
  reset(n, e, t) {
    n.tooltip && n.tooltip.initialize(t);
  },
  afterDraw(n) {
    const e = n.tooltip;
    if (e && e._willRender()) {
      const t = {
        tooltip: e
      };
      if (n.notifyPlugins("beforeTooltipDraw", {
        ...t,
        cancelable: !0
      }) === !1)
        return;
      e.draw(n.ctx), n.notifyPlugins("afterTooltipDraw", t);
    }
  },
  afterEvent(n, e) {
    if (n.tooltip) {
      const t = e.replay;
      n.tooltip.handleEvent(e.event, t, e.inChartArea) && (e.changed = !0);
    }
  },
  defaults: {
    enabled: !0,
    external: null,
    position: "average",
    backgroundColor: "rgba(0,0,0,0.8)",
    titleColor: "#fff",
    titleFont: {
      weight: "bold"
    },
    titleSpacing: 2,
    titleMarginBottom: 6,
    titleAlign: "left",
    bodyColor: "#fff",
    bodySpacing: 2,
    bodyFont: {},
    bodyAlign: "left",
    footerColor: "#fff",
    footerSpacing: 2,
    footerMarginTop: 6,
    footerFont: {
      weight: "bold"
    },
    footerAlign: "left",
    padding: 6,
    caretPadding: 2,
    caretSize: 5,
    cornerRadius: 6,
    boxHeight: (n, e) => e.bodyFont.size,
    boxWidth: (n, e) => e.bodyFont.size,
    multiKeyBackground: "#fff",
    displayColors: !0,
    boxPadding: 0,
    borderColor: "rgba(0,0,0,0)",
    borderWidth: 0,
    animation: {
      duration: 400,
      easing: "easeOutQuart"
    },
    animations: {
      numbers: {
        type: "number",
        properties: [
          "x",
          "y",
          "width",
          "height",
          "caretX",
          "caretY"
        ]
      },
      opacity: {
        easing: "linear",
        duration: 200
      }
    },
    callbacks: Bd
  },
  defaultRoutes: {
    bodyFont: "font",
    footerFont: "font",
    titleFont: "font"
  },
  descriptors: {
    _scriptable: (n) => n !== "filter" && n !== "itemSort" && n !== "external",
    _indexable: !1,
    callbacks: {
      _scriptable: !1,
      _indexable: !1
    },
    animation: {
      _fallback: !1
    },
    animations: {
      _fallback: "animation"
    }
  },
  additionalOptionScopes: [
    "interaction"
  ]
};
const nj = (n, e, t, s) => (typeof e == "string" ? (t = n.push(e) - 1, s.unshift({
  index: t,
  label: e
})) : isNaN(e) && (t = null), t);
function sj(n, e, t, s) {
  const r = n.indexOf(e);
  if (r === -1)
    return nj(n, e, t, s);
  const a = n.lastIndexOf(e);
  return r !== a ? t : r;
}
const rj = (n, e) => n === null ? null : Ut(Math.round(n), 0, e);
function Hc(n) {
  const e = this.getLabels();
  return n >= 0 && n < e.length ? e[n] : n;
}
class Xo extends on {
  constructor(e) {
    super(e), this._startValue = void 0, this._valueRange = 0, this._addedLabels = [];
  }
  init(e) {
    const t = this._addedLabels;
    if (t.length) {
      const s = this.getLabels();
      for (const { index: r, label: a } of t)
        s[r] === a && s.splice(r, 1);
      this._addedLabels = [];
    }
    super.init(e);
  }
  parse(e, t) {
    if (rt(e))
      return null;
    const s = this.getLabels();
    return t = isFinite(t) && s[t] === e ? t : sj(s, e, Pe(t, e), this._addedLabels), rj(t, s.length - 1);
  }
  determineDataLimits() {
    const { minDefined: e, maxDefined: t } = this.getUserBounds();
    let { min: s, max: r } = this.getMinMax(!0);
    this.options.bounds === "ticks" && (e || (s = 0), t || (r = this.getLabels().length - 1)), this.min = s, this.max = r;
  }
  buildTicks() {
    const e = this.min, t = this.max, s = this.options.offset, r = [];
    let a = this.getLabels();
    a = e === 0 && t === a.length - 1 ? a : a.slice(e, t + 1), this._valueRange = Math.max(a.length - (s ? 0 : 1), 1), this._startValue = this.min - (s ? 0.5 : 0);
    for (let c = e; c <= t; c++)
      r.push({
        value: c
      });
    return r;
  }
  getLabelForValue(e) {
    return Hc.call(this, e);
  }
  configure() {
    super.configure(), this.isHorizontal() || (this._reversePixels = !this._reversePixels);
  }
  getPixelForValue(e) {
    return typeof e != "number" && (e = this.parse(e)), e === null ? NaN : this.getPixelForDecimal((e - this._startValue) / this._valueRange);
  }
  getPixelForTick(e) {
    const t = this.ticks;
    return e < 0 || e > t.length - 1 ? null : this.getPixelForValue(t[e].value);
  }
  getValueForPixel(e) {
    return Math.round(this._startValue + this.getDecimalForPixel(e) * this._valueRange);
  }
  getBasePixel() {
    return this.bottom;
  }
}
oe(Xo, "id", "category"), oe(Xo, "defaults", {
  ticks: {
    callback: Hc
  }
});
function oj(n, e) {
  const t = [], { bounds: r, step: a, min: c, max: l, precision: d, count: h, maxTicks: m, maxDigits: y, includeBounds: b } = n, v = a || 1, w = m - 1, { min: o, max: u } = e, f = !rt(c), p = !rt(l), g = !rt(h), S = (u - o) / (y + 1);
  let x = Vl((u - o) / w / v) * v, E, k, R, O;
  if (x < 1e-14 && !f && !p)
    return [
      {
        value: o
      },
      {
        value: u
      }
    ];
  O = Math.ceil(u / x) - Math.floor(o / x), O > w && (x = Vl(O * x / w / v) * v), rt(d) || (E = Math.pow(10, d), x = Math.ceil(x * E) / E), r === "ticks" ? (k = Math.floor(o / x) * x, R = Math.ceil(u / x) * x) : (k = o, R = u), f && p && a && Tz((l - c) / a, x / 1e3) ? (O = Math.round(Math.min((l - c) / x, m)), x = (l - c) / O, k = c, R = l) : g ? (k = f ? c : k, R = p ? l : R, O = h - 1, x = (R - k) / O) : (O = (R - k) / x, _n(O, Math.round(O), x / 1e3) ? O = Math.round(O) : O = Math.ceil(O));
  const T = Math.max(Gl(x), Gl(k));
  E = Math.pow(10, rt(d) ? T : d), k = Math.round(k * E) / E, R = Math.round(R * E) / E;
  let D = 0;
  for (f && (b && k !== c ? (t.push({
    value: c
  }), k < c && D++, _n(Math.round((k + D * x) * E) / E, c, Vc(c, S, n)) && D++) : k < c && D++); D < O; ++D) {
    const P = Math.round((k + D * x) * E) / E;
    if (p && P > l)
      break;
    t.push({
      value: P
    });
  }
  return p && b && R !== l ? t.length && _n(t[t.length - 1].value, l, Vc(l, S, n)) ? t[t.length - 1].value = l : t.push({
    value: l
  }) : (!p || R === l) && t.push({
    value: R
  }), t;
}
function Vc(n, e, { horizontal: t, minRotation: s }) {
  const r = li(s), a = (t ? Math.sin(r) : Math.cos(r)) || 1e-3, c = 0.75 * e * ("" + n).length;
  return Math.min(e / a, c);
}
class Ir extends on {
  constructor(e) {
    super(e), this.start = void 0, this.end = void 0, this._startValue = void 0, this._endValue = void 0, this._valueRange = 0;
  }
  parse(e, t) {
    return rt(e) || (typeof e == "number" || e instanceof Number) && !isFinite(+e) ? null : +e;
  }
  handleTickRangeOptions() {
    const { beginAtZero: e } = this.options, { minDefined: t, maxDefined: s } = this.getUserBounds();
    let { min: r, max: a } = this;
    const c = (d) => r = t ? r : d, l = (d) => a = s ? a : d;
    if (e) {
      const d = wn(r), h = wn(a);
      d < 0 && h < 0 ? l(0) : d > 0 && h > 0 && c(0);
    }
    if (r === a) {
      let d = a === 0 ? 1 : Math.abs(a * 0.05);
      l(a + d), e || c(r - d);
    }
    this.min = r, this.max = a;
  }
  getTickLimit() {
    const e = this.options.ticks;
    let { maxTicksLimit: t, stepSize: s } = e, r;
    return s ? (r = Math.ceil(this.max / s) - Math.floor(this.min / s) + 1, r > 1e3 && (console.warn(`scales.${this.id}.ticks.stepSize: ${s} would result generating up to ${r} ticks. Limiting to 1000.`), r = 1e3)) : (r = this.computeTickLimit(), t = t || 11), t && (r = Math.min(t, r)), r;
  }
  computeTickLimit() {
    return Number.POSITIVE_INFINITY;
  }
  buildTicks() {
    const e = this.options, t = e.ticks;
    let s = this.getTickLimit();
    s = Math.max(2, s);
    const r = {
      maxTicks: s,
      bounds: e.bounds,
      min: e.min,
      max: e.max,
      precision: t.precision,
      step: t.stepSize,
      count: t.count,
      maxDigits: this._maxDigits(),
      horizontal: this.isHorizontal(),
      minRotation: t.minRotation || 0,
      includeBounds: t.includeBounds !== !1
    }, a = this._range || this, c = oj(r, a);
    return e.bounds === "ticks" && od(c, this, "value"), e.reverse ? (c.reverse(), this.start = this.max, this.end = this.min) : (this.start = this.min, this.end = this.max), c;
  }
  configure() {
    const e = this.ticks;
    let t = this.min, s = this.max;
    if (super.configure(), this.options.offset && e.length) {
      const r = (s - t) / Math.max(e.length - 1, 1) / 2;
      t -= r, s += r;
    }
    this._startValue = t, this._endValue = s, this._valueRange = s - t;
  }
  getLabelForValue(e) {
    return Lr(e, this.chart.options.locale, this.options.ticks.format);
  }
}
class _o extends Ir {
  determineDataLimits() {
    const { min: e, max: t } = this.getMinMax(!0);
    this.min = ft(e) ? e : 0, this.max = ft(t) ? t : 1, this.handleTickRangeOptions();
  }
  computeTickLimit() {
    const e = this.isHorizontal(), t = e ? this.width : this.height, s = li(this.options.ticks.minRotation), r = (e ? Math.sin(s) : Math.cos(s)) || 1e-3, a = this._resolveTickFontOptions(0);
    return Math.ceil(t / Math.min(40, a.lineHeight / r));
  }
  getPixelForValue(e) {
    return e === null ? NaN : this.getPixelForDecimal((e - this._startValue) / this._valueRange);
  }
  getValueForPixel(e) {
    return this._startValue + this.getDecimalForPixel(e) * this._valueRange;
  }
}
oe(_o, "id", "linear"), oe(_o, "defaults", {
  ticks: {
    callback: Dr.formatters.numeric
  }
});
const hs = (n) => Math.floor(Ui(n)), Gi = (n, e) => Math.pow(10, hs(n) + e);
function Gc(n) {
  return n / Math.pow(10, hs(n)) === 1;
}
function Wc(n, e, t) {
  const s = Math.pow(10, t), r = Math.floor(n / s);
  return Math.ceil(e / s) - r;
}
function aj(n, e) {
  const t = e - n;
  let s = hs(t);
  for (; Wc(n, e, s) > 10; )
    s++;
  for (; Wc(n, e, s) < 10; )
    s--;
  return Math.min(s, hs(n));
}
function lj(n, { min: e, max: t }) {
  e = Ht(n.min, e);
  const s = [], r = hs(e);
  let a = aj(e, t), c = a < 0 ? Math.pow(10, Math.abs(a)) : 1;
  const l = Math.pow(10, a), d = r > a ? Math.pow(10, r) : 0, h = Math.round((e - d) * c) / c, m = Math.floor((e - d) / l / 10) * l * 10;
  let y = Math.floor((h - m) / Math.pow(10, a)), b = Ht(n.min, Math.round((d + m + y * Math.pow(10, a)) * c) / c);
  for (; b < t; )
    s.push({
      value: b,
      major: Gc(b),
      significand: y
    }), y >= 10 ? y = y < 15 ? 15 : 20 : y++, y >= 20 && (a++, y = 2, c = a >= 0 ? 1 : c), b = Math.round((d + m + y * Math.pow(10, a)) * c) / c;
  const v = Ht(n.max, b);
  return s.push({
    value: v,
    major: Gc(v),
    significand: y
  }), s;
}
class Kc extends on {
  constructor(e) {
    super(e), this.start = void 0, this.end = void 0, this._startValue = void 0, this._valueRange = 0;
  }
  parse(e, t) {
    const s = Ir.prototype.parse.apply(this, [
      e,
      t
    ]);
    if (s === 0) {
      this._zero = !0;
      return;
    }
    return ft(s) && s > 0 ? s : null;
  }
  determineDataLimits() {
    const { min: e, max: t } = this.getMinMax(!0);
    this.min = ft(e) ? Math.max(0, e) : null, this.max = ft(t) ? Math.max(0, t) : null, this.options.beginAtZero && (this._zero = !0), this._zero && this.min !== this._suggestedMin && !ft(this._userMin) && (this.min = e === Gi(this.min, 0) ? Gi(this.min, -1) : Gi(this.min, 0)), this.handleTickRangeOptions();
  }
  handleTickRangeOptions() {
    const { minDefined: e, maxDefined: t } = this.getUserBounds();
    let s = this.min, r = this.max;
    const a = (l) => s = e ? s : l, c = (l) => r = t ? r : l;
    s === r && (s <= 0 ? (a(1), c(10)) : (a(Gi(s, -1)), c(Gi(r, 1)))), s <= 0 && a(Gi(r, -1)), r <= 0 && c(Gi(s, 1)), this.min = s, this.max = r;
  }
  buildTicks() {
    const e = this.options, t = {
      min: this._userMin,
      max: this._userMax
    }, s = lj(t, this);
    return e.bounds === "ticks" && od(s, this, "value"), e.reverse ? (s.reverse(), this.start = this.max, this.end = this.min) : (this.start = this.min, this.end = this.max), s;
  }
  getLabelForValue(e) {
    return e === void 0 ? "0" : Lr(e, this.chart.options.locale, this.options.ticks.format);
  }
  configure() {
    const e = this.min;
    super.configure(), this._startValue = Ui(e), this._valueRange = Ui(this.max) - Ui(e);
  }
  getPixelForValue(e) {
    return (e === void 0 || e === 0) && (e = this.min), e === null || isNaN(e) ? NaN : this.getPixelForDecimal(e === this.min ? 0 : (Ui(e) - this._startValue) / this._valueRange);
  }
  getValueForPixel(e) {
    const t = this.getDecimalForPixel(e);
    return Math.pow(10, this._startValue + t * this._valueRange);
  }
}
oe(Kc, "id", "logarithmic"), oe(Kc, "defaults", {
  ticks: {
    callback: Dr.formatters.logarithmic,
    major: {
      enabled: !0
    }
  }
});
function $o(n) {
  const e = n.ticks;
  if (e.display && n.display) {
    const t = zt(e.backdropPadding);
    return Pe(e.font && e.font.size, ht.font.size) + t.height;
  }
  return 0;
}
function cj(n, e, t) {
  return t = ut(t) ? t : [
    t
  ], {
    w: Jz(n, e.string, t),
    h: t.length * e.lineHeight
  };
}
function Yc(n, e, t, s, r) {
  return n === s || n === r ? {
    start: e - t / 2,
    end: e + t / 2
  } : n < s || n > r ? {
    start: e - t,
    end: e
  } : {
    start: e,
    end: e + t
  };
}
function uj(n) {
  const e = {
    l: n.left + n._padding.left,
    r: n.right - n._padding.right,
    t: n.top + n._padding.top,
    b: n.bottom - n._padding.bottom
  }, t = Object.assign({}, e), s = [], r = [], a = n._pointLabels.length, c = n.options.pointLabels, l = c.centerPointLabels ? pt / a : 0;
  for (let d = 0; d < a; d++) {
    const h = c.setContext(n.getPointLabelContext(d));
    r[d] = h.padding;
    const m = n.getPointPosition(d, n.drawingArea + r[d], l), y = Ct(h.font), b = cj(n.ctx, y, n._pointLabels[d]);
    s[d] = b;
    const v = Gt(n.getIndexAngle(d) + l), w = Math.round(ba(v)), o = Yc(w, m.x, b.w, 0, 180), u = Yc(w, m.y, b.h, 90, 270);
    dj(t, e, v, o, u);
  }
  n.setCenterPoint(e.l - t.l, t.r - e.r, e.t - t.t, t.b - e.b), n._pointLabelItems = pj(n, s, r);
}
function dj(n, e, t, s, r) {
  const a = Math.abs(Math.sin(t)), c = Math.abs(Math.cos(t));
  let l = 0, d = 0;
  s.start < e.l ? (l = (e.l - s.start) / a, n.l = Math.min(n.l, e.l - l)) : s.end > e.r && (l = (s.end - e.r) / a, n.r = Math.max(n.r, e.r + l)), r.start < e.t ? (d = (e.t - r.start) / c, n.t = Math.min(n.t, e.t - d)) : r.end > e.b && (d = (r.end - e.b) / c, n.b = Math.max(n.b, e.b + d));
}
function fj(n, e, t) {
  const s = n.drawingArea, { extra: r, additionalAngle: a, padding: c, size: l } = t, d = n.getPointPosition(e, s + r + c, a), h = Math.round(ba(Gt(d.angle + bt))), m = yj(d.y, l.h, h), y = mj(h), b = gj(d.x, l.w, y);
  return {
    visible: !0,
    x: d.x,
    y: m,
    textAlign: y,
    left: b,
    top: m,
    right: b + l.w,
    bottom: m + l.h
  };
}
function hj(n, e) {
  if (!e)
    return !0;
  const { left: t, top: s, right: r, bottom: a } = n;
  return !(xi({
    x: t,
    y: s
  }, e) || xi({
    x: t,
    y: a
  }, e) || xi({
    x: r,
    y: s
  }, e) || xi({
    x: r,
    y: a
  }, e));
}
function pj(n, e, t) {
  const s = [], r = n._pointLabels.length, a = n.options, { centerPointLabels: c, display: l } = a.pointLabels, d = {
    extra: $o(a) / 2,
    additionalAngle: c ? pt / r : 0
  };
  let h;
  for (let m = 0; m < r; m++) {
    d.padding = t[m], d.size = e[m];
    const y = fj(n, m, d);
    s.push(y), l === "auto" && (y.visible = hj(y, h), y.visible && (h = y));
  }
  return s;
}
function mj(n) {
  return n === 0 || n === 180 ? "center" : n < 180 ? "left" : "right";
}
function gj(n, e, t) {
  return t === "right" ? n -= e : t === "center" && (n -= e / 2), n;
}
function yj(n, e, t) {
  return t === 90 || t === 270 ? n -= e / 2 : (t > 270 || t < 90) && (n -= e), n;
}
function vj(n, e, t) {
  const { left: s, top: r, right: a, bottom: c } = t, { backdropColor: l } = e;
  if (!rt(l)) {
    const d = gn(e.borderRadius), h = zt(e.backdropPadding);
    n.fillStyle = l;
    const m = s - h.left, y = r - h.top, b = a - s + h.width, v = c - r + h.height;
    Object.values(d).some((w) => w !== 0) ? (n.beginPath(), Er(n, {
      x: m,
      y,
      w: b,
      h: v,
      radius: d
    }), n.fill()) : n.fillRect(m, y, b, v);
  }
}
function bj(n, e) {
  const { ctx: t, options: { pointLabels: s } } = n;
  for (let r = e - 1; r >= 0; r--) {
    const a = n._pointLabelItems[r];
    if (!a.visible)
      continue;
    const c = s.setContext(n.getPointLabelContext(r));
    vj(t, c, a);
    const l = Ct(c.font), { x: d, y: h, textAlign: m } = a;
    An(t, n._pointLabels[r], d, h + l.lineHeight / 2, l, {
      color: c.color,
      textAlign: m,
      textBaseline: "middle"
    });
  }
}
function Hd(n, e, t, s) {
  const { ctx: r } = n;
  if (t)
    r.arc(n.xCenter, n.yCenter, e, 0, ot);
  else {
    let a = n.getPointPosition(0, e);
    r.moveTo(a.x, a.y);
    for (let c = 1; c < s; c++)
      a = n.getPointPosition(c, e), r.lineTo(a.x, a.y);
  }
}
function xj(n, e, t, s, r) {
  const a = n.ctx, c = e.circular, { color: l, lineWidth: d } = e;
  !c && !s || !l || !d || t < 0 || (a.save(), a.strokeStyle = l, a.lineWidth = d, a.setLineDash(r.dash || []), a.lineDashOffset = r.dashOffset, a.beginPath(), Hd(n, t, c, s), a.closePath(), a.stroke(), a.restore());
}
function Sj(n, e, t) {
  return Ni(n, {
    label: t,
    index: e,
    type: "pointLabel"
  });
}
class Js extends Ir {
  constructor(e) {
    super(e), this.xCenter = void 0, this.yCenter = void 0, this.drawingArea = void 0, this._pointLabels = [], this._pointLabelItems = [];
  }
  setDimensions() {
    const e = this._padding = zt($o(this.options) / 2), t = this.width = this.maxWidth - e.width, s = this.height = this.maxHeight - e.height;
    this.xCenter = Math.floor(this.left + t / 2 + e.left), this.yCenter = Math.floor(this.top + s / 2 + e.top), this.drawingArea = Math.floor(Math.min(t, s) / 2);
  }
  determineDataLimits() {
    const { min: e, max: t } = this.getMinMax(!1);
    this.min = ft(e) && !isNaN(e) ? e : 0, this.max = ft(t) && !isNaN(t) ? t : 0, this.handleTickRangeOptions();
  }
  computeTickLimit() {
    return Math.ceil(this.drawingArea / $o(this.options));
  }
  generateTickLabels(e) {
    Ir.prototype.generateTickLabels.call(this, e), this._pointLabels = this.getLabels().map((t, s) => {
      const r = st(this.options.pointLabels.callback, [
        t,
        s
      ], this);
      return r || r === 0 ? r : "";
    }).filter((t, s) => this.chart.getDataVisibility(s));
  }
  fit() {
    const e = this.options;
    e.display && e.pointLabels.display ? uj(this) : this.setCenterPoint(0, 0, 0, 0);
  }
  setCenterPoint(e, t, s, r) {
    this.xCenter += Math.floor((e - t) / 2), this.yCenter += Math.floor((s - r) / 2), this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(e, t, s, r));
  }
  getIndexAngle(e) {
    const t = ot / (this._pointLabels.length || 1), s = this.options.startAngle || 0;
    return Gt(e * t + li(s));
  }
  getDistanceFromCenterForValue(e) {
    if (rt(e))
      return NaN;
    const t = this.drawingArea / (this.max - this.min);
    return this.options.reverse ? (this.max - e) * t : (e - this.min) * t;
  }
  getValueForDistanceFromCenter(e) {
    if (rt(e))
      return NaN;
    const t = e / (this.drawingArea / (this.max - this.min));
    return this.options.reverse ? this.max - t : this.min + t;
  }
  getPointLabelContext(e) {
    const t = this._pointLabels || [];
    if (e >= 0 && e < t.length) {
      const s = t[e];
      return Sj(this.getContext(), e, s);
    }
  }
  getPointPosition(e, t, s = 0) {
    const r = this.getIndexAngle(e) - bt + s;
    return {
      x: Math.cos(r) * t + this.xCenter,
      y: Math.sin(r) * t + this.yCenter,
      angle: r
    };
  }
  getPointPositionForValue(e, t) {
    return this.getPointPosition(e, this.getDistanceFromCenterForValue(t));
  }
  getBasePosition(e) {
    return this.getPointPositionForValue(e || 0, this.getBaseValue());
  }
  getPointLabelPosition(e) {
    const { left: t, top: s, right: r, bottom: a } = this._pointLabelItems[e];
    return {
      left: t,
      top: s,
      right: r,
      bottom: a
    };
  }
  drawBackground() {
    const { backgroundColor: e, grid: { circular: t } } = this.options;
    if (e) {
      const s = this.ctx;
      s.save(), s.beginPath(), Hd(this, this.getDistanceFromCenterForValue(this._endValue), t, this._pointLabels.length), s.closePath(), s.fillStyle = e, s.fill(), s.restore();
    }
  }
  drawGrid() {
    const e = this.ctx, t = this.options, { angleLines: s, grid: r, border: a } = t, c = this._pointLabels.length;
    let l, d, h;
    if (t.pointLabels.display && bj(this, c), r.display && this.ticks.forEach((m, y) => {
      if (y !== 0 || y === 0 && this.min < 0) {
        d = this.getDistanceFromCenterForValue(m.value);
        const b = this.getContext(y), v = r.setContext(b), w = a.setContext(b);
        xj(this, v, d, c, w);
      }
    }), s.display) {
      for (e.save(), l = c - 1; l >= 0; l--) {
        const m = s.setContext(this.getPointLabelContext(l)), { color: y, lineWidth: b } = m;
        !b || !y || (e.lineWidth = b, e.strokeStyle = y, e.setLineDash(m.borderDash), e.lineDashOffset = m.borderDashOffset, d = this.getDistanceFromCenterForValue(t.reverse ? this.min : this.max), h = this.getPointPosition(l, d), e.beginPath(), e.moveTo(this.xCenter, this.yCenter), e.lineTo(h.x, h.y), e.stroke());
      }
      e.restore();
    }
  }
  drawBorder() {
  }
  drawLabels() {
    const e = this.ctx, t = this.options, s = t.ticks;
    if (!s.display)
      return;
    const r = this.getIndexAngle(0);
    let a, c;
    e.save(), e.translate(this.xCenter, this.yCenter), e.rotate(r), e.textAlign = "center", e.textBaseline = "middle", this.ticks.forEach((l, d) => {
      if (d === 0 && this.min >= 0 && !t.reverse)
        return;
      const h = s.setContext(this.getContext(d)), m = Ct(h.font);
      if (a = this.getDistanceFromCenterForValue(this.ticks[d].value), h.showLabelBackdrop) {
        e.font = m.string, c = e.measureText(l.label).width, e.fillStyle = h.backdropColor;
        const y = zt(h.backdropPadding);
        e.fillRect(-c / 2 - y.left, -a - m.size / 2 - y.top, c + y.width, m.size + y.height);
      }
      An(e, l.label, 0, -a, m, {
        color: h.color,
        strokeColor: h.textStrokeColor,
        strokeWidth: h.textStrokeWidth
      });
    }), e.restore();
  }
  drawTitle() {
  }
}
oe(Js, "id", "radialLinear"), oe(Js, "defaults", {
  display: !0,
  animate: !0,
  position: "chartArea",
  angleLines: {
    display: !0,
    lineWidth: 1,
    borderDash: [],
    borderDashOffset: 0
  },
  grid: {
    circular: !1
  },
  startAngle: 0,
  ticks: {
    showLabelBackdrop: !0,
    callback: Dr.formatters.numeric
  },
  pointLabels: {
    backdropColor: void 0,
    backdropPadding: 2,
    display: !0,
    font: {
      size: 10
    },
    callback(e) {
      return e;
    },
    padding: 5,
    centerPointLabels: !1
  }
}), oe(Js, "defaultRoutes", {
  "angleLines.color": "borderColor",
  "pointLabels.color": "color",
  "ticks.color": "color"
}), oe(Js, "descriptors", {
  angleLines: {
    _fallback: "grid"
  }
});
const qr = {
  millisecond: {
    common: !0,
    size: 1,
    steps: 1e3
  },
  second: {
    common: !0,
    size: 1e3,
    steps: 60
  },
  minute: {
    common: !0,
    size: 6e4,
    steps: 60
  },
  hour: {
    common: !0,
    size: 36e5,
    steps: 24
  },
  day: {
    common: !0,
    size: 864e5,
    steps: 30
  },
  week: {
    common: !1,
    size: 6048e5,
    steps: 4
  },
  month: {
    common: !0,
    size: 2628e6,
    steps: 12
  },
  quarter: {
    common: !1,
    size: 7884e6,
    steps: 4
  },
  year: {
    common: !0,
    size: 3154e7
  }
}, Pt = /* @__PURE__ */ Object.keys(qr);
function Jc(n, e) {
  return n - e;
}
function Zc(n, e) {
  if (rt(e))
    return null;
  const t = n._adapter, { parser: s, round: r, isoWeekday: a } = n._parseOpts;
  let c = e;
  return typeof s == "function" && (c = s(c)), ft(c) || (c = typeof s == "string" ? t.parse(c, s) : t.parse(c)), c === null ? null : (r && (c = r === "week" && (us(a) || a === !0) ? t.startOf(c, "isoWeek", a) : t.startOf(c, r)), +c);
}
function Qc(n, e, t, s) {
  const r = Pt.length;
  for (let a = Pt.indexOf(n); a < r - 1; ++a) {
    const c = qr[Pt[a]], l = c.steps ? c.steps : Number.MAX_SAFE_INTEGER;
    if (c.common && Math.ceil((t - e) / (l * c.size)) <= s)
      return Pt[a];
  }
  return Pt[r - 1];
}
function wj(n, e, t, s, r) {
  for (let a = Pt.length - 1; a >= Pt.indexOf(t); a--) {
    const c = Pt[a];
    if (qr[c].common && n._adapter.diff(r, s, c) >= e - 1)
      return c;
  }
  return Pt[t ? Pt.indexOf(t) : 0];
}
function Aj(n) {
  for (let e = Pt.indexOf(n) + 1, t = Pt.length; e < t; ++e)
    if (qr[Pt[e]].common)
      return Pt[e];
}
function Xc(n, e, t) {
  if (!t)
    n[e] = !0;
  else if (t.length) {
    const { lo: s, hi: r } = xa(t, e), a = t[s] >= e ? t[s] : t[r];
    n[a] = !0;
  }
}
function Cj(n, e, t, s) {
  const r = n._adapter, a = +r.startOf(e[0].value, s), c = e[e.length - 1].value;
  let l, d;
  for (l = a; l <= c; l = +r.add(l, 1, s))
    d = t[l], d >= 0 && (e[d].major = !0);
  return e;
}
function _c(n, e, t) {
  const s = [], r = {}, a = e.length;
  let c, l;
  for (c = 0; c < a; ++c)
    l = e[c], r[l] = c, s.push({
      value: l,
      major: !1
    });
  return a === 0 || !t ? s : Cj(n, s, r, t);
}
class Ur extends on {
  constructor(e) {
    super(e), this._cache = {
      data: [],
      labels: [],
      all: []
    }, this._unit = "day", this._majorUnit = void 0, this._offsets = {}, this._normalized = !1, this._parseOpts = void 0;
  }
  init(e, t = {}) {
    const s = e.time || (e.time = {}), r = this._adapter = new eP._date(e.adapters.date);
    r.init(t), Xn(s.displayFormats, r.formats()), this._parseOpts = {
      parser: s.parser,
      round: s.round,
      isoWeekday: s.isoWeekday
    }, super.init(e), this._normalized = t.normalized;
  }
  parse(e, t) {
    return e === void 0 ? null : Zc(this, e);
  }
  beforeLayout() {
    super.beforeLayout(), this._cache = {
      data: [],
      labels: [],
      all: []
    };
  }
  determineDataLimits() {
    const e = this.options, t = this._adapter, s = e.time.unit || "day";
    let { min: r, max: a, minDefined: c, maxDefined: l } = this.getUserBounds();
    function d(h) {
      !c && !isNaN(h.min) && (r = Math.min(r, h.min)), !l && !isNaN(h.max) && (a = Math.max(a, h.max));
    }
    (!c || !l) && (d(this._getLabelBounds()), (e.bounds !== "ticks" || e.ticks.source !== "labels") && d(this.getMinMax(!1))), r = ft(r) && !isNaN(r) ? r : +t.startOf(Date.now(), s), a = ft(a) && !isNaN(a) ? a : +t.endOf(Date.now(), s) + 1, this.min = Math.min(r, a - 1), this.max = Math.max(r + 1, a);
  }
  _getLabelBounds() {
    const e = this.getLabelTimestamps();
    let t = Number.POSITIVE_INFINITY, s = Number.NEGATIVE_INFINITY;
    return e.length && (t = e[0], s = e[e.length - 1]), {
      min: t,
      max: s
    };
  }
  buildTicks() {
    const e = this.options, t = e.time, s = e.ticks, r = s.source === "labels" ? this.getLabelTimestamps() : this._generate();
    e.bounds === "ticks" && r.length && (this.min = this._userMin || r[0], this.max = this._userMax || r[r.length - 1]);
    const a = this.min, c = this.max, l = Rz(r, a, c);
    return this._unit = t.unit || (s.autoSkip ? Qc(t.minUnit, this.min, this.max, this._getLabelCapacity(a)) : wj(this, l.length, t.minUnit, this.min, this.max)), this._majorUnit = !s.major.enabled || this._unit === "year" ? void 0 : Aj(this._unit), this.initOffsets(r), e.reverse && l.reverse(), _c(this, l, this._majorUnit);
  }
  afterAutoSkip() {
    this.options.offsetAfterAutoskip && this.initOffsets(this.ticks.map((e) => +e.value));
  }
  initOffsets(e = []) {
    let t = 0, s = 0, r, a;
    this.options.offset && e.length && (r = this.getDecimalForValue(e[0]), e.length === 1 ? t = 1 - r : t = (this.getDecimalForValue(e[1]) - r) / 2, a = this.getDecimalForValue(e[e.length - 1]), e.length === 1 ? s = a : s = (a - this.getDecimalForValue(e[e.length - 2])) / 2);
    const c = e.length < 3 ? 0.5 : 0.25;
    t = Ut(t, 0, c), s = Ut(s, 0, c), this._offsets = {
      start: t,
      end: s,
      factor: 1 / (t + 1 + s)
    };
  }
  _generate() {
    const e = this._adapter, t = this.min, s = this.max, r = this.options, a = r.time, c = a.unit || Qc(a.minUnit, t, s, this._getLabelCapacity(t)), l = Pe(r.ticks.stepSize, 1), d = c === "week" ? a.isoWeekday : !1, h = us(d) || d === !0, m = {};
    let y = t, b, v;
    if (h && (y = +e.startOf(y, "isoWeek", d)), y = +e.startOf(y, h ? "day" : c), e.diff(s, t, c) > 1e5 * l)
      throw new Error(t + " and " + s + " are too far apart with stepSize of " + l + " " + c);
    const w = r.ticks.source === "data" && this.getDataTimestamps();
    for (b = y, v = 0; b < s; b = +e.add(b, l, c), v++)
      Xc(m, b, w);
    return (b === s || r.bounds === "ticks" || v === 1) && Xc(m, b, w), Object.keys(m).sort(Jc).map((o) => +o);
  }
  getLabelForValue(e) {
    const t = this._adapter, s = this.options.time;
    return s.tooltipFormat ? t.format(e, s.tooltipFormat) : t.format(e, s.displayFormats.datetime);
  }
  format(e, t) {
    const r = this.options.time.displayFormats, a = this._unit, c = t || r[a];
    return this._adapter.format(e, c);
  }
  _tickFormatFunction(e, t, s, r) {
    const a = this.options, c = a.ticks.callback;
    if (c)
      return st(c, [
        e,
        t,
        s
      ], this);
    const l = a.time.displayFormats, d = this._unit, h = this._majorUnit, m = d && l[d], y = h && l[h], b = s[t], v = h && y && b && b.major;
    return this._adapter.format(e, r || (v ? y : m));
  }
  generateTickLabels(e) {
    let t, s, r;
    for (t = 0, s = e.length; t < s; ++t)
      r = e[t], r.label = this._tickFormatFunction(r.value, t, e);
  }
  getDecimalForValue(e) {
    return e === null ? NaN : (e - this.min) / (this.max - this.min);
  }
  getPixelForValue(e) {
    const t = this._offsets, s = this.getDecimalForValue(e);
    return this.getPixelForDecimal((t.start + s) * t.factor);
  }
  getValueForPixel(e) {
    const t = this._offsets, s = this.getDecimalForPixel(e) / t.factor - t.end;
    return this.min + s * (this.max - this.min);
  }
  _getLabelSize(e) {
    const t = this.options.ticks, s = this.ctx.measureText(e).width, r = li(this.isHorizontal() ? t.maxRotation : t.minRotation), a = Math.cos(r), c = Math.sin(r), l = this._resolveTickFontOptions(0).size;
    return {
      w: s * a + l * c,
      h: s * c + l * a
    };
  }
  _getLabelCapacity(e) {
    const t = this.options.time, s = t.displayFormats, r = s[t.unit] || s.millisecond, a = this._tickFormatFunction(e, 0, _c(this, [
      e
    ], this._majorUnit), r), c = this._getLabelSize(a), l = Math.floor(this.isHorizontal() ? this.width / c.w : this.height / c.h) - 1;
    return l > 0 ? l : 1;
  }
  getDataTimestamps() {
    let e = this._cache.data || [], t, s;
    if (e.length)
      return e;
    const r = this.getMatchingVisibleMetas();
    if (this._normalized && r.length)
      return this._cache.data = r[0].controller.getAllParsedValues(this);
    for (t = 0, s = r.length; t < s; ++t)
      e = e.concat(r[t].controller.getAllParsedValues(this));
    return this._cache.data = this.normalize(e);
  }
  getLabelTimestamps() {
    const e = this._cache.labels || [];
    let t, s;
    if (e.length)
      return e;
    const r = this.getLabels();
    for (t = 0, s = r.length; t < s; ++t)
      e.push(Zc(this, r[t]));
    return this._cache.labels = this._normalized ? e : this.normalize(e);
  }
  normalize(e) {
    return Mz(e.sort(Jc));
  }
}
oe(Ur, "id", "time"), oe(Ur, "defaults", {
  bounds: "data",
  adapters: {},
  time: {
    parser: !1,
    unit: !1,
    round: !1,
    isoWeekday: !1,
    minUnit: "millisecond",
    displayFormats: {}
  },
  ticks: {
    source: "auto",
    callback: !1,
    major: {
      enabled: !1
    }
  }
});
function Zs(n, e, t) {
  let s = 0, r = n.length - 1, a, c, l, d;
  t ? (e >= n[s].pos && e <= n[r].pos && ({ lo: s, hi: r } = Ji(n, "pos", e)), { pos: a, time: l } = n[s], { pos: c, time: d } = n[r]) : (e >= n[s].time && e <= n[r].time && ({ lo: s, hi: r } = Ji(n, "time", e)), { time: a, pos: l } = n[s], { time: c, pos: d } = n[r]);
  const h = c - a;
  return h ? l + (d - l) * (e - a) / h : l;
}
class $c extends Ur {
  constructor(e) {
    super(e), this._table = [], this._minPos = void 0, this._tableRange = void 0;
  }
  initOffsets() {
    const e = this._getTimestampsForTable(), t = this._table = this.buildLookupTable(e);
    this._minPos = Zs(t, this.min), this._tableRange = Zs(t, this.max) - this._minPos, super.initOffsets(e);
  }
  buildLookupTable(e) {
    const { min: t, max: s } = this, r = [], a = [];
    let c, l, d, h, m;
    for (c = 0, l = e.length; c < l; ++c)
      h = e[c], h >= t && h <= s && r.push(h);
    if (r.length < 2)
      return [
        {
          time: t,
          pos: 0
        },
        {
          time: s,
          pos: 1
        }
      ];
    for (c = 0, l = r.length; c < l; ++c)
      m = r[c + 1], d = r[c - 1], h = r[c], Math.round((m + d) / 2) !== h && a.push({
        time: h,
        pos: c / (l - 1)
      });
    return a;
  }
  _generate() {
    const e = this.min, t = this.max;
    let s = super.getDataTimestamps();
    return (!s.includes(e) || !s.length) && s.splice(0, 0, e), (!s.includes(t) || s.length === 1) && s.push(t), s.sort((r, a) => r - a);
  }
  _getTimestampsForTable() {
    let e = this._cache.all || [];
    if (e.length)
      return e;
    const t = this.getDataTimestamps(), s = this.getLabelTimestamps();
    return t.length && s.length ? e = this.normalize(t.concat(s)) : e = t.length ? t : s, e = this._cache.all = e, e;
  }
  getDecimalForValue(e) {
    return (Zs(this._table, e) - this._minPos) / this._tableRange;
  }
  getValueForPixel(e) {
    const t = this._offsets, s = this.getDecimalForPixel(e) / t.factor - t.end;
    return Zs(this._table, s * this._tableRange + this._minPos, !0);
  }
}
oe($c, "id", "timeseries"), oe($c, "defaults", Ur.defaults);
At.register(Kn, Gn, ZM, qd, ts, ir);
At.overrides.doughnut.cutout = "80%";
const K2 = ({ className: n = "", style: e = {}, id: t = "", data: s, options: r, center: a }) => {
  const c = Re(null), [l, d] = X(null), [h, m] = X(window.innerWidth), [y, b] = X(window.innerHeight);
  return ee(() => {
    if (c.current) {
      l && l.destroy();
      const v = c.current.getContext("2d"), w = At.getChart(c.current);
      w && w.destroy(), v && d(
        new At(v, {
          type: "doughnut",
          data: s,
          options: {
            responsive: !0,
            ...r
          }
        })
      );
    }
    return () => {
      l && l.destroy();
    };
  }, [s, h, y]), ee(() => {
    const v = () => {
      b(window == null ? void 0 : window.innerHeight);
    }, w = () => {
      m(window == null ? void 0 : window.innerWidth);
    }, o = () => {
      for (const f in At.instances)
        At.instances[f].resize(600, 600);
    }, u = () => {
      for (const f in At.instances)
        At.instances[f].resize();
    };
    return window.addEventListener("resize", v), window.addEventListener("resize", w), window.addEventListener("beforeprint", o), window.addEventListener("afterprint", u), () => {
      window.removeEventListener("resize", v), window.removeEventListener("resize", w), window.removeEventListener("beforeprint", o), window.removeEventListener("afterprint", u);
    };
  }), /* @__PURE__ */ A.jsxs("div", { className: `chart-doughnut ${n}`, style: e, id: t, children: [
    a ? /* @__PURE__ */ A.jsx("span", { className: "center-text", children: a }) : null,
    /* @__PURE__ */ A.jsx("canvas", { ref: c })
  ] });
}, Ej = "data:image/jpeg;base64,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";
const Y2 = ({ id: n = "", className: e = "", image: t = "", value: s = 0, size: r = "medium" }) => {
  const a = (h, m, y = 0, b = 2500) => {
    if (h) {
      let v = null;
      const w = (o) => {
        v || (v = o);
        const u = Math.min((o - v) / b, 1);
        h.innerHTML = `${Math.floor(u * (m - y) + y)}%`, u < 1 && window.requestAnimationFrame(w);
      };
      window.requestAnimationFrame(w);
    }
  }, c = (h) => (h < 1 && (h = h * 100), h > 100 && (h = 100), h < 0 && (h = 0), parseInt(h.toFixed(0), 10)), l = Re(null), d = c(s);
  return ee(() => {
    l.current && a(l.current, d);
  }, [s]), /* @__PURE__ */ A.jsxs("div", { id: n, className: `circle-wrap ${e} ${r}`, children: [
    /* @__PURE__ */ A.jsxs("div", { className: "circle", children: [
      /* @__PURE__ */ A.jsx("div", { className: `mask full full-${d}`, children: /* @__PURE__ */ A.jsx("div", { className: `fill fill-${d}` }) }),
      /* @__PURE__ */ A.jsx("div", { className: "mask half", children: /* @__PURE__ */ A.jsx("div", { className: `fill fill-${d}` }) }),
      /* @__PURE__ */ A.jsxs("div", { className: `content ${t != null && t.length ? "image" : ""}`, children: [
        /* @__PURE__ */ A.jsxs("span", { ref: l, className: `number counter-${d}`, children: [
          d,
          "%"
        ] }),
        /* @__PURE__ */ A.jsx("figure", { children: /* @__PURE__ */ A.jsx(
          "img",
          {
            src: t,
            alt: "Profile",
            title: "Profile",
            className: "img-fluid",
            onError: ({ currentTarget: h }) => {
              h.onerror = null, h.src = Ej;
            }
          }
        ) })
      ] })
    ] }),
    /* @__PURE__ */ A.jsx("span", { className: `check ${d > 99 ? "done" : ""}`, children: /* @__PURE__ */ A.jsx("i", { className: "fa-regular fa-check" }) })
  ] });
};
const kj = ({ className: n = "", activeColor: e = "var(--primary_color)", steps: t, active: s, ...r }) => {
  var a;
  return /* @__PURE__ */ A.jsx("div", { className: `flow ${n}`, ...r, children: /* @__PURE__ */ A.jsx("ul", { children: t != null && t.length ? (a = Array.from(Array(t == null ? void 0 : t.length))) == null ? void 0 : a.map((c, l) => /* @__PURE__ */ A.jsx(
    "li",
    {
      className: `${l === s ? "active" : ""}`,
      style: { backgroundColor: s === l ? e : "" },
      "data-tooltip-id": "tooltip",
      "data-tooltip-content": c == null ? void 0 : c.status
    },
    l
  )) : null }) });
};
class J2 {
  capitalizeFirstLetter(e) {
    var t;
    return ((t = e == null ? void 0 : e.charAt(0)) == null ? void 0 : t.toUpperCase()) + (e == null ? void 0 : e.slice(1));
  }
  stringToRegexWithScapedSpecialChars(e) {
    return new RegExp(e == null ? void 0 : e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "i");
  }
}
class Z2 {
  getPayloadToken(e) {
    const s = (e.split(".")[1] || "").replace(/-/g, "+").replace(/_/g, "/");
    return JSON.parse(window.atob(s));
  }
  verifyExpirationToken(e) {
    if (!e)
      return !0;
    const t = this.getPayloadToken(e);
    return (/* @__PURE__ */ new Date()).getTime() > (t == null ? void 0 : t.exp) * 1e3;
  }
}
class Q2 {
  formatDate(e) {
    try {
      return new Date(e).toLocaleDateString("pt-br").split("/").reverse().join("-");
    } catch {
      return "";
    }
  }
  formatPhoneNumber(e) {
    if (e) {
      const t = "+55", s = "9", r = `+${e}`.slice(0, 3) === t, a = e.slice(4).length === 9, c = e.slice(4, 5) === s;
      return r ? c && a ? `${t} (${e.slice(2, 4)}) ${e.slice(4, 9)}-${e.slice(9, 14)}` : `${t} (${e.slice(2, 4)}) ${e.slice(4, 8)}-${e.slice(8, 13)}` : e;
    }
  }
  calcAge(e, t, s) {
    const r = /* @__PURE__ */ new Date(), a = r.getFullYear(), c = r.getMonth() + 1, l = r.getDate();
    e = +e, t = +t, s = +s;
    let d = a - e;
    return (c < t || c == t && l < s) && d--, d < 0 ? 0 : d;
  }
  formatTimeText(e, t, s) {
    const r = e / t;
    if (r > 1) {
      const a = Math.floor(r);
      return qe.t(`globals:${s}`, { value: a, count: a });
    }
    return "";
  }
  formatTimeFormatAgo(e) {
    const t = /* @__PURE__ */ new Date(), s = new Date(e), r = (t.getTime() - s.getTime()) / 1e3, a = [
      {
        period: "year",
        value: 31536e3
      },
      {
        period: "month",
        value: 2592e3
      },
      {
        period: "day",
        value: 86400
      },
      {
        period: "hour",
        value: 3600
      }
    ];
    if (t.getDate() === s.getDate())
      return qe.t("globals:today");
    let c = "";
    return a.forEach((l) => {
      c || (c = this.formatTimeText(r, l.value, l.period));
    }), c;
  }
}
var Vd = { exports: {} };
(function(n) {
  var e = Object.prototype.hasOwnProperty, t = "~";
  function s() {
  }
  Object.create && (s.prototype = /* @__PURE__ */ Object.create(null), new s().__proto__ || (t = !1));
  function r(d, h, m) {
    this.fn = d, this.context = h, this.once = m || !1;
  }
  function a(d, h, m, y, b) {
    if (typeof m != "function")
      throw new TypeError("The listener must be a function");
    var v = new r(m, y || d, b), w = t ? t + h : h;
    return d._events[w] ? d._events[w].fn ? d._events[w] = [d._events[w], v] : d._events[w].push(v) : (d._events[w] = v, d._eventsCount++), d;
  }
  function c(d, h) {
    --d._eventsCount === 0 ? d._events = new s() : delete d._events[h];
  }
  function l() {
    this._events = new s(), this._eventsCount = 0;
  }
  l.prototype.eventNames = function() {
    var h = [], m, y;
    if (this._eventsCount === 0)
      return h;
    for (y in m = this._events)
      e.call(m, y) && h.push(t ? y.slice(1) : y);
    return Object.getOwnPropertySymbols ? h.concat(Object.getOwnPropertySymbols(m)) : h;
  }, l.prototype.listeners = function(h) {
    var m = t ? t + h : h, y = this._events[m];
    if (!y)
      return [];
    if (y.fn)
      return [y.fn];
    for (var b = 0, v = y.length, w = new Array(v); b < v; b++)
      w[b] = y[b].fn;
    return w;
  }, l.prototype.listenerCount = function(h) {
    var m = t ? t + h : h, y = this._events[m];
    return y ? y.fn ? 1 : y.length : 0;
  }, l.prototype.emit = function(h, m, y, b, v, w) {
    var o = t ? t + h : h;
    if (!this._events[o])
      return !1;
    var u = this._events[o], f = arguments.length, p, g;
    if (u.fn) {
      switch (u.once && this.removeListener(h, u.fn, void 0, !0), f) {
        case 1:
          return u.fn.call(u.context), !0;
        case 2:
          return u.fn.call(u.context, m), !0;
        case 3:
          return u.fn.call(u.context, m, y), !0;
        case 4:
          return u.fn.call(u.context, m, y, b), !0;
        case 5:
          return u.fn.call(u.context, m, y, b, v), !0;
        case 6:
          return u.fn.call(u.context, m, y, b, v, w), !0;
      }
      for (g = 1, p = new Array(f - 1); g < f; g++)
        p[g - 1] = arguments[g];
      u.fn.apply(u.context, p);
    } else {
      var S = u.length, x;
      for (g = 0; g < S; g++)
        switch (u[g].once && this.removeListener(h, u[g].fn, void 0, !0), f) {
          case 1:
            u[g].fn.call(u[g].context);
            break;
          case 2:
            u[g].fn.call(u[g].context, m);
            break;
          case 3:
            u[g].fn.call(u[g].context, m, y);
            break;
          case 4:
            u[g].fn.call(u[g].context, m, y, b);
            break;
          default:
            if (!p)
              for (x = 1, p = new Array(f - 1); x < f; x++)
                p[x - 1] = arguments[x];
            u[g].fn.apply(u[g].context, p);
        }
    }
    return !0;
  }, l.prototype.on = function(h, m, y) {
    return a(this, h, m, y, !1);
  }, l.prototype.once = function(h, m, y) {
    return a(this, h, m, y, !0);
  }, l.prototype.removeListener = function(h, m, y, b) {
    var v = t ? t + h : h;
    if (!this._events[v])
      return this;
    if (!m)
      return c(this, v), this;
    var w = this._events[v];
    if (w.fn)
      w.fn === m && (!b || w.once) && (!y || w.context === y) && c(this, v);
    else {
      for (var o = 0, u = [], f = w.length; o < f; o++)
        (w[o].fn !== m || b && !w[o].once || y && w[o].context !== y) && u.push(w[o]);
      u.length ? this._events[v] = u.length === 1 ? u[0] : u : c(this, v);
    }
    return this;
  }, l.prototype.removeAllListeners = function(h) {
    var m;
    return h ? (m = t ? t + h : h, this._events[m] && c(this, m)) : (this._events = new s(), this._eventsCount = 0), this;
  }, l.prototype.off = l.prototype.removeListener, l.prototype.addListener = l.prototype.on, l.prefixed = t, l.EventEmitter = l, n.exports = l;
})(Vd);
var Oj = Vd.exports;
const Tj = /* @__PURE__ */ ms(Oj), Qs = new Tj(), Ij = {
  on: (n, e) => Qs.on(n, e),
  once: (n, e) => Qs.once(n, e),
  off: (n, e) => Qs.off(n, e),
  emit: (n, e) => Qs.emit(n, e)
};
Object.freeze(Ij);
var Gd = {};
(function(n) {
  var e = function() {
    var o = /* @__PURE__ */ new Date(), u = 4, f = 3, p = 2, g = 1, S = u, x = {
      setLogLevel: function(E) {
        E == this.debug ? S = g : E == this.info ? S = p : E == this.warn ? S = f : (E == this.error, S = u);
      },
      debug: function(E, k) {
        console.debug === void 0 && (console.debug = console.log), g >= S && console.debug("[" + e.getDurationString(/* @__PURE__ */ new Date() - o, 1e3) + "]", "[" + E + "]", k);
      },
      log: function(E, k) {
        this.debug(E.msg);
      },
      info: function(E, k) {
        p >= S && console.info("[" + e.getDurationString(/* @__PURE__ */ new Date() - o, 1e3) + "]", "[" + E + "]", k);
      },
      warn: function(E, k) {
        f >= S && console.warn("[" + e.getDurationString(/* @__PURE__ */ new Date() - o, 1e3) + "]", "[" + E + "]", k);
      },
      error: function(E, k) {
        u >= S && console.error("[" + e.getDurationString(/* @__PURE__ */ new Date() - o, 1e3) + "]", "[" + E + "]", k);
      }
    };
    return x;
  }();
  e.getDurationString = function(o, u) {
    var f;
    function p(R, O) {
      for (var T = "" + R, D = T.split("."); D[0].length < O; )
        D[0] = "0" + D[0];
      return D.join(".");
    }
    o < 0 ? (f = !0, o = -o) : f = !1;
    var g = u || 1, S = o / g, x = Math.floor(S / 3600);
    S -= x * 3600;
    var E = Math.floor(S / 60);
    S -= E * 60;
    var k = S * 1e3;
    return S = Math.floor(S), k -= S * 1e3, k = Math.floor(k), (f ? "-" : "") + x + ":" + p(E, 2) + ":" + p(S, 2) + "." + p(k, 3);
  }, e.printRanges = function(o) {
    var u = o.length;
    if (u > 0) {
      for (var f = "", p = 0; p < u; p++)
        p > 0 && (f += ","), f += "[" + e.getDurationString(o.start(p)) + "," + e.getDurationString(o.end(p)) + "]";
      return f;
    } else
      return "(empty)";
  }, n.Log = e;
  var t = function(o) {
    if (o instanceof ArrayBuffer)
      this.buffer = o, this.dataview = new DataView(o);
    else
      throw "Needs an array buffer";
    this.position = 0;
  };
  t.prototype.getPosition = function() {
    return this.position;
  }, t.prototype.getEndPosition = function() {
    return this.buffer.byteLength;
  }, t.prototype.getLength = function() {
    return this.buffer.byteLength;
  }, t.prototype.seek = function(o) {
    var u = Math.max(0, Math.min(this.buffer.byteLength, o));
    return this.position = isNaN(u) || !isFinite(u) ? 0 : u, !0;
  }, t.prototype.isEos = function() {
    return this.getPosition() >= this.getEndPosition();
  }, t.prototype.readAnyInt = function(o, u) {
    var f = 0;
    if (this.position + o <= this.buffer.byteLength) {
      switch (o) {
        case 1:
          u ? f = this.dataview.getInt8(this.position) : f = this.dataview.getUint8(this.position);
          break;
        case 2:
          u ? f = this.dataview.getInt16(this.position) : f = this.dataview.getUint16(this.position);
          break;
        case 3:
          if (u)
            throw "No method for reading signed 24 bits values";
          f = this.dataview.getUint8(this.position) << 16, f |= this.dataview.getUint8(this.position + 1) << 8, f |= this.dataview.getUint8(this.position + 2);
          break;
        case 4:
          u ? f = this.dataview.getInt32(this.position) : f = this.dataview.getUint32(this.position);
          break;
        case 8:
          if (u)
            throw "No method for reading signed 64 bits values";
          f = this.dataview.getUint32(this.position) << 32, f |= this.dataview.getUint32(this.position + 4);
          break;
        default:
          throw "readInt method not implemented for size: " + o;
      }
      return this.position += o, f;
    } else
      throw "Not enough bytes in buffer";
  }, t.prototype.readUint8 = function() {
    return this.readAnyInt(1, !1);
  }, t.prototype.readUint16 = function() {
    return this.readAnyInt(2, !1);
  }, t.prototype.readUint24 = function() {
    return this.readAnyInt(3, !1);
  }, t.prototype.readUint32 = function() {
    return this.readAnyInt(4, !1);
  }, t.prototype.readUint64 = function() {
    return this.readAnyInt(8, !1);
  }, t.prototype.readString = function(o) {
    if (this.position + o <= this.buffer.byteLength) {
      for (var u = "", f = 0; f < o; f++)
        u += String.fromCharCode(this.readUint8());
      return u;
    } else
      throw "Not enough bytes in buffer";
  }, t.prototype.readCString = function() {
    for (var o = []; ; ) {
      var u = this.readUint8();
      if (u !== 0)
        o.push(u);
      else
        break;
    }
    return String.fromCharCode.apply(null, o);
  }, t.prototype.readInt8 = function() {
    return this.readAnyInt(1, !0);
  }, t.prototype.readInt16 = function() {
    return this.readAnyInt(2, !0);
  }, t.prototype.readInt32 = function() {
    return this.readAnyInt(4, !0);
  }, t.prototype.readInt64 = function() {
    return this.readAnyInt(8, !1);
  }, t.prototype.readUint8Array = function(o) {
    for (var u = new Uint8Array(o), f = 0; f < o; f++)
      u[f] = this.readUint8();
    return u;
  }, t.prototype.readInt16Array = function(o) {
    for (var u = new Int16Array(o), f = 0; f < o; f++)
      u[f] = this.readInt16();
    return u;
  }, t.prototype.readUint16Array = function(o) {
    for (var u = new Int16Array(o), f = 0; f < o; f++)
      u[f] = this.readUint16();
    return u;
  }, t.prototype.readUint32Array = function(o) {
    for (var u = new Uint32Array(o), f = 0; f < o; f++)
      u[f] = this.readUint32();
    return u;
  }, t.prototype.readInt32Array = function(o) {
    for (var u = new Int32Array(o), f = 0; f < o; f++)
      u[f] = this.readInt32();
    return u;
  }, n.MP4BoxStream = t;
  var s = function(o, u, f) {
    this._byteOffset = u || 0, o instanceof ArrayBuffer ? this.buffer = o : typeof o == "object" ? (this.dataView = o, u && (this._byteOffset += u)) : this.buffer = new ArrayBuffer(o || 0), this.position = 0, this.endianness = f ?? s.LITTLE_ENDIAN;
  };
  s.prototype = {}, s.prototype.getPosition = function() {
    return this.position;
  }, s.prototype._realloc = function(o) {
    if (this._dynamicSize) {
      var u = this._byteOffset + this.position + o, f = this._buffer.byteLength;
      if (u <= f) {
        u > this._byteLength && (this._byteLength = u);
        return;
      }
      for (f < 1 && (f = 1); u > f; )
        f *= 2;
      var p = new ArrayBuffer(f), g = new Uint8Array(this._buffer), S = new Uint8Array(p, 0, g.length);
      S.set(g), this.buffer = p, this._byteLength = u;
    }
  }, s.prototype._trimAlloc = function() {
    if (this._byteLength != this._buffer.byteLength) {
      var o = new ArrayBuffer(this._byteLength), u = new Uint8Array(o), f = new Uint8Array(this._buffer, 0, u.length);
      u.set(f), this.buffer = o;
    }
  }, s.BIG_ENDIAN = !1, s.LITTLE_ENDIAN = !0, s.prototype._byteLength = 0, Object.defineProperty(
    s.prototype,
    "byteLength",
    { get: function() {
      return this._byteLength - this._byteOffset;
    } }
  ), Object.defineProperty(
    s.prototype,
    "buffer",
    {
      get: function() {
        return this._trimAlloc(), this._buffer;
      },
      set: function(o) {
        this._buffer = o, this._dataView = new DataView(this._buffer, this._byteOffset), this._byteLength = this._buffer.byteLength;
      }
    }
  ), Object.defineProperty(
    s.prototype,
    "byteOffset",
    {
      get: function() {
        return this._byteOffset;
      },
      set: function(o) {
        this._byteOffset = o, this._dataView = new DataView(this._buffer, this._byteOffset), this._byteLength = this._buffer.byteLength;
      }
    }
  ), Object.defineProperty(
    s.prototype,
    "dataView",
    {
      get: function() {
        return this._dataView;
      },
      set: function(o) {
        this._byteOffset = o.byteOffset, this._buffer = o.buffer, this._dataView = new DataView(this._buffer, this._byteOffset), this._byteLength = this._byteOffset + o.byteLength;
      }
    }
  ), s.prototype.seek = function(o) {
    var u = Math.max(0, Math.min(this.byteLength, o));
    this.position = isNaN(u) || !isFinite(u) ? 0 : u;
  }, s.prototype.isEof = function() {
    return this.position >= this._byteLength;
  }, s.prototype.mapUint8Array = function(o) {
    this._realloc(o * 1);
    var u = new Uint8Array(this._buffer, this.byteOffset + this.position, o);
    return this.position += o * 1, u;
  }, s.prototype.readInt32Array = function(o, u) {
    o = o ?? this.byteLength - this.position / 4;
    var f = new Int32Array(o);
    return s.memcpy(
      f.buffer,
      0,
      this.buffer,
      this.byteOffset + this.position,
      o * f.BYTES_PER_ELEMENT
    ), s.arrayToNative(f, u ?? this.endianness), this.position += f.byteLength, f;
  }, s.prototype.readInt16Array = function(o, u) {
    o = o ?? this.byteLength - this.position / 2;
    var f = new Int16Array(o);
    return s.memcpy(
      f.buffer,
      0,
      this.buffer,
      this.byteOffset + this.position,
      o * f.BYTES_PER_ELEMENT
    ), s.arrayToNative(f, u ?? this.endianness), this.position += f.byteLength, f;
  }, s.prototype.readInt8Array = function(o) {
    o = o ?? this.byteLength - this.position;
    var u = new Int8Array(o);
    return s.memcpy(
      u.buffer,
      0,
      this.buffer,
      this.byteOffset + this.position,
      o * u.BYTES_PER_ELEMENT
    ), this.position += u.byteLength, u;
  }, s.prototype.readUint32Array = function(o, u) {
    o = o ?? this.byteLength - this.position / 4;
    var f = new Uint32Array(o);
    return s.memcpy(
      f.buffer,
      0,
      this.buffer,
      this.byteOffset + this.position,
      o * f.BYTES_PER_ELEMENT
    ), s.arrayToNative(f, u ?? this.endianness), this.position += f.byteLength, f;
  }, s.prototype.readUint16Array = function(o, u) {
    o = o ?? this.byteLength - this.position / 2;
    var f = new Uint16Array(o);
    return s.memcpy(
      f.buffer,
      0,
      this.buffer,
      this.byteOffset + this.position,
      o * f.BYTES_PER_ELEMENT
    ), s.arrayToNative(f, u ?? this.endianness), this.position += f.byteLength, f;
  }, s.prototype.readUint8Array = function(o) {
    o = o ?? this.byteLength - this.position;
    var u = new Uint8Array(o);
    return s.memcpy(
      u.buffer,
      0,
      this.buffer,
      this.byteOffset + this.position,
      o * u.BYTES_PER_ELEMENT
    ), this.position += u.byteLength, u;
  }, s.prototype.readFloat64Array = function(o, u) {
    o = o ?? this.byteLength - this.position / 8;
    var f = new Float64Array(o);
    return s.memcpy(
      f.buffer,
      0,
      this.buffer,
      this.byteOffset + this.position,
      o * f.BYTES_PER_ELEMENT
    ), s.arrayToNative(f, u ?? this.endianness), this.position += f.byteLength, f;
  }, s.prototype.readFloat32Array = function(o, u) {
    o = o ?? this.byteLength - this.position / 4;
    var f = new Float32Array(o);
    return s.memcpy(
      f.buffer,
      0,
      this.buffer,
      this.byteOffset + this.position,
      o * f.BYTES_PER_ELEMENT
    ), s.arrayToNative(f, u ?? this.endianness), this.position += f.byteLength, f;
  }, s.prototype.readInt32 = function(o) {
    var u = this._dataView.getInt32(this.position, o ?? this.endianness);
    return this.position += 4, u;
  }, s.prototype.readInt16 = function(o) {
    var u = this._dataView.getInt16(this.position, o ?? this.endianness);
    return this.position += 2, u;
  }, s.prototype.readInt8 = function() {
    var o = this._dataView.getInt8(this.position);
    return this.position += 1, o;
  }, s.prototype.readUint32 = function(o) {
    var u = this._dataView.getUint32(this.position, o ?? this.endianness);
    return this.position += 4, u;
  }, s.prototype.readUint16 = function(o) {
    var u = this._dataView.getUint16(this.position, o ?? this.endianness);
    return this.position += 2, u;
  }, s.prototype.readUint8 = function() {
    var o = this._dataView.getUint8(this.position);
    return this.position += 1, o;
  }, s.prototype.readFloat32 = function(o) {
    var u = this._dataView.getFloat32(this.position, o ?? this.endianness);
    return this.position += 4, u;
  }, s.prototype.readFloat64 = function(o) {
    var u = this._dataView.getFloat64(this.position, o ?? this.endianness);
    return this.position += 8, u;
  }, s.endianness = new Int8Array(new Int16Array([1]).buffer)[0] > 0, s.memcpy = function(o, u, f, p, g) {
    var S = new Uint8Array(o, u, g), x = new Uint8Array(f, p, g);
    S.set(x);
  }, s.arrayToNative = function(o, u) {
    return u == this.endianness ? o : this.flipArrayEndianness(o);
  }, s.nativeToEndian = function(o, u) {
    return this.endianness == u ? o : this.flipArrayEndianness(o);
  }, s.flipArrayEndianness = function(o) {
    for (var u = new Uint8Array(o.buffer, o.byteOffset, o.byteLength), f = 0; f < o.byteLength; f += o.BYTES_PER_ELEMENT)
      for (var p = f + o.BYTES_PER_ELEMENT - 1, g = f; p > g; p--, g++) {
        var S = u[g];
        u[g] = u[p], u[p] = S;
      }
    return o;
  }, s.prototype.failurePosition = 0, String.fromCharCodeUint8 = function(o) {
    for (var u = [], f = 0; f < o.length; f++)
      u[f] = o[f];
    return String.fromCharCode.apply(null, u);
  }, s.prototype.readString = function(o, u) {
    return u == null || u == "ASCII" ? String.fromCharCodeUint8.apply(null, [this.mapUint8Array(o ?? this.byteLength - this.position)]) : new TextDecoder(u).decode(this.mapUint8Array(o));
  }, s.prototype.readCString = function(o) {
    var u = this.byteLength - this.position, f = new Uint8Array(this._buffer, this._byteOffset + this.position), p = u;
    o != null && (p = Math.min(o, u));
    for (var g = 0; g < p && f[g] !== 0; g++)
      ;
    var S = String.fromCharCodeUint8.apply(null, [this.mapUint8Array(g)]);
    return o != null ? this.position += p - g : g != u && (this.position += 1), S;
  };
  var r = Math.pow(2, 32);
  s.prototype.readInt64 = function() {
    return this.readInt32() * r + this.readUint32();
  }, s.prototype.readUint64 = function() {
    return this.readUint32() * r + this.readUint32();
  }, s.prototype.readInt64 = function() {
    return this.readUint32() * r + this.readUint32();
  }, s.prototype.readUint24 = function() {
    return (this.readUint8() << 16) + (this.readUint8() << 8) + this.readUint8();
  }, n.DataStream = s, s.prototype.save = function(o) {
    var u = new Blob([this.buffer]);
    if (window.URL && URL.createObjectURL) {
      var f = window.URL.createObjectURL(u), p = document.createElement("a");
      document.body.appendChild(p), p.setAttribute("href", f), p.setAttribute("download", o), p.setAttribute("target", "_self"), p.click(), window.URL.revokeObjectURL(f);
    } else
      throw "DataStream.save: Can't create object URL.";
  }, s.prototype._dynamicSize = !0, Object.defineProperty(
    s.prototype,
    "dynamicSize",
    {
      get: function() {
        return this._dynamicSize;
      },
      set: function(o) {
        o || this._trimAlloc(), this._dynamicSize = o;
      }
    }
  ), s.prototype.shift = function(o) {
    var u = new ArrayBuffer(this._byteLength - o), f = new Uint8Array(u), p = new Uint8Array(this._buffer, o, f.length);
    f.set(p), this.buffer = u, this.position -= o;
  }, s.prototype.writeInt32Array = function(o, u) {
    if (this._realloc(o.length * 4), o instanceof Int32Array && this.byteOffset + this.position % o.BYTES_PER_ELEMENT === 0)
      s.memcpy(
        this._buffer,
        this.byteOffset + this.position,
        o.buffer,
        0,
        o.byteLength
      ), this.mapInt32Array(o.length, u);
    else
      for (var f = 0; f < o.length; f++)
        this.writeInt32(o[f], u);
  }, s.prototype.writeInt16Array = function(o, u) {
    if (this._realloc(o.length * 2), o instanceof Int16Array && this.byteOffset + this.position % o.BYTES_PER_ELEMENT === 0)
      s.memcpy(
        this._buffer,
        this.byteOffset + this.position,
        o.buffer,
        0,
        o.byteLength
      ), this.mapInt16Array(o.length, u);
    else
      for (var f = 0; f < o.length; f++)
        this.writeInt16(o[f], u);
  }, s.prototype.writeInt8Array = function(o) {
    if (this._realloc(o.length * 1), o instanceof Int8Array && this.byteOffset + this.position % o.BYTES_PER_ELEMENT === 0)
      s.memcpy(
        this._buffer,
        this.byteOffset + this.position,
        o.buffer,
        0,
        o.byteLength
      ), this.mapInt8Array(o.length);
    else
      for (var u = 0; u < o.length; u++)
        this.writeInt8(o[u]);
  }, s.prototype.writeUint32Array = function(o, u) {
    if (this._realloc(o.length * 4), o instanceof Uint32Array && this.byteOffset + this.position % o.BYTES_PER_ELEMENT === 0)
      s.memcpy(
        this._buffer,
        this.byteOffset + this.position,
        o.buffer,
        0,
        o.byteLength
      ), this.mapUint32Array(o.length, u);
    else
      for (var f = 0; f < o.length; f++)
        this.writeUint32(o[f], u);
  }, s.prototype.writeUint16Array = function(o, u) {
    if (this._realloc(o.length * 2), o instanceof Uint16Array && this.byteOffset + this.position % o.BYTES_PER_ELEMENT === 0)
      s.memcpy(
        this._buffer,
        this.byteOffset + this.position,
        o.buffer,
        0,
        o.byteLength
      ), this.mapUint16Array(o.length, u);
    else
      for (var f = 0; f < o.length; f++)
        this.writeUint16(o[f], u);
  }, s.prototype.writeUint8Array = function(o) {
    if (this._realloc(o.length * 1), o instanceof Uint8Array && this.byteOffset + this.position % o.BYTES_PER_ELEMENT === 0)
      s.memcpy(
        this._buffer,
        this.byteOffset + this.position,
        o.buffer,
        0,
        o.byteLength
      ), this.mapUint8Array(o.length);
    else
      for (var u = 0; u < o.length; u++)
        this.writeUint8(o[u]);
  }, s.prototype.writeFloat64Array = function(o, u) {
    if (this._realloc(o.length * 8), o instanceof Float64Array && this.byteOffset + this.position % o.BYTES_PER_ELEMENT === 0)
      s.memcpy(
        this._buffer,
        this.byteOffset + this.position,
        o.buffer,
        0,
        o.byteLength
      ), this.mapFloat64Array(o.length, u);
    else
      for (var f = 0; f < o.length; f++)
        this.writeFloat64(o[f], u);
  }, s.prototype.writeFloat32Array = function(o, u) {
    if (this._realloc(o.length * 4), o instanceof Float32Array && this.byteOffset + this.position % o.BYTES_PER_ELEMENT === 0)
      s.memcpy(
        this._buffer,
        this.byteOffset + this.position,
        o.buffer,
        0,
        o.byteLength
      ), this.mapFloat32Array(o.length, u);
    else
      for (var f = 0; f < o.length; f++)
        this.writeFloat32(o[f], u);
  }, s.prototype.writeInt32 = function(o, u) {
    this._realloc(4), this._dataView.setInt32(this.position, o, u ?? this.endianness), this.position += 4;
  }, s.prototype.writeInt16 = function(o, u) {
    this._realloc(2), this._dataView.setInt16(this.position, o, u ?? this.endianness), this.position += 2;
  }, s.prototype.writeInt8 = function(o) {
    this._realloc(1), this._dataView.setInt8(this.position, o), this.position += 1;
  }, s.prototype.writeUint32 = function(o, u) {
    this._realloc(4), this._dataView.setUint32(this.position, o, u ?? this.endianness), this.position += 4;
  }, s.prototype.writeUint16 = function(o, u) {
    this._realloc(2), this._dataView.setUint16(this.position, o, u ?? this.endianness), this.position += 2;
  }, s.prototype.writeUint8 = function(o) {
    this._realloc(1), this._dataView.setUint8(this.position, o), this.position += 1;
  }, s.prototype.writeFloat32 = function(o, u) {
    this._realloc(4), this._dataView.setFloat32(this.position, o, u ?? this.endianness), this.position += 4;
  }, s.prototype.writeFloat64 = function(o, u) {
    this._realloc(8), this._dataView.setFloat64(this.position, o, u ?? this.endianness), this.position += 8;
  }, s.prototype.writeUCS2String = function(o, u, f) {
    f == null && (f = o.length);
    for (var p = 0; p < o.length && p < f; p++)
      this.writeUint16(o.charCodeAt(p), u);
    for (; p < f; p++)
      this.writeUint16(0);
  }, s.prototype.writeString = function(o, u, f) {
    var p = 0;
    if (u == null || u == "ASCII")
      if (f != null) {
        var g = Math.min(o.length, f);
        for (p = 0; p < g; p++)
          this.writeUint8(o.charCodeAt(p));
        for (; p < f; p++)
          this.writeUint8(0);
      } else
        for (p = 0; p < o.length; p++)
          this.writeUint8(o.charCodeAt(p));
    else
      this.writeUint8Array(new TextEncoder(u).encode(o.substring(0, f)));
  }, s.prototype.writeCString = function(o, u) {
    var f = 0;
    if (u != null) {
      var p = Math.min(o.length, u);
      for (f = 0; f < p; f++)
        this.writeUint8(o.charCodeAt(f));
      for (; f < u; f++)
        this.writeUint8(0);
    } else {
      for (f = 0; f < o.length; f++)
        this.writeUint8(o.charCodeAt(f));
      this.writeUint8(0);
    }
  }, s.prototype.writeStruct = function(o, u) {
    for (var f = 0; f < o.length; f += 2) {
      var p = o[f + 1];
      this.writeType(p, u[o[f]], u);
    }
  }, s.prototype.writeType = function(o, u, f) {
    var p;
    if (typeof o == "function")
      return o(this, u);
    if (typeof o == "object" && !(o instanceof Array))
      return o.set(this, u, f);
    var g = null, S = "ASCII", x = this.position;
    switch (typeof o == "string" && /:/.test(o) && (p = o.split(":"), o = p[0], g = parseInt(p[1])), typeof o == "string" && /,/.test(o) && (p = o.split(","), o = p[0], S = parseInt(p[1])), o) {
      case "uint8":
        this.writeUint8(u);
        break;
      case "int8":
        this.writeInt8(u);
        break;
      case "uint16":
        this.writeUint16(u, this.endianness);
        break;
      case "int16":
        this.writeInt16(u, this.endianness);
        break;
      case "uint32":
        this.writeUint32(u, this.endianness);
        break;
      case "int32":
        this.writeInt32(u, this.endianness);
        break;
      case "float32":
        this.writeFloat32(u, this.endianness);
        break;
      case "float64":
        this.writeFloat64(u, this.endianness);
        break;
      case "uint16be":
        this.writeUint16(u, s.BIG_ENDIAN);
        break;
      case "int16be":
        this.writeInt16(u, s.BIG_ENDIAN);
        break;
      case "uint32be":
        this.writeUint32(u, s.BIG_ENDIAN);
        break;
      case "int32be":
        this.writeInt32(u, s.BIG_ENDIAN);
        break;
      case "float32be":
        this.writeFloat32(u, s.BIG_ENDIAN);
        break;
      case "float64be":
        this.writeFloat64(u, s.BIG_ENDIAN);
        break;
      case "uint16le":
        this.writeUint16(u, s.LITTLE_ENDIAN);
        break;
      case "int16le":
        this.writeInt16(u, s.LITTLE_ENDIAN);
        break;
      case "uint32le":
        this.writeUint32(u, s.LITTLE_ENDIAN);
        break;
      case "int32le":
        this.writeInt32(u, s.LITTLE_ENDIAN);
        break;
      case "float32le":
        this.writeFloat32(u, s.LITTLE_ENDIAN);
        break;
      case "float64le":
        this.writeFloat64(u, s.LITTLE_ENDIAN);
        break;
      case "cstring":
        this.writeCString(u, g);
        break;
      case "string":
        this.writeString(u, S, g);
        break;
      case "u16string":
        this.writeUCS2String(u, this.endianness, g);
        break;
      case "u16stringle":
        this.writeUCS2String(u, s.LITTLE_ENDIAN, g);
        break;
      case "u16stringbe":
        this.writeUCS2String(u, s.BIG_ENDIAN, g);
        break;
      default:
        if (o.length == 3) {
          for (var E = o[1], k = 0; k < u.length; k++)
            this.writeType(E, u[k]);
          break;
        } else {
          this.writeStruct(o, u);
          break;
        }
    }
    g != null && (this.position = x, this._realloc(g), this.position = x + g);
  }, s.prototype.writeUint64 = function(o) {
    var u = Math.floor(o / r);
    this.writeUint32(u), this.writeUint32(o & 4294967295);
  }, s.prototype.writeUint24 = function(o) {
    this.writeUint8((o & 16711680) >> 16), this.writeUint8((o & 65280) >> 8), this.writeUint8(o & 255);
  }, s.prototype.adjustUint32 = function(o, u) {
    var f = this.position;
    this.seek(o), this.writeUint32(u), this.seek(f);
  }, s.prototype.mapInt32Array = function(o, u) {
    this._realloc(o * 4);
    var f = new Int32Array(this._buffer, this.byteOffset + this.position, o);
    return s.arrayToNative(f, u ?? this.endianness), this.position += o * 4, f;
  }, s.prototype.mapInt16Array = function(o, u) {
    this._realloc(o * 2);
    var f = new Int16Array(this._buffer, this.byteOffset + this.position, o);
    return s.arrayToNative(f, u ?? this.endianness), this.position += o * 2, f;
  }, s.prototype.mapInt8Array = function(o) {
    this._realloc(o * 1);
    var u = new Int8Array(this._buffer, this.byteOffset + this.position, o);
    return this.position += o * 1, u;
  }, s.prototype.mapUint32Array = function(o, u) {
    this._realloc(o * 4);
    var f = new Uint32Array(this._buffer, this.byteOffset + this.position, o);
    return s.arrayToNative(f, u ?? this.endianness), this.position += o * 4, f;
  }, s.prototype.mapUint16Array = function(o, u) {
    this._realloc(o * 2);
    var f = new Uint16Array(this._buffer, this.byteOffset + this.position, o);
    return s.arrayToNative(f, u ?? this.endianness), this.position += o * 2, f;
  }, s.prototype.mapFloat64Array = function(o, u) {
    this._realloc(o * 8);
    var f = new Float64Array(this._buffer, this.byteOffset + this.position, o);
    return s.arrayToNative(f, u ?? this.endianness), this.position += o * 8, f;
  }, s.prototype.mapFloat32Array = function(o, u) {
    this._realloc(o * 4);
    var f = new Float32Array(this._buffer, this.byteOffset + this.position, o);
    return s.arrayToNative(f, u ?? this.endianness), this.position += o * 4, f;
  };
  var a = function(o) {
    this.buffers = [], this.bufferIndex = -1, o && (this.insertBuffer(o), this.bufferIndex = 0);
  };
  a.prototype = new s(new ArrayBuffer(), 0, s.BIG_ENDIAN), a.prototype.initialized = function() {
    var o;
    return this.bufferIndex > -1 ? !0 : this.buffers.length > 0 ? (o = this.buffers[0], o.fileStart === 0 ? (this.buffer = o, this.bufferIndex = 0, e.debug("MultiBufferStream", "Stream ready for parsing"), !0) : (e.warn("MultiBufferStream", "The first buffer should have a fileStart of 0"), this.logBufferLevel(), !1)) : (e.warn("MultiBufferStream", "No buffer to start parsing from"), this.logBufferLevel(), !1);
  }, ArrayBuffer.concat = function(o, u) {
    e.debug("ArrayBuffer", "Trying to create a new buffer of size: " + (o.byteLength + u.byteLength));
    var f = new Uint8Array(o.byteLength + u.byteLength);
    return f.set(new Uint8Array(o), 0), f.set(new Uint8Array(u), o.byteLength), f.buffer;
  }, a.prototype.reduceBuffer = function(o, u, f) {
    var p;
    return p = new Uint8Array(f), p.set(new Uint8Array(o, u, f)), p.buffer.fileStart = o.fileStart + u, p.buffer.usedBytes = 0, p.buffer;
  }, a.prototype.insertBuffer = function(o) {
    for (var u = !0, f = 0; f < this.buffers.length; f++) {
      var p = this.buffers[f];
      if (o.fileStart <= p.fileStart) {
        if (o.fileStart === p.fileStart)
          if (o.byteLength > p.byteLength) {
            this.buffers.splice(f, 1), f--;
            continue;
          } else
            e.warn("MultiBufferStream", "Buffer (fileStart: " + o.fileStart + " - Length: " + o.byteLength + ") already appended, ignoring");
        else
          o.fileStart + o.byteLength <= p.fileStart || (o = this.reduceBuffer(o, 0, p.fileStart - o.fileStart)), e.debug("MultiBufferStream", "Appending new buffer (fileStart: " + o.fileStart + " - Length: " + o.byteLength + ")"), this.buffers.splice(f, 0, o), f === 0 && (this.buffer = o);
        u = !1;
        break;
      } else if (o.fileStart < p.fileStart + p.byteLength) {
        var g = p.fileStart + p.byteLength - o.fileStart, S = o.byteLength - g;
        if (S > 0)
          o = this.reduceBuffer(o, g, S);
        else {
          u = !1;
          break;
        }
      }
    }
    u && (e.debug("MultiBufferStream", "Appending new buffer (fileStart: " + o.fileStart + " - Length: " + o.byteLength + ")"), this.buffers.push(o), f === 0 && (this.buffer = o));
  }, a.prototype.logBufferLevel = function(o) {
    var u, f, p, g, S = [], x, E = "";
    for (p = 0, g = 0, u = 0; u < this.buffers.length; u++)
      f = this.buffers[u], u === 0 ? (x = {}, S.push(x), x.start = f.fileStart, x.end = f.fileStart + f.byteLength, E += "[" + x.start + "-") : x.end === f.fileStart ? x.end = f.fileStart + f.byteLength : (x = {}, x.start = f.fileStart, E += S[S.length - 1].end - 1 + "], [" + x.start + "-", x.end = f.fileStart + f.byteLength, S.push(x)), p += f.usedBytes, g += f.byteLength;
    S.length > 0 && (E += x.end - 1 + "]");
    var k = o ? e.info : e.debug;
    this.buffers.length === 0 ? k("MultiBufferStream", "No more buffer in memory") : k("MultiBufferStream", "" + this.buffers.length + " stored buffer(s) (" + p + "/" + g + " bytes), continuous ranges: " + E);
  }, a.prototype.cleanBuffers = function() {
    var o, u;
    for (o = 0; o < this.buffers.length; o++)
      u = this.buffers[o], u.usedBytes === u.byteLength && (e.debug("MultiBufferStream", "Removing buffer #" + o), this.buffers.splice(o, 1), o--);
  }, a.prototype.mergeNextBuffer = function() {
    var o;
    if (this.bufferIndex + 1 < this.buffers.length)
      if (o = this.buffers[this.bufferIndex + 1], o.fileStart === this.buffer.fileStart + this.buffer.byteLength) {
        var u = this.buffer.byteLength, f = this.buffer.usedBytes, p = this.buffer.fileStart;
        return this.buffers[this.bufferIndex] = ArrayBuffer.concat(this.buffer, o), this.buffer = this.buffers[this.bufferIndex], this.buffers.splice(this.bufferIndex + 1, 1), this.buffer.usedBytes = f, this.buffer.fileStart = p, e.debug("ISOFile", "Concatenating buffer for box parsing (length: " + u + "->" + this.buffer.byteLength + ")"), !0;
      } else
        return !1;
    else
      return !1;
  }, a.prototype.findPosition = function(o, u, f) {
    var p, g = null, S = -1;
    for (o === !0 ? p = 0 : p = this.bufferIndex; p < this.buffers.length && (g = this.buffers[p], g.fileStart <= u); ) {
      S = p, f && (g.fileStart + g.byteLength <= u ? g.usedBytes = g.byteLength : g.usedBytes = u - g.fileStart, this.logBufferLevel());
      p++;
    }
    return S !== -1 ? (g = this.buffers[S], g.fileStart + g.byteLength >= u ? (e.debug("MultiBufferStream", "Found position in existing buffer #" + S), S) : -1) : -1;
  }, a.prototype.findEndContiguousBuf = function(o) {
    var u, f, p, g = o !== void 0 ? o : this.bufferIndex;
    if (f = this.buffers[g], this.buffers.length > g + 1)
      for (u = g + 1; u < this.buffers.length && (p = this.buffers[u], p.fileStart === f.fileStart + f.byteLength); u++)
        f = p;
    return f.fileStart + f.byteLength;
  }, a.prototype.getEndFilePositionAfter = function(o) {
    var u = this.findPosition(!0, o, !1);
    return u !== -1 ? this.findEndContiguousBuf(u) : o;
  }, a.prototype.addUsedBytes = function(o) {
    this.buffer.usedBytes += o, this.logBufferLevel();
  }, a.prototype.setAllUsedBytes = function() {
    this.buffer.usedBytes = this.buffer.byteLength, this.logBufferLevel();
  }, a.prototype.seek = function(o, u, f) {
    var p;
    return p = this.findPosition(u, o, f), p !== -1 ? (this.buffer = this.buffers[p], this.bufferIndex = p, this.position = o - this.buffer.fileStart, e.debug("MultiBufferStream", "Repositioning parser at buffer position: " + this.position), !0) : (e.debug("MultiBufferStream", "Position " + o + " not found in buffered data"), !1);
  }, a.prototype.getPosition = function() {
    if (this.bufferIndex === -1 || this.buffers[this.bufferIndex] === null)
      throw "Error accessing position in the MultiBufferStream";
    return this.buffers[this.bufferIndex].fileStart + this.position;
  }, a.prototype.getLength = function() {
    return this.byteLength;
  }, a.prototype.getEndPosition = function() {
    if (this.bufferIndex === -1 || this.buffers[this.bufferIndex] === null)
      throw "Error accessing position in the MultiBufferStream";
    return this.buffers[this.bufferIndex].fileStart + this.byteLength;
  }, n.MultiBufferStream = a;
  var c = function() {
    var o = 3, u = 4, f = 5, p = 6, g = [];
    g[o] = "ES_Descriptor", g[u] = "DecoderConfigDescriptor", g[f] = "DecoderSpecificInfo", g[p] = "SLConfigDescriptor", this.getDescriptorName = function(E) {
      return g[E];
    };
    var S = this, x = {};
    return this.parseOneDescriptor = function(E) {
      var k = 0, R, O, T;
      for (R = E.readUint8(), T = E.readUint8(); T & 128; )
        k = (k << 7) + (T & 127), T = E.readUint8();
      return k = (k << 7) + (T & 127), e.debug("MPEG4DescriptorParser", "Found " + (g[R] || "Descriptor " + R) + ", size " + k + " at position " + E.getPosition()), g[R] ? O = new x[g[R]](k) : O = new x.Descriptor(k), O.parse(E), O;
    }, x.Descriptor = function(E, k) {
      this.tag = E, this.size = k, this.descs = [];
    }, x.Descriptor.prototype.parse = function(E) {
      this.data = E.readUint8Array(this.size);
    }, x.Descriptor.prototype.findDescriptor = function(E) {
      for (var k = 0; k < this.descs.length; k++)
        if (this.descs[k].tag == E)
          return this.descs[k];
      return null;
    }, x.Descriptor.prototype.parseRemainingDescriptors = function(E) {
      for (var k = E.position; E.position < k + this.size; ) {
        var R = S.parseOneDescriptor(E);
        this.descs.push(R);
      }
    }, x.ES_Descriptor = function(E) {
      x.Descriptor.call(this, o, E);
    }, x.ES_Descriptor.prototype = new x.Descriptor(), x.ES_Descriptor.prototype.parse = function(E) {
      if (this.ES_ID = E.readUint16(), this.flags = E.readUint8(), this.size -= 3, this.flags & 128 ? (this.dependsOn_ES_ID = E.readUint16(), this.size -= 2) : this.dependsOn_ES_ID = 0, this.flags & 64) {
        var k = E.readUint8();
        this.URL = E.readString(k), this.size -= k + 1;
      } else
        this.URL = "";
      this.flags & 32 ? (this.OCR_ES_ID = E.readUint16(), this.size -= 2) : this.OCR_ES_ID = 0, this.parseRemainingDescriptors(E);
    }, x.ES_Descriptor.prototype.getOTI = function(E) {
      var k = this.findDescriptor(u);
      return k ? k.oti : 0;
    }, x.ES_Descriptor.prototype.getAudioConfig = function(E) {
      var k = this.findDescriptor(u);
      if (!k)
        return null;
      var R = k.findDescriptor(f);
      if (R && R.data) {
        var O = (R.data[0] & 248) >> 3;
        return O === 31 && R.data.length >= 2 && (O = 32 + ((R.data[0] & 7) << 3) + ((R.data[1] & 224) >> 5)), O;
      } else
        return null;
    }, x.DecoderConfigDescriptor = function(E) {
      x.Descriptor.call(this, u, E);
    }, x.DecoderConfigDescriptor.prototype = new x.Descriptor(), x.DecoderConfigDescriptor.prototype.parse = function(E) {
      this.oti = E.readUint8(), this.streamType = E.readUint8(), this.upStream = (this.streamType >> 1 & 1) !== 0, this.streamType = this.streamType >>> 2, this.bufferSize = E.readUint24(), this.maxBitrate = E.readUint32(), this.avgBitrate = E.readUint32(), this.size -= 13, this.parseRemainingDescriptors(E);
    }, x.DecoderSpecificInfo = function(E) {
      x.Descriptor.call(this, f, E);
    }, x.DecoderSpecificInfo.prototype = new x.Descriptor(), x.SLConfigDescriptor = function(E) {
      x.Descriptor.call(this, p, E);
    }, x.SLConfigDescriptor.prototype = new x.Descriptor(), this;
  };
  n.MPEG4DescriptorParser = c;
  var l = {
    ERR_INVALID_DATA: -1,
    ERR_NOT_ENOUGH_DATA: 0,
    OK: 1,
    // Boxes to be created with default parsing
    BASIC_BOXES: ["mdat", "idat", "free", "skip", "meco", "strk"],
    FULL_BOXES: ["hmhd", "nmhd", "iods", "xml ", "bxml", "ipro", "mere"],
    CONTAINER_BOXES: [
      ["moov", ["trak", "pssh"]],
      ["trak"],
      ["edts"],
      ["mdia"],
      ["minf"],
      ["dinf"],
      ["stbl", ["sgpd", "sbgp"]],
      ["mvex", ["trex"]],
      ["moof", ["traf"]],
      ["traf", ["trun", "sgpd", "sbgp"]],
      ["vttc"],
      ["tref"],
      ["iref"],
      ["mfra", ["tfra"]],
      ["meco"],
      ["hnti"],
      ["hinf"],
      ["strk"],
      ["strd"],
      ["sinf"],
      ["rinf"],
      ["schi"],
      ["trgr"],
      ["udta", ["kind"]],
      ["iprp", ["ipma"]],
      ["ipco"],
      ["grpl"],
      ["j2kH"],
      ["etyp", ["tyco"]]
    ],
    // Boxes effectively created
    boxCodes: [],
    fullBoxCodes: [],
    containerBoxCodes: [],
    sampleEntryCodes: {},
    sampleGroupEntryCodes: [],
    trackGroupTypes: [],
    UUIDBoxes: {},
    UUIDs: [],
    initialize: function() {
      l.FullBox.prototype = new l.Box(), l.ContainerBox.prototype = new l.Box(), l.SampleEntry.prototype = new l.Box(), l.TrackGroupTypeBox.prototype = new l.FullBox(), l.BASIC_BOXES.forEach(function(o) {
        l.createBoxCtor(o);
      }), l.FULL_BOXES.forEach(function(o) {
        l.createFullBoxCtor(o);
      }), l.CONTAINER_BOXES.forEach(function(o) {
        l.createContainerBoxCtor(o[0], null, o[1]);
      });
    },
    Box: function(o, u, f) {
      this.type = o, this.size = u, this.uuid = f;
    },
    FullBox: function(o, u, f) {
      l.Box.call(this, o, u, f), this.flags = 0, this.version = 0;
    },
    ContainerBox: function(o, u, f) {
      l.Box.call(this, o, u, f), this.boxes = [];
    },
    SampleEntry: function(o, u, f, p) {
      l.ContainerBox.call(this, o, u), this.hdr_size = f, this.start = p;
    },
    SampleGroupEntry: function(o) {
      this.grouping_type = o;
    },
    TrackGroupTypeBox: function(o, u) {
      l.FullBox.call(this, o, u);
    },
    createBoxCtor: function(o, u) {
      l.boxCodes.push(o), l[o + "Box"] = function(f) {
        l.Box.call(this, o, f);
      }, l[o + "Box"].prototype = new l.Box(), u && (l[o + "Box"].prototype.parse = u);
    },
    createFullBoxCtor: function(o, u) {
      l[o + "Box"] = function(f) {
        l.FullBox.call(this, o, f);
      }, l[o + "Box"].prototype = new l.FullBox(), l[o + "Box"].prototype.parse = function(f) {
        this.parseFullHeader(f), u && u.call(this, f);
      };
    },
    addSubBoxArrays: function(o) {
      if (o) {
        this.subBoxNames = o;
        for (var u = o.length, f = 0; f < u; f++)
          this[o[f] + "s"] = [];
      }
    },
    createContainerBoxCtor: function(o, u, f) {
      l[o + "Box"] = function(p) {
        l.ContainerBox.call(this, o, p), l.addSubBoxArrays.call(this, f);
      }, l[o + "Box"].prototype = new l.ContainerBox(), u && (l[o + "Box"].prototype.parse = u);
    },
    createMediaSampleEntryCtor: function(o, u, f) {
      l.sampleEntryCodes[o] = [], l[o + "SampleEntry"] = function(p, g) {
        l.SampleEntry.call(this, p, g), l.addSubBoxArrays.call(this, f);
      }, l[o + "SampleEntry"].prototype = new l.SampleEntry(), u && (l[o + "SampleEntry"].prototype.parse = u);
    },
    createSampleEntryCtor: function(o, u, f, p) {
      l.sampleEntryCodes[o].push(u), l[u + "SampleEntry"] = function(g) {
        l[o + "SampleEntry"].call(this, u, g), l.addSubBoxArrays.call(this, p);
      }, l[u + "SampleEntry"].prototype = new l[o + "SampleEntry"](), f && (l[u + "SampleEntry"].prototype.parse = f);
    },
    createEncryptedSampleEntryCtor: function(o, u, f) {
      l.createSampleEntryCtor.call(this, o, u, f, ["sinf"]);
    },
    createSampleGroupCtor: function(o, u) {
      l[o + "SampleGroupEntry"] = function(f) {
        l.SampleGroupEntry.call(this, o, f);
      }, l[o + "SampleGroupEntry"].prototype = new l.SampleGroupEntry(), u && (l[o + "SampleGroupEntry"].prototype.parse = u);
    },
    createTrackGroupCtor: function(o, u) {
      l[o + "TrackGroupTypeBox"] = function(f) {
        l.TrackGroupTypeBox.call(this, o, f);
      }, l[o + "TrackGroupTypeBox"].prototype = new l.TrackGroupTypeBox(), u && (l[o + "TrackGroupTypeBox"].prototype.parse = u);
    },
    createUUIDBox: function(o, u, f, p) {
      l.UUIDs.push(o), l.UUIDBoxes[o] = function(g) {
        u ? l.FullBox.call(this, "uuid", g, o) : f ? l.ContainerBox.call(this, "uuid", g, o) : l.Box.call(this, "uuid", g, o);
      }, l.UUIDBoxes[o].prototype = u ? new l.FullBox() : f ? new l.ContainerBox() : new l.Box(), p && (u ? l.UUIDBoxes[o].prototype.parse = function(g) {
        this.parseFullHeader(g), p && p.call(this, g);
      } : l.UUIDBoxes[o].prototype.parse = p);
    }
  };
  l.initialize(), l.TKHD_FLAG_ENABLED = 1, l.TKHD_FLAG_IN_MOVIE = 2, l.TKHD_FLAG_IN_PREVIEW = 4, l.TFHD_FLAG_BASE_DATA_OFFSET = 1, l.TFHD_FLAG_SAMPLE_DESC = 2, l.TFHD_FLAG_SAMPLE_DUR = 8, l.TFHD_FLAG_SAMPLE_SIZE = 16, l.TFHD_FLAG_SAMPLE_FLAGS = 32, l.TFHD_FLAG_DUR_EMPTY = 65536, l.TFHD_FLAG_DEFAULT_BASE_IS_MOOF = 131072, l.TRUN_FLAGS_DATA_OFFSET = 1, l.TRUN_FLAGS_FIRST_FLAG = 4, l.TRUN_FLAGS_DURATION = 256, l.TRUN_FLAGS_SIZE = 512, l.TRUN_FLAGS_FLAGS = 1024, l.TRUN_FLAGS_CTS_OFFSET = 2048, l.Box.prototype.add = function(o) {
    return this.addBox(new l[o + "Box"]());
  }, l.Box.prototype.addBox = function(o) {
    return this.boxes.push(o), this[o.type + "s"] ? this[o.type + "s"].push(o) : this[o.type] = o, o;
  }, l.Box.prototype.set = function(o, u) {
    return this[o] = u, this;
  }, l.Box.prototype.addEntry = function(o, u) {
    var f = u || "entries";
    return this[f] || (this[f] = []), this[f].push(o), this;
  }, n.BoxParser = l, l.parseUUID = function(o) {
    return l.parseHex16(o);
  }, l.parseHex16 = function(o) {
    for (var u = "", f = 0; f < 16; f++) {
      var p = o.readUint8().toString(16);
      u += p.length === 1 ? "0" + p : p;
    }
    return u;
  }, l.parseOneBox = function(o, u, f) {
    var p, g = o.getPosition(), S = 0, x, E;
    if (o.getEndPosition() - g < 8)
      return e.debug("BoxParser", "Not enough data in stream to parse the type and size of the box"), { code: l.ERR_NOT_ENOUGH_DATA };
    if (f && f < 8)
      return e.debug("BoxParser", "Not enough bytes left in the parent box to parse a new box"), { code: l.ERR_NOT_ENOUGH_DATA };
    var k = o.readUint32(), R = o.readString(4), O = R;
    if (e.debug("BoxParser", "Found box of type '" + R + "' and size " + k + " at position " + g), S = 8, R == "uuid") {
      if (o.getEndPosition() - o.getPosition() < 16 || f - S < 16)
        return o.seek(g), e.debug("BoxParser", "Not enough bytes left in the parent box to parse a UUID box"), { code: l.ERR_NOT_ENOUGH_DATA };
      E = l.parseUUID(o), S += 16, O = E;
    }
    if (k == 1) {
      if (o.getEndPosition() - o.getPosition() < 8 || f && f - S < 8)
        return o.seek(g), e.warn("BoxParser", 'Not enough data in stream to parse the extended size of the "' + R + '" box'), { code: l.ERR_NOT_ENOUGH_DATA };
      k = o.readUint64(), S += 8;
    } else if (k === 0) {
      if (f)
        k = f;
      else if (R !== "mdat")
        return e.error("BoxParser", "Unlimited box size not supported for type: '" + R + "'"), p = new l.Box(R, k), { code: l.OK, box: p, size: p.size };
    }
    return k !== 0 && k < S ? (e.error("BoxParser", "Box of type " + R + " has an invalid size " + k + " (too small to be a box)"), { code: l.ERR_NOT_ENOUGH_DATA, type: R, size: k, hdr_size: S, start: g }) : k !== 0 && f && k > f ? (e.error("BoxParser", "Box of type '" + R + "' has a size " + k + " greater than its container size " + f), { code: l.ERR_NOT_ENOUGH_DATA, type: R, size: k, hdr_size: S, start: g }) : k !== 0 && g + k > o.getEndPosition() ? (o.seek(g), e.info("BoxParser", "Not enough data in stream to parse the entire '" + R + "' box"), { code: l.ERR_NOT_ENOUGH_DATA, type: R, size: k, hdr_size: S, start: g }) : u ? { code: l.OK, type: R, size: k, hdr_size: S, start: g } : (l[R + "Box"] ? p = new l[R + "Box"](k) : R !== "uuid" ? (e.warn("BoxParser", "Unknown box type: '" + R + "'"), p = new l.Box(R, k), p.has_unparsed_data = !0) : l.UUIDBoxes[E] ? p = new l.UUIDBoxes[E](k) : (e.warn("BoxParser", "Unknown uuid type: '" + E + "'"), p = new l.Box(R, k), p.uuid = E, p.has_unparsed_data = !0), p.hdr_size = S, p.start = g, p.write === l.Box.prototype.write && p.type !== "mdat" && (e.info("BoxParser", "'" + O + "' box writing not yet implemented, keeping unparsed data in memory for later write"), p.parseDataAndRewind(o)), p.parse(o), x = o.getPosition() - (p.start + p.size), x < 0 ? (e.warn("BoxParser", "Parsing of box '" + O + "' did not read the entire indicated box data size (missing " + -x + " bytes), seeking forward"), o.seek(p.start + p.size)) : x > 0 && (e.error("BoxParser", "Parsing of box '" + O + "' read " + x + " more bytes than the indicated box data size, seeking backwards"), p.size !== 0 && o.seek(p.start + p.size)), { code: l.OK, box: p, size: p.size });
  }, l.Box.prototype.parse = function(o) {
    this.type != "mdat" ? this.data = o.readUint8Array(this.size - this.hdr_size) : this.size === 0 ? o.seek(o.getEndPosition()) : o.seek(this.start + this.size);
  }, l.Box.prototype.parseDataAndRewind = function(o) {
    this.data = o.readUint8Array(this.size - this.hdr_size), o.position -= this.size - this.hdr_size;
  }, l.FullBox.prototype.parseDataAndRewind = function(o) {
    this.parseFullHeader(o), this.data = o.readUint8Array(this.size - this.hdr_size), this.hdr_size -= 4, o.position -= this.size - this.hdr_size;
  }, l.FullBox.prototype.parseFullHeader = function(o) {
    this.version = o.readUint8(), this.flags = o.readUint24(), this.hdr_size += 4;
  }, l.FullBox.prototype.parse = function(o) {
    this.parseFullHeader(o), this.data = o.readUint8Array(this.size - this.hdr_size);
  }, l.ContainerBox.prototype.parse = function(o) {
    for (var u, f; o.getPosition() < this.start + this.size; )
      if (u = l.parseOneBox(o, !1, this.size - (o.getPosition() - this.start)), u.code === l.OK)
        if (f = u.box, this.boxes.push(f), this.subBoxNames && this.subBoxNames.indexOf(f.type) != -1)
          this[this.subBoxNames[this.subBoxNames.indexOf(f.type)] + "s"].push(f);
        else {
          var p = f.type !== "uuid" ? f.type : f.uuid;
          this[p] ? e.warn("Box of type " + p + " already stored in field of this type") : this[p] = f;
        }
      else
        return;
  }, l.Box.prototype.parseLanguage = function(o) {
    this.language = o.readUint16();
    var u = [];
    u[0] = this.language >> 10 & 31, u[1] = this.language >> 5 & 31, u[2] = this.language & 31, this.languageString = String.fromCharCode(u[0] + 96, u[1] + 96, u[2] + 96);
  }, l.SAMPLE_ENTRY_TYPE_VISUAL = "Visual", l.SAMPLE_ENTRY_TYPE_AUDIO = "Audio", l.SAMPLE_ENTRY_TYPE_HINT = "Hint", l.SAMPLE_ENTRY_TYPE_METADATA = "Metadata", l.SAMPLE_ENTRY_TYPE_SUBTITLE = "Subtitle", l.SAMPLE_ENTRY_TYPE_SYSTEM = "System", l.SAMPLE_ENTRY_TYPE_TEXT = "Text", l.SampleEntry.prototype.parseHeader = function(o) {
    o.readUint8Array(6), this.data_reference_index = o.readUint16(), this.hdr_size += 8;
  }, l.SampleEntry.prototype.parse = function(o) {
    this.parseHeader(o), this.data = o.readUint8Array(this.size - this.hdr_size);
  }, l.SampleEntry.prototype.parseDataAndRewind = function(o) {
    this.parseHeader(o), this.data = o.readUint8Array(this.size - this.hdr_size), this.hdr_size -= 8, o.position -= this.size - this.hdr_size;
  }, l.SampleEntry.prototype.parseFooter = function(o) {
    l.ContainerBox.prototype.parse.call(this, o);
  }, l.createMediaSampleEntryCtor(l.SAMPLE_ENTRY_TYPE_HINT), l.createMediaSampleEntryCtor(l.SAMPLE_ENTRY_TYPE_METADATA), l.createMediaSampleEntryCtor(l.SAMPLE_ENTRY_TYPE_SUBTITLE), l.createMediaSampleEntryCtor(l.SAMPLE_ENTRY_TYPE_SYSTEM), l.createMediaSampleEntryCtor(l.SAMPLE_ENTRY_TYPE_TEXT), l.createMediaSampleEntryCtor(l.SAMPLE_ENTRY_TYPE_VISUAL, function(o) {
    var u;
    this.parseHeader(o), o.readUint16(), o.readUint16(), o.readUint32Array(3), this.width = o.readUint16(), this.height = o.readUint16(), this.horizresolution = o.readUint32(), this.vertresolution = o.readUint32(), o.readUint32(), this.frame_count = o.readUint16(), u = Math.min(31, o.readUint8()), this.compressorname = o.readString(u), u < 31 && o.readString(31 - u), this.depth = o.readUint16(), o.readUint16(), this.parseFooter(o);
  }), l.createMediaSampleEntryCtor(l.SAMPLE_ENTRY_TYPE_AUDIO, function(o) {
    this.parseHeader(o), o.readUint32Array(2), this.channel_count = o.readUint16(), this.samplesize = o.readUint16(), o.readUint16(), o.readUint16(), this.samplerate = o.readUint32() / 65536, this.parseFooter(o);
  }), l.createSampleEntryCtor(l.SAMPLE_ENTRY_TYPE_VISUAL, "avc1"), l.createSampleEntryCtor(l.SAMPLE_ENTRY_TYPE_VISUAL, "avc2"), l.createSampleEntryCtor(l.SAMPLE_ENTRY_TYPE_VISUAL, "avc3"), l.createSampleEntryCtor(l.SAMPLE_ENTRY_TYPE_VISUAL, "avc4"), l.createSampleEntryCtor(l.SAMPLE_ENTRY_TYPE_VISUAL, "av01"), l.createSampleEntryCtor(l.SAMPLE_ENTRY_TYPE_VISUAL, "dav1"), l.createSampleEntryCtor(l.SAMPLE_ENTRY_TYPE_VISUAL, "hvc1"), l.createSampleEntryCtor(l.SAMPLE_ENTRY_TYPE_VISUAL, "hev1"), l.createSampleEntryCtor(l.SAMPLE_ENTRY_TYPE_VISUAL, "hvt1"), l.createSampleEntryCtor(l.SAMPLE_ENTRY_TYPE_VISUAL, "lhe1"), l.createSampleEntryCtor(l.SAMPLE_ENTRY_TYPE_VISUAL, "dvh1"), l.createSampleEntryCtor(l.SAMPLE_ENTRY_TYPE_VISUAL, "dvhe"), l.createSampleEntryCtor(l.SAMPLE_ENTRY_TYPE_VISUAL, "vvc1"), l.createSampleEntryCtor(l.SAMPLE_ENTRY_TYPE_VISUAL, "vvi1"), l.createSampleEntryCtor(l.SAMPLE_ENTRY_TYPE_VISUAL, "vvs1"), l.createSampleEntryCtor(l.SAMPLE_ENTRY_TYPE_VISUAL, "vvcN"), l.createSampleEntryCtor(l.SAMPLE_ENTRY_TYPE_VISUAL, "vp08"), l.createSampleEntryCtor(l.SAMPLE_ENTRY_TYPE_VISUAL, "vp09"), l.createSampleEntryCtor(l.SAMPLE_ENTRY_TYPE_VISUAL, "avs3"), l.createSampleEntryCtor(l.SAMPLE_ENTRY_TYPE_VISUAL, "j2ki"), l.createSampleEntryCtor(l.SAMPLE_ENTRY_TYPE_VISUAL, "mjp2"), l.createSampleEntryCtor(l.SAMPLE_ENTRY_TYPE_VISUAL, "mjpg"), l.createSampleEntryCtor(l.SAMPLE_ENTRY_TYPE_VISUAL, "uncv"), l.createSampleEntryCtor(l.SAMPLE_ENTRY_TYPE_AUDIO, "mp4a"), l.createSampleEntryCtor(l.SAMPLE_ENTRY_TYPE_AUDIO, "ac-3"), l.createSampleEntryCtor(l.SAMPLE_ENTRY_TYPE_AUDIO, "ac-4"), l.createSampleEntryCtor(l.SAMPLE_ENTRY_TYPE_AUDIO, "ec-3"), l.createSampleEntryCtor(l.SAMPLE_ENTRY_TYPE_AUDIO, "Opus"), l.createSampleEntryCtor(l.SAMPLE_ENTRY_TYPE_AUDIO, "mha1"), l.createSampleEntryCtor(l.SAMPLE_ENTRY_TYPE_AUDIO, "mha2"), l.createSampleEntryCtor(l.SAMPLE_ENTRY_TYPE_AUDIO, "mhm1"), l.createSampleEntryCtor(l.SAMPLE_ENTRY_TYPE_AUDIO, "mhm2"), l.createSampleEntryCtor(l.SAMPLE_ENTRY_TYPE_AUDIO, "fLaC"), l.createEncryptedSampleEntryCtor(l.SAMPLE_ENTRY_TYPE_VISUAL, "encv"), l.createEncryptedSampleEntryCtor(l.SAMPLE_ENTRY_TYPE_AUDIO, "enca"), l.createEncryptedSampleEntryCtor(l.SAMPLE_ENTRY_TYPE_SUBTITLE, "encu"), l.createEncryptedSampleEntryCtor(l.SAMPLE_ENTRY_TYPE_SYSTEM, "encs"), l.createEncryptedSampleEntryCtor(l.SAMPLE_ENTRY_TYPE_TEXT, "enct"), l.createEncryptedSampleEntryCtor(l.SAMPLE_ENTRY_TYPE_METADATA, "encm"), l.createBoxCtor("a1lx", function(o) {
    var u = o.readUint8() & 1, f = ((u & 1) + 1) * 16;
    this.layer_size = [];
    for (var p = 0; p < 3; p++)
      f == 16 ? this.layer_size[p] = o.readUint16() : this.layer_size[p] = o.readUint32();
  }), l.createBoxCtor("a1op", function(o) {
    this.op_index = o.readUint8();
  }), l.createFullBoxCtor("auxC", function(o) {
    this.aux_type = o.readCString();
    var u = this.size - this.hdr_size - (this.aux_type.length + 1);
    this.aux_subtype = o.readUint8Array(u);
  }), l.createBoxCtor("av1C", function(o) {
    var u = o.readUint8();
    if (u >> 7 & !1) {
      e.error("av1C marker problem");
      return;
    }
    if (this.version = u & 127, this.version !== 1) {
      e.error("av1C version " + this.version + " not supported");
      return;
    }
    if (u = o.readUint8(), this.seq_profile = u >> 5 & 7, this.seq_level_idx_0 = u & 31, u = o.readUint8(), this.seq_tier_0 = u >> 7 & 1, this.high_bitdepth = u >> 6 & 1, this.twelve_bit = u >> 5 & 1, this.monochrome = u >> 4 & 1, this.chroma_subsampling_x = u >> 3 & 1, this.chroma_subsampling_y = u >> 2 & 1, this.chroma_sample_position = u & 3, u = o.readUint8(), this.reserved_1 = u >> 5 & 7, this.reserved_1 !== 0) {
      e.error("av1C reserved_1 parsing problem");
      return;
    }
    if (this.initial_presentation_delay_present = u >> 4 & 1, this.initial_presentation_delay_present === 1)
      this.initial_presentation_delay_minus_one = u & 15;
    else if (this.reserved_2 = u & 15, this.reserved_2 !== 0) {
      e.error("av1C reserved_2 parsing problem");
      return;
    }
    var f = this.size - this.hdr_size - 4;
    this.configOBUs = o.readUint8Array(f);
  }), l.createBoxCtor("avcC", function(o) {
    var u, f;
    for (this.configurationVersion = o.readUint8(), this.AVCProfileIndication = o.readUint8(), this.profile_compatibility = o.readUint8(), this.AVCLevelIndication = o.readUint8(), this.lengthSizeMinusOne = o.readUint8() & 3, this.nb_SPS_nalus = o.readUint8() & 31, f = this.size - this.hdr_size - 6, this.SPS = [], u = 0; u < this.nb_SPS_nalus; u++)
      this.SPS[u] = {}, this.SPS[u].length = o.readUint16(), this.SPS[u].nalu = o.readUint8Array(this.SPS[u].length), f -= 2 + this.SPS[u].length;
    for (this.nb_PPS_nalus = o.readUint8(), f--, this.PPS = [], u = 0; u < this.nb_PPS_nalus; u++)
      this.PPS[u] = {}, this.PPS[u].length = o.readUint16(), this.PPS[u].nalu = o.readUint8Array(this.PPS[u].length), f -= 2 + this.PPS[u].length;
    f > 0 && (this.ext = o.readUint8Array(f));
  }), l.createBoxCtor("btrt", function(o) {
    this.bufferSizeDB = o.readUint32(), this.maxBitrate = o.readUint32(), this.avgBitrate = o.readUint32();
  }), l.createFullBoxCtor("ccst", function(o) {
    var u = o.readUint8();
    this.all_ref_pics_intra = (u & 128) == 128, this.intra_pred_used = (u & 64) == 64, this.max_ref_per_pic = (u & 63) >> 2, o.readUint24();
  }), l.createBoxCtor("cdef", function(o) {
    var u;
    for (this.channel_count = o.readUint16(), this.channel_indexes = [], this.channel_types = [], this.channel_associations = [], u = 0; u < this.channel_count; u++)
      this.channel_indexes.push(o.readUint16()), this.channel_types.push(o.readUint16()), this.channel_associations.push(o.readUint16());
  }), l.createBoxCtor("clap", function(o) {
    this.cleanApertureWidthN = o.readUint32(), this.cleanApertureWidthD = o.readUint32(), this.cleanApertureHeightN = o.readUint32(), this.cleanApertureHeightD = o.readUint32(), this.horizOffN = o.readUint32(), this.horizOffD = o.readUint32(), this.vertOffN = o.readUint32(), this.vertOffD = o.readUint32();
  }), l.createBoxCtor("clli", function(o) {
    this.max_content_light_level = o.readUint16(), this.max_pic_average_light_level = o.readUint16();
  }), l.createFullBoxCtor("cmex", function(o) {
    this.flags & 1 && (this.pos_x = o.readInt32()), this.flags & 2 && (this.pos_y = o.readInt32()), this.flags & 4 && (this.pos_z = o.readInt32()), this.flags & 8 && (this.version == 0 ? this.flags & 16 ? (this.quat_x = o.readInt32(), this.quat_y = o.readInt32(), this.quat_z = o.readInt32()) : (this.quat_x = o.readInt16(), this.quat_y = o.readInt16(), this.quat_z = o.readInt16()) : this.version == 1), this.flags & 32 && (this.id = o.readUint32());
  }), l.createFullBoxCtor("cmin", function(o) {
    this.focal_length_x = o.readInt32(), this.principal_point_x = o.readInt32(), this.principal_point_y = o.readInt32(), this.flags & 1 && (this.focal_length_y = o.readInt32(), this.skew_factor = o.readInt32());
  }), l.createBoxCtor("cmpd", function(o) {
    for (this.component_count = o.readUint32(), this.component_types = [], this.component_type_urls = [], i = 0; i < this.component_count; i++) {
      var u = o.readUint16();
      this.component_types.push(u), u >= 32768 && this.component_type_urls.push(o.readCString());
    }
  }), l.createFullBoxCtor("co64", function(o) {
    var u, f;
    if (u = o.readUint32(), this.chunk_offsets = [], this.version === 0)
      for (f = 0; f < u; f++)
        this.chunk_offsets.push(o.readUint64());
  }), l.createFullBoxCtor("CoLL", function(o) {
    this.maxCLL = o.readUint16(), this.maxFALL = o.readUint16();
  }), l.createBoxCtor("colr", function(o) {
    if (this.colour_type = o.readString(4), this.colour_type === "nclx") {
      this.colour_primaries = o.readUint16(), this.transfer_characteristics = o.readUint16(), this.matrix_coefficients = o.readUint16();
      var u = o.readUint8();
      this.full_range_flag = u >> 7;
    } else
      this.colour_type === "rICC" ? this.ICC_profile = o.readUint8Array(this.size - 4) : this.colour_type === "prof" && (this.ICC_profile = o.readUint8Array(this.size - 4));
  }), l.createFullBoxCtor("cprt", function(o) {
    this.parseLanguage(o), this.notice = o.readCString();
  }), l.createFullBoxCtor("cslg", function(o) {
    this.version === 0 && (this.compositionToDTSShift = o.readInt32(), this.leastDecodeToDisplayDelta = o.readInt32(), this.greatestDecodeToDisplayDelta = o.readInt32(), this.compositionStartTime = o.readInt32(), this.compositionEndTime = o.readInt32());
  }), l.createFullBoxCtor("ctts", function(o) {
    var u, f;
    if (u = o.readUint32(), this.sample_counts = [], this.sample_offsets = [], this.version === 0)
      for (f = 0; f < u; f++) {
        this.sample_counts.push(o.readUint32());
        var p = o.readInt32();
        p < 0 && e.warn("BoxParser", "ctts box uses negative values without using version 1"), this.sample_offsets.push(p);
      }
    else if (this.version == 1)
      for (f = 0; f < u; f++)
        this.sample_counts.push(o.readUint32()), this.sample_offsets.push(o.readInt32());
  }), l.createBoxCtor("dac3", function(o) {
    var u = o.readUint8(), f = o.readUint8(), p = o.readUint8();
    this.fscod = u >> 6, this.bsid = u >> 1 & 31, this.bsmod = (u & 1) << 2 | f >> 6 & 3, this.acmod = f >> 3 & 7, this.lfeon = f >> 2 & 1, this.bit_rate_code = f & 3 | p >> 5 & 7;
  }), l.createBoxCtor("dec3", function(o) {
    var u = o.readUint16();
    this.data_rate = u >> 3, this.num_ind_sub = u & 7, this.ind_subs = [];
    for (var f = 0; f < this.num_ind_sub + 1; f++) {
      var p = {};
      this.ind_subs.push(p);
      var g = o.readUint8(), S = o.readUint8(), x = o.readUint8();
      p.fscod = g >> 6, p.bsid = g >> 1 & 31, p.bsmod = (g & 1) << 4 | S >> 4 & 15, p.acmod = S >> 1 & 7, p.lfeon = S & 1, p.num_dep_sub = x >> 1 & 15, p.num_dep_sub > 0 && (p.chan_loc = (x & 1) << 8 | o.readUint8());
    }
  }), l.createFullBoxCtor("dfLa", function(o) {
    var u = 127, f = 128, p = [], g = [
      "STREAMINFO",
      "PADDING",
      "APPLICATION",
      "SEEKTABLE",
      "VORBIS_COMMENT",
      "CUESHEET",
      "PICTURE",
      "RESERVED"
    ];
    do {
      var S = o.readUint8(), x = Math.min(
        S & u,
        g.length - 1
      );
      if (x ? o.readUint8Array(o.readUint24()) : (o.readUint8Array(13), this.samplerate = o.readUint32() >> 12, o.readUint8Array(20)), p.push(g[x]), S & f)
        break;
    } while (!0);
    this.numMetadataBlocks = p.length + " (" + p.join(", ") + ")";
  }), l.createBoxCtor("dimm", function(o) {
    this.bytessent = o.readUint64();
  }), l.createBoxCtor("dmax", function(o) {
    this.time = o.readUint32();
  }), l.createBoxCtor("dmed", function(o) {
    this.bytessent = o.readUint64();
  }), l.createBoxCtor("dOps", function(o) {
    if (this.Version = o.readUint8(), this.OutputChannelCount = o.readUint8(), this.PreSkip = o.readUint16(), this.InputSampleRate = o.readUint32(), this.OutputGain = o.readInt16(), this.ChannelMappingFamily = o.readUint8(), this.ChannelMappingFamily !== 0) {
      this.StreamCount = o.readUint8(), this.CoupledCount = o.readUint8(), this.ChannelMapping = [];
      for (var u = 0; u < this.OutputChannelCount; u++)
        this.ChannelMapping[u] = o.readUint8();
    }
  }), l.createFullBoxCtor("dref", function(o) {
    var u, f;
    this.entries = [];
    for (var p = o.readUint32(), g = 0; g < p; g++)
      if (u = l.parseOneBox(o, !1, this.size - (o.getPosition() - this.start)), u.code === l.OK)
        f = u.box, this.entries.push(f);
      else
        return;
  }), l.createBoxCtor("drep", function(o) {
    this.bytessent = o.readUint64();
  }), l.createFullBoxCtor("elng", function(o) {
    this.extended_language = o.readString(this.size - this.hdr_size);
  }), l.createFullBoxCtor("elst", function(o) {
    this.entries = [];
    for (var u = o.readUint32(), f = 0; f < u; f++) {
      var p = {};
      this.entries.push(p), this.version === 1 ? (p.segment_duration = o.readUint64(), p.media_time = o.readInt64()) : (p.segment_duration = o.readUint32(), p.media_time = o.readInt32()), p.media_rate_integer = o.readInt16(), p.media_rate_fraction = o.readInt16();
    }
  }), l.createFullBoxCtor("emsg", function(o) {
    this.version == 1 ? (this.timescale = o.readUint32(), this.presentation_time = o.readUint64(), this.event_duration = o.readUint32(), this.id = o.readUint32(), this.scheme_id_uri = o.readCString(), this.value = o.readCString()) : (this.scheme_id_uri = o.readCString(), this.value = o.readCString(), this.timescale = o.readUint32(), this.presentation_time_delta = o.readUint32(), this.event_duration = o.readUint32(), this.id = o.readUint32());
    var u = this.size - this.hdr_size - (4 * 4 + (this.scheme_id_uri.length + 1) + (this.value.length + 1));
    this.version == 1 && (u -= 4), this.message_data = o.readUint8Array(u);
  }), l.createEntityToGroupCtor = function(o, u) {
    l[o + "Box"] = function(f) {
      l.FullBox.call(this, o, f);
    }, l[o + "Box"].prototype = new l.FullBox(), l[o + "Box"].prototype.parse = function(f) {
      if (this.parseFullHeader(f), u)
        u.call(this, f);
      else
        for (this.group_id = f.readUint32(), this.num_entities_in_group = f.readUint32(), this.entity_ids = [], i = 0; i < this.num_entities_in_group; i++) {
          var p = f.readUint32();
          this.entity_ids.push(p);
        }
    };
  }, l.createEntityToGroupCtor("aebr"), l.createEntityToGroupCtor("afbr"), l.createEntityToGroupCtor("albc"), l.createEntityToGroupCtor("altr"), l.createEntityToGroupCtor("brst"), l.createEntityToGroupCtor("dobr"), l.createEntityToGroupCtor("eqiv"), l.createEntityToGroupCtor("favc"), l.createEntityToGroupCtor("fobr"), l.createEntityToGroupCtor("iaug"), l.createEntityToGroupCtor("pano"), l.createEntityToGroupCtor("slid"), l.createEntityToGroupCtor("ster"), l.createEntityToGroupCtor("tsyn"), l.createEntityToGroupCtor("wbbr"), l.createEntityToGroupCtor("prgr"), l.createEntityToGroupCtor("pymd", function(o) {
    this.group_id = o.readUint32(), this.num_entities_in_group = o.readUint32(), this.entity_ids = [];
    for (var u = 0; u < this.num_entities_in_group; u++) {
      var f = o.readUint32();
      this.entity_ids.push(f);
    }
    for (this.tile_size_x = o.readUint16(), this.tile_size_y = o.readUint16(), this.layer_binning = [], this.tiles_in_layer_column_minus1 = [], this.tiles_in_layer_row_minus1 = [], u = 0; u < this.num_entities_in_group; u++)
      this.layer_binning[u] = o.readUint16(), this.tiles_in_layer_row_minus1[u] = o.readUint16(), this.tiles_in_layer_column_minus1[u] = o.readUint16();
  }), l.createFullBoxCtor("esds", function(o) {
    var u = o.readUint8Array(this.size - this.hdr_size);
    if (typeof c < "u") {
      var f = new c();
      this.esd = f.parseOneDescriptor(new s(u.buffer, 0, s.BIG_ENDIAN));
    }
  }), l.createBoxCtor("fiel", function(o) {
    this.fieldCount = o.readUint8(), this.fieldOrdering = o.readUint8();
  }), l.createBoxCtor("frma", function(o) {
    this.data_format = o.readString(4);
  }), l.createBoxCtor("ftyp", function(o) {
    var u = this.size - this.hdr_size;
    this.major_brand = o.readString(4), this.minor_version = o.readUint32(), u -= 8, this.compatible_brands = [];
    for (var f = 0; u >= 4; )
      this.compatible_brands[f] = o.readString(4), u -= 4, f++;
  }), l.createFullBoxCtor("hdlr", function(o) {
    this.version === 0 && (o.readUint32(), this.handler = o.readString(4), o.readUint32Array(3), this.name = o.readString(this.size - this.hdr_size - 20), this.name[this.name.length - 1] === "\0" && (this.name = this.name.slice(0, -1)));
  }), l.createBoxCtor("hvcC", function(o) {
    var u, f, p, g;
    this.configurationVersion = o.readUint8(), g = o.readUint8(), this.general_profile_space = g >> 6, this.general_tier_flag = (g & 32) >> 5, this.general_profile_idc = g & 31, this.general_profile_compatibility = o.readUint32(), this.general_constraint_indicator = o.readUint8Array(6), this.general_level_idc = o.readUint8(), this.min_spatial_segmentation_idc = o.readUint16() & 4095, this.parallelismType = o.readUint8() & 3, this.chroma_format_idc = o.readUint8() & 3, this.bit_depth_luma_minus8 = o.readUint8() & 7, this.bit_depth_chroma_minus8 = o.readUint8() & 7, this.avgFrameRate = o.readUint16(), g = o.readUint8(), this.constantFrameRate = g >> 6, this.numTemporalLayers = (g & 13) >> 3, this.temporalIdNested = (g & 4) >> 2, this.lengthSizeMinusOne = g & 3, this.nalu_arrays = [];
    var S = o.readUint8();
    for (u = 0; u < S; u++) {
      var x = [];
      this.nalu_arrays.push(x), g = o.readUint8(), x.completeness = (g & 128) >> 7, x.nalu_type = g & 63;
      var E = o.readUint16();
      for (f = 0; f < E; f++) {
        var k = {};
        x.push(k), p = o.readUint16(), k.data = o.readUint8Array(p);
      }
    }
  }), l.createFullBoxCtor("iinf", function(o) {
    var u;
    this.version === 0 ? this.entry_count = o.readUint16() : this.entry_count = o.readUint32(), this.item_infos = [];
    for (var f = 0; f < this.entry_count; f++)
      if (u = l.parseOneBox(o, !1, this.size - (o.getPosition() - this.start)), u.code === l.OK)
        u.box.type !== "infe" && e.error("BoxParser", "Expected 'infe' box, got " + u.box.type), this.item_infos[f] = u.box;
      else
        return;
  }), l.createFullBoxCtor("iloc", function(o) {
    var u;
    u = o.readUint8(), this.offset_size = u >> 4 & 15, this.length_size = u & 15, u = o.readUint8(), this.base_offset_size = u >> 4 & 15, this.version === 1 || this.version === 2 ? this.index_size = u & 15 : this.index_size = 0, this.items = [];
    var f = 0;
    if (this.version < 2)
      f = o.readUint16();
    else if (this.version === 2)
      f = o.readUint32();
    else
      throw "version of iloc box not supported";
    for (var p = 0; p < f; p++) {
      var g = {};
      if (this.items.push(g), this.version < 2)
        g.item_ID = o.readUint16();
      else if (this.version === 2)
        g.item_ID = o.readUint32();
      else
        throw "version of iloc box not supported";
      switch (this.version === 1 || this.version === 2 ? g.construction_method = o.readUint16() & 15 : g.construction_method = 0, g.data_reference_index = o.readUint16(), this.base_offset_size) {
        case 0:
          g.base_offset = 0;
          break;
        case 4:
          g.base_offset = o.readUint32();
          break;
        case 8:
          g.base_offset = o.readUint64();
          break;
        default:
          throw "Error reading base offset size";
      }
      var S = o.readUint16();
      g.extents = [];
      for (var x = 0; x < S; x++) {
        var E = {};
        if (g.extents.push(E), this.version === 1 || this.version === 2)
          switch (this.index_size) {
            case 0:
              E.extent_index = 0;
              break;
            case 4:
              E.extent_index = o.readUint32();
              break;
            case 8:
              E.extent_index = o.readUint64();
              break;
            default:
              throw "Error reading extent index";
          }
        switch (this.offset_size) {
          case 0:
            E.extent_offset = 0;
            break;
          case 4:
            E.extent_offset = o.readUint32();
            break;
          case 8:
            E.extent_offset = o.readUint64();
            break;
          default:
            throw "Error reading extent index";
        }
        switch (this.length_size) {
          case 0:
            E.extent_length = 0;
            break;
          case 4:
            E.extent_length = o.readUint32();
            break;
          case 8:
            E.extent_length = o.readUint64();
            break;
          default:
            throw "Error reading extent index";
        }
      }
    }
  }), l.createBoxCtor("imir", function(o) {
    var u = o.readUint8();
    this.reserved = u >> 7, this.axis = u & 1;
  }), l.createFullBoxCtor("infe", function(o) {
    if ((this.version === 0 || this.version === 1) && (this.item_ID = o.readUint16(), this.item_protection_index = o.readUint16(), this.item_name = o.readCString(), this.content_type = o.readCString(), this.content_encoding = o.readCString()), this.version === 1) {
      this.extension_type = o.readString(4), e.warn("BoxParser", "Cannot parse extension type"), o.seek(this.start + this.size);
      return;
    }
    this.version >= 2 && (this.version === 2 ? this.item_ID = o.readUint16() : this.version === 3 && (this.item_ID = o.readUint32()), this.item_protection_index = o.readUint16(), this.item_type = o.readString(4), this.item_name = o.readCString(), this.item_type === "mime" ? (this.content_type = o.readCString(), this.content_encoding = o.readCString()) : this.item_type === "uri " && (this.item_uri_type = o.readCString()));
  }), l.createFullBoxCtor("ipma", function(o) {
    var u, f;
    for (entry_count = o.readUint32(), this.associations = [], u = 0; u < entry_count; u++) {
      var p = {};
      this.associations.push(p), this.version < 1 ? p.id = o.readUint16() : p.id = o.readUint32();
      var g = o.readUint8();
      for (p.props = [], f = 0; f < g; f++) {
        var S = o.readUint8(), x = {};
        p.props.push(x), x.essential = (S & 128) >> 7 === 1, this.flags & 1 ? x.property_index = (S & 127) << 8 | o.readUint8() : x.property_index = S & 127;
      }
    }
  }), l.createFullBoxCtor("iref", function(o) {
    var u, f;
    for (this.references = []; o.getPosition() < this.start + this.size; )
      if (u = l.parseOneBox(o, !0, this.size - (o.getPosition() - this.start)), u.code === l.OK)
        this.version === 0 ? f = new l.SingleItemTypeReferenceBox(u.type, u.size, u.hdr_size, u.start) : f = new l.SingleItemTypeReferenceBoxLarge(u.type, u.size, u.hdr_size, u.start), f.write === l.Box.prototype.write && f.type !== "mdat" && (e.warn("BoxParser", f.type + " box writing not yet implemented, keeping unparsed data in memory for later write"), f.parseDataAndRewind(o)), f.parse(o), this.references.push(f);
      else
        return;
  }), l.createBoxCtor("irot", function(o) {
    this.angle = o.readUint8() & 3;
  }), l.createFullBoxCtor("ispe", function(o) {
    this.image_width = o.readUint32(), this.image_height = o.readUint32();
  }), l.createFullBoxCtor("kind", function(o) {
    this.schemeURI = o.readCString(), this.value = o.readCString();
  }), l.createFullBoxCtor("leva", function(o) {
    var u = o.readUint8();
    this.levels = [];
    for (var f = 0; f < u; f++) {
      var p = {};
      this.levels[f] = p, p.track_ID = o.readUint32();
      var g = o.readUint8();
      switch (p.padding_flag = g >> 7, p.assignment_type = g & 127, p.assignment_type) {
        case 0:
          p.grouping_type = o.readString(4);
          break;
        case 1:
          p.grouping_type = o.readString(4), p.grouping_type_parameter = o.readUint32();
          break;
        case 2:
          break;
        case 3:
          break;
        case 4:
          p.sub_track_id = o.readUint32();
          break;
        default:
          e.warn("BoxParser", "Unknown leva assignement type");
      }
    }
  }), l.createBoxCtor("lhvC", function(o) {
    var u, f, p;
    this.configurationVersion = o.readUint8(), this.min_spatial_segmentation_idc = o.readUint16() & 4095, this.parallelismType = o.readUint8() & 3, p = o.readUint8(), this.numTemporalLayers = (p & 13) >> 3, this.temporalIdNested = (p & 4) >> 2, this.lengthSizeMinusOne = p & 3, this.nalu_arrays = [];
    var g = o.readUint8();
    for (u = 0; u < g; u++) {
      var S = [];
      this.nalu_arrays.push(S), p = o.readUint8(), S.completeness = (p & 128) >> 7, S.nalu_type = p & 63;
      var x = o.readUint16();
      for (f = 0; f < x; f++) {
        var E = {};
        S.push(E);
        var k = o.readUint16();
        E.data = o.readUint8Array(k);
      }
    }
  }), l.createBoxCtor("lsel", function(o) {
    this.layer_id = o.readUint16();
  }), l.createBoxCtor("maxr", function(o) {
    this.period = o.readUint32(), this.bytes = o.readUint32();
  });
  function d(o, u) {
    this.x = o, this.y = u;
  }
  d.prototype.toString = function() {
    return "(" + this.x + "," + this.y + ")";
  }, l.createBoxCtor("mdcv", function(o) {
    this.display_primaries = [], this.display_primaries[0] = new d(o.readUint16(), o.readUint16()), this.display_primaries[1] = new d(o.readUint16(), o.readUint16()), this.display_primaries[2] = new d(o.readUint16(), o.readUint16()), this.white_point = new d(o.readUint16(), o.readUint16()), this.max_display_mastering_luminance = o.readUint32(), this.min_display_mastering_luminance = o.readUint32();
  }), l.createFullBoxCtor("mdhd", function(o) {
    this.version == 1 ? (this.creation_time = o.readUint64(), this.modification_time = o.readUint64(), this.timescale = o.readUint32(), this.duration = o.readUint64()) : (this.creation_time = o.readUint32(), this.modification_time = o.readUint32(), this.timescale = o.readUint32(), this.duration = o.readUint32()), this.parseLanguage(o), o.readUint16();
  }), l.createFullBoxCtor("mehd", function(o) {
    this.flags & 1 && (e.warn("BoxParser", "mehd box incorrectly uses flags set to 1, converting version to 1"), this.version = 1), this.version == 1 ? this.fragment_duration = o.readUint64() : this.fragment_duration = o.readUint32();
  }), l.createFullBoxCtor("meta", function(o) {
    this.boxes = [], l.ContainerBox.prototype.parse.call(this, o);
  }), l.createFullBoxCtor("mfhd", function(o) {
    this.sequence_number = o.readUint32();
  }), l.createFullBoxCtor("mfro", function(o) {
    this._size = o.readUint32();
  }), l.createFullBoxCtor("mskC", function(o) {
    this.bits_per_pixel = o.readUint8();
  }), l.createFullBoxCtor("mvhd", function(o) {
    this.version == 1 ? (this.creation_time = o.readUint64(), this.modification_time = o.readUint64(), this.timescale = o.readUint32(), this.duration = o.readUint64()) : (this.creation_time = o.readUint32(), this.modification_time = o.readUint32(), this.timescale = o.readUint32(), this.duration = o.readUint32()), this.rate = o.readUint32(), this.volume = o.readUint16() >> 8, o.readUint16(), o.readUint32Array(2), this.matrix = o.readUint32Array(9), o.readUint32Array(6), this.next_track_id = o.readUint32();
  }), l.createBoxCtor("npck", function(o) {
    this.packetssent = o.readUint32();
  }), l.createBoxCtor("nump", function(o) {
    this.packetssent = o.readUint64();
  }), l.createFullBoxCtor("padb", function(o) {
    var u = o.readUint32();
    this.padbits = [];
    for (var f = 0; f < Math.floor((u + 1) / 2); f++)
      this.padbits = o.readUint8();
  }), l.createBoxCtor("pasp", function(o) {
    this.hSpacing = o.readUint32(), this.vSpacing = o.readUint32();
  }), l.createBoxCtor("payl", function(o) {
    this.text = o.readString(this.size - this.hdr_size);
  }), l.createBoxCtor("payt", function(o) {
    this.payloadID = o.readUint32();
    var u = o.readUint8();
    this.rtpmap_string = o.readString(u);
  }), l.createFullBoxCtor("pdin", function(o) {
    var u = (this.size - this.hdr_size) / 8;
    this.rate = [], this.initial_delay = [];
    for (var f = 0; f < u; f++)
      this.rate[f] = o.readUint32(), this.initial_delay[f] = o.readUint32();
  }), l.createFullBoxCtor("pitm", function(o) {
    this.version === 0 ? this.item_id = o.readUint16() : this.item_id = o.readUint32();
  }), l.createFullBoxCtor("pixi", function(o) {
    var u;
    for (this.num_channels = o.readUint8(), this.bits_per_channels = [], u = 0; u < this.num_channels; u++)
      this.bits_per_channels[u] = o.readUint8();
  }), l.createBoxCtor("pmax", function(o) {
    this.bytes = o.readUint32();
  }), l.createFullBoxCtor("prdi", function(o) {
    if (this.step_count = o.readUint16(), this.item_count = [], this.flags & 2)
      for (var u = 0; u < this.step_count; u++)
        this.item_count[u] = o.readUint16();
  }), l.createFullBoxCtor("prft", function(o) {
    this.ref_track_id = o.readUint32(), this.ntp_timestamp = o.readUint64(), this.version === 0 ? this.media_time = o.readUint32() : this.media_time = o.readUint64();
  }), l.createFullBoxCtor("pssh", function(o) {
    if (this.system_id = l.parseHex16(o), this.version > 0) {
      var u = o.readUint32();
      this.kid = [];
      for (var f = 0; f < u; f++)
        this.kid[f] = l.parseHex16(o);
    }
    var p = o.readUint32();
    p > 0 && (this.data = o.readUint8Array(p));
  }), l.createFullBoxCtor("clef", function(o) {
    this.width = o.readUint32(), this.height = o.readUint32();
  }), l.createFullBoxCtor("enof", function(o) {
    this.width = o.readUint32(), this.height = o.readUint32();
  }), l.createFullBoxCtor("prof", function(o) {
    this.width = o.readUint32(), this.height = o.readUint32();
  }), l.createContainerBoxCtor("tapt", null, ["clef", "prof", "enof"]), l.createBoxCtor("rtp ", function(o) {
    this.descriptionformat = o.readString(4), this.sdptext = o.readString(this.size - this.hdr_size - 4);
  }), l.createFullBoxCtor("saio", function(o) {
    this.flags & 1 && (this.aux_info_type = o.readString(4), this.aux_info_type_parameter = o.readUint32());
    var u = o.readUint32();
    this.offset = [];
    for (var f = 0; f < u; f++)
      this.version === 0 ? this.offset[f] = o.readUint32() : this.offset[f] = o.readUint64();
  }), l.createFullBoxCtor("saiz", function(o) {
    if (this.flags & 1 && (this.aux_info_type = o.readString(4), this.aux_info_type_parameter = o.readUint32()), this.default_sample_info_size = o.readUint8(), this.sample_count = o.readUint32(), this.sample_info_size = [], this.default_sample_info_size === 0)
      for (var u = 0; u < this.sample_count; u++)
        this.sample_info_size[u] = o.readUint8();
  }), l.createSampleEntryCtor(l.SAMPLE_ENTRY_TYPE_METADATA, "mett", function(o) {
    this.parseHeader(o), this.content_encoding = o.readCString(), this.mime_format = o.readCString(), this.parseFooter(o);
  }), l.createSampleEntryCtor(l.SAMPLE_ENTRY_TYPE_METADATA, "metx", function(o) {
    this.parseHeader(o), this.content_encoding = o.readCString(), this.namespace = o.readCString(), this.schema_location = o.readCString(), this.parseFooter(o);
  }), l.createSampleEntryCtor(l.SAMPLE_ENTRY_TYPE_SUBTITLE, "sbtt", function(o) {
    this.parseHeader(o), this.content_encoding = o.readCString(), this.mime_format = o.readCString(), this.parseFooter(o);
  }), l.createSampleEntryCtor(l.SAMPLE_ENTRY_TYPE_SUBTITLE, "stpp", function(o) {
    this.parseHeader(o), this.namespace = o.readCString(), this.schema_location = o.readCString(), this.auxiliary_mime_types = o.readCString(), this.parseFooter(o);
  }), l.createSampleEntryCtor(l.SAMPLE_ENTRY_TYPE_SUBTITLE, "stxt", function(o) {
    this.parseHeader(o), this.content_encoding = o.readCString(), this.mime_format = o.readCString(), this.parseFooter(o);
  }), l.createSampleEntryCtor(l.SAMPLE_ENTRY_TYPE_SUBTITLE, "tx3g", function(o) {
    this.parseHeader(o), this.displayFlags = o.readUint32(), this.horizontal_justification = o.readInt8(), this.vertical_justification = o.readInt8(), this.bg_color_rgba = o.readUint8Array(4), this.box_record = o.readInt16Array(4), this.style_record = o.readUint8Array(12), this.parseFooter(o);
  }), l.createSampleEntryCtor(l.SAMPLE_ENTRY_TYPE_METADATA, "wvtt", function(o) {
    this.parseHeader(o), this.parseFooter(o);
  }), l.createSampleGroupCtor("alst", function(o) {
    var u, f = o.readUint16();
    for (this.first_output_sample = o.readUint16(), this.sample_offset = [], u = 0; u < f; u++)
      this.sample_offset[u] = o.readUint32();
    var p = this.description_length - 4 - 4 * f;
    for (this.num_output_samples = [], this.num_total_samples = [], u = 0; u < p / 4; u++)
      this.num_output_samples[u] = o.readUint16(), this.num_total_samples[u] = o.readUint16();
  }), l.createSampleGroupCtor("avll", function(o) {
    this.layerNumber = o.readUint8(), this.accurateStatisticsFlag = o.readUint8(), this.avgBitRate = o.readUint16(), this.avgFrameRate = o.readUint16();
  }), l.createSampleGroupCtor("avss", function(o) {
    this.subSequenceIdentifier = o.readUint16(), this.layerNumber = o.readUint8();
    var u = o.readUint8();
    this.durationFlag = u >> 7, this.avgRateFlag = u >> 6 & 1, this.durationFlag && (this.duration = o.readUint32()), this.avgRateFlag && (this.accurateStatisticsFlag = o.readUint8(), this.avgBitRate = o.readUint16(), this.avgFrameRate = o.readUint16()), this.dependency = [];
    for (var f = o.readUint8(), p = 0; p < f; p++) {
      var g = {};
      this.dependency.push(g), g.subSeqDirectionFlag = o.readUint8(), g.layerNumber = o.readUint8(), g.subSequenceIdentifier = o.readUint16();
    }
  }), l.createSampleGroupCtor("dtrt", function(o) {
    e.warn("BoxParser", "Sample Group type: " + this.grouping_type + " not fully parsed");
  }), l.createSampleGroupCtor("mvif", function(o) {
    e.warn("BoxParser", "Sample Group type: " + this.grouping_type + " not fully parsed");
  }), l.createSampleGroupCtor("prol", function(o) {
    this.roll_distance = o.readInt16();
  }), l.createSampleGroupCtor("rap ", function(o) {
    var u = o.readUint8();
    this.num_leading_samples_known = u >> 7, this.num_leading_samples = u & 127;
  }), l.createSampleGroupCtor("rash", function(o) {
    if (this.operation_point_count = o.readUint16(), this.description_length !== 2 + (this.operation_point_count === 1 ? 2 : this.operation_point_count * 6) + 9)
      e.warn("BoxParser", "Mismatch in " + this.grouping_type + " sample group length"), this.data = o.readUint8Array(this.description_length - 2);
    else {
      if (this.operation_point_count === 1)
        this.target_rate_share = o.readUint16();
      else {
        this.target_rate_share = [], this.available_bitrate = [];
        for (var u = 0; u < this.operation_point_count; u++)
          this.available_bitrate[u] = o.readUint32(), this.target_rate_share[u] = o.readUint16();
      }
      this.maximum_bitrate = o.readUint32(), this.minimum_bitrate = o.readUint32(), this.discard_priority = o.readUint8();
    }
  }), l.createSampleGroupCtor("roll", function(o) {
    this.roll_distance = o.readInt16();
  }), l.SampleGroupEntry.prototype.parse = function(o) {
    e.warn("BoxParser", "Unknown Sample Group type: " + this.grouping_type), this.data = o.readUint8Array(this.description_length);
  }, l.createSampleGroupCtor("scif", function(o) {
    e.warn("BoxParser", "Sample Group type: " + this.grouping_type + " not fully parsed");
  }), l.createSampleGroupCtor("scnm", function(o) {
    e.warn("BoxParser", "Sample Group type: " + this.grouping_type + " not fully parsed");
  }), l.createSampleGroupCtor("seig", function(o) {
    this.reserved = o.readUint8();
    var u = o.readUint8();
    this.crypt_byte_block = u >> 4, this.skip_byte_block = u & 15, this.isProtected = o.readUint8(), this.Per_Sample_IV_Size = o.readUint8(), this.KID = l.parseHex16(o), this.constant_IV_size = 0, this.constant_IV = 0, this.isProtected === 1 && this.Per_Sample_IV_Size === 0 && (this.constant_IV_size = o.readUint8(), this.constant_IV = o.readUint8Array(this.constant_IV_size));
  }), l.createSampleGroupCtor("stsa", function(o) {
    e.warn("BoxParser", "Sample Group type: " + this.grouping_type + " not fully parsed");
  }), l.createSampleGroupCtor("sync", function(o) {
    var u = o.readUint8();
    this.NAL_unit_type = u & 63;
  }), l.createSampleGroupCtor("tele", function(o) {
    var u = o.readUint8();
    this.level_independently_decodable = u >> 7;
  }), l.createSampleGroupCtor("tsas", function(o) {
    e.warn("BoxParser", "Sample Group type: " + this.grouping_type + " not fully parsed");
  }), l.createSampleGroupCtor("tscl", function(o) {
    e.warn("BoxParser", "Sample Group type: " + this.grouping_type + " not fully parsed");
  }), l.createSampleGroupCtor("vipr", function(o) {
    e.warn("BoxParser", "Sample Group type: " + this.grouping_type + " not fully parsed");
  }), l.createFullBoxCtor("sbgp", function(o) {
    this.grouping_type = o.readString(4), this.version === 1 ? this.grouping_type_parameter = o.readUint32() : this.grouping_type_parameter = 0, this.entries = [];
    for (var u = o.readUint32(), f = 0; f < u; f++) {
      var p = {};
      this.entries.push(p), p.sample_count = o.readInt32(), p.group_description_index = o.readInt32();
    }
  });
  function h(o, u) {
    this.bad_pixel_row = o, this.bad_pixel_column = u;
  }
  h.prototype.toString = function() {
    return "[row: " + this.bad_pixel_row + ", column: " + this.bad_pixel_column + "]";
  }, l.createFullBoxCtor("sbpm", function(o) {
    var u;
    for (this.component_count = o.readUint16(), this.component_index = [], u = 0; u < this.component_count; u++)
      this.component_index.push(o.readUint16());
    var f = o.readUint8();
    for (this.correction_applied = (f & 128) == 128, this.num_bad_rows = o.readUint32(), this.num_bad_cols = o.readUint32(), this.num_bad_pixels = o.readUint32(), this.bad_rows = [], this.bad_columns = [], this.bad_pixels = [], u = 0; u < this.num_bad_rows; u++)
      this.bad_rows.push(o.readUint32());
    for (u = 0; u < this.num_bad_cols; u++)
      this.bad_columns.push(o.readUint32());
    for (u = 0; u < this.num_bad_pixels; u++) {
      var p = o.readUint32(), g = o.readUint32();
      this.bad_pixels.push(new h(p, g));
    }
  }), l.createFullBoxCtor("schm", function(o) {
    this.scheme_type = o.readString(4), this.scheme_version = o.readUint32(), this.flags & 1 && (this.scheme_uri = o.readString(this.size - this.hdr_size - 8));
  }), l.createBoxCtor("sdp ", function(o) {
    this.sdptext = o.readString(this.size - this.hdr_size);
  }), l.createFullBoxCtor("sdtp", function(o) {
    var u, f = this.size - this.hdr_size;
    this.is_leading = [], this.sample_depends_on = [], this.sample_is_depended_on = [], this.sample_has_redundancy = [];
    for (var p = 0; p < f; p++)
      u = o.readUint8(), this.is_leading[p] = u >> 6, this.sample_depends_on[p] = u >> 4 & 3, this.sample_is_depended_on[p] = u >> 2 & 3, this.sample_has_redundancy[p] = u & 3;
  }), l.createFullBoxCtor(
    "senc"
    /*, function(stream) {
    	this.parseFullHeader(stream);
    	var sample_count = stream.readUint32();
    	this.samples = [];
    	for (var i = 0; i < sample_count; i++) {
    		var sample = {};
    		// tenc.default_Per_Sample_IV_Size or seig.Per_Sample_IV_Size
    		sample.InitializationVector = this.readUint8Array(Per_Sample_IV_Size*8);
    		if (this.flags & 0x2) {
    			sample.subsamples = [];
    			subsample_count = stream.readUint16();
    			for (var j = 0; j < subsample_count; j++) {
    				var subsample = {};
    				subsample.BytesOfClearData = stream.readUint16();
    				subsample.BytesOfProtectedData = stream.readUint32();
    				sample.subsamples.push(subsample);
    			}
    		}
    		// TODO
    		this.samples.push(sample);
    	}
    }*/
  ), l.createFullBoxCtor("sgpd", function(o) {
    this.grouping_type = o.readString(4), e.debug("BoxParser", "Found Sample Groups of type " + this.grouping_type), this.version === 1 ? this.default_length = o.readUint32() : this.default_length = 0, this.version >= 2 && (this.default_group_description_index = o.readUint32()), this.entries = [];
    for (var u = o.readUint32(), f = 0; f < u; f++) {
      var p;
      l[this.grouping_type + "SampleGroupEntry"] ? p = new l[this.grouping_type + "SampleGroupEntry"](this.grouping_type) : p = new l.SampleGroupEntry(this.grouping_type), this.entries.push(p), this.version === 1 ? this.default_length === 0 ? p.description_length = o.readUint32() : p.description_length = this.default_length : p.description_length = this.default_length, p.write === l.SampleGroupEntry.prototype.write && (e.info("BoxParser", "SampleGroup for type " + this.grouping_type + " writing not yet implemented, keeping unparsed data in memory for later write"), p.data = o.readUint8Array(p.description_length), o.position -= p.description_length), p.parse(o);
    }
  }), l.createFullBoxCtor("sidx", function(o) {
    this.reference_ID = o.readUint32(), this.timescale = o.readUint32(), this.version === 0 ? (this.earliest_presentation_time = o.readUint32(), this.first_offset = o.readUint32()) : (this.earliest_presentation_time = o.readUint64(), this.first_offset = o.readUint64()), o.readUint16(), this.references = [];
    for (var u = o.readUint16(), f = 0; f < u; f++) {
      var p = {};
      this.references.push(p);
      var g = o.readUint32();
      p.reference_type = g >> 31 & 1, p.referenced_size = g & 2147483647, p.subsegment_duration = o.readUint32(), g = o.readUint32(), p.starts_with_SAP = g >> 31 & 1, p.SAP_type = g >> 28 & 7, p.SAP_delta_time = g & 268435455;
    }
  }), l.SingleItemTypeReferenceBox = function(o, u, f, p) {
    l.Box.call(this, o, u), this.hdr_size = f, this.start = p;
  }, l.SingleItemTypeReferenceBox.prototype = new l.Box(), l.SingleItemTypeReferenceBox.prototype.parse = function(o) {
    this.from_item_ID = o.readUint16();
    var u = o.readUint16();
    this.references = [];
    for (var f = 0; f < u; f++)
      this.references[f] = {}, this.references[f].to_item_ID = o.readUint16();
  }, l.SingleItemTypeReferenceBoxLarge = function(o, u, f, p) {
    l.Box.call(this, o, u), this.hdr_size = f, this.start = p;
  }, l.SingleItemTypeReferenceBoxLarge.prototype = new l.Box(), l.SingleItemTypeReferenceBoxLarge.prototype.parse = function(o) {
    this.from_item_ID = o.readUint32();
    var u = o.readUint16();
    this.references = [];
    for (var f = 0; f < u; f++)
      this.references[f] = {}, this.references[f].to_item_ID = o.readUint32();
  }, l.createFullBoxCtor("SmDm", function(o) {
    this.primaryRChromaticity_x = o.readUint16(), this.primaryRChromaticity_y = o.readUint16(), this.primaryGChromaticity_x = o.readUint16(), this.primaryGChromaticity_y = o.readUint16(), this.primaryBChromaticity_x = o.readUint16(), this.primaryBChromaticity_y = o.readUint16(), this.whitePointChromaticity_x = o.readUint16(), this.whitePointChromaticity_y = o.readUint16(), this.luminanceMax = o.readUint32(), this.luminanceMin = o.readUint32();
  }), l.createFullBoxCtor("smhd", function(o) {
    this.balance = o.readUint16(), o.readUint16();
  }), l.createFullBoxCtor("ssix", function(o) {
    this.subsegments = [];
    for (var u = o.readUint32(), f = 0; f < u; f++) {
      var p = {};
      this.subsegments.push(p), p.ranges = [];
      for (var g = o.readUint32(), S = 0; S < g; S++) {
        var x = {};
        p.ranges.push(x), x.level = o.readUint8(), x.range_size = o.readUint24();
      }
    }
  }), l.createFullBoxCtor("stco", function(o) {
    var u;
    if (u = o.readUint32(), this.chunk_offsets = [], this.version === 0)
      for (var f = 0; f < u; f++)
        this.chunk_offsets.push(o.readUint32());
  }), l.createFullBoxCtor("stdp", function(o) {
    var u = (this.size - this.hdr_size) / 2;
    this.priority = [];
    for (var f = 0; f < u; f++)
      this.priority[f] = o.readUint16();
  }), l.createFullBoxCtor("sthd"), l.createFullBoxCtor("stri", function(o) {
    this.switch_group = o.readUint16(), this.alternate_group = o.readUint16(), this.sub_track_id = o.readUint32();
    var u = (this.size - this.hdr_size - 8) / 4;
    this.attribute_list = [];
    for (var f = 0; f < u; f++)
      this.attribute_list[f] = o.readUint32();
  }), l.createFullBoxCtor("stsc", function(o) {
    var u, f;
    if (u = o.readUint32(), this.first_chunk = [], this.samples_per_chunk = [], this.sample_description_index = [], this.version === 0)
      for (f = 0; f < u; f++)
        this.first_chunk.push(o.readUint32()), this.samples_per_chunk.push(o.readUint32()), this.sample_description_index.push(o.readUint32());
  }), l.createFullBoxCtor("stsd", function(o) {
    var u, f, p, g;
    for (this.entries = [], p = o.readUint32(), u = 1; u <= p; u++)
      if (f = l.parseOneBox(o, !0, this.size - (o.getPosition() - this.start)), f.code === l.OK)
        l[f.type + "SampleEntry"] ? (g = new l[f.type + "SampleEntry"](f.size), g.hdr_size = f.hdr_size, g.start = f.start) : (e.warn("BoxParser", "Unknown sample entry type: " + f.type), g = new l.SampleEntry(f.type, f.size, f.hdr_size, f.start)), g.write === l.SampleEntry.prototype.write && (e.info("BoxParser", "SampleEntry " + g.type + " box writing not yet implemented, keeping unparsed data in memory for later write"), g.parseDataAndRewind(o)), g.parse(o), this.entries.push(g);
      else
        return;
  }), l.createFullBoxCtor("stsg", function(o) {
    this.grouping_type = o.readUint32();
    var u = o.readUint16();
    this.group_description_index = [];
    for (var f = 0; f < u; f++)
      this.group_description_index[f] = o.readUint32();
  }), l.createFullBoxCtor("stsh", function(o) {
    var u, f;
    if (u = o.readUint32(), this.shadowed_sample_numbers = [], this.sync_sample_numbers = [], this.version === 0)
      for (f = 0; f < u; f++)
        this.shadowed_sample_numbers.push(o.readUint32()), this.sync_sample_numbers.push(o.readUint32());
  }), l.createFullBoxCtor("stss", function(o) {
    var u, f;
    if (f = o.readUint32(), this.version === 0)
      for (this.sample_numbers = [], u = 0; u < f; u++)
        this.sample_numbers.push(o.readUint32());
  }), l.createFullBoxCtor("stsz", function(o) {
    var u;
    if (this.sample_sizes = [], this.version === 0)
      for (this.sample_size = o.readUint32(), this.sample_count = o.readUint32(), u = 0; u < this.sample_count; u++)
        this.sample_size === 0 ? this.sample_sizes.push(o.readUint32()) : this.sample_sizes[u] = this.sample_size;
  }), l.createFullBoxCtor("stts", function(o) {
    var u, f, p;
    if (u = o.readUint32(), this.sample_counts = [], this.sample_deltas = [], this.version === 0)
      for (f = 0; f < u; f++)
        this.sample_counts.push(o.readUint32()), p = o.readInt32(), p < 0 && (e.warn("BoxParser", "File uses negative stts sample delta, using value 1 instead, sync may be lost!"), p = 1), this.sample_deltas.push(p);
  }), l.createFullBoxCtor("stvi", function(o) {
    var u = o.readUint32();
    this.single_view_allowed = u & 3, this.stereo_scheme = o.readUint32();
    var f = o.readUint32();
    this.stereo_indication_type = o.readString(f);
    var p, g;
    for (this.boxes = []; o.getPosition() < this.start + this.size; )
      if (p = l.parseOneBox(o, !1, this.size - (o.getPosition() - this.start)), p.code === l.OK)
        g = p.box, this.boxes.push(g), this[g.type] = g;
      else
        return;
  }), l.createBoxCtor("styp", function(o) {
    l.ftypBox.prototype.parse.call(this, o);
  }), l.createFullBoxCtor("stz2", function(o) {
    var u, f;
    if (this.sample_sizes = [], this.version === 0)
      if (this.reserved = o.readUint24(), this.field_size = o.readUint8(), f = o.readUint32(), this.field_size === 4)
        for (u = 0; u < f; u += 2) {
          var p = o.readUint8();
          this.sample_sizes[u] = p >> 4 & 15, this.sample_sizes[u + 1] = p & 15;
        }
      else if (this.field_size === 8)
        for (u = 0; u < f; u++)
          this.sample_sizes[u] = o.readUint8();
      else if (this.field_size === 16)
        for (u = 0; u < f; u++)
          this.sample_sizes[u] = o.readUint16();
      else
        e.error("BoxParser", "Error in length field in stz2 box");
  }), l.createFullBoxCtor("subs", function(o) {
    var u, f, p, g;
    for (p = o.readUint32(), this.entries = [], u = 0; u < p; u++) {
      var S = {};
      if (this.entries[u] = S, S.sample_delta = o.readUint32(), S.subsamples = [], g = o.readUint16(), g > 0)
        for (f = 0; f < g; f++) {
          var x = {};
          S.subsamples.push(x), this.version == 1 ? x.size = o.readUint32() : x.size = o.readUint16(), x.priority = o.readUint8(), x.discardable = o.readUint8(), x.codec_specific_parameters = o.readUint32();
        }
    }
  }), l.createFullBoxCtor("tenc", function(o) {
    if (o.readUint8(), this.version === 0)
      o.readUint8();
    else {
      var u = o.readUint8();
      this.default_crypt_byte_block = u >> 4 & 15, this.default_skip_byte_block = u & 15;
    }
    this.default_isProtected = o.readUint8(), this.default_Per_Sample_IV_Size = o.readUint8(), this.default_KID = l.parseHex16(o), this.default_isProtected === 1 && this.default_Per_Sample_IV_Size === 0 && (this.default_constant_IV_size = o.readUint8(), this.default_constant_IV = o.readUint8Array(this.default_constant_IV_size));
  }), l.createFullBoxCtor("tfdt", function(o) {
    this.version == 1 ? this.baseMediaDecodeTime = o.readUint64() : this.baseMediaDecodeTime = o.readUint32();
  }), l.createFullBoxCtor("tfhd", function(o) {
    var u = 0;
    this.track_id = o.readUint32(), this.size - this.hdr_size > u && this.flags & l.TFHD_FLAG_BASE_DATA_OFFSET ? (this.base_data_offset = o.readUint64(), u += 8) : this.base_data_offset = 0, this.size - this.hdr_size > u && this.flags & l.TFHD_FLAG_SAMPLE_DESC ? (this.default_sample_description_index = o.readUint32(), u += 4) : this.default_sample_description_index = 0, this.size - this.hdr_size > u && this.flags & l.TFHD_FLAG_SAMPLE_DUR ? (this.default_sample_duration = o.readUint32(), u += 4) : this.default_sample_duration = 0, this.size - this.hdr_size > u && this.flags & l.TFHD_FLAG_SAMPLE_SIZE ? (this.default_sample_size = o.readUint32(), u += 4) : this.default_sample_size = 0, this.size - this.hdr_size > u && this.flags & l.TFHD_FLAG_SAMPLE_FLAGS ? (this.default_sample_flags = o.readUint32(), u += 4) : this.default_sample_flags = 0;
  }), l.createFullBoxCtor("tfra", function(o) {
    this.track_ID = o.readUint32(), o.readUint24();
    var u = o.readUint8();
    this.length_size_of_traf_num = u >> 4 & 3, this.length_size_of_trun_num = u >> 2 & 3, this.length_size_of_sample_num = u & 3, this.entries = [];
    for (var f = o.readUint32(), p = 0; p < f; p++)
      this.version === 1 ? (this.time = o.readUint64(), this.moof_offset = o.readUint64()) : (this.time = o.readUint32(), this.moof_offset = o.readUint32()), this.traf_number = o["readUint" + 8 * (this.length_size_of_traf_num + 1)](), this.trun_number = o["readUint" + 8 * (this.length_size_of_trun_num + 1)](), this.sample_number = o["readUint" + 8 * (this.length_size_of_sample_num + 1)]();
  }), l.createFullBoxCtor("tkhd", function(o) {
    this.version == 1 ? (this.creation_time = o.readUint64(), this.modification_time = o.readUint64(), this.track_id = o.readUint32(), o.readUint32(), this.duration = o.readUint64()) : (this.creation_time = o.readUint32(), this.modification_time = o.readUint32(), this.track_id = o.readUint32(), o.readUint32(), this.duration = o.readUint32()), o.readUint32Array(2), this.layer = o.readInt16(), this.alternate_group = o.readInt16(), this.volume = o.readInt16() >> 8, o.readUint16(), this.matrix = o.readInt32Array(9), this.width = o.readUint32(), this.height = o.readUint32();
  }), l.createBoxCtor("tmax", function(o) {
    this.time = o.readUint32();
  }), l.createBoxCtor("tmin", function(o) {
    this.time = o.readUint32();
  }), l.createBoxCtor("totl", function(o) {
    this.bytessent = o.readUint32();
  }), l.createBoxCtor("tpay", function(o) {
    this.bytessent = o.readUint32();
  }), l.createBoxCtor("tpyl", function(o) {
    this.bytessent = o.readUint64();
  }), l.TrackGroupTypeBox.prototype.parse = function(o) {
    this.parseFullHeader(o), this.track_group_id = o.readUint32();
  }, l.createTrackGroupCtor("msrc"), l.TrackReferenceTypeBox = function(o, u, f, p) {
    l.Box.call(this, o, u), this.hdr_size = f, this.start = p;
  }, l.TrackReferenceTypeBox.prototype = new l.Box(), l.TrackReferenceTypeBox.prototype.parse = function(o) {
    this.track_ids = o.readUint32Array((this.size - this.hdr_size) / 4);
  }, l.trefBox.prototype.parse = function(o) {
    for (var u, f; o.getPosition() < this.start + this.size; )
      if (u = l.parseOneBox(o, !0, this.size - (o.getPosition() - this.start)), u.code === l.OK)
        f = new l.TrackReferenceTypeBox(u.type, u.size, u.hdr_size, u.start), f.write === l.Box.prototype.write && f.type !== "mdat" && (e.info("BoxParser", "TrackReference " + f.type + " box writing not yet implemented, keeping unparsed data in memory for later write"), f.parseDataAndRewind(o)), f.parse(o), this.boxes.push(f);
      else
        return;
  }, l.createFullBoxCtor("trep", function(o) {
    for (this.track_ID = o.readUint32(), this.boxes = []; o.getPosition() < this.start + this.size; )
      if (ret = l.parseOneBox(o, !1, this.size - (o.getPosition() - this.start)), ret.code === l.OK)
        box = ret.box, this.boxes.push(box);
      else
        return;
  }), l.createFullBoxCtor("trex", function(o) {
    this.track_id = o.readUint32(), this.default_sample_description_index = o.readUint32(), this.default_sample_duration = o.readUint32(), this.default_sample_size = o.readUint32(), this.default_sample_flags = o.readUint32();
  }), l.createBoxCtor("trpy", function(o) {
    this.bytessent = o.readUint64();
  }), l.createFullBoxCtor("trun", function(o) {
    var u = 0;
    if (this.sample_count = o.readUint32(), u += 4, this.size - this.hdr_size > u && this.flags & l.TRUN_FLAGS_DATA_OFFSET ? (this.data_offset = o.readInt32(), u += 4) : this.data_offset = 0, this.size - this.hdr_size > u && this.flags & l.TRUN_FLAGS_FIRST_FLAG ? (this.first_sample_flags = o.readUint32(), u += 4) : this.first_sample_flags = 0, this.sample_duration = [], this.sample_size = [], this.sample_flags = [], this.sample_composition_time_offset = [], this.size - this.hdr_size > u)
      for (var f = 0; f < this.sample_count; f++)
        this.flags & l.TRUN_FLAGS_DURATION && (this.sample_duration[f] = o.readUint32()), this.flags & l.TRUN_FLAGS_SIZE && (this.sample_size[f] = o.readUint32()), this.flags & l.TRUN_FLAGS_FLAGS && (this.sample_flags[f] = o.readUint32()), this.flags & l.TRUN_FLAGS_CTS_OFFSET && (this.version === 0 ? this.sample_composition_time_offset[f] = o.readUint32() : this.sample_composition_time_offset[f] = o.readInt32());
  }), l.createFullBoxCtor("tsel", function(o) {
    this.switch_group = o.readUint32();
    var u = (this.size - this.hdr_size - 4) / 4;
    this.attribute_list = [];
    for (var f = 0; f < u; f++)
      this.attribute_list[f] = o.readUint32();
  }), l.createFullBoxCtor("txtC", function(o) {
    this.config = o.readCString();
  }), l.createBoxCtor("tyco", function(o) {
    var u = (this.size - this.hdr_size) / 4;
    this.compatible_brands = [];
    for (var f = 0; f < u; f++)
      this.compatible_brands[f] = o.readString(4);
  }), l.createFullBoxCtor("udes", function(o) {
    this.lang = o.readCString(), this.name = o.readCString(), this.description = o.readCString(), this.tags = o.readCString();
  }), l.createFullBoxCtor("uncC", function(o) {
    var u;
    if (this.profile = o.readUint32(), this.version != 1) {
      if (this.version == 0) {
        for (this.component_count = o.readUint32(), this.component_index = [], this.component_bit_depth_minus_one = [], this.component_format = [], this.component_align_size = [], u = 0; u < this.component_count; u++)
          this.component_index.push(o.readUint16()), this.component_bit_depth_minus_one.push(o.readUint8()), this.component_format.push(o.readUint8()), this.component_align_size.push(o.readUint8());
        this.sampling_type = o.readUint8(), this.interleave_type = o.readUint8(), this.block_size = o.readUint8();
        var f = o.readUint8();
        this.component_little_endian = f >> 7 & 1, this.block_pad_lsb = f >> 6 & 1, this.block_little_endian = f >> 5 & 1, this.block_reversed = f >> 4 & 1, this.pad_unknown = f >> 3 & 1, this.pixel_size = o.readUint32(), this.row_align_size = o.readUint32(), this.tile_align_size = o.readUint32(), this.num_tile_cols_minus_one = o.readUint32(), this.num_tile_rows_minus_one = o.readUint32();
      }
    }
  }), l.createFullBoxCtor("url ", function(o) {
    this.flags !== 1 && (this.location = o.readCString());
  }), l.createFullBoxCtor("urn ", function(o) {
    this.name = o.readCString(), this.size - this.hdr_size - this.name.length - 1 > 0 && (this.location = o.readCString());
  }), l.createUUIDBox("a5d40b30e81411ddba2f0800200c9a66", !0, !1, function(o) {
    this.LiveServerManifest = o.readString(this.size - this.hdr_size).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
  }), l.createUUIDBox("d08a4f1810f34a82b6c832d8aba183d3", !0, !1, function(o) {
    this.system_id = l.parseHex16(o);
    var u = o.readUint32();
    u > 0 && (this.data = o.readUint8Array(u));
  }), l.createUUIDBox(
    "a2394f525a9b4f14a2446c427c648df4",
    !0,
    !1
    /*, function(stream) {
    	if (this.flags & 0x1) {
    		this.AlgorithmID = stream.readUint24();
    		this.IV_size = stream.readUint8();
    		this.KID = BoxParser.parseHex16(stream);
    	}
    	var sample_count = stream.readUint32();
    	this.samples = [];
    	for (var i = 0; i < sample_count; i++) {
    		var sample = {};
    		sample.InitializationVector = this.readUint8Array(this.IV_size*8);
    		if (this.flags & 0x2) {
    			sample.subsamples = [];
    			sample.NumberOfEntries = stream.readUint16();
    			for (var j = 0; j < sample.NumberOfEntries; j++) {
    				var subsample = {};
    				subsample.BytesOfClearData = stream.readUint16();
    				subsample.BytesOfProtectedData = stream.readUint32();
    				sample.subsamples.push(subsample);
    			}
    		}
    		this.samples.push(sample);
    	}
    }*/
  ), l.createUUIDBox("8974dbce7be74c5184f97148f9882554", !0, !1, function(o) {
    this.default_AlgorithmID = o.readUint24(), this.default_IV_size = o.readUint8(), this.default_KID = l.parseHex16(o);
  }), l.createUUIDBox("d4807ef2ca3946958e5426cb9e46a79f", !0, !1, function(o) {
    this.fragment_count = o.readUint8(), this.entries = [];
    for (var u = 0; u < this.fragment_count; u++) {
      var f = {}, p = 0, g = 0;
      this.version === 1 ? (p = o.readUint64(), g = o.readUint64()) : (p = o.readUint32(), g = o.readUint32()), f.absolute_time = p, f.absolute_duration = g, this.entries.push(f);
    }
  }), l.createUUIDBox("6d1d9b0542d544e680e2141daff757b2", !0, !1, function(o) {
    this.version === 1 ? (this.absolute_time = o.readUint64(), this.duration = o.readUint64()) : (this.absolute_time = o.readUint32(), this.duration = o.readUint32());
  }), l.createFullBoxCtor("vmhd", function(o) {
    this.graphicsmode = o.readUint16(), this.opcolor = o.readUint16Array(3);
  }), l.createFullBoxCtor("vpcC", function(o) {
    var u;
    this.version === 1 ? (this.profile = o.readUint8(), this.level = o.readUint8(), u = o.readUint8(), this.bitDepth = u >> 4, this.chromaSubsampling = u >> 1 & 7, this.videoFullRangeFlag = u & 1, this.colourPrimaries = o.readUint8(), this.transferCharacteristics = o.readUint8(), this.matrixCoefficients = o.readUint8(), this.codecIntializationDataSize = o.readUint16(), this.codecIntializationData = o.readUint8Array(this.codecIntializationDataSize)) : (this.profile = o.readUint8(), this.level = o.readUint8(), u = o.readUint8(), this.bitDepth = u >> 4 & 15, this.colorSpace = u & 15, u = o.readUint8(), this.chromaSubsampling = u >> 4 & 15, this.transferFunction = u >> 1 & 7, this.videoFullRangeFlag = u & 1, this.codecIntializationDataSize = o.readUint16(), this.codecIntializationData = o.readUint8Array(this.codecIntializationDataSize));
  }), l.createBoxCtor("vttC", function(o) {
    this.text = o.readString(this.size - this.hdr_size);
  }), l.createFullBoxCtor("vvcC", function(o) {
    var u, f, p = {
      held_bits: void 0,
      num_held_bits: 0,
      stream_read_1_bytes: function(P) {
        this.held_bits = P.readUint8(), this.num_held_bits = 8;
      },
      stream_read_2_bytes: function(P) {
        this.held_bits = P.readUint16(), this.num_held_bits = 16;
      },
      extract_bits: function(P) {
        var N = this.held_bits >> this.num_held_bits - P & (1 << P) - 1;
        return this.num_held_bits -= P, N;
      }
    };
    if (p.stream_read_1_bytes(o), p.extract_bits(5), this.lengthSizeMinusOne = p.extract_bits(2), this.ptl_present_flag = p.extract_bits(1), this.ptl_present_flag) {
      p.stream_read_2_bytes(o), this.ols_idx = p.extract_bits(9), this.num_sublayers = p.extract_bits(3), this.constant_frame_rate = p.extract_bits(2), this.chroma_format_idc = p.extract_bits(2), p.stream_read_1_bytes(o), this.bit_depth_minus8 = p.extract_bits(3), p.extract_bits(5);
      {
        if (p.stream_read_2_bytes(o), p.extract_bits(2), this.num_bytes_constraint_info = p.extract_bits(6), this.general_profile_idc = p.extract_bits(7), this.general_tier_flag = p.extract_bits(1), this.general_level_idc = o.readUint8(), p.stream_read_1_bytes(o), this.ptl_frame_only_constraint_flag = p.extract_bits(1), this.ptl_multilayer_enabled_flag = p.extract_bits(1), this.general_constraint_info = new Uint8Array(this.num_bytes_constraint_info), this.num_bytes_constraint_info) {
          for (u = 0; u < this.num_bytes_constraint_info - 1; u++) {
            var g = p.extract_bits(6);
            p.stream_read_1_bytes(o);
            var S = p.extract_bits(2);
            this.general_constraint_info[u] = g << 2 | S;
          }
          this.general_constraint_info[this.num_bytes_constraint_info - 1] = p.extract_bits(6);
        } else
          p.extract_bits(6);
        if (this.num_sublayers > 1) {
          for (p.stream_read_1_bytes(o), this.ptl_sublayer_present_mask = 0, f = this.num_sublayers - 2; f >= 0; --f) {
            var x = p.extract_bits(1);
            this.ptl_sublayer_present_mask |= x << f;
          }
          for (f = this.num_sublayers; f <= 8 && this.num_sublayers > 1; ++f)
            p.extract_bits(1);
          for (this.sublayer_level_idc = [], f = this.num_sublayers - 2; f >= 0; --f)
            this.ptl_sublayer_present_mask & 1 << f && (this.sublayer_level_idc[f] = o.readUint8());
        }
        if (this.ptl_num_sub_profiles = o.readUint8(), this.general_sub_profile_idc = [], this.ptl_num_sub_profiles)
          for (u = 0; u < this.ptl_num_sub_profiles; u++)
            this.general_sub_profile_idc.push(o.readUint32());
      }
      this.max_picture_width = o.readUint16(), this.max_picture_height = o.readUint16(), this.avg_frame_rate = o.readUint16();
    }
    var E = 12, k = 13;
    this.nalu_arrays = [];
    var R = o.readUint8();
    for (u = 0; u < R; u++) {
      var O = [];
      this.nalu_arrays.push(O), p.stream_read_1_bytes(o), O.completeness = p.extract_bits(1), p.extract_bits(2), O.nalu_type = p.extract_bits(5);
      var T = 1;
      for (O.nalu_type != k && O.nalu_type != E && (T = o.readUint16()), f = 0; f < T; f++) {
        var D = o.readUint16();
        O.push({
          data: o.readUint8Array(D),
          length: D
        });
      }
    }
  }), l.createFullBoxCtor("vvnC", function(o) {
    var u = strm.readUint8();
    this.lengthSizeMinusOne = u & 3;
  }), l.SampleEntry.prototype.isVideo = function() {
    return !1;
  }, l.SampleEntry.prototype.isAudio = function() {
    return !1;
  }, l.SampleEntry.prototype.isSubtitle = function() {
    return !1;
  }, l.SampleEntry.prototype.isMetadata = function() {
    return !1;
  }, l.SampleEntry.prototype.isHint = function() {
    return !1;
  }, l.SampleEntry.prototype.getCodec = function() {
    return this.type.replace(".", "");
  }, l.SampleEntry.prototype.getWidth = function() {
    return "";
  }, l.SampleEntry.prototype.getHeight = function() {
    return "";
  }, l.SampleEntry.prototype.getChannelCount = function() {
    return "";
  }, l.SampleEntry.prototype.getSampleRate = function() {
    return "";
  }, l.SampleEntry.prototype.getSampleSize = function() {
    return "";
  }, l.VisualSampleEntry.prototype.isVideo = function() {
    return !0;
  }, l.VisualSampleEntry.prototype.getWidth = function() {
    return this.width;
  }, l.VisualSampleEntry.prototype.getHeight = function() {
    return this.height;
  }, l.AudioSampleEntry.prototype.isAudio = function() {
    return !0;
  }, l.AudioSampleEntry.prototype.getChannelCount = function() {
    return this.channel_count;
  }, l.AudioSampleEntry.prototype.getSampleRate = function() {
    return this.samplerate;
  }, l.AudioSampleEntry.prototype.getSampleSize = function() {
    return this.samplesize;
  }, l.SubtitleSampleEntry.prototype.isSubtitle = function() {
    return !0;
  }, l.MetadataSampleEntry.prototype.isMetadata = function() {
    return !0;
  }, l.decimalToHex = function(o, u) {
    var f = Number(o).toString(16);
    for (u = typeof u > "u" || u === null ? u = 2 : u; f.length < u; )
      f = "0" + f;
    return f;
  }, l.avc1SampleEntry.prototype.getCodec = l.avc2SampleEntry.prototype.getCodec = l.avc3SampleEntry.prototype.getCodec = l.avc4SampleEntry.prototype.getCodec = function() {
    var o = l.SampleEntry.prototype.getCodec.call(this);
    return this.avcC ? o + "." + l.decimalToHex(this.avcC.AVCProfileIndication) + l.decimalToHex(this.avcC.profile_compatibility) + l.decimalToHex(this.avcC.AVCLevelIndication) : o;
  }, l.hev1SampleEntry.prototype.getCodec = l.hvc1SampleEntry.prototype.getCodec = function() {
    var o, u = l.SampleEntry.prototype.getCodec.call(this);
    if (this.hvcC) {
      switch (u += ".", this.hvcC.general_profile_space) {
        case 0:
          u += "";
          break;
        case 1:
          u += "A";
          break;
        case 2:
          u += "B";
          break;
        case 3:
          u += "C";
          break;
      }
      u += this.hvcC.general_profile_idc, u += ".";
      var f = this.hvcC.general_profile_compatibility, p = 0;
      for (o = 0; o < 32 && (p |= f & 1, o != 31); o++)
        p <<= 1, f >>= 1;
      u += l.decimalToHex(p, 0), u += ".", this.hvcC.general_tier_flag === 0 ? u += "L" : u += "H", u += this.hvcC.general_level_idc;
      var g = !1, S = "";
      for (o = 5; o >= 0; o--)
        (this.hvcC.general_constraint_indicator[o] || g) && (S = "." + l.decimalToHex(this.hvcC.general_constraint_indicator[o], 0) + S, g = !0);
      u += S;
    }
    return u;
  }, l.vvc1SampleEntry.prototype.getCodec = l.vvi1SampleEntry.prototype.getCodec = function() {
    var o, u = l.SampleEntry.prototype.getCodec.call(this);
    if (this.vvcC) {
      u += "." + this.vvcC.general_profile_idc, this.vvcC.general_tier_flag ? u += ".H" : u += ".L", u += this.vvcC.general_level_idc;
      var f = "";
      if (this.vvcC.general_constraint_info) {
        var p = [], g = 0;
        g |= this.vvcC.ptl_frame_only_constraint << 7, g |= this.vvcC.ptl_multilayer_enabled << 6;
        var S;
        for (o = 0; o < this.vvcC.general_constraint_info.length; ++o)
          g |= this.vvcC.general_constraint_info[o] >> 2 & 63, p.push(g), g && (S = o), g = this.vvcC.general_constraint_info[o] >> 2 & 3;
        if (S === void 0)
          f = ".CA";
        else {
          f = ".C";
          var x = "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567", E = 0, k = 0;
          for (o = 0; o <= S; ++o)
            for (E = E << 8 | p[o], k += 8; k >= 5; ) {
              var R = E >> k - 5 & 31;
              f += x[R], k -= 5, E &= (1 << k) - 1;
            }
          k && (E <<= 5 - k, f += x[E & 31]);
        }
      }
      u += f;
    }
    return u;
  }, l.mp4aSampleEntry.prototype.getCodec = function() {
    var o = l.SampleEntry.prototype.getCodec.call(this);
    if (this.esds && this.esds.esd) {
      var u = this.esds.esd.getOTI(), f = this.esds.esd.getAudioConfig();
      return o + "." + l.decimalToHex(u) + (f ? "." + f : "");
    } else
      return o;
  }, l.stxtSampleEntry.prototype.getCodec = function() {
    var o = l.SampleEntry.prototype.getCodec.call(this);
    return this.mime_format ? o + "." + this.mime_format : o;
  }, l.vp08SampleEntry.prototype.getCodec = l.vp09SampleEntry.prototype.getCodec = function() {
    var o = l.SampleEntry.prototype.getCodec.call(this), u = this.vpcC.level;
    u == 0 && (u = "00");
    var f = this.vpcC.bitDepth;
    return f == 8 && (f = "08"), o + ".0" + this.vpcC.profile + "." + u + "." + f;
  }, l.av01SampleEntry.prototype.getCodec = function() {
    var o = l.SampleEntry.prototype.getCodec.call(this), u = this.av1C.seq_level_idx_0;
    u < 10 && (u = "0" + u);
    var f;
    return this.av1C.seq_profile === 2 && this.av1C.high_bitdepth === 1 ? f = this.av1C.twelve_bit === 1 ? "12" : "10" : this.av1C.seq_profile <= 2 && (f = this.av1C.high_bitdepth === 1 ? "10" : "08"), o + "." + this.av1C.seq_profile + "." + u + (this.av1C.seq_tier_0 ? "H" : "M") + "." + f;
  }, l.Box.prototype.writeHeader = function(o, u) {
    this.size += 8, this.size > r && (this.size += 8), this.type === "uuid" && (this.size += 16), e.debug("BoxWriter", "Writing box " + this.type + " of size: " + this.size + " at position " + o.getPosition() + (u || "")), this.size > r ? o.writeUint32(1) : (this.sizePosition = o.getPosition(), o.writeUint32(this.size)), o.writeString(this.type, null, 4), this.type === "uuid" && o.writeUint8Array(this.uuid), this.size > r && o.writeUint64(this.size);
  }, l.FullBox.prototype.writeHeader = function(o) {
    this.size += 4, l.Box.prototype.writeHeader.call(this, o, " v=" + this.version + " f=" + this.flags), o.writeUint8(this.version), o.writeUint24(this.flags);
  }, l.Box.prototype.write = function(o) {
    this.type === "mdat" ? this.data && (this.size = this.data.length, this.writeHeader(o), o.writeUint8Array(this.data)) : (this.size = this.data ? this.data.length : 0, this.writeHeader(o), this.data && o.writeUint8Array(this.data));
  }, l.ContainerBox.prototype.write = function(o) {
    this.size = 0, this.writeHeader(o);
    for (var u = 0; u < this.boxes.length; u++)
      this.boxes[u] && (this.boxes[u].write(o), this.size += this.boxes[u].size);
    e.debug("BoxWriter", "Adjusting box " + this.type + " with new size " + this.size), o.adjustUint32(this.sizePosition, this.size);
  }, l.TrackReferenceTypeBox.prototype.write = function(o) {
    this.size = this.track_ids.length * 4, this.writeHeader(o), o.writeUint32Array(this.track_ids);
  }, l.avcCBox.prototype.write = function(o) {
    var u;
    for (this.size = 7, u = 0; u < this.SPS.length; u++)
      this.size += 2 + this.SPS[u].length;
    for (u = 0; u < this.PPS.length; u++)
      this.size += 2 + this.PPS[u].length;
    for (this.ext && (this.size += this.ext.length), this.writeHeader(o), o.writeUint8(this.configurationVersion), o.writeUint8(this.AVCProfileIndication), o.writeUint8(this.profile_compatibility), o.writeUint8(this.AVCLevelIndication), o.writeUint8(this.lengthSizeMinusOne + 252), o.writeUint8(this.SPS.length + 224), u = 0; u < this.SPS.length; u++)
      o.writeUint16(this.SPS[u].length), o.writeUint8Array(this.SPS[u].nalu);
    for (o.writeUint8(this.PPS.length), u = 0; u < this.PPS.length; u++)
      o.writeUint16(this.PPS[u].length), o.writeUint8Array(this.PPS[u].nalu);
    this.ext && o.writeUint8Array(this.ext);
  }, l.co64Box.prototype.write = function(o) {
    var u;
    for (this.version = 0, this.flags = 0, this.size = 4 + 8 * this.chunk_offsets.length, this.writeHeader(o), o.writeUint32(this.chunk_offsets.length), u = 0; u < this.chunk_offsets.length; u++)
      o.writeUint64(this.chunk_offsets[u]);
  }, l.cslgBox.prototype.write = function(o) {
    this.version = 0, this.flags = 0, this.size = 4 * 5, this.writeHeader(o), o.writeInt32(this.compositionToDTSShift), o.writeInt32(this.leastDecodeToDisplayDelta), o.writeInt32(this.greatestDecodeToDisplayDelta), o.writeInt32(this.compositionStartTime), o.writeInt32(this.compositionEndTime);
  }, l.cttsBox.prototype.write = function(o) {
    var u;
    for (this.version = 0, this.flags = 0, this.size = 4 + 8 * this.sample_counts.length, this.writeHeader(o), o.writeUint32(this.sample_counts.length), u = 0; u < this.sample_counts.length; u++)
      o.writeUint32(this.sample_counts[u]), this.version === 1 ? o.writeInt32(this.sample_offsets[u]) : o.writeUint32(this.sample_offsets[u]);
  }, l.drefBox.prototype.write = function(o) {
    this.version = 0, this.flags = 0, this.size = 4, this.writeHeader(o), o.writeUint32(this.entries.length);
    for (var u = 0; u < this.entries.length; u++)
      this.entries[u].write(o), this.size += this.entries[u].size;
    e.debug("BoxWriter", "Adjusting box " + this.type + " with new size " + this.size), o.adjustUint32(this.sizePosition, this.size);
  }, l.elngBox.prototype.write = function(o) {
    this.version = 0, this.flags = 0, this.size = this.extended_language.length, this.writeHeader(o), o.writeString(this.extended_language);
  }, l.elstBox.prototype.write = function(o) {
    this.version = 0, this.flags = 0, this.size = 4 + 12 * this.entries.length, this.writeHeader(o), o.writeUint32(this.entries.length);
    for (var u = 0; u < this.entries.length; u++) {
      var f = this.entries[u];
      o.writeUint32(f.segment_duration), o.writeInt32(f.media_time), o.writeInt16(f.media_rate_integer), o.writeInt16(f.media_rate_fraction);
    }
  }, l.emsgBox.prototype.write = function(o) {
    this.version = 0, this.flags = 0, this.size = 4 * 4 + this.message_data.length + (this.scheme_id_uri.length + 1) + (this.value.length + 1), this.writeHeader(o), o.writeCString(this.scheme_id_uri), o.writeCString(this.value), o.writeUint32(this.timescale), o.writeUint32(this.presentation_time_delta), o.writeUint32(this.event_duration), o.writeUint32(this.id), o.writeUint8Array(this.message_data);
  }, l.ftypBox.prototype.write = function(o) {
    this.size = 8 + 4 * this.compatible_brands.length, this.writeHeader(o), o.writeString(this.major_brand, null, 4), o.writeUint32(this.minor_version);
    for (var u = 0; u < this.compatible_brands.length; u++)
      o.writeString(this.compatible_brands[u], null, 4);
  }, l.hdlrBox.prototype.write = function(o) {
    this.size = 5 * 4 + this.name.length + 1, this.version = 0, this.flags = 0, this.writeHeader(o), o.writeUint32(0), o.writeString(this.handler, null, 4), o.writeUint32(0), o.writeUint32(0), o.writeUint32(0), o.writeCString(this.name);
  }, l.hvcCBox.prototype.write = function(o) {
    var u, f;
    for (this.size = 23, u = 0; u < this.nalu_arrays.length; u++)
      for (this.size += 3, f = 0; f < this.nalu_arrays[u].length; f++)
        this.size += 2 + this.nalu_arrays[u][f].data.length;
    for (this.writeHeader(o), o.writeUint8(this.configurationVersion), o.writeUint8((this.general_profile_space << 6) + (this.general_tier_flag << 5) + this.general_profile_idc), o.writeUint32(this.general_profile_compatibility), o.writeUint8Array(this.general_constraint_indicator), o.writeUint8(this.general_level_idc), o.writeUint16(this.min_spatial_segmentation_idc + (15 << 24)), o.writeUint8(this.parallelismType + 252), o.writeUint8(this.chroma_format_idc + 252), o.writeUint8(this.bit_depth_luma_minus8 + 248), o.writeUint8(this.bit_depth_chroma_minus8 + 248), o.writeUint16(this.avgFrameRate), o.writeUint8((this.constantFrameRate << 6) + (this.numTemporalLayers << 3) + (this.temporalIdNested << 2) + this.lengthSizeMinusOne), o.writeUint8(this.nalu_arrays.length), u = 0; u < this.nalu_arrays.length; u++)
      for (o.writeUint8((this.nalu_arrays[u].completeness << 7) + this.nalu_arrays[u].nalu_type), o.writeUint16(this.nalu_arrays[u].length), f = 0; f < this.nalu_arrays[u].length; f++)
        o.writeUint16(this.nalu_arrays[u][f].data.length), o.writeUint8Array(this.nalu_arrays[u][f].data);
  }, l.kindBox.prototype.write = function(o) {
    this.version = 0, this.flags = 0, this.size = this.schemeURI.length + 1 + (this.value.length + 1), this.writeHeader(o), o.writeCString(this.schemeURI), o.writeCString(this.value);
  }, l.mdhdBox.prototype.write = function(o) {
    this.size = 4 * 4 + 2 * 2, this.flags = 0, this.version = 0, this.writeHeader(o), o.writeUint32(this.creation_time), o.writeUint32(this.modification_time), o.writeUint32(this.timescale), o.writeUint32(this.duration), o.writeUint16(this.language), o.writeUint16(0);
  }, l.mehdBox.prototype.write = function(o) {
    this.version = 0, this.flags = 0, this.size = 4, this.writeHeader(o), o.writeUint32(this.fragment_duration);
  }, l.mfhdBox.prototype.write = function(o) {
    this.version = 0, this.flags = 0, this.size = 4, this.writeHeader(o), o.writeUint32(this.sequence_number);
  }, l.mvhdBox.prototype.write = function(o) {
    this.version = 0, this.flags = 0, this.size = 23 * 4 + 2 * 2, this.writeHeader(o), o.writeUint32(this.creation_time), o.writeUint32(this.modification_time), o.writeUint32(this.timescale), o.writeUint32(this.duration), o.writeUint32(this.rate), o.writeUint16(this.volume << 8), o.writeUint16(0), o.writeUint32(0), o.writeUint32(0), o.writeUint32Array(this.matrix), o.writeUint32(0), o.writeUint32(0), o.writeUint32(0), o.writeUint32(0), o.writeUint32(0), o.writeUint32(0), o.writeUint32(this.next_track_id);
  }, l.SampleEntry.prototype.writeHeader = function(o) {
    this.size = 8, l.Box.prototype.writeHeader.call(this, o), o.writeUint8(0), o.writeUint8(0), o.writeUint8(0), o.writeUint8(0), o.writeUint8(0), o.writeUint8(0), o.writeUint16(this.data_reference_index);
  }, l.SampleEntry.prototype.writeFooter = function(o) {
    for (var u = 0; u < this.boxes.length; u++)
      this.boxes[u].write(o), this.size += this.boxes[u].size;
    e.debug("BoxWriter", "Adjusting box " + this.type + " with new size " + this.size), o.adjustUint32(this.sizePosition, this.size);
  }, l.SampleEntry.prototype.write = function(o) {
    this.writeHeader(o), o.writeUint8Array(this.data), this.size += this.data.length, e.debug("BoxWriter", "Adjusting box " + this.type + " with new size " + this.size), o.adjustUint32(this.sizePosition, this.size);
  }, l.VisualSampleEntry.prototype.write = function(o) {
    this.writeHeader(o), this.size += 2 * 7 + 6 * 4 + 32, o.writeUint16(0), o.writeUint16(0), o.writeUint32(0), o.writeUint32(0), o.writeUint32(0), o.writeUint16(this.width), o.writeUint16(this.height), o.writeUint32(this.horizresolution), o.writeUint32(this.vertresolution), o.writeUint32(0), o.writeUint16(this.frame_count), o.writeUint8(Math.min(31, this.compressorname.length)), o.writeString(this.compressorname, null, 31), o.writeUint16(this.depth), o.writeInt16(-1), this.writeFooter(o);
  }, l.AudioSampleEntry.prototype.write = function(o) {
    this.writeHeader(o), this.size += 2 * 4 + 3 * 4, o.writeUint32(0), o.writeUint32(0), o.writeUint16(this.channel_count), o.writeUint16(this.samplesize), o.writeUint16(0), o.writeUint16(0), o.writeUint32(this.samplerate << 16), this.writeFooter(o);
  }, l.stppSampleEntry.prototype.write = function(o) {
    this.writeHeader(o), this.size += this.namespace.length + 1 + this.schema_location.length + 1 + this.auxiliary_mime_types.length + 1, o.writeCString(this.namespace), o.writeCString(this.schema_location), o.writeCString(this.auxiliary_mime_types), this.writeFooter(o);
  }, l.SampleGroupEntry.prototype.write = function(o) {
    o.writeUint8Array(this.data);
  }, l.sbgpBox.prototype.write = function(o) {
    this.version = 1, this.flags = 0, this.size = 12 + 8 * this.entries.length, this.writeHeader(o), o.writeString(this.grouping_type, null, 4), o.writeUint32(this.grouping_type_parameter), o.writeUint32(this.entries.length);
    for (var u = 0; u < this.entries.length; u++) {
      var f = this.entries[u];
      o.writeInt32(f.sample_count), o.writeInt32(f.group_description_index);
    }
  }, l.sgpdBox.prototype.write = function(o) {
    var u, f;
    for (this.flags = 0, this.size = 12, u = 0; u < this.entries.length; u++)
      f = this.entries[u], this.version === 1 && (this.default_length === 0 && (this.size += 4), this.size += f.data.length);
    for (this.writeHeader(o), o.writeString(this.grouping_type, null, 4), this.version === 1 && o.writeUint32(this.default_length), this.version >= 2 && o.writeUint32(this.default_sample_description_index), o.writeUint32(this.entries.length), u = 0; u < this.entries.length; u++)
      f = this.entries[u], this.version === 1 && this.default_length === 0 && o.writeUint32(f.description_length), f.write(o);
  }, l.sidxBox.prototype.write = function(o) {
    this.version = 0, this.flags = 0, this.size = 4 * 4 + 2 + 2 + 12 * this.references.length, this.writeHeader(o), o.writeUint32(this.reference_ID), o.writeUint32(this.timescale), o.writeUint32(this.earliest_presentation_time), o.writeUint32(this.first_offset), o.writeUint16(0), o.writeUint16(this.references.length);
    for (var u = 0; u < this.references.length; u++) {
      var f = this.references[u];
      o.writeUint32(f.reference_type << 31 | f.referenced_size), o.writeUint32(f.subsegment_duration), o.writeUint32(f.starts_with_SAP << 31 | f.SAP_type << 28 | f.SAP_delta_time);
    }
  }, l.smhdBox.prototype.write = function(o) {
    this.version = 0, this.flags = 1, this.size = 4, this.writeHeader(o), o.writeUint16(this.balance), o.writeUint16(0);
  }, l.stcoBox.prototype.write = function(o) {
    this.version = 0, this.flags = 0, this.size = 4 + 4 * this.chunk_offsets.length, this.writeHeader(o), o.writeUint32(this.chunk_offsets.length), o.writeUint32Array(this.chunk_offsets);
  }, l.stscBox.prototype.write = function(o) {
    var u;
    for (this.version = 0, this.flags = 0, this.size = 4 + 12 * this.first_chunk.length, this.writeHeader(o), o.writeUint32(this.first_chunk.length), u = 0; u < this.first_chunk.length; u++)
      o.writeUint32(this.first_chunk[u]), o.writeUint32(this.samples_per_chunk[u]), o.writeUint32(this.sample_description_index[u]);
  }, l.stsdBox.prototype.write = function(o) {
    var u;
    for (this.version = 0, this.flags = 0, this.size = 0, this.writeHeader(o), o.writeUint32(this.entries.length), this.size += 4, u = 0; u < this.entries.length; u++)
      this.entries[u].write(o), this.size += this.entries[u].size;
    e.debug("BoxWriter", "Adjusting box " + this.type + " with new size " + this.size), o.adjustUint32(this.sizePosition, this.size);
  }, l.stshBox.prototype.write = function(o) {
    var u;
    for (this.version = 0, this.flags = 0, this.size = 4 + 8 * this.shadowed_sample_numbers.length, this.writeHeader(o), o.writeUint32(this.shadowed_sample_numbers.length), u = 0; u < this.shadowed_sample_numbers.length; u++)
      o.writeUint32(this.shadowed_sample_numbers[u]), o.writeUint32(this.sync_sample_numbers[u]);
  }, l.stssBox.prototype.write = function(o) {
    this.version = 0, this.flags = 0, this.size = 4 + 4 * this.sample_numbers.length, this.writeHeader(o), o.writeUint32(this.sample_numbers.length), o.writeUint32Array(this.sample_numbers);
  }, l.stszBox.prototype.write = function(o) {
    var u, f = !0;
    if (this.version = 0, this.flags = 0, this.sample_sizes.length > 0)
      for (u = 0; u + 1 < this.sample_sizes.length; )
        if (this.sample_sizes[u + 1] !== this.sample_sizes[0]) {
          f = !1;
          break;
        } else
          u++;
    else
      f = !1;
    this.size = 8, f || (this.size += 4 * this.sample_sizes.length), this.writeHeader(o), f ? o.writeUint32(this.sample_sizes[0]) : o.writeUint32(0), o.writeUint32(this.sample_sizes.length), f || o.writeUint32Array(this.sample_sizes);
  }, l.sttsBox.prototype.write = function(o) {
    var u;
    for (this.version = 0, this.flags = 0, this.size = 4 + 8 * this.sample_counts.length, this.writeHeader(o), o.writeUint32(this.sample_counts.length), u = 0; u < this.sample_counts.length; u++)
      o.writeUint32(this.sample_counts[u]), o.writeUint32(this.sample_deltas[u]);
  }, l.tfdtBox.prototype.write = function(o) {
    var u = Math.pow(2, 32) - 1;
    this.version = this.baseMediaDecodeTime > u ? 1 : 0, this.flags = 0, this.size = 4, this.version === 1 && (this.size += 4), this.writeHeader(o), this.version === 1 ? o.writeUint64(this.baseMediaDecodeTime) : o.writeUint32(this.baseMediaDecodeTime);
  }, l.tfhdBox.prototype.write = function(o) {
    this.version = 0, this.size = 4, this.flags & l.TFHD_FLAG_BASE_DATA_OFFSET && (this.size += 8), this.flags & l.TFHD_FLAG_SAMPLE_DESC && (this.size += 4), this.flags & l.TFHD_FLAG_SAMPLE_DUR && (this.size += 4), this.flags & l.TFHD_FLAG_SAMPLE_SIZE && (this.size += 4), this.flags & l.TFHD_FLAG_SAMPLE_FLAGS && (this.size += 4), this.writeHeader(o), o.writeUint32(this.track_id), this.flags & l.TFHD_FLAG_BASE_DATA_OFFSET && o.writeUint64(this.base_data_offset), this.flags & l.TFHD_FLAG_SAMPLE_DESC && o.writeUint32(this.default_sample_description_index), this.flags & l.TFHD_FLAG_SAMPLE_DUR && o.writeUint32(this.default_sample_duration), this.flags & l.TFHD_FLAG_SAMPLE_SIZE && o.writeUint32(this.default_sample_size), this.flags & l.TFHD_FLAG_SAMPLE_FLAGS && o.writeUint32(this.default_sample_flags);
  }, l.tkhdBox.prototype.write = function(o) {
    this.version = 0, this.size = 4 * 18 + 2 * 4, this.writeHeader(o), o.writeUint32(this.creation_time), o.writeUint32(this.modification_time), o.writeUint32(this.track_id), o.writeUint32(0), o.writeUint32(this.duration), o.writeUint32(0), o.writeUint32(0), o.writeInt16(this.layer), o.writeInt16(this.alternate_group), o.writeInt16(this.volume << 8), o.writeUint16(0), o.writeInt32Array(this.matrix), o.writeUint32(this.width), o.writeUint32(this.height);
  }, l.trexBox.prototype.write = function(o) {
    this.version = 0, this.flags = 0, this.size = 4 * 5, this.writeHeader(o), o.writeUint32(this.track_id), o.writeUint32(this.default_sample_description_index), o.writeUint32(this.default_sample_duration), o.writeUint32(this.default_sample_size), o.writeUint32(this.default_sample_flags);
  }, l.trunBox.prototype.write = function(o) {
    this.version = 0, this.size = 4, this.flags & l.TRUN_FLAGS_DATA_OFFSET && (this.size += 4), this.flags & l.TRUN_FLAGS_FIRST_FLAG && (this.size += 4), this.flags & l.TRUN_FLAGS_DURATION && (this.size += 4 * this.sample_duration.length), this.flags & l.TRUN_FLAGS_SIZE && (this.size += 4 * this.sample_size.length), this.flags & l.TRUN_FLAGS_FLAGS && (this.size += 4 * this.sample_flags.length), this.flags & l.TRUN_FLAGS_CTS_OFFSET && (this.size += 4 * this.sample_composition_time_offset.length), this.writeHeader(o), o.writeUint32(this.sample_count), this.flags & l.TRUN_FLAGS_DATA_OFFSET && (this.data_offset_position = o.getPosition(), o.writeInt32(this.data_offset)), this.flags & l.TRUN_FLAGS_FIRST_FLAG && o.writeUint32(this.first_sample_flags);
    for (var u = 0; u < this.sample_count; u++)
      this.flags & l.TRUN_FLAGS_DURATION && o.writeUint32(this.sample_duration[u]), this.flags & l.TRUN_FLAGS_SIZE && o.writeUint32(this.sample_size[u]), this.flags & l.TRUN_FLAGS_FLAGS && o.writeUint32(this.sample_flags[u]), this.flags & l.TRUN_FLAGS_CTS_OFFSET && (this.version === 0 ? o.writeUint32(this.sample_composition_time_offset[u]) : o.writeInt32(this.sample_composition_time_offset[u]));
  }, l["url Box"].prototype.write = function(o) {
    this.version = 0, this.location ? (this.flags = 0, this.size = this.location.length + 1) : (this.flags = 1, this.size = 0), this.writeHeader(o), this.location && o.writeCString(this.location);
  }, l["urn Box"].prototype.write = function(o) {
    this.version = 0, this.flags = 0, this.size = this.name.length + 1 + (this.location ? this.location.length + 1 : 0), this.writeHeader(o), o.writeCString(this.name), this.location && o.writeCString(this.location);
  }, l.vmhdBox.prototype.write = function(o) {
    this.version = 0, this.flags = 1, this.size = 8, this.writeHeader(o), o.writeUint16(this.graphicsmode), o.writeUint16Array(this.opcolor);
  }, l.cttsBox.prototype.unpack = function(o) {
    var u, f, p;
    for (p = 0, u = 0; u < this.sample_counts.length; u++)
      for (f = 0; f < this.sample_counts[u]; f++)
        o[p].pts = o[p].dts + this.sample_offsets[u], p++;
  }, l.sttsBox.prototype.unpack = function(o) {
    var u, f, p;
    for (p = 0, u = 0; u < this.sample_counts.length; u++)
      for (f = 0; f < this.sample_counts[u]; f++)
        p === 0 ? o[p].dts = 0 : o[p].dts = o[p - 1].dts + this.sample_deltas[u], p++;
  }, l.stcoBox.prototype.unpack = function(o) {
    var u;
    for (u = 0; u < this.chunk_offsets.length; u++)
      o[u].offset = this.chunk_offsets[u];
  }, l.stscBox.prototype.unpack = function(o) {
    var u, f, p, g, S;
    for (g = 0, S = 0, u = 0; u < this.first_chunk.length; u++)
      for (f = 0; f < (u + 1 < this.first_chunk.length ? this.first_chunk[u + 1] : 1 / 0); f++)
        for (S++, p = 0; p < this.samples_per_chunk[u]; p++) {
          if (o[g])
            o[g].description_index = this.sample_description_index[u], o[g].chunk_index = S;
          else
            return;
          g++;
        }
  }, l.stszBox.prototype.unpack = function(o) {
    var u;
    for (u = 0; u < this.sample_sizes.length; u++)
      o[u].size = this.sample_sizes[u];
  }, l.DIFF_BOXES_PROP_NAMES = [
    "boxes",
    "entries",
    "references",
    "subsamples",
    "items",
    "item_infos",
    "extents",
    "associations",
    "subsegments",
    "ranges",
    "seekLists",
    "seekPoints",
    "esd",
    "levels"
  ], l.DIFF_PRIMITIVE_ARRAY_PROP_NAMES = [
    "compatible_brands",
    "matrix",
    "opcolor",
    "sample_counts",
    "sample_counts",
    "sample_deltas",
    "first_chunk",
    "samples_per_chunk",
    "sample_sizes",
    "chunk_offsets",
    "sample_offsets",
    "sample_description_index",
    "sample_duration"
  ], l.boxEqualFields = function(o, u) {
    if (o && !u)
      return !1;
    var f;
    for (f in o)
      if (!(l.DIFF_BOXES_PROP_NAMES.indexOf(f) > -1)) {
        if (o[f] instanceof l.Box || u[f] instanceof l.Box)
          continue;
        if (typeof o[f] > "u" || typeof u[f] > "u")
          continue;
        if (typeof o[f] == "function" || typeof u[f] == "function")
          continue;
        if (o.subBoxNames && o.subBoxNames.indexOf(f.slice(0, 4)) > -1 || u.subBoxNames && u.subBoxNames.indexOf(f.slice(0, 4)) > -1)
          continue;
        if (f === "data" || f === "start" || f === "size" || f === "creation_time" || f === "modification_time")
          continue;
        if (l.DIFF_PRIMITIVE_ARRAY_PROP_NAMES.indexOf(f) > -1)
          continue;
        if (o[f] !== u[f])
          return !1;
      }
    return !0;
  }, l.boxEqual = function(o, u) {
    if (!l.boxEqualFields(o, u))
      return !1;
    for (var f = 0; f < l.DIFF_BOXES_PROP_NAMES.length; f++) {
      var p = l.DIFF_BOXES_PROP_NAMES[f];
      if (o[p] && u[p] && !l.boxEqual(o[p], u[p]))
        return !1;
    }
    return !0;
  };
  var m = function() {
  };
  m.prototype.parseSample = function(o) {
    var u, f, p = new t(o.buffer);
    for (u = []; !p.isEos(); )
      f = l.parseOneBox(p, !1), f.code === l.OK && f.box.type === "vttc" && u.push(f.box);
    return u;
  }, m.prototype.getText = function(o, u, f) {
    function p(R, O, T) {
      return T = T || "0", R = R + "", R.length >= O ? R : new Array(O - R.length + 1).join(T) + R;
    }
    function g(R) {
      var O = Math.floor(R / 3600), T = Math.floor((R - O * 3600) / 60), D = Math.floor(R - O * 3600 - T * 60), P = Math.floor((R - O * 3600 - T * 60 - D) * 1e3);
      return "" + p(O, 2) + ":" + p(T, 2) + ":" + p(D, 2) + "." + p(P, 3);
    }
    for (var S = this.parseSample(f), x = "", E = 0; E < S.length; E++) {
      var k = S[E];
      x += g(o) + " --> " + g(u) + `\r
`, x += k.payl.text;
    }
    return x;
  };
  var y = function() {
  };
  y.prototype.parseSample = function(o) {
    var u = {}, f;
    u.resources = [];
    var p = new t(o.data.buffer);
    if (!o.subsamples || o.subsamples.length === 0)
      u.documentString = p.readString(o.data.length);
    else if (u.documentString = p.readString(o.subsamples[0].size), o.subsamples.length > 1)
      for (f = 1; f < o.subsamples.length; f++)
        u.resources[f] = p.readUint8Array(o.subsamples[f].size);
    return typeof DOMParser < "u" && (u.document = new DOMParser().parseFromString(u.documentString, "application/xml")), u;
  };
  var b = function() {
  };
  b.prototype.parseSample = function(o) {
    var u, f = new t(o.data.buffer);
    return u = f.readString(o.data.length), u;
  }, b.prototype.parseConfig = function(o) {
    var u, f = new t(o.buffer);
    return f.readUint32(), u = f.readCString(), u;
  }, n.VTTin4Parser = m, n.XMLSubtitlein4Parser = y, n.Textin4Parser = b;
  var v = function(o) {
    this.stream = o || new a(), this.boxes = [], this.mdats = [], this.moofs = [], this.isProgressive = !1, this.moovStartFound = !1, this.onMoovStart = null, this.moovStartSent = !1, this.onReady = null, this.readySent = !1, this.onSegment = null, this.onSamples = null, this.onError = null, this.sampleListBuilt = !1, this.fragmentedTracks = [], this.extractedTracks = [], this.isFragmentationInitialized = !1, this.sampleProcessingStarted = !1, this.nextMoofNumber = 0, this.itemListBuilt = !1, this.items = [], this.entity_groups = [], this.onSidx = null, this.sidxSent = !1;
  };
  v.prototype.setSegmentOptions = function(o, u, f) {
    var p = this.getTrackById(o);
    if (p) {
      var g = {};
      this.fragmentedTracks.push(g), g.id = o, g.user = u, g.trak = p, p.nextSample = 0, g.segmentStream = null, g.nb_samples = 1e3, g.rapAlignement = !0, f && (f.nbSamples && (g.nb_samples = f.nbSamples), f.rapAlignement && (g.rapAlignement = f.rapAlignement));
    }
  }, v.prototype.unsetSegmentOptions = function(o) {
    for (var u = -1, f = 0; f < this.fragmentedTracks.length; f++) {
      var p = this.fragmentedTracks[f];
      p.id == o && (u = f);
    }
    u > -1 && this.fragmentedTracks.splice(u, 1);
  }, v.prototype.setExtractionOptions = function(o, u, f) {
    var p = this.getTrackById(o);
    if (p) {
      var g = {};
      this.extractedTracks.push(g), g.id = o, g.user = u, g.trak = p, p.nextSample = 0, g.nb_samples = 1e3, g.samples = [], f && f.nbSamples && (g.nb_samples = f.nbSamples);
    }
  }, v.prototype.unsetExtractionOptions = function(o) {
    for (var u = -1, f = 0; f < this.extractedTracks.length; f++) {
      var p = this.extractedTracks[f];
      p.id == o && (u = f);
    }
    u > -1 && this.extractedTracks.splice(u, 1);
  }, v.prototype.parse = function() {
    var o, u, f = !1;
    if (!(this.restoreParsePosition && !this.restoreParsePosition()))
      for (; ; )
        if (this.hasIncompleteMdat && this.hasIncompleteMdat()) {
          if (this.processIncompleteMdat())
            continue;
          return;
        } else if (this.saveParsePosition && this.saveParsePosition(), o = l.parseOneBox(this.stream, f), o.code === l.ERR_NOT_ENOUGH_DATA)
          if (this.processIncompleteBox) {
            if (this.processIncompleteBox(o))
              continue;
            return;
          } else
            return;
        else {
          var p;
          switch (u = o.box, p = u.type !== "uuid" ? u.type : u.uuid, this.boxes.push(u), p) {
            case "mdat":
              this.mdats.push(u);
              break;
            case "moof":
              this.moofs.push(u);
              break;
            case "moov":
              this.moovStartFound = !0, this.mdats.length === 0 && (this.isProgressive = !0);
            default:
              this[p] !== void 0 && e.warn("ISOFile", "Duplicate Box of type: " + p + ", overriding previous occurrence"), this[p] = u;
              break;
          }
          this.updateUsedBytes && this.updateUsedBytes(u, o);
        }
  }, v.prototype.checkBuffer = function(o) {
    if (o == null)
      throw "Buffer must be defined and non empty";
    if (o.fileStart === void 0)
      throw "Buffer must have a fileStart property";
    return o.byteLength === 0 ? (e.warn("ISOFile", "Ignoring empty buffer (fileStart: " + o.fileStart + ")"), this.stream.logBufferLevel(), !1) : (e.info("ISOFile", "Processing buffer (fileStart: " + o.fileStart + ")"), o.usedBytes = 0, this.stream.insertBuffer(o), this.stream.logBufferLevel(), this.stream.initialized() ? !0 : (e.warn("ISOFile", "Not ready to start parsing"), !1));
  }, v.prototype.appendBuffer = function(o, u) {
    var f;
    if (this.checkBuffer(o))
      return this.parse(), this.moovStartFound && !this.moovStartSent && (this.moovStartSent = !0, this.onMoovStart && this.onMoovStart()), this.moov ? (this.sampleListBuilt || (this.buildSampleLists(), this.sampleListBuilt = !0), this.updateSampleLists(), this.onReady && !this.readySent && (this.readySent = !0, this.onReady(this.getInfo())), this.processSamples(u), this.nextSeekPosition ? (f = this.nextSeekPosition, this.nextSeekPosition = void 0) : f = this.nextParsePosition, this.stream.getEndFilePositionAfter && (f = this.stream.getEndFilePositionAfter(f))) : this.nextParsePosition ? f = this.nextParsePosition : f = 0, this.sidx && this.onSidx && !this.sidxSent && (this.onSidx(this.sidx), this.sidxSent = !0), this.meta && (this.flattenItemInfo && !this.itemListBuilt && (this.flattenItemInfo(), this.itemListBuilt = !0), this.processItems && this.processItems(this.onItem)), this.stream.cleanBuffers && (e.info("ISOFile", "Done processing buffer (fileStart: " + o.fileStart + ") - next buffer to fetch should have a fileStart position of " + f), this.stream.logBufferLevel(), this.stream.cleanBuffers(), this.stream.logBufferLevel(!0), e.info("ISOFile", "Sample data size in memory: " + this.getAllocatedSampleDataSize())), f;
  }, v.prototype.getInfo = function() {
    var o, u, f = {}, p, g, S, x, E = (/* @__PURE__ */ new Date("1904-01-01T00:00:00Z")).getTime();
    if (this.moov)
      for (f.hasMoov = !0, f.duration = this.moov.mvhd.duration, f.timescale = this.moov.mvhd.timescale, f.isFragmented = this.moov.mvex != null, f.isFragmented && this.moov.mvex.mehd && (f.fragment_duration = this.moov.mvex.mehd.fragment_duration), f.isProgressive = this.isProgressive, f.hasIOD = this.moov.iods != null, f.brands = [], f.brands.push(this.ftyp.major_brand), f.brands = f.brands.concat(this.ftyp.compatible_brands), f.created = new Date(E + this.moov.mvhd.creation_time * 1e3), f.modified = new Date(E + this.moov.mvhd.modification_time * 1e3), f.tracks = [], f.audioTracks = [], f.videoTracks = [], f.subtitleTracks = [], f.metadataTracks = [], f.hintTracks = [], f.otherTracks = [], o = 0; o < this.moov.traks.length; o++) {
        if (p = this.moov.traks[o], x = p.mdia.minf.stbl.stsd.entries[0], g = {}, f.tracks.push(g), g.id = p.tkhd.track_id, g.name = p.mdia.hdlr.name, g.references = [], p.tref)
          for (u = 0; u < p.tref.boxes.length; u++)
            S = {}, g.references.push(S), S.type = p.tref.boxes[u].type, S.track_ids = p.tref.boxes[u].track_ids;
        p.edts && (g.edits = p.edts.elst.entries), g.created = new Date(E + p.tkhd.creation_time * 1e3), g.modified = new Date(E + p.tkhd.modification_time * 1e3), g.movie_duration = p.tkhd.duration, g.movie_timescale = f.timescale, g.layer = p.tkhd.layer, g.alternate_group = p.tkhd.alternate_group, g.volume = p.tkhd.volume, g.matrix = p.tkhd.matrix, g.track_width = p.tkhd.width / 65536, g.track_height = p.tkhd.height / 65536, g.timescale = p.mdia.mdhd.timescale, g.cts_shift = p.mdia.minf.stbl.cslg, g.duration = p.mdia.mdhd.duration, g.samples_duration = p.samples_duration, g.codec = x.getCodec(), g.kind = p.udta && p.udta.kinds.length ? p.udta.kinds[0] : { schemeURI: "", value: "" }, g.language = p.mdia.elng ? p.mdia.elng.extended_language : p.mdia.mdhd.languageString, g.nb_samples = p.samples.length, g.size = p.samples_size, g.bitrate = g.size * 8 * g.timescale / g.samples_duration, x.isAudio() ? (g.type = "audio", f.audioTracks.push(g), g.audio = {}, g.audio.sample_rate = x.getSampleRate(), g.audio.channel_count = x.getChannelCount(), g.audio.sample_size = x.getSampleSize()) : x.isVideo() ? (g.type = "video", f.videoTracks.push(g), g.video = {}, g.video.width = x.getWidth(), g.video.height = x.getHeight()) : x.isSubtitle() ? (g.type = "subtitles", f.subtitleTracks.push(g)) : x.isHint() ? (g.type = "metadata", f.hintTracks.push(g)) : x.isMetadata() ? (g.type = "metadata", f.metadataTracks.push(g)) : (g.type = "metadata", f.otherTracks.push(g));
      }
    else
      f.hasMoov = !1;
    if (f.mime = "", f.hasMoov && f.tracks) {
      for (f.videoTracks && f.videoTracks.length > 0 ? f.mime += 'video/mp4; codecs="' : f.audioTracks && f.audioTracks.length > 0 ? f.mime += 'audio/mp4; codecs="' : f.mime += 'application/mp4; codecs="', o = 0; o < f.tracks.length; o++)
        o !== 0 && (f.mime += ","), f.mime += f.tracks[o].codec;
      f.mime += '"; profiles="', f.mime += this.ftyp.compatible_brands.join(), f.mime += '"';
    }
    return f;
  }, v.prototype.setNextSeekPositionFromSample = function(o) {
    o && (this.nextSeekPosition ? this.nextSeekPosition = Math.min(o.offset + o.alreadyRead, this.nextSeekPosition) : this.nextSeekPosition = o.offset + o.alreadyRead);
  }, v.prototype.processSamples = function(o) {
    var u, f;
    if (this.sampleProcessingStarted) {
      if (this.isFragmentationInitialized && this.onSegment !== null)
        for (u = 0; u < this.fragmentedTracks.length; u++) {
          var p = this.fragmentedTracks[u];
          for (f = p.trak; f.nextSample < f.samples.length && this.sampleProcessingStarted; ) {
            e.debug("ISOFile", "Creating media fragment on track #" + p.id + " for sample " + f.nextSample);
            var g = this.createFragment(p.id, f.nextSample, p.segmentStream);
            if (g)
              p.segmentStream = g, f.nextSample++;
            else
              break;
            if ((f.nextSample % p.nb_samples === 0 || o || f.nextSample >= f.samples.length) && (e.info("ISOFile", "Sending fragmented data on track #" + p.id + " for samples [" + Math.max(0, f.nextSample - p.nb_samples) + "," + (f.nextSample - 1) + "]"), e.info("ISOFile", "Sample data size in memory: " + this.getAllocatedSampleDataSize()), this.onSegment && this.onSegment(p.id, p.user, p.segmentStream.buffer, f.nextSample, o || f.nextSample >= f.samples.length), p.segmentStream = null, p !== this.fragmentedTracks[u]))
              break;
          }
        }
      if (this.onSamples !== null)
        for (u = 0; u < this.extractedTracks.length; u++) {
          var S = this.extractedTracks[u];
          for (f = S.trak; f.nextSample < f.samples.length && this.sampleProcessingStarted; ) {
            e.debug("ISOFile", "Exporting on track #" + S.id + " sample #" + f.nextSample);
            var x = this.getSample(f, f.nextSample);
            if (x)
              f.nextSample++, S.samples.push(x);
            else {
              this.setNextSeekPositionFromSample(f.samples[f.nextSample]);
              break;
            }
            if ((f.nextSample % S.nb_samples === 0 || f.nextSample >= f.samples.length) && (e.debug("ISOFile", "Sending samples on track #" + S.id + " for sample " + f.nextSample), this.onSamples && this.onSamples(S.id, S.user, S.samples), S.samples = [], S !== this.extractedTracks[u]))
              break;
          }
        }
    }
  }, v.prototype.getBox = function(o) {
    var u = this.getBoxes(o, !0);
    return u.length ? u[0] : null;
  }, v.prototype.getBoxes = function(o, u) {
    var f = [];
    return v._sweep.call(this, o, f, u), f;
  }, v._sweep = function(o, u, f) {
    this.type && this.type == o && u.push(this);
    for (var p in this.boxes) {
      if (u.length && f)
        return;
      v._sweep.call(this.boxes[p], o, u, f);
    }
  }, v.prototype.getTrackSamplesInfo = function(o) {
    var u = this.getTrackById(o);
    if (u)
      return u.samples;
  }, v.prototype.getTrackSample = function(o, u) {
    var f = this.getTrackById(o), p = this.getSample(f, u);
    return p;
  }, v.prototype.releaseUsedSamples = function(o, u) {
    var f = 0, p = this.getTrackById(o);
    p.lastValidSample || (p.lastValidSample = 0);
    for (var g = p.lastValidSample; g < u; g++)
      f += this.releaseSample(p, g);
    e.info("ISOFile", "Track #" + o + " released samples up to " + u + " (released size: " + f + ", remaining: " + this.samplesDataSize + ")"), p.lastValidSample = u;
  }, v.prototype.start = function() {
    this.sampleProcessingStarted = !0, this.processSamples(!1);
  }, v.prototype.stop = function() {
    this.sampleProcessingStarted = !1;
  }, v.prototype.flush = function() {
    e.info("ISOFile", "Flushing remaining samples"), this.updateSampleLists(), this.processSamples(!0), this.stream.cleanBuffers(), this.stream.logBufferLevel(!0);
  }, v.prototype.seekTrack = function(o, u, f) {
    var p, g, S = 1 / 0, x = 0, E = 0, k;
    if (f.samples.length === 0)
      return e.info("ISOFile", "No sample in track, cannot seek! Using time " + e.getDurationString(0, 1) + " and offset: 0"), { offset: 0, time: 0 };
    for (p = 0; p < f.samples.length; p++) {
      if (g = f.samples[p], p === 0)
        E = 0, k = g.timescale;
      else if (g.cts > o * g.timescale) {
        E = p - 1;
        break;
      }
      u && g.is_sync && (x = p);
    }
    for (u && (E = x), o = f.samples[E].cts, f.nextSample = E; f.samples[E].alreadyRead === f.samples[E].size && f.samples[E + 1]; )
      E++;
    return S = f.samples[E].offset + f.samples[E].alreadyRead, e.info("ISOFile", "Seeking to " + (u ? "RAP" : "") + " sample #" + f.nextSample + " on track " + f.tkhd.track_id + ", time " + e.getDurationString(o, k) + " and offset: " + S), { offset: S, time: o / k };
  }, v.prototype.getTrackDuration = function(o) {
    var u;
    return o.samples ? (u = o.samples[o.samples.length - 1], (u.cts + u.duration) / u.timescale) : 1 / 0;
  }, v.prototype.seek = function(o, u) {
    var f = this.moov, p, g, S, x = { offset: 1 / 0, time: 1 / 0 };
    if (this.moov) {
      for (S = 0; S < f.traks.length; S++)
        p = f.traks[S], !(o > this.getTrackDuration(p)) && (g = this.seekTrack(o, u, p), g.offset < x.offset && (x.offset = g.offset), g.time < x.time && (x.time = g.time));
      return e.info("ISOFile", "Seeking at time " + e.getDurationString(x.time, 1) + " needs a buffer with a fileStart position of " + x.offset), x.offset === 1 / 0 ? x = { offset: this.nextParsePosition, time: 0 } : x.offset = this.stream.getEndFilePositionAfter(x.offset), e.info("ISOFile", "Adjusted seek position (after checking data already in buffer): " + x.offset), x;
    } else
      throw "Cannot seek: moov not received!";
  }, v.prototype.equal = function(o) {
    for (var u = 0; u < this.boxes.length && u < o.boxes.length; ) {
      var f = this.boxes[u], p = o.boxes[u];
      if (!l.boxEqual(f, p))
        return !1;
      u++;
    }
    return !0;
  }, n.ISOFile = v, v.prototype.lastBoxStartPosition = 0, v.prototype.parsingMdat = null, v.prototype.nextParsePosition = 0, v.prototype.discardMdatData = !1, v.prototype.processIncompleteBox = function(o) {
    var u, f, p;
    return o.type === "mdat" ? (u = new l[o.type + "Box"](o.size), this.parsingMdat = u, this.boxes.push(u), this.mdats.push(u), u.start = o.start, u.hdr_size = o.hdr_size, this.stream.addUsedBytes(u.hdr_size), this.lastBoxStartPosition = u.start + u.size, p = this.stream.seek(u.start + u.size, !1, this.discardMdatData), p ? (this.parsingMdat = null, !0) : (this.moovStartFound ? this.nextParsePosition = this.stream.findEndContiguousBuf() : this.nextParsePosition = u.start + u.size, !1)) : (o.type === "moov" && (this.moovStartFound = !0, this.mdats.length === 0 && (this.isProgressive = !0)), f = this.stream.mergeNextBuffer ? this.stream.mergeNextBuffer() : !1, f ? (this.nextParsePosition = this.stream.getEndPosition(), !0) : (o.type ? this.moovStartFound ? this.nextParsePosition = this.stream.getEndPosition() : this.nextParsePosition = this.stream.getPosition() + o.size : this.nextParsePosition = this.stream.getEndPosition(), !1));
  }, v.prototype.hasIncompleteMdat = function() {
    return this.parsingMdat !== null;
  }, v.prototype.processIncompleteMdat = function() {
    var o, u;
    return o = this.parsingMdat, u = this.stream.seek(o.start + o.size, !1, this.discardMdatData), u ? (e.debug("ISOFile", "Found 'mdat' end in buffered data"), this.parsingMdat = null, !0) : (this.nextParsePosition = this.stream.findEndContiguousBuf(), !1);
  }, v.prototype.restoreParsePosition = function() {
    return this.stream.seek(this.lastBoxStartPosition, !0, this.discardMdatData);
  }, v.prototype.saveParsePosition = function() {
    this.lastBoxStartPosition = this.stream.getPosition();
  }, v.prototype.updateUsedBytes = function(o, u) {
    this.stream.addUsedBytes && (o.type === "mdat" ? (this.stream.addUsedBytes(o.hdr_size), this.discardMdatData && this.stream.addUsedBytes(o.size - o.hdr_size)) : this.stream.addUsedBytes(o.size));
  }, v.prototype.add = l.Box.prototype.add, v.prototype.addBox = l.Box.prototype.addBox, v.prototype.init = function(o) {
    var u = o || {};
    this.add("ftyp").set("major_brand", u.brands && u.brands[0] || "iso4").set("minor_version", 0).set("compatible_brands", u.brands || ["iso4"]);
    var f = this.add("moov");
    return f.add("mvhd").set("timescale", u.timescale || 600).set("rate", u.rate || 65536).set("creation_time", 0).set("modification_time", 0).set("duration", u.duration || 0).set("volume", u.width ? 0 : 256).set("matrix", [65536, 0, 0, 0, 65536, 0, 0, 0, 1073741824]).set("next_track_id", 1), f.add("mvex"), this;
  }, v.prototype.addTrack = function(o) {
    this.moov || this.init(o);
    var u = o || {};
    u.width = u.width || 320, u.height = u.height || 320, u.id = u.id || this.moov.mvhd.next_track_id, u.type = u.type || "avc1";
    var f = this.moov.add("trak");
    this.moov.mvhd.next_track_id = u.id + 1, f.add("tkhd").set("flags", l.TKHD_FLAG_ENABLED | l.TKHD_FLAG_IN_MOVIE | l.TKHD_FLAG_IN_PREVIEW).set("creation_time", 0).set("modification_time", 0).set("track_id", u.id).set("duration", u.duration || 0).set("layer", u.layer || 0).set("alternate_group", 0).set("volume", 1).set("matrix", [0, 0, 0, 0, 0, 0, 0, 0, 0]).set("width", u.width << 16).set("height", u.height << 16);
    var p = f.add("mdia");
    p.add("mdhd").set("creation_time", 0).set("modification_time", 0).set("timescale", u.timescale || 1).set("duration", u.media_duration || 0).set("language", u.language || "und"), p.add("hdlr").set("handler", u.hdlr || "vide").set("name", u.name || "Track created with MP4Box.js"), p.add("elng").set("extended_language", u.language || "fr-FR");
    var g = p.add("minf");
    if (l[u.type + "SampleEntry"] !== void 0) {
      var S = new l[u.type + "SampleEntry"]();
      S.data_reference_index = 1;
      var x = "";
      for (var E in l.sampleEntryCodes)
        for (var k = l.sampleEntryCodes[E], R = 0; R < k.length; R++)
          if (k.indexOf(u.type) > -1) {
            x = E;
            break;
          }
      switch (x) {
        case "Visual":
          if (g.add("vmhd").set("graphicsmode", 0).set("opcolor", [0, 0, 0]), S.set("width", u.width).set("height", u.height).set("horizresolution", 72 << 16).set("vertresolution", 72 << 16).set("frame_count", 1).set("compressorname", u.type + " Compressor").set("depth", 24), u.avcDecoderConfigRecord) {
            var O = new l.avcCBox();
            O.parse(new t(u.avcDecoderConfigRecord)), S.addBox(O);
          } else if (u.hevcDecoderConfigRecord) {
            var T = new l.hvcCBox();
            T.parse(new t(u.hevcDecoderConfigRecord)), S.addBox(T);
          }
          break;
        case "Audio":
          g.add("smhd").set("balance", u.balance || 0), S.set("channel_count", u.channel_count || 2).set("samplesize", u.samplesize || 16).set("samplerate", u.samplerate || 65536);
          break;
        case "Hint":
          g.add("hmhd");
          break;
        case "Subtitle":
          switch (g.add("sthd"), u.type) {
            case "stpp":
              S.set("namespace", u.namespace || "nonamespace").set("schema_location", u.schema_location || "").set("auxiliary_mime_types", u.auxiliary_mime_types || "");
              break;
          }
          break;
        case "Metadata":
          g.add("nmhd");
          break;
        case "System":
          g.add("nmhd");
          break;
        default:
          g.add("nmhd");
          break;
      }
      u.description && S.addBox(u.description), u.description_boxes && u.description_boxes.forEach(function(P) {
        S.addBox(P);
      }), g.add("dinf").add("dref").addEntry(new l["url Box"]().set("flags", 1));
      var D = g.add("stbl");
      return D.add("stsd").addEntry(S), D.add("stts").set("sample_counts", []).set("sample_deltas", []), D.add("stsc").set("first_chunk", []).set("samples_per_chunk", []).set("sample_description_index", []), D.add("stco").set("chunk_offsets", []), D.add("stsz").set("sample_sizes", []), this.moov.mvex.add("trex").set("track_id", u.id).set("default_sample_description_index", u.default_sample_description_index || 1).set("default_sample_duration", u.default_sample_duration || 0).set("default_sample_size", u.default_sample_size || 0).set("default_sample_flags", u.default_sample_flags || 0), this.buildTrakSampleLists(f), u.id;
    }
  }, l.Box.prototype.computeSize = function(o) {
    var u = o || new s();
    u.endianness = s.BIG_ENDIAN, this.write(u);
  }, v.prototype.addSample = function(o, u, f) {
    var p = f || {}, g = {}, S = this.getTrackById(o);
    if (S !== null) {
      g.number = S.samples.length, g.track_id = S.tkhd.track_id, g.timescale = S.mdia.mdhd.timescale, g.description_index = p.sample_description_index ? p.sample_description_index - 1 : 0, g.description = S.mdia.minf.stbl.stsd.entries[g.description_index], g.data = u, g.size = u.byteLength, g.alreadyRead = g.size, g.duration = p.duration || 1, g.cts = p.cts || 0, g.dts = p.dts || 0, g.is_sync = p.is_sync || !1, g.is_leading = p.is_leading || 0, g.depends_on = p.depends_on || 0, g.is_depended_on = p.is_depended_on || 0, g.has_redundancy = p.has_redundancy || 0, g.degradation_priority = p.degradation_priority || 0, g.offset = 0, g.subsamples = p.subsamples, S.samples.push(g), S.samples_size += g.size, S.samples_duration += g.duration, S.first_dts === void 0 && (S.first_dts = p.dts), this.processSamples();
      var x = this.createSingleSampleMoof(g);
      return this.addBox(x), x.computeSize(), x.trafs[0].truns[0].data_offset = x.size + 8, this.add("mdat").data = new Uint8Array(u), g;
    }
  }, v.prototype.createSingleSampleMoof = function(o) {
    var u = 0;
    o.is_sync ? u = 1 << 25 : u = 65536;
    var f = new l.moofBox();
    f.add("mfhd").set("sequence_number", this.nextMoofNumber), this.nextMoofNumber++;
    var p = f.add("traf"), g = this.getTrackById(o.track_id);
    return p.add("tfhd").set("track_id", o.track_id).set("flags", l.TFHD_FLAG_DEFAULT_BASE_IS_MOOF), p.add("tfdt").set("baseMediaDecodeTime", o.dts - (g.first_dts || 0)), p.add("trun").set("flags", l.TRUN_FLAGS_DATA_OFFSET | l.TRUN_FLAGS_DURATION | l.TRUN_FLAGS_SIZE | l.TRUN_FLAGS_FLAGS | l.TRUN_FLAGS_CTS_OFFSET).set("data_offset", 0).set("first_sample_flags", 0).set("sample_count", 1).set("sample_duration", [o.duration]).set("sample_size", [o.size]).set("sample_flags", [u]).set("sample_composition_time_offset", [o.cts - o.dts]), f;
  }, v.prototype.lastMoofIndex = 0, v.prototype.samplesDataSize = 0, v.prototype.resetTables = function() {
    var o, u, f, p, g, S, x, E;
    for (this.initial_duration = this.moov.mvhd.duration, this.moov.mvhd.duration = 0, o = 0; o < this.moov.traks.length; o++) {
      u = this.moov.traks[o], u.tkhd.duration = 0, u.mdia.mdhd.duration = 0, f = u.mdia.minf.stbl.stco || u.mdia.minf.stbl.co64, f.chunk_offsets = [], p = u.mdia.minf.stbl.stsc, p.first_chunk = [], p.samples_per_chunk = [], p.sample_description_index = [], g = u.mdia.minf.stbl.stsz || u.mdia.minf.stbl.stz2, g.sample_sizes = [], S = u.mdia.minf.stbl.stts, S.sample_counts = [], S.sample_deltas = [], x = u.mdia.minf.stbl.ctts, x && (x.sample_counts = [], x.sample_offsets = []), E = u.mdia.minf.stbl.stss;
      var k = u.mdia.minf.stbl.boxes.indexOf(E);
      k != -1 && (u.mdia.minf.stbl.boxes[k] = null);
    }
  }, v.initSampleGroups = function(o, u, f, p, g) {
    var S, x, E, k;
    function R(O, T, D) {
      this.grouping_type = O, this.grouping_type_parameter = T, this.sbgp = D, this.last_sample_in_run = -1, this.entry_index = -1;
    }
    for (u && (u.sample_groups_info = []), o.sample_groups_info || (o.sample_groups_info = []), x = 0; x < f.length; x++) {
      for (k = f[x].grouping_type + "/" + f[x].grouping_type_parameter, E = new R(f[x].grouping_type, f[x].grouping_type_parameter, f[x]), u && (u.sample_groups_info[k] = E), o.sample_groups_info[k] || (o.sample_groups_info[k] = E), S = 0; S < p.length; S++)
        p[S].grouping_type === f[x].grouping_type && (E.description = p[S], E.description.used = !0);
      if (g)
        for (S = 0; S < g.length; S++)
          g[S].grouping_type === f[x].grouping_type && (E.fragment_description = g[S], E.fragment_description.used = !0, E.is_fragment = !0);
    }
    if (u) {
      if (g)
        for (x = 0; x < g.length; x++)
          !g[x].used && g[x].version >= 2 && (k = g[x].grouping_type + "/0", E = new R(g[x].grouping_type, 0), E.is_fragment = !0, u.sample_groups_info[k] || (u.sample_groups_info[k] = E));
    } else
      for (x = 0; x < p.length; x++)
        !p[x].used && p[x].version >= 2 && (k = p[x].grouping_type + "/0", E = new R(p[x].grouping_type, 0), o.sample_groups_info[k] || (o.sample_groups_info[k] = E));
  }, v.setSampleGroupProperties = function(o, u, f, p) {
    var g, S;
    u.sample_groups = [];
    for (g in p)
      if (u.sample_groups[g] = {}, u.sample_groups[g].grouping_type = p[g].grouping_type, u.sample_groups[g].grouping_type_parameter = p[g].grouping_type_parameter, f >= p[g].last_sample_in_run && (p[g].last_sample_in_run < 0 && (p[g].last_sample_in_run = 0), p[g].entry_index++, p[g].entry_index <= p[g].sbgp.entries.length - 1 && (p[g].last_sample_in_run += p[g].sbgp.entries[p[g].entry_index].sample_count)), p[g].entry_index <= p[g].sbgp.entries.length - 1 ? u.sample_groups[g].group_description_index = p[g].sbgp.entries[p[g].entry_index].group_description_index : u.sample_groups[g].group_description_index = -1, u.sample_groups[g].group_description_index !== 0) {
        var x;
        p[g].fragment_description ? x = p[g].fragment_description : x = p[g].description, u.sample_groups[g].group_description_index > 0 ? (u.sample_groups[g].group_description_index > 65535 ? S = (u.sample_groups[g].group_description_index >> 16) - 1 : S = u.sample_groups[g].group_description_index - 1, x && S >= 0 && (u.sample_groups[g].description = x.entries[S])) : x && x.version >= 2 && x.default_group_description_index > 0 && (u.sample_groups[g].description = x.entries[x.default_group_description_index - 1]);
      }
  }, v.process_sdtp = function(o, u, f) {
    u && (o ? (u.is_leading = o.is_leading[f], u.depends_on = o.sample_depends_on[f], u.is_depended_on = o.sample_is_depended_on[f], u.has_redundancy = o.sample_has_redundancy[f]) : (u.is_leading = 0, u.depends_on = 0, u.is_depended_on = 0, u.has_redundancy = 0));
  }, v.prototype.buildSampleLists = function() {
    var o, u;
    for (o = 0; o < this.moov.traks.length; o++)
      u = this.moov.traks[o], this.buildTrakSampleLists(u);
  }, v.prototype.buildTrakSampleLists = function(o) {
    var u, f, p, g, S, x, E, k, R, O, T, D, P, N, I, C, U, z, j, F, q, W, K, Q;
    if (o.samples = [], o.samples_duration = 0, o.samples_size = 0, f = o.mdia.minf.stbl.stco || o.mdia.minf.stbl.co64, p = o.mdia.minf.stbl.stsc, g = o.mdia.minf.stbl.stsz || o.mdia.minf.stbl.stz2, S = o.mdia.minf.stbl.stts, x = o.mdia.minf.stbl.ctts, E = o.mdia.minf.stbl.stss, k = o.mdia.minf.stbl.stsd, R = o.mdia.minf.stbl.subs, D = o.mdia.minf.stbl.stdp, O = o.mdia.minf.stbl.sbgps, T = o.mdia.minf.stbl.sgpds, z = -1, j = -1, F = -1, q = -1, W = 0, K = 0, Q = 0, v.initSampleGroups(o, null, O, T), !(typeof g > "u")) {
      for (u = 0; u < g.sample_sizes.length; u++) {
        var G = {};
        G.number = u, G.track_id = o.tkhd.track_id, G.timescale = o.mdia.mdhd.timescale, G.alreadyRead = 0, o.samples[u] = G, G.size = g.sample_sizes[u], o.samples_size += G.size, u === 0 ? (N = 1, P = 0, G.chunk_index = N, G.chunk_run_index = P, U = p.samples_per_chunk[P], C = 0, P + 1 < p.first_chunk.length ? I = p.first_chunk[P + 1] - 1 : I = 1 / 0) : u < U ? (G.chunk_index = N, G.chunk_run_index = P) : (N++, G.chunk_index = N, C = 0, N <= I || (P++, P + 1 < p.first_chunk.length ? I = p.first_chunk[P + 1] - 1 : I = 1 / 0), G.chunk_run_index = P, U += p.samples_per_chunk[P]), G.description_index = p.sample_description_index[G.chunk_run_index] - 1, G.description = k.entries[G.description_index], G.offset = f.chunk_offsets[G.chunk_index - 1] + C, C += G.size, u > z && (j++, z < 0 && (z = 0), z += S.sample_counts[j]), u > 0 ? (o.samples[u - 1].duration = S.sample_deltas[j], o.samples_duration += o.samples[u - 1].duration, G.dts = o.samples[u - 1].dts + o.samples[u - 1].duration) : G.dts = 0, x ? (u >= F && (q++, F < 0 && (F = 0), F += x.sample_counts[q]), G.cts = o.samples[u].dts + x.sample_offsets[q]) : G.cts = G.dts, E ? (u == E.sample_numbers[W] - 1 ? (G.is_sync = !0, W++) : (G.is_sync = !1, G.degradation_priority = 0), R && R.entries[K].sample_delta + Q == u + 1 && (G.subsamples = R.entries[K].subsamples, Q += R.entries[K].sample_delta, K++)) : G.is_sync = !0, v.process_sdtp(o.mdia.minf.stbl.sdtp, G, G.number), D ? G.degradation_priority = D.priority[u] : G.degradation_priority = 0, R && R.entries[K].sample_delta + Q == u && (G.subsamples = R.entries[K].subsamples, Q += R.entries[K].sample_delta), (O.length > 0 || T.length > 0) && v.setSampleGroupProperties(o, G, u, o.sample_groups_info);
      }
      u > 0 && (o.samples[u - 1].duration = Math.max(o.mdia.mdhd.duration - o.samples[u - 1].dts, 0), o.samples_duration += o.samples[u - 1].duration);
    }
  }, v.prototype.updateSampleLists = function() {
    var o, u, f, p, g, S, x, E, k, R, O, T, D, P, N;
    if (this.moov !== void 0) {
      for (; this.lastMoofIndex < this.moofs.length; )
        if (k = this.moofs[this.lastMoofIndex], this.lastMoofIndex++, k.type == "moof")
          for (R = k, o = 0; o < R.trafs.length; o++) {
            for (O = R.trafs[o], T = this.getTrackById(O.tfhd.track_id), D = this.getTrexById(O.tfhd.track_id), O.tfhd.flags & l.TFHD_FLAG_SAMPLE_DESC ? p = O.tfhd.default_sample_description_index : p = D ? D.default_sample_description_index : 1, O.tfhd.flags & l.TFHD_FLAG_SAMPLE_DUR ? g = O.tfhd.default_sample_duration : g = D ? D.default_sample_duration : 0, O.tfhd.flags & l.TFHD_FLAG_SAMPLE_SIZE ? S = O.tfhd.default_sample_size : S = D ? D.default_sample_size : 0, O.tfhd.flags & l.TFHD_FLAG_SAMPLE_FLAGS ? x = O.tfhd.default_sample_flags : x = D ? D.default_sample_flags : 0, O.sample_number = 0, O.sbgps.length > 0 && v.initSampleGroups(T, O, O.sbgps, T.mdia.minf.stbl.sgpds, O.sgpds), u = 0; u < O.truns.length; u++) {
              var I = O.truns[u];
              for (f = 0; f < I.sample_count; f++) {
                P = {}, P.moof_number = this.lastMoofIndex, P.number_in_traf = O.sample_number, O.sample_number++, P.number = T.samples.length, O.first_sample_index = T.samples.length, T.samples.push(P), P.track_id = T.tkhd.track_id, P.timescale = T.mdia.mdhd.timescale, P.description_index = p - 1, P.description = T.mdia.minf.stbl.stsd.entries[P.description_index], P.size = S, I.flags & l.TRUN_FLAGS_SIZE && (P.size = I.sample_size[f]), T.samples_size += P.size, P.duration = g, I.flags & l.TRUN_FLAGS_DURATION && (P.duration = I.sample_duration[f]), T.samples_duration += P.duration, T.first_traf_merged || f > 0 ? P.dts = T.samples[T.samples.length - 2].dts + T.samples[T.samples.length - 2].duration : (O.tfdt ? P.dts = O.tfdt.baseMediaDecodeTime : P.dts = 0, T.first_traf_merged = !0), P.cts = P.dts, I.flags & l.TRUN_FLAGS_CTS_OFFSET && (P.cts = P.dts + I.sample_composition_time_offset[f]), N = x, I.flags & l.TRUN_FLAGS_FLAGS ? N = I.sample_flags[f] : f === 0 && I.flags & l.TRUN_FLAGS_FIRST_FLAG && (N = I.first_sample_flags), P.is_sync = !(N >> 16 & 1), P.is_leading = N >> 26 & 3, P.depends_on = N >> 24 & 3, P.is_depended_on = N >> 22 & 3, P.has_redundancy = N >> 20 & 3, P.degradation_priority = N & 65535;
                var C = !!(O.tfhd.flags & l.TFHD_FLAG_BASE_DATA_OFFSET), U = !!(O.tfhd.flags & l.TFHD_FLAG_DEFAULT_BASE_IS_MOOF), z = !!(I.flags & l.TRUN_FLAGS_DATA_OFFSET), j = 0;
                C ? j = O.tfhd.base_data_offset : U || u === 0 ? j = R.start : j = E, u === 0 && f === 0 ? z ? P.offset = j + I.data_offset : P.offset = j : P.offset = E, E = P.offset + P.size, (O.sbgps.length > 0 || O.sgpds.length > 0 || T.mdia.minf.stbl.sbgps.length > 0 || T.mdia.minf.stbl.sgpds.length > 0) && v.setSampleGroupProperties(T, P, P.number_in_traf, O.sample_groups_info);
              }
            }
            if (O.subs) {
              T.has_fragment_subsamples = !0;
              var F = O.first_sample_index;
              for (u = 0; u < O.subs.entries.length; u++)
                F += O.subs.entries[u].sample_delta, P = T.samples[F - 1], P.subsamples = O.subs.entries[u].subsamples;
            }
          }
    }
  }, v.prototype.getSample = function(o, u) {
    var f, p = o.samples[u];
    if (!this.moov)
      return null;
    if (!p.data)
      p.data = new Uint8Array(p.size), p.alreadyRead = 0, this.samplesDataSize += p.size, e.debug("ISOFile", "Allocating sample #" + u + " on track #" + o.tkhd.track_id + " of size " + p.size + " (total: " + this.samplesDataSize + ")");
    else if (p.alreadyRead == p.size)
      return p;
    for (; ; ) {
      var g = this.stream.findPosition(!0, p.offset + p.alreadyRead, !1);
      if (g > -1) {
        f = this.stream.buffers[g];
        var S = f.byteLength - (p.offset + p.alreadyRead - f.fileStart);
        if (p.size - p.alreadyRead <= S)
          return e.debug("ISOFile", "Getting sample #" + u + " data (alreadyRead: " + p.alreadyRead + " offset: " + (p.offset + p.alreadyRead - f.fileStart) + " read size: " + (p.size - p.alreadyRead) + " full size: " + p.size + ")"), s.memcpy(
            p.data.buffer,
            p.alreadyRead,
            f,
            p.offset + p.alreadyRead - f.fileStart,
            p.size - p.alreadyRead
          ), f.usedBytes += p.size - p.alreadyRead, this.stream.logBufferLevel(), p.alreadyRead = p.size, p;
        if (S === 0)
          return null;
        e.debug("ISOFile", "Getting sample #" + u + " partial data (alreadyRead: " + p.alreadyRead + " offset: " + (p.offset + p.alreadyRead - f.fileStart) + " read size: " + S + " full size: " + p.size + ")"), s.memcpy(
          p.data.buffer,
          p.alreadyRead,
          f,
          p.offset + p.alreadyRead - f.fileStart,
          S
        ), p.alreadyRead += S, f.usedBytes += S, this.stream.logBufferLevel();
      } else
        return null;
    }
  }, v.prototype.releaseSample = function(o, u) {
    var f = o.samples[u];
    return f.data ? (this.samplesDataSize -= f.size, f.data = null, f.alreadyRead = 0, f.size) : 0;
  }, v.prototype.getAllocatedSampleDataSize = function() {
    return this.samplesDataSize;
  }, v.prototype.getCodecs = function() {
    var o, u = "";
    for (o = 0; o < this.moov.traks.length; o++) {
      var f = this.moov.traks[o];
      o > 0 && (u += ","), u += f.mdia.minf.stbl.stsd.entries[0].getCodec();
    }
    return u;
  }, v.prototype.getTrexById = function(o) {
    var u;
    if (!this.moov || !this.moov.mvex)
      return null;
    for (u = 0; u < this.moov.mvex.trexs.length; u++) {
      var f = this.moov.mvex.trexs[u];
      if (f.track_id == o)
        return f;
    }
    return null;
  }, v.prototype.getTrackById = function(o) {
    if (this.moov === void 0)
      return null;
    for (var u = 0; u < this.moov.traks.length; u++) {
      var f = this.moov.traks[u];
      if (f.tkhd.track_id == o)
        return f;
    }
    return null;
  }, v.prototype.itemsDataSize = 0, v.prototype.flattenItemInfo = function() {
    var o = this.items, u = this.entity_groups, f, p, g, S = this.meta;
    if (S != null && S.hdlr !== void 0 && S.iinf !== void 0) {
      for (f = 0; f < S.iinf.item_infos.length; f++)
        g = {}, g.id = S.iinf.item_infos[f].item_ID, o[g.id] = g, g.ref_to = [], g.name = S.iinf.item_infos[f].item_name, S.iinf.item_infos[f].protection_index > 0 && (g.protection = S.ipro.protections[S.iinf.item_infos[f].protection_index - 1]), S.iinf.item_infos[f].item_type ? g.type = S.iinf.item_infos[f].item_type : g.type = "mime", g.content_type = S.iinf.item_infos[f].content_type, g.content_encoding = S.iinf.item_infos[f].content_encoding;
      if (S.grpl)
        for (f = 0; f < S.grpl.boxes.length; f++)
          entity_group = {}, entity_group.id = S.grpl.boxes[f].group_id, entity_group.entity_ids = S.grpl.boxes[f].entity_ids, entity_group.type = S.grpl.boxes[f].type, u[entity_group.id] = entity_group;
      if (S.iloc)
        for (f = 0; f < S.iloc.items.length; f++) {
          var x = S.iloc.items[f];
          switch (g = o[x.item_ID], x.data_reference_index !== 0 && (e.warn("Item storage with reference to other files: not supported"), g.source = S.dinf.boxes[x.data_reference_index - 1]), x.construction_method) {
            case 0:
              break;
            case 1:
              break;
            case 2:
              e.warn("Item storage with construction_method : not supported");
              break;
          }
          for (g.extents = [], g.size = 0, p = 0; p < x.extents.length; p++)
            g.extents[p] = {}, g.extents[p].offset = x.extents[p].extent_offset + x.base_offset, x.construction_method == 1 && (g.extents[p].offset += S.idat.start + S.idat.hdr_size), g.extents[p].length = x.extents[p].extent_length, g.extents[p].alreadyRead = 0, g.size += g.extents[p].length;
        }
      if (S.pitm && (o[S.pitm.item_id].primary = !0), S.iref)
        for (f = 0; f < S.iref.references.length; f++) {
          var E = S.iref.references[f];
          for (p = 0; p < E.references.length; p++)
            o[E.from_item_ID].ref_to.push({ type: E.type, id: E.references[p] });
        }
      if (S.iprp)
        for (var k = 0; k < S.iprp.ipmas.length; k++) {
          var R = S.iprp.ipmas[k];
          for (f = 0; f < R.associations.length; f++) {
            var O = R.associations[f];
            if (g = o[O.id], g || (g = u[O.id]), g)
              for (g.properties === void 0 && (g.properties = {}, g.properties.boxes = []), p = 0; p < O.props.length; p++) {
                var T = O.props[p];
                if (T.property_index > 0 && T.property_index - 1 < S.iprp.ipco.boxes.length) {
                  var D = S.iprp.ipco.boxes[T.property_index - 1];
                  g.properties[D.type] = D, g.properties.boxes.push(D);
                }
              }
          }
        }
    }
  }, v.prototype.getItem = function(o) {
    var u, f;
    if (!this.meta)
      return null;
    if (f = this.items[o], !f.data && f.size)
      f.data = new Uint8Array(f.size), f.alreadyRead = 0, this.itemsDataSize += f.size, e.debug("ISOFile", "Allocating item #" + o + " of size " + f.size + " (total: " + this.itemsDataSize + ")");
    else if (f.alreadyRead === f.size)
      return f;
    for (var p = 0; p < f.extents.length; p++) {
      var g = f.extents[p];
      if (g.alreadyRead !== g.length) {
        var S = this.stream.findPosition(!0, g.offset + g.alreadyRead, !1);
        if (S > -1) {
          u = this.stream.buffers[S];
          var x = u.byteLength - (g.offset + g.alreadyRead - u.fileStart);
          if (g.length - g.alreadyRead <= x)
            e.debug("ISOFile", "Getting item #" + o + " extent #" + p + " data (alreadyRead: " + g.alreadyRead + " offset: " + (g.offset + g.alreadyRead - u.fileStart) + " read size: " + (g.length - g.alreadyRead) + " full extent size: " + g.length + " full item size: " + f.size + ")"), s.memcpy(
              f.data.buffer,
              f.alreadyRead,
              u,
              g.offset + g.alreadyRead - u.fileStart,
              g.length - g.alreadyRead
            ), u.usedBytes += g.length - g.alreadyRead, this.stream.logBufferLevel(), f.alreadyRead += g.length - g.alreadyRead, g.alreadyRead = g.length;
          else
            return e.debug("ISOFile", "Getting item #" + o + " extent #" + p + " partial data (alreadyRead: " + g.alreadyRead + " offset: " + (g.offset + g.alreadyRead - u.fileStart) + " read size: " + x + " full extent size: " + g.length + " full item size: " + f.size + ")"), s.memcpy(
              f.data.buffer,
              f.alreadyRead,
              u,
              g.offset + g.alreadyRead - u.fileStart,
              x
            ), g.alreadyRead += x, f.alreadyRead += x, u.usedBytes += x, this.stream.logBufferLevel(), null;
        } else
          return null;
      }
    }
    return f.alreadyRead === f.size ? f : null;
  }, v.prototype.releaseItem = function(o) {
    var u = this.items[o];
    if (u.data) {
      this.itemsDataSize -= u.size, u.data = null, u.alreadyRead = 0;
      for (var f = 0; f < u.extents.length; f++) {
        var p = u.extents[f];
        p.alreadyRead = 0;
      }
      return u.size;
    } else
      return 0;
  }, v.prototype.processItems = function(o) {
    for (var u in this.items) {
      var f = this.items[u];
      this.getItem(f.id), o && !f.sent && (o(f), f.sent = !0, f.data = null);
    }
  }, v.prototype.hasItem = function(o) {
    for (var u in this.items) {
      var f = this.items[u];
      if (f.name === o)
        return f.id;
    }
    return -1;
  }, v.prototype.getMetaHandler = function() {
    return this.meta ? this.meta.hdlr.handler : null;
  }, v.prototype.getPrimaryItem = function() {
    return !this.meta || !this.meta.pitm ? null : this.getItem(this.meta.pitm.item_id);
  }, v.prototype.itemToFragmentedTrackFile = function(o) {
    var u = o || {}, f = null;
    if (u.itemId ? f = this.getItem(u.itemId) : f = this.getPrimaryItem(), f == null)
      return null;
    var p = new v();
    p.discardMdatData = !1;
    var g = { type: f.type, description_boxes: f.properties.boxes };
    f.properties.ispe && (g.width = f.properties.ispe.image_width, g.height = f.properties.ispe.image_height);
    var S = p.addTrack(g);
    return S ? (p.addSample(S, f.data), p) : null;
  }, v.prototype.write = function(o) {
    for (var u = 0; u < this.boxes.length; u++)
      this.boxes[u].write(o);
  }, v.prototype.createFragment = function(o, u, f) {
    var p = this.getTrackById(o), g = this.getSample(p, u);
    if (g == null)
      return this.setNextSeekPositionFromSample(p.samples[u]), null;
    var S = f || new s();
    S.endianness = s.BIG_ENDIAN;
    var x = this.createSingleSampleMoof(g);
    x.write(S), x.trafs[0].truns[0].data_offset = x.size + 8, e.debug("MP4Box", "Adjusting data_offset with new value " + x.trafs[0].truns[0].data_offset), S.adjustUint32(x.trafs[0].truns[0].data_offset_position, x.trafs[0].truns[0].data_offset);
    var E = new l.mdatBox();
    return E.data = g.data, E.write(S), S;
  }, v.writeInitializationSegment = function(o, u, f, p) {
    var g;
    e.debug("ISOFile", "Generating initialization segment");
    var S = new s();
    S.endianness = s.BIG_ENDIAN, o.write(S);
    var x = u.add("mvex");
    for (f && x.add("mehd").set("fragment_duration", f), g = 0; g < u.traks.length; g++)
      x.add("trex").set("track_id", u.traks[g].tkhd.track_id).set("default_sample_description_index", 1).set("default_sample_duration", p).set("default_sample_size", 0).set("default_sample_flags", 65536);
    return u.write(S), S.buffer;
  }, v.prototype.save = function(o) {
    var u = new s();
    u.endianness = s.BIG_ENDIAN, this.write(u), u.save(o);
  }, v.prototype.getBuffer = function() {
    var o = new s();
    return o.endianness = s.BIG_ENDIAN, this.write(o), o.buffer;
  }, v.prototype.initializeSegmentation = function() {
    var o, u, f, p;
    for (this.onSegment === null && e.warn("MP4Box", "No segmentation callback set!"), this.isFragmentationInitialized || (this.isFragmentationInitialized = !0, this.nextMoofNumber = 0, this.resetTables()), u = [], o = 0; o < this.fragmentedTracks.length; o++) {
      var g = new l.moovBox();
      g.mvhd = this.moov.mvhd, g.boxes.push(g.mvhd), f = this.getTrackById(this.fragmentedTracks[o].id), g.boxes.push(f), g.traks.push(f), p = {}, p.id = f.tkhd.track_id, p.user = this.fragmentedTracks[o].user, p.buffer = v.writeInitializationSegment(this.ftyp, g, this.moov.mvex && this.moov.mvex.mehd ? this.moov.mvex.mehd.fragment_duration : void 0, this.moov.traks[o].samples.length > 0 ? this.moov.traks[o].samples[0].duration : 0), u.push(p);
    }
    return u;
  }, l.Box.prototype.printHeader = function(o) {
    this.size += 8, this.size > r && (this.size += 8), this.type === "uuid" && (this.size += 16), o.log(o.indent + "size:" + this.size), o.log(o.indent + "type:" + this.type);
  }, l.FullBox.prototype.printHeader = function(o) {
    this.size += 4, l.Box.prototype.printHeader.call(this, o), o.log(o.indent + "version:" + this.version), o.log(o.indent + "flags:" + this.flags);
  }, l.Box.prototype.print = function(o) {
    this.printHeader(o);
  }, l.ContainerBox.prototype.print = function(o) {
    this.printHeader(o);
    for (var u = 0; u < this.boxes.length; u++)
      if (this.boxes[u]) {
        var f = o.indent;
        o.indent += " ", this.boxes[u].print(o), o.indent = f;
      }
  }, v.prototype.print = function(o) {
    o.indent = "";
    for (var u = 0; u < this.boxes.length; u++)
      this.boxes[u] && this.boxes[u].print(o);
  }, l.mvhdBox.prototype.print = function(o) {
    l.FullBox.prototype.printHeader.call(this, o), o.log(o.indent + "creation_time: " + this.creation_time), o.log(o.indent + "modification_time: " + this.modification_time), o.log(o.indent + "timescale: " + this.timescale), o.log(o.indent + "duration: " + this.duration), o.log(o.indent + "rate: " + this.rate), o.log(o.indent + "volume: " + (this.volume >> 8)), o.log(o.indent + "matrix: " + this.matrix.join(", ")), o.log(o.indent + "next_track_id: " + this.next_track_id);
  }, l.tkhdBox.prototype.print = function(o) {
    l.FullBox.prototype.printHeader.call(this, o), o.log(o.indent + "creation_time: " + this.creation_time), o.log(o.indent + "modification_time: " + this.modification_time), o.log(o.indent + "track_id: " + this.track_id), o.log(o.indent + "duration: " + this.duration), o.log(o.indent + "volume: " + (this.volume >> 8)), o.log(o.indent + "matrix: " + this.matrix.join(", ")), o.log(o.indent + "layer: " + this.layer), o.log(o.indent + "alternate_group: " + this.alternate_group), o.log(o.indent + "width: " + this.width), o.log(o.indent + "height: " + this.height);
  };
  var w = {};
  w.createFile = function(o, u) {
    var f = o !== void 0 ? o : !0, p = new v(u);
    return p.discardMdatData = !f, p;
  }, n.createFile = w.createFile;
})(Gd);
const Uj = /* @__PURE__ */ ms(Gd);
class X2 {
  constructor() {
    /**
     *
     * Get codec name from video file
     * @param file: File
     * @returns string
     * @example
     * const codecName = await getCodecName(file)
     */
    oe(this, "getCodecName", async (e) => {
      let t = "";
      const s = Uj.createFile();
      return s.onReady = (a) => {
        var c, l, d;
        t = (d = (l = (c = a == null ? void 0 : a.videoTracks[0]) == null ? void 0 : c.codec) == null ? void 0 : l.split(".")) == null ? void 0 : d[0];
      }, await fetch(URL.createObjectURL(e)).then((a) => a.arrayBuffer()).then((a) => {
        a.fileStart = 0, s.appendBuffer(a);
      }).then(() => t).catch((a) => {
        throw a;
      });
    });
  }
}
class _2 {
  constructor() {
    oe(this, "window", window);
  }
  sendToDataLayer(e) {
    var s, r;
    const t = {
      ...e
    };
    (r = (s = this.window) == null ? void 0 : s.dataLayer) == null || r.push(t);
  }
}
const zj = ({ height: n, backgroundColor: e, label: t, tooltip: s = null, size: r = "md" }) => /* @__PURE__ */ A.jsxs(
  "div",
  {
    className: "vertical-bar-chart display-flex align-items-center",
    "data-tooltip": s,
    "data-tooltip-position": "center top",
    style: { pointerEvents: s ? "auto" : "none" },
    children: [
      /* @__PURE__ */ A.jsx("div", { className: `chart-bar-line background-${e} ${r}`, style: { height: n, backgroundColor: e } }),
      t && /* @__PURE__ */ A.jsx("div", { className: "chart-bar-label text-center small", children: t })
    ]
  }
);
const $2 = ({
  dataSet: n = [],
  legends: e = ["female", "male", "unisex"],
  dataLength: t = 8,
  colors: s = ["lilac", "gold-light", "purple-light"],
  showLabel: r = !0
}) => {
  const a = xt(() => new Tn(), []), { t: c } = Ze("sqGroupVerticalBarChart"), [l, d] = X([]), h = He((o) => {
    const u = [];
    for (let f = 0; f < o.length; f += 3)
      u.push(o.slice(f, f + 3));
    return u;
  }, []), m = xt(() => h(l), [l, h]), y = He(() => n.map((o) => o.value), [n]), b = He(
    (o) => {
      const u = o || 0, f = y().reduce((S, x) => (S.push(...x), S), []).map((S) => Number(S || 0)), p = Math.max(...f);
      return `${u === p ? 100 : 100 * (o * 100) / (p * 100)}%`;
    },
    [y]
  ), v = () => {
    const o = n.reduce((u, f) => {
      var p;
      return u.push({
        label: f.label,
        star: f.star,
        value: (p = Array.from(f == null ? void 0 : f.value)) == null ? void 0 : p.map((g, S) => ({
          label: e[S],
          value: g || 0
        }))
      }), u;
    }, []);
    d(o);
  }, w = He(
    (o) => {
      let u = "";
      for (const f of o)
        u += `<p><strong>${c(f == null ? void 0 : f.label)}:</strong> ${a == null ? void 0 : a.formatPercent(f == null ? void 0 : f.value)}</p>`;
      return u;
    },
    [a, c]
  );
  return ee(() => {
    v();
  }, []), /* @__PURE__ */ A.jsxs("div", { className: "vertical-chart", children: [
    r && /* @__PURE__ */ A.jsx("div", { className: "vertical-chart-subtitles", children: n == null ? void 0 : n.map((o, u) => {
      var f;
      return /* @__PURE__ */ A.jsxs("p", { className: "text-center", children: [
        /* @__PURE__ */ A.jsx("span", { style: { backgroundColor: s == null ? void 0 : s[u] } }),
        /* @__PURE__ */ A.jsxs("strong", { children: [
          o == null ? void 0 : o.label,
          " ",
          /* @__PURE__ */ A.jsx("br", {}),
          a == null ? void 0 : a.formatPercent((f = o == null ? void 0 : o.value) == null ? void 0 : f[u])
        ] })
      ] }, u);
    }) }),
    /* @__PURE__ */ A.jsx("div", { className: "vertical-chart-container justify-content-center align-items-stretch", children: m == null ? void 0 : m.map((o, u) => /* @__PURE__ */ A.jsx("div", { className: "chart-group display-flex justify-content-space-around align-items-center", children: o == null ? void 0 : o.map((f, p) => {
      var g;
      return /* @__PURE__ */ A.jsxs("div", { className: "chart position-relative", children: [
        /* @__PURE__ */ A.jsx(
          "div",
          {
            className: "to-show-tooltip position-absolute",
            "data-tooltip": w(f == null ? void 0 : f.value),
            "data-tooltip-id": `group-vertical-bar-chart-${p}`
          }
        ),
        /* @__PURE__ */ A.jsxs("div", { className: "chart-wrapper", children: [
          /* @__PURE__ */ A.jsx("div", { className: "chart-content", children: /* @__PURE__ */ A.jsx("div", { className: "chart-bar", children: (g = f == null ? void 0 : f.value) == null ? void 0 : g.map((S, x) => /* @__PURE__ */ A.jsx(zj, { height: b(S == null ? void 0 : S.value), backgroundColor: s == null ? void 0 : s[x] }, x)) }) }),
          /* @__PURE__ */ A.jsx("p", { children: /* @__PURE__ */ A.jsx("strong", { children: f == null ? void 0 : f.label }) })
        ] })
      ] }, p);
    }) }, u)) })
  ] });
}, Rj = (n, e = 500) => {
  const t = Re(0);
  return He(
    (...s) => {
      const r = Date.now();
      r - t.current >= e && (t.current = r, n(...s));
    },
    [n, e]
  );
};
const e3 = ({
  className: n = "",
  elementToScrollId: e = "",
  endMessage: t = "",
  hasMore: s = !1,
  children: r,
  onLoadMore: a,
  loading: c = !1
}) => {
  const l = Re(null), [d, h] = X(!1), m = new IntersectionObserver(([v]) => h(!!v.isIntersecting)), y = Rj(async () => {
    a && typeof a == "function" && !c && a();
  }), b = He(async () => {
    var v, w;
    if (!c && s)
      if (e) {
        const o = document.getElementById(e);
        (o == null ? void 0 : o.scrollTop) + (o == null ? void 0 : o.clientHeight) + 50 >= (o == null ? void 0 : o.scrollHeight) && y();
      } else
        window.innerHeight + window.scrollY >= ((v = l.current) == null ? void 0 : v.offsetHeight) + ((w = l.current) == null ? void 0 : w.offsetTop) + 100 && y();
  }, [y, e, s, c]);
  return ee(() => {
    let v;
    return d && (e && (v = document.getElementById(e)), e || (v = window), v.addEventListener("scroll", b)), () => {
      v == null || v.removeEventListener("scroll", b);
    };
  }, [e, d, b]), ee(() => (m.observe(l.current), () => {
    m.disconnect();
  }), [m]), /* @__PURE__ */ A.jsxs("div", { className: "wrapper-scroll", children: [
    /* @__PURE__ */ A.jsx("div", { className: `scroll ${n}`, ref: l, children: r }),
    c ? /* @__PURE__ */ A.jsx("div", { className: "wrapper-loader", children: /* @__PURE__ */ A.jsx(Et, { size: "small" }) }) : null,
    s ? null : /* @__PURE__ */ A.jsx("p", { className: "end-message", children: t || "End scroll" })
  ] });
};
const t3 = ({
  className: n = "",
  children: e,
  placement: t = "left",
  menuArray: s = [],
  icon: r = "ellipsis-vertical",
  styleButton: a,
  classButton: c = "",
  disabled: l = !1
}) => {
  const [d, h] = X(!1), m = Re(null), y = Re(null), b = (w, o) => {
    w.preventDefault(), o && typeof o == "function" && o();
  };
  if (ee(() => {
    function w(o) {
      m != null && m.current && !m.current.contains(o == null ? void 0 : o.target) && h(!1);
    }
    return document.addEventListener("mousedown", w), () => {
      document.removeEventListener("mousedown", w);
    };
  }), !e && !(s != null && s.length))
    return null;
  let v = e;
  return s != null && s.length && (v = /* @__PURE__ */ A.jsx("ul", { className: "menu-array", children: s == null ? void 0 : s.map(({ label: w, icon: o, action: u, iconText: f }) => /* @__PURE__ */ A.jsx("li", { children: /* @__PURE__ */ A.jsxs("button", { type: "button", onClick: (p) => b(p, u), children: [
    /* @__PURE__ */ A.jsx("span", { className: "text", dangerouslySetInnerHTML: { __html: w } }),
    f ? /* @__PURE__ */ A.jsx("span", { className: "icon-option", dangerouslySetInnerHTML: { __html: f || "" } }) : null,
    o ? /* @__PURE__ */ A.jsx("span", { className: "icon-option", children: /* @__PURE__ */ A.jsx("i", { className: `${o}` }) }) : null
  ] }) }, w)) })), /* @__PURE__ */ A.jsxs("div", { className: `wrapper-menu ${n}`, children: [
    /* @__PURE__ */ A.jsx(
      "button",
      {
        onClick: () => h(!d),
        className: `button-to-open ${c} ${l ? "disabled" : ""}`,
        type: "button",
        ref: m,
        style: a,
        disabled: l,
        children: /* @__PURE__ */ A.jsx("i", { className: `fa-regular fa-${r}` })
      }
    ),
    /* @__PURE__ */ A.jsx("div", { className: `menu-box box ${t} ${d ? "open" : null} scrollbar`, ref: y, children: v })
  ] });
}, Wd = kn(void 0), Pj = ({ children: n, value: e }) => /* @__PURE__ */ A.jsx(Wd.Provider, { value: e, children: n }), Ss = () => {
  const n = ia(Wd);
  if (!n)
    throw new Error("useMetricChartContext must be used within a MetricChartProvider");
  return n;
};
const Mj = () => {
  const n = xt(() => new Tn(), []), { formatStandardNumber: e, formatCompactNumber: t, formatPercent: s } = n, { state: r } = Ss(), { metric: a, percentage: c } = r;
  return /* @__PURE__ */ A.jsxs("div", { className: "header-graphic", children: [
    /* @__PURE__ */ A.jsx("span", { className: "user-metric", children: c ? s(a == null ? void 0 : a.user) : e({ lang: "en", number: a == null ? void 0 : a.user }) }),
    (a == null ? void 0 : a.first) && /* @__PURE__ */ A.jsxs("span", { className: "first-place", children: [
      "#1 -",
      " ",
      /* @__PURE__ */ A.jsx("strong", { children: c ? s(a == null ? void 0 : a.first) : t({ lang: qe == null ? void 0 : qe.language, number: a == null ? void 0 : a.first }) })
    ] })
  ] });
};
const jj = () => {
  const { state: n } = Ss(), { metric: e } = n, { t } = Ze("sqMetricChart");
  return /* @__PURE__ */ A.jsxs("div", { className: "metric-chart", children: [
    /* @__PURE__ */ A.jsx(Mj, {}),
    /* @__PURE__ */ A.jsx(
      CT,
      {
        value: e == null ? void 0 : e.user,
        pinValue: e == null ? void 0 : e.influencersAverage,
        percentage: (n == null ? void 0 : n.percentage) ?? !1,
        total: e == null ? void 0 : e.first,
        labelPin: t("average")
      }
    )
  ] });
};
const Lj = () => {
  var t, s, r;
  const { state: n } = Ss(), { metric: e } = n;
  return (e == null ? void 0 : e.position) && /* @__PURE__ */ A.jsxs("div", { className: "user-position", children: [
    /* @__PURE__ */ A.jsx("span", { className: "ranking", children: `${((t = e == null ? void 0 : e.position) == null ? void 0 : t.ranking) >= 0 ? "#" + ((s = e == null ? void 0 : e.position) == null ? void 0 : s.ranking) : "-"}` }),
    /* @__PURE__ */ A.jsx("span", { className: "total", children: `/${(r = e == null ? void 0 : e.position) == null ? void 0 : r.total}` })
  ] });
};
const Dj = ({ children: n }) => {
  const { state: e } = Ss(), { metric: t } = e;
  return /* @__PURE__ */ A.jsxs("div", { className: "metric-chart-card-header", children: [
    /* @__PURE__ */ A.jsx("span", { className: "title", children: n }),
    (t == null ? void 0 : t.position) && /* @__PURE__ */ A.jsx(Lj, {})
  ] });
}, Nj = ({ title: n, type: e }) => {
  const { t, i18n: s } = Ze("sqMetricChart"), r = xt(() => new Tn(), []), { formatCompactNumber: a, formatPercent: c, percentageDifference: l } = r, { state: d } = Ss(), { metric: h, percentage: m } = d;
  return /* @__PURE__ */ A.jsx("div", { className: "metric-chart-description", children: /* @__PURE__ */ A.jsx(
    "span",
    {
      dangerouslySetInnerHTML: {
        __html: t("description", {
          type: t(`metrics.${e}`),
          firstValue: m ? c(h.first) : a({ lang: s == null ? void 0 : s.language, number: h.first }),
          positionFirst: l(h.influencersAverage, h.user),
          userPercentageDiff: h.user >= h.influencersAverage ? t("aboveAverage") : t("belowAverage"),
          userPosition: h.position.ranking
        })
      }
    }
  ) });
}, Fj = ({ metric: n, percentage: e = !0 }) => {
  const [t, s] = X({
    metric: n,
    percentage: e
  });
  return {
    state: t,
    setState: s
  };
};
const i3 = ({ title: n, metric: e, percentage: t = !1, className: s = "", type: r = "" }) => {
  const { state: a, setState: c } = Fj({ metric: e, percentage: t });
  return /* @__PURE__ */ A.jsx(Pj, { value: { state: a, setState: c }, children: /* @__PURE__ */ A.jsxs("div", { className: `metric-chart-card ${s}`, children: [
    /* @__PURE__ */ A.jsx(Dj, { children: n }),
    /* @__PURE__ */ A.jsx(jj, {}),
    e != null && e.first && (e != null && e.influencersAverage) && (e != null && e.position) ? /* @__PURE__ */ A.jsx(Nj, { title: n, type: r }) : null
  ] }) });
};
const Ua = ({
  modalClass: n = "",
  modalSize: e = "md",
  className: t = "",
  buttonClose: s = !0,
  backdrop: r = "static",
  children: a,
  open: c = !1,
  header: l = null,
  footer: d = null,
  id: h = "",
  onCloseChange: m,
  onOpenChange: y,
  onLeftPress: b,
  onRightPress: v,
  forceMobileNoMargin: w = !1
}) => {
  const o = Re(null), u = Re(null), [f, p] = X(!1), [g, S] = X(0);
  ee(() => () => {
    var N;
    document.getElementById("modal-backdrop") && g === 0 && ((N = document.getElementById("modal-backdrop")) == null || N.remove(), document.body.classList.remove("block"));
  }, []), ee(() => {
    if (r !== "static" && o.current && c && f)
      return document.addEventListener("click", E), () => {
        window.removeEventListener("keydown", k), document.removeEventListener("click", E);
      };
  }, [f, c, r]), ee(() => {
    var C;
    const N = document.getElementsByTagName("body")[0], I = document.getElementById("modal-backdrop") || document.createElement("div");
    return c && o.current ? (N.classList.add("block"), u.current = document.getElementsByClassName("modal open"), S((C = u.current) == null ? void 0 : C.length), document.getElementById("modal-backdrop") || (o.current.classList.remove("modal-over"), I.setAttribute("id", "modal-backdrop"), I.setAttribute("class", "modal-backdrop show"), N.appendChild(I)), o.current.style.display = "flex", p(!0), window.addEventListener("keydown", k)) : o.current && x(N, I), () => {
      window.removeEventListener("keydown", k);
    };
  }, [c]);
  function x(N, I) {
    var C, U, z;
    R(!1), O(), (U = (C = o == null ? void 0 : o.current) == null ? void 0 : C.style) != null && U.display && (o.current.style.display = "none"), I.parentNode && ((z = o == null ? void 0 : o.current) == null ? void 0 : z.tabIndex) === 1 && (I.parentNode.removeChild(I), N.classList.remove("block")), p(!1), window.removeEventListener("keydown", k);
  }
  function E(N) {
    if (r === "static" || !o.current || !c || !f)
      return;
    const I = o.current.firstElementChild;
    if (!(I != null && I.contains(N.target))) {
      const C = document.getElementsByTagName("body")[0], U = document.getElementById("modal-backdrop") || document.createElement("div");
      x(C, U);
    }
  }
  function k(N) {
    var I;
    if (c) {
      const C = document.getElementsByClassName("modal open");
      ((I = o == null ? void 0 : o.current) == null ? void 0 : I.tabIndex) === (C == null ? void 0 : C.length) && P(N.keyCode);
    }
  }
  function R(N) {
    y && typeof y == "function" && y(N);
  }
  function O() {
    m && typeof m == "function" && c && m();
  }
  function T() {
    b && typeof b == "function" && b();
  }
  function D() {
    v && typeof v == "function" && v();
  }
  function P(N) {
    switch (N) {
      case 27:
        R(!1), O();
        break;
      case 37:
        T();
        break;
      case 39:
        D();
        break;
    }
  }
  return /* @__PURE__ */ A.jsx(
    "div",
    {
      className: `modal align-items-center ${c ? "open" : ""} ${t} modal-over modal-number-${g}`,
      tabIndex: g,
      id: h || `random-id-${g}`,
      ref: o,
      style: {
        display: "none",
        backgroundColor: "#00000080",
        maxHeight: window == null ? void 0 : window.innerHeight
      },
      children: /* @__PURE__ */ A.jsx("div", { className: `modal-dialog modal-${e} ${n} ${w ? "force-mobile-no-margin" : ""}`, children: /* @__PURE__ */ A.jsxs("div", { className: "modal-content scrollbar", children: [
        /* @__PURE__ */ A.jsxs("div", { className: `modal-header ${l ? "" : "without-header"}`, children: [
          l,
          s ? /* @__PURE__ */ A.jsx("button", { type: "button", onClick: () => O(), className: "button-close modal-exit", children: /* @__PURE__ */ A.jsx("i", { className: "fa-regular fa-times" }) }) : null
        ] }),
        /* @__PURE__ */ A.jsx("div", { className: "modal-body scrollbar", children: a }),
        d ? /* @__PURE__ */ A.jsx("div", { className: "modal-footer", children: d }) : null
      ] }) })
    }
  );
};
const n3 = ({
  overlayClass: n = "",
  className: e = "",
  buttonClose: t = !0,
  backdrop: s = "static",
  children: r,
  open: a = !1,
  header: c = null,
  footer: l = null,
  id: d = "",
  onCloseChange: h,
  onOpenChange: m,
  onLeftPress: y,
  onRightPress: b,
  width: v = "475px",
  maxWidth: w = "100vw",
  headerColor: o = "var(--background_secondary)",
  footerColor: u = "var(--background_secondary)",
  bodyColor: f = "var(--background_secondary)",
  backdropColor: p = "var(--background_secondary)",
  borderless: g = !1,
  overlayDirection: S = "right",
  headerHeight: x = "52px"
}) => {
  const E = Re(null), k = Re(null), [R, O] = X(!1), [T, D] = X(0), [P, N] = X(!1);
  ee(() => () => {
    var K;
    document.getElementById("modal-backdrop") && T === 0 && ((K = document.getElementById("modal-backdrop")) == null || K.remove(), document.body.classList.remove("block"));
  }, []), ee(() => {
    if (s !== "static" && E.current && a && R)
      return document.addEventListener("click", C), () => {
        window.removeEventListener("keydown", U), document.removeEventListener("click", C);
      };
  }, [R, a, s]), ee(() => {
    const K = `
    .overlay.open .modal-dialog.opened {
      width: ${v};
      max-width: ${w};
    }
    `, Q = document.getElementsByTagName("head")[0], G = `${d || `random-id-${T}`}-style`;
    let M = document.getElementById(G);
    return M ? (M.innerHTML = "", M.appendChild(document.createTextNode(K))) : (M = document.createElement("style"), M.setAttribute("id", G), M.appendChild(document.createTextNode(K)), Q.appendChild(M)), () => {
      M.remove();
    };
  }, [v, w, T, d]), ee(() => {
    var G;
    const K = document.getElementsByTagName("body")[0], Q = document.getElementById("modal-backdrop") || document.createElement("div");
    return a && E.current ? (K.classList.add("block"), k.current = document.getElementsByClassName("modal open"), D((G = k.current) == null ? void 0 : G.length), document.getElementById("modal-backdrop") || (E.current.classList.remove("modal-over"), Q.setAttribute("id", "modal-backdrop"), Q.setAttribute("class", "modal-backdrop show"), K.appendChild(Q)), E.current.style.display = "flex", setTimeout(() => {
      N(!0);
    }, 100), O(!0), window.addEventListener("keydown", U)) : E.current && I(K, Q), () => {
      window.removeEventListener("keydown", U);
    };
  }, [a]);
  function I(K, Q) {
    var G;
    z(!1), j(), N(!1), setTimeout(() => {
      var M, te;
      (te = (M = E == null ? void 0 : E.current) == null ? void 0 : M.style) != null && te.display && (E.current.style.display = "none");
    }, 300), Q.parentNode && ((G = E.current) == null ? void 0 : G.tabIndex) === 1 && (Q.parentNode.removeChild(Q), K.classList.remove("block")), O(!1), window.removeEventListener("keydown", U);
  }
  function C(K) {
    if (s === "static" || !E.current || !a || !R)
      return;
    const Q = E.current.firstElementChild;
    if (!(Q != null && Q.contains(K.target))) {
      const G = document.getElementsByTagName("body")[0], M = document.getElementById("modal-backdrop") || document.createElement("div");
      I(G, M);
    }
  }
  function U(K) {
    var Q;
    if (a) {
      const G = document.getElementsByClassName("modal open");
      ((Q = E.current) == null ? void 0 : Q.tabIndex) === (G == null ? void 0 : G.length) && W(K.keyCode);
    }
  }
  function z(K) {
    m && typeof m == "function" && m(K);
  }
  function j() {
    h && typeof h == "function" && h();
  }
  function F() {
    y && typeof y == "function" && y();
  }
  function q() {
    b && typeof b == "function" && b();
  }
  function W(K) {
    switch (K) {
      case 27:
        z(!1), j();
        break;
      case 37:
        F();
        break;
      case 39:
        q();
        break;
    }
  }
  return /* @__PURE__ */ A.jsx(
    "div",
    {
      className: `modal overlay align-items-center ${S} ${a ? "open" : ""} ${e} modal-over modal-number-${T}`,
      tabIndex: T,
      id: d || `random-id-${T}`,
      ref: E,
      style: {
        display: "none"
      },
      children: /* @__PURE__ */ A.jsx(
        "div",
        {
          className: `modal-dialog modal-xl ${n} background-${p} ${P ? "opened" : ""}`,
          style: { backgroundColor: p },
          children: /* @__PURE__ */ A.jsxs("div", { className: "modal-content scrollbar", children: [
            /* @__PURE__ */ A.jsxs(
              "div",
              {
                className: `modal-header ${c ? "" : "without-header"} background-${o} ${g ? "borderless" : ""}`,
                style: { backgroundColor: o, height: x },
                children: [
                  c,
                  t ? /* @__PURE__ */ A.jsx("button", { type: "button", onClick: () => j(), className: "button-close modal-exit", children: /* @__PURE__ */ A.jsx("i", { className: "fa-regular fa-times" }) }) : null
                ]
              }
            ),
            /* @__PURE__ */ A.jsx(
              "div",
              {
                className: `modal-body background-${f} ${l ? "" : "without-footer"} scrollbar`,
                style: { backgroundColor: f },
                children: r
              }
            ),
            l ? /* @__PURE__ */ A.jsx(
              "div",
              {
                className: `modal-footer background-${u} ${g ? "borderless" : ""}`,
                style: { backgroundColor: u },
                children: l
              }
            ) : null
          ] })
        }
      )
    }
  );
};
/**
 * @remix-run/router v1.21.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function ea() {
  return ea = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var s in t)
        Object.prototype.hasOwnProperty.call(t, s) && (n[s] = t[s]);
    }
    return n;
  }, ea.apply(this, arguments);
}
var eu;
(function(n) {
  n.Pop = "POP", n.Push = "PUSH", n.Replace = "REPLACE";
})(eu || (eu = {}));
function Kt(n, e) {
  if (n === !1 || n === null || typeof n > "u")
    throw new Error(e);
}
function Kd(n, e) {
  if (!n) {
    typeof console < "u" && console.warn(e);
    try {
      throw new Error(e);
    } catch {
    }
  }
}
function Yd(n) {
  let e = {};
  if (n) {
    let t = n.indexOf("#");
    t >= 0 && (e.hash = n.substr(t), n = n.substr(0, t));
    let s = n.indexOf("?");
    s >= 0 && (e.search = n.substr(s), n = n.substr(0, s)), n && (e.pathname = n);
  }
  return e;
}
var tu;
(function(n) {
  n.data = "data", n.deferred = "deferred", n.redirect = "redirect", n.error = "error";
})(tu || (tu = {}));
function Bj(n, e) {
  e === void 0 && (e = "/");
  let {
    pathname: t,
    search: s = "",
    hash: r = ""
  } = typeof n == "string" ? Yd(n) : n;
  return {
    pathname: t ? t.startsWith("/") ? t : qj(t, e) : e,
    search: Kj(s),
    hash: Yj(r)
  };
}
function qj(n, e) {
  let t = e.replace(/\/+$/, "").split("/");
  return n.split("/").forEach((r) => {
    r === ".." ? t.length > 1 && t.pop() : r !== "." && t.push(r);
  }), t.length > 1 ? t.join("/") : "/";
}
function bo(n, e, t, s) {
  return "Cannot include a '" + n + "' character in a manually specified " + ("`to." + e + "` field [" + JSON.stringify(s) + "].  Please separate it out to the ") + ("`to." + t + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
function Hj(n) {
  return n.filter((e, t) => t === 0 || e.route.path && e.route.path.length > 0);
}
function Vj(n, e) {
  let t = Hj(n);
  return e ? t.map((s, r) => r === t.length - 1 ? s.pathname : s.pathnameBase) : t.map((s) => s.pathnameBase);
}
function Gj(n, e, t, s) {
  s === void 0 && (s = !1);
  let r;
  typeof n == "string" ? r = Yd(n) : (r = ea({}, n), Kt(!r.pathname || !r.pathname.includes("?"), bo("?", "pathname", "search", r)), Kt(!r.pathname || !r.pathname.includes("#"), bo("#", "pathname", "hash", r)), Kt(!r.search || !r.search.includes("#"), bo("#", "search", "hash", r)));
  let a = n === "" || r.pathname === "", c = a ? "/" : r.pathname, l;
  if (c == null)
    l = t;
  else {
    let y = e.length - 1;
    if (!s && c.startsWith("..")) {
      let b = c.split("/");
      for (; b[0] === ".."; )
        b.shift(), y -= 1;
      r.pathname = b.join("/");
    }
    l = y >= 0 ? e[y] : "/";
  }
  let d = Bj(r, l), h = c && c !== "/" && c.endsWith("/"), m = (a || c === ".") && t.endsWith("/");
  return !d.pathname.endsWith("/") && (h || m) && (d.pathname += "/"), d;
}
const Wj = (n) => n.join("/").replace(/\/\/+/g, "/"), Kj = (n) => !n || n === "?" ? "" : n.startsWith("?") ? n : "?" + n, Yj = (n) => !n || n === "#" ? "" : n.startsWith("#") ? n : "#" + n, Jd = ["post", "put", "patch", "delete"];
new Set(Jd);
const Jj = ["get", ...Jd];
new Set(Jj);
/**
 * React Router v6.28.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function ta() {
  return ta = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var s in t)
        Object.prototype.hasOwnProperty.call(t, s) && (n[s] = t[s]);
    }
    return n;
  }, ta.apply(this, arguments);
}
const za = /* @__PURE__ */ vt.createContext(null);
process.env.NODE_ENV !== "production" && (za.displayName = "DataRouter");
const Zj = /* @__PURE__ */ vt.createContext(null);
process.env.NODE_ENV !== "production" && (Zj.displayName = "DataRouterState");
const Qj = /* @__PURE__ */ vt.createContext(null);
process.env.NODE_ENV !== "production" && (Qj.displayName = "Await");
const Ra = /* @__PURE__ */ vt.createContext(null);
process.env.NODE_ENV !== "production" && (Ra.displayName = "Navigation");
const Pa = /* @__PURE__ */ vt.createContext(null);
process.env.NODE_ENV !== "production" && (Pa.displayName = "Location");
const Hr = /* @__PURE__ */ vt.createContext({
  outlet: null,
  matches: [],
  isDataRoute: !1
});
process.env.NODE_ENV !== "production" && (Hr.displayName = "Route");
const Xj = /* @__PURE__ */ vt.createContext(null);
process.env.NODE_ENV !== "production" && (Xj.displayName = "RouteError");
function Zd() {
  return vt.useContext(Pa) != null;
}
function Qd() {
  return Zd() || (process.env.NODE_ENV !== "production" ? Kt(
    !1,
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useLocation() may be used only in the context of a <Router> component."
  ) : Kt(!1)), vt.useContext(Pa).location;
}
const Xd = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
function _d(n) {
  vt.useContext(Ra).static || vt.useLayoutEffect(n);
}
function _j() {
  let {
    isDataRoute: n
  } = vt.useContext(Hr);
  return n ? n2() : $j();
}
function $j() {
  Zd() || (process.env.NODE_ENV !== "production" ? Kt(
    !1,
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useNavigate() may be used only in the context of a <Router> component."
  ) : Kt(!1));
  let n = vt.useContext(za), {
    basename: e,
    future: t,
    navigator: s
  } = vt.useContext(Ra), {
    matches: r
  } = vt.useContext(Hr), {
    pathname: a
  } = Qd(), c = JSON.stringify(Vj(r, t.v7_relativeSplatPath)), l = vt.useRef(!1);
  return _d(() => {
    l.current = !0;
  }), vt.useCallback(function(h, m) {
    if (m === void 0 && (m = {}), process.env.NODE_ENV !== "production" && Kd(l.current, Xd), !l.current)
      return;
    if (typeof h == "number") {
      s.go(h);
      return;
    }
    let y = Gj(h, JSON.parse(c), a, m.relative === "path");
    n == null && e !== "/" && (y.pathname = y.pathname === "/" ? e : Wj([e, y.pathname])), (m.replace ? s.replace : s.push)(y, m.state, m);
  }, [e, s, c, a, n]);
}
var $d = /* @__PURE__ */ function(n) {
  return n.UseBlocker = "useBlocker", n.UseRevalidator = "useRevalidator", n.UseNavigateStable = "useNavigate", n;
}($d || {}), ef = /* @__PURE__ */ function(n) {
  return n.UseBlocker = "useBlocker", n.UseLoaderData = "useLoaderData", n.UseActionData = "useActionData", n.UseRouteError = "useRouteError", n.UseNavigation = "useNavigation", n.UseRouteLoaderData = "useRouteLoaderData", n.UseMatches = "useMatches", n.UseRevalidator = "useRevalidator", n.UseNavigateStable = "useNavigate", n.UseRouteId = "useRouteId", n;
}(ef || {});
function tf(n) {
  return n + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function e2(n) {
  let e = vt.useContext(za);
  return e || (process.env.NODE_ENV !== "production" ? Kt(!1, tf(n)) : Kt(!1)), e;
}
function t2(n) {
  let e = vt.useContext(Hr);
  return e || (process.env.NODE_ENV !== "production" ? Kt(!1, tf(n)) : Kt(!1)), e;
}
function i2(n) {
  let e = t2(n), t = e.matches[e.matches.length - 1];
  return t.route.id || (process.env.NODE_ENV !== "production" ? Kt(!1, n + ' can only be used on routes that contain a unique "id"') : Kt(!1)), t.route.id;
}
function n2() {
  let {
    router: n
  } = e2($d.UseNavigateStable), e = i2(ef.UseNavigateStable), t = vt.useRef(!1);
  return _d(() => {
    t.current = !0;
  }), vt.useCallback(function(r, a) {
    a === void 0 && (a = {}), process.env.NODE_ENV !== "production" && Kd(t.current, Xd), t.current && (typeof r == "number" ? n.navigate(r) : n.navigate(r, ta({
      fromRouteId: e
    }, a)));
  }, [n, e]);
}
new Promise(() => {
});
const s3 = ({ currentPage: n = 1, totalPages: e = 1, showPages: t = 5, onPageChange: s, className: r = "", style: a }) => {
  var o;
  const [c, l] = X(n), d = _j(), { search: h, pathname: m } = Qd();
  ee(() => {
    l(n);
  }, [n]), ee(() => {
    const u = new URLSearchParams(h), f = u.get("page");
    if (f) {
      const p = parseInt(f) || 1;
      return l(p), () => {
        u.delete("page");
      };
    }
  }, [h]);
  const y = (u) => {
    if (u < 1 || u > e)
      return;
    l(u);
    const f = new URLSearchParams(h);
    f.set("page", u.toString()), d(m + "?" + f.toString()), s && typeof s == "function" && s(u);
  }, b = () => {
    const u = Math.floor(t / 2);
    return n + u < e;
  }, v = () => {
    const u = Math.floor(t / 2);
    return n - u > 1;
  }, w = (u) => {
    const f = Math.floor(t / 2);
    return u === n || u >= n - f && u <= n + f;
  };
  return /* @__PURE__ */ A.jsx("div", { className: `pagination-wrapper ${r}`, style: a, children: /* @__PURE__ */ A.jsxs("ul", { className: "pagination", children: [
    /* @__PURE__ */ A.jsx("li", { className: `page-item ${c === 1 ? "disabled" : ""}`, children: /* @__PURE__ */ A.jsx("button", { onClick: () => y(c - 1), children: /* @__PURE__ */ A.jsx("i", { className: "fa-regular fa-chevron-left" }) }) }),
    v() && /* @__PURE__ */ A.jsx("li", { className: "disabled", children: /* @__PURE__ */ A.jsx("button", { onClick: () => null, children: /* @__PURE__ */ A.jsx("i", { className: "fa-regular fa-ellipsis" }) }) }),
    (o = Array.from({ length: e }, (u, f) => f + 1)) == null ? void 0 : o.map(
      (u) => w(u) && /* @__PURE__ */ A.jsx("li", { className: u === c ? "active" : "", children: /* @__PURE__ */ A.jsx("button", { onClick: () => y(u), children: u }) }, u)
    ),
    b() && /* @__PURE__ */ A.jsx("li", { className: "disabled", children: /* @__PURE__ */ A.jsx("button", { onClick: () => null, children: /* @__PURE__ */ A.jsx("i", { className: "fa-regular fa-ellipsis" }) }) }),
    /* @__PURE__ */ A.jsx("li", { className: `page-item ${c === e ? "disabled" : ""}`, children: /* @__PURE__ */ A.jsx("button", { onClick: () => y(c + 1), children: /* @__PURE__ */ A.jsx("i", { className: "fa-regular fa-chevron-right" }) }) })
  ] }) });
};
const r3 = ({ className: n = "", color: e = "var(--pink)", active: t = 0, steps: s = [], ...r }) => /* @__PURE__ */ A.jsx("div", { className: `steps ${n}`, ...r, children: /* @__PURE__ */ A.jsx("ul", { children: s == null ? void 0 : s.map((a, c) => /* @__PURE__ */ A.jsx(
  "li",
  {
    className: `
                  ${c === t ? "active" : ""}
                  ${c < t ? "old" : ""}
                `,
    style: {
      background: c === t ? "linear-gradient(90deg, " + e + " 0%, " + e + " 50%, transparent 51%)" : c < t ? e : void 0
    },
    children: /* @__PURE__ */ A.jsx("span", {})
  },
  c
)) }) });
const s2 = ({ title: n = "", active: e, disabled: t, height: s, className: r = "", onClick: a, tabIndex: c }) => /* @__PURE__ */ A.jsx(
  "li",
  {
    style: { height: s },
    className: `${r} tab ${e ? "active " : ""} ${t ? "disabled " : ""}`,
    onClick: t ? void 0 : a,
    children: n
  },
  c
);
const o3 = ({
  noContent: n,
  height: e,
  maxWidth: t = "initial",
  margin: s = "0",
  boxShadow: r = !1,
  selectStyle: a = !1,
  lineStyle: c = !1,
  tabsCenter: l = !1,
  tabsWidth: d = !1,
  defaultActiveIndex: h = 0,
  children: m,
  className: y = "",
  onChange: b
}) => {
  const [v, w] = X({
    activeIndex: h
  }), o = (g) => {
    g !== v.activeIndex && (w({ activeIndex: g }), b && typeof b == "function" && b(g));
  }, u = (g, S = 0) => /* @__PURE__ */ cf(
    s2,
    {
      ...g.props,
      height: e,
      onClick: () => o(S),
      tabIndex: S,
      active: S === v.activeIndex,
      key: S
    }
  ), f = () => Array.isArray(m) ? m == null ? void 0 : m.map((g, S) => u(g, S)) : u(m, 0), p = () => {
    var S, x, E;
    const g = m;
    return g != null && g[v == null ? void 0 : v.activeIndex] ? (x = (S = g == null ? void 0 : g[v == null ? void 0 : v.activeIndex]) == null ? void 0 : S.props) == null ? void 0 : x.children : (E = m == null ? void 0 : m.props) == null ? void 0 : E.children;
  };
  return /* @__PURE__ */ A.jsx("section", { className: `tabs-squid ${y}`, children: /* @__PURE__ */ A.jsxs("div", { className: "tabs-container", children: [
    /* @__PURE__ */ A.jsx("div", { className: `wrapper ${r ? "box-shadow " : ""}`, children: /* @__PURE__ */ A.jsx(
      "ul",
      {
        className: `tabs-header ${a ? "select-style " : ""}${c ? "line-style " : ""}${l ? "tabs-center " : ""}${d ? "tabs-width " : ""}`,
        style: {
          maxWidth: t,
          margin: s
        },
        children: f()
      }
    ) }),
    n ? null : /* @__PURE__ */ A.jsx("div", { className: "tabs-wrapper-content", children: p() })
  ] }) });
};
const a3 = ({ icon: n, labels: e, separator: t = !1, className: s = "", style: r, title: a = "", subtag: c, wrapperStyle: l }) => {
  let d = null;
  return e && (d = Array.isArray(e) ? e == null ? void 0 : e.map((h, m) => /* @__PURE__ */ A.jsxs(Fe.Fragment, { children: [
    /* @__PURE__ */ A.jsx("div", { className: "label-text", children: /* @__PURE__ */ A.jsx("span", { children: h }) }, `${h == null ? void 0 : h.toString()}-${m}`),
    t && m !== e.length - 1 ? /* @__PURE__ */ A.jsx("span", { children: "-" }) : null
  ] }, `label-${m}`)) : /* @__PURE__ */ A.jsx("span", { children: e })), /* @__PURE__ */ A.jsxs("div", { className: "tag-wrapper", style: l, children: [
    /* @__PURE__ */ A.jsxs(
      "div",
      {
        className: `tag ${s}`,
        style: {
          width: "fit-content",
          ...r
        },
        title: a,
        children: [
          n || null,
          d
        ]
      },
      a
    ),
    c ? /* @__PURE__ */ A.jsx("div", { className: "sub-tag", children: c }) : null
  ] });
};
const r2 = ({ items: n, children: e, ...t }) => /* @__PURE__ */ A.jsx("ul", { className: "timeline", ...t, children: n != null && n.length ? n == null ? void 0 : n.map((s, r) => /* @__PURE__ */ A.jsx(nf, { children: s }, r)) : e }), nf = ({ children: n, ...e }) => /* @__PURE__ */ A.jsxs("li", { className: "item", children: [
  /* @__PURE__ */ A.jsx("div", { className: "marker" }),
  /* @__PURE__ */ A.jsx("div", { className: "container-item", children: /* @__PURE__ */ A.jsx("div", { className: "content-item", ...e, children: n }) })
] });
r2.Item = nf;
const ws = kn({}), Vr = ({ children: n, className: e = "", id: t = "", dateString: s, ...r }) => {
  const [a, c] = X(""), [l, d] = X(0), [h, m] = X(""), [y, b] = X(0);
  return ee(() => {
    const v = new Date(s).toLocaleDateString("en", { timeZone: "UTC" }), w = new Date(v), o = w.toLocaleString(qe == null ? void 0 : qe.language, { month: "short" }), u = w.toLocaleString(qe == null ? void 0 : qe.language, { weekday: "short" });
    d(w.getDate()), m(o.replace(".", "")), c(u.replace(".", "")), b(w.getFullYear());
  }, [s]), /* @__PURE__ */ A.jsx(ws.Provider, { value: { day: l, dayWeek: a, month: h, year: y, lang: qe == null ? void 0 : qe.language }, children: /* @__PURE__ */ A.jsx("div", { className: `tiny-calendar ${e} display-flex justify-content-flex-start`, id: t, children: /* @__PURE__ */ A.jsx("div", { className: "card-tiny-calendar", ...r, children: /* @__PURE__ */ A.jsx("span", { children: n }) }) }) });
}, o2 = ({ ...n }) => /* @__PURE__ */ A.jsx(ws.Consumer, { children: ({ day: e }) => /* @__PURE__ */ A.jsx("div", { ...n, children: e }) }), a2 = ({ ...n }) => /* @__PURE__ */ A.jsx(ws.Consumer, { children: ({ dayWeek: e }) => /* @__PURE__ */ A.jsx("div", { ...n, children: e }) }), l2 = ({ ...n }) => /* @__PURE__ */ A.jsx(ws.Consumer, { children: ({ month: e }) => /* @__PURE__ */ A.jsx("div", { ...n, children: e }) }), c2 = ({ ...n }) => /* @__PURE__ */ A.jsx(ws.Consumer, { children: ({ year: e }) => /* @__PURE__ */ A.jsx("div", { ...n, children: e }) });
Vr.Day = o2;
Vr.DayWeek = a2;
Vr.Month = l2;
Vr.Year = c2;
const u2 = "var(--background)", iu = "var(--title_color)", d2 = ({
  type: n = "checkbox",
  id: e,
  name: t,
  checked: s,
  disabled: r,
  readonly: a,
  required: c,
  colorBackground: l = "var(--primary_color)",
  hideInput: d = !1,
  block: h = !1,
  toggle: m = !1,
  toggleSwitch: y = !0,
  direction: b = "left",
  onChange: v,
  label: w
}) => {
  const o = (u) => {
    v && typeof v == "function" && v(u);
  };
  return /* @__PURE__ */ A.jsxs(
    "div",
    {
      className: `wrapper-selectors ${s ? "checked" : ""} ${h ? "display-block" : ""} ${m ?? ""} ${y ? "toggle-switch" : ""}`,
      style: {
        backgroundColor: s ? `${l}` : u2,
        color: s ? "var(--white-html)" : iu
      },
      children: [
        /* @__PURE__ */ A.jsx(
          "input",
          {
            id: e,
            name: t,
            type: n,
            onChange: (u) => o(u.target.checked),
            disabled: r,
            readOnly: a,
            required: c,
            checked: s,
            className: `${y ? "toggle-switch-checkbox" : ""} ${b === "right" ? "direction-right" : "direction-left"}`
          }
        ),
        /* @__PURE__ */ A.jsx("label", { htmlFor: e, className: `${r ? "disabled" : ""} ${d ? "display-none" : ""} checkbox`, children: w }),
        w && /* @__PURE__ */ A.jsx(
          "label",
          {
            htmlFor: e,
            className: "text-center",
            style: {
              width: "100%",
              color: s ? "var(--white-html)" : iu
            },
            children: w
          }
        )
      ]
    }
  );
};
const l3 = ({ name: n = "", defaultValue: e = "", contentList: t = [], colorSelector: s, onChange: r }) => {
  const [a, c] = X(e), l = (d, h) => {
    h && (c(d), r && typeof r == "function" && r(d));
  };
  return /* @__PURE__ */ A.jsx("div", { className: "toggle-switch-group", children: t.map((d) => /* @__PURE__ */ A.jsx(
    d2,
    {
      id: `toggle-checkbox-${d.value}-${n}`,
      name: `${d.value}-${n}`,
      hideInput: !0,
      toggleSwitch: !0,
      checked: a === d.value,
      onChange: (h) => l(d.value, h),
      type: "checkbox",
      label: d.label,
      colorBackground: s
    },
    `${d.id}-${d.value}-${n}`
  )) });
};
At.register(nr, qd, ts, Xo, _o, Ri, VM);
function c3({ className: n = "", style: e = {}, id: t = "", data: s, options: r, theme: a }) {
  const c = Re(null), [l, d] = X(null), [h, m] = X(window.innerWidth), [y, b] = X(window.innerHeight), v = He(
    (w) => {
      var f, p;
      const o = a || ((p = (f = document.getElementsByTagName("html")[0]) == null ? void 0 : f.classList) != null && p.contains("dark") ? "dark" : "light"), u = w.createLinearGradient(0, 0, 0, 220);
      return u.addColorStop(0, getComputedStyle(document.documentElement).getPropertyValue("--blue-50")), u.addColorStop(1, getComputedStyle(document.documentElement).getPropertyValue(`--blue-${o === "light" ? 90 : 10}`)), u;
    },
    [a]
  );
  return ee(() => {
    if (c.current) {
      const w = Math.max(...s.datasets[0].data), o = Math.min(...s.datasets[0].data), u = (g) => g.parsed.y === w ? 5 : h < 991 ? 0 : 2;
      l && l.destroy();
      const f = c.current.getContext("2d"), p = At.getChart(c.current);
      p && p.destroy(), f && d(
        new At(f, {
          type: "line",
          data: {
            ...s,
            datasets: [
              ...s.datasets.map((g) => ({
                ...g,
                fill: !0,
                backgroundColor: v(f),
                borderColor: getComputedStyle(document.documentElement).getPropertyValue("--blue-55"),
                tension: 0.4,
                borderWidth: 2,
                pointBackgroundColor: getComputedStyle(document.documentElement).getPropertyValue("--background_secondary")
              }))
            ]
          },
          options: {
            plugins: {
              legend: {
                display: !1
              },
              filler: {
                propagate: !1
              }
            },
            scales: {
              x: {
                grid: {
                  display: !1
                },
                border: {
                  display: !1
                }
              },
              y: {
                max: w + w * 0.1,
                min: o - o * 0.2,
                display: !1,
                grid: {
                  display: !1
                },
                beginAtZero: !0
              }
            },
            elements: {
              point: {
                radius: u,
                hoverRadius: 10,
                hoverBorderWidth: 2,
                borderWidth: 3
              }
            },
            responsive: !0,
            ...r
          }
        })
      );
    }
    return () => {
      l && l.destroy();
    };
  }, [s, h, y, r, v]), ee(() => {
    const w = () => {
      b(window == null ? void 0 : window.innerHeight);
    }, o = () => {
      m(window == null ? void 0 : window.innerWidth);
    }, u = () => {
      l == null || l.resize(600, 600);
    }, f = () => {
      l == null || l.resize();
    };
    return window.addEventListener("resize", w), window.addEventListener("resize", o), window.addEventListener("beforeprint", u), window.addEventListener("afterprint", f), () => {
      window.removeEventListener("resize", w), window.removeEventListener("resize", o), window.removeEventListener("beforeprint", u), window.removeEventListener("afterprint", f);
    };
  }, [l]), /* @__PURE__ */ A.jsx("div", { className: `chart-line ${n}`, style: e, id: t, children: /* @__PURE__ */ A.jsx("canvas", { ref: c }) });
}
const f2 = ({ onClose: n, hasChangedValues: e, hasValueFilled: t, onSubmit: s }) => {
  const { t: r } = Ze("sqModalProfileCache"), a = He(() => {
    s && typeof s == "function" && s();
  }, [s]), c = He(() => {
    n && typeof n == "function" && n();
  }, [n]);
  return /* @__PURE__ */ A.jsxs("footer", { className: "display-flex justify-content-space-between align-items-center", children: [
    /* @__PURE__ */ A.jsx(
      Mi,
      {
        color: "transparent",
        borderColor: "var(--gray)",
        textColor: "var(--gray)",
        style: { borderWidth: "1px" },
        onClick: () => c(),
        children: r("cancel")
      }
    ),
    /* @__PURE__ */ A.jsx(Mi, { disabled: !t || !e, onClick: () => a(), children: r("save") })
  ] });
};
const h2 = ({ socialNetworkObject: n, type: e }) => {
  const { t } = Ze("sqModalProfileCache"), s = xt(() => e === "facebook" ? "instagram" : e, [e]);
  return /* @__PURE__ */ A.jsxs("div", { className: "card-profile mt-3", children: [
    /* @__PURE__ */ A.jsxs("header", { className: "header-card display-flex justify-content-space-between align-items-center p-3", children: [
      /* @__PURE__ */ A.jsxs("div", { className: "first-block display-flex align-items-center", children: [
        /* @__PURE__ */ A.jsx("figure", { className: "display-flex", children: /* @__PURE__ */ A.jsx("img", { className: "mr-2", src: n == null ? void 0 : n.picture, alt: "Profile" }) }),
        /* @__PURE__ */ A.jsx("span", { className: "username text-bold big", children: n == null ? void 0 : n.username })
      ] }),
      /* @__PURE__ */ A.jsx(
        "div",
        {
          className: "social-icon display-flex justify-content-center align-items-center p-2 rounded",
          style: { backgroundColor: `var(--${s})` },
          children: /* @__PURE__ */ A.jsx("i", { className: `fa-brands fa-${s} white small` })
        }
      )
    ] }),
    /* @__PURE__ */ A.jsxs("main", { className: "main-card p-3", children: [
      /* @__PURE__ */ A.jsxs("div", { className: "title display-flex align-items-center py-2", children: [
        /* @__PURE__ */ A.jsx("i", { className: "fa-solid fa-diamond-exclamation gold mr-2 big" }),
        /* @__PURE__ */ A.jsx("h6", { className: "m-0", children: t("updateValues") })
      ] }),
      /* @__PURE__ */ A.jsx("p", { className: "description", children: t("description") })
    ] })
  ] });
}, p2 = ({ fieldsCache: n, onSubmit: e, onChange: t, state: s }) => {
  const { t: r } = Ze("sqModalProfileCache"), a = (l) => {
    var m, y;
    if (!l || l === "")
      return "0,00";
    l = (y = (m = l == null ? void 0 : l.replace(".", "")) == null ? void 0 : m.replace(",", "")) == null ? void 0 : y.replace(/\D/g, "");
    const d = { minimumFractionDigits: 2 };
    return new Intl.NumberFormat("pt-BR", d).format(parseFloat(l) / 100);
  }, c = He(
    (l, d) => {
      t && typeof t == "function" && t(l, d);
    },
    [t]
  );
  return /* @__PURE__ */ A.jsx(
    "form",
    {
      className: "form-profile-cache mt-5",
      onSubmit: (l) => {
        l.preventDefault(), e();
      },
      children: n == null ? void 0 : n.map((l, d) => /* @__PURE__ */ A.jsx(
        sa,
        {
          label: r(`labels.${l}`, { count: 1 }),
          leftLabel: "R$",
          value: a(s[l]),
          onChange: (h) => c(l, h)
        },
        `${l}-${d}`
      ))
    }
  );
}, u3 = ({ open: n, onClose: e, onSubmit: t, socialNetworkObject: s, fieldsCache: r, type: a, onStateChange: c, cacheState: l }) => {
  const { t: d } = Ze("sqModalProfileCache"), [h, m] = X(window.innerWidth), [y, b] = X(window.innerHeight), v = He(
    (g, S) => {
      const x = { ...l, [g]: S };
      return c && c(x), x;
    },
    [l, c]
  ), w = xt(() => r.every((g) => l[g] && l[g] !== "0,00"), [l, r]), o = xt(() => Object.keys(l).some((g) => {
    const S = l[g];
    let x = new Intl.NumberFormat("pt-br", { minimumFractionDigits: 2 }).format(
      s[g] || ""
    );
    return x || (x = ""), S !== x;
  }), [l, s]), u = He(() => {
    const g = r == null ? void 0 : r.reduce(
      (S, x) => {
        var E, k;
        return {
          ...S,
          [x]: new Intl.NumberFormat("pt-br", { minimumFractionDigits: 2 }).format(
            ((k = (E = s == null ? void 0 : s.socialNetworkProfilesCache) == null ? void 0 : E.find(({ contentType: R }) => R === x)) == null ? void 0 : k.contentValue) ?? 0
          )
        };
      },
      {}
    );
    c && c(g);
  }, [r, s, c]), f = He(() => {
    e && typeof e == "function" && e();
  }, [e]);
  ee(() => {
    const g = () => {
      b(window.innerHeight), m(window.innerWidth);
    };
    return window.addEventListener("resize", g), () => window.removeEventListener("resize", g);
  }, []), ee(() => {
    o || u();
  }, [o, u]);
  const p = /* @__PURE__ */ A.jsxs(
    "main",
    {
      className: "content-modal p-3",
      style: h < 991 ? { maxHeight: `calc(${y}px - 58px - 61px)`, height: `calc(${y}px - 30px - 120px)`, overflow: "scroll" } : {},
      children: [
        /* @__PURE__ */ A.jsx(h2, { socialNetworkObject: s, type: a }),
        /* @__PURE__ */ A.jsx(p2, { fieldsCache: r, onSubmit: t, onChange: v, state: l })
      ]
    }
  );
  return /* @__PURE__ */ A.jsx(
    Ua,
    {
      forceMobileNoMargin: !0,
      className: "modal-profile-cache-component",
      open: n,
      onCloseChange: () => f(),
      header: /* @__PURE__ */ A.jsx("h5", { className: "m-0", children: d("title") }),
      footer: /* @__PURE__ */ A.jsx(
        f2,
        {
          hasChangedValues: o,
          hasValueFilled: w,
          onClose: () => f(),
          onSubmit: t
        }
      ),
      modalSize: h > 991 ? "md" : "lg",
      children: p
    }
  );
};
const Xs = 0.2;
function d3({ dataSet: n, color: e = "blue", className: t = "", ...s }) {
  const r = Fe.useRef(null), a = xt(() => new Tn(), []), c = `random-id-${(1 + Date.now() + Math.random()).toString().replace(".", "")}`, l = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"], d = ["00h", "03h", "06h", "09h", "12h", "15h", "18h", "21h"], [h, m] = X([]), { t: y } = Ze("averageEngagementChart"), b = He(
    (v) => {
      const w = n == null ? void 0 : n.flatMap((f) => f), o = Math.max(...w);
      return v < Xs || v === null ? Xs : v === o ? 1 : v * 100 / o / 100 * (1 - Xs) + Xs;
    },
    [n]
  );
  return ee(() => {
    (() => {
      const w = n.map(
        (o) => o == null ? void 0 : o.map((u) => ({
          value: u,
          percentage: b(u)
        }))
      );
      m(w);
    })();
  }, [n, b]), ee(() => {
    const v = r == null ? void 0 : r.current;
    if (!v)
      return;
    const w = v.rows;
    v.tHead && v.tHead.remove();
    for (let f = 0; f < w.length; f++) {
      const p = w[f], g = l[f], S = p.insertCell(0);
      S.innerHTML = y(g);
    }
    v.tFoot && v.tFoot.remove();
    const u = v.createTFoot().insertRow();
    u.insertCell();
    for (const f of d) {
      const p = u.insertCell();
      p.innerHTML = f;
    }
  }, [h, y, l, d]), /* @__PURE__ */ A.jsx("div", { className: `engagement-chart ${t}`, ...s, children: /* @__PURE__ */ A.jsx("table", { border: 0, cellSpacing: "0", cellPadding: "0", style: { width: "100%" }, children: /* @__PURE__ */ A.jsx("tbody", { children: /* @__PURE__ */ A.jsx("tr", { children: /* @__PURE__ */ A.jsx("td", { children: /* @__PURE__ */ A.jsx("table", { className: "engagement-chart-values", ref: r, id: c, children: /* @__PURE__ */ A.jsx("tbody", { children: h == null ? void 0 : h.map((v, w) => /* @__PURE__ */ A.jsx("tr", { children: v == null ? void 0 : v.map((o, u) => /* @__PURE__ */ A.jsx("td", { children: /* @__PURE__ */ A.jsx(
    "div",
    {
      className: `element-value background-${e}`,
      style: { opacity: o == null ? void 0 : o.percentage },
      "data-tooltip": `${y("averageEngagement")}: ${a == null ? void 0 : a.formatStandardNumber({
        lang: qe == null ? void 0 : qe.language,
        number: o == null ? void 0 : o.value
      })}`
    }
  ) }, u)) }, w)) }) }, c) }) }) }) }) });
}
const m2 = "data:image/png;base64,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", g2 = "data:image/png;base64,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", y2 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAZwAAAGRCAYAAABR3wXnAAAABmJLR0QA/wD/AP+gvaeTAAGmz0lEQVR42uy9Wcyt+13f9/nPz7DGd9p7n33O8fGAMT7GYAyEMUBLIBAgKc02KhEB1AraUJQLUrUqN6et2psOkRIpDVStitqLyL6oSKkJaqQ4HWgDNmCMDcc+ts+897vfYb1reNYz/YdePGvvYyyaoCiAh+cjLenV2mvaa/3X+ur7GwUjIyN/iE/9ne9zE3az/S4tUXpmTSj7KJKirdpdXInWb9lt2+6Ba975gY/3AtL4ro2M/IsR41swMjKQ3n9PvfBgVxY63Ym+ve276ok++qdE6s5C8CZ0fQp9vExRvhI9L8jav17VYb3t+vZ7/qfz/Sg8IyOj4IyM/POFJiEu/+cfvh1a+c7gq/f4fveuELu7oauPUuytNroRKcTYx9T3fd+3fRO6eJ6E/t2I/v0Y0/W2i5ei3732XX/vYgeQQHzgHvLZZ59VAM8+9/FufKdHRsEZGflyFZrnkK/O7i3cLfMuIcIPhNB9T9+2d1NsJtpgmn0n27r1QoRWEHwKIYWEEAmJb7vY96+GpF8y2eT5dt+/3Nb786T0x6VSD/NkYpdsDLLSXTJRtavmm//2q83hSzc6oZFRcEZGvhx4/7176tu+m7vCxW+SOvxgMLMfaHZ1EXwwKUSxvb6h2e/Yrje0dcP55Zaq7pASnJGpyB15UTKdmDTJRCwK6Y2z91Xsf7urm1dDSp8C/QmkvrTWWIWMTdcsm77zIcadivHBx6pXH/70L9KPn8bIKDgjI1+CfPgX3muO+ltPoM13pOh/IoTwLejCmckRfduyvV5zef8hSiaib9nVkYdXFUYrrJUE37GtamLfMckV82lO1weUTCyXGcu5TfOZ/L9809yX0v1Do9XvNk1cW2trTx1Fl9xNVZWd98u+E1lD/VJR3Zz/0/+R7jmI4yc0MgrOyMiXwDl/8W9/7+1ayB8I3v+EEPy5gFPa5fR9YLep2N6siSkhRUTbjCQdQWb4mPB9g5MBrRLJt8jQEn1H2zZoJen7SOc9zggWU8FsIhsp0vNW6/8zwod1ii/JoF/f7Vav9RuVtt3rESDocl41fkpot9sb6hd+ld0oPCOj4IyMfJGSnkP+weQvvaf3/I1d0/4bItQLbbTQ+Yy69mw2NX0AZRwmn1Aulmhr6Zo9odkQQ0DLxM3lFZv1Gkkihh7f96ToIUW0hiLTOCORMpJZRZkLjI77ycR8lhg/Sud/s+/UPzbbT3/qK/4u7Qd/Fvf9f5f2OZDvvMfU9Jz0nmZ1n4c//ZEx1DYyCs7IyBeX2ID4vf/6L7+vbZr/uPPiK4mdU6InqYy6V6zXNdn0iNvPPMPs7ElMXpJCoK3WbK8fsj5/nfXqmnq3JbOSvu3Z7naQEsF72qZBkOi9J3jPpHTMS0NmAmUmKQvFZKo7KbvKCH5LePGr+7r/f28uXv/IRUX/vg8QHr3WD34fbiUpgsXUL7MaRWdkFJyRkS8aZ/Od+venJz+33u3+U2GsIbSia/YIqdjsBUjDrafvsji7g3QF1mXEtqberNlcnXNzfc3lwxUPL1Zc3awJ3nPnZMLZrVvU+5qLyxUyekQKrKseZSyTMiP6gFKB44nGyo5ZmVjOFWWZPNFft1X/auf9z37L39n++h/1un/hvRTZgvyzgfVzH8KPn+TIKDgjI1/Aruaj/829J4xIP7PbVT/XJ2VjiAh6hIggDUIobJ4RosSYjMl8Tls3rG9WrK43XF2teXhxw2pbIZTBaEmmE+tdy9FiwhOnc3KnWF2tqPYdXRR0vafte4SQZEbS1VuOJpqThcWKhlkeWS4VRWmu66r/8Orh/j9b1fVvvO8DfH5/jvjvf4hJsyH9zIfYjZ/oyJcSanwLRr6U+OH/8t6brXX/0a6q/+3NPhRt3SGIaDm4kdB33Kw2vP76Nft9j3Oa0DW0dU3X9vgo2VYdD683nN2+xWJe0nc9N/ueJ564zZ3jKX1bc7OpcHnB0ekpfdfQdg0xQRugbTqsNUgh2O32pOSJIeE9KC1sQndVw9/vts3sA5/k5vP/D//wefof/Sqydz9J+NCLYxHByJcOenwLRr5U+K3/4t6pVPpvbbbVX7u4rGbSWIxSWNXjmy37fceDq4Y+CLLMMZ1GROrom5YQBSImCmd401vexO2nn+bh+QUPzi+4deuErz4qESnx+msPWG1rEIoudvRhQ2Y1k1vH9CFxcb1FCoMzhhR7QpdoQiJDUneJ61VUVoc7pveFlVYlOvFHNIKmvqZ7u+IYOB8/2ZHR4YyMfAHx8ee+cxK1+MXax3sXV/spQiGVxJpAsz5nt9vz6kVLlIYiM8wmltkkw1hLvff4pNntO7LZDKMVs0nObDbjmTc9ydnRFKkUH/v4C3RRIo0lpQQxIASEJGj6gNOKk0WOEhCCBxIpJfoeYhKklNjuGpRKLsr0FTGJf/rgrH/4S3+Ei/lr34CUkbd84FM8GD/dkdHhjIx8gfD+e89an+fP9W137+amInMTYopAx+7mir7uadKMxUlJiD1labhza0ExmdE0HalrQGrc1LG52bDfVdx64jbLk1O0m9K0nv3FA55529u5Pr9P0zYEIj5GbqqWMssQCF4+v6GuG+alRRKpmp4YAkYmqr3nWglSCMSY5FvfvPiuYOqv++Rn9r/7h6wNCJ5DfOhDyOoJfYuxbmBkFJyRkS8M0nPI3xGn97ab/U8jNVpLJHuSb9FGU54cgXkTQeZIm2OtxqSGervh4eWWXdWglKJua/rOo0RiuVzQtx2vvvgieVEymS+4/fTTnN65zWuF46UXX6ZuAyhNV1VUu5qQEl3bEmNP37VoJYa+HJHYdwFiwCVF0ybO155nfNSuMO9+67N3Z3zktWsOYTUB6cOvo3n7dFJ45d5/78b+EYUFIyOj4IyM/Gnz2/zr72j77m+IFEuRIk4n2raDmJAa+hZIPYFIamt06bha77jZdWzqgPeBq9UNfRTcWkxZTjP2dUvTtnRtR+SapnuRbDLl7hO3ufXEbQA++fynabue+5drEIJd3SGEQBDwvWeWa2aFpe48dRuZOmg6j5YQIlxf78XTT06+enKnePZ3/72nP/YHl9PqfR/4eAeIz6wQt+ZyGpXarz4zDvoc+dJhzOGMfNHy8ee++agJ8W82Tfh+q6PzvqdtW3zfE2NCKk3dRoKPbNc7tMnAlFxte663Pettw3ZXsdnWlOWEO3fOKKczkJrOBy5We262LcYVZM4ihMA6w3IxYT6dIEPLfFZyPCtZzkqc0RzPp0zynMxqQhK0PTijiQg8GqUVViWWpaQsbZmX0+NUFGfLaWp+8uvPwn/3fQ/3TqGa3sUm6tWPfHC/GT/pkdHhjIz8GfIcyG3df3sX/V9XWk22mw0xQrXvQChMXjKfLmgerrhabVGTI4qzZ+iaHW3vaXZbMiUIKXLn1ilPP/M08/kEISQRzcnTb+WZr2jx3R6ZPFIKiIHY7VmtK0xW8pVf8x6k0Tx48dNsri45v7jh8qbiZFESfI/Smv1uj9EJLRNOwySTyNjggxebTXeSqP5NV5bfq7X5PSPFr/3G+p3/x9763+/6taRizbjKYGR0OCMjf7b8V8+9NxdC/ocI9U0xBq6uK/a7NTFKjm49wdGt2zR1Tx8UIp9z9sxbkTrx6Y9/nJuLS4wxKGW4ffcJnrh9zGySM8k1VnpyFTAikbodbbun2m7wfaRpei4ePKCqai4eXvHg9fuc3Drh7O4TFLlB+Ibcwq7aI6Tg4nrLuukHx9R5NvuOqunRGqwR3GxqoVKnQkh504s32cJ8W1L666Y2O8rNVEhhtv/Db16ux0975EuFcdLAyBclH3/uvd/mEb+8q8LR+eUeJT3zqUWXpyRpaXtFwNC1FVEXyKzg1U+/wPrqhqyYMDs+IS8KrAbrNM2+GiZFG8P98yuuVxtW24Z95zlbTvAhYW3O0ekpKfTEriXLHVJKnnjqLmfHU2SouXzlRbbbHdtdQ910NH1iU3ek4OnbBkg4I5DJczSBet9SOMF8UnByuqQsi5CXeR18/1JXt7+c2uZ/ybrPfPTrx905I6PDGRn50yc9h7wSxz+3b8J3tn1CELl9apFKcXNTs7rZU+1runrDzfU1UTruv/wS29UK7wPaGEiBq8tLet+yq3ZcXa7YbDe0XYcU8PxnH7DrwOY5zmpee7jhpQcrqtYzXyzxCTbrLU3bsL7Z8PDiith7lvOSwkmMSBgFhYEYemISSAH7piPEQO4cIQQg0rSBzBmWyxnGKqGlYLvZn7Vt+23aqq/s0vzVf/89Ny//4kfGqQMjX9yMOZyRLzqe5ytvJ5rv18rijCDTnq6uuVoFqibRekHbefLJnOubCr9+ma5tCSHR+sS63dBdbtl3PW++M2M+LbBOsa97aHvu3l7ik8RYgzWapvX4KOgibKuWhxfXPHnnhEmRkVtJtd1yfXXDarVhkhlkbLl9NMO5DKsEt/D0UYDIubyCvve0MfHSwwYjEzMnOFMWKS1Kyk6m/rcz0V9vQ/cdTau/PSWRNeLN7sM/9dl/NDqdkVFwRkb+FMmV+Lqq755RItLXLUUB623Pet3R+UQfJU3QbK63PH+/YtMEWh+RQlJOF2ROsq87Zk7grCZzGoRgtW3ohSAJzenRnNevG4wKbPctAc2uqfCpYtv2rOuOb3nPO4aqNGcwsef+1ZpV07KvW155uGFqJctCczy3WDqcExS3Ss4vNqiu562nGTf7FiNhNimo6z1aK5zwVW74mPdRNjF9jw/pGzIjf/6yvX0OD36TsZBg5IuUMaQ28kXF+++h3vTmox/3Mf753a5lu6koSsGDhxW7vacLgtoLmiARUrLa9zitUFJgsoLjxZR9VXFcakonKTLL6emSpgvsG08ToJzkxCDoRca66nEuY71vB9FSBmtzYoCr6xVawvJohpIQ2xYtBbnVNF03OKo+cHXTENIwqy3GyHJREkJkX3cscsHRVDItFJkVpLDTRnWTlGJrlfq9tu/eXu391BoKEePFv/Y11W/88u+M4wdGRoczMvInzjc8+8zUh/ZrhJT0PuEy2O4ajDWUJexbRd9LTJLEBCEm2j4SkORWs9k3LGdTRGyQSoJUWOtofYPLC3abmq5PzJZLLuodk4kgpkQSe+7eOqMoS5IQLMuMtm342Av3+fTLrzMxcDLLSAmkgFmesW9a6rbHaMX5jedyA5NMoVZ7jFacncyxosf7ls12z263Yzm3ZJk+Kax4SiYRSlx1s2uBUFmd7j5RHZ3C9SvjSRgZBWdk5E+YPV5OhA5SRYL3FKUhCcmuAa0TE63oqsQsz7jceDJr8CmgpEErSVlM8H1H9JFpmTGZTYlCUTcd5WxB1Umcy0Ba2u4aRGK9q7BG0/tAta85WiwoiwJFhNDjQ+S8bniw2lEYxXHpMFKhrT0IXmDXtEghWO0OglRaLtYdhYnMMnAK6qYjxYCUmbRH+i0g7uxazgSgpdiISFKqm46nYGQUnJGRPwVCI5OZ2k9F6o1WzM7uTlFWUU57rleKV16vaQPst4GrKuKsoyPQB0GMCaUkREkfJNpaprMZD86vCVEglcE5h9KGfeupqoq67Wn9UBxmjeGJsyOOF3OK3BEKw2ajadoWXQu2O89q17HeNogUOJ46CiMRGo6mJXXX09Q1PiXuX3VYo9gp2DWJZQFWKKraY9Yt1pp575lvd57CpWC0UrHhPFNhXMo2MgrOyMifBrs2NouO16XiZZupd5WznGrvefW853de2NN4R+8jSgrqHia5AyPZ1p4+RPLcse1bppOCvChweUG82ZOIdD4RgkcqySv3X6dpO86v1rjMcXZ0zCSzLMqc3CqKzOKVQKRECIF11xMC+Chw2hCSookK2UdCCExzzcRpDBmt72n3Da9d7rFacjRRTDPDcmopjGBWJDabhq5TlKVjOnW1EvEPkg5/kGXZGurxIIyMgjMy8idNPtcObQrpdL6pb/jQ/73iatWx2wv2ncVYRx8DQkmmZUYfEsvFkmIqWG13JBRZlnG0KLl955R9F8nzEi805WTCxc2OT79yjbEZ67qjnC0xSrHd7WmaBmslPnr6GMmswThHUZYcIZh6TxTQdR31do9PnlZIdk1DFyNOgpZgteLOYkppDZfblpud575K7PawzHuMtpSlY7YomORs6cP/Hrv4gYD69V/55KoaT8HIKDgjI38CvP8e9sknUXlauCwvz4TS79527Xfdf71764sPAkonFhPL9S5itcAYjbWOTdWSlSUahbKW0+mcfDpls94wKSaU0wknZ6c8fLgiIDm7c4fX7l9Rt4HlwrKvPTafQBIIkShcTl5k2GLKvgvs6xueefqMPLMcn0yZFRkQCX3DarOj6T3Vesd+s+Z0OaFuO/pmT/Ad26rFKsit4qkjx7qCPiT2XcJKyfUmkJeR6Ux3TvI7Sdrf8oaP6ptPPXjuQ2OF2sgoOCMj/8r58E9htt2i6NtiWkzkHa/MD1kpvum1+/tv+eTLLU+cFGirOb/x9DGA1FRVz2I5JZ/m1K1nOiuHyQJCIpXEOYe2ivliQUxgrCUmiEiub7ZopciN4zMvnZNCYFoWzGcTnjhZsJjmGJUop1Nm8xmny5zMKQQBUqLre0gFp8dTqromPLGkbW5xc73hweWa62tJ6FtmxuKbPT70pBSYFRpSQIqAc4qQYN94jCNkWWFjr13WhJPq+G2X8MIlYx/OyCg4IyP/aknlraemM3OqjV1Jrd4mdPz6za77qk2VTJY5VntYX3QoW3B07HjtqiEqx64VnJye4rqeuu0QRqKNpllvWW0rjp6+g8tzVjdbYhRIbbi8uiGEyHI+o6p7ui7w5PGE22dHzKc5hU6c3Z5yfLIkyxzWanxb4dsGkSLJD4vXBAl8x9xZQhR463DZMce3lnziM+d89pMvQhQEWaCNRLZrchNYFhqrA04Fpi4igZdfafLFwr57MTe5cTrP1NT9xs+/9fkXP/np19/3AcJ4Qka+2BgbP0e+IPlnP3P32E7sX5Qy/IzNxV9ou/5Hmi599cV1P79YRVl1Eh81xjgu1h2th+PlHGkysrJEas10MkMoaJoOKQS7as+rD8552zNPoiSsVlu63nN26w6/+3vPs1gsMFnG5mZL33W86e4ZpZOUBp5405sIwRNDIHOK6uaaerdjv9nw8LXXefHTL7K6uKZardnvKrqmQWvFZDZBCkGWO26fLThaztndrJgVmkIL3HTBet/z+lXFetcRfIAECYHRObuqNzGIU4T8eqnTN5dSXd+ZLa6+/c7V5t6zmPd/gvSfjI5nZBSckZF/acTPfsfRrSjjvV0rvm+1Te/qgzkS0urWGxFlBtLQ9JLNvid3hpQETR+G/hhjsMYQYqSua+q2ZVfV7KqaGCJvunuHuukhCYoip21bzh9ecev2bYw2rFfXOCUIvkNbTT5fsKsqMmdQEh6+fp/LyxXnD1fcf3DF+fkNPgqkshRlQZYXaGMQAvp6T6ZgWlqsguN5QfQ9m/WaFHpSV/Hk2Yynb01YTBx5ppFC0PmEK3KOTxYoKYQxSSM46WP8bk9852IymR3NJicXX1Os/v6Hq7GQYGQUnJGRf6lQGojXvyPXTpcmn2TH03l+q/bKXd0IGq+IwqB0htEWbRxCGaSUOGep2xZrDXmW0bQdvQ/EmNjXLSEEMmuYljk2y9BaobXi9fvnLGYzpvMJbVXx8PycXbVnPp8yW8zp25ZY71EicX11w/2LDZfrhtcuNnRdQlqH1BZpLSEkttuKXVXR7Guq7Z5qV5F8IMsdfd9ydlJQlBYpBZtNzWq1po/Q+wihZV4qnFX03dBUmk9KSGB0IHdhnbx/KUU9j0mVXqibH/vG0Pz1out+6cVxmvTIFzZjDmfkC5Km0SEY8UJusn/iQ/xzShumC0NMlqoJ9EGhbCKpHp0ECUVEYWIipUC332GVoyEhhSQzhkmRUxYZQgjKPIOU0EoiE2RWk3zPw/NzmrohyxxlkXFxfkFdNxxNctq64abuaQLs6o6z5RSrNb73hNZzua5ouw4RAzJ5Mi1YFI7FNKfvIn2A41tHWKe5fQuMUizmE1565YLnP/sA6yyFkNxUDVMHR1PNbrtFK1gs5+iYIfq2dFp9jFj/oxC6TZKxs3W+2L7ddB/MV81v/Cr9c4zCMzIKzsjIHy+eBumj6qhFs1dRZJ9+dT2rO4kyjj5pbDYlCY3LLVJ7+gCbXYO2hhihbVp09IQuYJDozCEShOg5Wc7I84zcWaSUNPUeqwRFnrHbVWxvNggBTz55h/sPL+i6wLRwXK62VE1HlJI8LziZTXj5/JqJzal6z66q2FV7vA8oIifzgmWREaOn7XbUbUfdDo7l1p0zTm7fRSrDpnqVZ976JDWO5z/9GrV2WN/ThYgUgVme2G83GCVJIUdMi0zZ+EMq6d+rmutfaxf3N/zO8EVenZKeG/M5I2NIbWTkj88Hf/Ztrsyzr1U63lvV7c+sq1iuq0DTC1JUrNYNDy5vqPYd29rjIxR5QdN61lXDbHFEiAKlNCFG8jzn6PgIKQVSSOazGdYqlJQk3xN8RzkpeXh+wXZX8eTd2+x2ezbrLU4rog/UTceuaSjzHKUUr1+sOFsuaLxnu9uzqRpSkiQhcNaSu4LMOYzVnBwtiTESfKBrGlKMFHlOUWZoEbi6qXjLM3fo2kDdevZNT0qwayIxJlIMEFpyp+iaDuPckdRpkmv30bB1V3/+H2y6X3qR+IFPjGIzMgrOyMgfm0/97NvcdLF8m8rU+zat//HzK39WdZKQJNeblptdz67uqJrI5abletvQdoHOR1zmyPOcvvco52h9z6QoSSQEieV8xsnxApEiRkusNUTvmS9mVNuKutpTOj3MONvscMZQ5jm992z2DadHc9o+UHeB48WMXRuQQlBYw+lyytnRlCdP5iwnJUpJohQ0vacPgTzPKcscKSVKGW5W15RlyfJ4iRKC88sVd5+8y2ZbcVpKrEzkdsjl5Fbjk0QRmU8VoaulzVQRvV/h4/mPvmO9/aVxZcHIKDgjI3880nPI951imieeOk1G/uS6an/kwcX+6fOrhvNVTecjWhmapudm19D0njYMy9IeuYK284MAFDlKSJSUKKUpywJnDUXmOL11hpYCYw3GaFIMg9PpOoxWZNaQwnBd7iykhI+Rs+WcrvNMJwVP3D5hNpsxnZRMSsvJYsakLJjlOU4lnDF47xGA0Yq6C1hnsFpgjUE7hzaWpqqYLmYUec5mU9H1LYujY65utjy83nK5rtnVHq0EPkaqtidzEiUC0fdFCOnIh/BJlfTqL76l2Y0OZ2QUnJGRf5HYgPh/3vNkltTtqZ5lf6UN3d/87Cs3b7redPQBitxgtUWJR/0pBiEVeZZjtEYIgVaSzDmUUkgBZZ5RliWS4e/ZtCR3ltliTvI9mbNorVBCoITAao21BqUERivyzGG0xmhNkTlIidkkZzmf4oyisJpJbpjnhmlumRSOo3nJcl5yerJkPsmZZQ4tQDCsKPAhopXAKYnLHL0PeN+xPDliOimpNisW84KUBF3dQBhCbFUbWO08KQm8j6QI+72XwYdjq8Qrdde/2JTF7t5bGj+KzsgoOCMj/xx+8KcwfX3HTk/yN3ei/8/vX1RvffnBTtQdhCS4dTzD+8S+DShlWC7mnB4tMVJAChgBkoiRCWs0ZZYxKXKOT4+ZlDnTScFsPiNzmjwvsGYQKWcsWim0UhRlgRSgpUBJhVIKYzS5sxSZJbMarSS+98TeI1Kirnv2+47V6oari2sur2/YVTWrmxWz0nK0mGIkyBTIjGTfw67pmZSO2WxGQtDWNVnuWCznTCYZ15dXlIslm01F6hucFogU8VFwteuxWiJIGC1JMSql0lNWi+enWt64pMNPLrt+LI8eGQVnZOT/x928+k13F9nCFhh+vO6598kXV2K17dDacPd0zmqzp+0TZ8cL7pwdQRJcXm9Ybyu6PtD1PaUzlFlGWeQ45zg6OmI6LZkv52RGMZ1OsBKcsziXo5XGWIuSMF0sCb4f+nKMIQYPKTCZlMxmU5qqZr+vsc4yn04QQtA0LdJotBl6gIwxVPuWm5sduyby8mvnVLs9p8uSO7eWhLbBqoCRgk++dMGsMCyOlgC0bcd8OcUZTUoBn0CLyIMHF8jkKbNhhUFpElIwOKA+YhTMS1Um5d5jRHy3y5VvJuL8B9/W70enMzIKzsjI5/HDf+tW6b3UzrlbVV//B69dhzubbUPuHNaawYnYjLu3lmTWsF7vuVxtuFrvCCHijGYxKZiVJfPZhOOjJbdvnzApC6bTCUXmcFZjjCLLcyazGUoJrLMYa8jzHJM5nHNY6xBIhFRMlsdopUje46zheDkbenhCJHcGpxUqRfA9WiSs1mSZQQmBkZJd03O52XO92RN6z8nJknJS0DYNi8JyvtqglWQ6nRD6btheOi3REpq6IiEgei6utxATpGG+mpYJZwRKKayVFE78mg3hF9oYjkPwX+2cmc8mev1jz3ZjIcHIKDgjI5/LT7zXfUURsq0v4l+VLv/LL3z2OlNKHfInitm04Ox4SUKy3TVcrTZs9g29T5SFYzktOF7OOD5aMJ1NKQ+u5OTWGYvjIzKjyfIcay0ucxij0epRyMyilEYJgdYWgUBKNST1tQYBSg4hN+ssuctYLGbMFzNm0wllWTKfTpjkGbnRZEbjrMFoyaLMQUh2bWTXdIgUybKM+ayk63piiIfXMIhe17YYLZhMpojk8X3HbruDBNc3FU0fgIQzmpASfQAlBUWmV07af9DV/pcT/TVSPiVIR7WX+Z//Rv/ar3xkDK+NfOEwNn6O/JmG035TijLM5dz78I27qppIAgmJAGbTDGcdyjqqmx3bXcW2bmm6wLwsOF3OmExKtHU4ZymLnPnRknIyIc8cmTUQFVIphFQIIRBKQYggBUhJSomEBAQmc0hjsSHQNTXODWXTpCGUpYTA5QUpBUIIJCGJMdI3Ld73dG1L3bT4rqdpW5qm52K15f7Fil3VE9KG05M5x8dLiiKnbhqi7/DBIRBsN3ucM+RFwbTeUZYZiCGX1LaRPgRCFCRgVhpiDOyb+F498T/mlP95+1L9y+2T4te988ddk8xTPTnQjydtZBSckS97BKR/JtWTpPZrndNff7nxUgjBo4uSGq0d6+st1b7i/HrLuuo5nRcsCstyVuKyIUxWzhcUkwnFdEFRTjDWHgRGI6UCqYdnFI/ULgIJoRQxRlIaHIeUoI1GBI8ocpJvhxE4xh3KrBWkRIoJlCSlSPSBGAOJRAyRrq5o6z0hRO5WNU9fL3j5lQfcVHu22z2ytCxmE2bzKSn09F1PPinZbDZkVrKYZcQET95e8pkXz8nyjBACXedZ7VqePC3YtwGZSTZVryLqx5Zm9t9+74d2D2F//zk4f+c9RDsuMBgZQ2ojI2/w735b8T3O6cxk5pslTFaboEBQFhPyvEQqzaba89rFmqr1nM5yZoXjqTsnwxK0W6ccn52yPD6hmM7Ii8HxKG0QgBQKITWChJByGPwiBVIrhFAg5ONhMEJIlFRIMWz51Hq4n81ytDFoPYiXFBKhJCKl4TkQKCmG3h8l0FphjcFai1WSLM/IlCC0LaSIl4pqu+Xk9JgkhsFnMUmKoqDaXFMWltIpVjdrTpc5Dy42EPwgZt4jUmA5tVglyIykC0nbUi7/6ldU/9sHPoH/EKQPfGK4jCdsZHQ4IyMHvIinUaYHWqRGyJSO5xk3O09R5rjMsd213L/a4iNMc4MxijtnxyyPlyxPTrGuwB7WAWhjUdoihISYkNo9FhLEEEIjPlYXUkoQQSBAKISUgx5JicsnQ+VaZgahIpJiRCoFQiBSIqVEDB4hEykKhIAYA1oNQiQE4CzGakQ8Rgp4/cFDknWIsqCqGu7cOWW727He1sPmUJ84P7/k1umEaenQoudkkfHqvsYZhVWWEANWS6alo2v3GKm53ulvPS5vvwse/OZ4qka+UJHjWzDyZ0W6h9Jazqyx0fd9SiHoshDMphOsdfR9YL2rKYqc3BmkUJweLTk5PWZ5fIR1Dm0M1mWYvERZO+RrhEQoA1IilB5yNRyMjJSPBWcQIjk4IKkAMfytLEK7QbzkkE9KKSGl5CAlgzMS8hCuk0h9eIwYEUKhDqE8ZQxSafLMsjiacbyc45s91llA0vtAMZkxm89Y3VQIadlsGna7isJJYgg8dWuC1oqIIKaEUYKu91T7DqEzrrYdbdcfRdRfef898vFkjYyCMzLyeXxkiVNC3XZWL1xmmnJmg7WS2XyKADbrLXluabueuu2Zz6bcvXPC8emCLM/IywnFfIHJC5R2SO0QUiHV0NiZUhoSRSRICSEGMULpIaejNEJb0kGYHl+0A2URJkMqM4gSkpjEIDhSD4IzKNcQYntUlCAGNySEQCqFshZzEMaiLDk+WXCynBP7gMsL2tbjsmxo5nSW/b4lKUNVtaQYmE8ycqfIM4WSghgHk3a1brlYd5zfBNaNICWRXa+bv4A5eed4skZGwRkZ+Tx+5RdprFI3Uog3aWO6PNehKCYIBL73OKvZVTVGCUJM3Dmdc3Q0xWiFLUpsUWBsdgijcRCUIS2ZxBA6Syn9IcdD4pC7UaAsKI3KpgidDUIjJKTBDwllECY/CJABPdw+AUlqhC0Q2oIcRAmpEMaBVMRwyNiHAEKgjcUYS5Y55tOcWG0Jfc/06ASpFC7P0SIOc+F2NQlDShotE7NpxtmyIApJZjXXW4/3CUki+IDNcvY9ovM8KwV/6X/9QYrxdI2MgjMy8jk8B9G6yQelMA+cK17TxrRJFJAEXd/TRU9KcHG14XhacLQsyYsMW0ywLkcqi1BqcCVSIeIwIWAwHnIQGuRjMSAKkjIHgVCH4y9IKQ5ioSzSZMNtEcTgB3ERatgqKiQkSYqJFOMwg1oZktJDabXUj0NyCUn0AYQktA2oIexmXUbmLKUztOsVV+fn9F3PpCxJMWHzjLb17KqOza4DoSis5KmzHKdhUjhyp+kj3Ow6pEi0dYuRkBdZEQQ/uitnXz2erpFRcEZGPp+oXvAx/U4IcR+SEwhFSkPyfVf1bHcNRWY5WU4piwzjHCbPB4GRB1FJjxL/MATQ0uNwl9AaxEEQtBvMCwKUIUlNkvbRTUlKDQITA4lDrw4MxQRJgrAgDEJlw2OmIZ+ThBweCwlCkeIhXySGPp9HZdRSK5TWuDxnOslxStBut4SuR6TA6e3bNLsKpKSqGpo+0fcJEpQTx7QwXG8bjqYOKQUhwb5uOSoFzimCD/R9fLtP6mt5owB8ZGQUnJERgBjzcyXLF0KfrqNXgiRpmobeB5rOU7eexXT4gS4OTZ5CauRhYnQ6OJQUA2mIqw15lENYLCUxuBehDtfJITwmh/yNsNkgPmLoqRnyPgfXpCyYHHRGUgqMRZghrCaUHqrQQhwe85DTSdETQxgKCMTBPQlJioHoPUJptHXkZUFZZIRmz+ZmRd91qDj0aAYfqfYtm9WGuhvKphcTy+lRzs3ek4Si9QIlJVoBKdC1LSkF6j4JK/V3v3/8bo+MgjMy8vkHcN0RQya1U0KY2DSBXd2wbwNV3aOVIrOWclJQTKcom6GUHXIy4o3jm1IkhUFghp7OoWhgcBiHyjLkUCRwKIPmcbm0AaGH28lBTIYQ2VCBhlLIbILQDmGzIU9zCMmlBCl4EoIYE6HrDt5iqHhDDMUJUplBfFJASonNM5w1OK1ZX17Tty1Ez6RwVPua3kdCEFxdbmjagFKaW8clWmvWdWA+zWk8XG09613HxAraNnBTBaLkO+W/dfSO8XSNjIIzMvI57JjIFPXC2lx3vRLVvqbvAzdVy6pqmU0KXOY4OjlCGfNGAYAQB8fC4CQQw/SAeAhhpTQISgzDimYBGHMokz64Ig65mBjfCLWl4bqh2kwMSf+UEIc+nuQ7ku+H+/t+cFbBv3F9jEOOJwRi6IfX9Oix4hCuIwWUVORFRp45QufxnadvW8pMMy0yYohUdUfwka5L+AC3jnK00bxy1VJkGSeLAm0c2xb66ClzyZ1jS/D9sVDym8fTNTIKzsjI5+BMmyfEdL3df91+H6abXcWuiWz3Hq0MMcHRckZW5MOP9uP5Z0OoLCFIIQ3FAelRBic+FqQUGcRCGUA8FpfhfhHCIBiPhCmFcGjojETfE31/EJTw2MmkQx9OJJHUEKJL8RCuk2qYHhACRIgxErqOmCJCH8qyhRrWXBtLUWSUuaXZN5AEvu0oMouSkqpq6ZOmrnvatiezine/ZYExmuud53zdkTvF2SKjDxol4GbTEEIURsv3jKdr5AuNcdLAyJ8tFaz15lu9cO9svRJ167nctPQhkTvDpMiZzmZoYxBCHy7yDXeDAKXecCWHHExKw4SBIZcyXJ98/4bbCP3jHEsSCqI/zFc7hMPEMF9NCDE4lcOInMchvHDIyUj5hpCFQIyJ6PvD4/NYBEUShyZThTQSaTRKJIwRlLnl5voad/cWbdsiSOTO0naJ3a5GhURmI6pUvOftc377hRV9AITiwU3Hw43muPS4W5aYBkH2wX/XeLhGRoczMnLg/fdQlW/eVdX99yZc0bSRth/WKlutsIc1BZNpibEOoRTp0XSARyGwg6AIIQ5VYZGUwiGEFd8Qh64l9R0pDnmUIXoWidGTYk/oGqJvSaEfLr6HR+G2OPimFHqQbwwXFUpDPJRhp0iKHkFEHOrkHjWeDhV0B/WREkhINSx7M9pg9bB35/r+Q2JI+K5Hkui7nqbuaPpI2wZiFFijeMeTxTBxQEqMUtw5mlC1iS4IjBbD86dQjidsZBSckREgPYe8e+epr4qh//Ht3r9DmgyfwPue3vthB43VzOYlzrnHTZ2PXMwQGktDIv4gLDyqMkMcci7qkDM55FEOc9AQ6nFYDKFJMSD00NiZHjWOpjiE7wTDvyEOTZ9iaAB9PH1aPXZFUojDgNBDzmeI3ZEO7mko4x5CfPIw+81lDucMmdVsVmtSgnrfoJXEKsm+bqn2nt2uo+sDISbe9mSJkdCFRIiJum0ByboKh+eMiNQ/GE/ZyCg4IyPAh158ZuZ0eN/96+p9+05ppCV4jxSKwjmaLmCUYjItMM4Oc8yEPFSfMYhBPDS8HH7b46FQ4FGzZzq4Hg5OY8idHORB20OD5yA6cBh9o9RhYoAdbi8GkZLKDJMHhBweS8k3ZrGRhtCdMsN95VBWPVTIhWHgJxHxqHw79Eg5OBEpBEZrMjc4nWbfEhI0TUueORazGV0f6b2gqXuk0kwLw3yisEaipGC9bZlkEpECbeexBqSQ/3g8ZSOj4IyMADrfvXW12/47VY1xeY6yGZuqZV0HNvsGrSXz+ZRJOXkcnhKPpgccfuiHwoBICnEoFEA8FoTPdUAJMeROHpU5CzmEzFIa9uUYi7T5IR9zKLFOcei3MQ7xqKT5kYMRiRQ96VEORwwCJYDk+yHcdhjoyaPQG4IYh9coDzmnFANKKVzmKIuCInOkkMizjLbp6LsOZxUxCfZdYlf1CCCzhrc+UaKIaCVxViJSxOnhfVJKXGqZ/sl4ykZGwRn5suf991CE7lsT6rRwiizLiSnSdR1N09KHSJk5itxhjEFJhbIOqc0bBQCHcBUpPRYbHs9yPvz9aEfAI2FKhxLpGA/FBENFWQrh0Ksjh54cZd7o05EKIQd3M3xj9KHPRyJtdgimHSJ6YlhR/WhkziCOb7gqYGhWPcxZE1IipMRYQ15klBOHILGrGqzL2G5ruqYhM4b9vqdpItWuQZI4mioKJ9AKFoUmRk8IHi1BitQ6ac/HkzYyCs7Ilz3PPotKieeNEp9KgMkyupDY7WserhucluSZIc8cWg0FAYfMzJAbOfzMSynfmND86PK56wMe/U0i+aFXJvru0LfDQaAGl4MY3I+Q8vHQziHnIx+vo+aQ/E8pDaXUj4oLpEKkITzGwU09EjBxCAMK1CCE8TBJ+lHFmlYopbDOUuQ5uTV0TU9Vd1iXsVrthteeJPs20TQRIQVKJualIfoep8EoSd9HtIIicy8mmd48nrSRUXBGvux5+CHiXOW/rZI/FwK0NrRtz77ucAaWU8eszHBOo7Qads0MEoMQEqk0Uj4qjT509D8WmsG5POrL4RCO+9x9ONF3h/6bMPTPHETl8WgbqRG2RCjHYbMBQg45meh76DsEj/JC8vC4h+d9vEFUHNzMYVTOoV+IGJGHVQbA4xChRKClHiZhK81mU9P1kaIoqXZ7nFZUtaeqB3eXG8kkl/g45HuUTJS5GZ47ektMbjxpI6PgjHzZc3FKqoy6K4X8A+c0xki6/Y7Qtzg1jCezWg6zwqwd0i6HH2h5SMgP02MeOZlHyXsF6dEE6KHpcxgt80aYTMR0CJHpx45myM2o/4+9N4u1ND2v855v/Ic9nnPqDDV2dVePZLObo0iKEklRimyYUnKRNBMlsR0riB0gMQxLvpDvKCC5s5UgBgQ4SOQEMZCAlAXZomVFCZmWOJgzm012N3uurvHUGfc5e/inb8jFt7tIy5BiOaIosfYCGoXaU9X5+9v/qvd917vW0uQzzV+iT5WQyHp3A9yEsYjowNXg2ySDNuZuew7kXZeBRCQ6pY56n9ymlUXqlEoqZQqUW/qNIqREKY21ltwqjNLc3j+hCxGlLdPpHCMlk5OWxdwB0M8k1kgWXcS5QFi2Gqu6vhyiXLAy8FxhRTgr3Ov42CfxHhGUKu6URYYylrZt8N5xsghsDw1WQdnLsZlBItLNWYBMjTXEm/5nqOSfFiURRSCZXUZEcrnhTa80QVy20qJvCb5dLmfK71YuIqnXUtWTPNJCV6V9nKYCAq6a47su+ab5QAhL/zYf09JnTHEGLCMKhDLIrAS5FCeYHIG+63Adg8B3yZUgyzKKoqAscnKrkUJw/fYhzguCg64NeBc5OKzBR3p5ek1mLS5EOpdk0p0Xm52rnvjEU6x2cVZYEc4KK8hgJ0LGMUJjjCX4ls5Fxj2NUhJrNWWRIZX87mxFqO9WNVKnSuV7sm3etJ0JIS5NnBUhsiQCQSQtjsb0IKFrEpG4NpUZy+oJpZPkOnhi2yznNIKwOCW2Nb6pCZ1bviYSYiDEgOvqZGGT5csKy6c50NL7TSxNPIWxyCwHlrHW2iC0JYSA1pqiLCkyizUaozR7kylRKBZVR9N4TqcdrvOMckmv0BzPW4zWNF3ABwhBEkV8P2BXJ22FP0tYWdus8IM5eMJKkcX7jcxR2iBjh/ORfq6YLhwP9nvkvQKlFUK+WdWouzMapEly6BgIIdBWC5rGEX2g7TqUzQmItM2fFxibYfMCgkMoeTdWINBCEIhol6s6OrXUQoTgls4DjuBbYleBT/EDcdkKIwqcX7A4OaabT7G5xfb7aT7kHaGpiN6hREQak5ZUBSk2QZtUtS1JURqD0oYss/R7BWtNy2HwTOcVdyZztkY5nVcQPNNZYNSHxy6UHJ22KKXQMtnouABVx/vbJtuE5mh12lZYEc4K9zTaKEzo+ECLYBQFeIeSMi185orx+oisLJdBa6kSSFY2muAjbTNnfnqC7zx13XH92i2OD09wQmCMod/rYZRCqBTvPB6NWN/awOaWrMiR8k1FWVKoCd8hfAfBI0xOdG2yrVn+GtvmLvG4qgXlQCiayTGHh4cc3LqBVQpRFuzWnufe2OVwWuGdAySuW3BumPPg1pi3XblIkecYrZaEqhDaoLMCnTls6yiLhjyvyStLVVVM5hUyBi5ur9F1kdnck1vF9lBz/3bJ6cKR5xkxpDZfVYeNXPFu4MXVaVthRTgr3LOIH0d+/qj54GTqRyqPeOdoW4dA0nrolzllP09qNKVRQgER17W8/tobfP4bL/Hy7UOqFoQpaHxgkBm2Bz3yrsEoiVUTiiJf5uQEitxy/nib9bUBg3Gfoj9AWYtUJrW5tIEggUBo5kkA55oUOxAC+BbfVLi2op4tcF1kuqi4ee06e/sHHNae6/MWZ3JMW2NjJAeM0awPcqYzw/RgweduHfNPPvss59cHPLkz5PzWGls7W5zZ2oLOJZm0MRibkVtDv8ypqjlFJ7gzmZFrxaUL22Aj8/kRG2uac2smlVtL2x4hIrMmCJHHj/2jD/PP/9rTTFanboUV4axwT+JTt87lRjcfG5Q9NesiInraLhCiIAhDv5+jjby73T+val65vsfvf/VlZgvPle0N3n/5IreOZjTOU2Q5bYCZD+xHjaha1lWkbCoypcmNZjZ33Lp5i8VpyTm/jSCSlSXa5mk3JoXVEABlCpyrl1VOR4wR39XMj/eJMVIvKo4PJ1x74xaTRcuLR3PmHh7a3kCHwCx01HWd5kERqqoldo5Rrjk3yvnRhy9y4/iE3391jwv7J5y/fpsz62Ou3H+RbGnjI5Wm1y+pu448z/DegTDcf+UhfuJD76ean/LKs59nOj2AGBiVGh8lbd3hosdqwfHMPTEamEeh++Lq1K2wIpwV7kmsFfmZyaLatMozqyPa2rQEqSS7x4HHUHcjmq/e3OPFl29y7fYR96+PsZsKgWLeOLbWRiilcC5gyx55WRCD53Be8cadfXZPThhax/2DNXpFTvCeqqqo5gt6gx5SySSTLpIKTElFdB0+iuVSZ0voKqL3NNNTgg/UTYP3gaqquXZ4wolX7GxtstUr6Lo0vO+XOcF1+KXXmzGatu0IMSAF1HXLhWHJVu8S375xh1f25wQfOTk+5crlC/T7JUpr4vK9xliMdfz4E4/yUx/5CFJFFlnJ2UtvYe/618jVjEaBVYrYJSV0iALnxVAL9USk+5K4u5W0wgorwlnhXmmngfhsaN4mBBs+OFHm+fJRiUdy+3jObOGIEZ596QbXd6dkwfPw9hoxKIpyiLWWcQClEjFpk2GH4zTiIXKRyGOXznJt/4BXrt3kxrzmRy9uo6XEKI3Wgq6u0ErgAaUTuSUXnIgQER+XfmneE1yL6xratmF+OsU5z4u7h8Si4NH1MaNeSQgBqXJsluGdR6ukQTPW3nU2CM5RzefUs4qmaciM5r2Xz7I7mfKVq7e4Ms7xnWd7a51+P8eFiNIam2X0y5In3/Y4pihpuwZvJevb91PPD6nvPId3Dq0kuVWJ+JQkInpOiMd/7QP0+TzT1elbYUU4K9xT+ORTyFHXvYcoN50P9HsW5wI+RFoPl8aavhW8+NodXtrteMcj9xEXc3zQFL0RJitQkSRd9j5JpoVCGp3Iw2hi15JbyZPjC1zcKPndrzzHt6/v8oHHr5ApAyImz7O4zMaRIFRyfU4xBAbaZpljAyE4gnf4toHg2ZtMOVrUPHFxm0wrfHBILdGZwmYSqy0ms2hj0TYpz3zXpdbhoqSrG7qmS2q3ENlaGzAqc379K8/x40rBnX26doDJDSFEjDGc3T7DcNinPj4gCBDFOlJp1jfuZ3L4Km07ISIYlIa5b9I+LMI6z9vkYHAOpivxwAorwlnh3sImm8Wru/OL2+tlbjPL3lHD9uW0dY+QjEtNZiJvHLS864nHWMsFCyEpBuvkvQFKG4LzeJ/+S3adcrnH4tNOjBSErsP7yNqwz0+98zF+83PfYGgV73jwAtZmKCmQSiKtuVvVRCJKJYECUn3XEiem57zvqF3Ht67vcnljSC48wXuyok/e75MVOXlZfPczgl/a1qSgN2JASVCFJS+zFEMdI2WXbHz+Qy34yktXubw1wnfJTUBJidEKrSS+bclHW8ToCW2N6p1BTCdsbl3hpRtfYlYHIpYyzwjeYbQUdRfPbw/jDiu12gorwlnhXkOzFgf+thwro0GAixKUIbMWrTXBeyZ1ZHxhnYvbayAl5cgky5oQCW2FaxuaqknkEkjLnELhQ4p4jiEilUQJSZSCcb/HR9//JJ/63De4cu4Mva7DGo0QJTqzKaYAkEqlnBxhkCoSVENsPL5t8V2DVJLXdw9RMbDVz9A2w/b6lOMNbL+HkimqulnMcXV1N7I6eo+IgeAdIoRkOpqCp5fEIjBZxuVzW9w+WbBftVwY9+iWaaNaSZqmpfWCvs4QWR9xvAdIZNZjsHWZixd3+c6rVzmddWycL4kOFlWD1XErIB75h+/iC3/ja3SrE7jCinBWuGdQWHWmLMz2YGCYLwJN2yFCQFuNC5JBkXN9Knj3xY0UuiZTPEFwAeca2qqimp1ydHDComoJUYBSeCQyyzE2GW7iO3xTo4GiyBj1Ch6+uM2nvvwd/r33PoZ3NdIobNcRszRHEktlMVIg8AifFj991+Lalvlszu3DE+7bGCG0JRuMMEVBJNDWLa3zIDSugcW0RQpB1y73eFyLiimELXQtViuy3KYlVAS+7ZAILp/d4DvXb3OlVyKqiqpapPahVGkO1DlkJjCjddrjI8AQguTKY+/k8OSU3b19Fm2fUWHJbI3C97UUP3bu4cFv8LXpweoErrAinBXuFYjauc1eT29ZK4hIepUixEiH4agW6FKzsbHJmXG2jL5J7azgHW1TMTnY5/VXbxB0gS4KhFK0LnDatNBKeqUm0wpah0biYmT/5i79TPHIzphvvHyN528d8/ilHU4mM6SS2CyHfCni8i7ZQ/uG6BvwHcE52rrh+OCY2aJjcD5H5SURQbuoqKojTucNg80dsqIHAiaLBdW84uT4dOkBB+N+SWYUBk1dO8L0iNF4gLUW5z1CSjbHPV69bZh0kbOjIU3b8K1bJ2zNPY8+VDEcOYRrEHlB1u/RNac0pxVm0OOxx58kfuubbG89yM65Ebz4ZSZHh0oq8fYozP3AinBWWBHOCvcGPg4iSmmJQXatY3295LTW+OD5+iuHfP2NCQ/tjPnIT2wilzaccWlF07ULJnfu8NJ33sDnPZx3HNze4+B0ztFphUPhQiQvCkbrm3QnB6xbweXzG/QHfQ4PjnDO8Zfe8RC//qUXePzyBYQtWcwbemNHCCHZ0YiOGJKrACEN9b33NFXD67ePWF8fk/X6qSrpHF3XcXo6p1w7A92CV199mdduH3DjcMpo+z5uXH8DPz9lYA2DXsnGqMfDF7ZZG/XBGGazmuFYI036KlpgUOYcLxrODrNEavOW/cU+J5NjNs9sIV2LDDm66JEPhni3yWK2z9aF+7HC0svH9MdDLj8kef6bn8YFv9118RLwldUpXGFFOCvcK4QTfztwx7v2zmwurvT6GVZbqq7jlcOKBoPrbbE+0AgJSgpQGfPjCSf7e1y/vkctDS9fu8Mruyc4HxjkBecuP8y0bbj+xivcPpljW8H0+Ag/m7Dzxh2euG+bB89t0AawLrBWFvzOl77Jw+c3uW97TNN05D6gQlj6pwWCc3RtR103HB6f8uUXrvHN64f89PsuoKyl6PcQMVIdzsnLnMnebW5ParrhDi8e3WFWRaKy7HvJ6bRlvYio2rO7cLx654QL630eOr/G2a11qsbT7xXY3BBC4IH7zvIbX3qRX//iC+gY+JHNETtrOdXJPu1iByV1MgAtetjBmBAa2mZC7GrOXLxErDy2v8Oa7fOw91x76YvBt+0qqmCFFeGscE8hWiduVfgX55V/+xtvTIt8WAolBIN+D20auvkMtYwG8O0CHz1SGZzIKMZrnIYZF3cM5ze38D6ZXtqewss+fc6zf7rguKoQWmLGI8osZypyXrp1zIVxyfqZMY9d2uJTz7zK9eMpa2+UnN/a58zGmOFwhLE5TV0xn884ODji+q07vHZzH2kz9qcLfm48ZLi+Tn80YHq4h2tbrl69xVz2uPLeDzA+f5Fvv/QqrqvYv36VuqrZGA25tD4iL3usDwZcf+N1nru+y+7xKW+5VPPI/WfpCUF1OkMQyJD4psJquDwa8OiVTQaZ4NrN62yub3BGZZDlmF4P3euThZp8sUY1P0StbRFVTYyefH2HrVDTLU7snZvX1j/x1JH62Cfxq2O4wopwVrgn4BsxG/bMZ7XRa0W/fBSTPVJaK953aci4W3DbW7TJiL7FtYGgBNErijxna0uzvX0GoQ0hCqTOcAECEtc53vrgeXwQ1J3nZDKBGBAxorWiWcwJTc3pdMGFzSE//e5HePzBi7zw6g1msznX5nOCu4FA0VZzQnDUbYsSkh99YIdL45LfeP4mvX7BYG1InltuvXjA3q19ysE69126xM5GSWhPef9bHmBR13gER5MT1no5pVb0MouKge38Mrv7h1RtS9U49vcOoWsoC0vZK+grw5XtMR994iKb/QwJnJ6e0HUdzz7/bX58fRvTNfh6gRoMUXlJ1h/SVhPcYkZ/cAbpOnTeJw622X7gnetFb/3nX3t58A14ZtVWW2FFOCvcG7DX7zTqbTtfkjbbzWzvgaxf/K0AD50bFYzO9fitGxFILS0QGJuR2QKb53RNSwgRlRfJYVnI5AgQZcrAcZ4QIwJJc6ZHCHG5zBnRWYZQiq5tWTQVr+0/x05Pc/ax81THk2Ws2zLMLQS88ywWCxbzOVVdE1yHFILdgwnrmxsQNTv3P8Bw+zxlr4fSFqEiTT3jA088iLA5QQhmp3P6wz7zo0N8W1MtFpzfHvHAhQ3mswXBe7SI5HlGUWRYY0ApeoXl/M4GuYxU84o3s65393bZ273OhcEA0RZI30PojHywQWjmdHWFCQqT9QguIu0a5RBs3nuvi/qXf/9vDv7qB//BZ/dXJ3GFFeGs8EOPn3ga//98OH9teGJPXKt9jPKGzbKHtFJYkxG7OV3nKExM2/IxRQOARBuLdwERQrKjISKFJMSID4EYOkLn8AFEDGhtUFphM4vSGoiofkk8hdlszs1rr7M5GpGNRoy3zpMVZYqc9gHvO5qq4uj2bQ72DqjqCiX3efq5a+yezHj3o/cx6PfplzlKSYge37RIH5MhaOyIRLKhBTpUz+JtpLQQvMOZyNqwQBCRErIsWdhopZlXTSKgMkeHjqYWiBjTtQiel15+gZ3z51BFga9zZF6g+2MKX6MnE5Qtkf0z+PkpPhhc5ciGI7YvP/STk2L4Ufjs/7I6iSusCGeFewGxOrwaCx6cijy7arPiujaKPLc0xrA9yLhxuOCt/V5yj+5ahNaJWIDQtVRHM5pqTlaUmLwgxIAPnhgh+LRQKZSlq+c4IvXEoa2lNx5js5KvPf8Kx6dTuibDludZP3+JPC9R2iCigBjxXhG7jqKwjNZHMFVcGBa8uneErysuDS16c40odHITkMvgtgiuWSClhJDsa5LUOoW2iQgyRKxOuT3Bd2kvRxm0kiitmMwXFEaipUBGhXduWWEFtILd/V1uvfEK563FtS3Z+jay30MXI9rDCcEHUBrVHyEOblFPbhOjIl87a4eh+Zsv/r2//qlH/s7/uJJIr/CnjlXE9Ap/6vhL/4DmvRuvzPJMT5B6HyGitpYss7zjvhHfen2fiAKhiSESnENKRV70GJ3ZYvv+K5x7+FF665vEKPEuQJQIljf8ztFUFcFFhNBkvT6DjQ3K4YDWBT777Vepnce7QNYbpGg3IVBRICFVEy4ldqbnIMsztgc5KnRczCOmrcF1aCXQWVrgjCEglUYoTYiREEBpi8oKst6QvDcgywu0lsjocPUCnKPoDyiHY4peD6M1d46nFFajAd91yamAmGxxJHjX8vyLz3N86xqhXYCrwHcIZYgI3HwKbYUyGtsfUIzXaGdT6tkBphw9otZHv3T9f/rb66uTuMKqwlnhnoD4OOHZX5IdPk5BxghCe3jgTMnLr06ZzALDUhCjR1mZMmKkQAgJSqGMJst7xLWAc47OeZCC4FPktFzGUksBQgqk0uhl4NqH3/oQ3/rm11jf2MAWaR6kVKpUCGlWQkzx1VIplJQIITh/Zsz24ZxLwwI3W6C2I0Vu0GWJlDq5HgiZ0quXZBGcw3cdznUpthqBVBZrMkyZkxc52hqkFETvmE7nnM4WXFgrwXu8S35rMQaEiGgJUkbuHBzw7HPf5j39ISYvkFKiyj5oSzc9xc1nKK3RRZ/crdM1UxZHd8jXQs/m9j9r5uH2F37lqV/90V/4ZLU6jSusCGeFH3oM8htVx5NOau1cCFaXFmMz3n6/5ZWbp7zzobRgKaRECpHaUUohlEm1uY9EkcLKjI0phTpGYvTEmG7UoEAuEzFDRBHZ6Gds9S3j9U20MWit0+dLASE5GyBIaaNao4xGdi1FbhlkipMoODsaoJTB2pwsz5INDxK0Tl8rKVMDIYZlgFsLISClQkqW3m0iuVWHtODqIxxMZjRtw7n17fSY84QQkluBACEDRkHdOV6/cYPLF65R9Psp7E0qZF5QH+5jFqfkvRJZlqg8Jxtt0B0uaGcTTF5uSCV+YT0/8ylWpp4rrFpqK9wLuP/jV2uZmVNr8g4JTejQWcnmqGTeNMyqACJVN0KZdFNVCiGSokzqLD0uFUqbuwQhhUAiETpDKI0Qgug6om+ByBeffYHHLp9jsH4mtbxUStkUMbkbhBAIPiCUQplEglobcmvZWRvwxtEMMxyRDYZIqRBCoW2JzQq0VBgRMCJipMBoiTWGstenNxhQlAVZXmBshlxq44QQCKlwznH9zgHn14eURuPbVB0FH3hTpSaiR8qIIHA6m/Evv/oMh1dfoz49olvMUTbDR2jmx/hmkdpxSiEF5IMNvAt0PuJ8c1Yb/YnVKVxhRTgr3DutNZHfir516yNF61tsUbI+KOkVgq+/fAvnwzIcTYBQpIg1idQ5oJDKJlWWyZDagpAgDVEooo/EAMF3xOiIvuW5l15hsn/A2UuXyftjbN5Ha5u6aHFZJRGTEEAZpM2QSzLTWvPofWfpFRkv3T4EKVFm2YpTFpn3UaZAmgKlLFobpNCJVOLSHJRUqQFJ2h1F+jt2juPjKbfvHPGOK+fvtgYJKeaA4FNlJEARMRKaNvLSjWM+/fkvc3zzKtVkj24xxQyHLCZHdNUM37VEIZBao5RE6wzXdkRViLarn3juV/+rT3/hV54qVidxhRXhrPBDD62j8N1MFbmk1xPYvEQKzeP3bVG1Da/ePEzuz0ItrZwFQqj0q1IgNYjkKh1NDtIShSZGmaobmZI8Y3AcHU/4p7/7Of79n/oAF+6/gtFLUpAiqdN8+kpIqVFKpbmRkBitwQeaxQKj4MnLW9zeO+TanSO8DySWEsQgkLpAFSNkPkDYElUM0UsiEtIs22wC4QPRh7uiiFu7hzz99Rd414MXiC7NbryPLAN5iDFFHEgRk+VPDMQAzsMrtw547vnnOb59nWZ6jNQSB1THe/jZcVp+zftom2NsQWwXBNeiihGR5n09MfxPPvHxp+zqNK7wff++ry7BCj/QCgc3CG1TSKU4s6FQmcFNa4bjHu977AJfeO4mJit58q1rKRRNSBCKuBzqL+sRohAQRLqB+yRBjiGAbwm+o6lrPvOFZ3j3gxd45PFHsDbDKrmUKyxLBykQxiBF92b5hXcKJUAR6OoGKWCjX/LIzpinv/gMk3nN+9/+FmTwaYSESMSyrMqEUuAd0bXpz3FtipxeskUMgTdu7fO1F17lLZfOcnFjSLOY49s2CQ6WooPgOmJwaY6jSLOfGJExImLkjds3kTLwQFOzfv4yZjji9OAAW/bR5QBtCwQhDYIkzE+PQCpUNihCO/k779jZuQP81upErrCqcFb4oYWSonRtpYgeYwWEjrgMHtsc9/jAWy7yma88y+99/Xmc94TgcW1NVy9wXY1rK1wzxy1OcdNTfJ3+9e79MhbaO5q24dNf/hbzvT3e9a63ILVCS3lXfSZNgSgGqN4YkQ9Q/XWEtuk5SIKCZbaoXyrH7ju/xXsfPMvXv/YsT3/9Obz3IFJBErxnqToApcFmCJ3dJba4FBLE4Ll6+w5ffv4V3n7lIg+f38S1LV3T0TUNbV3TNhXedUsBRJrdKJEk0lJIXDK1pu0cN3Zv8dJ3vsVk9zrRd4g8x7V1ekEEaXOULbHlCG0K5oe7RBBRyIe64H7xxX/4Xz+6OpErfF+/76tLsMIPEn/7o4+8P/r6Hb49lVnZM8FZIgaTG5TJ6RU9Hjt7hq8/+wJff+U6m/0CS8B3DXG5EOnbFt82RN8RuiYN/UNSd83mC37z//oCh6+8woc/9B627rtvOdyXdxVvMu+jxmehGCLKAUIbiB2+nuHbBu86Tg8PqZuGcjBA2wwhBBcuXeDKzgbPfO1b/N63XmJzY42N9TMImQx1WCroEDL9PiwVab7Fu47f/txX+M7VW3z4iYfYHuS4ek5b1TRVTduk0Leu63Cuxrka7xsIDhc8i8oTo+TgOCJUZNjTaBVZ1FOa6Sm9vIftDRAEbNFDZQVimTMaXEeMgdnRHZrFjGJ0RsTQ3heR5qn3XH76f336+XZ1MldYEc4KP3T4xZ959BFJrFy7mAhVXIzBaGkzlDEoW2KKIcV4k4ceuJ9quuBTX3meo9kcFcF1Hb5ucZ2ja7rUfvKequk4OJ3zwms3+Gef/jxnjeAnPvQedh54gLwoEdGhRaoXiBB9TJY2riV2NbFe4GdHdNNjunpOU1VUsxnOefrjNfqjUWoPCMloa5OHLuwwbhb89v/9Ob7y/HfwrkWIFP7mYqSpKxZ1y+Rkwu7+Hp/72jP85me+wLuuXOCDj92H7mq6xZxmvqCparq2pWuWxBk9XVvhugrvW0L0BB+YLjxCCCbTiNKSUV9jJCHTuKqdy8nRkTizuY0UAptnaGsRWQ53q7QOgmN6vIfKe0hlRPTtu0Pn1v7CxmO/88nnn4+r07nCnzRWM5wVfqCQMc4bF54hmK9qJbeiMu9EL6chQiCURuqMfj7gwx/5IG99csZXX3ydr1zbZ2QEhQQtBISQKgsp6AIcTWti5/mZH3k74zKQD0oyqxGho5tNiDI5E0iTI2SDbxuElATXEpqKdnHCfP8OdVPTOUfXVEuiClglEUsHamsV5XjEYz/yLi5cvo/Xr+7y8le+ybe/+ixr62OKXnk3anp6eoJyLZc2hvz8ux8ihprTG9cJIYLWBO8IPlVmxlo2Ns4gJZwc7jE9tUynitn0EB8jwS93eSQYo9IMC3nqXLyhTdg4Od3fuXn1FXH5obdQz06xRYnUCmFzlMlQypD11xi1Nc38BDXaIPqACN1fHtzf/BPg06vTucKKcFb4oYIIsRd9MxMx/2LsxNlic+OdzXwOfHeR882YAaUl5y6e42evPMxkf4+9vTtM51PauiF0LWiFNpZ+f8i784zMTTm8+iLVNDDa3gTX0NUN1dEdvOsQSJTJMMUQkxUQBME5XFuxONxn7+Ytmi6ZcHrnkFoTm5rQLAh1Q1vVzILDaI3OMtYvX2TjkbfyZBNYHBwxmxzjlSF0LbKryc9uoESaxXjn0u6QNkm4IMFLgfce6Ryj7TNcuHIfUina2XkWsymnx0cc3bnB8y98Gyk8tRMMhhZrNUaZ0HTuplDZ50QMm1F2P7l7cHt8+eG3UC/m5PUCaTNU3keZZGaqTU65tk27+zpdNUcpiZD0Y+f/yxXhrLAinBV++AhHhg3pw57w7YEMoy9II6ZCiEF8c7gePHQd6LQmiVigEGzsbLOxvUXo2hQN7V0yGgvQnhxS7V3n2je/yt7RKU9+5EMoKZjt36KdnzI/ndE2LVmeUfZ6KSpa50v5caSrFhzevMl8tgCZ/h6+61Cdo5meoEWkazsWs4pmsaA/HoOIRO+wBHq9DfrDS2ypB1IJ4h0AoW2IrgGXDDuDa8F3uLahqxd0dUMInq5rKQqLykukkGS5R9ucLC/pGYt3it39L3M8c2ysZwx6xWHdxOPo1VWPeSEG97rUdti21QdcMyul1FQnE5TJQU2RWYY2Ga6tiTbHFgPmswm9jR2EiHjf3Lc6mSusCGeFHyp89a+/ywhCv3PV/oNf/9Lpqz/y088W05NPIcufI3YE3yGkQ6o3jTQliIYYAyp0oG1apJSCiMLNJ9T7t5jv7/LG889z+/CE9330pxmMR7R1zdHuHm+8+DJXrx1xa2/OyaJjY3PEf/Cz7yEzKkUfCEmzmHNwfMrnn7nGi3tT2uDJleTc0PL2Bzc5vz1OmTutJ0jFzuXLyF4P19a4wz2KzpH1R6isB0iEUogYiVYRtSE6iFaCV0SfISuBWFY+zneIBUlgQFpiFUiEa9FSoYs+O5s73HfhAe6cvJYIyfSeU0K/PvNzXAy7fSXvOG+Db+PW9Pjgwa3Rdm96dITSGQKJ0WdQeYluF4QYMLaknd9E2RNsVqLl4epwrrAinBV+uLBxbqBQshej9HyScOWTv7t/8Gv/6d+TOvykD2KL4AmuTUucIiAjhBihc4SmShLjEPFNjatm1JMJpwd73Hj1DSaLhnf91IcoewXRdWhj6G3sMNya8fjmOR7roKobmqrhzv6UrTN9mkWFlIpqNuf5F64jFzUXjKIOkixTjMuCk8qhDk5RAhYLx/lL54neIQmosqCaTJge3kEANkak1qDTXg4hLqMKAkSf5NPhu04KAkGMkRBDEjSEmGTVukA4jxQeYzKssTx0YZujyTFddGgpW2HDWDaiLzxZEOKqEVLoEDfaunp39M0HhbbWe48wGUIqpCxRWQ/pU6tQ6pzp8RGDtXV6g3L8iadYxVGvsCKcH9bO0p/yn/dnQoHkt+3Qe79htThdXoTIz//jr+/9z3/lvwvW/nIk2uA7RJBII4muRYSwHO1EfNfhmxZXL6jnU2aHh1x9+Soni5ZH3/U2er0ewaeFTERkeGaTy0UP777r4tws5rRNRdM2NG1LiLCYV6ytlfT6KSPH5DlFadFaJR8zAV3r2RxlnNneRIqIa2pUNNhej3o65fTgDgMiOiuSt5s2yQInJsl2Ip2wtNxxhOCWuTeOEHza20FBXFr1REHa2xToPKdnNWc3xuydHpFl7vJrR4uN3nB42k0XD/ai/gbaOCGa19u63q9PD9eywcbbTVkqlCHGiFAaZUtUW2OyEmtzuiCYn5ygi2xj/aF/963wz55dfTVXWBHOijB+0H/fPxHCKttF3oq8570/Ed/zmdLEfyoET4UQ3hl8m7b1RYsQAUR31w7Gty3dYkFTV8wnE+5cu8Xu8ZSH3/YYZ3a2ksu0Mun9gFKC3niYRABdWq7UWUaYTGjbDhcFbd1Qtx6V5/T7lqIs6fUK8sKijEYbjbEWEdPn5XkGJC80gUAYTTYYsTg+ZXawT299A21tiheAVOnEpSN1SPJk77tEnt7TtcmJwBT9ZNMTQ3JXQBCjJHoggAiCUa/kZDHBucX9B7NGFuvGD8Zrw7iYnjeI7UjsV1X7zGJ6coow/w3b57YhEInJtVobtMkxWU7R61G1DQjLbF4PdGH/c+Bvrb7aK6wIZ0Usf1avwx+LiKoK2jAL0Td3vvfxzOkDp8VLMfh3+i4gPCk2QLhkY9M5vEuE0VU1i+mMO9dv8q2XbvDw44+xc+kCtuyjsjxJgZPVWTIADckOR9y9iQsKH5DGJOscNafQOXYQMdaS5xl5npRgyhiM0Sgh7kqShZRph0dIgvOIEEAqfFuzmM9RWpH1+yhrkW8ae7wZgxADrmlwbYtzjqZe0NYNtleSDQcgJdF3sHSvDt4TXMBXDUJpiswQPDgX1NnCftvM2r8vrLpttR76bvGAMsLUbTNvZ9VvoY63Qtf8t8mDLZAcfTTSGLQtyPsj1OEB0eZQLfTR4fQd//vPf+Dcz/3a52+tjvsKK8JZEcyfh+v1RxJQrE/rqg27qpX/yk3N143zRZx7ByGolHsTIxF91ysttcMqFscn7N/a43PPvMwDVy7zwGNXGKyvY5dkgxAIJZcmnhKxDFiTISBF+le+MjlqPkWbjGJQ4b1LN+QQMZnFaIkUEa1VMvUUIERERJHcCqS6+9NGItE5sl5BEHBwZ4/14MjKPkrr5RVKsxq8S24CdU1TV8nOpq3pnRlji5yIT7HV3qXKSIjkoOAcxmYYbbAaQiOeKYP6+Dy8/M/j9OJWOcrf70IcaK1OtBaVcndOnC9/b358k2JtGxk80fsU9SA1UipMVpDZjFlb0+sPhKhm75k09X8E/MrqWK+wIpwVyfx5u5b/Gvk0J0euiXb6vv/+tcX3Pj61hRAhSAR451gaxRCDI4SI9xHfOarZnKODY16+doetnbM89rZHGa5toIwhimXcQIyJbFAIoVEyeZihVbLsR2CyiC1K2qbBtR2+cwgZkw1N9EgiWslEMrD8PNJNO6aYAUJczmZS6SOFIC9L5rOKw/0j1s9EbF4k0onp5/FdR1fXyTOtqmiqBc532CJPu0daETufgt2UIYga39UQHEpLtIpY5bpFGz/nXfv0x5/G/Q8/3nXEYqGEPJLS3NBtOdmfE9bH9ebR8ZxxPUfZMi3KKrss/SRSZ+SDMcfXXydkW+jM5Jsbg7f/1i9++MzP/v2nD1ZHeYUV4ayI5s/j9b1LPMedyCXVRPwBMlJ+IYPKU6ynCHR1hTIZIPBdpHOeajrjaO+Ql6/ewuuMd7zzrZw5t4PJbVJ6dS6RihAEB0Kk6kIgUx5NXCaJZgUog42RwnffTeeUqf0V24rQLoClomzZkoKYQt2IxGVKqBBqSSaJkILo6I8HTPYPOdw7YLw2wuZZasMhcE1LW9c01YJqPmM+n+GjRypFDAHfNuAiIAlCEIIjRp9mPt5DdGi6G9J1v/FLX5udALhSe2vUvEXfllJdr8fqsCpMXIvyfp31WBwforM+0liElCib4+oFUhtsf4AxOZPjKUa0aMFf1FL8H8C/4M+I0GSFFeGsiOaHn7zi9+HaRBG681G4O//6SwYI4USaM4gUsew7YpSEEHFtRzWds7t7SOUiDz16iTPbGxibJZsYwlJunKocIRShjRAkwQukEESfrPp1L2L6Q4TRy5swaOvTPCcEglje7NsGVCBEh1QQg0/ezd4RYrc0RHCpGiF5s4ml3Lkc9JlPp0yOJwzHQ/RSxOCalrqqaJuaetlWQwq8DzjnkB4kaQYVlguibbWgWSzwztHWMwjxOY9/+c0r1/PWdz7Odcx2JeHOa9efbT704Q+TVeLiaDigqWuayR5Kq5QDtFTPCSFR2jIYr1EdTRiOz1DPJpve+//i//zLT/zeX/jfnp2vbhUrrAjnB0sK4h6/Vv9/iEh0rr2slTr5g08UtnUzLxcCkMoA9ZuFA8hEOtWiZdEFHnz4fnYunEXbfDnbcQglk7CgaYh1h1t0hFYgokZIg5SS6EKa5RiN0PuoQR87HqF6JXQtvlrg6zmhqghNnRZPMwWaJEQwAkTybyMkB+YQQorBDjHFIzgH3iONxOSWxWyOnM7oD/qppeaTQq1pKhaLOV3XEaWgaRq8C0QCyEh0Le18Qj055OTWLeqTBW1bM2n3qOpm2requXvxjusubJUTKRvfMHr940/jfvttRbaxpX6st7FBO52makyKJEjoOpRUyCXp6LxA+AOktmR5QVcvPlr1Bx9cVjkrrLAinD9Foli13f7o6xH/mG++5IN74Q8+3i3mTmSDqRBEKaVApmhppQwQMdqgjGU4HrNzbhObWUKArnW4uia0Lc3BIfXxKbHt0DJDK4NUGdpmxCgQQpPy21TKrZH7mPEaKi/BdfgqRRMIIZchbi6FdQaf2m0SQtchVEQWGiwIIxGyJsaI1Co5PTtHEkRLtM3oOo9rW6QSOO/o2pR707UNbeeIRJqqwnUd0nf4GAjVKc3phOpkil3fId80LGantEeCk6p2IcruzWu39sCt5rjun0R89zd+62sLgPs2+iZf7+WyPaE3HKLLNWSWI6Qmdl2KrxYCpZIXnZaCtmkp8h5dNTNK+n/8iafef+Fjn/yX1erIr7AinO8vadzr5BT/LX/m/+/3eS9Q8vryfXdfv79P29+JB0JKj5LaFj26OjkLJNPJFLN8ZusMRa+gXsxZnMwInaebVTSnMyZ3JtSTCuVhkOVsnF9nvGVwizlCKIS2BJ/abbbfT9Lm2QRCSxSSUFd01fyuR5sgEmJSd8UQCC4RRwiBtmnpfIfqGUwvQxcKVWZJWaZlkkkHiCJVOtJYjNV4lzzWYowobdEh4nygrWqC90ido4xFKIXVPcz4LFIbYuzIp8c4JkyO9mfHR83da/exTxJ+9aO1z1Th3nws6+WlKUbalEOk6adUHO8RUiPyAhE9cVkjKakoypLp5IDy7AWKokfsqvXRlvjlTzzF3125D6ywIpwfLNGIe/S6xX/D9/2hr3OgTtt4/Q++/i0f/2R37Vf/6mGU0kkhtMnz5c05RRZIrRltbNAGyIsCIST71/d57puvIr1kdrrg9b0Jlwcj3vrw/Vy8vMPa5XPka0Pc4QxpLMRIdzpD2Bx7ZowEwqIjOI/3Ld700KWiPprg6hqMwjUN1dGEtmkQGkJwLKYNJ5MZLkZkplFWk/UzbJmhcoPKDEFEimGP/vqQ/miMNQqlFdF7FicTkCnuQAaDEoGuS7HYshwgtUWaAt2XEBx4h29mxLZGK41AiJ4W/8o1jvNBN9jkbtWDzS6GqApp+0hp0q6Q80QRILoUS0DK95FSUJR9ZicT5pNDBqMRJZ52fvJXNi/85Gfg07+zum2usCKcPzlSEH+Cn/XnlZTiv8XPFP+4xBNC8N186v5AhSMExNd8OEa0Myl1rrIcneVpcA8obegN+ohFRVZk2KJAiIxvPHOLatEwqwNHwfGehy9y8UceZ7jRJ9/aoLxwke7aTfRwjDKGsH8IgyHq/FmE84TJnNgFglsQC4trG5rb+4TTGXJQ4PBMX7pKPZmid/rUixOqZ64ikHjfMT2eU9eO2jlEYRiO+wz6OZXreOLH3kbZG1D0+0ixJM7l8qm2lrZzCCnRShF8wLkOqdTSwdpD9IgYEDEglUYZS1b0yWyvui5vd9/7P+FpNuuf+OTTDiB+4in13Bv1TxWu3EgXVy3jsxUsW5QxeAh+SeYGk2cURcn8dIK1hrwYImLY9G37dz/zCz9z+yO/8qlvrm6dK6wI5/tbqXw/iOjP4zX7YxPLH/a8d3Hct8h/9GHsX3ua5ntf6zzXtIg3o3JniBGTZdRdh5QCbTO0lfgQ0uzBZpy5b4Of/Y+3+OaXXuaFF17k/KDkgX/nwwwfuYKRQJnDxjkQFobrRN/RtQ16+xxhtEHsWmg7wmSCOnsW+j2EaxFlSZjO0FubRBFRvZzQRuyVB1hM7hCazzCcz1nMK04OphwdzVjsTthrOl6/dczl7U3ObK5z9sEHsbkkLyxaG6JvaU/EXaoVQqKUxmSWGNJsR0iVFGQ++bcJJEiRGDkv6I826Y937TsOvntNBUSefvpuO+3F1welLc2TeN8PzqPVUrQtVRLz+Q5CXFY4IJVCG0Pe61FXU+anJ4ngbF+67vh9tgwfifCsWMmkV1gRzp842Yh7uOUW/w1/nvhHPB//kPdHgEAgms3SnPfA0fcSDvPJ9MXRRvkdEfzbIEplUux06DqUAFMW5MERQ0BbnUjn/Ii3vqVFO8/NeoHojxHFEJkZsIbWBeJwA29zvNP4rXPQGyIQ+AgyLwn9DkYbBDwhgOuvIbICBv8ve+8dbcl1nXf+Tqqqm17q3ECjG42cAQIgAIJZpMVMiWaQRWkkkhZHGs+SLY3DkmetGc4fI8metSZ4LHusbFkWJVKiSUmkqMgEEsxBBEgQgQA6p5duqnDS/HGqHwESQHcDjXzPQi/cW7de3boVzld7729/3xK4GrF5CzrvIxa3I72jKXLmLr8EDh8h2xspv7OPLefupF5ewwwrrrr5Rm582dUoUyNw5L3kceMqh3OpD6epLd5Ziv6A6B3OOlxdIpRA6xypC3CO2NQbfTgiRkzeZTC3ePHalr05fLd6pJNVNtX2QS/f5ptGuLLEmA6opKKAEiB16ziaIYJHKYcyGSbL0CanrCqm4zFFt0tjm6wej1/yp+++9Y+YSd7MxuMY8nkONuIMwUY8xt+IR/n3bD5+p/N7TvXZo247iriipL1sctfKD7Cfrnvfh9cbH+4IwVbRNyndlBctXAUEEZ3nrepyhGCRSrL5vK1ctGcHnarkrz/6Me6/7x5Wl09QThLrzFmLcw5rHV4XuBixtsF7j1eGOFgkxKRk4JzDhYg3HZwPOO+hOyDmBa6psN5hzjsPs303ast2su07UZuXyLZtZ/PSJn7o1hdy7Q2Xkvc0UkbyokAbjVSC6CxNVeFc0nZTSqGVIs8LgrNU0wmxqYi+AVcBIQGESA2rKTxxaMGe2Nuy9RMvR3/i5S/X/+m915uTx/3P3vvGrgvuhqau9kbvqVaOYidDgrNJFDTGpE0nVQIdoZAmT6KeeY7SBu88dVkxGU8ZDceM10aXrE9GS7OpczZmEc7ZASTxBJY9F1Ns8QwiHHGaywCobfimdOW1//1X+OQjfnOwHw8hvsvVk73SdNFZgasrYgwgAiYzBG8J3qGCR4iA6eUsnbOdG0vH/i98gT//0J+xadtmFhbnuOqqKzhw6BhXXHctWiQK8PzmTalq5F3qoxECb2ucs6m3xltWTqyysLSIipHJaEhZWRa27eD4gQMcXp0iF6ccOHqCwmR88/79XLP7Ai668AJ2X3gOnb7C11N0rpPKgBD4uqQajagm0wRiQtAdDNBZjiC5nE7HI7y3ZO1hE0qC0ISmwo2OUa0v09QVPrLN9PS/nHvZm1akyLi2XDjwqZ9f+nih+0J23Ot8Xb9GLS3tUVIzPLgfoSQ9qVFdiYgmMfIi+BCJIRnQSZWBUBunriyniLpmuLJCXVnV1ELOps7ZmAHOEwODs73s2QpA8TT2+/GAzA8sW57Uf7+YZy9+tB0Z3/XANwaX7fmmkM3eYEt0t0DnHXxdIkREGYN2BhFFCnKcQ6qMfKnH0rbNvPWGG7lnZYXvisg3vvQ1vnzb7UxHEz7z5x9nURu6xrB117kUgx5SSdZX18jm5ti8exd5t4NRivWjx/jGZ7/AeXt2sWnTAvfffR/jSc15l17IV7/0VfYdXmbTjq3sO3CILYMBr7nwYq5eXGBhxyZUF5ydok2OzjOkkuADtpzS1BV1XSOUwhhDXuSYvKApJxAD5Xic1KEJiBjBe4ItsesH8dUU3Z9Hzi2xfWn73BZnf0pKJC5EV1fD0ar76bzflS648yaTaRFJxmu618cMNiGyDrEVHI0+9f6kE5NeBRIANU2DbSwueEJwSRXBusNV7cazqXM2ZoDz5IKNOM3veTaw2OLj2Jf4KOvEU4DMIwFYBPiZP+X4R35cH/l3r22yn/8Lmu//wht+/Svujv9j+x8qGd/sxBiVD8i7A6ZNjXc29a5kWdtYGSE6ghOIDPTAsLB5ieuKnD1VxYUveCEPDtfZ/8D9vPyltxCcJysyJqtDhsePUk1K1o8co3Seu7/2DSajMTmRfp6B83zjzu/Q6XWo64bRuOQbt32JoXVYAavHT3DZOefyD6+5ngt2bkNqgTAWW5colaO0xBidHD2JBN9QTcZMx1Nknn6DMQapBN42OFfjRxbnmiTBk0uis4R6HdmdQ3aXki6cMulne2eid/hmihIsyYWlxSglmlxkeYGvpwQh6W3eSjFYQmY5IuuAzogEpK/xTWidRr8HPc45qqoiCoF300SaUP7rerh+dDZ1zsYMcB7fxC7O8vtnQ0RzJvsWT5FKE2f4/mGg47X624vO33Q1LH/lkYDw8In6L3ZvlffC9MLQTJE6Q+cFTTkiKzroIse7gDI6pdpkBAFqTuHXA/nCgG1lxtK05PL5jOlFfTJy3I4Fss1b8ER8U5L3+9jpBB/B9Ab4umT94H5U3iE6x/qRoxTdLvX6Gnd86e85vjxiYWGeUFbcePFlXHDuuem7OxC6gcqPkSZHS4XOTGKGxWSHPVld4fiB/fjgUSSLA2kMwTmausI1FVF4vC1bOrQnClCDbYimJqmPSrBJzDO0YqJCKmSWY8S8iNGhY8QjmK4t42VNMdicen6kRqo2nWYtrTkOSJ0o2K39gtSyFSWVeOeI+AbB/f/i75mcxetrNp6cB8cZ4DzDJtJTgceZfPZsBZ6zATQnl50O8PwA6Kiss97vFpe8723L+n0ffEizYjte/W/+Znjnr7ziVwz8e1uOOsJ00CYjuAJbV+Q6S743CIRUrYimR2Zgtmf4FYcgI88zOtYzX3ShgXB8jAgK3+1SEymCoowSpw15Z4CzHq8KOqZHsFMK3SVrJNEXLO2+GHG+ojfoU3Q6KQ0VLNFEovEEQKCRCHSukSISvSUQqSdDVo8eZTScoPICZTRZnhNDxNUlTTkluArnSnxVgoh41yT3TyGQeVLNpmlSwT8koVJfV4ToCTESlQEP0deJBCA1Outi8g5S6eSxE0OyJTAaGXNktMjaJgUCPEoJdKZQWhJiBBGRkhNV4w7OAOVZO9897YD1fFYaOF1AEY9zG89G8Imn2Nd4Gum0xwKaHwSdEKZ5V09fffH5O97H/fsf6SZYHro/27Y4/QlXD18hyw6mO48yGb5lW0ll8MGjTYfoQpKgERHdlRAEYdWDldDtIExrD50ZTDFAdvsEpQCFEYEgNGrqCVbT1QPE6pjoIgudJWLw+CCZL3qEdt9cVdH4mmg8QgtQigAooZBaIrUiBk/AE61lsrrCyvET+BDIjSHPc5RSuCr54dTVBG+neF9TToZEmQKQDfFSZYhN0zZuRgjJZC7GSAiRGEUCE++ST4/S6KKD6fZSX49UbZQDwU2IeKJdRbgRMoyJrsJIR2aG9PuecV8xnTrAYyT3DJ37ymyef84D1pMGRPp5cPDOFAieyOszAZZnCvjEM7gATyeqOZPXvPm3T0w//0vdw1oXCy9/OQc/+UnC91/wR+79zMrOm17+74KfXmAnK+cJqRG6AMA7izQFAoGQEGVM5mmpBRKRB+QgENYDMUjodBGdLrIooNuDXg+0QeY5ufcIpYjOEXtzZL05/OoKrqpbvTNJXFvFjce4UWKRWVcSMg9FihYSZTmlyXRmkIK0PS2pJkNWjh6lLCt0lpFlBpNlRO9oqpLpeIytxsSQTOfGa8vYcozpKBAGqTJ8NUUKSUx5L6IgUaWzDOEcBAveERXIok9wDqEVKssRRhPcGrFaBzeC5gjBTxHSo6JDElCuQuYFWdcxOE+xtJizviY4tF8xWo/Hv/rJav9snn5eAdFZBZ+ZWvSpXz9sWYxxppj7SAdUiM4jgNBpgc7KeHxgx87uC3755VfMveiTd659/7bf/kHC167gk4NB9ZFg+SeuKqTpZyAVtqlQJkeYguCatGkpEDE5cAotoeeJTUMYeaQViE4H55MQp7AWIRV2MiFYizQa3ekSo0V0coRaIh47jl8f4gW46Zh6tEZTjfHSIeYV5BKUIkqZ/HeURBnd6qU5ZJYTXM1k5QTLR48SiBRFQdHtYoyhmgyZjoZMhyt4NyFGi5KCyXgV1zQIbVGqi6+mRFsjigE01cnjDlq3Xjy0KTafVK61IVRTCBVhcg9hegz8FGKN7nSphyvoPANtiK7G2pq8N0+wY7RS2GZMLiu2bFJsmi/K8Yq/46fYCO5mYwY+z1vAOZPo5nGBTYyxml17jxEmtUAshCi+D1ROCTqv+39XJl/73zet9QvOed/bGF9+7rnqhZduWwg2ZD6Mjlz08/c2azDePu/+spzUr3H12kUq7yNNhxB8UlaWyQvH5AVCiGRBoBTBuWQ1XURitPjxiLhWI8jwpoCiA50uIUbcaAQqNT1KKRHBEZqK5sQJ3NoQ15RELFY0xAJiVxG1JMqYHBRESKQGZVBaJ6XptqZUT8csHzlCVVXkRZeiU6AzQzUZMVpdpZqOCHYKwaMkNM6zf98xLrzWogLIEAl1cj4Ntko6a0IgRAB8skPwgiSL5lF5QXQVhFUydRztVzBFhnMTgk91reBqRMcgRMS7mrw/R3AWRKQZD4kIvLU0VUPwtday2cQjMw9n4/kFPo/7/M8cP08BNjOgOWPgqR4CPKcCnY1x2MbvXtQx1737JdfvioUsMhG3+FzI5bXuiQ+8DXfhufVcr+O3Z2aq11YCbtpDd5M0i3MNRdFNrKrgUnqNmKyao8b7QJRAFmEeovcEV4KvCJMRVFnyuHGeWIEdpYd4X1e48Yhga7xrEIbke1OYtL1kc5MK8UohpcTkWQKbYIkhInVBjIH1Y8c4ceQ4SEXR79Hp93BNzXQyopyOqcs1vJsghcf6yOEVh+MY5XhMPthKcE2ynbY1WmXJ9uCkkZqUSG1QeGJsELKLEB6a/WTqMFLWSCmw9QidG4QTCKOTdE530JISBCrv4OwQISIR2YqHNjjvcA7TTJvL3v9jbP9Hf8iR2ZX+7Lw9n27geb5pqZ0yZTYDm7MHPKcBOhvLPvxn95b/4z+66mivI6+RWmZE15eO/dsXQn/n619waaYnN9ly9ON1Ve/Uoqa2PYLtoIp2wmwlX6JtEngIUrSgNOjURe+iTX0wKhB1TIQC7yHYlIIygaAiMUCwjpAFQh9CVCByohJEkRhbCdBa+2uZyAFGa5QEER3Rg5DJy6aZjjhx8CCNdQwWFuj2+wgB9XTCdDSiqcd4O0GK1AdzaNlxfC0gRMmJEyvMbz+f4BpEiERniV1DFBERA0iV0moyHcoEumsItx/CCXQmQcgEIqFBmg5RSoRUKKNThCQgxoB3NbYckQ/m8d4jTAJWIUUCtiB3bulzAcwA5zmWCYpPcHun/ff6OXwQTyeK4TEAaEb9PDvnJj4K6DxsnV//CuHSvasPvvXVW2/OBOdKKQKI4yYvrleifns9Wn2Vt83WetIYZz3ogqALVFaAUNhySD7YlOo3RNr/ko20Upiii1QW1zTJvllAIOJC22kfBEppgkig42UkeohGpzCG2NZGAAJSRGTbrY8ApRVKtz8vpLqNKbrYumTl4H7WVlbozc3Rm59HigR0ztU09QTfTFB4pIT7jlruP+LRIrLQh9XVFaJIPTwxOKRQQCT6BqHbxk8hid4i8Eh/iGjvR+fg8ai8Q3A1KsvQNkv1pKYm+Ardn8f5CoRMFG0lyHt9VGaQWrapt6RSbasJEHto5meX9XMeiOLj/PtT/p1+Hh1EzgBkZuSAsxPllN9HJnhM8PnFDx5o3vxDO+8wkcuFxGRdcXGoV1/smvJNtqlpJg3eCibDmhgfpLu1j5AZMp+jmXh0liNVYn1JqZKkv0iyN0JIlFTIVh05xkhA4J3Fu5D25OTk3TZCBucJwX7PIZPY0rDTNOybGiElSkukkggpCbbBC4HOCiKR6doqJw4dQijN/OZNaG1wdYm3NePVEzSTVUQokRKOrHm+/l1HzyQ3haaB4cQSokd6sXHUYvCpyVMqiIGIB19CeRdaLuNlidB9FBlSQwyRGGqCKxHZVoT3xNCg+3NUJw6TzS3gvcM3E5rJiEw4fJN6maTRCJFo2M5WcfYw9rxIpz3elNkp63szi+nZeCZFQjhbjmVejCBeL2W8znv7wuADeIF3gsnYU1YwXq8ZxH3Mby/IdQZS0IxXyec2IaIHZGtwlpwso0iAkGtDjIIQSZGD1CkoiT4RDYQGmXpniJHomlSPcTXeOYJtkspyjChFAhoiIQS8bYixdc+UEm9rhsePsb62ymBhEUHENxVNOWG0fJxmuo6INVJGViaOz9xd4xwMkppOq9aT/GpiCCipEJkh+gqZLxAJRDcmVkdw619FiTHkOSrPiL5KNHGS8oLIOujBAjE4vJ0ipETEQHQlQiwhkKg8B90kmrlsgATEzvlECQ8ia2qK2eX6nJn34hn8TTzTe/m5CDhPxJNmFt08A6McH5SPgihF3B1sfaFUWRGlwCuJcw3Wwdq6YzoJTOxxpjbnnN0a3duEjR5teyiVEYNHqaTUn2ocqlVAbl02pQapESZLki4h8FCnhdg6YUZbp6ilGqO1wxudmG/BEWOqFQUfEK3StPMRkxeE4Bgvr7By9AjGZHS6XWIINNMJo5XjlOOVBDbCszJx3LHfsj6FgTmZCkzNnmur68QYUNoglSSGBqE0MTTEckizcgfS7keEadJIa6MvIXSq24i4QRCIMRK9Q2dZinq8JYaQgCt4ok9RXQwBlWdIEbEuoI3G1hVSiTpIytlD23MmqjmTVNqZRD2PCjrPN7XoUy2f3UhPfhTzaBejAKLWUmvFDiHi9hhkL3pE8A7XOEKUuBBYXveMRh5jAqvj/XR7PTaZHOhgp2uI7hJSGyIgRUqttW8gCsRJsJEGMAgUZIYYXLuHCZSSknLq6cHkRJc2JEIktKkt709GICnKSZIAken6KmvHjlBXFZ1eD+csfjqmGg+pxyvgxgg8axPH4RXP8ihSWZgz4D1YQCmIoUl6ajoHIRI1WnXx43sJ033E6QF0L8M7iTSqBSVLiCQw9TX4gOx0yfpzuHKK1KaNxjzS5OAbpJb4pkIXRfIeMhnBJ48hose7QIihjv6UOmqz8cyfB0/HXDE+3rTZY633fLWYFqfx2Ww8CSmzUwFQJ8MI4h6iXSQIIXQXFSImlyjt8c4yLiOHVyILg0jW1Nx/7z4G8/NkhHaizoAeWgmE1q2Fs2hbFiXRRwiBKEPbz6LhJDCJVkrGeyKSGATRBfAQXCAGQGnwQAyJzRYDzlmcswjAtimz8doyWkskkXq8Tj0Z4qox0U0wCo6sNhxZ9UzrwLCOuNjqckbQCooCCDUCD6FJkYgfE9f/HumX0dTQz0EpRGySZ44SoAy4gFAKoiGGsq37RKKrEUUBtkZKRT6/mRgsUsREQtCGGJM8kHdNioSiT02siNqLWYTzHIhwTieyEY/zs8e872d9OLPo5pkU5SCikoIwh3B59BKhJEIXCGmRKoJMjLBJ5ZEqsDSnWFld5zvfvpdLL7+YGBwVkY7cQRAKXIMgKSQLBAifRCuVAaGJUkMn0ZRxTbt3AkLVEtPiRjNl8D7Rh71r+2wcMQZc0+Csbe2fHdV0zPryMYJ3GJMRvaWeDLHlEHyFlIEDJ0qOr3lqF6kaKBtBIBJasOl0oN8X1NWY6B1CC2J9EF3dg1IVQviNHhxhNBKNNCax9IRGyJYwISLSZEQURE/wtqVI+1SH6i5QrxxMLqQx2XW7pkZJRdA5WIt3DYGIFFRNZDq7jJ9zEY44jc/i44x2HrbOTLxzFt08E6KcjfdC265UshMjrSRMQ6hrCJ4sUyws5HS7nnEVyXOBdZEQAw/sP8bipu1s3SaIcYgyBQiBMiAwKFI/SgypWTLgIVqoqqTmHAJIgVQ6PdVLDU1NaKpU6/CpthG8b2VkEvCEtqDvrcXZGtuUTEdDqskE1UYc1XSCrycIGqy3HDxesjr2hBDxEawHFxLYCAkqA52ByRT9Xk41XSFXEcN+RO5TdAVEAUIrhPDIokuUAggtdTvZFQilENJgx6vowqA7vUSKcI6oA9FOicGCzhE6I0ab6jVaQfB478mKLtPxkBgRwSFn98mzPto5U9deTpUKP92dmBmw/eCy2c305ILNYwKPkKovZOxHJxAEpNSQAVJiUBS25PxdPf7+7oZx6dEqkGcSYzyHDq1TFAX9fgCOIWVGCAKlCqKMgEeKVJWXCAgNEPHDSVu6kS17q1Ve9o7YMtN8UxFCCzbR4V2DrWuca/DWYeuSajqmnAyZjNYTXTlAOR7imxKCo6obDi9XrE8cILABrINxFWh8ojNICXku6HY1i4sLzC8uEKp96IFHiAlgW2KASulCKVOkIxLARN/Q/rqW3JDIDKEuEb0eoZ4imkQ8EKRmUIQClRFsA7FBKonSOd6GliKeGj+d9bMHtGdvKu10QAZO7WN1JmD0A58/35QGZkDzzAYepIiLIvq5FO6kukL0jugboq/RmWJ+XnHVxT2+fOcIF8DExKbyPjKdRmKwdJ1FisPobknW2UTQEYHGi4CUgeAsISQq2EmfS5RAStnunIQIvmmS26ZPVgjRu+TKaSuausI7SzUd01STJMA5XiaGkIrw1hJshYieUdlw5ETNuPSECD5GnIfGRWrX/nZSRJYVmk2bl5if71PknsFgghQRZEwEByJCZUidJRAU7f5Hn2R2TJ4UCVydDnJM/UOgkVLjy/GGJJCSJtWAlMZPRggRECpLkj1a4UZlq6YAyqjgog88+204nsvAcqrjH0+RRjsjA8UzBR39LJ+8no6/nY0nMdWmZJiPMJdCjoDAobLUZ4NUCBsovGXveTkHjluOrVRkMU2qjfOEAE0jmU4meNfQtSW+rjG9zQiZQ1QIoRBRpiimnZBDBKElqjVzizEihSLUdQs0Fm8bvLO4k4AznWBtTVWOqcZr1OUI7xukFEQbwFts07A+diwPG8o6zdUhQuPBOahtSqkFIFOQdzQ7dmyl1zEQppx//maKThIelSpDiJYv3dZusC7J1dgSqTVIQ3AWQUBITXAVoXHIvJt6iwSJjdZfwNVNIkZECPWUYBu6W8+lmYxSv5GI5L0+fjhqaeJBxOkspfYsnANPN5qBUxgmPkHQed7UcE6Xlfa03UjD4ZD14ZBNS0t0u93nbVpNCHTE5YnK7NMkKQuUSZOtkJY8BubnFXt3dXjwSI0PSQ9sS4iEAFJrfGN48MEhO7Zbur0pphwj9TxS5dCyz4RQRKFxtkmV+lbwU0qFNlkbJfikSO1skqNpKpytqcsJTTWhLifU01WaeowQAikEMUS8c4ynDSfWa6rK41IWjdDWbEI4Gd1EbAAtBUJLLti1xJY5QyZGnLtNMRiIRF0TmkiyHQiuQWd9QnCJ4OAtQuv0PjiEyonlKEVuMUVrOu9QrR4im9tKVDnS5DQnjtHJt4N3BBQqz3HVJPX5NDUq6xADqKxBqRKprCRDzQDnWRcBnamZ4hm59p4B6IgZS+1pAJ0HHniQD3zgA1xxxRW8/vWvA+AP3v+H/Oqv/hv+n//7/+LNb37TaW8rELAhiVKe7aGEwgjzlKTSNlaUoZFK2xCcFiqDtkDvyjGpoVGijWYwHzn/PMnh5T53PTDGuZAsl2Mk+EBedLCNZf+BKZ3OlMX5Md3uCgKThDhRbYSjcM7jIZmmaYM2GUqbxGqLqcfGuQZflXhbUVdT6ukI7ypsNSH4GhHS9zc+UNWe0cQynjpqGwgnlXMi2AA+tr02UWBjJArBYt9w1QVzbF/QFHqd887RDOYkwpcEW6TISyTLBSnypJ2WdZJhnE29QCenEF+PkFlBbCwq7ySbBJURQ0qT6U4Pbx26N0geQDpFRcXCNsrV4+hOp/UXSrk+11QopUBE1dWoWbbgWZNmE6cBQk/ctfd5TBoQT9K6Z+dKiJHbb7+df/rPfpEDBw7wjne8fQNwvPfUdY0P/oy2ebg+zNAPn5T91UKzK99FIYsn83w97GJ1xBO5UmNvY4e2EVMolXxgvEvWyURMblhahKsu6nB8vWHf0Sr5twQIIWIyTbfXI0bB6uo6J5ZX2bI0YctSATEVwJ0H7yPOhZYhplDGoEyGVprUQZO0yJL+WYN3Fd42BG9xrk7stQjOBSaVZzixTCtPYwM+pPRZunMFPra4EAUuRnwUBAS9ruLC3QtsX5AMOlN279LMzxtMJiHU2HIMnQ466yTLA5URgiO6BpUXeAIEkCZvm1cjUeiUklQaV42QbZNnCAFfTyGCGSxRHXuQbG4TIPG+IXoLdECaRJ5oKrJOF+eHZB2T+cx2mTE8n23RzGOlz56wa++ZgNDzXbzzKb1hPvyRj/DP//m/YNeuXRvF6Ucb+/bt56Mf/Sg7du7kTW98w6Ou/1CwiURu+/ZtZDrjpotuesL766JjGqZnE3BO+TRka/WA7KkVIeWWk2FBOOnXIjOCFEQsITjyXHDODsO1lww4vGKpmiTXj1QQBUXRRSlDRLK+Pmb/4RFHjpUszRvmBxIjk8T/yaJEcBHvJL6W2Bg3jnlwDu9seh08wTmCT5ThqgmMJo5J5Shrj7PgQyREsWGNmXKFSeZfhqQiEBAEIchyzY6tcygDvW7DnvMyFhY0eSZRJqlKe2tRWSIICCWIuLap07esujaCakU9URmhqRBS4psykR5iROY9QtMklQVlkEKw8+fuP5Pzd+XN8Mn427PZ/Tk7aX7PUuSRAOm0MxU8j5UGziR99qSCziUXX8J73v1uXvLSl/DjP/4Tj7rewYMHefd73sOhQ4f5vf/8O6cEp5PjU3d+io9//eOpqx42QOf44WW+9dXvIJXk5ldez1du+wbVtObcvTvpdAvuueO73PzK6zn44BF2X3gu2uiHRWVPEtg84sV754nRoZds3rRMm4JKaswG31StWoAj680jqwobp3R7gssvKBhNF1kZObz3hGBAS7QxZJ1OK8opUEoxmkw5eKzk4FFHvyvYNK/oZKSiShutBN8W5mFDqDOEkPpmAjQ2sD6xrA4ttfUED75VtUkcrodfYlKCUhKBJKnjtIZwUbBlaY5eP6OblVx5cZfNmyRFJ0ObDKEEwVlsY1MzpikSmIRqg5EWSTUjRCs0qrLERGsqEJpgm+SIqjOy/hLliQOY3hyLb71tNrvOxiNlYR7JQPGh9+jpRj3Pi5TaM3pcfvllXH75Zdx+++cfdSIfj8e8970/y4EDB/jN3/wNbrjhhjN5OuENL3gDmcmomu95xy1smuOlr7uFr33um6wcW+WGl1yL955Pfex2FjfNs/eyPdx9x3epq5oLLtvztB6jB+4pxy++lHEUEV9PUVmBnVSY3oDoLKro4iarCG3I+z1k3SCl5eU3zXPkRM7yWqr5RFItx+SKweICQisg1UFskTOdjhlVluX1muAdvRx6hSBTES1TWg7AB4+1kWnlqW1gUnrqOuBahlsrxsxJ9llopWlO4o5SCWyU0qkfxoNWAg0sDrosLfbIdMULr+ixZVuHXj9Da030dsOPRqkkGOqaEiEFOjd4WyGEJIbU/BlDTCoCoUboDFQOUhBCjSz6CGXwtiR6NwOb2Tgt4DkLoPOckbYRT+K2xFNwMh/1s1/7tf/Ivn37eNe7fpoX33rrGW33ZZe/jNvvvh2jDC+8/IUby01mmI5L1laGXH3TFZw4fIIvffrrnHfhueRFxn3ffoBqWqGU5NMf+xwvee0tG1HSUxDdPGz8zWcPuZ/60T0uSdpogmtQRRdfjlInvHOYwSLEiK+mKBmJWiII7NzaUGRjJrUkohFaghQYqRjMzSWHzxCo6walJFVVoYSmbmrWJxXL6xbvPD6GRIWOMdlTB5KG2sb5Sz/hpLb0SQG0RFpo01sCtJRkWmGMTm6kCISIKJFAbTDoEEPFpXsM553boZMLtErunEiRVK99air1USCVQumMmBlUnpiM0TdIk+HrEqmTKHcS5cxIrLsMISTNcIWs12Pbu781m01n44mAzmmnxx9pyOfBcXtWaaVVVcmePXv4yIc/wje/+c2zs82y5vN/92VufOm1KCXZes5WXveOV3HwgcNceMVeLr36Qnbu3k5vrpfYUPHpO1c//xNX9aSUC0qZJEVDenJHJC00lRX4epI66JVCao3Oc7QO5IVn86aS7VvWmeuPkNK36SyFyTJ6gz6DwYC8KMiynE63S9HtUnS65EXRprFa1m8A51MKzcf0z4WUMvMt/To85DiF72XhkFKQG0WRGbIsI8sytDFIpZNpmlTozBCiY++5hksu7DO3NEcx6KO0bNNlihhSrQgcMXiCD9imxlvLSQM4YkSYTptWE+0/AyKpXSMEITiEgIW33f6oB/6ee+/jzm99m+WVldM6UZ/7/Bc2Xg+HIw4dOnzGJ/uu79zNyurqI34WYuTbd93NHXd+m/sfePAMt3sP0+mUffsPzFDjLKXYOEutJXJ2SJ9Z41//0i/xH37t31M3Db/wi/8Tk8kTV4P/zjfuoZxWfOlTX+PogeN89q++wG1/9QX2XrIbrRVry+tcdeNlFJ2colsg5NOHzddcsukKIcR50ui0H0LhppPUeCgl3jZJiFNKiAGpNSJadJaRFTmZdvR7jsX5IYPiANGvIFREZ4a816G/OMfc4nwCAKnI8pyicxJ0OmRZgdYZUhm0Mql+JkRb9D/pXtDWZWTrZEDqv5ESjJFkRlNkGXlekBdFsndu6dZSG5ASKQXnbldcd9WAhcUMEWtEdIjW+yYGn1AseGKUBGeTaGhL0yYGCA5flwl0dCfVhiKE6Ii+btdtILiU23uMiPvPP/aXOOf5r+//IEePHSOEwPLKCo1NZImmaVhbW6Oq0vxz57fuSg8zdb2Rzm0aS103rKysbkTxq2trrKysMn7IdRxCYHl5hQce3MdoNE7rra5R183GOs5aPv5Xf70RaTrnaBq7se2VlVVsu2/ee5aXV/Det78nfO8RPEaWV1Yoy2o2uZy9h/YzeYgXz4WU2rMujXa6w2SG6667ll/4Z/+UX/6VX+V/fd//xq/+yi+j9SOfqr7qM/bjjffnbz2fTGcPn8RvvpJrbr5y4/22c7dsTBIAl113MQDXv/iah/2dEoqu6j4Zx/5R02tFP/yIJ54jVPJ3CU2r0uxdK5cPpjugHg0p5hawoxOoYoAQ4MpRWjYt8X6NQb8gqydYt4xXu9HZZvKT/TJNg23sBkjIvkaqMjWD0va7hIB0uiUihBRV6YiIke/H5BiTs6jWGm0yssxgMp3qKy35IbpU5DFC0Z8z3HLdHJsXJVo06LyLKnrY8VryvMkLgg9tSi9FNzQ1Uiu8M1B5lE7A622TBK7RycYgeGRWEKoJwiSK88Lr/+IxT8rcYMA1V1/JPffeR1013Pntuzh+/AR3fedufu697+FX/u3/ya0vupk77vw2P/fe9wBw/wMPcsed3+KKyy/jwIGDfPmrX6OsKpRUzM/PMT8/x4EDhzhw8BAvuO4abr3lJmKM/N7vv5+dO3fw1a99g8suvYSPffyviTFy4OAh/rt3voNOp5PuBZMxNzdHv9fj7++4ky988Svs2L6V79x9Ly+47hruvuc+fvZn3sVv/e5/4fw9u3lw335++iffyW2f+zxzc3Pcdfc9fPHLX2VhYZ5OUfCiW26aQcfjGMeOL//x1i2b3spjmyieFoFgRhp4GsaVV17Jf/vQH7Np8+aNZW/50R/hxhtu4IIL9gLwj//xe7j55ptbf5ZHz3Gdk59DHeqNxs/d23eftf3UQpOJ7Ck7Lof/5EXXBhF/NCa9SUyng6+T13IQbURjcrz3qE6XEByyGCBMhhutks1vw1VjBI7e5i34uiS6MUY1NHZENd2CVDuS/H+3Q1k2hOk0ydjISJ7lKKkxeUZdJ0DyvmW+eU+IHoVI0UWMCQgfco9pbTCZwZj2/1kGQuB8QAhJbRsiMD+fcesNc2zfkdPpd5NtQDPBro2RWZeoDK4sEUoglCR4h7MBX5eYootvaqTuIlSW/sWQaNa+TgdOKLytCN6hhMLX41Me+4OHDvHrv/W7FEXBrl3nsH7nEOccw+GIECJbt27hVa98OdPplPXhOuvrQ37//R/gl/7FL/DgvgM473HO87KXvJj5+Tk++Cf/jRAiO3dsp2kazj1n50Y0UjeWf/CqV+Jciki+9OWvcPVVV1JXFYcOH+GCvecDMJlOOHjoMFu3bCb4wLVXX8ktN7+Q//jrv8Wrf+gVPPDgPo4eO87WrVt49Q+9go/82Uc5cvQo1iYnU+ccO3Zs57777uelL3nRbOJ5BowZ4DwNY25uwI033viwZTt27GDHjh0b7/M85/rrX3DKbUkkHdl51h+TD/yrvd3FgXyngL2cLJpnObqocbUhuBoCCOmJ1qK7PXxVojtdfDXFzG9qaz0C058nNCW66NDTimYyRRuLqfdTNscJoY+RcwwGqbBeVjXCpyZMCaig0TqipGrBJhBigOhpedN453BCtB47AqkkJsvJsqwFm5SOi4D0HuvTbyo6iqsu7bLnPEluIvgKQmslkPfx1iYVAanwTU3wHmuTgoJtoKldqwwQiHlrhh1Cyo4HTxQCISCKDMH3tNJONc7ZuZN3/dQ7+f9+43cYDkfc9rnbee973sW377o7TRQbEbaACEVR8MIbr+dzn/8i5+zcufFRon+n59uLLtzLF774ZW6+6UZ2n7drI6p2bU/TeJyAcPPmzbzmh1+F0TopGrRj+7ZtvOjmRH758le+ttEe8NBov9vpbKTlhqMx3e7D74VbbrqRF1x7Nf/pN3+Hn/8nP3u2yTDPx8zQ6UY5j5jVmAHObDwjxitv3X49Qrw2xpPilMmpUxcFalriq5IodMrPx0hoSpxzCNsk5WST04yPoAebCdUEVfRT0Txa8kEfN52gTU4eYbJ6GCWGqJjj/QAhNWXpCS3vLLb0Zu88IJPfTAwIVJrgvUdKmVJatD0+WpEVBVlm0FqjjEIKiQ8hpb2iRSnJnt05l1/WpzvQSFwCGi3xTZNIAG16DiWSorRNCtW2cYzXG1Sek3VzXF1iigKUJtgamXc3HEuFlK0GncDXow2K92ONSy+9GCklb3z9azhw8BDnnnMOH/7TP+fKKy5DCMFll16SIujdu+h0Cq69+kpefOst/M3ffZJut+CcnTtZWlqkyAuUUlx00QU8uG8/w9GIv/m7T7Jt21be+LrXoJTiphtv4I8++CG6vS79fo83v+G1/MmHPoLWmre+5c1orZFSIoTgD/7oj9m2dQsXXrC3BVa47JKLN/6/sDDPBXvP5w8/8CdcuPd8lhYXAej1euzadS6fu/0LHDpyhGuuvmoGNmc3Ff641hfP4h9/quWPVej6/tcPex9jHM2ur7N4soQYtBffyQswPvT9B953Re9NL970r2WM/0MIoSOIoEySjfGecmUNOx0SPUiTIaSBaJGqQOCROsdXE8zcZqKvETEisg5+uo7uzuGm64QQUTrDTsaQ9anGI+rKUVYZw5Fi3PQZTTvUTcTVHudc0ljziSIdQiDpAyTAIYYWkGJqMG3ZaEprlEqkgCjANg7nPbWzbNkMV1+ds2lJImODVBlRCEJTtQAbsFUNUmGbZDpnbWS6NqKqHKN1h9SKXZfuIOt0MEWOyYvkYJp18dWopV4LfFWCloS6RijD/Ns+hzHmKT3vv/nbv8etL7qJ4WjEwYOHecuPvPFJ/8577r2PT376Nn7m3T81u/HO0jh+YuWjW7dsetv33b88wj3N94HMD7yeRTiz8bSPl1+/eLkU8h8QbZGYabptfIkttdejTI4XSbpGSI2va4QMqZve1UnIUkpCE1GdPna8Qr64lWiTwVg+v4gvh+QLS7hyRKdX0Okr1PEVer0cZ1dZXh2yXi4yHOfYRmLtSVvpiA8+tduQmnJ88BR58s8xRqO1QWmN1OnJXCqJ9x4fAkrAji2C666GblYhY4bM+0Tb4KspMi9oJuvoog9KU4/HKK0QpoNbP0rTWKrS4V2knAZGqxVLeZfgRbIRICJNl4hMxyxGZGfQCo+qp411+JPvfAffvf9Btm/bxgtvuP4p+U6lFO/8sbfNbqqnLso53bQaM8CZjad9vO+dF+bdjnmREOGCKLU4qQt2MrUVA6nZ0UWIlmADUThisMSYE6OD4MkH80RXp74TWyGVIVqLHR3HzG3FV2OEKVL0IyWm6OGrivntm3HWMlkdsmNHh8XyOGujgtL2qJoudSNpmkBwAe9cm+86qWPjWyuDth8oM0nbDDYiIpMJBh244jLF3KYOWg0IrsaNjqO7S6BSrUaaLvV4mAzUpCSGwPjEKkSFd6E1i/PYxjMdlcwtNckFNe8htdpoAI3OtlpqUxDJMyd5pj31I89zLrv04qf0O/eev2d2Uz35YPN4mj6f9QZsz7lxYnmFw0eOctUVl20se3D/Abzz7Nyxnfsf3MclF11w2tpqG7FsjNz/4H46RU7dNOxpC7jPhPH2V23alqn4IyHQfcgOE0Mg+kCMAqRGKpekYZxLhXiT45s6+eRIQSQQmhIhNa6cplRaUyI7c23zpEBqQ7N2lGxhO74aY/oDXDVGycj8zu246YSia+jPOZpymdpXDEeCyvUoK0PTZLgm4BtHjKCLLNkxK402GqnVxvH23tHtCZY2CbZucvTnOojo8eUElfeQeRdXTYlS4H0guJoYFXVZAZIYI0rDaC05jdom4HyktpHhasnClpquaSncwbWRn0xq46FC6CIx6IKDGGc312w8HcDznJG2eaLjkcyHnjJJm0crXn7nnvv4209+hisvv3Rjvc9/8atMyymv++FX8YnPfI7zd59HUeTttsSGTmQIsW00/962Q4hIKZhOSz7x6c8yLUvO2bF9A3AeaX9ijE92cfVhF+Cu7ebVhHDt94LxmFjHPhCsTVphADIBRgwR39QkCBGEoJIHWVPhqzG6GCCUSfWQ8YjOph34ZozQBt+UmP7S91SWZTIvK5Z24KZryG5S3g8h0BmAq6fMzUmsHTKZgI1dxkPPcKhxrm0O1QqldNsTAyEGtPLkeWDTkmVhkyDL+kRXIciIKk92A1KR9OIsUUhcY9u+G49SEVsHXG1ZX7XkhSS41PApJdjSMjy+TlZAcH1kkROVSedfKoJPRm0QCdae7E6djdl4ssDmtCOeWYTzFIwDBw/xic/cTlmW1HXDT7zjLew7cJAH9h3gza//Yf70Y3/FrnMTtXQ6LfkPv5H6IX7srW/+3iwdAr1uFwR8/Zt38jef+DRCSH723T/JZ7/wJb769W8y6Pd5+1veyNygz4f//ON894F9XHvVFbziZbdijGG6vEKR5wAcPHSYD/3pX2Cd5bWvfiU7tm/j/X/8YdbW1rn1lhfy0hc9+U1yb7welRt+hhA66YpNlNsYIfqYBMlSPIMQMjVjmqxlqglCSI6gMQSCMngfEM4mEkFTIYsurhwSiclPp6qRnYxgUyHdVRNUMYDgCNUYs7ADX48xWYFvSmSnQy4Urp7SX+xRry+zabFH01jKssKGeZrKp3SXFCjp6c1Z5gYeI0uKQZfYjJFoPBFfDhEqw1Z1agZVCltbpNHYqsEUBc4G6jq5hNra44PA2tiqVtM2nEZWTkzpLxRknQqV5cS6RCrRSv4Ygi2TiGcLPKcaX7rX8s19nlsu1lx27mxamI1TRyuPsc6jrvt8ePR5JPbEUzpG4ymf+PRneemtNxNC4C//7lMcO7HMPfclL5J7v3s/R4+dAKCsKl7/w6/igQf386WvfH1jG5PplDu+dReTyYTf/N3/yq0338gbXvMqut0OF+09nx95w2sYjkZ88Stf47bbv8S37rqHH3/7W7jmqsv5q7/9FIcOH+Efvul1/O2nbuPOb3+H3/+jD7F1yyauufIK/vMffJC777mPe+79Lq//4VdxyYV7n5Lj8l/+l1teHxHXRlotMt+mq3zb1S9kS20ObW9HQCqdxDJVlhQDpiNsNcXWNd4nhejgA65pUMWAmJzJiM6DSmmmeryW0l5NIhTYyRpmbgsxNElLTQpiM0F35iA6TKdH3s3pzvUZLOTMz0V27srZufkYe85bZc95h9lz7gH2nr/Kzu0TlrYVdHoi0Z6VSVFGTNpstprim5pqPMFVNU1V0kwngKSaWiKS6cRRTj11FcgyiS093keaJtIpJFUVGY8dk7USW06SqrQAVIHqLrbHzRNsgxDqlBHON/c5/uf3T/iD2yr+5e9POLQSZtPrbJwKWB7p9XM2wjmbKbBH8/Y+q6PTKbj04gv59nfu4fDRY2xaWtz4qvCQou7i4gJ7du9i547trK6t/8B2qqqhrGquuOwS5gYDhsMR7//jD7N921am0xLnPMdHJzhv1zns3nUOAMf/+u/Ys3sXF+zdw8L8HEePHef4iWWkEAxHY/aev5srL7+Ua+6+l9/6vffzmle/gte++hVPWhoNiP/qbYu5kfZdMSiiC0SbvGiIASE1tPL/UhmC8yASOy1GkFJhq9Tsp7RJjpvlBKEkrmmQPqTmzGqCr6cI7RFEVN7HVxOCDa0mWyry+3KCmd+KHx1DmC6itZ5GRKRWyKyDL4fo3iD1zUSL7i+AnaC7vbYZNIApsOP1VI8JbV0meGxVIyVJD82Bdy39GZEk0UjWz6PlMVJAOXHYOiCVwDaR/5+9N4+W7DzLe3/fsIeqOkN3qye11Jpao2UJT7KNsbExy2YwYDMYbIZgk8SE+ZopsLKAXJI4Nrn3skKAYBYQAtybACYQwANm8DxJlmVZ1tCaWy11t3o6Y1Xtvb/p/vF+Vaclq/ucliVZts6n1UunqvauXXvXru/53vd93ufxQRGj6HJO7KqrSjMcebZ0nuADpqokTRe8aK1NjejSunf05w/6qRDpuEvceTiwZ9tmGm5zPO5I57T7bt5VT9EYjUa8+33/wI2f/RwXnH8e83NzHHzoMP/04Y9x/wNrqrZHHj7Ke97/T9y+/072nLvrC96n3++xdcs8f/2e9/O37/t7Dj98lIcOH+GyfRdnZhRcsPd8br3jTv7pQx/lE9ffyJWXX8bNt9zG+/7hAxw9dpwrL7+MSy6+kH6/z/O+6hquvfoqjh47zmX7LuarrnkWd+y/60m/Hj/33fteQYgvD6OGMG4EVCb1myzYmGLWEfMtoRuLOKV3pOjRVppAg5eGyeC6vK1ornnX0q4s4ruGGBPRB4JrSMGLmZpzKFuKBIxCnDGTWAi0q0tCK46ioUaui0TfkkKHQpNCFsWcNIpma/AYPG5liYTCe48bD0kJVk8u0SyvMFpcoRuNMUXJeLUBEsFHuuGYrkusLntWlzxtE/FeGj9jjBiriElhjKauDVpB23i6VgAnZQUEovgBYayAozbrcgbiowKauEky2BxfXNRz2ueficnax7JNfTIip0eM+bk5irLga1/yYl7+sq8GYGlpmdXVIW/+/u9h65Z5yrLgh37gDRw/cZLXfcs38bznXMvszCzOO7Zt3co3vurrmBn0eeuPvYVP3vAZlNJcdMFe3vCdr2VhYZE3vv51lGXJJRddwPLKKn/7vn/gzd//Bq6+6nKsNRx88BA/+i/fxJ5zd/HP3vh6PvGpT3P3vfdz9VWX0+v3OHzkYbZsmedbvulVT2Zqk8//ztVX1Cb+ZGy7GluSfCc2yXlyVMkAUiRPIeSIp8trqyhpouimjjRq0l3vA0kFCApjLL5rKKqK2I6JMaBDwppJb00GNdcQnM/9PgVKwizp6QmBGBKhWSU6SdFF35EwKO9kolZGaM7OYWmISZOcQ0dPNxSX0uRHdE1HWRV0TYc2iVInYhBpGt96unGHaxPN0BETFIXchmWlaFudG1chKUVRyMWMPjEedcxlrTbx45HoTtlKrmEiEwie+BEiPLwY2T6nKTfLPs/E6Oaso52v5NvkbMHjSWWqJeDVr3z5I5571Su/9gu2m4gcTsazrrxs+vfXv/ylAJy3Zzff+dpvnj7/ssco8F9+6SV84MMfY8f2bWitedELnseLXrCmzTYz6H/B8b/zta950r+Tf/y1S/dcsL18K0m/JHSdNrrI5ACIrkHZStJCKUhPibZSfwEpgnuP0IalMdQYQ0yibcZER0wq8nTDMQrQRUHyDuci1EIl9m0DLmB0EJZYMwKVPWi8+M3EbixsOR1Aa4l0Wge6wncNwQWCjzTLy8KMw+HbhuCk/6YdjlCmpF1eJiaFU+B9pCpLfOuF7jxuGS17fIDlBYcxohQg2UUBP60UpoCqNozHkbKAzsu5jlcb2pUh/S2zmKJHTKBtRTLy007JgXnif+aNS/zrPxly60HPeds0v/6mGbbNbCZMNsczC3DOBjSeEio0wN7zzuUtb/q+p/RC9Hs1P/QDb2DXzh1Pmy/nv/3cRfPPv6D/Zq3U61IK9VRJIMmkLxN+RBUFOiqSNSK1X5UkLzWJVFQiUBk8wQ2Fxq012mpSEkaWKWzWO0v4zqNCWKOPB4VrGkwh0jmKSDtsMEVNcGPKuoKU6EarGK3xXYtViW40JOlaakCqxepEszqmaQ5TFArnHLpzhLYhKUWzEhivdNha4dqArWu6sUNncUpFRCtD1zqaccD7hOsS9Zz47yidJeVQRAOg0RqshcGMpVsKoGC03NKMGrG19q0QFEwh19S3ck1994R/l5+933PrQQ/AQycjH7rN8e0vrDZn1M3oZlNp4HGk2Z7QMTMz4OqrrnhKT2j3rp3s3rXzaXFxX/eKLcW/+dbtF196Xv/HtE7fGUOYl458TWjHGGtJUSKURK6OK8TxM0bwbf67y82VBSk4UlERg8+1HinEK6NRzkmfjdH4VjxkBHGc7Bs9wXXCajNk+X9P7BraJGrUZTWDb8f5uJCSxo1WM2g5OiLKaEKIuOjpxp6iV5OCZ3XJUZSWro2gA0WvFLWCIG6eKQr7bLjSokmEAMpo6oGiKBXOJ8pS0zQRW2uSU1SVousCvb6m6wKlTfgEKSm6cSPAC2hjpJ6kstBVCPAk9FWNu0f+TEbtZt1nc6wPPM8UwHm01s+ZwGZTUvaJvPDNcd75Ly58Q2XCm7VWL4jea2U1hIAqa9JwiZiVgSERmgZMh637qGmDphahy1zAhwbjLVQ1rhnL6j566eGJiaRAE4kuoAuJkkIAYxTt0KFNpFkdElzAFIWIZLYdsevQAYgev7CAwaMLWbX7tsH0a3TydKOxTOIpMFwa0htYfBdR1tMsN6Aszom9dXAeZRLRJ7TRWGvwLtKNhfpcWE3wUFSKupZroHN0Q0oUhVqr3zRgraJzUuWPPhFjwnXCTFNoYnSAIfous/rcptLA5vhSRTtfURHOFwMOm8DypH87gbh4G+Hed9Er+T9jSDtiCEppk5s7Y2ZRWaY1mRQxZU/qI+0YU1ZobUHr3PgYUcmg0SRj0UUNEbzvMBG0FkbXhPGmtHTep+gEH7AE7wlBmjS1Vvg2SL1ldShMsNajbaRbGVLVhth6bCUTejcUGZxuPEbbApUlZ4oy4V3ALTUkcTTAWI0pEiEktAXtpWmzazyjYcBkVYgYhIGmUAQfEXxTRB8pClFDMAaCT1Nr65jWFCFcSGhjUMaC0aig5Xq5CFqUrjHF5v24OZ4W4ys9wlkPWDajmydjxBZ/5x/iDrwHv/wgKaadKaRcDA8oneVzYkCXZSYNaHw7RKmELaUob8oeKQUUwlqTIEg689E9YgwU/RmM99iiI7hGJGK0FN2Dc6KzlsgKzkpAJURhl8UIKomfToQYEjE6LODGHVpXGGvwbSeeNK6jKEvakaeoFBBQaLxXYnSGohpolLIEL7alMSmK0jBcbvGuI7iIC5qkE9FLysyHSPApy+MEiBLJ6NLiWiEguE5YeySFzilH10WsVlT9OrPhOjCCSCm4LPGzeUtvjk3AebqAzOmAZ3M8nsvux8Tjn8bt/wO647dI/SAKm0ylREohA4cWjYuc6oneoa2hqGZyo+QIEoS2pZzbBtHnfbRMqlGIBlprEfc0itAFil4fpRqCMfjOSW0oRwApZns1ldBWTRWUjRX2mdEJ13hICtcKWAwXW+qBomsSRalBQTMco41GWUtygaIn0UPZs4DCaEhJGGhFaXBdollpaUZO+miUyBRpC9oq6c2M0J+1hCzrU5TSZ2MtjF3MPT2SPgtBmG7WSqqxLjVlv4+yBcSW2DYkZUGJNXUK3eYtvTmezHTaZoSzQaA5LfAopQYppeHmvbXB4VYIJz+HP/Bu3OGPkNoVoTXHKKAQgnTtTzrfgRQ9CiVSNfn2VUYimaI/gAiu6+hWlyl7PclHpYgylhiSCHkmATRT9cBUmblcSqNkMyKhGC0sCmstCqMqhETZr0Q0Mym0MXTDBlsV08J7iAprFW0jts4xJLwTNIgRigoRyNQaa0Q6pyjkvauqJ6ZrriP6yHCpo7AqK10nylphsxCAyr2aRakpa433ieAUmihWzVrASCUNeMpSEbyiKDRaCVO77pXUgxm5dUNE24oYoqQLmxWSNnLdnyZj2CY+fY9n7zmaS3aZzd/OZoTzTFyafwGhYHNJuKHUWUc6+Tm6A+/BHfkoYeWwNB2aQqRoEPZYAibFjRS9FLNDkFV5QkDEdWANKIkulIZCG9y4oUuJanYWpbW4WypDci0qRVRRSVTQq4ldg+3NZKBTKFuhUszy/44QAr3ZnjDPQhT5/pQwVuNbYclpC2HsoLAywceEKQSYFJHkI1onXOfozdYkHzClpSgUOkS0ATfqaEZCyx4PPXogEjbWamypcS5S1hblErYQQEvThlMwhcK7hM4W01UtZANSonGJuqdpm0BRKIraYCthGchqyQId2iip+RSVuIk+DYYP8JO/v8qB4wGj4d+/YcB1l27WlzYB5ys/xbYua00p1U8pjTZvkce6opG0dCfu/v+FO/JJwtL90rkf3BSqU2IquKmMRdezxGZ5rR6jtShC6yAgYgpSEFZYih6lDDo5bF3jmhHN0gLV7Jx44yiD7xrsYE6ikhQyuIVczEekXayl7A9yKsrTra6gbYlvxyhjZLsUKYoKxp2EHNmHRmmNLRMqWcpKM151VLXUarQ12BSwhcXHAAiYdqOOYBXeeRKKEEAbjbYKk0HUGNFFM0YozcSILVQ+toCPKoRAoI3GFgZjDTpGUhBQMdmgzRQKrcTlUgHKlGCMRJhaoYuapG1m9n3px33HAgeOSxNviPCx/W4TcDYB5ysWZDby/JmAaHMAqV3E738n7QPvJwyPktwYZapsv2wklRZEJTmFgC5KARiSWEdrNTVXM70esRsDQVJrMeJGK1RzW8Qa2lpMjFBKEX71+MP0t+0E5dFFSfQd2pZrKTmVIIj/izIWUkKbAlNZdNdg5ubQ1TzD4w9gbCXGncERgsJWRiRuktRjvAtUvZIQ1dQSoJ6dxbctIUJRaTAVtkp4H2i7lmbo0MbiXcQ1EaWF0pwwWJPoXCRFTVnZfE0gJo1WEkkpIkVt0YWCRlJkVWXyeSWsVVibKGvNeKwoNNS9ClMWa31LwYn9QjlDwmf69tND/TkLRpz28enGapP40G2OrQPFiy8r0JuCBpuA8zQDlscT5XwB2GxGOXmEhtQcI9z3v2jv/Qvc6jFE6ywABkIgpig6ZMpIYcIw7a1RKEIzQlc9EckMAWXEDlnZAkInLLKqBzYIG0sJc02ozVKvMLZi6dAhBtu2Ug5mJaoJHVpb/HgZOziHMF5Clz0iSvTQXIMiiQV0NUBVAwZ+O1EZutVlEfAcjrFVhZivJcpeRVhYwXVBKMtKMZir8J2X2osxFJUVlWetJaJRmqKydJ1ksIzRaKOpakVRgQFMaSXYaD1FWRK8l7SeMnTjQN3XoBXWGqoeaAIpKbwLpCjHkvRboCrBJxiPWwGUFMUDqOxjZ7YTfCcy1NF/WTPVQoRf+dMhNx+QGty/elWP7/rqTUWDL9F4LMLAWZEInuninetup5TqA+oZSSLwQ8LCHYSHP4574L345Qck8sgIoBREnxlkwYEtTrEXiMLkyvTcCTVZIewplCgta2WmDp0pBlQKRA/aWvmSosaUfbSNmBJsVeO7lmbpJOXMLNpYEgpteyTXCOW5a1DGkoKnGMwTuwZjLcG12KLAVBUqRIqqwpSl/BDKHrZoCSGgjKU33yMlQ/AduigprCYli8KjbI2x0Kw22F5FQkt0FBN+6OkPCsYjR+jilIVmKk3M+md1ryApTdUzOBcpikRnhJXmfSA4IVsYDbq0hE4UCJRKbNte4NvAyjBy7GRg994eMTiCIytsB2JwpKyujbJPipbaUzWWx4nbHvTTx5+6220CzmaE82ULLOtFOdP/P5OAJzUniCduojv8EeLxm/CL9xJdS0oJY3PHf5bjV0pL7aSoMxNMEV2D6c9K86XSKG0kTaQ0uqzQ1hJch8ld/CLEqSB5lCmJwRGjQpsSZRLJR5Sy6EKEOIteTTsa062uUPRnsFWNsobQNph6RtSntaZdPEm1tSalhC4sOnqSGxGdl/epB2hrCFVH0RtIFBQD6IJoIUaNokLZEmOQQr4pQZWYQogGtu7TjY4Tvc8sNqEug8bYRN3XtG3ClmLspkhQKEJIFBqpz1iwZaLqWYwTvxyjFWVVE2IkKklJKq2AyINHHcvDxJatlt3n9tFW6iBKTHeyJ85EcFRNGXpflvdiSlOvnknEs9HROElbVsXGI7zOQ4iJXrnxfXyA1icG1WYW/pkAOI8nrfa4UmwZeAanhJI8xt+wQW+Ip9v447eev/Prru5/a13Z1xidnoVWu5P3Ks9mqBSJXiIclaNohUIVtUQyuY7AhH0mvgEiRmnEvVO0viLGlllGv5Sau1FT8BF6siJ2TWaOlTnFllBRSAZloQm6xjcjXCMpMWML+bqMJaVEMbMFohN9thhE4SB0YjVQ1fmsI1oblFIYWxC8NIOWvVm89xhrwJTo5EFJ02oMidiJ/w5ZnTolUQeIPuFaOQdtoagNwQeKqiAhVPBqpmZ5YUw1U6PbgDaR3ow4mRalAJVCpHB0IdGTApomcOKYwxaaSy8tmN/Wo5qdgM1apKiVJnYOpS2qEEvtZ9r44K2O//LeEVrDW1/T5yVXrE9O+NwBz9v/csTYJd78ippvu279SOqB44Ff+dMhJ1YTr31BxT//+noTVZ7BKbUz9d6cjg59OtBhnefWy3PC05Ru/cFf3Xvlsy+a+SFdqG9RvtuVcJZoVOzELoAUshJklNpL6CZVrjXjryTNJdF1Eu0EjypKIEvYGEtyjUDUNMUjzDaRt1GkJCZnuuxJmq6wEAN+dRk7My+XT2uSa7EzW9FujO5kom8WFtBlQT0zEFvnGCkGW3DDk0KNbkfookbX84S4KIWW5HPWqRQlau/QWqNsTWyXhVQwkczxLfiIkKlNTgEmxksLdMMW5xXElBs/oT+jKaqCumfwXaSaGWCKFpTCFIb+wKKtxiZRGLAoXOvQOmGMppodiCrBeInFhcjqcmAwZzhnZ8HMtpqiKrG2JBCEPGFqomvRKNAWO5gntCOJblJ4xk1sv/ePY5ZG8nP7ww82GwKcP/5ww9FlCaH++4cavvG5JaU98xrxLz7ZcvCE7POuTzZ823UlO+bWZzWEKOnCLQO1cXn7BAvDyNaBPis91sVhYqansHoTcJ6OwPRkgM3TAmi2g/rxb5/pXXvx/JY929h2wZ766yvDNxprnxdT7KfWSa3FCOtJZWl7EdCUrn0SU+OzGAK6qGSiy9382paiJVb0hBSgJcVGB9qWOX1G7r8RnxqyCoHSBtufl3oQIsiplUJXJdE1j9Bfi1EM02wtAGiKAnTBeOEYMSlsIWoD1mr5jO0IZS1+vIqtBqTgMbbEj1ewZY/YDVG6zBbWVtJYatLfItYJMXmUUvh2TEoJ13TYXiU21T6iEmijsLVhMFCYskbryMx8Jewx77B1j+Q6qn4PUxQo1WAKi2/HGGuoBxUojW+GjIeOhRMeU1guuXou13EiRX9A9FIzSl1HaBu0MVLPSgGSQVUVdM2TYk3w5TCWx+kx/z7TWDllu2GbNpS+O3UfH2W/9QxBTqxEfv5Phjx4IvDiywp+6bsG2HWY602X+MX/b8htD3ouP9fwju+fob9OCi9GeNtfDvno7Y5zt2re/n0z7NqiNwHnSU6rbSTKOdvoZyNgc7ZRzZOWbnvjK2brn/im+Uu2z5T75nr6uqq0L8J3VyattqUQCK2kyRKglZmmtpSRCENbK6v/XL9RuiApRK4mrCkqkxLKmOyk2eX+j6zXIghG8K0IckaxIZiQCSDT0VKWuilqFCIno8syb1+I+2aIMFaY3qyk77TF9vrE6Oht2UaMiWZ5mWY8xuhENRhgy1o0xmJOuTUjIkrICUVF6kYQgwCDdqAyCw1Fcg3JNbTDIUWvh++C9PFoRbMyQqeEMYmiKpjtl/i2oyitpAlDxBQFwXuKqpRmTFMJgcwJO09lSYGyVwOJbrjC0oKjGUUG8z227uhRDfqkBL5ZxWhDopNeHFsIiCtF8M302qqYhTtzZLo5nj7j727uOHBMos6P7Xfc/pDnmgvOPBV/8i7PLQ9ILe72hwIf2+941bXlGfe583Dgg7fK4u3gicj7bu74wZfXm4DzNIloOAuAefTfcPZy3Y9VQ3rCxg5Qf/CLe85//kXVS21lXmS0vkaT9qXot6aQjBifSSpLai0WpZKoK6eAQorN2lYCICBmaSiRoPFtDutlwkzBT22ZtbH4bkTRy8QBbYjOkayYjiktigMpSE1jQhqY9O9kA+Vp97zWJTEMUUUl4FYoUghSm3CNbFfWkKVyTN3DFCVKF4yWFumajq4ZoxIYqzC1pAYhEboGW81J06rK3s0JiQySPeWzOQGGmK+DUhgL42HHYLYHJmIKI8V9BbauCSGAshijgYKiV+DGDbrfR8dAVFp013xLiuA7x3CpxXUSOe7ea+nNz4hqgvDCSaEkZvXribtp8oHoHNpMym2K1GVTthBR66TUHl1Ur+z6a59Hp5o2UpivLGe9j9EKa6RP6bHe40zHGrWc1T6nnlNp1IbSVuUp56CV7LfeeDz9SC6kRz1mA8d55D7+acAd0V9hIPJ4Xnv06xv9Oz3q78d6PZ3m9TNt80X9u2I7+q7fuviVt/7+Jf/lJVf2/2dV6bfb5N9MDC8K3m9PIZnonfTLMBGxVKisczYBgtxJmGs0a1RnbS3RjdZWzUmkaCY6ZMQgPTW5EB+9k8gipSmRIAYP2qCsRdlCiAeTJDUiz6JUIZ8hSGEeUyHNPWIDrQohEuiyRhclKXj8cBG3coJu4RCxGQGKqrLM7thJPbuFFAOj5ZaFBw8zXl0VeZw8UShApSB1pBhynSmDXpZNUCqibSFps7LEFgV1r8CWBba0VP0BikRR1xR1LSoAhcGPhyL4qRTGGoq6R/QtCkmzLZ8YcfK4Z/H4CFsWbN01x669c/TnKspeP9sS6Gk6M4Uw1aebNNrGmIhBamBocUcVYM9stTOMr7miYOtAJsoLthuuuXD9GfqrLrRcsF2i4a0DtaEayUU7DNfmlXy/Unzd1evvM9dTfO1VBQooDLz6OeWGJoPXPL9CZb25b3ruxmjU3/zcEiscF155TbEhQHz1teUUoJ9/ScHuretPqV/7rIK5nuyzb7fhyvPWV4J4wb6C3TkdtmNO88J9639Hl+0xXLlH3nu2Vnzts770qg5faTw+dZavn+nx2bx2pmM/Zdd4/29e/pJzt5lfdW3zEolajDQDTvztYxDgyLWQGINIyFhLdC22N0voRrlWYkVuJoVMgZb0l+nN4IcLIsoZJapJSeozCkUMDlP2c+TQk2MaO23ylMk7s9yUyp422e0zeHmMKCqHdpgZapO1kZoan6GkliMqyYHQDEGBKWvQFreUqcrEHKVljDcloetYObGIa1rmzulTz/YlhRa8FODLAVoloWYXFW68KqnEFPFdJ+mxwSyhGeJdpKhqSQOWNXEszaSoRAyRstenWTxJNbdVFAOiI8VAN+5YXYmcONIwt61m254ZtIJqZg6lAQKxC9iZWWI7Qtsa146J3sk1NIboPTFEkumh6zmKuiAlj7Z9dD1D9B1+dYGE4pzv+ThFcfoJZ2GYOHg8sG+32TC9d9gk7nk4cMF2w5bBxvZpfeKuQ4Gd85qd8xtb7/oIdx0OzNSKvedsbJ+U4O4jYoK37yxEQg8cC4w7uHyPyQoT64/DC5ETq5Er9liKDR7qxErk0ELk0t1mwxTslXHi3qOBS3YaZnsb22fcJe4+Ejh3q2b77OOLL44dP/nunTvOecNpFtnpNIvwx/r/V6R8izrL19QT/Pgpvbavvxr782/ae9FFuwZvskb/q+T9gKwrRiSvgiVqSNFlKZi49qtURuouwYkCc6YdpxSlmO7HcioxElPClH0hEpjc1GlL3HCRcrCFlCRFpRS5rqMyQ80Q2wZdVtmiQGfACjJJd2OJKHLTpeiKqQyQBmxB8vm16CWNFPyULp1iltPJmmFr/xcFAqV1LrJLxCKgEXDjhtXFlrE4SVP1LTPzPWxpUTiMNZiyxDcNphpACmLg1sljP14RLx2jiV1L0iUahykqkbQJneilAb5LNMOGkBRdJ3I5M9tmqQcF9aBE2xo/XsFUfUTFoSN6j+3NEVwrtaUkBIwY5bvxXUMIgVTOg60pezVKRZSuUEZ6nWI7JibY/sZPnBFwNsfmeCoA55lWw1nPC4cz1GbWe8w6zz/hkebz96B//eeu+OZ+aX5CB3ddSqpKvpMVdkridGkEaJTWKGUeCTYTQNBGHDonumjSUJMnviTsJ61QecJWpsjim0HkbJJEUySP1mZaxCa7UqYQZFWuFSrm/FUGD6UtE/2aRMiFcLuWGkoIyEzZbBGVU13RdyhToIuKEPzaJU+BmJSYtVX93HfTm7LObB0ldTgX6W3pSAnaJrC6MGRloaEZdRijKCpN3bcobRholydzRVGWpBTQmeIcQ0QZJTWlsqIdj+nGgZjP21hLSJZiMMvcbE1RV6TQUA7mpXYEpOgIwWGUEC4SoCdsQa1RSrTpVPafjimglMZYTcgLDKnjIM2s3Rh0kdUHNkkDm+PpMTYN2L54IOI0250NqJw1YeD1r9hR/Pabt/xIUeofSZGLYxDmlEz8KbPJclrM++w1Iz40WhticOiyn2sC8lyIWtJvSknrRpZKwdZSZ9Eawlr9BCXPTXxshCAg/S0qs82whYBIWeUravIEKsrLk4hEocCWJN+Rsk6b9OdIUTwXd+RzKEsKLbkslDvt15pMY/C5LUhYdmJroEihy+8Z8+YGW5egNNVMwWDLDK4Z044cISRGy2PaJtC1LaOVDucSVS021c1YgK83cOgsSKqtJsUx9cBmvbWCerbGGrFPmF6rmETFQKV8rpEYMkEjRJIyECW9hzEk77N5TkLbClSHUoZghFUYvIB5SuJeGr30OyXfIaWfzQ74zbEJOE9H0GEdkFnvuTMBzBPGQnvLt+6x/+GNcz9nvH8rkVlJg1mRkVHiL6MSOc0kEYSk0gIxRyipa2QFnaKkq2yNnqSwtMaIJaf4wGgD2Kybdgo9Jslxtc0RTxQPluhBl1nqJiEGYEpJNGSKHHHl1NkEKGyJjp6oEmihKiulZdJNmVodwykrfzd9PmQ7at+NMcaQyGZvuVFUJbEGCK3DVCXKmqwqrdABQtehZ3qgQeuKelDju8Dc1h4JjXcO13mC8/i2I0ZDNTCk0NKf61OUBUobTFUTupZqVlhoymhRtW6HAnhECKI/J4+9pPqmrLeCmBURtLbT9GPIjqgpRbQpULGQKNaNxSY7JpJvoJgBotTLjKTVUnJy3TfH5tgEnKclKD1ekHlSac6T8U2Xov/D987/cGmKnwo+zKYJLVllh00jq32tIKpMEy5Ewl9pK/JaRQltsSZFA3lyyh8720KLHXRmBSlRP3bjVareDDEKdVcwpJK0mXdgS1RaCwLF20ZBhBCD9PkkSdmJ5bPODaEBTJGbPnNj6UQDTIkxm3AGpL4kVtElwXWEdkwMHlMPJEUVIxQlyYl6copOghqlmVhcp8kn0Jqi14fowHdZWbrGuBaKCmUKbKGpZ/qQFHFaP7JEN8b2ZrNEjwB+WG0oeoPMJGvls5ti2gOUCOiyollapBzMTK0UfNNg6wJiNobLvUkpdGhjhCmoQBuDb0c5lbkG/IpC3ksZMLmHyrcS3Xi/OdNtjidy3twEnMcR5ZwOSDYSBZ0NwDxh+Yy3vh77C99+7TeXRv148mGeGEWbLHSioVX1CKNlTD2T6zCOlCKxG2P7OZpJwkwzOcU28YxRSlJTSkmEMHHXRAUyHxdlC2GBJUmGJaXyVdKgEypqEZg0WvZHJtPonaSCck1HqM2B6D0m13gk3RcFLKKX94xRZGq6duqrE12D1gW+a1Ha57Sh/FNZUBQtpISgDBN9mhQjqiggBVKapPQSOqf6km8zthXEboSpB0TfkXyDtqJHZuoZdIoQxWPGlGUGnsAUQrUiuVYiFYAQCOMhSYkSgNImEyvkXKLLoKR0ducUNp42WmjaAFqhVUFMYKo+2gsoq+Al3ZZTn8k7UlWgbU1Co2yFUVqaXTfH5ngajK90K6P0RW53uh6aR7+2Xg/QE/Lvx771qn1loX46JS4RccgSpSVto3Qhxf1Jf00u5CulczOlTKam7KG1kQlcywpfGYOypdRSrNCkJQ1XSARS1JNOGVEZSImkDAkjzCk0wSuiqgjJ4LpIjAk1pSODsvYRp6OUFv2ynEKSGouT5sZ8rJQn7YSk2aR3SEzGRGk65WZVqV9E32TXUVEMmLSfSDNrWhMTTWFKbEhdQ0qB4MTSQBlRLhCyhc8EhTCtU0npKkdgXgQ8pSivSEoaLWNM0+dT8FPSRPBOiAT52ki4aaS3R4X82ZOkPjPrThpOFdhChDi9m0Z5EnWK5JCodmfwCY7oRlIbcu00ij3tDZoSR48eZXV1NT+OkqpbZ/jjR+nuvxdSonvgftyRwxv/YT5wL7izkN2JjjS8B5rDG/5ZxxgZDocMh8MNnc+klvaIfxslXJwtMSMl0vKN4Jc2vEt77BjNoUMAjB96iO748Q3v649+iNQtbKbUniaRznrRztm8/qRFOdsGxY8qF14oK9YsicJEwj2xutwwHFXEVUM4JcXinRbRTV1IAIHCtxpVFMQgXczGFnhnRSoGhbCqNTEGkhLF45jAOSnCx6iICVIU+XjnhZXVjke0rabXa5mtIru3ePZuhy21RueJPObUlWi26TUJlokCdRbSzDm//J8U2HP3qABIplYrNQHDiYKBE8Vk12JqQ4qZxp2JCClHPUqJqjSuhRBI2mcWXAamCdBlwVGlNaFrBZDTBFAl1ZeCh2jAVJl+DSGnspSV3qIYAjH5Nc05fJbaSZmoJwKgk4hFlX1UOuU6xUT046x4ECQ1meR9dYzErsuU6QrdjaYNues1fi4uLqLCKur4h0n1qzmx2LK4uMS+ffum1/YLJrATxxn/9q/Tn59neXVIf34O17Sk730T5Z7z15n9HOmD7yKdPIL+8Xfke+4MY3SItPjHqG1Xgl8kHWxQ5//LdYA0cd999zA/vxWlFEcfPszFl1x6xsM0C4c4/vm/f8Rz85dcx9zeZ6/72wy3X4/qDaS2VvdRO/ee+RIs3ET3+X+N3vVa6it+Yt33bx54gAd/6qdQIVC87GX4j32MqDV7f/M3qfbsWQdIPd3d/xl7yU9S7n7Fk7GQ3zRge5yg83iART2OL+isx/E/u/rlJuofjClarYRppYsK1zQcOfgwDxxsOTg+n8NxJyEkVFFiix7KGPSk5VqZqVzHVK4mz/VaK7RSpzCaFGu15txtn6MNRZZEzm6ePgTatmG0usLyUsJ1Gm0VMUjPy65B4HUvTFy9z9KvQCudGzYzqEyjMDctlKMtxhSyap/QqJ3YaaYJIy96UhLVgtgNMb0tpNiRIoS2zcFMJ+BlQKUIRZ/ULOZVqRE2W1GjJmoK2XghuhZlKkn/kQSQ8rWJQZSi0UVm44XssiZWCsF3ApoxkXyLLiwpxFzL8jmSzOeRZQ5UUWaKtLD/tBaJn0lPEXmREZohdmZbrsuoHAklQjtClT2R5OnNCEQbC8FPxVBPN7Zu2cLSR9+KH93B+ND/ZGbuWuyeHxYbCfPYnYxu4STp+k9ADMx0HdQ1hbW4V34DnAlwDh0kPngX6qH3weIi8aED6AvPDATus78Fdx6GnZ/H3xWxe0GnizAXfMPp93nwr9gb7qXc/jOQEjOH/zP+6CuxO19xholZWgMe8Vw4c/0rdS3hpo8TPveP6L0FnGgoXv9v1weohZtYHu1mx4X/bEO//+b+++H4cZRStH/5lxgryh/NgQPrAk4cH6NbPYlavgeeGMB53FmjZ5I7eDrLiX+j229ExuaLGm95C7ooi7dF1/V1noS1KYgkjh06wn0HhjxwouZht4NxGjBOA4LdQqf7tKlmHCuaUNEGSxMsjTeMvaENlqBLoinx0dIGg0+WqEqSLlFWzMcwwopStkSf8lxAM2w6lpZXOXHiJKPWY3uzzGzbSW92Hp8siyO45XDi/353y39/b8fJEw0x13BwTZ5flYBBltchiaR+IvcApYl+mZbi+yS9V1Toqp+p2CmLhaps+oZYTTufgdaQdIHSltA2KNvL8jmSSkkxHz8DTMopyJSlbXRR4F2TQURo1xIt6WndKEU/DdRSBiElXbAE32USgSKGDpW89M0ohTEGUwxIviNOnTp1bsiV90wqm7flFUL0TiRtvMO1YrgWXCuA5R0UfRQGVc1kID3zLRzaFYJzGLWEbT7JYPjB04INQH3RJSzVA9LxY+jg0CeOM3aB+prnnHnyu/ezpOv/BnVNgdo2IPzu29ZNR43uv57VP/8w3QM3ML7pEzTvv5726C1njiAe+H1Ucy9h+W7Cyj2o5k7cA3/0hE8qqqwIs9tp7/sM+tlXEtMi4Y5b102n2fENzO19Lmr1s6SH3wXtkTPuMvOc57AYAscOHeLk0aMcO3SIRaUYPHv96MudvEVMDZc/91RENWkzwnn80c6jL6D6Ir6gxz1+9RuvfZkK+rpJDQMgqsTCsSUOHoX7l7dxxG1jNWm62IKCLrHWeAlZeTlNtcFiDFLLyT0kk6hHKz2ZbrN45pqI5qkrfMlxCyjETGwzRcHctnO47iUvZW7Q5647buP6j32UE8dPkLTmI/dF/D8M+faXevacP48uZ8QjJ0bQZa4zlTJJpyzkqZTYBkTIVDPRFitrIQMESVGpckZSTUoTY1Zh1gXKiMmbdP1DDB266ENOF5J7kkQGqBW5nIkUj8nJPKUIPqewFAJMIUwVmVPK/T/eYTMFPKUgNbIkVtemqDId3AhrUBlsNoFLRLRKmUoeQRdZQQGpyYUAKnsRYXJDKVPJH1uUBJep0yEzDJOT9zKFRJNnnDU1s8/7VVY++RbKSsRZ3ckPkva8TqK8x9rFWra97f/hoe95LXtHDcsBynf8hhAzzrSyf/BubPwb0rXfgNp6L+l3PyHXujy93lncfS0rr7uTpjB0L1Ds2TLGbH/hGY9jyh7aHcAt7ie1R6n0KphtT/xkkiLuwQfxdi/j//G/UXpAufeiM+/jh/iTt7C68iD1+L0oWxIe/BP0tX+CKmYee6Kem+OCt72NG777u0lNgx4MeOF//I/Y2dkzHuu+h45zzsE/Yby8RK93PZ/7zAe46tqvpbDmSzL5bqpFf3Eo/6R31L3nJy4tKq2/P7ZeTQ6nTMHKUPOhz1fc9fC5nByXjILGpREhN2hqRhATKsX8eKJQmdWhtcIohc4QJim1qbGmnOh0Vc1UGTplBQKjc3/NIy6Dohsu87lPfZTz9l5AVfeY37aNxcWlnMJT3P5QYNeNJ3n1QDPbB1XUa+8RXHYPDWuaaSFBaEFVAoTTFX43BclJ42g8xdIaldWVmwg6kpLKfUfyOYSQoKcRyaTGMzlGSpEUIUqhCm3EDVTpOGXepRRPIS9IflIYg1mNIUW60TLl7Lx8Zifvq7FT2jNKCs4p5vqRFUUBUgbEHA2qqf9QT6K1mFBK3i96t9bcmkS1QL6mgNYVifUFL4ttVzP3sj9l8ZbfwD3w52y7Yla0384wBpdfgf/dP+Lz/+IHuOA3fof+s69df8L5hu/H/e3vYHd/G8n/v+gf/d4zgg3A3Iv/DcPjBzl889/THwxQz3sr/YtedsZ9xv4iVFhk7oLXkKJn+UN/idq674xXQtuScm7XI4GrGpwZq1HMvOob6S69DAXYHTtxn/8c5Ve/9PSTSGgZLzxMzx5ndDTRjh2hdy3b5Vd62rHzFa/guX/4h3zmR36E5/7e77H9pS8942f79F3H+KU/u5Mf3reLF1zwk3z+oY/wGzcFXnx4Pz/2mmc9pbWbp2zC/DIY6un8nkfe9azreqr4o+TTZQqrUJq2i/zVRztuuFvTJYVPiiYqPAZTVpyzcwfzW2Y4fuQow4UFVEoYpbJ6rsIYi63KPMcHCqUo7ASAMqRM4O00dnLplFrQVFk6g1MCjBGSQOccyyurLC4tYRTsqhv21id46XPned7zdmHKnvjCaJPtEMqpTM5kovXNUCZao3OeXZQTpuKiE1AsakKzknuONKbs0a0sUgxmxUnUFMQUSV2LMoop+ULrNcNsY3KtZDSV/xfadYFvGtCQQkAbQ4iJotcjdJ1clhinfTUp+IyZnVCnIyhirpcZ6WEKHlUUJN/K1YuibZdSJKFz5DYgNpllpYTOrYylHQmjrBuORd/eGJQtsHNbKfoiiKrL2Wyc55n9tvdvTEsteoZHbqXeugfT27Ghe9StrFCss9J+xCw1OgJqEVSNqi5kQz4AKeKHJ4TqXc+tu7lfvBWSx279Knl8/FNQnoOdu/QM0cpjz59qQ58vcUqB9MznlAKjY3eR3JjoRxQz51Ft3btWr1vv3EYjbL+/7nYnVjrufLjFjYd8zdU7ufvBRU60ll1zhn27Bhv+vrKW2vdweoX8DemoPZMjnMdCafUkvOcXNf7tv0VVpnp1CvF8WaJDdCNu299x090K9AwxJJwu0VXFYDDH7r0Xs+/Zl+NGS7hoKYoeNgUKo1EodFEwt+Nc9j3nKo7ccwf3fvYWFpdXKYuC2bpEK+nK1xPk0HyBC1DSWSafNffPaRpuYswWEzF6rFZsnZuhKi1LCwtUqmHGdtx11wmeffVW+lU/s41yP46dWBhEYvQotFhOT1M5FUZbEiYr2RiC7wBDHK1iql4GvlzrSTHTknOB3RjpZ7E1oWuIIWKMzQX9jKQ6N2sm8fYRa+0CdEuMUdh21qJcR+waSWNpgylqmtEKRZWN3ZQiZWuBkIFHTSYwbdFZ200o6BVutIiyE202ERw12gnFXYtAqNJCllAEoo8QPKaSKMv7NgOoyPWIkndY6wnayNCWwZ6vOqv79GzABkD1dwO7z3IJp7EzOza8ud1y9SMfb3/R+odQX8QUcOq+672PMvR3Xvn401IbABuAc2ZLvnq2BOT7ueKCbV/quS3pTbx5xIV8WnXI/fNnXX6uTuoFRNVnYlSmDUcWYzYLk36YmcGAuq5QyePHq+yY387Fey4ijMe48ZhBYamNptBSVpiZmeW5z76O7dv3snXXeWyZGeC8Y3HUEpJCIXRqbQxai8KANhoz+TtroWklfxsFRimM0hil5XmlxDgM0Eox0+uxdctWRl4K7U0TuOfORZHLIaJ0JggEabZUSmO0RZEERFIu7gcnIOJGRN8SXfbbCR26kPXTREonhRZd9UhKZxWGtYl4SiZAEdqG6ByhayW6cC06+/tIT0oSa4CQpq6mSgt4oGxOq8n305uZxzVjiW6iRxmLrvqiFiAcZpmQQla9TmHqhCqUagWYqVo2WmjjKaSs5CPinqFzWbxUCes5BWxVTddNWutsDV6g0qbSwOZ4UhbpZw1Am4BzeuD5koPPoD9zidLq8gljieAxRY+yNBgNRsNMqZmrLT0CDJdZPnQQPW4ZLy2xvLTEwUNHOHz0mKStUmDX7j0897LzCEfv4fj9dzFaWaaqexhboFRktXWENKnfrEUwKjuDZjjKLpTTVpmpA6WwnNVab8wpL9S9mlhu5WRTM9e33H7HCZrVldx3ksSYLStCp+iEWZO9eJQWB9IJwUGXteiNxTDVVEsJomtEKZk1++oJCy3GJDYCMTd+kgv2VS+nshK+GcmXP2XNZTUH59AqScEfCE7ALGbSQsr21MoWVINBbiK1meSQBUu10L+1EZsGoXDHTD/PUR6IiGlKENVUIVrrJNJCTUOKAWMrUBpjLbqQ95f+ICfnr3JNKrTr3sreez75yU9x3333AfDQQw+xuLh45sxbjHzmMzdx2+23k1Li05++kSNHHl4/HRQC+/fvn6awbr/99g1kqxJ33HEHKSX277+TW265ZWM/5JS4+ebPTc9ro2NhYZGPf/wTG2/6BG6++XN86lPX45w7q2Pdd999jEajDW9/6NAhPvrRj9G27Yb3OXnyJB/5yEdYXl5+siObtN62m4CzcfB5ygGoSOxJMZ03/SRKQ/Scv0NTmkBlFbWF0IxYXVpkdWmZ5YXjfOIf/pYPvOd/c/LoYZxreXhhmePLqzJ5aoMp+sz2+jz76quZn+lTF4b52RlMVRB0oglBZGumkUwGm0kNYaLaPAGhSS+NehQ4qWmWTSIdrSn7sxzvZhg6zcFjkQcfWMrd/7nwnpsUJ8V/lU3kxCxO8nsCFhOAilJjyV4+UkeZKCyb7EsTpiraSmfNuCRMO5TKWmjlmrJCJhBMUjkx+/QoW0xdSbWWyMJWNdoatNU5GvHT6IYUSF0jcjy2XDOMUxCa5czCy/pwuSl12qyJnqozKNaiG2Mnatspg02RVa+rU74HM1UiMLZEF70z3mdLS0sceOAAP/0zP8vNN9/MD77ph7jxxs+ccZ+2bbn77rv55V/+Ff76r/+GP3/Xu/iZn/3Zde/pt7/9HfzSL/8KAO9+97v5qf/jrevu83u/9/v8+E/8FMPhkH/6wAf4tf/0f3Hfffevu9/+/fv57f/6X/n5n/8F3Ab15EajEb/wi7/IsWPHTlvTeazxq//u37P/zv34s9CtO/Lww3zv9/0ABw48sOF97rhjPzfccAN/8Af/bcP73H33Pdx9zz28/R2/9mRFNhu+UJuA88UB0JMGRJ9+J9a36TwV00B8XEDbHikpLjq/z7a+TGyVgWa8ysLiMp1rSd5T+yXapePgOrbP9WjGY04srRBCYPHhgxxdHLKQepxsAo0L1L2aLf0e52zbSr1lwKjziPO0mrLaHh2xTABFK0mZ6VO2U6cC1CmgpICy6tEWW3hwSSb+O+8dyrFyvSW22Q3NFLkZVK01RGojhXSVfXIygMTs0yOU6Nz5n11NU45+FKIj55thVqeuMGU9rYmEdhWVgui4pSgqAtliW4IdS0xqLfqBzJyIUz+fiSmdMOiUpD1P0TJLURpI1/R+TAZASZlNLCRidvaUOk4jgqEpSvwTOqLrsveNxpbFmscRKteXSlEPR2W6+ZlrCueccw4nTy6wc+dOrrrqKr779d+17v3Z6/VkAVFWPHToEK94+cvRSq+7wv/pn34rZVny0EMPceNnbmLL/JZ1J+k3vekH2b17F1VV8R3f/jqqquLcc9evAe3YsYMD9x9gfn4eozc21d1/4ADHjh3nz/7szzl0aONSPc961lW8971/x8GDBze0fYyRd77zd3ne855L2zYbPs6+fZfw2Ztv5rLLLtvwPldeeQXXX38Dl19++VOdTkubgPPUAtFG/33B2Molfa3SpSEETe4XmXxb/V7NFedpnI+iIpCiTHxiYUbZm+HCC87HGoVvW/bumGc8lhA8dGNu+PD7eedv/ibv+Zv3UM3s4Ou/4wews3MoZRhs38o4RNrcd7IGNGtF1WnEkiOdNfkZdYp5G1OAOhWsjNbYeobDo5q5XuLkQsvSiRXIDK7Jvsk7QKPrAaY3iylrdDZbm9Q9pFvfT2VmQojoopBaTKYZa60JviM4J3WeqicGZq6RSR2NG49FSSDTmWNMqJTypG4wxcTvJzPMbDmNONy4yRTunF40FSi7FrUZ+8hfX47idNnLwCjHAXEtjSl73hgjUUzRB98RmrGk7HRCWZO9jya4lRtf1QS4U67biCWCWmeyvefee7lg7/kcO3aMpmnW3R7g2LFjlKUIqm6Zn+cDH/gAXdety4Qr8+snTpykV9c8+NCDPPzw0TNH+nmflZVV3vSmH+Kaa67hxIkT637Gz3/+Vq677gV471lY2JiO2PZzzmFubpbBzAzj8XjDE8BVV17Jli3zLC+vbGj7ruuYn5/nwIEHuO222zd8nDvu2M8Lr7uOG2+88SzSfTfz0pd+DZ/5zGe+JHWbR9/+m+NpOIZ/8fxzo05/Gr16mRSbRaRS6RKl4NixEe/4HyNm57eSSBw8vsJKG9C6oO7VlIVhOBwRvOfyC87l/iMnufzi80Ep7n94maIqmd+6g+944w+y96Lz+K3f+E/cfdt+6kHN6vKQ7bN9zt0ywKhJZeGx+1/TpP+FyZyc1hK56ZH59OmPzTnGxx/g8uogGviaF+/imudfSHJtphGXoE3WOosk1wm4TKKWKL05uuznfpgkaSSVSHmFLVRnUVyWpk0/NYyTyEQcQ7UthA1WVGhrpTZjCpRKdKMx2lpSjNhsfWCqSlJxMU6tq9csrQVcYxbzjCFM61q66Imjaj6HmKLYGWTl5+iFDBGcz58pYHs9QjOc2iKg8gIji7Ey7czShOBJWKKu0HWPorBCGCh7pOAYfPN7TgsGq6ur3HTTTVxw4YVceMEFHD16lKqqmJ+fP+OE+elP38g555zD5Zdfxk033cS5557Lueeeu25d5e577uGySy+Vv+++h8suu3QDaaG7Of/887n11tuAxL59+9iyZcuG6kzz8/MbOsapxxo3Dc+++uoNM9euv/4G+v0+V1/9rLNiux08+CDbt59Dr9fb0PZ33nknx44f5wXPfz5VVW1onwceOMiBA/fznOc8h9mzZBTClBb9eh6b8nwmGnTaBJwvk7H4F9dcoik/lBLnq8RUrFJrS3CiQfZXf/cwNzy0jdmZHuMucnhhyGrjc+1FhAUqq7nq4j2sDBtmZmdF5HPcsLgypqgHvOCrX8rK4nE+9vFPsto4jLE41zHbq7hsz7ZMp06nMD3VKeChJhUGgZ48kac0iVfUKekjtaZYkBIriyfY2dxBX7Vccek8r3zVZVjlsmmcmXrtTNJFcfp8SXROmhIntYoUhRRRVKKBltNkaCs9MJ2bwmCKQfpxnEzwuizx41Vs3cNU/ZzeknqKH6+KcrRS6LIUt9OJCKgS1px3XiRgMiuPFEnkz+mdbOdbTDUg+Uaip2z9kLL9QnAdbrhK0esTujbvpzDVgNAOpQalNbZXS+rOVhLBuRZlLTEkYowkxMra9nrYqidqDbZPUokwWuWc7/nY5g9rc5z1UEr1NwAwGwKczT6cp+kwSvVT5ByVslNkZjvFia99DLz0eQPuONqQYk1dV+zeXrAybPAh4lOktJatM0IprqvcY5M8Dx87QdN5itGY6z/yTzRtg/IdtY50QdTBuq5j2DjmBzVaraXH/n/23izG1vQ6z3u+4R/23jWdubsPu9kzm91sTk1xJkVKbImkJEuixEhWLBhBgMSAHEBGAghBLiIgyEXiAM6FEig3yUUuYssXCRAHSOQoVuwkkmxIliXO7JE9nrmmvf/hm3Kx1v/XoRSJZJN0TlO1iQJPn1N1Tu1dVd/61lrv+7wz5v+2kpP17iKTJZVCT99it71v0V9bY2iXW1w/2uZyNXL1WsfNa4dcvNDoYl0KSQ4j1vq5gM5tk7YNOY560Fts06rhc1KENYKASXkWHBRVw2nbJkKDFATeaSSSeXqfHKNIjp0VJVqKlDQKCFNrqfW1FBmDxkYnXLMg9xuK0qWNc6pIi4KpsUJ3xoiPxtmGkiVZ1XpHig5MxFY1KWxmisCkCDTOkDW7By16xlqsa4hjUAWeeqCqlmINJmco4fSH6vTxvRqpveH3P93h3KGPEOwulKaQFXUyhZOleVR/8eIO738kMo4jzmSauub83g6Xzu1ycW8L5z2v7XdcXRcefOf7WWxtSfZLyuqlgTAMugdJ2BRZuiIudQoHh2tiKrcp0PgmUYAuJP78LsfwZxRsJ0IDqx9V1w2hOcvxWHHj1siLLxyQqMTj4qoT17VGXjMt10uaow1sVWOtCAXMVN+sdFI5Z9IwUmKUMZQQNbHOCqWarARti60qMvLv5BSIgxSW2PXErpcY6CywTZRNJ/9YmaMKijEiciiZUiIlDeovcuQoxtOCqOaSkhUoiTR2GkCXCV2nLDd5HUoW+bcxkvsTJylsFrqCUR9RUU+P7JHySWZOGjE5zp6fG3///ac/WKePN9rdfDtdzbcEep4WnDv0kdNwIcU4wbZmfwoli7M+Z1zT8rYHl7RulEJkCjhHMY7XDyOvHo4cDpmnP/c3efQ9H+DVWx1DAOd09KX/M8bi1OTZWDi7tWC7cZTUzwqaP6tAO/m9qbsxt3U+f+b9bn/Tj/HO0e6c5SA13FjDH33lgMODDZLWg0ZFJ3LoKXFUccQ0FpsAlQZcg1/sCBE5hlmtZgy4tpbQsixF29XNLHk2Rg/qKIexQRRvfrGF9RZTNfja45pGQJDOU22f012PjMysqyVrxzpV4UVd9quizCgfTnN0pqA28ee4ecSXhl7zcRBuXE6UmPALIT2n4kjZ4tsWTKUqOel8iymztBtTKGFNGjayR/IL2fdYi6+XlJy49T/+yOkP1+njjYzSvieP04Jzp36xXeusl0wUVy+ZEiazFh3jKnIc2dv2PHApE0LEKtesYNldtVzaWfDQ/fdz732Xef2Vl3jxldf58ks3OLO9orKWlDKbrqcfRmLKOGvYW7Xce36Xs9tLVpUR4YHolr/JgyOUAR1n2dvoA9N/T8SB2/578vRMJIJlu2Tjd7gStnjmxoqrtxIxKIU6JYy6W1MsuoCXUaIU3kKO0p3l0OtZrWgXHTXnscd6j6vrmS5QENK0KdotVhXeV1gnEurU9/K8nBPNN0XNpVbI1iUJ2SBnCobU9dqRyesu/+biJDRtkio7iWAwyn7Lw1rvEgnrPWGzkUjpHKFEGZvlSIojvmlotnZw7QpKUjm3EsCxM3fNoimwGNI4yihPc3jSuME1O5AiN/7Bh05/wE4f32mxeaO7m296nO5w7tCHNTlTRFo7GQ9z6HG+0mhhRw4D21sND97V8+zrA54GqLAmszk64Kgb6PuB/+m//02uX7tC6I44WI8YU7h8ZouYEusuMIwBZ2BvteDM3hbWN1TtghvDhpQiYwhUvj3pYFSQUE6+OU8I09o73faty0mwwVQKpKOovWexfZ5Xr13n+v6aP/1S4eG33KMMN6+k6oKrvMQ8qykzh2NK6JUSjXZ/EsomexkhSRtrKTFopLM7+bU1FI24NvM+SEZPOUUpNsbi6pWYR+OIcRbra41sFgWUo6g5M2M0TiGFAVst5kgIETFYGe3VFanvJHemcoBGX1sze3BAIiiMsxgyvq51nzVgTMbWLTn0au5MCvw0EkSH1VycCK4m+ZpqsQL8CUE7izDjxt9/PyUXzv/Svzj9YTt93F5oVm+wyPCtxmmnBeeO7nDqI2vIOUmObklxHvsIAThQcsBS8eBlx8XnAte7SNsmDtYdh+uNZK+QcOM+/fqQReVod1tuHK7ZWTQ8fPkc/TgyDiMpRNq6wrsK07RU1uHrhtT3jGNgtWynYdm8Q5rzdv5M2IPFTMpjprg0c/JB3ySX3t7aYbW1xTDc4gtfP+Knny4nkNAp/bKuyWMnB2yxkmLpKs17MZSY9NDWuGrEiS/jszgr3azzjN0R1WJL1WY6jpqC31DXf4qYdqUE54whC706qnjDWIxJusz38jFTcZ2eXLmtAlvZS+UkI7+SEsWpEKAUsAbrNI7BVlhnpyBUTC7SIdmpc2OWhhvnMCTpkmxF1IKaQsZUWbOQihKmG0g9YHCVBMIZ4OZvfVBWQpMgRf1WedoXeo/1DbFby9OKQfZWWLAVucj+iSmWW+kPEnsuwoo0rgGnEnaIYcDVi3nXJky7rBlNhrpdiNfIOFJ/hHVOd3qWnCPWesEepSBqwhDBeZWZJ2KMxCCcvdANWGOpPVSt7P0mwKxbLBi7DZvjgfXBIYfr4dc+/Rv5N9/kR8e3G4xW/pLdzHdaZL5tj87pSO1OLTgVBwWTpuV5yRFbteQQ9IC3yiBLnDvT8Pi9mZQGvEm4ya+BnLXL5YqL587oTTxzdunoBtk9tE1LW9UQIt16Q7fpZMmdM1tb28IXS2k+jGcRACc7mkmoZY1GHBijQE/wBrz+vjdQWagtEolgYKup2dnZY7eFqzcCz37t2kx4znGkxAFSECBnyaSxl0LkheYsb5JXY32lCaF6AJI1BG1iwmmRtFbTOCXuuqjpc4or0JJJDiMpBVXCqWhBF/ZWd0CzFLoUSlaVmKrHco4n5k8z/ahlKR7VghzlUC5ZGG15Flxw8rmS9UPLPDrLUzqpAkNFNm3mnJySMyl0hL5TntoIJUm2j/OUIge7rZxGKEsMBGGkhFEMpkUiGEzJ5HEjHVdJWmwgh046Pw3tsxjK2DOhh4oKT0occM5DHkWwYcDXjXamwqkjD4AIWVzVCP8tjpQw6M6smsepRokUM9LIesELWaNdcKGqxKvmvMfXFTlEuuOBcTMybga8l2LnqwV13bC9u2Dvwh7nzlQf5rs3cf///Xb7wf8XxQh8Kx/Nd1pkTnc4b/qR2sgGGKDID2AKgnbR8VHJGdusiJs1JSaefMBQm4F1P7LV1CwbR8qZ9TjypWde4vVr+5QCIQTObi85p3LpyUsTYyTFxLDpiH2HpdBU9RyhbOb3tEqTNic7GWtw85sUGsdUbOStMtBYaC0snGHlYcsbtpzl/PYuy6YhF/id3z/QsVSDa5aS1kkhp35q/XCLLfIYJLgsxbkTkq5PMnUmmbMxDqPATdnJODlQtVMQYkGlnY6Ethnv5bUde8o4SpHTfYtRxRzKQVMtNsY1FFth64WqCiMlysfGzTGp3yjJQFM7s0jMrfeYkojDIEUnDiIGyAlcfVu0SiaFnjyusb5R0oEUL9ssSMNGipNzpJAgjAyHN4l9T46JNA5K1Y4432rUdVJ6tgeFg1LyvGeT2O4aUy1lX+TVaFg1sgdDxphYj2kWVNtnMDkJkcEoWVxD3FzVamEq+HaJMRKxYEiQBnyz0J3cOPfRvqpwWpymy45vlyK4yBlrPKRAGY5xRpJPva8x1lA3LROHLoZEGDPjZiQNA93BLXzlyf0a5yuqZslia8nuuZ0f+Q9+jMUPQNH5iwoPf0FR+XY6nG9nX/MtA9rc6dF+Zz7+479+904y9pcpbDHf2AWAKbfWSAk9frGNMZZ2a8X+rcAL1x3WWVaNJ8ZCTELoHUIACqu25uLeDjvbWzgnS23nK5yXEZP1jnohjLHj9Zp+COztbNPW9SwMEJnuCUPNzqJocGXK0ZTQN6+Fp7Ynb56MKxkHmAw2GfpuzZgSQ6p55G7Y22ukoxk2YnRU06Xztfhl9IZsjJXxSL0gjxvJjikij47dMa5ZitBAA85yiPh2OZtXcwyzNFqk55EcgyjViqr+ctGbt1AAZMSWIQds1QikM6lhdOKhhUEOdQ1nmwCdOUEaR5x32MphjSYJGSvFo1rgq0o+xnlR6FXt3NFivfiZ9HMtOWJyIRfpfkpMIrueR44O5wzVcpvx4Dq+bmV0xklnBpphlNJJrIFvJOo69SJm0NGcvOYO126pnFvTkMa17qO8RDvY28ZgcZQSYvVzDB3G1XrfzVLwiiSpWh2HurqlxGEGspYUTtJoc5CPtyc5TE4pCkW7/ikMr2AY1h39UQQKKcieLoUR39RzV2zwhOGoeeLe5fiVZ7vff2GffAcfD98LT0x5g7/+rgCepwXnDn38+7/41l1r3b9hMOfIIl2mJKyvSEMn+JMQhMnFDtbfy1Z7nt//4usYX1F7x96qYdnWVN5QO8vOouGuc7vUdY2vasmbUaNk3TS0qyXNQrJb+n5gs96wvVqws1rhnRMPjZmHU3M8tSll1ktNvzalyMFTCjYnkR+HQBp6Yr8hdj39ZiD2gRST0HzriuVqSeoOeOyRXelgjMX5SvhlOWoEwTB3LNZ5chRvTk63+2SEJm2rRkZzWQ/9Yqg0sGzC3ZQcyUOP1V3L7Ow0oiwrRQ/AHObCbwxacBY6ljopgBhLCrJfyDFStUs9LJU07SucdwLynH+/yOE3Kf6s7ESkyMlzN76ex4MTlLSAmFtTEhRQihq7E0hR1Hy2qrAI1NT4WrN5UFl4wHkPSGKo8dW8y9HTnRw66XzUc0SKolT0tfh8NJpBK/hEw1Mq9vFs3JVRm3ZlSnCQy4GnpAHn1LRbIk6LLkVk8uQohcEUFXB4ee1DL6o9soxXVeZfVLGXcqDEwOZQvkbOW6qmku6yMlSVVxWhp6SCJT70gUe3/+S/+6fr599kR0b511h03ui/dyoauFMfjUkp4TbT0lnYnEX9NrpDqWowu9jFe7H2PHfdnXjbXVd49tZmBmUuG8+ilgPGOy/yX4z8gOaEMemke9LbakwJT+Hc7hZVVVH5E+Pn9G1k1P1obvs1WXcZRX4dc4IonpLGG86f3+bCxbvZ2tmB4jg67nj9G6/wjZeuEEMhDxteu3XMeeu4tT9yZq+RPQKQsxQTowoyIS+c5MVI6qf6d3CYqrptz2QUSyNRAimNMBEbSpZDNsthjAozKJOazeBcJT6XeYxlNQJhjuKRELWhw7dWisMMVUVMnEq8NtbojiyJGM84BWx6HQtGiql0b+FIg6UYydExxqjPx2NiEHJBNhTrMabHVp6SawiZEhIlBsKmo14uKO0CYxx57DBVo/k5tarwIpg007mtlThsVSgIk817iKPu8IoWxDKTrG21mD//kzlgUQBpS4qD7tayCgayCEAM5Dji60YTVh3WrsTkXHSE6+xMrDCaxCp/PkiOk3Y2tmrE5JoSvm5JccRiqJYN9TIwbiJNazDO4Bsvl66q0e4x4+uGnIZLd11q//b/8ncuvfgTf+/Ksz9AooFvd+z1RopN+XY/h9MO5w59/Eefu7Adjft5Y7iMEXmt/KCleTnsmiXF3oNfvhtT7eFcy/ntlj/88jMYX82O+KKKr5wLKQtpQKKHo4x5YpSgMx1FGAOV91RVhbP2RCwwfS/portMsQAq3c4xkkIgDYEwjMRhJI2Rxx65jx/9zMd48n1P8sDbHuPyWx/k7nvv5/Jj7+SBd76HrXjIy6+8zvFmw2bs2aoSFy8suetiCwrzlO5Gbq9p2FBywPn2pLuQ9ktGb8ZhvCcOHdVipRRmceG7SsCcExfNKDKIkrFVrdLpKIciqhxDPDc5Dkp/NljXkOKIqxoZy2m5nv6uSQWWo+yYTJGCZXRxLh8nN3lKxi9XIozIQWKtyXJQh0EFEyJs0CwHEUSActSYFXU5JvlcQySHJJ2Wr2i2d/F1TYpxHomCwepBPxdl6yhpJA5rTUg1Cnpo5OuQgkRHaCR3mWIijJOOsaTZg4T1OFeLjFs+WSmkKiHPYSAPR/q8M64StJG1yqOw8vkZY3F1I/BTjTe3Xgq1tVaEJRPPz3k1CWu3Zbx2uJkcC83S0Sw8zaKhaRdKcrBKoahIY2+995f3tsrRuZo//N2vjeOb+Bgpb7DwvNE/Ox2pvVkf/+HfuH9ZMp81mIem3c20Byj6gy6H4i5+63FsvYJSWLQtt65f4dWDDW5aik+U5Elrq3/XnJA2JXhq1zAVmOnfnB4TRLRMBSYlUoykcSSGQBwjQz/SDyNhHDm3t81nf/yH+dAnP87ePW+haRq8W2D9CkuDMxVV3XJmb8UZjvnSC6+zXfdcP05c3DY89MCO5O1UNaFbnxxEiEMfU4k82BhK6GXXkXURbix52OAXW+SkyjBrZzlxjoq5mZDLWQ5KKViW3B/Kgl+D4YqxWN9KlzAo1dp5aezCKH+fdcwa8FJwvmbsRtqdLe1Goo6G5FC31kAO8/JdDvE8f62M80rKrlWZJUgfo0oxGU85XdJDHEbdExVyKqQYyMWQQsLVQpMw2n1IgRoxVoLrfL3QEaKAS32z1A5DRl552JCGtY77wNVLwfcUcHULaDGxctA7X4mUPQb1Nan+r/I6zRzJY4dvFvjFUrrkCWdUsnRZas6VNFq5YFGSepKKAmoTrllKdzO//tIRkkUFJ2NEi7eR5U5L3S7xdUPVtMTuSC4kup+zIiapTAkPXNwrv/ff/m730g/AcVK+g9//bjuZv7TInRacO/Txa5+7r8GbT0B58mScHkUtZCa8/oCrtrDLR7BbF2XMMBxhc+Sr33iNNAegTSmaJ3LmWdKsOwNuY6DdLnmef62FpuQiirYxaJEJhDEwDCPDEBj6EW/hve94hJ/6yae575FHcYstIRsXR2nOSIQyFvqBdOsGpURWreXWa69w5XDN8RBoTOK+yyu2Vzoe09uqiAdk1+HqRqnRcjjHsRdCtHMyugojvl2Qw6C5MyMiv3XzmianIPkzScCdOY5ygBYpTEU/toRBQKI5MvPtkHHQpHbjtrjpaUF+EolQyDHpRVx2WjiJEJDJlSNtjmXfop4SKapGitVURGOH9S1p7EStFvXfxEoyahJ13Nj1pGRIGVLK+LrCNUIhKDljdXfBRL5Og6rm9N+3fn7fUrKM4ZQX51yl48Nd+TOj3qBhg3UCREVVasYayTZSEYH1nhwkq0e4eV4KiG9IY69KQNmdufrEbFzSOIs0zGQk1s9XaBBRoiRSlKJnnd6nhF+Xs2FYb1TyHXHWqAdKFIrWWRG9tEuKQGF3W5ceffpJ/9v/w/8zHP+AiAe+kyLxvS42px3OHS0a+PTKm7r5IJQPSIFQOa/z5NDJiGHscNUCzAUMMh4gjuQw8NJrVznoAzhLMX8eunl73AC3iQFmNhq3mTx1bJJLFmNdkCIzhihvo7yFmDi3u80nPvJefuRTH2d77ywGBzGRNx3YxTf5h3KM5KEjbPaJsWPYv8ozVzfk1HNrP3DxbMW9l5e4qhJzp6vmgiuHnBdfksJHJ06bKJwV/w9zFDUqQ04xzDsBa53ugoIe9My0AmONHqjSEfnVzqyKkk6pEp5blp3CFNNgXYWxBeHCWSZ5rnx+WeGcspx3lZebv28wDr0cWAWW1ipEUHmWlR2MdZWE0KFenBhEnYchZ9kPpZgoOFKM5CgHtG9kFJbiIIerq8B5vbg0us8wcyGd9k+TSMKQMaUoMDTMXwdKVgGE1Q5Zn0fJ+FY7TIqo0nMSpV2WUV+JA0lfe3LUyGyJ4bDeixDFGL1EeN0VokWi1q4w4qp2HjOWFOfPpyTBBIWhYzgeib3seMgRZ4sKGDLWGd3dybjS+YqS470Xtput2B/+9r94gfQDtMf5Trqe8l0UrT/356cF5w59/Od/64wZ2X63oXwSjDFGb6ZWZuWSlyKej1xWkJp5v+At3Lxxg5duHIh357ZEzvnwuI2LxjcVG/5MVJKZf8hTygQtNv0YGLTYDGMi5cLbHngLn/nUh3n3e56kWa4gFYiZMowUtyANmdyLAzwPHbHbEPs1/c1X6G++wuH+Ps/djBQSQ6mpnOWxBxYslgtCt9bnV4M7IzkvYaOmzXTbohoNUBP2nDFScMXNDq6qldpgVRKc55vwJPnNOUo422TYtJVIhr3X26/T8DaJby4aG10KWGuIfS+dhxpKvZcD2tX1SbjctJA3gtmxTvY0Zvp6WT+P90AtRFOHZyvy2OvnbIkhYsnEocNYKwKM7LAGci7ECDEkqrbCN15Nk/XcHRiLeFomZNKsQpPCIMt8kaOL2KTgmsVtl5YsIy7rKDlJ4UoSsTBdX6zX8a6SGWRXJFRr3y4oTIw4MXi6usXmqMIDg5m8VUV/BnJUpWDE6UVhEqvYyT1rAFdDka/R0c1j1kcBEwvWFJyH2I84Z7BVI92+n+Lca0rKWGcfe+r+rVd+4x8f/vEP6Fjte1FUvm2hwmnBuUMfv/7IzRLuuu8xY/h0SdnhKtz8Q683aWvFBMqKXFbS7ah0NA9rnnv5KkNWZL/+AJ50Aeb2YOjZxHjS25wodot2NzElMdFNXU1IhCi/f//dF/i5n/oRHnz4fnxdSxhbSrrviOR2RXaedHxEPD4idR3j0T7DwXX6g9egDHzt5Zu8djjStgvuOn+efh149D7D9tJi7B5++124Mx/G7X0QFg9RbIvJtzBllJ1IpZJmo2OrFGRfE0YZmxWhNcT1AbaqTyCfUf9cF+9SXbPsJHw1381yWKvwTA4+kkRGGA1gc75RvpvsG6wXJ7+tGxl3ImO+CU1TJhGCeppK7LH1av4qoDEH1lpNBC3i4Wm3CEMvkvCkRO3iRN6dxMCbg3iDQhC4UL+OkEaarZXc/EsW2oCvVaRgKEl2UTmIGGLel1l0qV8zKe1MjoovkvGhb5byWiX9nL1KsYt4aChx7n5Uo64XmYQpiapdyfvmiCFjyTPVwjVLJXOLIfhkrFY0CVZ3ShopTknatdXyWhdDGoWgMWxG0d6MiXbpqCqLcbL+8W0jVHEvQg4JtSuVr92j/+5H2//rv/qd4ys/IMdLeQN/9kaLzelI7U1RcH4X+l+49+1QfqpQfMlF1URJEy1FLSTjKUe2Z3F+oWOHTOPg9Vdf5fomzI2Kua2QKPP5ZFwz0TdVfl0mzlUuJMWpxDB1OJFRyQTeOj723sf4xc/9GJfuvqSeDhmdlDCIy35zRA6RZCxx6Blu3mA82Gdz7RXGo6uYheHKtZv83ldfp4uGynu2q8zCFVaV577HP0p19sO4vfdg2nswZklOLSmvZIw1XsMY2cXkUQyuxQDcLucu846Cogo153DNkjT0smdSc2HJ5iTHNGoOUUmyM9Fuhix+EOGDZdLQ62ucSUNA1mJqopxgpFbC3Fwt+wo5ENV0iTDgrIxydMxWacaN0/FQwlTtXLxMMeQsz2VC9ZQiBSaOPSnnOUbJ2kLdynOWzyPhnFW/SxFzZ1HatBUHvxQD7RjVQzPl8IgfJ8g+TaGmqT8WX1jW7yeVyRvvdVKVSEMnr1kWNaH1Da5dkMa1ml2dIGtUOm2sE/OrInkMBZOjfp+jIgsHCHUCY/CLbeXA1eQik4E4bmSUWgLt0quIwuIqh29q+Rpk4RUWLYhePwdr7U4aO97xQP1P/9Ef9uEHpLB8twXoDY3uTtE2d+hDwjNtwrjsqoUUGyNeg5xGucl2x3oTS4ybA+K4Juvy2y8WPHbfBWwYpEvJkMvkm1DeFZk8c8CmPY2qz1IihcQ47WtGLTRjYoyJnDNntlf8wmc/zi9+/ic4c/7szBUjDuTQkfo1OXTEOBA3+6SbrxKOrjEe36C7+To4Q3X3PVw97Pkn//JFXt/vGcbImArZOqJp2Hv4acy5j0B9ieLPAAtKqSnZEzrL0f42sezpEr9gvBGu2lyMy21hPJacxjkoLSfhi9lmqemhTiMGNrjF1hxiNpkIS5LY6oyRw3xC01iHqxtd/htZWhsBXRrrKEpqnrl4KYr6rla6AQVbLTTiQHZDpaTZNyMdiUjRxSsSyQqopBRZypdEioE4jjJi0v2O0fy6qhbQZzg+JIeeOHSEcSTHQIojmaIE8k6UakY4dEZJCkYBmsZW+jpUuj8aIY04KyM8k2U/YsoJMaWEQTZZEwVgkrJn6bpyv5Hfy1mKs6rTxJOjfqsgHZ1R5Rw5SIc4dVtpVNVaoQwDrmpP9kYpCCkiyy6pamC5W2Fr2dnEfiTngvOtCBiKBj8YcDI2rZvF4nM/9nj7i3/3l6l58+Ft/r+KwLd6vzf6Z39pQTotOHfyw1KMwqisMsWYkiWN14Wudj5FkiRTkMwcW9Xc85Z72HVSHMrtBwAn8Wuzc3E6nNMEzhTMfVBBwDBE+hAYQsAYw+MP3svnP/sJPvCB9+DqavaK5LEjp0jsj4mhI+ZAKvrf61vk/hDMiG0dmcjzX/4Kv/PP/pSvvXpIFxLdGFl3IgV+6sMf4oF3vFcgmqEiDZC6SDw6Jh4fE7qRza0N/fEozC9XqbprJI+9miwDxoiR0xoo4yDjMyVEFxUUmIktVor8WBihFeMqivqUcpbx20wU4GR1JIqs6feKkqQVHzN9jHUnCjQx5TAHsuWkOxn5epasIQ/GkFPWwqn7HO1SnHZM+pXU98vkFPFNTVV7vLc4C96rGCBEjbT2jF3PsNkQ+g1x6EgxiBepJDGbGiipk4Jzm3R+HsnVSxU7aG5Ts9I0Vq8SZTcr7bBOBRoeVy9OxrpOhAAifjkRIOSxE3Wh7n0EiTPIRSGKidY6r4gbj9WvV8k6urNOilcaFXsz0QDldaJEfOuhrinGaqz4QLXYUq+WCkmqGu8r/GJ5yVXVr3z2vZcfeZN1OG+0EH1fuqZT0sCd/MjJFOONMTrVN045X43gXKwRCS4jJW4kB8X04kkwsNjZ5W33nuMbX7rKcncbm1VFpBj9Yk4YbWZSoqWshOhCipmYMzEXeUuZ1js+8YF38kPveyfnz58Vb4fIq2RX029IcZAOKQaSynZTTsT1EeNmzXB4zOH+AX/yjWt88cohV447QpYD2NrAatXywY9+kHe/7yla74j7NzDtGUo/ko/XxKMDYtywWd/i+MZ1qr1jVos035In5ZWtJnJ0UWc7c2dnrFVPZ9YD05LGUcZYimGRbtCSi8HGEayTQ9n5uQhMDvlSxFGfY8BVorDKRjErWbopG4fZpZ9ioLJelIVauaYdCLdxy9IYqFrdseSRsD7A1guct1KjzFRUpTszVpb+pRhVYIHzelEphZQycbOmWi0pGNa3brB1/oLEUqgJNpcB68RwmcNGugdfZEQ1durdifNzEaxQlE4up9lUm1MUJZyRQl1SwlfyXHK0+MUWKXQYp0bOrF1olNGmq8SvZJzHeDuNt+RC5VTJZ4RCYXytHiN07yUdo3ieMtZYXFWLGs1oNLr3qnSzlBwI/Sj7R072cjl3ulMqGMPbd5vqV4F/+6/ALuf78r6nBefO/U4w++CdwYhqCB2vGFy9xFXx5B2bXYg1KQaK6fFWoZzO8ehDl/nf/vlXKNtbgs0vEyxy+raYsPyoh0QOpZQKIQZCkoKTEpzbWfFv/uyP8sDDD0lmyRzaYnVhHcg50x3ui0nPNwKTzJEQBvrNMd2tfW68fpX/+7nrfOnGhj6Iwk0+p8SqrfncZz/E+z74Pup6QT46Jg8Rd3ZF7iJjt2Hcv8nYbzg6fJWj669z9qy67seOUsRT4eqVwB1LLzuDNGIrpSxnhW8aTwojNglmBmvngWYOg+xlJvOnX2o4W43xHu8kOkDAkpkUM8Ymuck76TxIGeOd3KinGARpV1XhJv4enO5RMPOIU7AzkgVkjKVYg6kMpZMRVEYpBkk6p9itiYPIe611pBCVDK1jKUSpVlfSTaVug1/tEFNQ8oR0dXFzqDk0a/XJWAytAEFjAOtJocO3K/XcDDMjjSJ+IKNF2xQVtWT5vvPtlnTBKWEn7ptgEnT/okXFWSgBqGaxhGtX+v0mUnZBBWnyqvUiDY+DvP6+lviE6TUqSN7Q1DGqEMbkBE4uCzImNdj1hsXeeZGolyT3l6rSkWD2xbi//o3/8p5/ft+vvvrf/AAXl+/bx5wWnDtWNYBxkhJm0J2LmWKQQydolDDqrbjDtQtxfTin2BqJK97a2eLJt2zzhf0Dtnb3sFjdeZtvyl2RnJVCytLZpJQYQiQpOPTt99/Nz3z2E7zlrW+VjkDNjNI5JMo4kgdZVNt6Reg2YAdCtyb0Hd3hAYdXrvP8K9f5o5cPePFooA+JnLIcAMCls1v87b/5aR5/6imqdiWjPR3vcXSN3J4h+UK3XnN84xVuXXuBVDr6zpPYxjGAiXNujXMLleYWSpYxj3gCNQxtGstYiXh2TSU7FOsUu69pnyVDCcTNodAMFG4pRUYX3VLyIEZSivjFioxCNZ2bI6uNxmIL5UAXBSQmNM6cZpchZ2G+lRwoMUnn2u4QNkdY78hpUMTRApcLLvdKGojCjMsFa41EhJeCr5wICEwhhyBFhcJwfIyzDkONrxe6f/FgLTn2xGHEL7exrpb9lq9nQ+xEKhCeWoNRs6vEcieMb9S9LzuUFCUS3NQLisZrG98IPNXL1yINx7h6qbJsybURObaO3JQ8LSNMK8SJ2EHdSiibkcuDmWwExuKKMNSUjaPRCSJjz6WoiKMhG8+wWdOstnREm1Tl6KkWS8Iw1rjy68/9Z+d/58Ffu/71H9z77vfn4053OHf2TM2ZUk40zdbLrTIXzWMxM6VXYI9gvMFUDlt7oeEuPI8/fIlF6skpcbLKKbctcbXYpKSJiSIMSFk6h3c++lZ+/qc/xT333Sc7DTjJokmJ0q9JwzFx7Eg5Ybxk1sRhZDg84PjqFV76yrP8wZde5refucmzhyNdyCKpVh/f3taCz3/6gzzxrndR1SvIUIJ47Yp19FdepH/lGcb1AZv1TW5deYm+Hzg+CDzzBc+rV9/BOr+DzBY5SpeQxg1pHOYD3xhDHHopxrq/ySmIxNieaPiKlfFOCiPkLFMiLe7WItj8Ehm7TuMKpkPR4BrNjMmyhJevS1KYKHOcgYzIxFNDTuBrVZxVMpormRyjLO2BHHpS6EljpzJ3M++gYreeR3CC2pe9kXMZ7w3NssFWFuenN4W4hpE8joTjA8bNmjD0xDCCr7HNUhsCJyFoGPI4SPcw0RScnztDv9iSz2Ey3BoVwCr5IIdeMD4lnajqnBfBxthp0UWeX6XCiBBUgCHPNQ1rcpwMwz1p6CRzqD+QWp2DGkDR8ayQxk0RAYezHl95fFOp0E8uaFYjw2OIZCClQgxyIXHtEluJf0r+roxf7Fzwq8Wvf/HXd/Z+gArMt7O/+VYf/y0fpx3Onfp4HJPBWzBzhHHJyiQciWMvpOFiwC0xfok1taBPjAHv1CeS2Nvd4v7zS55bByqVqJrbxmmlyAgtpaJRAYmgRejxBy/zox/7IS5cvCgHclS0i6J2SgrkOMpiP0ZddFtS6oljx/rWLZ597hX+8MV9njsa2QQpaClnko6Rzu2s+OxH380Pve/dOLegZCN0gmEgRcW7xIHx4CZDSHSbq0QbCGNmOMycues+/Op+RmNJ3SEL9yzeC3BzwtzPEdCoOCDrOMx4jNPCPZst3XyTdnVzgneZRjqqTGu3NFVU8TVTxLVxEmWc4zCTD0wRqXbRYDjnW/FU+YbbE0bxtRQgwDVLUfsFCSUrSWMASiaOo3Q3ugOaqQXOikw+BpxTqsOU3okcrMJaS8pfS7jKEboNzgsOpm5lpCiFw2KsEsBLJo9JFYBTDHWcjxJjxduU8jDvyYTAYFSbLbsryfkZRIoewyy0yBp0Z7K6/kly8SBpLtBCLQHSxYkRdGKsiaZfdkvihSpJpOsyD8t6vbZUdUPo1mRlrUHBOUcIUeTg3hKGDmsSvlmKRDsF6cxMgVSo2uaTy7OLH4fDf/BXoHP5nv19px3Onfq48AnjjPOT812ihKPyuSANHcZXmoq5DVSixrIVaexI/TF56CEW2sUW957bpsmRkoqO1DSQbN7ZSHczxkhIMur6yLse4ed+8pO85S13i68mBukOYiANGxmXrY+I6yPi2MthljOh7+hvXefWyy/yr774LP/712/w5f2B4zGJWTQlYpbiuWgrPvOxd/NjT3+EnfOXxE0fImnoSMMwezaKgRgHhqMbDOMBm+M11567xnL7LnYvP8xi5xIltaxvQUnCHbO+VtJ00sNadwzGynitakgxYa2jOx5JIQiqv0AuGi6mIxlm5ZmbKdOuqmcCdI7DHAw3xxHIAkBGQFPgWNHy50R5JaZNVDUnB2bo1yJNz4k49EJlVoq3tRWpyMIbk0/EDSmQxoEcItZa6tWCqm1xdT0v9ktO1G2jUc3yfTAp68Z1L6TvYokhqOdGrVlDL+MpX8lzDr3smOJI6jearirF0GoshsikrSJxZLRHijjf4KoK5xu5EKVxNh9bY/HO45zsTChFTakyZrSKZUpjj9Nlv3R02ptaCc2b/i1jivjVRrmETVikuq1plss58bZqV9SNcOly6PC24KqKMIykvoMYKCFCHKmbBeSEbxbnvbW/8JW/e+mtvPll0t+3jua04LxJHn/4tSOTS7GZZObQGevIcVB2V5qx+DlEhqMDhsPrxCGAqSAVcsjkIZKHwNIYloi/Rn6W87zryFnUaTFGYiyEmHns/rv5az/5CS5cPCv37xA11TLfFkOwIY0dMXRS5OJIHDr6/evsv/wNvvrl5/lnz+/z0tFIHyJjDIw5EnKZ9zbvffhenv7kB9g5cw7rF+BbTDGUoMWmFFKOZCPZNOPQcXjjBi/8yUsYt2Tv/kdo9s6RM4yH+4zrA4yT55b6Q0rsdRxphdlVtdKVjTKSQc2CzlmlHHsFRYrZMw4dcRCXOrkwCTgokGKSgK+chSydDSVlUWVlDXfT0VEpEgWBqg1xHlu1mGqhomYrMuN6S3EsWSXmSCwq+vUyEuEtr55TGnMtJta6pmpbcs7T/l12K96BKfjaYqz8mfMe5610EClikNEcGcIoME1bLSBFqtWOfB36NVDwqx3ycCQFyzmFgTZYVxG7Q3IcRMCRRtLQU8IouJhKTJ7Wt7JnjKPss6pKXwv9/ylZ1jcqq1a5eVav1W3iDqNCAKzH2lrI2ll2WOQoXLaqkYKfoogpcqZqF6RYyDGI98Za6rbRjrNgrXSkQ7dhPLypopOWQqFuKvLYOeerj69a96Hf+vxfmXP0uy5cpyO1O/TxFLBvnbPFKjwgUUzBlkYc8UAaZflqnMcvtknZzct/65aYqsK1ULcD585G7r46cHA0kJ3GJ8Pc4YSYCLp3eMeD9/Czn/kobdPMAWc4GdMYKzk6KXTkNJLSMDvKU4z0x0fcfOEFvvLl5/k/nr/Fa30hFsQoyZSfYmgrz4+851F+6eefZu/cJWy7g6kWpKObQigYOmKIFGNIpRDGns3RITevvs7LL15jTI5LTz7J7oMPYXxFf+sW61dfhHDjNrVdAi+O/IJVf8tAMRVxFFOm7D4i9VJc/WkUg2EaoyaEiojAKn3aNQtloSUsBpuM1hCHMTU59hqmJjQCsqBnfNUKhFTJzhNU1NYLqJeS3urEa+W8sNuMgWQiMGH3HSZFwihBaCVrDLUWzcmT5WuvjnuJxU4xCGXAesKY1NuTKMXgnSVOkNM4EvpjjF0x9muJuvaNSKyNjCdLKeShw/hWd4cy5srjsVIRJsK0+pkQs3JJQYprzuq9sdIR1bUWdynaOUdyGLDGYis/+3SK+pFMEeqA8S0miVTdGsQMrV4lo1QHYx1x6EUyXsR75n2Fs4Zma4s+B0qxmGqB94mUCuPmmHa5lDTcxtNtbpCM5vJMcdmuhrDGN4szxna/+p6PXfwD/uHV504FBKcF5037eGY4sJfsbk1KZnKjGz38xB8ictE4rKGBPI7k4jRwKqkXVA7dHAtpjGynkXoYYCGcrJx1dxMzMWWWu3u8/dH7+dQHn+Di2W0mLllOAVNvU9KGuDmgWEcMo6RwimuBnBLD8TG3Xn6JL37x6/yjL1/jetCdBUYPLTmQFrXjU089xt/4hc+wffY8tl5i6qVQjoc18fiQVEQxl3MkDj394T77117j1W+8yv6tnnseeZBLTzxOvVqRuzX99de4+dpznLsYRADgPGVU2WwZBfGPxgSEqK5/NVVq3IK1RukDGV9VpFREDRaT4FeGTr2J6sJ3Vn1Qctsuati09SQEmFhgWyqpnrhpUeTiYy9Y/Xqlyc3jjFfJSaXqGmwnyipPSknJBhU5d+QQqLcWpFFpzc5DykKGLghWRndQE/XbOisdG6LccsbhayFcx82RiB+qXQlro+CsmUUpck+pCJsD6u1zsrQfO0zJktNjPJThBAdUtTpCrPTCYombWxQstlkwhaYZHRnLgT6RFrzGaJd5VGmsneybcgkae4raAIyvyEMnggjf6PjyJIIB6/U5ZZxHvnfULGucE+VigdD3+Mpjncc3DSnBeLymKZlcDNVyQbWUr3cayruXxnwW+I3TInM6UnvTPtq7LliTy1IomFmHB3KDtRp7bEoSeesoKHrr1LQYR+LQE9bHhOOO8XggrAcYBi5XI2mUubmMq0RCvdje5Yd/7FP86Efew4XzezOws+j4LYeBYiuKlfySKR206Kgr9B0Hr7/M17/yDP/4S6/x0v6GYRgFiRMjKScKhXPbK37iI+/iZ37iE2yfvYBrtjCNhMflzQFp7AhDT0pl9mcMh7c4unmV1156hWvX15y/+yKXH3kr23edwa1q4nDMwZUX6fs1O+esKpaEAzfdbnMQHBDWzCorVAKNFSFF0WW9ncyTSnbwteyBXC237TyRoFXJJIq3YWaxiegALW6jcNQ48f8UY2X0Y0USPI3h0jAI2Tjq+6kfZ/q8ShQUjW9bpR1kfFMr0TnPo6aqqXHOzyO8OUxPNiAC7XQn1ALfVvi2wdU1rpId4LheE0ZNysxZXr8MOYqYolrtiZKsSEyEBJ4VeV2yxHTbaqFmUv1cUoA4Yq2XHY91SmyYggE1V0hHvaUUzQzyJ4GBRfw6JQaxBaigRpJERUAwha+hya+TKi4OAykVCk5QOWgXqUpEMf1axk2naRCearmF80Icz8XgmxpKENOoqOAq1yz/va/+F/ecexOPyL5fu57TgvNmebxld9saYzTnWHG2U6SzMfMy1fqlSIGzjLRKjOCVkpunKGhV7FA4V0Uu7rUiGEhFDrsCH/vhj/GBxx/g0rk9gUKmIqirkMkpE7oDYncst2iv8cD9hjwOhO6Y9fUrPPe1F/jtP32VZ/Z7xhTpx4ExBEXGZHYWNb/w4x/i5372M9x93wO4dhuz2KZYS+qPiN0RYejJxspoJSfi2LPZv85rz7/Ayy9eZ2fvHA88+QQX778XO9zCxGPG7jrr45ucvXvBzpnbi4lIx3PU/UnJ5BD0dfNi4UBGTFXbCHL/Nve61ayVQpEIbiPLekOkhF72NNOy2jqsa04MjFpgShwltycOKkBwsqsqkuFiXEOKvRgjm0b3O+r6z4VSouxkjNWDXyChsV/r87OETuTDJY0a/qYjpCLP2XqHqypiLLi6wTmPryusM3gv6rqqbanaJb5psc4SNgfyddP4CgmwEzl4SSOkXnyyJUp0j9MocrKOtKQ7MVWjmXOBnAYZ2bnp6xJE7ab5RJJBJKIMq0WiBE141khr6UgkvM7WS4kTn2LCzYkIYkILTSFv04gvxawS8yACBq9G2DDoHm1BGCOh04RTB1Vd4RdbxCAU7hyDCESKFU9Xjg9vN+ZX76CC8a9bRHBacN70j35tSzEKmMq6ADUarauz+sU2pjlLt5YfUOc8rl3hl1v4RYtrGyHvOo/1jrqqcAUeu/c8666bb69PPHCB93/swyxs0r3F5KBPxPUxw80rxG7NcHSN8eiG+B9SYjw+pL91jfXVK7z+0iv87pde4gvXjuhzEpe3GkpLzpzfavmVzz/Nj3/mU5y5eBnXbkOzku5iHEibI+F5pQK3JXb2B/tcffF5nv/aKyyWe9z/jse565GH2L54ARd7wmtfJR2/zmKv5p571ziPJmPq0j4G5mAupRjPfiSV7OY4aNcSVThgaLb2TlhfJeN9TRo2Siyecl2cRjwrr84wGx4lwEyZbNaJqCCJ8KBgRUY+9sS+0zuEE4NnGrF1i/ENpqopqWDV0yKxAQvByxi5cMQhUC+XuGaF1a4BU2Gcw9ct1ivTTSOufVWrNBr5uyvPYtVSLZdUyxXGWY1ugLBZa0egkc0GnBNSeUkJ4jjTwWVHovDWEmbFHXHAOUu92sUvt/HNQpb61mjxTkJ/znkGbpJGXN2IadcUUnesiatFOzOhW1srI0Nbt/L3WI0Gt8oKDB1l3FBSj7MWayxpzDIi9TXGyPvkOJBTEPjpsCEGUWySM95V1Ist2Ys5T9RI80lY4JsFvl4YKve3Xvh75+/izak6Oy04f9Uf+7lyhrycYgOKHo7GNVhdipICVBcobomrG6p2pdkhXmXBcrP1TU21bGm3W6gc9+w5zmzVOApPPnyZpz/9AdzWOeLRgaJAjBgChw3D+oBhs6a7cUUMgsMh43qf4fiAw9de5uD6dQ4PDvijr77IH71ywKjonKyiBO8tb7/vIv/J3/llPvajn6Re7WHqBbRLCUHrN6TNIXHsCVFEAjhHBobNmpuvvsRX/uQFwmC4/4lHuOfRh1nt7srOwTtSCAybQxp3heWyk2KSRL4d+07HZ/kkB8h5fT2luKYobvTYbWTPYZ2IFSbjpjUaN+2Fm0bWMY0lh04v32IyJEfdFRmFbXodA0mhmW7hsd/g2h3SpJDSIDaBSibysBZZ+NhTb21DCaShk7GYNYA8d2MMvvZCExg7+ZrXjXQcVkPFXI2rGsmcqQxxHLQYBKyDOPb4domvG4w1ol6rGjFyIl1zzqLyc3UjaxErBUg4eWVG0vh2i6xoG6Om16IppMKH86Cwz3JbIoYkq4oJt5QyJ6yi1AJbVXOXYo3F+RYzZfMYhMZgKinu9XIOYTMaaZDDAGRyjvhKIhlEQCKUi9Bt6A5vMQ4DYzeQM6QQlMMnxcVXIufuDg8ZNxucb8WbkwIlG2zV7lpX/VvlJLnw9HFacN48D9cdeWPM9hQ5LDuJpOZP9VC4mrS4F7N7mWwaTNXg6wW+WuDbbarFLn61g28aqramXq4wy11MDR95oubdb7+fpz/5HpZ3PcKNW/tEt2A8PiSPIkmO6wMZoVUNtl1AVWPrBRnY7F+n32wIIfHHX3qef/LVKxyFE0yNtYZl2/CBxx/i3/mln+TBtz+BW+wIrLKS0VFJgdgJoSCqBLogQofu6ICbr7zAc1/+OkdHgXsffZC7HnyArTO7VE0FJguqxDtK6bnn3hHnBY0fx0gOiRgg9h1pDOrn0cW0EgRKkqCvgsqZi5U0S+d1nOI1/4Y59mHOetAFvfX6XLL8OBlbzYUL7XiKxjWnMMih17Yiaq7q+X3SsMG3OzImm9AtGtVsXI1r2jli2XmrEd0BUzJpPMaUhPMO57wAXo0qqkzRmAT5eyTV0uGbBld5uaG3K5yz+KrGVS2+bqjaJcZaxvUhY7eWA1hNwtNOyan6LCvXLHaHOuKyqtSz856sqCrN6D5wtuIakS2Tk0ZLuzndM3b74uHxlbj8jfhx8rgW308MMEVglyTKy5zB15QURAVnHbZaUDLiq8mQQlKxx1TAarAVYSykbBn6RBjDLDKZJgvOyWs39oHheB+s0Mnb3T2sNa7a2v6Zb/zX9z1wenr9xY9Tldod+jBtY1OJKzQYarpFlpJnsjPGYsN18vYjdN0xthRhYhmnElMLVqXTiy2OqzWv5TX+1Vt8/KNPUfw9tFstx+1Zuv0Nzf1P0H/h/8QbdW0XKKkXP4ZvFaOyYX39dbrDI2hW/PGXX+Qf/sGzXF0PMwbMAm1d8fT7n+DzP/3jvPXBB3GLXZEAWy+z+HFDOt4nDhtBtoRRVHMxMPYb9l99kee+8GVef/k6Dzz2EA+97ynO3H2JysmeIKckWJpxzWq5ZmsHhWNqHk5dk/MGV/u50zFYTNLD14o73+oB7SqPMQlsUfNnVOimIaURm73IzSezZGFeypdidEeASoDlRi9KK1l2T/MPYx0p9MpTE3y/8XJwpXEj6aNVo7Hf5TYhgiFP01VVxrm6lYM5jrJvsoYcurm7MSFoIqfIwq0XwYSVfbqy4JSa7CtsQT1ZCSw4Z0jjwHAs+T05GIGBelGeFfUZlRAF+9NsETdHwumzJ0VZqABJjLVB00Ct5hWBEtBrvRRI4UnDWsaEmjyaU0QxBComCdLNaEEQQqeM3ERwgEJSvRhiVVGJeoesr5XTN+r/F1IyTDzRFCNp7Chti6u3ybmnahvarS3WN28x9hIx7hcrDBlfN6YM46PeVj9R4DfMm3Tkddrh/FUtOE1tTcl1SYJ1L0plnublRp3qZvMCvhyxWZ7nRnuJ+pEPUV1+DLM6RyyOgGOTLS8djnzp+jE3xsKjTzzF6txjLJdL8SHULWcvXGbnrY/jztzDsF6TY5RRTN2QcyD1x/SHNzh67SWG9RpTN7z0ylX+5z96ltfXA3rEyg3cWj7+5MP88i/+Ne5/5G341S622RIOWwik7ph0fMB4fEDsNsRxkAydMDL2HcfXrvDS157hG8+8xt758zz4vh/izN33UFVeDuEQyONAHAbG9Q12do4poWPozWRKV0SNpJaKmdAp5kQMkjlJoJ0YI/0cy3ACJM365xL/nLVITJkqwlArGnMw6u5CUClmQsqEfj6ImfZiMcwplaIuS4qcKQreTMReGHBYRwoDKQVB8JdEToMu5aWDSingnBPBw5Q7U1XSldaKMXKSAmusKA/BkmNWb02rajFZvE+cNeccVbukWmxTSiKGgWItGSfF22knV4wKSVRNZ5gFAZOqToQBsh/zyx1KGOdujxSE9Kzx27KrGmR8bNVTgyj0ShD/ka1bYdaVRB463WikWRko0NBKFJxDDylIOJwKGUrJwlKzThlqA3GUYjdJpM1tFPQ0HItcPSecc9Rb24xDIAyi1gwbgY2W2O9U3n34+f/04sXTE+y0w3lzFZwYrLGmKQVwIh3NOYq3whiKot9JEXfzFVp3zLD9AO7cg/i2JR9coy//kj57rr74Kl2IvPfRe3nXe97O2bvvUeVWEcPc0HNwtOar/8qydNt0+4ds766wjQRcOZeJw0b4YWcv4Yaer3/hK/zW732F5/c7kcbqLdxbw8eeeIBf/ZVfZvfCZZHG1iu5DQ8jZehIwxFpEBhlzknQOjkQug3HN65y5fkXeOGrL7Ncrnjoqae4+/F34AiU4Xg2O9oIw9F1aq4Q1yPPvbBF1Vxk5+IZFls3qapXySFR+UoW+JaTkWRGpcq6MwnjPNoy1uO8Iw7xZBw1pUa2KznAUxHDq2tmGgIT42s4mn1H1nklNAiUk6TpqymRdQxnjCePgyL2RyEx5yLjQvlOABzWNpCluOQ4EpPBhEC1XEKW0ZmrJZivZAnjIyUtThoiFxMkiTAoxem+pGixUU+RxGnifIUtidI02KphWB9gjaVaLOW/j/fxzQJTN1IQjCVPCrQieJ3Yr/HtCpzQMNxyR8gIzUKemdPCGYVIMHlyoFBV25QYCJsjETJ4j3ELIUdYp7J+UQ7GzSFuuQ1xVKxQxjQLvKvJ44AxDfQDMcrI13mPX2zRH1wjjaNcKrwlR/GMDZvAUCXyzoBxZ2Z6Adbi65rWOk1cTcRBRB6xP8LayqQS39Ns+YeAK6en2GnBeRMVnGhL5Ztph5OzokzM5NQGay3FblO7HWrfEjbf4Mr/+pvYxRnC/8vem/RaemXpec/uvu80t4uewZ5MMrNSVZWuSlWTVt8UbEADC4ZhwQN7aPsHeGJAf8CQIdjQ1PBEM0szAxYgSzZUZchCyZAKkjKzsopFZrILRsSNG7c553zNbj1Y65xgwf4BJHAPkGAQybjNafbaa633fd6YmK+ek55/yZ3NOY/vLrn//vucPnoINsjt2gC1US5+wTx6/uD/+ZeUnHgzbvjAFBZnJzKicxbT9bgK6fKCJz//jP/tX33ET863ZJlwYIH7Jyt+5ze+z3/xn/1NTh+8IZgQ38v8PkbaPAkOZx4o80iumZYTuWTSPDNcveDi88/4+Ccf46zngx/+gLd+7c/SL5e0OZNVGguQxi1XTz/j/OOvSDs4u3/Gw/deZ/29v4hfBOqL/4OW/jmlSEyDaRZMxYWeHCfpeLwcHAfUvfXKmfva3sx4AVGGlXDo9iMu18ltuMitvqWI6TrFynSHcDyso8RR9jJ+If6Rkml1xPUL6bAM1KKHv/PUlpQR1mScZ1QObx3YJaYUXJWsnVbSQbbcSsI46cpaMjoyNPoze+ns8kZEISVScqP3vUQkWIe1sph31UnRCYGcC9YK/SCOg6jCfKe+pUqrM64TvpjVADqsKPtcv6YZiwXcYiUSZ2MOHaA1jjJtxcXvnLr5OURElDpr3DRULJYsQgyMKvuaCAF9R4sTtusPz3mLg7z/jNHYDcs0ZH1dKvPmUro0I3k+0uFmwqInbpNAcW1HjTvdr2mXbBrWNLrlivHqEt8X+lAp8yxpqcW+15bml9s/4PfN31IE9u3jtuB80x8z0fnKMQc0YdObnRXTJQ3jelq2WG+xXUe3OKJUSMOGtrkmXT4lpJHTD77H0aNHLFbhsAg9mO2w+O05q2Hiw7fu8+w6km5mttsr3GqJCeICL/NE3G44f/6C3/vJp/zBl1fkqnNZA+89vsd/8js/4q//pd/mzqM3dRTiXkVYl6pUadnXZPXZ1FJIMTJub7h69pRP/vDnDNvId3/4K7z167/J+u4DbI00awQYaSU9cnd1wR/9+FO++mTLu++8Tnf8iNVrHxJOX6MON0zxdWxZ0K2qChLkUMdkamn4/aHnRN1Um8h8DVJcAeHG6ZjGIOMV8XU4leBOtD2U0xqMscxjJCzl95ZuwSgUcsZ2S6zvJFm0X+geKmukcT3sNCSu2tGKYlmcBsV5NUa6gKlR5blGpc/qwjeilsNbbPWHQacxsnOxmqNUFVpqQjiModgDSdVYaa3B+0RpldB5FZMoTSGsaBScF5o2eVZZdFODq+JwuoV0UvvkVeuo0/CKfGCDdF7NSAKtAeMCNY6iioujFCvdp4kkO6vIwKgMPIvyEWjsiQqJlkVKnpX91w7vfREiUCs+LEhplD1pQ/c9Fd85kV07iZiWCZunUSBYTMq44Jh3N/juTJ7LVnHOdzW1v/6LL9/9h/CLq9uT7LbgfDs6HLyzxqzkhl6xfkGpUWfQIg4ocVKntyqaLHjrMMslLY5wsmb98CHLe3fplitBr7SqMcbyXYyxdGHJXb/jtLvgwTtv8fzckM9Hbs6fcxbewBqYdwOfffaMf/L7P+Wf/exLNlGikJ0x/OaHb/Kf/8e/ww9+8MusTu5gfa+HjIbdUKh5phTZR+SSJPQqZ0rOzMOWzflTfv7Tj7l6dsP7P/gu7//2n+Pu+98lWGjzTG6iaCo1Ml5d8OnPfspPPnrG68enHN1/jbC8Q7jzFq1apotLNk++4M5ZO3DGBMnf8L1TynKhZY111p+ztYrtgh6Yuu/Y57qgUuK9HFfn/45GSdL11Goldpl9DMCMW6zJc9Rbvd6EncX4npIGkQ6Xgu0WOmKzFA03swocNS5guoXSmKWQNfSwtZaSJrplkNFZyeBE5h3WRxoh0SRSIieFYnqwHudEOSb+JKPPBbjD+LbI93MeZ6RwpnHDVDP90TEhdBL3bKxQsUtU71KQXZXRBX5+1YXl4UbTTs0hcsM4r34lxfdECZLzvpNuRSMjRKaMxkRoB+k6TFgc5O7WWJHG1yoJoMbRiqjOUix0DqVlq/jCGoGZBkOZZMzsvBTOmqOq5JSkoLms1IQPPbmbmDY36oVaYGnIOyL+heVRuwPcFpzbgvPteDhT+oZfWxvEm6IPWWyjWR4Bqkh3jeLzaY06bynDJW61wq9XhCDkXYoscSXPRkPdVDti6Enn5yzW19zzZ3Tvfchn/+J3wXpyLvzhR7/gj37+FK9qMlmmw4++9xb/zX/1t3jj7Xdw3VoVTOqPcJ0sjksR2Oe0pSQRQZSSKCUT48zu8gVPPv4FF08uePd77/D+b/029z/4Pv1iCdNGwJ+lSHHabnnx2Sf8o//7Z/Q28ODNNzi+95DV3Uf49QnT+Qu2X/6c3fknnK03tBBElqzR0/vbPlYRMkVc/LJnEcOoMY6cK94JKQ5d/+xd8dZ3IqkOHdYFShRwpDGJ0EnC6D5kTW7iCpX0PZRMTonOJ3wnu4Gqi/KSEl6RNMJdkwCxWjXuuFSaaZCTeHJU5Sb8r0jonMZSL3FZTbxKCqhAiqMUNawaLyV64VXstuQTSUNdaC2LOMJLts/y9A7GXpNiEvpE0eA6L0VZjMRAiq+SVlW6XKPsV4Su4MTHM26VaQd12tKdPhCV3T4d1TkgUOZBvE7eqQpQLjvGOsq0wa3PRHzQAB8wacSEBdVW8rjFdQvydMFmm7h3JpifOk8yimsRZ8EsVtAic55UXyaSwJZn6iyjVeMDdnkGsUEaDsy+NE1Yk/GLNY2CMfnxPNq/CPz89iS7LTjfioc1YWUMi7rH0pcJa4LsQ5ADGyd7BoEOFhk35Ewdb8BAv+7xoR0Ix615jKm0XKDIrHtviPRdj+uO2T57QalburuF7/2Vv8HLJ5/xxb/7t5TdwK++/ZD+zgP6s1/w1Tby1uO7/K3/6K/x2htvqe9i7zSXUQRWaMtld01Jozi540hKs2S95MxwfcHTT37BFx894dGbj/neX/4rPPgzP2RxdAJppFUJeCvzzLy9ZvPsc/7Fv/4xn7wY+Bu/8h6vvf82J/fus7x3h7S7Yvj0Yy6/+Ih+KQFiaUrC/zJyU22lUtKermwPqZK1AaXgfBCIZtHuRmf+0AjrU/I8ipRXZbZp2mKdk1gILxHVwipzIvZolRwr3UpSLMESlgtRjMVRkTlye/ar9YEkUfKMM0u5vWfByZigB3sDF3RcaRr98QlxN0gkdBSPi7j0PXneHUDSznfSebpOYxYKLY60enQQG0hQmcUv11II5pHWCr5fSh7TakWeL5ivXxBWp1AivuvwXYdbnpJ3l9huSUuzPB8lYZRqIHudFSWNrxBATSLMbb8kbS80zM5R04zTwug09RTnhQPopLszztKyOxhI5Q8NuzqlbC/BdljnmIaBaZrJUQjfe6+YoICa7LRqIU0jvguUWCQZtFuq/L3hV0vhugHGBpwLhIWjVIibLaHvlAsH1lprff6bwN+/PcluC8634pEy9zy5kwEHcngb3d9oYiXOCE6lSK6I8YK39+sj/OmpQAZRxzvi4MYFbHPUFl8lSFZB8XerFXCXedgxXz9nfPEVrVbeenjCcWjM7ojtnPkP/vJv8+j1+6zv3mF1fKr7jSJRvnqDbjWBzUoukKA3GpKXM+yorZHTzOWXn/Pk4yec3bvLhz/6czz81d+kXx1h0kibdwf8Sxx37F6e8yd//BG/99Mv+fXHp7zx7ls8eOddjo6P8aYyPftjNhefk+vM/XteD/9K1ZRO1wXJXtnvC+qehl3loPeBPTus5Iyv5QCrNNYSx60uu2UhX+aRsFqDCTQjzLUSZ8pccZ10P1iPCxK3YLRjESwOChP1B1SRaVZd60v1x/SUkvCLNXkQNZ1fn4hMt6jD3xhqjvi+l4GPk69fS8WhOTXWkKdRuF8la5cWVJVmFNFn5DUDTPNSLOadFjpl86UBHwLL0zuM2x2tVdxifdgt5d0NxnWqVBNOXQX84hij4XRVI9Hlv0Nyj0oSE+m+uaLhuqXKrzutS402D9RS8aujg7kTa2llPuwKxbPWsGFByUUzdQZqdYRgCR0Yo6BT11HnG2pJ1AJhtaTlRuisjNVo2H4hlwdjKOMNtsuirvMe2xLeO6ZmmLc7nJO5tnUdXWf+6sf/3fun3/lvP7m+Pc1uC843/4Wx9r6xxu93C7SG8RKXKyIgQ0N4UlWl0nL7LZhOYpVrjOD9gbwkrvVANVUlwfFgYqxJYqJpErdruwBdh+l6mu/Z1I6zs0d899hydLKmPz4lrFaa9ihYEmOCFJvWdLQyU0ulFqFFlxSZd1umzTXVwHD5kq8+/px+fcQHv/GbPPr+DyRRcR6paUedR/IwMN1sGa9e8tXnn/J7/+4TVsby/luPePz++5w8fEi/6GjzFrfLYGb8otH3I85askZl05rIsg9eG/U07eH3rWnnI2w0E7zCK3WvkpPINwwHL4cYPiFNg1CHUxIZuTVC2m7tINUFNUHWTBsmwatYMSCiAgoNyZFxZViQxx227yX3yDrcYk3Je2Co/N0cJ6zCVPESl5xjlgDRkmXEWgW/Y7yXnztOoDBQZx1lHnDBYvbiAymx8vthsban5VkC4nR535phniYtpEtsCJSa6RZLapzUL7PElFlUegegqcQ0iBnUS1dWstClrZOdkyrNrHPUFEWN2Qo2BDARasJUKQju6Iw67/RrFyVFSxE2tqOlhKGRsxhanZKnJW8oY53FWvl5rLEUMvsJ9p4DiHP6/XulPUielO9XlAqLE5hvrohjpD9eY7sFZZzP7KL+CPjHt6fZbcH5xj9aayemYQRDLzc8iQWWsCyrMMjaBjEolkyJg7CujNObrDjQW04yZ7dBc1WsUIzVpNeM3synQWbtBvr1Ed3pfdzxfcr6LuHtHfblE46PlnTHx6I6qk34YUm+l2T0yPdrTTqrZmWJm3Ni2rxk8+wrxmkg18ovfvLHtGr58Ec/4s0f/Abru/cweRYS8zSQp4l53DJtJQvnD372MZ88u+KHrz3gjXfe5N5b77A8XmNNo2RxoTeTCf4C2671ABIDn8iOjXhokpCgjXfyO1hz2JO1vcy5Cl3YWGWcaQaLtXuGmEQul1wOmS2iLjOUHHHdSruYWfUZ8jygMuY0TvjOibDCOkntNEYo1c5T06QIfEfJs/pyKi4saUVHqYqsaSVjwlJTRtvBzr0vkvtoBtOqgkt1x3TA4zRy9BgCxkM1FlcEGGtdhw1LSh6hyM/qQseyO6K2F6SY2b8V/OpYD+ksargcFSeUXvHsnKPkCdsLJlB8OEmEEtbigvh+8nCjCkKjF64KOHy/Fo5akxTUOg+Y/pg2D/IcOTWgWimueRbKxDREnG2E4PBdJ/+t/pwmaRe+774sWgTtwRBr96ocq9lOVtoxHzoSG+msAKcw17A4MdPm8i/dFpzbgvOteBhYtirQR8GT+AOlFu1URA1kyDlRshB4Jd1SPjC1RAoWfMTisGH/cjeVz0rOSd5uSJtrSm24vmdxeo/F3dfozh5QjSedvIYdrjHphuXdO7QUlcLcvqZEkqV+jjLeO6DtraMh0dCbZ1/w8tlTmrOcf/mceZj53m//iNd/9dc5uncfZxrkmZom8jQQx4F5mpjHDc/On/LTL8652/W8/dp9Hrz9Hkd37+GthTKTWyHnmTTfcNRd0spEte0Q5yAZLXt6876jabjOM24mulWPNe3ACau50lwUH8ohjGtJq5k6jdRSJQ/FeU2alNdH0iqbKNq6BRSv1OpMrY1uuQQKLRnF2UTZkSzXUsScV+OoiD8MK903yWufNYvI7kkTvpPwMyq5FHy3os67g4y8lSzCAaygZXJSZZYlTSNt2OL6BTUvaaFT34yMFQkLTC00q4y4EgWrhNC8Q9dJzLYiaWzw2AbWOGqRcV3c3hBWsky3vqfE4RVrDUNJlTyNhPWJFJAqyrjaCs5Id++6DuvXMjqzTvZDTot1A0qS97NFPVdKrjb2EPewGSp699CCa0UqHiVUL/QLci6kcVZIKgeoqhT1JBe5ONJMEFVhydR5i7Pgu440TeTVgi4spTiG9h8Cf/v2NLstON8G1YDfh5wZTXuUNEijWJSCcwG6QEtZcS6NQsPUpMowuVEbH8F2GCcFrOQoIW3TQLx+SdzeYJxleXLK8sEbLO48wq3WgGGaInF3Q3v5JQvbFEUyHQ5mrByEssCV3Jg8C6qmlUrNlRQnNlfnXD1/zjhHbi53xCnx/R/9iMc/+A1O7j/ABwdJxi9lGojzRJwnpu0NV+df8m8++pQ8V3749mPe/e53uPvmm3R9j6mZnDJp3pHmCcpLjo4TzntKLlhvZVSGUS9GOxy4LYuAwAUZA7amLDZrCaslNSaJfvadHM4qpzXW4g5wTU+rM77TeOoQNN0y08pWFHKhExz+finfKnaxkB1aaxiriq59Zk81uG5JtvXgqpebd4fNRRRc1mLDUrxNNVOjjHxKGnGd7FxynOX1KuXQ7bjQH3Az3WIp6jonlw+xyuglwVjp8mqDaaOBb+bwzxq3kpxpG2mOVBfkObUWnNfRYGZx96F0WUqMDm5NrYgz3/cYY+iOTg4Fq+ZEmqPEbKeIC+Ew6pXY7oxbHAtxwDQRKGTtIv0Ck8SzZWyjzpHWKtPNhfirnKXh5c9WJOx+scTkwjyKyMRYqLFSiyGXgoujRl0H8RZ1KwxG6N2uIyxPKOUK1xfyXJl3O0lUbRNhGd5/+j+9895r/+Wnt2q124LzjR+prcXkKSmVkofjMapK24eLUTOtTpQ8KxfT6OERqblSmTBhFoNdFaBiK4UyjaRhoMSICz3dyRmLOw/pzx4JesSJC79Zx/rxO8TxCoZzMe1Rvwau5GCmk3wZyDUTx5E8TxJtsNuyub5ic7Nh+3LAGscHv/YD3v713+Lo9bfpuh5SFFx/nEnzRBwHpt0N24sn/OSPPuGjL6744P4dPvzgHR69/wEnDx5j6r5wbpm3G7YXT+jCDV1QDwhVArcUV19rI8/ividIp0dzQCHNmeDl0G3WYtW4aHygtkKes2LtRSJrNbOnpIh1npzyIdCr7YuH3tAlyK1oiJoQiss84sKCsFyIcCGOBy+Q6xbQIi4obw3d9QDNB1qSot4termFhyWGScyoJVPThOtWupMwr34Ov1AllSj/JJytF/pBTuQkiBzrvbyW+5FdE5KCDaI8NPvRXpOcHeM60jwp829PcLWyB8qyxzPe7503aqhcvrq0GOXbzVulaPfUmnFGYrcl4UGFMt5Rp534nbQbxHjpeDA032FUNl2VcWdcT4oD687ibBOzbafR01ak1i5XUtpHVhRqk+Jn3PrgKZNLiowvXW/RGFCcC/ggJt6inazvApW+T9v5rwH/8+2Jdltwvtkjtdb6pnPqlusB2S7ZK7JPMNZQppk0DzQ34dB9hVKCG+KctmGm5CIL4G4pB5/GHLhesk/6kzv4o9ND4FjLsi8Kx/cozahCTncZGiVcdTTXikIncyTNIznNxDgxjjum3YbdzQ3Pnrxg2ozcffiAt7//Szz+/i9z8ugx3foYaiUPG8o8kOaRaXPFuLli3Fzy2aef8a//6BkPFgs+eOd1Xv/wO5w8ekDLg+TZ10zcbdief8XNi8/pF0orzlBzUyoAGtfssM6QYznkC4Xeyd6pFkoR8YXBiBPfWUpuONMIfUeehWVmvOxsTGvU1jDqS8pRCqDvOz1HvebXGHBevyYHwyIYGRPB10yeovJqaZK+xnS6I5LLBU3wLFYX+sZU2Ul5v1/1U5GludCXxa/iQ1CUT8F4h6wwkogBfCd/L0WK97gKpk6yA+xXuNBR9j6XNB9+d+sd4qMs1CDEgFqgeS9BclZjoY0VKb7XA9s6FE0t49iSMaEXh/9iLXEExuoI76B4wS6OaGnUYob8/TTJ+9J6eY+2pqSCAdV3kFMlxsLJ0uCcRIZb50U30iw1yWeoFiFV+85hnSgK9zslY4zup7TLrwnjenAWFyzBrkjzNTlH8jzi+44y7jrbd79+e5p9bXBz+xR8cy8DYoqTebqMM74WnWtEkdZqkYW/LoZrqZSSD/HHkgMyEseRNA5kHVXlJDJV168I6xPcYqlu+PIqM6YU3GJJf3xKd3KPqh/gWjTnvlbhoKWZedoyz4OQd3Mi10KthTlGvvr8OTcXWx48fo0PfuOHvPFnfpnjh6/R9Uus8bR5pM4DeRqYby4Zry7YXZ5zdf6Uf/ezL1k0y7uP7vLWd97h7ltv06/XtJrJ047h8kL+9/IZT1885/NnEykVUsq6i1GnfVW6QGvUKgW0FEH0Z83KOUQNoGml+10GkJN0dLbrxL3eGnE30qoYMH0v3Y0xe4VupcSZZiRuuZXyp2jK9mtRyLLnEklvy1Fiwm2gsY8Jl9ejNcSHooTqGkf101SMDYLTb+1gjKw57b8dpcj7ZP/6tpIpKVOb7Hqcl0V8nifSuKEq1BIk8oBWRIKsGrY9qcboVFWELE4D7GSkKuo6r14X3afVjA2LAzGjpgjWUNIk/DhrqWmSYrg31/o9aigJSBNDU3HGYSzpghZk+cGM78AFckrkNJE1Yt0Y8UlxoBfs48gFC9RqoxQN7XNBOIJ2T2rXkSIG1x/tlRlC3PYeq0mjaZzI44DvFhZTXv8H/ynu9ji77XC+2TcB71urGXwHOcqHyTThaIHM9hsUPeRdkVx241RGXeXQsc5KGqST5XMdt7rEnjFY3Lo7LKVNazoP11MTaJdfUfpjYreC/kjVOI2yR+mnKLk0SWbvcZ6Zh4Fx2HH94iWf/tFnWOBX/v1f59EH3+P0wSNWJycE7yEn6vYlZdxRYyQPGzF3vnjK5uaKH//sCzbXE+8+POG9D9/hwbvvs7pzF2uN7KtKIe5GhsuXPH3xFdfDFgzcbAt3TgNxzvhOBAPWGmo24qvRg9TYRqkVHwLjNurqoYBTN3sTenKO4rGxBvI0qWO+w3ZB6ACdk05S91nWiwmwFlGA1TTjfMAv1DypSkPpMKToG6zIlivSCYWA85aiuTn78aVfrDFOdjiH7tdKfILQDALWZA2zs9pFFR3NBj3IOdCx93s4450QleOsY6Z6yKzBOAGPplHR/XL4UzLG9/i+pxlDjPlPxV26fqk5QfUQn9Cc0rs1yhzrCKtTahwUflnEiDmNdMcnUmSsgD1bTgdJuqXHL0+oaToUYIHaCgeulaTR4ZF5LAxDxTyQApPjRH98V/aMWqCc9aSW9f3cpICnWd8HsmMzVPxSQ3ibyP0lulv8bK7rMNMkKkbh9piW8ulf+q1HC/7hs93tqXZbcL7Rr43IQQutREpNmLAQbpWR6Nw8XOMXZ5irST48tmJN0VTGJlQBuaOKOdQGlapKypTrehlBNMmVJ9nDWGJ/I63pBSyPOXr8PVIaGH7yf+GXHaVWcpJMkHkcSfPEPA7Mw8A8TlxfXfPzn33G6ekJ3/+NH/D6939At1rhHNQ8UaZCjTtqEqlujjNx2LI9/4qr82d88vk5n3/5kkenR7z/wbu88eF3OX3tsRgni4wtSkqkOPDy8hn/9NORd3tLmzJPnhdOjzwpg/OGkpsEgMlOnn7Vk3SX02ojtyRqq2IPLvduuSSN0yvWWZCdllXBBlV2LLVm0jjKwdwFfNepV6bKgW8dznXkecJqVLV4lLIsyWPUPJiKW51JVEERonTabehP71HmQQLD4ohfrEjDJDd6IxywlhLWoz+bSIWbX4q3pMnlQWTKRcaC3qmPR8Cl4gUqmrIZ8YsqYzEaOU6vDI0aFJenjYS/adhfayIPzvNEs+FAmhCBYAXvScMG33Wq1hND5p5Jt6dp1z3XzUiBqcr8k1GyVUJ1ARyVhNWxsgkLJW5kbN8Rby5EWCP51RTbE/yENQbn5ffI4wbXH2H9klJnskZl1Cyx6PucIqV2ymjUijH3VXZQh+lX1HnE1QZ1wFkhW9ecyQbTLU5O0so8hmd/cnuk3Racb+yjYHqjHgQJk5pElSYLHmntvVcVkhCYne2piGLN7CemBox9FQ3cSiLPM8Y7vDGHr9VSFNCmsa+6G1UGzV/+mHT5lGyP6O6/y/jsY2qcKSUyjSPzNDCPI9MwMs8zJvRMU+Hh40d894c/4NF3PmR1dldSNONErZV5HrWgCX04jjs2L77i6tmXPHt+yVdPN9w7WfPO+2/zxi/9EmeP3xD2WCvUEknTxLy55uWzz/nxV5fMpuOLXc9DMs8vK+/Ola43pJTxIVDSnhJsKCVDRVVLjZKh6/ZdhBg24zCIubbJ7sIi3pxSE855WjPkVMThb9Al/H7MuWeSmcOBZYOQulsp2H130WQUJxw2Q1PDZFNoqFusibsNLnjKPGp0gnnVYbiANR0EKPMke6rQQ1hAldwb6QAcxgRqlu6lNoPVbqlIVZZxakqEvmO6voDjI5E49yt8txZlognUkkRdZsMrcrN1WAPd+og8T9RmvmaMlfGb9YJlqsZqF67PkxcxixiIiyjAinDmSpyEJdcixAms1bHb3gej7MA4YvxCilyaCEdn5HGro+ZCjoXgYbkUk6fvl5Iam3cY29OyCkKmhO8tRhV17TCi044mjkrr6KhJs5TGDXnc0ZC4cRciLc7k0lgdH1FrPs7ZvQbcFpzbgvMNHqkZ69th4RoVV5/0w20FMFkSBk+tE2UaBYmidOMGB3z9q7Rb2SG4rhM0R1Ap676IGc0b0L6o7Ze1pZBf/ByOX2P5wa9x8exL2rAj3VyS00ihEufEZiyYbs3q6Ig7DwpvfPAB9998i8X6CGul06ilUGIkx0gctodgsGlzzfX5V/zi8+d8/uWGVd/zzvtv8+4v/xnuvfEm/XIh8NFSycOO6eolL558yo8/e8pnm0wXPDfzigd+4NmLwsvrwt1jVdIWGXHIyEtg2cZaxLTfdIQCxlZq0WV456iUQ/G1xlGQub7tvOJwDGnc4YMyyjpP0c7FqPGw5qSZOxJtvF9qt5LkoG268K4Sd2y93MwlBE4NpAjGiJrJ04zrdcyaJ3IcZV9hg4SzlUKJI2F1SpkyoLs8jQIQD1LVcasHitCQLbSahJbQCiWrdLvJ82PdQsZ4St8ucZQuR70zALZVfLcQpVZRReTXhBGyh4kYL7gdrEjRa8myp9HuMiyOxQKgNATf9eCaigWsvq+t7ujU3Kvv96aXJusXWJ9pDMwzBN9e7ZlKAtNUDCF+qj2RQaETejnR1zFH3PpUxqBJ0kkPDEOZf9PSjEEjNFKixJE4OJxxS9vq2e2JdltwvtGP1urCGDFNCg8qHz4NrWZMt5b8Emfp+sIwbmn1RJzWKlWuh9phD3XEOIfrgyiBvEiCa03UFuRCLqNn+XDrBty0hk+J4bN/w9XFv6W/+x4nf/Z3mC6e8Ivf/6dcX18zV09edKTdjqOHp7z54AEP332PxUIYXy1HTInSYU0TKc7EOZKnkXnYMlxf8Mknn/PxL65YhsAbjx/wxnvvcvbwESGIubHGSIkz49Ul188+408+/5w/vpiYC3jv8P2CqQZsmbm4qtw98rKnybLLyrkJer9UQrBSQDBiAGxChJaC04iTjJ5akwOp1CZQggYNJzihavAa+mWsERHFOLNcLA8L9TwLxbkkcPvi5SQioZamYxpNbu1XonyyRajDtFe7CeupKUphKHIYN2NoLSqBolGiKsBaOygH2964mKJ8j67XPUeUaGy0uyoiMPCLBfM2ESdB8li73wXtMS9e9xoiVT5k8FiHIcmdxkjYXYkT1neioMsSH21A8TVC6ZaInADIaNX1y6/tY4wIYTSS+4BNKhmrzDjjgxTkPR4IpVanqGQAyzQWgpPxKjVR4szi7D41z2L8VFGA8544zbScab3VXZzR7KON4Hf6lUJdK6b1uvOU6IoybcWr40RSnWMik3yOsb890W4Lzjf6UVu1dj9H1lm3cZrUuffnACVPHB0b5uGSmu5hjEQKyxfZJ6QpFbohJgjrDre6kjKGierFLGgPkiOrmSGZPOyIV1fE7ZYXH59Tw2cMz76iuCXheMnuZmJz8ZTT01MYRx68/33u9ZnlcoVp9dUSNwqvLadJfDO7LWkaubl4wSd/8gVPvrrhdBF47fWHvPHhu9x59JCu73DO4pwjDQPj9SVXTz7lyRef8m+fjcxln48CXd8xTEvu9pEn54X3Xg+4KlHEtUJKSh3IhSzPMbVCF0QuHaNihKIIBLyX6GSceDOaMr/KPFOrSKXlJr/PcYm4zpPHHb7v1V8iwEy/XIlD3npKFNK0vCBy4OO0oJQs3K5uhe2WlDTL19BAMhGPeJGGNQGy1jQf1HFYI96amnU5LwWiVfUG1XwQhdQsoXBQleZsScMWQHxHXnZDOSVsZyHPMtbynRSNVqRAUqEmMYmWpMo69WnV8jVvUVMDpjt0jtBIuw3h6IyWIrXNamoNEg/tgmKBIs4s9HsKk87ZBaZmGaUVERTYbqnS70qdJ6btjt1mYtk5/Sh4/OpIKN/W063PGK9f4rsFbGflDjZ8v5Qoha7Hrk4g664tZ2y/wJRJhBpV6egYFkdnzMOONk4045jnGR9673x3W3BuC843+2Ga9cbIAnIve21fC04DSUbM48ji6JT+eiDGrbq3pcAI2VOJ0Fha0+UnVdzpVcjHuTWsm8WPYgu266EVyhyJ047x+pJxu2G72TDOhfF6x5ef/S7TMDPNiZQE+Hn24a/g7z7k7LU3cTefya0ziVIox0lir6eZeRwYdzvmYcfL8+f80U8/5+Zq4t7JEa+//ZCHbzzm7qOHrI/XLI9XgkSZB+bNFTdPP+f86Wf88y8GhoL+Pmi354hmSTI7djeZlKtOXgytgPNWdyBG11UWStUzpuKcxB+nObNYOuGE0TDJ4IIU41YTVZM8ay0YCtaoidAUrF9BU9SQU3xNA2YZB/oeUT/VRlgsDt2Vs0H8M2mSA9PM5HnC+F7HckkUUiqVr0U4ZW65omZR1NWUhI8WJ9ziGOP6AwATi+BzSqLMouzq1sfgJDLaKAPMzRFvDfPVQPYGUxN27KAFvAOnQWjWL6h5khFb041hvwY7QJbnrVkJP2s4TcgOr+CovhexQKv49Ql5HgB5fZzM98R7JsYlrHXkuJNIBJqEz9UksdbzAL4TanVDYJ566aqlMMXK8drTr3tc1+P7Fa5fkLZX5DjKHm8eqUWym5yTyYELvYyvi2CcKo1WZsqYNDTviJrEG9VsIG6uRDBiBVlUSsHgahrjbdT0bcH5hu9wvOtoDmOLEorLq5As1w7ph6I6K5w9CDz74pK2OBW0SLNQ91kuMp+X/Y7FOaOCALnlt1TJdhAjXVho5k4jbq8ZN9eMNzeMux3TMDHPiTllMX13PWfHJxIPEDpO792BeaBbH5Oebgj2iBJn9QENxHFk2GzY3VxxfXHB86cv+PLJS0qCN998wMPHD3nw+CHrk2PWJ8f0iw5TM3WuzJcX7J4/4+X5V/zk+cAmvyJkG/WGWGNJbsFN6ehNZjcWzo4cOSo40hsWK0+aZaEuozaDC5Y0F0m1LAUfDA157q211NwoqdIMdGvhqXkvsuf9c+iMkViAXCSvxQXd4WRckH2OdbLs9t2aeXcji/XcyDFhlkj8tJGRJ0gyqw2aXWOc3Pi1Qy0x4hcr8UzFAduvMR7Fsyh1uWSMfu8SZ6qZcf3iMLaqWaIP9krFmmZC35FiBCrzbsKvFtA2OH+CNQ7rpYjWONJaFhWb7l8MDWs9eAu2SqLr3t9UG7WJyq/WTJtnHRU6Re00fB/UqOrJ44DtFvoaV4z1dCcPJMmWtscVqLdJfDUSJJdpxlHmUSYAtdIHKVo1zrTWa2eSD2IAgDhN1NJw3mGRMD7byW5OvoeSE6xXZd+CEifSLImmpURsv6YyUsYNpRqmXYRSkmMx3p5otwXnG/0ojc5S1K+Qlc5clASgyjJ1aufphrA64ehkYDfe4HxQxpkcyrXohxIx3tVshEjcJPFSKMaFGgp+AaRCnkamqwtSjuQUiTEyTRPTPFMbrI6OWZ+ccHx2h+VqKTfV4zWTrcTrC3bX11AyJc5aaG6Yhg3Xlxe8eHnNi/Mbrl5sOF4f8ej9B9x7/JDTe3dZrhd4Z/GdjILSNpJjYrq+5uL8GT9+cs1nGy0ghyRUc1CFWR94NvS804taSn61hth+GtMuUWuhRaED9L2My/Zm2pKl43O+YZ3e0GuVwDMsaZwxtmGq0aWyJk/mrPTgIN1GzoLo93pbN1YNnLOWR+2sivz9ZjQyvDasCYf4Ac2u1sjpoORoGcUJDbtTgKru91LUYlWgZZEq14rr19AyZRa/jrUaiBwWGG8o44z1gTTuyDERgmfYRsZxYH3aE5ZLwvJI94GSPGr37n7ndAGmBGbdr1AKhO5VZ27FGGqqozUZ99Wc8aGTfJuWNaJBwbCtCGdOf7+Wo3wGugV7iroUYdlBCVDW4vqePA+UNGOto+sczhRcCFgtfs3sDc6z8PKsxfcd027Geov3ysPzXvHRKtF2nUwLXAcm41xjHieadaTdhpwLOVUqloZjGGt0ddrenmi3BeebPVIzrchcuuqoXxQ9lFcASDH6ie/DTBOnD+4wfPyUVtYYu371tayYBpsuVK2plJYP8+paK1Vd51WRKWm3U7Cjp9RRMuGTOPKXqyWn9x9wfHbGcrXGe+GK4Qvt+IThy48YM5RnT2nAsLlhe3PJuBv49Mtzkl2Qi+XNN1/nweOH3H30kNXpMaELBC9k3jxuiFlilUvMTNtrPn/xks82mdK+rsB7JYowgHeenVuxWg/C7lJ12p6SkEs7MM0akLPENcxTZrmyOI8ATlPBIODPhqHGIjub1nBoxkxrcniVQpoi/UqzbUrB+qYEghPScC07DKs5RbWo691gQqeiA4mOMHEUREw2WCv7uFZn6VLyTIkzLtjD0h5Utm2diABMw3ZrUU0pa6zmjDVewTfQcpKQvuWJSMNrUrRPISzXpLihqIBi3GV87+nmKDBU57E1HTo446R4SRrnJCF2ba+EKzi/oPogozf2UnuDDZ3GkFtst5BU10FVesbiFsfUNFDSqKFmEjVtrcWUCE5k5kIeqNK9q5GzTIMW+Eqpjpgad08cVoPXnKSwUYatquMKzYjIIs2JzgdJFLVORAJVBQ/Wasx4oTXJVorTVriDygJsVfh7eUqU0lou5ucrt/2D2xPttuB8ox+tFmutyFapEiJmwpHELuuN2Zggee27K0qe6Hzj3hvw8vk53VEQXpdRwKJslMVLkve3UFFsGWt1vCEIlFoSpu+x/ZIybMipiKIsFbqu4/TOXc7u3mF5fEzXBawVM11zBnN0jxc/+Vc0Y7kcJubLC6Zx4vz8JZ98/pzXvvNd7h8fYXZXvPHO25w+uMdi0cmEpDWqqoimzYZaCt1iwTxu+eL5U/7wYmSu/Kk9Fl/3thuDdUJBLqHHufkgCG9FCovIeEVWGw7aioIxjThXQmcIncM4Q85KbvZq/jMyhiylYbxk1xjEG7NYL5Q67fSmLjfpeXeFwZLnGeudpooK6Xm/0K+5QBuwVpAsLnQS7WygtayhZaLYKnPC+SXGiTqulkl/iaSHaS/jq5QErmn3woQm4z3nRWm295podEJJkVYa8zzpz6PmXwwvnkUwN4R+IXw916hkXCey6aK5S2gxA4sJHh/EIGwqr+gCRWTYfnVKjSN2n9SZI7brZeTWJJ/J9f0htrk1GX/inIzdnIomVKGHkf8v73ZY34vk3znZp6UMzQnQ1Elhdos14fgucdiAinEaVkyxe6IUlTrdyD7MOqp6gTAihCkp4lyg1kZRukOKiXHKpAzzXGaK+Sc/+Htc3p5o2uTePgXf0A7HuQ7nxZFtkBFFa5igDm23Jwmbg29gvPiS5UnH8eqcmm7UX6N7HGv1AJFDupSiCjXx+kioVSNNO+ZxwzzuGG9ecnP5kssXL7h6+ZIUE32/Zrla0y8W9H1Pt+jpV0t88JicaM8+pnY9m/OvSKUwAnW55jpWfunf+xUe3Ttlfv4Fj15/yP3XH3F8sqbvAsEanDW0GIm7kZIrzRiePf2Sf/mzP+H//PiCq7n8f4sMezyZOfw5OMeQxZAZ5yI5ca1RqiQ/Oi/FY56KCgH28EzpeHY3kTQLc81YR85GIhA0PdI5q1JdGbfkmMnzTJ6VbKwFRZRtlWZFbltbOzDb8pwO+7c9XqUqILPEWZfsnRzUqN/EeGwXdEdkJP/IBrmxYxTWWUnjDnyvfhHEqFiFsVdyUlmxlwJoUNGA+LKstfjFUg55LDlVLi5mnnwxM262kvmSlQ4xjyK9RsLljBd/UWuVMu4wRkyWlAmoIgf3ojpL25cCGC064tx32yXjQnfYgxndmYDB+oWmeSYZr5l94FrVpqqp6g7S7praRA5/fOJxvjHvJqp+j5qTZNmEhdAmctZIj6rREwIXtf0xxnWSeWQVyuo9hkpYnlBrI04D8/aGacpMUyHGRhpTyrH+r3/+741/5/Y0u+1wvg13gfU+WhoboMn8WiTSio+vAjiUOX6glYGaR/ojSDfXlLiEsH5FLDbqarMW9EBvFt1FSP7HNGzZXl0xjhNxmphiZp7EF3F25w6nZ6cslyu6rhPJcugkjjllah5IN1ew3cJ6TctZ2Gfdgu84mK63bL865/6DO9y5e4dl3+lYSnJnSorEYSDnxDhPPLu85MdfvODJJh3wJlpD5Xkwf7r4aDKP/r6WcVdZhkar0pW4sI+aViGGNeTSDq58jXsRZVkp9J2n1CLZOgkdsVU5jFplSuKHsXv1W0UOrlzI0yCHpCL9Jc+okXPEdaKGsy7IHsUpal/d63vTYduP55zHBsHv+67XX1lo34LeyRgVghQ1CVvvlSdWpYMpCRcW0gk5JyRr5zAU3Q81lRdXasuClWlZOojaePY8sjre8fZyhe8XUAsheH3CpEt0xoHvRdas6aetZFx/hCnik2k50rwEvRljsdaQxxv52YzCY7MIEVpOh3GpdRKjbcPi8NzhAi0nbL/SsWQ7ULJxPWW4Eqm0lVFiv/JCge6UxNCtmLbXErUdenIaMVbUjC70qtZECQ1Cl25ZjboYyrQTxFIplCog2JQqOdVSa/lHNcT/+vYcuy0435J64/w+7XN/CLVWZCShs3kJghqURpzlJr25AixHZ0u2Vy8oRcCL+2jhUqoSVzR0rEoEgsHSKOJZkVASwlGPB05DR9/3rNYrFosVXbfAaTCYwdFSocSJeXvF9uqCmxcX7OZEbJbNzYithUXwOOt49NoD7ty/x2LZKzMsHVhq8zQwbW54frnho+fXfHE1sFVK8//Pkkt5COaQQa/DM2ot3FkVvDOUqgt29rHRhtqaGPRMI6cqtGMFb2It3sk5V0pVooA8/85ZUpRiJd2FRBBYB865V76avZTXedIoqHrrHPv6KKDHnpwEZSPdRiANA12/pOSJkiYxmOakBl0xlmpgjxIiFL+iXayxBu86GafVIrs5JQO0UrELC9ZjTHtVtK2jZekwWp5F6twcvu/oV7DdzWAq213ho4+2HJ0seRgcvpMYA2vlXWCCLPJluSXqr1aqBsz5g6nYLVYal97pf9cI6zOJSegWEjlREq0VGdnVoq+VUcPr3uMTaPNOiq4WhmbA+UAet2INsAJDbUUyiVopMlqu0kmmOaogQ2gJQlQAH0ShZnT8hgvUOCntI6vaDY0aFy8Uxklaqbf41v5ZK/ztP/8/cHV7kN0WnG/Fo9ZqrbGvwp9cOIwc5E0u6iCZbe8Bkz3jy+esH75OWBqO2HLzEox9U7hgpal4QD4YEkewP8gkVdF3Peszx1HoVF4th7FVn0u/XBJcwDl76DhKikzbGzaXF+w2W+Y5sr285up6BON57dED7ty9Q9d39MuOEDw1zYxJFFSlCADz5uaSn3z6lF9cRra5iDjAmgNi/08P0fblpWlcipxoJRfu+4HX+63g9gtkvaWHYEjVqOu8ia/E2oOazRggCc9L5nAirGqpQFPjqC77rd+78FU4sMcCea8KNwlpkxGWdBnW90pedljfk3bX+BBotRK3V1gnzviak5p0wYVOLwUS511yxZkir80+Olr3HfsYaWOdZAzFjN2LE6zBhUCJr5I/jQ8qcAj4fsG8G2mICXZff32wlNKIqXKzK3z5xZaze0tRkLVGt+hlB2Y1n8eKJNkYI9HVccL5hZIMpANx/UrGXUG6oTJc0YrGFhijOUJe1JNVsEM1zbjFmlfRAwKwpWZankVAseee1UYctoAXgkStZKm7OkY01Dzju47aDKELxFnC+sDQr5cSHZ6iUK5VmGKsk+87T4oJElOwaY5cRnKBecof1Zr/+//9NP7h7Sl2W3C+PTscYwo1SyaH3uKrpg4KOUCItDYEbOgodcT1S3Iq4nvZbOiP1pyebrm6NGDvYmyHUWR9TfEwWtnnlTQdt4XFQpzv+w4oZ3LO4D01iM/CBTHlVQPzbsP10yfsbjaM48huOzBOiaOjY15//TH3Ht6n6+VGW3Oi5ETUGXxKM2n7gt3Nl3zy1Tnn14mT4FgBpRnq/jbfLKVZCvLP1gy5WpzVzqJUli7yxtHAe6cjjkLJjVz36jWRTS+CIaZ2UK5Vj9CQm+Jt9J+mgXFGsTT1VWGz0hXUIv8eFp0cePuiVxIpV6yvByNiqwXjVVlWM7VlilXMv3YFrRQIlnlzKYV/scB2a8q4/dr4EMJqpTk4iuqvUYpDydR5kjyaeUCidzQwzDZc6NkbJm0IQptwosTKu2tqioSlmDlb85SiOUC54rwlBMPFdeVf/Zsb7t71vP6mLNJNytgq497u+J4IAfZx07VhNRbaWIc1DoPT3VWiFSMScGdEyT1vlZKgI8bWqGUG5Z21HMXztFhrt6ME51JkzNUq6focvzymVkMaJymCQNdZ2ScZg3E9zjoZHrSZeZiYhgnnLV5RQ60kbN/JTqgJzaBGEaHYfkmaBjXpRuY5M213LWV7aWh/58/93fkf355gtwXnW9bipNpoGBOEh7VnYlXNQnEeazvMspc8mVKINy/xyzW2W5PSlaDTx4H7b265eT4SeQQsacZBFeFAzUWv8eVVz9CKUpwFbdP2AMrS0bpA63tqq5R9tPOL50zDyDiObG82xBg5OT7mwaPXePDaI/pFT0mRFCOlJEotlJSI0464/RybnuDmLR+eZT48E/pBVelxM+CsIcZG1i7EOkNKr5oda4WTFmOl7wwtNjIN5w3WCAOtVGGZVawcgsIQoKRKmguhd1grjMxSwBnx4eTEgbeWs2Bhuq6qARJoMuKstUr2UK34vhMPRzVaoMQkKl2ojNdc2AsCJHwMJBrCWNkzGC+mV+ecoGUceoMPVBzBd6ImrNJlVVC1VVXSjJAknFMfj7VQEi54XL+QbgLZVwkORqKpwYo0Wc2ONTecNYRg6bvKMFfOX0w8fv1YJOu54pZrLIUSt4cQORd6sCpvzglrvQSm6fOlv5DsR/zy1WhKsTsljrr/WUsxrQVSFBf/PMrXd07k0VVp6CliF8dymQoL2uYGZwuLtXTivu+xLpDnARt6Sq0aaKehexWM7m9ct5Cpgmb+HKISrJWAuiKj55wr026mNptNbX8/muF/uT28bgvOt++h6Z57A1zNGes68SXo/sWEnjrvKCnqCCLSHZ8IygTLcHFOiZGz41OO70Wm4QnTeEwx92lWQsJKlVt9zUnknTmRcqYUOahbLZgGIXjCspfs+ZwZLi+YtxuGzYaYMrvdjuura6Y5s16vuXPnPqf3zgjBUdJMmiZSSuRciGlm2l4w3XzBOrykxoGSCti9xage5MzWwhA1a34fHBYb3pmD+szYRo1yl41RhBbeC4I/53bYtzS9sXtnDuKDXBrOiim072XMaE2jpIbvmt62LTLelHNSooglddJYCXUTiXI9jBgPi/ta5M96WMlYSdMwjRStPeFbOh0ZLbWSdPzWEVwAyoFt54MumRDnf7OVnPIrekRt0vnq/koylaTgmbDc32gEX5QECit8Mtlx5WnCBY+ZZ0JnCb4cUj1zhovLSomDBgJ6GGdCkK7X+V5MySVroF+iRtnPGIzkGVlHrTJeM8ZBjlLUdYy1T+50i2NalufJBYke8N1KN3JVJdge47uDak0KpSPtLmVkbKAUQ7cQUG2rMhXYB8P5vifXiA+BmiLWOXy/EiiodRrulg4x3y0lwFHmgRgjKSZyNeTSftfl/D/+hb/L5vbwui04376Hqo7ErCfYc0G7L4QcXKUDQccPxjrKFOn7+8Sbl1jn2Z1fsDw7Yd5eMW8G1vce0S9vGHcz83yGMafY0JFzJddKSpkUZ/kQJVk6t9rwwROCF55VyZTdlpuLczbX18xRCtScIq1a1kdr1kfHdL04tcftRkyFVRbwcR4ZNueU8av/l703ibV13c6znvEVfzHnKvY+xb3XNzaJCCaFIwONCJAQoo3oIaUNPSSqBg1awBXCQiI2RIqEZOhEoujElEEIgoRCCEIgIWGQIgfHxva9555in733WrP6//8raYwx5z42VgqEwL53zaOts3axqrnW+sY3xnjf58WVN5S66R5KtDiIyIfC0rWrKUUzfUSEbOOwKtoB1drprtt5beMwA1nW0o1ODF06peiluNZOHLTYuusmJOjz3bpxMY0qLZaEer31h+As8lufm5L0sFSbU6CkDe9tNGOLoWZSaP1YGkin5qRjot50tNkVq1JNIix2eDrnbandbso155wWLAA/Gu273yjMvTUkeFrNlFQIg2cYo4a0DfMtCkBxNCgd2ToanMMPAyVn/BDAZTpalLx1gD/8aqP2V7BdFCQ6jrqn2RIhBgWZlgthfqDm1eTSRUGkfk9NugO5yfWvxAT72mn4WkW8p22aens1l3YTJbRiuyqvsR1XBVvdVrroOK6uixqdb7w99eLk5ax7qmFHOR2ptVCydlEhRBsBBv3aVS1+akkSal6oW1I455I4nwut1F+uKf3zf/IX0m++HFwvBef35aOWpjEfgu1xrivypObBUullMRWQigfUAa0L+OH+FRIDft5z/OoNPkRqPpPPZ+bHT5H6TGkfs6531OwpSyanYsZPPUxrLmomdE5vgK2yPZ05vX/P09N7lmWz1EnHMO01RjlozMG2qvdi3O9xIdDWlXU5cnz7OXn9kl044JwWGx+EkvWHuliRWLeO91hOvKh5snZqw2b7YsZI3e/n3FVrZzfxVm8aNrw1BLeOAjPDd90TiXSkfXjb3atJtJZKGAz02Q17303x5VU+S9PxX4jquHduIAyiIFTT/rWkaatdqiJyrvHEKAbHBWWnlS3jB+2yailqPKxieTERrEPoXdNc5aaua2Bqv95UUt3yBj4SRsE7M032pjJnESMTZNywo6UN/IB3jd4HyrrpiK9pLg5OCN7RLCLjV75f+fXfOPNH//BIXY/mB2vM9w+0XpCmApbeio4GwcyrwWTkKkbREWBFnO6X1IOj/ikftKORMKqvZ1tvuyfVqoQbTUBCULJ2WnHjTDodkRiNQpCZZv3+1dHwSph31HUhH59U9lyVGq7UbzMx54VaBT/eaYgcakbN60prnrQWUmq02n/Qav5n/4FfSH/15dR6KTi/bx/OSRPLfXdeF9N07HYacMGRLwdazTfkSJhm8uWsKZc1EaaogMXlwvDJJzz98Ctb7j4yvZ7p6T2ezymXmcCelMHhCCpawMXAME/Md3t88CynI09v3nI6nTS4KkacD/igv1ptuqiNnofXHzHd30HvbOcj58M7jk9veH7/JUN/x/7RJMs2Akr5qqaCZe2K5jIsjfemIBOIUdiSjbrk2tmg+x3X2TIMgxoeS+260+lwWTrDgHUVHSXY6OI/DO6De12EVjsx6ILICZRcqbURglcpdvB4K0gu6sdQr+MwKq3qvwsWzeyj2HjH06vyy5zFGIO3sZrxzUoBVwlDJAwT6XzEhQEfo8Y7mAnYj3tqutCaSspbk1sR1ZGkqgp7K/gghPkeH711yGoUlTBSL++BoBEIW0K6kigUpaOx08F5aisEr5/TZYG/+usbf/zvnmx3slFCZD0fiYPHTzMSRqRl9ViVghsmfNQsmb6eIEScePJ6JuweLDFVA/oElS77cadjyqpy8HxeGB8/Vv6cIYHU6CkfILc14UKgrBe6qNotDo1qKCOcp6eV8eOfpL77kr69w/mIDx1qYZg8fhhx84Pu5tICrZEu72lFvyfX84HT05m01TOt//w0rv/Ty4n1UnB+Xz/EhXbdiivp2WKFJWjyZSmE+Z58OeK6JoA6r36YOI7kbVPZss2IxOkBOT3csR6feff9X+P1dz9mvt/zyS4hwfHuhytbGtlWj4g61f3oCL6R08Z6eCYtJ0Q6cVCVk3Me522nJDA/7Jj3e+KoQoG0Xjg9v+fd11+yXp4oy3s++ViLS2s6Mrty3rwXzovuWK7+mFo6rQtp071OaTANWphKuaqXdbGtb0fIBYIHJx1xQu0QoyN40QgCLG7aXfcSjRiNdAC3zqGWTilOHfLXbhNlmJVeGadAScWKbUV6RYKOfVzQkUwtRbuaWpXDFtS3U1MmjNE+jnBL+/SWFqp7kEzc3VPXM72pT0r8DHWjbhv0TsmbdaTqN1GvcKVspu7yHRcmpFd61VRTXDfw5WIerkxPhbpd9G3VRhgnQu44n/FRd2YxCrux8WoPzwdVnvmgBbksF40buLtXUUQpiHQdhQV16PecFIPj1cPVW9WcoLpp3IGRMyRMtNT1c03vuVp647z/kLOTFrMKNDV75lWl2nHES0U2+73z6l8ztBM4/HxHevcD+qYqtm1VbJMPTrE4YdAOJ6kHyA174v5T1sM71ud35NyQEFPE/adhPf/SH/ke6eXEeik4v89FA7YBRp34zkWI003x1Eo2MGO2ULAFP06shyeG3R05Zfw4okZ6vbWq4a9zeT4Sdzv8NPD+izf4ccf+ccfD647zjcaO7mA7XiiWZ1LOJxyZ3Vw1syR4Xcha/IH3nmGcCMOAi55aNpbzmfdv3/D89BXBn5jHhYcHCOLYUqdW3atE25+Uogv/ZYXWdOkPnbR1glNuqQCldVoxDliH0uSK0qKbSMBZQFkzsIKTK3hZR3beK+vMRzV6qpdGdzl0/dh6FzOYaualD4YH6g1v8ckiQohBIRDarhkQs9JyI04T6XJm2O/pqdgIR0nOdPOEmDlTScT9JhjpOJVcG5etI0hNuHFH3TZKWnQ/JHaoNsjrpoh9J0oxGAaVXgs24oqm7CpqhmwFnO7bNFgt41yj5k3FBIbll9scUr89ny7Cunb29xO4Qk6Flhp52XBe6N7jo/nDnHZ2OkWzrqgrKUO8xw2TmXL5IDhwGoGgHaKZStHvEz8MZght9Jpsv6IA2Xw5q4BCNHVTRGXdYHs0i25ABDfMhK4FtZ8Vxolx33yYcHGvMv7tTClFR8w+UtaVsqb/WRp/+o/83PLZy2H1UnB+BFoc+9HuqDmz5hunq6Mwybocb8iUar6aVorOtGtHgmc9HNQx3UGC2K4gMT5+RE6Jy2nlbpiotfL8w694/d1vM96N1HJkeK2vU9aV/a7C+AgysL5/i58G0rKS1sZ2EbyP5vdI5NTI6zOuLXz00cann8D93R3PX67UTTg+NyPsOJw0SlUBQC66R1FopvljvnHOXcdepaD5M2rf4Bog2RrU1omYMCBYp+O00LQGIehsTqnRRh/w3zhLe6fVThgE7wK1qAPdO7l1XCF6yxFTL4iq0qz4jBN5vTCMg3ZfNesoi06IkTgp3bj2Sm/qpq854WIwr40u+53RI6Dj5zstVHkDA3PqdCjSW7LDt1tQmcUlDyO0qsTp3mwUq/vATruRJtSTlRX4WZQY7cJItqgEBVLqaM07fT4ReHuovHuGh9cjdKHmQkUDA9NaYFAVWJx2lg6qMvPbRm7c04JibHrVtFAlUOslwg+zFe/xQzRDWrSDvNILvO2qUAoBopyzcjrSvY6exYMPBe+6ihd6U4l2zsrW21YdSdbKMHqamZB9HKCvSoQ+HyHOtNZYLxuX43oJtH/pT/xrp19+OaheCs6PxKP1SkDlsk1dFjf5rAZIdeq2Eu8+Ip8Ptuwc6E1vbq6CD4H1eObx2x9Rc76NJpbzxvSQKauOfsb7e9LlpLsR5/j6N39AGEfuP/2Y97/1a/gQefzOp1yeP2N6eGT+zgje0YsekiXr2M7HgJ9mtqevwd/R257DV5/TUuP47owTWDbrbMxTYzH0pKwFo1lXkovuYIYgNxFAqWhn02EerWURrRQpq+dEnJhpsVtx0aLdGkyTkFNnGIXexQqV7otUlaaRBCJCDPo+Q1SQY6tQUiNE/XhqqmrsRMndThzdwsJatV2ExXiPu3tVr0VRkjQOQXc2ZTP8ftDgO+8ClU1v5AIu7CzjBmrJ+DDQ8kqvemO/JYsSKGc1fAan3DkJTg2koso48VHVb6jhtOaksdd+Aoyd5sUW6EJOmkujS3rtDOMgvN7DX3/T+PLNyh/8O2blj3klEtRtoW4d+g4JO3xrSCu3bJ/ryLKuRx0Pd2W4iXWPLS3m5XEmgd+UiIBl5SDGT5sNpaMy8oZlC6Hy7GSdHtuinrLBWSfkKNsK3qt509h54oU4Bob7e9ww3TrRK0k9XS6krbIshdj5+Z+Jp7/8ckq9FJwfmYcX33WEcA1haxp21ZqlGTpNgyzZaMOaZT/sd9ScyeuCBCGOET/tSOt7XbAaqWB6eOD8/ok4BnpJnN4/Md/tyOvG5fnI40/sWA5PvP/yPZ/+oe9y+PoNb37zK37yjwnnNXN4c+TVd16RLom6Lbz67rc5vf0SCYKXxrvP3zG/fuTdF+8ZpkBaV9KlkjbdvawJBotJUYqzKsly7qxFiKo+JhXtVIoJAwBihBhgLf1WRK9rlmpjuBDkVrh2k3Fauu5t6Iq1qbUzRD3YhigGj9TlckqKvndGHHYCYdBRXe/ouKiVDxHXdFpu5F4JMRCGgVq0yJd8sUmZ3s7DOFBa0cPXB/ygUQPSGgUzO7aiaaclqXenFouk0MV3nB/J52f9Mxepy8m4aNmwM40wTFYwLAMmjHbgO3pXMGa3zgUpyDDiJNLbCRci3mTYw+CIQdRI2zo7hUbwK79+4Wd/5p7d3WTdUmJd9HuzpIFeD9RpYtrtKOcDYbojzDN1PeKiBq7VbUVYiQ+fUM/vlU0nA2VbVJEngtAU2hmjwknDqEF23rqcbcWFmZoWk4s34jwpwDZvxBCZ9nf6cS0XwjjTtpUw7qn1gkhiGCNhHMjLBS/AfAe9kE7PpGUhF1iWQsv5f/3Znzv8Ky8n1P9DMdTLU/B7dIVD97d5knU34pSnpsSBQtg9kM7PxuhyrId3ms9WFXnf0kZrmjyYlw3nKsvxRJxGSslsl8UYoYXT08L8+p7tshLGiATHV7/1OUvSW/vh7RMN9a4c3rylEajd8+azd8S7e45PJ7787C2npyNf/uAda/Gcj5W0Vo5fH7kcK8dDZVl1hKZEA/1ct00Lw7LCkk3W3LXIXDZIxsEKnlsRuaROLp1SVVww2C4mGqomeOW/qYNcfT4arQ0+WIdjKZ/NmJOGLTDSsT31WvaVSyDaYen2vdGbdnViuySRjrfXr6Xi7dB2ftCPw4gNdds0SEycdUEGBI0OcQ3p5Rb+JV6NjS5O+rwUjQrP6+UWiVyL+kb0c1PVm48jYYz4YcRPO/1hd05HUOIRP0Er+GFWFE5vN8ArQN4WNYXajsk7Z8ZQvbNMEd4eOqczWgwd+CHcnuO8Xmh4WhfW5UwXT6vpQyS0BAV2hkDY3dPySpjuuWJ8fFSFZZh2xobT13PXPZm78tbUP9OagmBdDDZazkoqCAEfnJKd0+VmOL0Sr+UatCbKrYvTHb1VtuMbSlpp4qits6XEdjo/x+5//uV0eik4P3ornCtgyrD8V/9IMyd1q52ass7dc8KFkbIl4jzrrdZ7HSM93FOWIzk1XIicnlfCNFKLeizCOFC2lWk/Eacdacv4aUfJG19/eeHucaTWwvH9wnw/ky4XcmqEQVgO70mbuim//vwdpWly5pdfrIjA1z/8mrptpEvh+b1CMVPqbKmTc2e5NE6XTm5aXKwOcV47qcCyKWYmV30ZKzrBowVDYAxKh7sunYOXG+1ZVWjd8oREo6a9/pkPRjoW8+FY5yO9m/gA4uC0OBkVuTfb84hJ1px6OJzXpbQPV2TL7YtoF4TAMO8Z5jvERVwIuKghYT5EnI+4ELlmmP62hbjFS+snFKi5UlIxs2a5BeiVvKknRbRj86OBMFGlmNyYY5qjlC/PhpBZVSbtRgtC03wa7HXiGHFeQ9GGqEq1UQV4XC6NL7+4qF8lTIRhUuOndHrXlNa0XGjd0d0IbtTY52GvRSoYX88SR1vd1KsTJnwIGsXQ1dODuFuoXL8q06qFvTlnEQJi3Lrxlg56jfx2QZ9jfT+FZjTPjioZ4zjcQLI6cvTU2tnOZ9KW2S5r8k7+s2Gf/+LL6fRScH4UtzjaqZjTGfEfLPRypfJeDP3uNBRK9IZb82bL2k6YAul8oDVHa7CcMsNuR9kStUX8MJCXlelhpz/UteIHz/npyLbB/mFS7AzCfD/TSmLddJZ/en9m/3rPcjiyLoVxHnj3dmPaeU5PJ9J5peVKMl9NrcpFE9Sxfl50n3P14eTMjQxdaqfaCKwbESBl9d/QP6jNLKXYZvG2H7B/EwNEj5GP+zcC6PT3zgsuCMNoPhxpONc/KNhsd+GcFhyNdtADSlVlzm707WZo7K0rJFXMgzMMtixXaboWNqUB1JSvCGOV+DrthlwcLfYg3ggDNacPIzWLKuhoWFu6nIyWrOO9MFyTYtU82vuHwx3RjixOe5Oya24NHcXo7F8BQogDOE9OVT0shgvyXpgHHYU+Hys//OLC5dwgRMQHpt2ecR6N4aak7HReWM8X8rpQUiIvZy10XQjjnUUrBJN3awRBPj9ZzIOpOcTpeNFhQoNCWc6K6nFOjaYW+V23i/nXHN474jSq0EMcNaulAKeR2L3Wm9LPOaGsZzqQt5XLuzekLZNyo6byq1P0f+4/SKe3L2fTS8H50XvUmjsd50YrKnLLnr/e7jpd0TRJfwB7q3obLRnnHWlLpPOB5bggHs1miQ4XhPPTgTCq3+N8KOw/+ojt9IT3nmm343TYuHs9M97dsZ5X9ZLQePvlAe+EWjPnY2bcR778wRMlN86HI5fThpfG09cb0wA1NUvSVNnztjUtPpYtVxtsSUUDtXaWBLmol8ahReOaFmBxNYCKBroIqWhnpGGSurcRUWinD5ZmesXzB2e3VzvnravJ2bD1N1KBdjl60jl8jLaw7lfkADQ1grba8TGaSk2lx34wyXhK9mvVHU9JuGtyq1M5tWYRdc1ZyZsWHvOo1OseA7Gbf7CIZP1600C8p6ybdkneEWLAe6+G3HEG6TpyLYvJrqvRrauNDp0eAjVTt5W8HPDjrMbbqvlIQjPgqY7LoocxQiqNd4fK6bCQlg1qwQ8D427S+PFxNFqBsvlq99SmKksJI12CIX4C9KL+HOtCxodPtUkMo8Jk06phdqC+Iq+m455OKqIoVpB9UPLF3SuG/YPuofKGk0bLZia1nyE/76ll086Uauo9r1in7pBhZlsrabk8u1p+8Q//9Nd/+Xvfo70cTi8F50dvh1Pr4UrBvfkyrnkfXX8wtsOzcricp6aLjmMkkC4L6+G9KdYmLsfKfD+xrYVhigidvCT2jzvSsjDuNPFzORzoLpC3lW0p3O2FmhKX40YYdeRyeO68/s4rTofC7tWevFx4977y6luPHJ4K8wyn9yv3e/j668bh2fD7112K0yKzbp3NxAPVRlWl6bisWKzAtdB4d51iCSFqV3LtemIUxsFZEBgMXknP2iR28/dcQaSKLrmNrmqj5MY46vuNo9P4aTSWoNWrOVTjkZ1X34z3ehuWbsFerar0uhaGeafy5BDxQ0SsYwnjiI/2Z6I3dr24B2U9N70klLSaiRFwAR+dxYDr7qKVzTKRCjUnypYIw2AJsAU1L2kyaBgnOp5OgLij1oKIYpB6Tgqi7Mo4u5ld04Xt+J5WM8MU8RbRMIxezbPW5ewVNs3zqfH8nEypGOk14WNknGd2D3d4X6Flatad4Xpe2JaFdDlTs30uVzCm+WBK2miCRmKnswFNzeSZE5hYwMVRuxMX6AK1bNrdtE5ZF8pyNhPrbAglb4mngXw5qeQdrzLzVinLWUfNObOejpyej6ynQ6eWv+iG5RflT1FfTqaXgvOjucMJsYv/QKyVa/4xip4XFzTn3mnaYEmFLpGyXqjV0aooASArhysOE2nJTPc76qpzde876bwSbKmc1kwYPJfDgVoad48KCkWEcR54/vrANA/UBmmr+Og4Pmdevx44PZ0UaFkawTfS1vn+5413z/0GLstZx2qtdWq1M9V/KDaIKtGm0UZY3TJr6ISgHprezYQogvsG8sZ7w9E47XRi1KXXda2iHY3ibcQLPjqcV2l0652UDDBKp9FxoeOCaAxDq+Yl0fdbSlXPT1F2mXZR/hu7Fn/7uJBOL+uHg7XpwSwWxqaSaIVpttrwceYaHCYukBd93bottJKoFeLuwZ7DCm7Q942olkE8fpyMb6bx4b0XWpMbX86FSbEvcaDmigsDDbvZlwYSqLVRSoegLztvz1dwDKPXr1+H89I4njKXw8K2ZSTu1GMVAnHesX/1mmEetLCVpFEKxplrXcD8Mlg0A9gIFHX6iugo7Po95IZZi2XLmoraDK7qB8K4x4fB6NIRN4z4YSSMs0YOjJNGKqSEG1UsgTjCOOnPmY8K8qw64k1bpvf21+7i+HM/80IT+H/l8SKL/r3a4XQmupIBxHtoRV3PWTNUWs5Mrz5VVLtASYlh/8jl3RPDPN9UVdcxWy2auBijYzsvzA8PuBCptbHb72g5U7NSlN/+UL0h08Mdp/dnuos419m2zqtP9zy/O1G7cDllcgtIzzy9r0xRs2Wkw+HYbiqvqzFzy9xwNrnq3uUb5nWi14KjZICuzvkiFhUN3ulNODghBMPORxuDOS0uYp4aZ7LqEGwyJtwCz7wuZ7Rrat+QNTfBXbEvN4Wa3PZDMfrbWM05dNHfimbuNKUtuOB0vGnPv/P+lkjaalY/Soj4GAyX48FFVZAZCdnFaKRuS7Hs+mc03enV9aJfr1SUDGBkAxeuQNEEMtuITrsxXX5UJQ1Q8QTF60zqEeqt4r0nF8196a2TUyZv2QqN7gcpDe8qDxOcFjXrLlslbxvprLBSVe4FhEoYJ4bWaGfb31yqjgLnCUqj1YVhGrXzELFuztHzqlEYeaM7FV744YGaN31uuyaKajDaqrubonk5gvLq+rYYKLSjok8xOfaVF2ddsOsWmWBdVhe2daPl9EVE/um/819+ejF4vnQ4P+JfGNcbrf42xdL1aHYxfiALbLYfyA0fB9bzRpyjHUAC4hWoGEe71TvWU2Laj+Q1E0aVzy6HM3HeqZt6a+zuJ2pprMtCp3E+rVQcaV15fr/SauXtmw3v4P1TxgElN2rVZf7/+bkWDz1DVQKds/5Zse5GBJbrp2XmzGvxGYL+8k6X1VdZ9JW5VqsWMmcKs2vEtFisgS76zXcjjmFwRuQXG+tptxii0JsQg1hujqrZrlUqDHpga2qzSYdpGsZmo86rWEFEoZM0A1AiuluJk0mH/U0erZEG7YZyudKlxXk1ZFa9UPugnDUFCag8u5ZNx6p0G+cJYtEJItWMmN7UcNOtc2i1mLgAarELTEmkZQHx1Fp1NJWTAizDcKM91NJMhu2Ig2M3XdWCncvayCmT1o20rKznM3m53FhncZqZ7h8Y5p0+v62yrSslF4va6CrICCP4QdE7YdT9lo+A08JSku6cQuR6KyjngxpD86IJnGnFDTvycrQkWDOAisWy0+1rqMmf1wJUcqLi2bZK3hJl23Iv5d/8T6b1L72cRi8F50f+0Upr3ZbL4oTbeA0dm7jg8cNAOh8RcfghQrfb6KD7ljDOLMcT411UIyhCmHb44AmDUzXbqDfny/OZ+fGe8/PCtmoC5un5zNdfJ7xrHN5vTHPg+Kz+j1wU0V8tvMY5HZXULmwZvv+m8+YAyfJsXj1oF9HRJb8T7XLclZEmusvJVbuXohdNQtCuKH5DIaV+F32eip7ZdjAKzgvjqG/DW3FxlqUzDE5VctYNxah/HwdNelQTpxCiFabQzcmvr++cLunB4300+nK0nVu20LWorLuq47WryEMPfu2QvOVOXCO9nTMum3PQrkZeT02bdjo1m6GzI3g0ldMSNaPu9nyMxHkEO0j1YjKaJFoNnOKD5cdoKqeEgZIycRqBqgt30cuJOKglEQd/2zf5ILfiGoMQvfqSjsfKclFg6Ho6sRzOrOeFkjaNROidOESGeVbZfleBS94WSil0p+9XOzx3G6H1MNHFK5qpaNyC84r8aVUvN71VfW7E0j+9Kv70Z0BHBWU9qxggraynM7UUjRmohbItbJeFnDQeIl3UrxPofyHW+B++iAReCs6PR8HpPTsbD+i4QQ89+1uNBK46VkmLykD1B0tTEzvK8SpbYZgGvcW6ARHllalCyQQHtekNk8rz+zM5d6QlvvzBSYnHFXwMtNpZV7h/DPRSePXRxOmUmWdhWRWJPw7C4dS5m7SonFcdpd3NathM1uWkco1y1lWHdi9C8B0v2t0ARPfBW+OvHUhX2sA4qGDAe248tt7BGWStWbcVg2bC6B7Hcmqcs27H/DU2//PBplhVF9jOB7xJdn1Q1/vVK9NqQejUpgFtLmg+C93pCAyNCHU+mqy32csWGzDslW3WlUKG8zRUnNBbucmhu2H7dQeULEhMiwvOU7NunmppOB8Y7x5UIe2cpqhWBb36YYK60aqRqYeJsNuboXRDuok7ar2N2HQcp9J1sVEiCPtJfVDO9m4pY1HbQq+d7bxyORxIm0Yxa8RCYBhH4jBaWJxGKyyHZ7Jx8GpJBmWtHxh6HUreyMd31KThZ4pxarhhoq4n3QN1j5/uNRfHEjuRQBj3tLSSlrPuaKyzqymBH3DDQGuNWjLD6Dut/Fre2r/z9/5bL2DOlx3Oj8sXJrhjz0VvbJb1rodaom2rot19IEyDReyeabWze3Wv6iq7DYoLuhTlzDBHtsOzHT4jJWWc96yHI/OrRwByboy7SGlKA/74255tzYRh5HIpjKZc6iZUAMc0ObatE6NOMX7jCxUIzAMMg4achSjMU+fpqIVGQaQfvDP+GyOwjhai4GEcnI3MdPk/RGyno9Ll67kq4mj9t8dJT5OzIqIyaWe+mjEa96uq56bVzjgGU551QtBipMBK98Fn45RPhrO3JxqLHKRrOFupiHfE3V5v5a1aVyf0smmgWt5wYTDRx4YfFW5pUhHb2UVw0TpHJS57j6n91EtC18A1by5VkUExRtHTijpmnQ9XyYUKTciIGVF7a7RtoddGTUofaCXpTgPjjVFtBNWI3yAu9+6YRmGI4Oik1EhFqK0RnNMOplSWp0TNnWE/M4lKtfWLbly1DnW7QJx0JyWCxEHJBmFQzpvIDdbp7x7o+aLxBXlD0MgFN8y0kvGDt51WoKTVnueme7OS8VHwg2dbLkrfSIXmPGkrlFKpaWO385eA/Hshlr/ycgq9dDg/No9ayhHnboZAEWWn+WGklUzcqVvbecV++DgquHEab9TgXjLDNGl+S6qE6NnOK7uHPb018poQ58lbxgfh/PTMujTmu5HLuTDvI48f3ZsyrHE+Ze7uPcfnzaCdlbs7LUjD4PACy6VzOGkXFbyOrrrtOnajLv9L03Fa/Iav7+rv0BhjFQJEowgEZ6gaIIh2JEN0ev51JTnrN7P+O0G7nGH0yNW7Ix+6mN4/eG2UYqyH+Y1KINd1WVfJMtoZKW1ZK2UXpzRo66rEe5qoVLeLUHO2gqoHZq2V7jzdRVXCWcfSStLdUCn0slG2Vf+t/V2vhVoU21JbMaWZ7lR6lxtupvcG3tnYTBVorWtn0roRxl1UhE2rtFZuoWTtakStnWrU5drqTcjgxN2SVPX5hmlwN3FFb43LovJzfcJ1f1Rr4fJ84Px05HI8kTctIN57hnnG+6C7maa+l95FlWfoHqnWomBP5297KIkqhrgaoMuygg9GVbj99Fi6qH4x83qm5CvXLtO6WJaSo5ZGLaoeDL7Tc/ulkP0v/j0/z/nlFHopOD9OM7W3GgksN46U9AZVce4isDy9Zbx/jXOiQMJqxk9rIUpujHcq/0ypaxRArkx3e8q20VJWBMk561iqZEIM7Pcqy/34WwPHdwcd4UhnngPT3T21CPPOU3Jntx8oGeadct4+/7qxJh21DB72E0yj7gAeHt0tvbP9dtP/jWIcnFDhFpZW+ZBnE8wEqh2gpYEapHMcHfMsCvaMwjCKIWx096IZMboPkG7diajHJBoDTEnQ/dps3CIPzOiuOKHa6E5D2eRKGXCiezV3DcuzGOcQdUcTgnlwRjWgejU6XlEsmg+jnZDGQydayZRlUfd9ycrFK5mOChda1Z1ObxrwFncTPg5I0M8x7B70eyaMH5QYaEAZ5kkS53TPIoPGLPdrMdO33VpTMUNXsUAI+hzFoCF40+BUGUjnfCnkorJp5x2tKUC05sTp3ZHT1wfW80rrXoUBztON2uDCYJ6bTU2iJenYz3vo1TjVjnJ8p8/NthqaRjls6XigNSEvi8mt1X8l3lNyouRMLZnSGtuWWC6bXnpKZV1WVayVxOj5X6Jb/8Wf+dPnL14OoJeR2o9bxXnbu9CrykC9j9R0woWB6f6RvK0WdjYBFz2oLJ+llYwEx/ndgd1HDzjUJ1Jzwnuno7XzxvjwSF6yJUU2ju8vDONEr5mcYdpNvHvzzP2rHdtl5f5x5PD2iTB4hsEDWfNDMux3ju9/1fiNzxu1wN0edju423vmvcMPwiffEeYfdk6r7kFKhXnSgz2Ejjel2eg/EAa8dT0qYYUuqlq7LJ15spu3qEfDB/kwQnNGgx6DFgCL63RepeGt2k7syk8LkZIyrcEwaRBZnAZTdXWc87RcifOAH3Qk5cOIE6e3etU+09JKc14jpZuzmGOvZIJxr9kvtBueqNdkCr1icQea6SIuUGTRDkYEcZGeNwW4UmlFPTNxUHJEnPaG6wn4aW8VUoPIOkXnka1DzyaA0EPcUZGghz45kC7nGyS0NUftjmE3006bCTAcpXdC6DzeQ6+O6DrrWjgvnd1ciIaRifOE+ER6KhzeH8A1SirEaSBEpZT3q0RRPNVFRAKtR/w80dIZyLgw6iVr2GmnP+6s2Orn64Y96fQeFxXT1HtV5du6aiJqTnQX6d1RqpIXtrWynBOgsNRA/eGQ4j/+x3+BL1/OnpeC82P3kDCu3gelEueFWjJu2EErhGGkrAthmKjrkTBNxHlPjCMhTvjg8YMnDJFxt+f5h1/Ykhmm+z29bqTDmf23PuH5+Zn7T3V/40MkBEcunXl2nN4+Q+vMQ2U7ZKZ5T2KlVce2Vnb3O8R15t1ALY2v3zWeT0oSvp/hfucYR2GcHXHQvYv6XbD3p0KC1k0YEK3tNrJADHL1URolQLuX1mE3i5o4MThMBx90hHT12Tine53g1TTrvWOwWOcQOiV3FQGEQCmaDBmcp9E0xbMUFRcETZN0Tgtb3TRwLZfKtN+bmdNpsFcMikrpBTfsbuo1wVG2k52tGtrm42D+j3bjmdW82e1cs1jCECmrSppruu4adOfjvCDeE6ed7jpsoVXzqqO1soFvRn0eqK0Y5kefn1Kqmh2LjvSICvGU0HCx0JtALqRl1Y7FKcMtRM8wwhw9x62SbU5yuXT6a2cdWCVtahgNk2c/eqQX8nLE+XvF7jgTgvhwC5VrtSOukk4HfAz0nE1GjqJ5usnfnRIYlvdf4ad7LVhFIxw6kd438mXR8eJ4z/J8JLfOthR81NHpOHmcuE5r3/fi/4U/Ni7ffzl5XgrOj+Wjt7oi1x2Cw007ux2r8iiMO/wcyJcjJVfWp6+NGGDzEmN0iUBJhd3HD7S6qdLKR7rz+Dioc3waSZcDKcPjQ+T0tHL3MLKdzuz2o8VHB4KHp6fM7vUDpTScE+Ws+cbxufLF24YX2I/w6kF49eC4u/dMs2PYa1flvpEaqeM1uf1ezZX6KThjlwWvePh5+iDJdejfX/02wbA2IqI0AjrSLd1TIETo3alBs2Zz5uu+QUGXjVYgRB0thesi3tyjCpdUEkC0HVq3nJyakxKbxcFoYNKoQXg+RGqvOuaSD7SIXtNNtltz0Smh89RSdV+HBcPlikhRnI3JxJ13FNvdeAeCMtGca7hpvjn29W0Gjcnuohw2Z7TkvNFLRm2agosTva86kqpKUcAJHU/rGec0nCxtGtAm5ktyDrbUGAME57gsnVwcwdvXJXRK7ewedsRBAal5y6TjyUy29itY9EatNs4bbl0g3uPQDpy20Z3umFqtN5BpXs70XinbamKYVZNxvaeURl5WcvNcjgtdlLjeakV67Y32W/Pg//UyXv5LeZFAvxScH9vlmrAom746cdFe1JueiyNxH8nrSm+WArmtjA976npUPwVBHdyiodTzfqAslTjv6CUTvDKkxAKutsuiKZZUc7B7llPik598RU4bwzgRjUv/+PEj7756QqTqnmgQ3nxZOF86Q4C7CR72nrv7wH7vmGZVbIUx8PHHhfNSWa+GT2cHp1j4sIPoxVRpQunckjwHG7M5A2XWxq3glKqCgmaInCEq7qY2CAbtFPsvp3q7JYcQqC0TBlWIueBuXicx/04tKtXWxbtX8GXw4OXmQ9LoZtExkVhHkvXr04o342jV7kc++HBcHPUwNRVi6/0mY24i9Lzpgj9nG5kG3TO1hhujgkKDv3H2dCemsmKRoJTwLkgTHKpI61e127bcxlWdjkR92221HU7ORgrvNyzOtbA760CdM+FC79Si4oH9XSB4B26jLoVaGxGvBsyu8eG9JKp1k2TBD/3mM9NwOAEpur5sqpKkZpOX66WhrBcVRtRKTUomqGmji2dbNpVkI6S1kUqj1GZZO4J3DU/7VYf8q/tx+gs//b3L5eXUeSk4P74jNZFnpBVEEbk9ryoe8EGNbqiJ0TtHNUpvGAKHL98yvvqIsm7EecShh1wIQvMOP06k43vmxzsQiOOIHwZ6Vxlx8Pr/u8d7lqcL896z9Ui4G/HRM86BbGa5YR4pWaWwn39VWTbYDXC/E+7uHXd3nv2jBmApHaBzf58ZhsbhoruXCOaxsc7nOirCCo3AMFgctHU24iBGh7eC03pnmjQK2kc1DsbQiBG2pHkwiqv3lFQVzGlBdrVUehec7zelk1hsdO8C0lTQUPVtt6KdTxxGU3cp9PL6fmWeaXm123cnTPcqLPDexj1aEKSDC6MJKDo1Z8I0QS76fp2+rzhNloEkNpYrFm8dcCEYuiaA+YwkDurrKQWJUcdiosbJUrebIKJsyQpRIa+X246rW0SFi5F6WVSAYiNLJ4b+8Y1hcAyBmy8HOlIz6xqsQBdCcBTvaaWwnArjbsKFgWA0BSUIRN1PWdfhQqQXhZTSZ8I4IK2T14U43yu+RvytaOb1TNjtkB7JKdFq53JZb+F84Ei53Ap88B2plSD8jw3+yf60/vpP/xtrfjlxXgrOj3fBcfWtkyHVmgcV/ILEUeN5x516OqoefuEqh7UZ/bB/JF++YLp/oKxn9h/dEXYP1NzwcaS3znB3x+X9O/w8g/fU3Ll7dUecIq8+UcT8fh+Y7h5Il7c4L+TLyuG58+q7I3FwCIVeG+/fZb54o93Ntx7hk488jw+eh9cD484Q/C5QLyt3+8DjPvPmvYoGhviBMtDoRITjpfO41xs01rU458itMQYhZVUQTJO7RQ3UpiO+6DQczntNJx2nawS1o7SmY7RRQZWqKO9KcG6KZ6kVxiFYnLTTHxEp2uVNmrrp/DW4y+gEVim1gzGPSVNps47cEmG+M7WhprX2MOolAsvvaYW8dmiKVnHeGw3gkb4lxA3UtpIvq8UqqFdFHNS8Mjy8QsZZQa7LSTH84ql1BQmG3B4/eFyaenAY94gP9KIjqeYGjSboFXERP3TyJZm8upvaD1qqjKPHuUII2kVH10gZUla1oIijtY2atNNsPWnQXwxI2bRzypmaT8TdvcmhCy1f6L1Q0krcPxIchHFgvShDrtVkFAmHTHeshwMSA6V08pbAebZtpbVO75m0ZoYIu5FOK9m78O/7cvnnXqTPLwXn5WGP1v0mwtZru+s148dZHdRxNmZ/REJluHu0jXpkO7xn9/G3qNvJAIqVvFwY7+5oOdniW2/wXYSWFkKM5POR9dL49rdnLs9H4jQjTfNFeslILzhb8O/vI7VU9VxslZwbX7+rbAXud/D60XF/73n4aCIMA2GaCEOklqwHKZU56q6mW5ZNR8UA19v3frpy2MxM6lQaMM/u5pFRQ6jYHkPIrWu8gEcVTLWpDNp8N611vDji3URaNrzTjiMMOlLEg29CCN5UcY2eiwVz6V5GRAhDNBSBSoZbKZr4KWoabWVjvPuIup3VC+IjYq731io+DrQbfE13SS44WmqWJjcgTkPI/BA1/jlt9NbVvGmqPB90JxTGGT/PSM9IHxHxhPke8VH9Kjgdr3VHbxs+jJTtSp3I5DWryM5HcOUWy11rpxRVMI7zwLYkfBcLs2sM0TGExjQoHUIwP1SrnC+FMWoRjdHjXKXnzum4URvsxOHdYMq5jBtmSs7KimvVUksdLkyKoPGBlDaNIioJpFMtStsFIdUOJVNyYVszy7Ioc81DLxXXK73Uc6/yv0vj390Nlz//R1+KzUvBeXl8eMROqdf4Qx/I5yf8sNMDLgR6WfFhom3PuPFBMevDAGHk8tVnxPlB5cA1Efcz+XjUmX5eCdOs+S5OiPOOy9OB3f3IeLdnO56Y7/a0srB7fKA7Z9kjA8vXR5wXDu9PrGtncJ1163z2RvcwnzwKH73yvHo9sHuYme7ubobJmo7gPaV0xqFztxPeHrR2Vo3MwTu5qdCCkY+9178fBrkVzGlUGGNt/QbcjF4PQ2cVyQVPyQZJ7oK0hosaKYB3iNMDNfqRWgp+UJd+LRXxoyq+xNz6veJFpc7VpOdiJlIXvRasWnBxUPXaesE5r4WupGvLakt8nQu2UnQMpVnXdNlwCHldLVFU9zwtFzOGVu2qwjeJBwGJM+Y4Ut9M2yxoTX+8e690EUQCfrg3qKt+bL1U3DhRNyWrqjougBONWhZBTE2NoMh/dxW1KOqn1U6BG/pGWmE5O7bZM4/qV6rnQoielDKX00aund1uIkT1y/SebbTZblEcNSdC7VSjNQgGaUXUA1VVWl9bUh8NQl42cir0qj6rnmpxIm+i51fSWv6ru/n+P//ZP3P8lZfT5aXgvDz+b6oB30Sk9K6E395FyQIh6C3QBeryjN89IH6glxUXPHm7EOY9Pkby5ch4/wBoJsvw8Al5OzM+vLpl3SsGJPP6O68tGbHjXGPLFT/P1NrIKcHhWf/vR7bTStkKuTQ++7zw/hle38FHD47HRx2lxeiIux29bOT1AmGirUdK0V1DcN8wVXJloH3oeK6UYhGYZncL3MQONgyHE0c9mGvrhCjKEwv6ij5ehQDh1tlhTLpSmooOqmbaSK3WqXS6Q022ogZGZ7HQ+Agl6/4HK27SET9SUiKGhnTNtFaop9wW4Kp0c7qDMGOis/1GbRXyRvNq3Ox5AxotKw1Ao5c7NVctdsGiq2O8RVD4SflpYsFtLevCvduT2Hql52qxD9f9VaFLpqSEhABhoLZGLdbZiUrFezGEkKhgwA8eKMRBmCcVVeiXp0GrtNrYsmN3P2lOUcnU5hgnz3KpXA6JlrUz1BFdp7fSW+2icFRF7LSSb2ZmFwI9q8y61m4Kwk5JmbxuajYtVT1lpR6c+P+ul/5Xam+/HJl/4x/+t7f/A44v58pLwXl5/O5LnFZBCuLIy5Oha4oCEkvCefDj3Q3tjzhlbjkhvvqEup7orTN/8h1aWdQnMkRYO3Heky5HBSCWjV4Kw24mXU76b7wnL4kwqDQ6F2HYeQ6nyu6usa0KrfzqbeXtE3zyAJ+8dnz66cDjx5HpbiDeP+jIY9pRS6bnTLokcB3ndca/aLQPQxByhZEPRcibVLp28K0j3hbWzlgArROis2W36P7KDwTXb7HSKoowtIE46N5IzmrqCSFYQXGIdzd3erOJmXPQijJ4egdfVG6NCM4FU7Fp+mSYLOisFNw40HOme68cPLGP0+CY+rpXybXKk/FXT47m/Ch/1JPT5WbM7TbO4mpijaPSDqoKDzDmW69NO5QeTFTvrSBUStWcIaEpTiZpQWy1U7ZEKZWcErV5WlfmXk6LgkWbIpOUxwbD5Jl3nsuxseVOqyruiKFTigb6yeiQMNGTRaJ7h2uN7ZxA2lkk/Mc9jr9UelsHkZ8Orvx9TvqfEOc+rbSPnOO+1e6bMZBqXs1H5A162slrehb4VXD/W4jxv0/r9j+sh/J0uuPwj/5Z0u8oNDdw0cvjpeC8POzR86mV7ovGHGtspcpXQYa9ym1bg7zh7Jbvgo6C+nbG+4H9t76rN/ZcccMOEWGc9xAC27uvzLHd9JYpji6O3oRaCuulsPvIU4umYXLcWC+V/U4d7ofnxmdfVJyHb30kfOeTwOtPIg+fvGLYz8TgkeAsDrmxnI4s58R6gVKF3diJUTuTWqF6JZf5GyLtmugprFtjv/dKHfDX3BjBRR0v+QBuiLigyllaR4IezrXoDqj3YtkngWEqpE2fVzHPDf2qVnMqDabRuidMEzWbbyM2BotzFoftG6ClFT/sNL2yV5xoUqi7AjjjrEQB7/HOU7cLzs+6m6kNGSJ05YVJTnS8OenVtBmGmbIuiEBeEnF3T5zvjLMmSM/QzTgJ5vnRmITeMZSMMeJuAypH2N+TzyeVSBfNV3IS8SPUZUHCoF1WVf+PAku5pZ/G4NhPgXXJRiEQxACseavUFmlYpk+rxKbybec6edM7wGmt/8U/82ef/uu/rkXgL33zR+B7/8Sr/T/4SfnJVyJ/CLjHtQcR+QOUnqG9dc4lCfKD/+azy3/7vT+PEVBvwZwvReWl4Lw8/lYfKxMhhkbbkDjexmglLfg43BD2eihst3Cqbhw18crUannFDRMBp/8mXD09hfHxFevTex1fOTQvXkShkTRcnDg+fU4qAXGNeXScnjbev2t89mWhNvj2a8dPfDvw0SeBu1cTwxQY7vY4r6mVrVfUwuHV3NjbbXxWqurvSoMBDKrYb+KAK3xxmqNhaXRmpBy0fuVE6qHfOj1hGBihNWHcTxqZjNh+o+K93r7jqIFjrXSG3aRjJemUVAgmSHBOdEzTC3GMhKjxDlciqR9n7YrE0UyK7FykGhEaC1nTsWjRW7l4vTBYBrX4AF0o60nTRUull0LtjZKSdUfdRACJ8W66SaX9oPkvLs76ecfZKNS60+ii+6fWK6RELyu9GbqhNQVa9oILA8UgotvlRG/BPpas4hDUsDlOmsXjY6RRNYImQPQO51SJpoQf7YBKdZRckEH3Lj5UYhdK7ldU0X4O/Ml/7B/hL/6Zv8TyOwqFfO/PPZ2Bv2a/fmcR+ZsVlL9RJ/PS5fz/tSl4eQp+bz4mgC7SSqGsJ2paqEld7TVnyuWgs/qk7Ch1wlcQr8ZP72n5okwvGsP9gx6i057lzWfM3/mD+PmevBXCbqYDedtsj6GqquV44HQolFRJa+HwXPi139j4/udabH7iW56f+qmRb/3EwKtP98wPD7o/GnfIuP8wyhJvOfae06lRSuP50rkkg+d7JTfXqqqj2uTGORuiIWXQcVoIGq4mYqicXnWUGBxh1EwanVAFcgY/qBrKxUhtzWIDmhYgOmFwlJwML6PCAXDkVFTl5sR2DUEJA+3qeq+AdhLio1G9ByM1j+A94qMGpXUNRRNU9ddrtS5stFGo8n3Eq0a80+yCoXPFWjK1qjpLrFvoNdNrupk2u3jb8xlFutuhblEEWh1GoztXWmv6dRpGas0a/Z0yvTuDhOqYrTf1s/jg9BLjxJA7g4rqzPx5vRBc48G9dFJuCgYt6oEKFtkao6bQghBC/1P/0E/Fv+t3FAP5XV7mb/Dy7/b7l8dLwXl5/C13OG3rLS/5iuHoDfJ2UT9EVff2dRTSu9MbfgM33d8OLhej5oMME4ioXFag10rY31PTRqk6HknLRZlbIbKtmdOl8vTVETpcjhuf/dbCb31WePdOXfd/4BPHd78V+Na3A3ePkf2rB8I84cdZwYk500ql5o1a1FuSU2PbDLfT4Jz1/6mqH6Z1Vaph1AEtPGh6aXRGVAak46NohDa2uHcgXiGlzodbIJoi7q8dixZfF0Xd6bkY96vTa7f4Au06fBhoHX05Dop08cYrE28RBBYtkDXm4WoK6l39NgSNKmi9QYh0w/0jHgmjFgnUfLqtSXNosnVCHaMaaBJlb00vD8INYOmmB3ADHa+y6ZotDbNaEJwpMFrT3VVO+vYsOuFKnu4a/EDrynOLuweTbBtKZysfHLe2Q6tlw3lht4va+YiqC1XP0bSTTI1SxYQPym3zprJzwRHGQAjyU9/+iH/qb6O4/O0UHfmbdEAvj/+vV9MvT8HvzcflP/r7fzJL/7/aO88wOaozUb+nQndPT9QkSSNpFEASEtEgojIgBEIIZAwOe72O4PDsep131/fad3/6gvc+z+4+jx/s9QVhE4RlhDAgFEnKwhhQApEVZzQz0qSOFc65P2oQCAtN0IzUI33vn+6pnq7urvpOvfWdOnW+ZV4md1m+s7XrgBbduGl1zaVmTBjVFCG6pwOjcRJFXUO+6JoyxWDFirpGPkXdLEEuhRUvIX24kfSRI9GwZ8sin/XI5TTpTp9MJiCT0nSmNS0tIf/0Unj8a01GusuFPh58lDrRa4lP6T4z3XSvHS8YPy1AJXDlGo4AQMwyTjQIFzCEXu5o9xSuG52h5zOo4nKiG058HDdG6GVxkhWE+c6P6qGoqAaJ1hrj57BjCYJcBst2oxLDTlRxURufXCags8Nn736fhmbNL/6iuzloyHmL0P8YY3IfE8/Hr7l8+Px4yz75vCcn3CIdEY5AGFhKkYi5FiZZQi7V2dUdY3V1V0XT2gR+GA1TNdGFZidZTpA6jFHRUFjbiUfdLEFU6VAHIWhIH25EK4dcKkcY5EinPFpacjQ2+Bxpi6ogdicbQTgV4ukH6YhYRDjCibDCnBtiVVi2Qywe3TiYS3d2VTrs+h/lQD7Lh3OFKSu6yOtnM1ixeNccWdGNijoIoxsXlYWfy+IHkMtmyKbzdLb77D8Y0tgUkM1pkjH40SaRjVDQ0ukvmYiMRDhC6IXluFa1Uha2o3ATCfx8NipJYCzseDyqAY/uuiveoL2QMGyNaouYaBoQnctiuiZJVJZDEBq8bAo/tOho90inDXv3BuzdHxBzDFVlFt9eHcgOEApdOt3JR0QiwhF6LBzDJZaykkqprvs7LNx4HBMEeJk8Xj6PnUhiOQod5KL7HGwXZftYbhKlNcoPsGNxwryHZVvRSDSjSB1O0dGZo6XF0HIkpKkloLjIUF/nMKRCQkIoWD4pmxPJRzKZQuy5kU1QqE3LTNO+p3QQgGWhdIibKMFNFOEmXGzbkG1txUtnMToqqxsaizAAv2uKkjAIuu7kD/E9n0BHRaiyuYCmRp+9+z2OHPYojsPYETGG1saZ/p/tsu2FgqShoWkRx96jc6LHTz4XJMMRjt99gOp8VE+ParhDGHhYtosF2IkErg6w3ThKZQn8gCAXoAKF5dpgPIxRXTNCW5ich/ZDcOLkMxkyHVmOtORpbAnxfcPwWofaKofKmgTJsrhsfOFszpwEEc7ZR9uiMeVuafEooyyUiaaFV8pC53PYlo22bZQyFFVW4nW2o4MQL5vDy4YYy8KJx6LaIhYEQXTtxstEAwTa2/McPhLi5TV1NQ7D6mJUVRdHdecTRbLxhcEkiN52sYlYRDjC3+wU2x0ehn6861Z3nERxNPmjDlEmuukz8D0wmniyKCo2plJ4OYOX9/HDaNLKeGkJjmsTao2XyRAGEASGwNcMq7EYWu1QWRUnURLHtu1oWhtBOLOyEZFMASFHmAIknc+Uh/ms0r6HHUsSenlMGOAky6JpVugqYUyIkyzGdiBRVk5RWTFFxQ7xuCLM5uhoOEKoFSb0sWybXDqLnw+oKFcMrbaJJxXxIjcaPm0Mfj4rG18YTOL5+KMgGY7Qt5akMloH2LFS/Gx7NMminUB7KSxl48ST0YSLJppIUrkJTOATS0TT47vGwnZ8/HyI39GGFXeBkFjMUFaqCHyFGwPLDvFyOZTvoUOiiqGCMDiznL6MXBMkwxEsbTdbbpGOJlu2o/K6KqrOiW1j/Cy25WDZ0RT4yrJw4kmsRIJ4WRl2zCWeTJAojuMQQDaDyeaxQoMKFV7O0NFqyHQqmg8FHNiT53BzQOP+VI+/4+HDR1i+YvXRvx986FFaW9t6/Vufe+ElDh8+Ijv9DGDbtu384hf/m3/92f8kl8uxfv16fvDDH/Ev//oz9u7dR3NzCz/56T+zaNGDGGPYvXs3jz++tK+ZTV+zG8mIRDjCx6lmT4vByn44PY3RJprCvqsqJLYdlfq1YxjVVdvedrBixVhuDDcRx00kiSeLiRfFiZcU4SYc3JhFLG5jK4vQg3zG0Nbi0d7icaQpz+FGr8ffce0LL7Ft+w7S6QwAvh90zbYMBxsa2bN339H/bW1r443db/H+B3tIpdJ0dHTS3tHBwYMNXDB5EqWlJQAcOHCQD/bsPboeYfDw/vsf8LWvfZ36+nquv/46lFIsW/YkkyZNoqmpiZ///BcsXrwYpRT33fcbmpubuefeXzFy1MiTyXJ6KhHVy/UJA4R0qRVif8G38A8/FBwxIcUoCx36YEJUYFCOi2VHM0Mr20JpNyrhjELn010lCCwsDTrUUYG2rglAHTdGLpPHUh4lZRahNpSW2l336hgc1+3R9/N9n4aGRuZcN5vNW1/mutkzj7724roN7N27j7KyMrZs/QtTr76SxUuWMu2aq7j/iSf55x9/n9/+bhF1dcO5YsplvPr6NmZNn4oBdu56g9bWNrbv2MUtN98ogTCIWPbkk0w+fzKNhw4Ri8WwbZtf/epeABobGmhobCSTzVJbW4vjOqxZsxYdag4eOMj27du58MILeyubk524U5AMR/gIc0BrHx3kUJaNn2rFchNRGWInjh1PQuijdIhlOVERLiDIZ49W9nQSCSwXFIZYcQmxkiISxQ4lFS7llQkqKuNUVMeorSumaliCquHJHn2znbveJAxDUuk0GzdvPea1555/iZKSEsIwZMeuN2g5coRRI0dwycUXUjlkCJVDhgDwpS/cweRJE4++b8iQCpJFRSilaGpult0/yGg4eJD9+/YzbuxYfvl/7mH9+g0APPXU0zyz/Fl++pMfc+uCW1izZi3nTz6fxx77I8OGDePRxYv55l3fIp/P92eXmAwoEOEIvfONWaesOFgugZchVlaL9nNdwomB9rFLq6Iqi3ZXaWnLxnLiKCeBsiwsN4FblCReVolTVIRlOzjxBPHiYhIlRRSVlZEcMoREaSklFaUku7q2umPDpi1cPuVSEok4iUSc/QcOHH0tFo9xzdVXMmvGNH70/X9g0nkTefvd93jyqeX83RfvxLIsEokEtnVs6P36vt8xcuQIpk29Svb9IKSqupqx48Zyxx13UFdXR0tLC0899TT33PsrHrj/d4waNYrzzjuPFc8+w+zZs7j0sktxXZe5c2/Atm2OtLYOdLeaIF1qwqfhBWa5a/vfN+AqQIc+luOCoks8NujwaHE1y4YwNAT5NLYbTewZVcd0MH4epaIia24iiYoVof0sKCcqlWxZ0fpU9+cfnakUYJg+9WoAhtbW8sJLG45W6rx21gz+tPRJzhk3hpKSEi656EJaW9s4fOQIGzZtoba2pqvyZtcZj2WBUsRiMd7c/RbNLYdxe9i1JxQOn7/zTr74xS9xw9y5GG24/PIp3Dx/AWEY8JWvfp2KigqWP/MU+Xyehx5+hAcX3c+WrVv55S/vIRGPU1tT0xfZ9LX7TLreThNyVlCgtD48dnQQ2KtQzgSlFI4bw1IGy41/1F6MiURh2WgdEngeYRCidYAbT2K7CYJMK0o5+F4ODFiOi50oBhSBl4syIxRWPIkxhrKF64jFPv2A7wcBYRiSiH80DU4qlca2beKJOJZS0aCA9naGDhvK4sceZ+o1VzFqZB0rVq2ltraGiy6YTDIZdd/lcjlisag43MGGRobW1mAMJBIyzc5gI5vNsm/ffkaPricWi9HS0sKH4z8sS1FVVUUQBGQyGcrLywE4cOAAZWVllJaWdrv+xsbmx4YPr/0Gx1b9NPxtFdDjLTvR8xMtEyTDOQt61FKqjbh6AaUmYLlR8TUMytIoN44yGsuNoTEo28YKfRyjo1r0ARhjMDqIKn4ajeXGsWwXYzQYDW4xllEYO4yu/1h2NOy6G1zHwXWO/b+SkuJj/i4rK6WsLDqAjBlTz+q1z1FeVkZrWxszp089KhuARCJxNNOp7/uIJaEAKCoqYsKE8Uf/rjlO1uK67lHZAIwYMaI/MhTJWEQ4wslQ+a332hsfGPkiOvH3jpNIBPlObNvBAI6KusuMsqJuNh2gLBs7kURn0lhODGM0gZ+LZirIpVGWjdEalMLY0Ug3CwfthRisaNSbm+j33zFj2jVMu+YqjDHYti07Vij0Hh8R1wAigwYKOfq1u1MZXtd+2hit0SbEGNC+hw5D/FwWHeSJ5lyzwICTKMZx4thuNEggzHWiQx8T+oBGKY3SATrXFr3XtqOpb9wE2huYqW0syxLZCP0phRP93d1yQYQjHI99wfu7lA7Xhl42GhVg2egwIAg8jA6xFZjAj07KdDRKDcvCcuMopTBYhEGIsuME+Qza9wGbIJfBGBOJq2vkW9TpLVIQChdjwr4cr0Q8IhyhJ0z5Fr4O/D8DB1EWJtSEgY/uymi01qBNdGe+sqKh0F3dZUopjO+BNtHkn1qD5UTdZ5aLMRag0CYaJRam29BBRja6ULgEuVgfsx1BhCP0hDca9r+irNhapZQJwxCtDUZDGIYoxwVLgdEYbSKhaA2WhdEhoZ/DAFr7OEUlGO0T5NOEfp4gm8LYcXQ+h/a7JBaEssGFgkW3vzdGtsLgRgYNFDiz/42g8QHzX8bwVaO1a7qu1Zh8HozGTZaAcsFowmwqGhxg/GhwgAYdehgUgRd1w2kvG90cascJUu1gWdG9O7ES/GzPr+H4AQRarq+eamwLXPvMOpFXPfw5Jn1wwrevIXnfRtISCSIcYYAY9rX3trcsmvB0gFloNBjLQhMQBAHK89FWCCa6CdQyCg2E+QxaB4RBdN0m9NIoy4qu1YQaZTyiHjmF0RrLa4tuBO0BK17zeHR9jqwn++ZU4zow9+IYcy+J9fhAXdCyAeKOojSpuu0Ps5Qp+tyV9i33bQwXIyPKRDjCwBHm8vcq25qtfa8ixMJSoByXwPeiG0LtGIQ+GAhDj8CLRrJFlUEtFAptiCb59H2UEw2TDgM/unfHGELtd/s9DrVr/uOZDL70vp02/vBSjvHDbcbWnhmDPDKewbEhGVfd2qk4bt8M4WKJgsGJXMMZJNR+e89mQtagFJgPh0ErDDbGWAR+Dq0NgZcnyPsEQYjv+2DF0WGINtHgAmXZaA0mNAS+T+D7GKMIwoDA6144Te1aZHOaMQaaO/SZdULVw5+TLImf9+vbGSpRIMIRBrbrwfj55H8Yk/iLZUygA48gnyP0A3zfI9QGL5Mmn+4km+ok19lB4AWRbEJNGBp8zyfXmcLPeWRSnYSBTxj45DrbCUJNLtN9Abbxw21G18jw6dNJVanFpBFnTueEUpCIdd8/qCwH17arLx9ffaVEwaA9jglnyD473sy5x3v85PNjluXzXueJ5lIDONypWfm6R2dWutBPNYmYYupEl6Hl1hkTzQlH4fbAn11zqX2T48+ldqJ51LqbV40eLBf6AbmGI9Lq9clHVanFl6YlZCsKpzN+TQ+WCQWGdKkJgiAIIhxBEARBhCMIgiAIIhxBEARBhCMIgiCIcARBEARBhCMIgiCIcARBEARBhCMcH9PDZYIg8SuIcARBEAQRjnAWkM1mSafTUXnr3p6eGkM6M/DlrPN5jw/27EVr3efPy2QyBEFALpcbkO+Yy+UIguCYZelMpk/b9XTj+z4dHR2EYXh0P3d0dJJKfVQvrbOzE8+LCilprQdsuwoiHOEMYdWa57j/wYd59I+P88qrr/X4fTt3vYExhlQ6zUvrNvbLd+no7GTP3n2f8loHz7+wjo6OTjZu2tLrdQdBwNJlT/GHRx5j7fMvDci2/MtfX6Oh8RCHDx+h8VATAC+8uI50enAVtXz//feZd/Mt3HbbZ/ny33+Fzs5Ofvaz/8XUadOZOm06jy9dyubNm5l38y18+ctfIQgCnnhiGb/9799JgzqLkMk7hV7z11df5/v/+F0SifjRM9l1GzaxZ+8+LrrgfC6+6AI2b3mZzlSKAwcamDljKpZl8bsH/sDM6VOZOWMq1VWVeJ7Hpi0vc6ipCcdxGH/OOF59fTsTxp/LVVdM4UhrKytWrsFxHG6eN5d0Os3bb7/L3v37KUoUMe/GOSx78mkONTUz57pZjBwxgudfXIfn+9w457qPgtxxqK6qoqHxEBs3bSHUIWNG13PB+ZNZsXI1mUyWaVOvZszoet56+x02b3mZiooKFsy/ierqKpqaW6itrQagqbmFtc+9gLIs5l5/LUOGVBz9nPUbNtHa3k5bWzs3zrmOmppqdu56k1f++iqVlUOYO+c6OlMpVq95Ht/3mT1rOpVDKojFYixe8jhaG66/diY11dWk0mneevtdLv3MxXR0dvLm7rcZUTec9Rs2obXmlptvpKSkpGBiYtOmzbiuwx9+v4gZM2fT2NjI3Lk38OMf/5CHHn6Ehx9+hCmXTeELn7+TPy5Zwu7db/H/7n+ABxfdLw1KMhzhLKNX/TfXXH0l//Xr3/DKq69hjGHb9p00Nh7i859byIpVa8hkMjz97EomjD+XW2+Zx5+WPknd8GEMHz6UuXOuBQOvbduO7/s88+xK5t80l8AP2LZjF3fevpBVq9cC8NAjj3Hj3Ou55OILeXzpk7S0HGHjlq0sXDAfz/fZ9eZuzhk3lksuvojzJ0+mpKSYm+bO4crLL2P5ilUf66JKs33HLmpra5h30w3kcnlKSkpwHYfrZs9kwfx5PPHk06TTaZYue4qFt93CtbOmAzDlss/wxTtvZ+1zLxIEAYt+/zDXXTuLWTOm8uBDjx6zXZYsXcZVV1zO7JnT+f3Di2lra2fVmue44/aFlJeXs3L1c6x97kXOnzyJ2xfeSlVlFbvfeoeOjg7GjB7NVVdMYfy55/Dq69uIx+KsXvs8YajZ+vIrGGOoqChnwfybOPfccTz/4vqCCqB5826itbWNm+bNZ/78mxk3bhyzZs2kpKSUjRs3MWPGdGpqa3j1tddIpdI88cQTnHfeRP7hH7/HPffcO+AxK0iGIwxSZky7himXXsLyFat55533cFyHvfv289Cjf8R1XTKZLGWlpYyuH0UYhliWhW3bOLZNIpEgn/eOrmvM6HqSySRDh9aSiMdJJOIUFRURBAHvf7CXZX9+BmMMJcXFAJw3YTyJRIKRdcNJpzO4rkssDHFdh+07d7Jz5xsYzDGf8SG2ZfHBB3soSiSYfN5E3nv/AzZs3ExRURGpdJqm5hbqR42ktCtzaO/o4JnlKykuLqa1rZ0gCAmCkNqa6i6RHXtdaOjQodRUV6GNIQxD9u3fz9gxoykqSnDJxRfywIMP8eUvfYHH/rSUzVtf5nMLbwVAKYXrOsRiMRwnapK2bVFfP4p9+/azbcdOvnv3N3nl1df44IM9pDMZKocMKaiYWL16DSXFxdx91zf5zW//m/fee4/6+nq+/4MfUlFezne/8x2CIMD3fWbNmskjDz/KZZddyqWf+QxL/vQ4d931TYYU2G8SJMMRCoAgCEgmk8yeOZ1DTU3UDRvGhedP5utf+R/84Hvfpbq6CvXJ6jpKEYa6xxfDbdumpqaav/vCHXzjq1/mzs8tPHpwPna1ijCILlI/vXwlX/rCHVx95RXH/Zx0Os2KVWtZeOt8AJ565lnmz7uROdfPxlKKsrJSDjY2Hn3vS+s2csH5k/nswgUk4rEPfwZ5zyOXy//N+puamvE8j3QqTag1Q4fWcrChEYCGhkNUV1dTXl7Gt+/6OldMuYyVXZnch7/jk4MHpk+9iuUrV1FVWYnt2Lzw4jq++Pk7uOTiiwpuUMH27Ts499xzmT17Fo5js/utt/jJT37Km2++yYJbb2HTpkjs3/3Ot9m5cxd3330XyWQyKmVrJFk5W5BawYOPk634+eHjcat//vznP/+ZbZ84LBb94RE2bdnKjp27WLhgPhMnTOC117exbsMmtm3byaWfuZhDh5qZdN5EAFpaDjNp4gQ6OjrZtHkL48aNIZfLM3bsaNra2hl/7jmk02mKi4upqqqkqSl676gRI1i8ZCmvb98BQGVldAY8om446UyGokQRY8eMZtXa5wnDkNraGp5/YR3pdIb6USMZWVdHOpNm1KiRZLJZ2traaTl8hLffeZdUKsW554zj2VWraWpqpr5+JBddeAGe5/PI4j9x4GADU6+5ihWr1vDOO+8yauRIJk4YT/2oUSx5fBnbtu/gtgU3M6Tio2s4m7f+hQMHG9i8ZSufu+1WRoyoI5VKs+a5F9i3bx+337aA17ftYPnK1ezbv585181Ga01NdTV1dcN5evkKYrEYrusydsxoqqqq2LZjJ3OunUVFeTnNLYfZvPVldKgZMaKOkSPqCiYoJ06cwPr1G/jjkiVce+213P7ZhSxfvoLS0lJ27dzFO+++w9wbbqCtrZ2Xt77M3XffRX19PYsffYwZM6Zzww1zuv2MVCqz89///d4/n6BbTcw1SA9ewpkhHI4jlhMKpyclps90nnl2FWPHjGbypIm9et+9//c/+ckPvycROkB8osT08cpKH6+k9KeVlZYS09KlJgwQPW1cZ31jS6fTeL5HTdd1mt5w4QWTJdJOfSyLOCTDEU7DflPdPFfdPFcA+byXOtszHKGgM5xvnCCr+bTnPc1wRFKS4Qin+UxRECR2BRGO0OMGKQ1TkNgXRDjCgDe0gX6vIEi8CyIcoUcNThqfIHEsnBJkpoGzo1Gqjz2e9JmfH8C2vQGpnLTxsw0FnDPMpqq0/8YbxRyFpXoVzz39HwlQEY5QIAI60fNPJdTwb0vSbH3bl9Z8llKcUPxofpIJdf1z37htGSpLLGyrVzEsWc4gRLrUBn9XQl//p08N9d3GkK3viGzOZtI5w5rtXr+tL9SQ9czJtAFzCtqLIMIR+qHR9Eo8ji03bwlRN1h/ogYoXkUsIhzh9InoRH3bPWqIY4fafPbKOJZEzlnL8CEW8y+L9dv6XBuK4qov8dzbGBdOM3Kyeubtu57MOPBpjwrAGHPCeszGQHOnJpOXNn02Bl1NmdV/GY4C2+rZgUgplfyYTEw3opE51EQ4wikWTk9Fc8xjd8IRhNMS8JFweiqaT8t0RDinEekYOfPorkF12zA/diYpCIUkm17HskhFhCMMrFj6Zb0iHaEAZWMGWVsSRDhntZh61Q0h0hEKUDZ9vXYjFML+lE1wxu4/1YvnPbmuk5bNLZxC0RT3g2R6Kh8RkwhH6EfhdCeankinu2XdfSeJtbM3sz7R8hNl4L2VjOnh54hwThO2bIIzVjo9EU5fxNJb2YhoRDz9LZ3+lIXIRoQjnMIsp6+CUSIaoR/F093z3mQ0UqBNhCMUQJbTV+kMtGxETmeORAZSOn2RjWQ3IhyhQLKckxVMX2Qjcjm7JdSf0unr5wkFeKASRDqqj+uQWBN6K4KeXNfpTjYyUEAyHKEAhdMb6fRWPCIZoTcH956KpreyESTDEQaRdLoTzYk+T+JK6I14etPN1lPZSHYjGY5wmk8gTlY6fZGPnPCc3RlMb97T2yHUfZGNIBmOUGDS6al4ehpDEmciopPNevoqKJGRCEcoQOn0VzYjMSX09YB/slIR2RQ40qV29p5IqH5aLpIRTpV8TkY2gmQ4QoFKp78EI/El9EYGZgBeEyGJcIQC278nKxeJI2GgRNQfo81ENiIcYRBJp6/xIvEl9OWA358Zi8hGhCMU8H5WEj9CAQtJ5koT4Qhn6L6We2uE053tnMr3CCIcoQD2t8SJMFjkJLIR4Qhn2H6XuBEKSTAiGhGOcBbuf4kn4XSIQUQjwhEkDgRhUIlLkAONIPEgCCIaOcAIEhuCIJIR5KAiSJwIIhlBDiSCxI8giFjkgCEIEn+CCEMYCP4/t0SBJBiq9sYAAAAASUVORK5CYII=";
const xo = 3, f3 = ({ className: n = "", onCloseChange: e, onConfirm: t, open: s, onOpenChange: r, loading: a, ...c }) => {
  var g, S, x;
  const l = Re(!1), [d] = Ze("sqModalWelcomeCreatorsInsights"), [h, m] = X(window.innerWidth), [y, b] = X(window.innerHeight), [v, w] = X(0), o = He(
    (E) => {
      r && typeof r == "function" && (w(0), r(E));
    },
    [r]
  ), u = He(() => {
    v < xo - 1 ? w(v + 1) : t && typeof t == "function" && t();
  }, [v, t]), f = He(() => {
    v > 0 ? w(v - 1) : r(!1);
  }, [v, r]), p = [
    {
      title: d("firstPage.title"),
      description: d("firstPage.description"),
      image: m2
    },
    {
      title: d("secondPage.title"),
      description: d("secondPage.description"),
      image: g2
    },
    {
      title: d("thirdPage.title"),
      description: d("thirdPage.description"),
      image: y2
    }
  ];
  return ee(() => {
    let E = null;
    const k = (R) => {
      if (l != null && l.current)
        return;
      E || (E = R.touches[0].clientX);
      const O = R.touches[0].clientX, T = E - O;
      T > 50 && (u(), l.current = !0), T < -50 && (f(), l.current = !0);
    };
    return window.addEventListener("touchstart", (R) => {
      E = R.touches[0].clientX;
    }), window.addEventListener("touchmove", k), window.addEventListener("touchend", () => {
      E = null, l.current = !1;
    }), () => {
      window.removeEventListener("touchstart", () => {
        E = null;
      }), window.removeEventListener("touchmove", k);
    };
  }, [u, f]), On(() => {
    const E = () => {
      m(window.innerWidth), b(window.innerHeight);
    };
    return window.addEventListener("resize", E), () => {
      window.removeEventListener("resize", E);
    };
  }, []), /* @__PURE__ */ A.jsx(
    Ua,
    {
      ...c,
      open: s,
      className: `sq-modal-steps ${n}`,
      onCloseChange: () => o(!s),
      modalSize: h < 991 ? "md" : "sm",
      children: /* @__PURE__ */ A.jsxs(
        "div",
        {
          className: "content position-relative display-flex pb-0 pt-3 px-3",
          style: { backgroundColor: "var(--purple-90)", height: h < 991 ? `${y}px` : "500px" },
          children: [
            /* @__PURE__ */ A.jsx(Mi, { className: "button-close position-absolute", color: "var(--purple-95)", onClick: () => o(!1), children: /* @__PURE__ */ A.jsx("span", { className: "display-flex justify-content-center align-items-center", children: /* @__PURE__ */ A.jsx("i", { className: "fa-solid fa-x small" }) }) }),
            /* @__PURE__ */ A.jsxs("div", { className: "main-content position-relative display-flex align-items-end mt-5", children: [
              /* @__PURE__ */ A.jsx("h3", { className: "title text-center", children: (g = p == null ? void 0 : p[v]) == null ? void 0 : g.title }),
              /* @__PURE__ */ A.jsx("img", { className: "position-absolute", src: (S = p == null ? void 0 : p[v]) == null ? void 0 : S.image, alt: "Background" })
            ] }),
            /* @__PURE__ */ A.jsxs("div", { className: "footer position-relative p-3 display-flex", children: [
              /* @__PURE__ */ A.jsx("p", { className: "description text-center m-4", children: (x = p == null ? void 0 : p[v]) == null ? void 0 : x.description }),
              /* @__PURE__ */ A.jsxs("div", { className: "actions display-flex justify-content-space-between mt-3", children: [
                /* @__PURE__ */ A.jsx(kj, { steps: Array(xo), active: v, color: "var(--primary_color)", style: { width: "100px" } }),
                /* @__PURE__ */ A.jsx(Mi, { size: "sm", onClick: () => u(), children: a && v === xo - 1 ? /* @__PURE__ */ A.jsx(Et, { size: "small", color: "var(--purple-40)" }) : d("next") })
              ] })
            ] })
          ]
        }
      )
    }
  );
};
const v2 = ({ profiles: n = [], className: e = "", ...t }) => /* @__PURE__ */ A.jsx("div", { className: `social-connect ${e}`, ...t, children: n == null ? void 0 : n.map((s, r) => /* @__PURE__ */ A.jsx("div", { className: `profile-container ${s.socialNetwork}`, children: /* @__PURE__ */ A.jsxs("div", { className: "profile-wrapper", children: [
  /* @__PURE__ */ A.jsx("img", { src: s.image, alt: `${s.name} profile`, className: "profile-image" }),
  /* @__PURE__ */ A.jsx("div", { className: "icon-container", style: { backgroundColor: s.bgColor }, children: s.icon })
] }) }, s.id || r)) });
const h3 = ({
  profiles: n,
  onToggleCreatorsInsights: e,
  onTogglePublicProfile: t,
  onConfirm: s,
  onOpenChange: r,
  open: a,
  requireActiveProfile: c = !1,
  registerCompleted: l = !1,
  titleModal: d = "",
  messageModal: h = "",
  textButton: m = ""
}) => {
  const [y, b] = X(window.innerWidth), [v, w] = X(window.innerHeight), { t: o } = Ze("sqModalActivation"), u = He(
    (k) => {
      r && typeof r == "function" && r(k);
    },
    [r]
  ), f = He(
    (k) => k.hasCreatorsInsights && ((k == null ? void 0 : k.socialNetwork) !== "instagram" || (k == null ? void 0 : k.socialNetwork) === "instagram" && k.hasSocialNetworkCache) && (k != null && k.hasValidToken) && l ? "info" : "alert",
    [l]
  );
  ee(() => {
    const k = () => {
      b(window.innerWidth), w(window.innerHeight);
    };
    return window.addEventListener("resize", k), () => {
      window.removeEventListener("resize", k);
    };
  }, []);
  const p = (k) => k.map((R) => ({
    name: R.username,
    image: R.picture,
    id: R.profileId,
    icon: /* @__PURE__ */ A.jsx("i", { className: `fa-brands fa-${R.socialNetwork} gray-light` }),
    bgColor: `var(--${R.socialNetwork}-50)`,
    socialNetwork: R.socialNetwork
  })), g = {
    maxHeight: "35px",
    maxWidth: "35px",
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexShrink: 0,
    aspectRatio: 1 / 1
  }, S = /* @__PURE__ */ A.jsxs("div", { className: "header", children: [
    /* @__PURE__ */ A.jsx("h4", { children: d || o("activationQuestion") }),
    /* @__PURE__ */ A.jsx(
      Mi,
      {
        color: "var(--purple-95)",
        className: "button-action rounded",
        size: "sm",
        borderStyle: "none",
        customPadding: "10px",
        type: "button",
        style: g,
        onClick: () => u(!a),
        children: /* @__PURE__ */ A.jsx("i", { className: "fa-regular fa-xmark", style: { color: "var(--purple-20)" } })
      }
    )
  ] }), x = n.some((k) => k.hasCreatorsInsights), E = /* @__PURE__ */ A.jsx("footer", { className: "footer", style: { width: "100%" }, children: /* @__PURE__ */ A.jsx(
    Mi,
    {
      color: "var(--purple-30)",
      size: "lg",
      borderStyle: "none",
      type: "button",
      width: "100%",
      onClick: s,
      disabled: c && !x,
      children: m || o("buttonDone")
    }
  ) });
  return /* @__PURE__ */ A.jsxs(
    Ua,
    {
      className: "modal-creators-insights",
      header: S,
      footer: E,
      open: a,
      buttonClose: !1,
      modalSize: y > 991 ? "md" : "lg",
      forceMobileNoMargin: !0,
      children: [
        /* @__PURE__ */ A.jsx("div", { className: "box-insights", children: /* @__PURE__ */ A.jsx("p", { dangerouslySetInnerHTML: { __html: h || o("insightsText", { socialNetwork: "instagram" }) } }) }),
        /* @__PURE__ */ A.jsx(
          "div",
          {
            className: "profiles-list",
            style: y < 991 ? { height: `calc(${v}px - 30px - 240px)`, overflow: "scroll" } : { maxHeight: `calc(${v}px - 58px - 61px)` },
            children: n.map((k) => /* @__PURE__ */ A.jsxs("div", { className: "profile-item", children: [
              /* @__PURE__ */ A.jsxs("div", { className: "profile-and-username display-flex align-items-center", children: [
                /* @__PURE__ */ A.jsx(v2, { profiles: p([k]), style: { width: "40px", height: "40px" } }),
                /* @__PURE__ */ A.jsxs("span", { className: "text-bold", children: [
                  "@",
                  k.username
                ] })
              ] }),
              /* @__PURE__ */ A.jsxs("div", { className: "profile-selector display-flex justify-content-space-between align-items-center", children: [
                /* @__PURE__ */ A.jsxs("span", { children: [
                  /* @__PURE__ */ A.jsx("i", { className: "fa-regular fa-user-chart mr-2" }),
                  o("activateCreatorsInsights")
                ] }),
                /* @__PURE__ */ A.jsxs("div", { className: "wrapper-selectors toggle", children: [
                  /* @__PURE__ */ A.jsx(
                    Po,
                    {
                      type: "checkbox",
                      name: `toggle-creators-insights-${k.username}`,
                      id: `toggle-creators-insights-${k.profileId}`,
                      checked: k.hasCreatorsInsights,
                      onChange: () => e == null ? void 0 : e(k.profileId, k.socialNetwork, k.hasCreatorsInsights),
                      errorSpan: !1
                    }
                  ),
                  /* @__PURE__ */ A.jsx(
                    "label",
                    {
                      className: "checkbox",
                      htmlFor: `toggle-creators-insights-${k.profileId}`,
                      "aria-label": `Toggle creator insights for ${k.username}`
                    }
                  )
                ] })
              ] }),
              /* @__PURE__ */ A.jsxs("div", { className: "profile-selector display-flex justify-content-space-between align-items-center", children: [
                /* @__PURE__ */ A.jsxs("span", { children: [
                  /* @__PURE__ */ A.jsx("i", { className: "fa-regular fa-eye mr-2" }),
                  o("makeProfilePublic"),
                  /* @__PURE__ */ A.jsx(
                    Nu,
                    {
                      message: f(k) === "info" ? o("tipForInfo") : o("tipForAlert"),
                      icon: f(k) === "info" ? "fa-solid fa-info-circle" : "fa-solid fa-triangle-exclamation",
                      color: f(k) === "info" ? "var(--blue-30)" : "var(--red-30)"
                    }
                  )
                ] }),
                /* @__PURE__ */ A.jsxs("div", { className: "wrapper-selectors toggle", children: [
                  /* @__PURE__ */ A.jsx(
                    Po,
                    {
                      type: "checkbox",
                      name: `toggle-public-profile-${k.username}`,
                      id: `toggle-public-profile-${k.profileId}`,
                      checked: !k.hasCreatorsInsights || !(k != null && k.hasValidToken) || !l || (k == null ? void 0 : k.socialNetwork) === "instagram" && !(k != null && k.hasSocialNetworkCache) ? !1 : k == null ? void 0 : k.isSharedCreatorsInsights,
                      onChange: () => t == null ? void 0 : t(k.profileId, k.socialNetwork, k == null ? void 0 : k.isSharedCreatorsInsights),
                      disabled: !k.hasCreatorsInsights || !(k != null && k.hasValidToken) || !l || (k == null ? void 0 : k.socialNetwork) === "instagram" && !(k != null && k.hasSocialNetworkCache),
                      errorSpan: !1
                    }
                  ),
                  /* @__PURE__ */ A.jsx(
                    "label",
                    {
                      className: "checkbox",
                      htmlFor: `toggle-public-profile-${k.profileId}`,
                      "aria-label": `Toggle visibility for ${k.username}`
                    }
                  )
                ] })
              ] })
            ] }, k.profileId))
          }
        )
      ]
    }
  );
};
const p3 = ({ iconColor: n, className: e = "", ...t }) => {
  const { t: s } = Ze("sqInsufficientData");
  return /* @__PURE__ */ A.jsxs("div", { className: `text-center display-flex justify-content-center insufficient-data ${e}`, ...t, children: [
    /* @__PURE__ */ A.jsx("i", { className: "icon-exclamation fa-regular fa-circle-exclamation mt-5", style: { color: n || "var(--neutral-35)" } }),
    /* @__PURE__ */ A.jsx("h4", { className: "mt-5", children: s("insufficientData") })
  ] });
};
er.subscribe((n) => {
  qe.changeLanguage(n);
});
export {
  Pj as MetricChartProvider,
  N2 as SqAccordion,
  d3 as SqAverageEngagementChart,
  F2 as SqBanner,
  CT as SqBarChart,
  B2 as SqBarChartPercent,
  q2 as SqBorderWithIcon,
  Mi as SqButton,
  A2 as SqButtonBack,
  Hx as SqButtonCopyText,
  C2 as SqButtonSocialNetwork,
  H2 as SqCallout,
  h2 as SqCardProfile,
  V2 as SqCardToCopy,
  G2 as SqCarousel,
  K2 as SqChartDoughnut,
  c3 as SqChartLine,
  Y2 as SqCircleCompletation,
  Xr as SqCollapse,
  Vx as SqColorIconHelper,
  Cu as SqColorsHelper,
  Q2 as SqDataHelper,
  _2 as SqDataLayerHelper,
  Ij as SqEventEmitter,
  kj as SqFlow,
  p2 as SqFormProfileCache,
  $2 as SqGroupVerticalBarChart,
  e3 as SqInfinityScroll,
  sa as SqInput,
  E2 as SqInputBirthday,
  D2 as SqInputBirthdaySimple,
  Kx as SqInputDate,
  k2 as SqInputDigits,
  O2 as SqInputDocumentCnpj,
  T2 as SqInputDocumentCpf,
  I2 as SqInputDocumentInternational,
  U2 as SqInputDocumentRut,
  $x as SqInputFile,
  z2 as SqInputMedia,
  R2 as SqInputName,
  P2 as SqInputPassword,
  M2 as SqInputPhone,
  p3 as SqInsufficientData,
  Z2 as SqJwtHelper,
  Et as SqLoader,
  t3 as SqMenuOptions,
  jj as SqMetricChart,
  i3 as SqMetricChartCard,
  Ua as SqModal,
  h3 as SqModalActivation,
  f2 as SqModalFooter,
  u3 as SqModalProfileCache,
  f3 as SqModalWelcomeCreatorsInsights,
  j2 as SqMultiSelect,
  Tn as SqNumbersHelper,
  ra as SqObject,
  n3 as SqOverlay,
  s3 as SqPagination,
  L2 as SqSelect,
  Po as SqSelector,
  v2 as SqSocialConnect,
  r3 as SqSteps,
  J2 as SqStrings,
  o3 as SqTabs,
  a3 as SqTag,
  r2 as SqTimeline,
  Vr as SqTinyCalendar,
  Nu as SqTip,
  qx as SqToastHelper,
  d2 as SqToggleCheckbox,
  l3 as SqToggleCheckboxGroup,
  Ai as SqValidator,
  zj as SqVerticalBarChart,
  X2 as SqVideoHelper,
  s2 as Tab,
  er as onLangChange,
  w2 as setAllComponentsTranslations,
  Nx as setComponentTranslations,
  Fj as useSqMetricChart,
  Ss as useSqMetricChartContext,
  yl as useSqRect,
  Rj as useSqUseThrottle
};
//# sourceMappingURL=index.es.js.map
